//Autogenerated

import {BaseLocalizer} from "@renta-apps/athenaeum-toolkit";

class Localizer extends BaseLocalizer {

    //Constants
    public readonly widgetRentaLinkLabelLanguageItemName: string = `Widget.RentaLink.Label`;
    public readonly loginPageSsoButtonLanguageItemName: string = `LoginPage.SsoButton`;
    public readonly dayOfWeekSundayLanguageItemName: string = `DayOfWeek.Sunday`;
    public readonly dayOfWeekMondayLanguageItemName: string = `DayOfWeek.Monday`;
    public readonly dayOfWeekTuesdayLanguageItemName: string = `DayOfWeek.Tuesday`;
    public readonly dayOfWeekWednesdayLanguageItemName: string = `DayOfWeek.Wednesday`;
    public readonly dayOfWeekThursdayLanguageItemName: string = `DayOfWeek.Thursday`;
    public readonly dayOfWeekFridayLanguageItemName: string = `DayOfWeek.Friday`;
    public readonly dayOfWeekSaturdayLanguageItemName: string = `DayOfWeek.Saturday`;
    public readonly topNavFrontpageLanguageItemName: string = `TopNav.Frontpage`;
    public readonly widgetNewSiteLabelLanguageItemName: string = `Widget.NewSite.Label`;
    public readonly topNavLoginLanguageItemName: string = `TopNav.Login`;
    public readonly topNavEmployeesLanguageItemName: string = `TopNav.Employees`;
    public readonly topNavWarehouseLanguageItemName: string = `TopNav.Warehouse`;
    public readonly topNavConstructionSitesLanguageItemName: string = `TopNav.ConstructionSites`;
    public readonly topNavInvoicesLanguageItemName: string = `TopNav.Invoices`;
    public readonly topNavWorkReportsLanguageItemName: string = `TopNav.WorkReports`;
    public readonly topNavAuditsLanguageItemName: string = `TopNav.Audits`;
    public readonly topNavAdminLanguageItemName: string = `TopNav.Admin`;
    public readonly topNavAccountLanguageItemName: string = `TopNav.Account`;
    public readonly topNavLogoutLanguageItemName: string = `TopNav.Logout`;
    public readonly widgetConstructionSitesLabelLanguageItemName: string = `Widget.ConstructionSites.Label`;
    public readonly widgetConstructionSitesDescriptionLanguageItemName: string = `Widget.ConstructionSites.Description`;
    public readonly widgetNewSiteDescriptionLanguageItemName: string = `Widget.NewSite.Description`;
    public readonly widgetNewTaskLabelLanguageItemName: string = `Widget.NewTask.Label`;
    public readonly widgetNewTaskDescriptionLanguageItemName: string = `Widget.NewTask.Description`;
    public readonly widgetEmployeesDescriptionLanguageItemName: string = `Widget.Employees.Description`;
    public readonly widgetInvoicesDescriptionLanguageItemName: string = `Widget.Invoices.Description`;
    public readonly widgetInvoicingPeriodLabelLanguageItemName: string = `Widget.InvoicingPeriod.Label`;
    public readonly widgetInvoicingPeriodDescriptionLanguageItemName: string = `Widget.InvoicingPeriod.Description`;
    public readonly widgetBudgetDataSet1LabelLanguageItemName: string = `Widget.BudgetData.Set1Label`;
    public readonly widgetBudgetDataSet2LabelLanguageItemName: string = `Widget.BudgetData.Set2Label`;
    public readonly widgetMyWorkReportsLabelLanguageItemName: string = `Widget.MyWorkReports.Label`;
    public readonly widgetMyWorkReportsDescriptionLanguageItemName: string = `Widget.MyWorkReports.Description`;
    public readonly widgetMyInvoicesLabelLanguageItemName: string = `Widget.MyInvoices.Label`;
    public readonly widgetMyInvoicesDescriptionLanguageItemName: string = `Widget.MyInvoices.Description`;
    public readonly widgetMyAuditsLabelLanguageItemName: string = `Widget.MyAudits.Label`;
    public readonly widgetMyAuditsDescriptionLanguageItemName: string = `Widget.MyAudits.Description`;
    public readonly widgetRentaLinkDescriptionLanguageItemName: string = `Widget.RentaLink.Description`;
    public readonly widgetLoginDescriptionLanguageItemName: string = `Widget.Login.Description`;
    public readonly validatorsEmailLanguageItemName: string = `Validators.Email`;
    public readonly validatorsPasswordLanguageItemName: string = `Validators.Password`;
    public readonly validatorsPhoneLanguageItemName: string = `Validators.Phone`;
    public readonly validatorsRequiredLanguageItemName: string = `Validators.Required`;
    public readonly validatorsNumberRangeLanguageItemName: string = `Validators.NumberRange`;
    public readonly loginPageLoginButtonLanguageItemName: string = `LoginPage.LoginButton`;
    public readonly loginPageForgotPasswordButtonLanguageItemName: string = `LoginPage.ForgotPasswordButton`;
    public readonly loginPageEmailInputLanguageItemName: string = `LoginPage.EmailInput`;
    public readonly loginPagePasswordInputLanguageItemName: string = `LoginPage.PasswordInput`;
    public readonly loginPageTitleLanguageItemName: string = `LoginPage.Title`;
    public readonly loginPageSubtitleLanguageItemName: string = `LoginPage.Subtitle`;
    public readonly enumLoginResultStatusNotFoundLanguageItemName: string = `Enum.LoginResultStatus.NotFound`;
    public readonly enumLoginResultStatusDeletedLanguageItemName: string = `Enum.LoginResultStatus.Deleted`;
    public readonly enumLoginResultStatusLockedLanguageItemName: string = `Enum.LoginResultStatus.Locked`;
    public readonly enumLoginResultStatusSecurityLanguageItemName: string = `Enum.LoginResultStatus.Security`;
    public readonly errorPageTitleLanguageItemName: string = `ErrorPage.Title`;
    public readonly errorPageErrorMessageLanguageItemName: string = `ErrorPage.ErrorMessage`;
    public readonly errorPageContactSupportLanguageItemName: string = `ErrorPage.ContactSupport`;
    public readonly contactSupportPageTitleLanguageItemName: string = `ContactSupportPage.Title`;
    public readonly formInputEmailLanguageItemName: string = `Form.Input.Email`;
    public readonly formInputReceiverEmailLanguageItemName: string = `Form.Input.ReceiverEmail`;
    public readonly formInputPhoneLanguageItemName: string = `Form.Input.Phone`;
    public readonly formInputFirstnameLanguageItemName: string = `Form.Input.Firstname`;
    public readonly formInputLastnameLanguageItemName: string = `Form.Input.Lastname`;
    public readonly formInputMessageLanguageItemName: string = `Form.Input.Message`;
    public readonly formInputStreetLanguageItemName: string = `Form.Input.Street`;
    public readonly formSendLanguageItemName: string = `Form.Send`;
    public readonly topNavContactSupportLanguageItemName: string = `TopNav.ContactSupport`;
    public readonly topNavWorkOrdersLanguageItemName: string = `TopNav.WorkOrders`;
    public readonly rentaTasksDashboardQRCodeLanguageItemName: string = `RentaTasks.Dashboard.QRCode`;
    public readonly rentaTasksDashboardQRCodeDescriptionLanguageItemName: string = `RentaTasks.Dashboard.QRCodeDescription`;
    public readonly rentaTasksDashboardCheckInLanguageItemName: string = `RentaTasks.Dashboard.CheckIn`;
    public readonly enumDailyAllowanceMealLanguageItemName: string = `Enum.DailyAllowance.Meal`;
    public readonly enumDailyAllowanceDayLanguageItemName: string = `Enum.DailyAllowance.Day`;
    public readonly enumDailyAllowanceHalfDayLanguageItemName: string = `Enum.DailyAllowance.HalfDay`;
    public readonly enumDailyAllowanceMealDescriptionLanguageItemName: string = `Enum.DailyAllowance.Meal.Description`;
    public readonly enumDailyAllowanceDayDescriptionLanguageItemName: string = `Enum.DailyAllowance.Day.Description`;
    public readonly enumDailyAllowanceHalfDayDescriptionLanguageItemName: string = `Enum.DailyAllowance.HalfDay.Description`;
    public readonly componentDropdownNothingSelectedLanguageItemName: string = `Component.Dropdown.NothingSelected`;
    public readonly componentDropdownMultipleSelectedLanguageItemName: string = `Component.Dropdown.MultipleSelected`;
    public readonly dropdownGroupWarehousesLanguageItemName: string = `Dropdown.Group.Warehouses`;
    public readonly dropdownGroupConstructionSitesLanguageItemName: string = `Dropdown.Group.ConstructionSites`;
    public readonly rentaTasksDashboardSignInLanguageItemName: string = `RentaTasks.Dashboard.SignIn`;
    public readonly formInputAddressLanguageItemName: string = `Form.Input.Address`;
    public readonly formInputCityLanguageItemName: string = `Form.Input.City`;
    public readonly formInputPostalcodeLanguageItemName: string = `Form.Input.Postalcode`;
    public readonly formInputLanguageLanguageItemName: string = `Form.Input.Language`;
    public readonly formSaveLanguageItemName: string = `Form.Save`;
    public readonly componentDropdownNoItemsLanguageItemName: string = `Component.Dropdown.NoItems`;
    public readonly componentDropdownNoDataLanguageItemName: string = `Component.Dropdown.NoData`;
    public readonly componentDropdownFilterResultsLanguageItemName: string = `Component.Dropdown.FilterResults`;
    public readonly componentDropdownGetResultsLanguageItemName: string = `Component.Dropdown.GetResults`;
    public readonly loginPageSsoUserNotFoundLanguageItemName: string = `LoginPage.Sso.UserNotFound`;
    public readonly myAccountPageTitleLanguageItemName: string = `MyAccountPage.Title`;
    public readonly loginPageSsoFailedLanguageItemName: string = `LoginPage.Sso.Failed`;
    public readonly enumCustomerApprovalTypeEmailLanguageItemName: string = `Enum.CustomerApprovalType.Email`;
    public readonly enumCustomerApprovalTypePhoneLanguageItemName: string = `Enum.CustomerApprovalType.Phone`;
    public readonly enumCustomerApprovalTypePhoneDescriptionLanguageItemName: string = `Enum.CustomerApprovalType.Phone.Description`;
    public readonly enumCustomerApprovalTypeEmailDescriptionLanguageItemName: string = `Enum.CustomerApprovalType.Email.Description`;
    public readonly enumCustomerApprovalTypeSignatureLanguageItemName: string = `Enum.CustomerApprovalType.Signature`;
    public readonly enumCustomerApprovalTypeSignatureDescriptionLanguageItemName: string = `Enum.CustomerApprovalType.Signature.Description`;
    public readonly enumDailyAllowanceNoneLanguageItemName: string = `Enum.DailyAllowance.None`;
    public readonly enumUserDocumentTypeCraneCertificateLanguageItemName: string = `Enum.UserDocumentType.CraneCertificate`;
    public readonly enumUserDocumentTypeDrivingLicenceLanguageItemName: string = `Enum.UserDocumentType.DrivingLicence`;
    public readonly enumUserDocumentTypeElectricalSafetyCardLanguageItemName: string = `Enum.UserDocumentType.ElectricalSafetyCard`;
    public readonly enumUserDocumentTypeFireWorkCardLanguageItemName: string = `Enum.UserDocumentType.FireWorkCard`;
    public readonly enumUserDocumentTypeFirstAidCardLanguageItemName: string = `Enum.UserDocumentType.FirstAidCard`;
    public readonly enumUserDocumentTypeForkliftCardLanguageItemName: string = `Enum.UserDocumentType.ForkliftCard`;
    public readonly enumUserDocumentTypeIdCardLanguageItemName: string = `Enum.UserDocumentType.IdCard`;
    public readonly enumUserDocumentTypeLifterCardLanguageItemName: string = `Enum.UserDocumentType.LifterCard`;
    public readonly enumUserDocumentTypeRoadSafetyCardLanguageItemName: string = `Enum.UserDocumentType.RoadSafetyCard`;
    public readonly enumUserDocumentTypeRoofFireWorkCardLanguageItemName: string = `Enum.UserDocumentType.RoofFireWorkCard`;
    public readonly enumUserDocumentTypeWetRoomCertificateLanguageItemName: string = `Enum.UserDocumentType.WetRoomCertificate`;
    public readonly enumUserDocumentTypeWorkSafetyCardLanguageItemName: string = `Enum.UserDocumentType.WorkSafetyCard`;
    public readonly enumModuleModelUndefinedLanguageItemName: string = `Enum.ModuleModel.Undefined`;
    public readonly enumModuleModelModuleLanguageItemName: string = `Enum.ModuleModel.Module`;
    public readonly enumModuleModelPerimeterFrameLanguageItemName: string = `Enum.ModuleModel.PerimeterFrame`;
    public readonly enumModuleModelWeatherShelterLanguageItemName: string = `Enum.ModuleModel.WeatherShelter`;
    public readonly enumUserDocumentLevelFirstLanguageItemName: string = `Enum.UserDocumentLevel.First`;
    public readonly enumUserDocumentLevelSecondLanguageItemName: string = `Enum.UserDocumentLevel.Second`;
    public readonly formInputFileDragAndDropLanguageItemName: string = `Form.Input.File.DragAndDrop`;
    public readonly formInputFileReadonlyLanguageItemName: string = `Form.Input.File.Readonly`;
    public readonly formInputFilePreviewLanguageItemName: string = `Form.Input.File.Preview`;
    public readonly formInputFileChooseFilesLanguageItemName: string = `Form.Input.File.ChooseFiles`;
    public readonly userDocumentSubtitleLanguageItemName: string = `UserDocument.Subtitle`;
    public readonly userDocumentTitleLanguageItemName: string = `UserDocument.Title`;
    public readonly userDocumentSendHelpTextLanguageItemName: string = `UserDocument.Send.HelpText`;
    public readonly userDocumentSendButtonLanguageItemName: string = `UserDocument.Send.Button`;
    public readonly userDocumentValidThruLanguageItemName: string = `UserDocument.ValidThru`;
    public readonly userDocumentImageLanguageItemName: string = `UserDocument.Image`;
    public readonly userDocumentLevelLanguageItemName: string = `UserDocument.Level`;
    public readonly enumDailyAllowanceNoneDescriptionLanguageItemName: string = `Enum.DailyAllowance.None.Description`;
    public readonly myAccountPageSubtitleLanguageItemName: string = `MyAccountPage.Subtitle`;
    public readonly userDocumentSendSuccessLanguageItemName: string = `UserDocumentSendSuccess`;
    public readonly genericAccessDeniedLanguageItemName: string = `Generic.AccessDenied`;
    public readonly genericDataSavedLanguageItemName: string = `Generic.DataSaved`;
    public readonly resetPasswordPageTitleLanguageItemName: string = `ResetPassword.PageTitle`;
    public readonly resetPasswordConfirmPasswordInputLanguageItemName: string = `ResetPassword.ConfirmPasswordInput`;
    public readonly resetPasswordPasswordsDontMatchMessageLanguageItemName: string = `ResetPassword.PasswordsDontMatchMessage`;
    public readonly resetPasswordSuccessMessageLanguageItemName: string = `ResetPassword.SuccessMessage`;
    public readonly resetPasswordSuccessMessageAndInfoLanguageItemName: string = `ResetPassword.SuccessMessageAndInfo`;
    public readonly changePasswordCurrentPasswordLanguageItemName: string = `ChangePassword.CurrentPassword`;
    public readonly changePasswordPageTitleLanguageItemName: string = `ChangePassword.PageTitle`;
    public readonly changePasswordButtonLanguageItemName: string = `ChangePassword.Button`;
    public readonly changePasswordNewPasswordLanguageItemName: string = `ChangePassword.NewPassword`;
    public readonly roleNameScaffoldingMounterLanguageItemName: string = `RoleName.ScaffoldingMounter`;
    public readonly roleNameMounterLanguageItemName: string = `RoleName.Mounter`;
    public readonly roleNameScaffoldingHeadMounterLanguageItemName: string = `RoleName.ScaffoldingHeadMounter`;
    public readonly roleNameStpHeadMounterLanguageItemName: string = `RoleName.StpHeadMounter`;
    public readonly roleNameScaffoldingManagerLanguageItemName: string = `RoleName.ScaffoldingManager`;
    public readonly roleNameStpManagerLanguageItemName: string = `RoleName.StpManager`;
    public readonly roleNameScaffoldingAdminLanguageItemName: string = `RoleName.ScaffoldingAdmin`;
    public readonly roleNameStpAdminLanguageItemName: string = `RoleName.StpAdmin`;
    public readonly enumWorkOrderStatusHasActiveTasksLanguageItemName: string = `Enum.WorkOrderStatus.HasActiveTasks`;
    public readonly enumWorkOrderStatusWorkReportNotSentLanguageItemName: string = `Enum.WorkOrderStatus.WorkReportNotSent`;
    public readonly enumWorkOrderStatusWorkReportNotApprovedByCustomerLanguageItemName: string = `Enum.WorkOrderStatus.WorkReportNotApprovedByCustomer`;
    public readonly enumWorkOrderStatusTaskNotApprovedByManagerLanguageItemName: string = `Enum.WorkOrderStatus.TaskNotApprovedByManager`;
    public readonly enumWorkOrderStatusInvoiceRowsNotApprovedNyManagerLanguageItemName: string = `Enum.WorkOrderStatus.InvoiceRowsNotApprovedNyManager`;
    public readonly enumWorkOrderStatusInvoiceNotCreatedLanguageItemName: string = `Enum.WorkOrderStatus.InvoiceNotCreated`;
    public readonly enumTaxRateRate0LanguageItemName: string = `Enum.TaxRate.Rate0`;
    public readonly enumTaxRateRate10LanguageItemName: string = `Enum.TaxRate.Rate10`;
    public readonly enumTaxRateRate14LanguageItemName: string = `Enum.TaxRate.Rate14`;
    public readonly enumTaxRateRate24LanguageItemName: string = `Enum.TaxRate.Rate24`;
    public readonly userManagementAddUserLanguageItemName: string = `UserManagement.AddUser`;
    public readonly userManagementButtonAddNewSubcontractorLanguageItemName: string = `UserManagement.Button.AddNewSubcontractor`;
    public readonly userManagementSettingsTabLanguageItemName: string = `UserManagement.Settings.Tab`;
    public readonly userManagementSettingsSavedLanguageItemName: string = `UserManagement.SettingsSaved`;
    public readonly userManagementUsersTabLanguageItemName: string = `UserManagement.Users.Tab`;
    public readonly userManagementAlertMessageUnlockUserLanguageItemName: string = `UserManagement.AlertMessage.UnlockUser`;
    public readonly userManagementConfirmationButtonUnlockUserLanguageItemName: string = `UserManagement.ConfirmationButton.UnlockUser`;
    public readonly userManagementConfirmationButtonDeleteUserLanguageItemName: string = `UserManagement.ConfirmationButton.DeleteUser`;
    public readonly userManagementConfirmationButtonRestoreUserLanguageItemName: string = `UserManagement.ConfirmationButton.RestoreUser`;
    public readonly enumBusinessAreaScaffoldingLanguageItemName: string = `Enum.BusinessArea.Scaffolding`;
    public readonly enumBusinessAreaStpLanguageItemName: string = `Enum.BusinessArea.Stp`;
    public readonly enumConstructionSiteStatusActiveLanguageItemName: string = `Enum.ConstructionSiteStatus.Active`;
    public readonly enumConstructionSiteStatusActiveDescriptionLanguageItemName: string = `Enum.ConstructionSiteStatus.Active.Description`;
    public readonly enumConstructionSiteStatusClosedDescriptionLanguageItemName: string = `Enum.ConstructionSiteStatus.Closed.Description`;
    public readonly enumConstructionSiteStatusInactiveLanguageItemName: string = `Enum.ConstructionSiteStatus.Inactive`;
    public readonly enumConstructionSiteStatusInactiveDescriptionLanguageItemName: string = `Enum.ConstructionSiteStatus.Inactive.Description`;
    public readonly enumConstructionSiteStatusClosedLanguageItemName: string = `Enum.ConstructionSiteStatus.Closed`;
    public readonly enumContractTaskTypeAssemblyLanguageItemName: string = `Enum.ContractTaskType.Assembly`;
    public readonly enumContractTaskTypeCoveringLanguageItemName: string = `Enum.ContractTaskType.Covering`;
    public readonly enumContractTaskTypeDeliveryLanguageItemName: string = `Enum.ContractTaskType.Delivery`;
    public readonly enumContractTaskTypeDismantleLanguageItemName: string = `Enum.ContractTaskType.Dismantle`;
    public readonly enumContractTaskTypeReturnLanguageItemName: string = `Enum.ContractTaskType.Return`;
    public readonly enumUserRoleGroupAdminsLanguageItemName: string = `Enum.UserRoleGroup.Admins`;
    public readonly enumUserRoleGroupAdminsDescriptionLanguageItemName: string = `Enum.UserRoleGroup.Admins.Description`;
    public readonly enumUserRoleGroupEmployeesLanguageItemName: string = `Enum.UserRoleGroup.Employees`;
    public readonly enumUserRoleGroupEmployeesDescriptionLanguageItemName: string = `Enum.UserRoleGroup.Employees.Description`;
    public readonly enumUserRoleGroupManagersLanguageItemName: string = `Enum.UserRoleGroup.Managers`;
    public readonly enumUserRoleGroupManagersDescriptionLanguageItemName: string = `Enum.UserRoleGroup.Managers.Description`;
    public readonly enumWorkDayStateNormalLanguageItemName: string = `Enum.WorkDayState.Normal`;
    public readonly enumWorkDayStateNormalDescriptionLanguageItemName: string = `Enum.WorkDayState.Normal.Description`;
    public readonly enumWorkDayStatePaidDayOffLanguageItemName: string = `Enum.WorkDayState.PaidDayOff`;
    public readonly enumWorkDayStatePaidDayOffDescriptionLanguageItemName: string = `Enum.WorkDayState.PaidDayOff.Description`;
    public readonly enumWorkDayStateSickLeaveLanguageItemName: string = `Enum.WorkDayState.SickLeave`;
    public readonly enumWorkDayStateSickLeaveDescriptionLanguageItemName: string = `Enum.WorkDayState.SickLeave.Description`;
    public readonly enumWorkDayStateVacationLanguageItemName: string = `Enum.WorkDayState.Vacation`;
    public readonly enumWorkDayStateVacationDescriptionLanguageItemName: string = `Enum.WorkDayState.Vacation.Description`;
    public readonly enumWorkDayStateWeeklyRestLanguageItemName: string = `Enum.WorkDayState.WeeklyRest`;
    public readonly enumWorkDayStateWeeklyRestDescriptionLanguageItemName: string = `Enum.WorkDayState.WeeklyRest.Description`;
    public readonly enumWorkDayStateFlexHoursLanguageItemName: string = `Enum.WorkDayState.FlexHours`;
    public readonly enumWorkDayStateFlexHoursDescriptionLanguageItemName: string = `Enum.WorkDayState.FlexHours.Description`;
    public readonly formInputEmployeeNumberLanguageItemName: string = `Form.Input.EmployeeNumber`;
    public readonly formInputRoleLanguageItemName: string = `Form.Input.Role`;
    public readonly genericActionCancelLanguageItemName: string = `Generic.Action.Cancel`;
    public readonly monthAprilLanguageItemName: string = `Month.April`;
    public readonly monthAugustLanguageItemName: string = `Month.August`;
    public readonly monthDecemberLanguageItemName: string = `Month.December`;
    public readonly monthFebruaryLanguageItemName: string = `Month.February`;
    public readonly monthJanuaryLanguageItemName: string = `Month.January`;
    public readonly monthJulyLanguageItemName: string = `Month.July`;
    public readonly monthJuneLanguageItemName: string = `Month.June`;
    public readonly monthMarchLanguageItemName: string = `Month.March`;
    public readonly monthMayLanguageItemName: string = `Month.May`;
    public readonly monthNovemberLanguageItemName: string = `Month.November`;
    public readonly monthOctoberLanguageItemName: string = `Month.October`;
    public readonly monthSeptemberLanguageItemName: string = `Month.September`;
    public readonly roleNameContactPersonLanguageItemName: string = `RoleName.ContactPerson`;
    public readonly roleNameScaffoldingDriverLanguageItemName: string = `RoleName.ScaffoldingDriver`;
    public readonly roleNameAdminLanguageItemName: string = `RoleName.Admin`;
    public readonly roleNameStpDriverLanguageItemName: string = `RoleName.StpDriver`;
    public readonly topNavChangePasswordLanguageItemName: string = `TopNav.ChangePassword`;
    public readonly adminHeaderTitleLanguageItemName: string = `Admin.HeaderTitle`;
    public readonly userManagementChooseRoleLanguageItemName: string = `UserManagement.ChooseRole`;
    public readonly confirmationDialogAreYouSureLanguageItemName: string = `ConfirmationDialog.AreYouSure`;
    public readonly confirmationDialogConfirmLanguageItemName: string = `ConfirmationDialog.Confirm`;
    public readonly confirmationDialogCloseLanguageItemName: string = `ConfirmationDialog.Close`;
    public readonly footerFrontpageLanguageItemName: string = `Footer.Frontpage`;
    public readonly baseInputDocumentTooBigLanguageItemName: string = `BaseInput.DocumentTooBig`;
    public readonly baseInputDocumentTypeNotSupportedLanguageItemName: string = `BaseInput.DocumentTypeNotSupported`;
    public readonly changePasswordWeakPasswordMessageLanguageItemName: string = `ChangePassword.WeakPasswordMessage`;
    public readonly changePasswordWrongCurrentMessageLanguageItemName: string = `ChangePassword.WrongCurrentMessage`;
    public readonly passwordHelpTextLengthLanguageItemName: string = `Password.HelpText.Length`;
    public readonly passwordHelpTextLowerCaseLanguageItemName: string = `Password.HelpText.LowerCase`;
    public readonly passwordHelpTextNumberLanguageItemName: string = `Password.HelpText.Number`;
    public readonly passwordHelpTextPasswordHintsLanguageItemName: string = `Password.HelpText.PasswordHints`;
    public readonly passwordHelpTextSpecialCharacterLanguageItemName: string = `Password.HelpText.SpecialCharacter`;
    public readonly passwordHelpTextUpperCaseLanguageItemName: string = `Password.HelpText.UpperCase`;
    public readonly sendWorkReportSubtitleLanguageItemName: string = `SendWorkReport.Subtitle`;
    public readonly forgotPasswordPagePageTitleLanguageItemName: string = `ForgotPasswordPage.PageTitle`;
    public readonly topNavWorkHoursLanguageItemName: string = `TopNav.WorkHours`;
    public readonly gridNoDataWorkReportsLanguageItemName: string = `Grid.NoData.WorkReports`;
    public readonly documentPreviewModalWorkReportTitleLanguageItemName: string = `DocumentPreviewModal.WorkReport.Title`;
    public readonly componentFooterContactLanguageItemName: string = `Component.Footer.Contact`;
    public readonly workDayPanelFixedContractCostLanguageItemName: string = `WorkDayPanel.FixedContractCost`;
    public readonly addWorkReportModalCreateNewReportSubtitleLanguageItemName: string = `AddWorkReportModal.CreateNewReportSubtitle`;
    public readonly addWorkReportModalCreateNewReportLanguageItemName: string = `AddWorkReportModal.CreateNewReport`;
    public readonly addTaskModalWorkReportLanguageItemName: string = `AddTaskModal.WorkReport`;
    public readonly workDayPanelHalfDayAllowanceLanguageItemName: string = `WorkDayPanel.HalfDayAllowance`;
    public readonly workDayPanelWorkDayTypeLanguageItemName: string = `WorkDayPanel.WorkDayType`;
    public readonly workDayPanelSalaryHoursLanguageItemName: string = `WorkDayPanel.SalaryHours`;
    public readonly workDayPanelSalaryHoursDescriptionLanguageItemName: string = `WorkDayPanel.SalaryHours.Description`;
    public readonly componentListLoadingLanguageItemName: string = `Component.List.Loading`;
    public readonly componentFooterFrontpageLanguageItemName: string = `Component.Footer.Frontpage`;
    public readonly documentPreviewModalInvoiceTitleLanguageItemName: string = `DocumentPreviewModal.Invoice.Title`;
    public readonly gridNoDataTasksLanguageItemName: string = `Grid.NoData.Tasks`;
    public readonly gridNoDataModulesLanguageItemName: string = `Grid.NoData.Modules`;
    public readonly gridNoDataInvoiceRowsLanguageItemName: string = `Grid.NoData.InvoiceRows`;
    public readonly gridNoDataInvoicesLanguageItemName: string = `Grid.NoData.Invoices`;
    public readonly gridNoItemsLanguageItemName: string = `Grid.NoItems`;
    public readonly enumInvoiceRowTypeWorkReportLanguageItemName: string = `Enum.InvoiceRowType.WorkReport`;
    public readonly enumInvoiceRowTypeWorkReportDescriptionLanguageItemName: string = `Enum.InvoiceRowType.WorkReport.Description`;
    public readonly enumInvoiceRowTypeRentLanguageItemName: string = `Enum.InvoiceRowType.Rent`;
    public readonly enumInvoiceRowTypeRentDescriptionLanguageItemName: string = `Enum.InvoiceRowType.Rent.Description`;
    public readonly enumInvoiceRowTypeExtraRentLanguageItemName: string = `Enum.InvoiceRowType.ExtraRent`;
    public readonly enumInvoiceRowTypeContractTaskLanguageItemName: string = `Enum.InvoiceRowType.ContractTask`;
    public readonly enumInvoiceRowTypeContractTaskDescriptionLanguageItemName: string = `Enum.InvoiceRowType.ContractTask.Description`;
    public readonly enumInvoiceTypeCreditLanguageItemName: string = `Enum.InvoiceType.Credit`;
    public readonly enumInvoiceTypeDebitLanguageItemName: string = `Enum.InvoiceType.Debit`;
    public readonly enumManualInvoiceRowTypeContractTaskLanguageItemName: string = `Enum.ManualInvoiceRowType.ContractTask`;
    public readonly enumManualInvoiceRowTypeContractTaskDescriptionLanguageItemName: string = `Enum.ManualInvoiceRowType.ContractTask.Description`;
    public readonly enumManualInvoiceRowTypeRentLanguageItemName: string = `Enum.ManualInvoiceRowType.Rent`;
    public readonly enumManualInvoiceRowTypeRentDescriptionLanguageItemName: string = `Enum.ManualInvoiceRowType.Rent.Description`;
    public readonly enumManualInvoiceRowTypeWorkReportLanguageItemName: string = `Enum.ManualInvoiceRowType.WorkReport`;
    public readonly enumManualInvoiceRowTypeWorkReportDescriptionLanguageItemName: string = `Enum.ManualInvoiceRowType.WorkReport.Description`;
    public readonly enumManualInvoiceRowTypeTaskEquipmentLanguageItemName: string = `Enum.ManualInvoiceRowType.TaskEquipment`;
    public readonly enumManualInvoiceRowTypeTaskEquipmentDescriptionLanguageItemName: string = `Enum.ManualInvoiceRowType.TaskEquipment.Description`;
    public readonly enumInvoiceStateFailedDescriptionLanguageItemName: string = `Enum.InvoiceState.Failed.Description`;
    public readonly enumInvoiceStateFailedLanguageItemName: string = `Enum.InvoiceState.Failed`;
    public readonly enumInvoiceStateProcessedDescriptionLanguageItemName: string = `Enum.InvoiceState.Processed.Description`;
    public readonly enumInvoiceStateProcessedLanguageItemName: string = `Enum.InvoiceState.Processed`;
    public readonly enumInvoiceStateSentDescriptionLanguageItemName: string = `Enum.InvoiceState.Sent.Description`;
    public readonly enumInvoiceStateSentLanguageItemName: string = `Enum.InvoiceState.Sent`;
    public readonly taskHoursPanelHoursInfoLanguageItemName: string = `TaskHoursPanel.HoursInfo`;
    public readonly taskHoursPanelExtraHoursInfoLanguageItemName: string = `TaskHoursPanel.ExtraHoursInfo`;
    public readonly taskHoursPanelNoAccessToHoursLanguageItemName: string = `TaskHoursPanel.NoAccessToHours`;
    public readonly invoiceExportModalSendToNavLanguageItemName: string = `InvoiceExportModal.SendToNav`;
    public readonly workDayPanelAutoDistanceLanguageItemName: string = `WorkDayPanel.AutoDistance`;
    public readonly addTaskModalAddTaskLanguageItemName: string = `AddTaskModal.AddTask`;
    public readonly addTaskModalDescriptionLanguageItemName: string = `AddTaskModal.Description`;
    public readonly tasksPanelTasksLanguageItemName: string = `TasksPanel.Tasks`;
    public readonly tasksPanelTypeLanguageItemName: string = `TasksPanel.Type`;
    public readonly tasksPanelWorkReportDescriptionLanguageItemName: string = `TasksPanel.WorkReportDescription`;
    public readonly tasksPanelCodeLanguageItemName: string = `TasksPanel.Code`;
    public readonly tasksPanelRestoreTaskLanguageItemName: string = `TasksPanel.RestoreTask`;
    public readonly myWorkHoursDescriptionLanguageItemName: string = `MyWorkHours.Description`;
    public readonly tasksPanelActivateTaskLanguageItemName: string = `TasksPanel.ActivateTask`;
    public readonly tasksPanelCompleteTaskLanguageItemName: string = `TasksPanel.CompleteTask`;
    public readonly tasksPanelActionsLanguageItemName: string = `TasksPanel.Actions`;
    public readonly tasksPanelExtraHoursInfoLanguageItemName: string = `TasksPanel.ExtraHoursInfo`;
    public readonly tasksPanelForecastInfoLanguageItemName: string = `TasksPanel.ForecastInfo`;
    public readonly tasksPanelForecastLanguageItemName: string = `TasksPanel.Forecast`;
    public readonly tasksPanelDoneLanguageItemName: string = `TasksPanel.Done`;
    public readonly tasksPanelStartInfoLanguageItemName: string = `TasksPanel.StartInfo`;
    public readonly tasksPanelStartLanguageItemName: string = `TasksPanel.Start`;
    public readonly tasksPanelInfoMounterHoursLanguageItemName: string = `TasksPanel.InfoMounterHours`;
    public readonly taskHoursPanelFixedPriceLanguageItemName: string = `TaskHoursPanel.FixedPrice`;
    public readonly addTaskModalMountersLanguageItemName: string = `AddTaskModal.Mounters`;
    public readonly taskHoursPanelContractHoursPriceInfoLanguageItemName: string = `TaskHoursPanel.ContractHoursPriceInfo`;
    public readonly taskHoursPanelContractHoursLanguageItemName: string = `TaskHoursPanel.ContractHours`;
    public readonly taskHoursPanelContractHoursPriceLanguageItemName: string = `TaskHoursPanel.ContractHoursPrice`;
    public readonly taskHoursPanelOvertimeLanguageItemName: string = `TaskHoursPanel.Overtime`;
    public readonly taskHoursPanelExtraHoursLanguageItemName: string = `TaskHoursPanel.ExtraHours`;
    public readonly enumInvoiceStateApprovedDescriptionLanguageItemName: string = `Enum.InvoiceState.Approved.Description`;
    public readonly enumInvoiceStateApprovedLanguageItemName: string = `Enum.InvoiceState.Approved`;
    public readonly enumInvoiceStateCreatedDescriptionLanguageItemName: string = `Enum.InvoiceState.Created.Description`;
    public readonly enumScaffoldingLoadClassTypeClass2DescriptionLanguageItemName: string = `Enum.ScaffoldingLoadClassType.Class2.Description`;
    public readonly enumScaffoldingLoadClassTypeClass3LanguageItemName: string = `Enum.ScaffoldingLoadClassType.Class3`;
    public readonly enumScaffoldingLoadClassTypeClass3DescriptionLanguageItemName: string = `Enum.ScaffoldingLoadClassType.Class3.Description`;
    public readonly enumScaffoldingLoadClassTypeClass4LanguageItemName: string = `Enum.ScaffoldingLoadClassType.Class4`;
    public readonly enumScaffoldingLoadClassTypeClass4DescriptionLanguageItemName: string = `Enum.ScaffoldingLoadClassType.Class4.Description`;
    public readonly enumScaffoldingLoadClassTypeClass5LanguageItemName: string = `Enum.ScaffoldingLoadClassType.Class5`;
    public readonly enumScaffoldingLoadClassTypeClass5DescriptionLanguageItemName: string = `Enum.ScaffoldingLoadClassType.Class5.Description`;
    public readonly enumScaffoldingLoadClassTypeClass6LanguageItemName: string = `Enum.ScaffoldingLoadClassType.Class6`;
    public readonly enumScaffoldingLoadClassTypeClass6DescriptionLanguageItemName: string = `Enum.ScaffoldingLoadClassType.Class6.Description`;
    public readonly enumProductUnitPieceLanguageItemName: string = `Enum.ProductUnit.Piece`;
    public readonly enumProductUnitMeterLanguageItemName: string = `Enum.ProductUnit.Meter`;
    public readonly enumProductUnitKilometerLanguageItemName: string = `Enum.ProductUnit.Kilometer`;
    public readonly enumProductUnitMeter2LanguageItemName: string = `Enum.ProductUnit.Meter2`;
    public readonly enumProductUnitLiterLanguageItemName: string = `Enum.ProductUnit.Liter`;
    public readonly enumProductUnitBoxLanguageItemName: string = `Enum.ProductUnit.Box`;
    public readonly enumProductUnitPairLanguageItemName: string = `Enum.ProductUnit.Pair`;
    public readonly enumProductUnitBottleLanguageItemName: string = `Enum.ProductUnit.Bottle`;
    public readonly enumProductUnitCanLanguageItemName: string = `Enum.ProductUnit.Can`;
    public readonly enumProductUnitBagLanguageItemName: string = `Enum.ProductUnit.Bag`;
    public readonly enumProductUnitRollLanguageItemName: string = `Enum.ProductUnit.Roll`;
    public readonly enumProductUnitCustomLanguageItemName: string = `Enum.ProductUnit.Custom`;
    public readonly sendWorkReportTitleLanguageItemName: string = `SendWorkReport.Title`;
    public readonly sendWorkReportDropdownLabelLanguageItemName: string = `SendWorkReport.Dropdown.Label`;
    public readonly enumPaymentTermsCodeP0LanguageItemName: string = `Enum.PaymentTermsCode.P0`;
    public readonly sendWorkReportDropdownNewContactPersonLanguageItemName: string = `SendWorkReport.Dropdown.NewContactPerson`;
    public readonly sendWorkReportNewContactPersonLanguageItemName: string = `SendWorkReport.NewContactPerson`;
    public readonly workHoursWidgetApprovedLanguageItemName: string = `WorkHoursWidget.Approved`;
    public readonly workHoursWidgetReportedLanguageItemName: string = `WorkHoursWidget.Reported`;
    public readonly workHoursWidgetContractHoursLanguageItemName: string = `WorkHoursWidget.ContractHours`;
    public readonly myWorkHoursLabelLanguageItemName: string = `MyWorkHours.Label`;
    public readonly enumScaffoldingLoadClassTypeClass2LanguageItemName: string = `Enum.ScaffoldingLoadClassType.Class2`;
    public readonly enumScaffoldingLoadClassTypeClass1DescriptionLanguageItemName: string = `Enum.ScaffoldingLoadClassType.Class1.Description`;
    public readonly enumScaffoldingLoadClassTypeClass1LanguageItemName: string = `Enum.ScaffoldingLoadClassType.Class1`;
    public readonly enumPredefinedDeliveryTaskPackedMaterialTransportLanguageItemName: string = `Enum.PredefinedDeliveryTask.PackedMaterialTransport`;
    public readonly enumInvoiceStateCreatedLanguageItemName: string = `Enum.InvoiceState.Created`;
    public readonly workDayPanelPassengersLanguageItemName: string = `WorkDayPanel.Passengers`;
    public readonly enumPaymentTermsCodeP7LanguageItemName: string = `Enum.PaymentTermsCode.P7`;
    public readonly enumPaymentTermsCodeP60LanguageItemName: string = `Enum.PaymentTermsCode.P60`;
    public readonly enumPaymentTermsCodeP45LanguageItemName: string = `Enum.PaymentTermsCode.P45`;
    public readonly enumPaymentTermsCodeP30LanguageItemName: string = `Enum.PaymentTermsCode.P30`;
    public readonly enumPaymentTermsCodeP21LanguageItemName: string = `Enum.PaymentTermsCode.P21`;
    public readonly enumPaymentTermsCodeP14LanguageItemName: string = `Enum.PaymentTermsCode.P14`;
    public readonly enumConstructionSiteSubContractorTaskStatusWorkReportNotApprovedByCustomerLanguageItemName: string = `Enum.ConstructionSiteSubContractorTaskStatus.WorkReportNotApprovedByCustomer`;
    public readonly enumConstructionSiteSubContractorTaskStatusWorkReportNotApprovedByCustomerDescriptionLanguageItemName: string = `Enum.ConstructionSiteSubContractorTaskStatus.WorkReportNotApprovedByCustomer.Description`;
    public readonly enumConstructionSiteSubContractorTaskStatusOpenTasksLanguageItemName: string = `Enum.ConstructionSiteSubContractorTaskStatus.OpenTasks`;
    public readonly enumConstructionSiteSubContractorTaskStatusOpenTasksDescriptionLanguageItemName: string = `Enum.ConstructionSiteSubContractorTaskStatus.OpenTasks.Description`;
    public readonly enumConstructionSiteSubContractorTaskStatusTaskNotApprovedLanguageItemName: string = `Enum.ConstructionSiteSubContractorTaskStatus.TaskNotApproved`;
    public readonly enumConstructionSiteSubContractorTaskStatusTaskNotApprovedDescriptionLanguageItemName: string = `Enum.ConstructionSiteSubContractorTaskStatus.TaskNotApproved.Description`;
    public readonly enumConstructionSiteSubContractorTaskStatusWorkReportNotSentDescriptionLanguageItemName: string = `Enum.ConstructionSiteSubContractorTaskStatus.WorkReportNotSent.Description`;
    public readonly enumConstructionSiteSubContractorTaskStatusWorkReportNotInvoicedLanguageItemName: string = `Enum.ConstructionSiteSubContractorTaskStatus.WorkReportNotInvoiced`;
    public readonly enumConstructionSiteSubContractorTaskStatusWorkReportNotInvoicedDescriptionLanguageItemName: string = `Enum.ConstructionSiteSubContractorTaskStatus.WorkReportNotInvoiced.Description`;
    public readonly predefinedTaskGroupMounterLanguageItemName: string = `PredefinedTaskGroup.Mounter`;
    public readonly predefinedTaskGroupDeliveryLanguageItemName: string = `PredefinedTaskGroup.Delivery`;
    public readonly enumPredefinedExtraTaskAssemblyLanguageItemName: string = `Enum.PredefinedExtraTask.Assembly`;
    public readonly enumPredefinedExtraTaskDismantleLanguageItemName: string = `Enum.PredefinedExtraTask.Dismantle`;
    public readonly enumPredefinedExtraTaskWeatherCoverOpeningLanguageItemName: string = `Enum.PredefinedExtraTask.WeatherCoverOpening`;
    public readonly enumPredefinedExtraTaskExtraWorkLanguageItemName: string = `Enum.PredefinedExtraTask.ExtraWork`;
    public readonly enumPredefinedExtraTaskModificationWorkLanguageItemName: string = `Enum.PredefinedExtraTask.ModificationWork`;
    public readonly enumPredefinedExtraTaskRepairWorkLanguageItemName: string = `Enum.PredefinedExtraTask.RepairWork`;
    public readonly enumPredefinedDeliveryTaskDeliveryTransportLanguageItemName: string = `Enum.PredefinedDeliveryTask.DeliveryTransport`;
    public readonly enumPredefinedDeliveryTaskReturnTransportLanguageItemName: string = `Enum.PredefinedDeliveryTask.ReturnTransport`;
    public readonly enumConstructionSiteSubContractorTaskStatusWorkReportNotSentLanguageItemName: string = `Enum.ConstructionSiteSubContractorTaskStatus.WorkReportNotSent`;
    public readonly tasksPanelApproveTaskCreateLanguageItemName: string = `TasksPanel.ApproveTaskCreate`;
    public readonly salaryHoursPanelOvertimeFiftyLanguageItemName: string = `SalaryHoursPanel.OvertimeFifty`;
    public readonly salaryExportModalSendToPayrollLanguageItemName: string = `SalaryExportModal.SendToPayroll`;
    public readonly salaryHoursPanelNormalHoursLanguageItemName: string = `SalaryHoursPanel.NormalHours`;
    public readonly salaryHoursPanelHoursLanguageItemName: string = `SalaryHoursPanel.Hours`;
    public readonly salaryHoursPanelTotalLanguageItemName: string = `SalaryHoursPanel.Total`;
    public readonly workDayPanelAutoHoursLanguageItemName: string = `WorkDayPanel.AutoHours`;
    public readonly salaryHoursPanelEveningLanguageItemName: string = `SalaryHoursPanel.Evening`;
    public readonly addMounterModalAddHoursInfoLanguageItemName: string = `AddMounterModal.AddHoursInfo`;
    public readonly tasksPanelSendToCustomerLanguageItemName: string = `TasksPanel.SendToCustomer`;
    public readonly constructionSitesSitesInfoLanguageItemName: string = `ConstructionSites.SitesInfo`;
    public readonly tasksPanelSentToLanguageItemName: string = `TasksPanel.SentTo`;
    public readonly addConstructionsiteProjectNumberLanguageItemName: string = `AddConstructionsite.ProjectNumber`;
    public readonly tasksPanelRestoreDeletedWorkReportLanguageItemName: string = `TasksPanel.RestoreDeletedWorkReport`;
    public readonly tasksPanelDeleteWorkReportLanguageItemName: string = `TasksPanel.DeleteWorkReport`;
    public readonly addMounterModalNoTasksAvailableLanguageItemName: string = `AddMounterModal.NoTasksAvailable`;
    public readonly tasksPanelApproveWorkReportInvoiceLanguageItemName: string = `TasksPanel.ApproveWorkReportInvoice`;
    public readonly tasksPanelPreviewWorkReportLanguageItemName: string = `TasksPanel.PreviewWorkReport`;
    public readonly tasksPanelSentAtLanguageItemName: string = `TasksPanel.SentAt`;
    public readonly taskHoursPanelMounterLanguageItemName: string = `TaskHoursPanel.Mounter`;
    public readonly constructionSitesSitesLanguageItemName: string = `ConstructionSites.Sites`;
    public readonly constructionSitesInvoiceReferenceLanguageItemName: string = `ConstructionSites.InvoiceReference`;
    public readonly constructionSitesReferenceLanguageItemName: string = `ConstructionSites.Reference`;
    public readonly addConstructionsiteOrganizationLanguageItemName: string = `AddConstructionsite.Organization`;
    public readonly tasksPanelDownloadWorkReportLanguageItemName: string = `TasksPanel.DownloadWorkReport`;
    public readonly addMounterModalHoursLanguageItemName: string = `AddMounterModal.Hours`;
    public readonly checkInsPanelSignInLanguageItemName: string = `CheckInsPanel.SignIn`;
    public readonly checkInsPanelSiteOrWarehouseLanguageItemName: string = `CheckInsPanel.SiteOrWarehouse`;
    public readonly workDayPanelDistanceInfoLanguageItemName: string = `WorkDayPanel.DistanceInfo`;
    public readonly workDayPanelDistanceLanguageItemName: string = `WorkDayPanel.Distance`;
    public readonly workDayPanelOwnEquipmentLanguageItemName: string = `WorkDayPanel.OwnEquipment`;
    public readonly workDayPanelDailyAllowanceLanguageItemName: string = `WorkDayPanel.DailyAllowance`;
    public readonly workDayPanelAggregateDailyAllowanceLanguageItemName: string = `WorkDayPanel.Aggregate.DailyAllowance`;
    public readonly workDayPanelWorkDayLanguageItemName: string = `WorkDayPanel.WorkDay`;
    public readonly workDayPanelAddNewTaskHoursLanguageItemName: string = `WorkDayPanel.AddNewTaskHours`;
    public readonly workDayPanelDetailsInfoLanguageItemName: string = `WorkDayPanel.DetailsInfo`;
    public readonly workDayPanelDetailsLanguageItemName: string = `WorkDayPanel.Details`;
    public readonly salaryHoursPanelSundayOvertimeLanguageItemName: string = `SalaryHoursPanel.SundayOvertime`;
    public readonly salaryHoursPanelEveningOvertimeLanguageItemName: string = `SalaryHoursPanel.EveningOvertime`;
    public readonly salaryHoursPanelNightLanguageItemName: string = `SalaryHoursPanel.Night`;
    public readonly salaryHoursPanelNightOvertimeLanguageItemName: string = `SalaryHoursPanel.NightOvertime`;
    public readonly salaryHoursPanelMarkAsNormalLanguageItemName: string = `SalaryHoursPanel.MarkAsNormal`;
    public readonly salaryHoursPanelContractHoursLanguageItemName: string = `SalaryHoursPanel.ContractHours`;
    public readonly salaryHoursPanelOvertimeHundredLanguageItemName: string = `SalaryHoursPanel.OvertimeHundred`;
    public readonly checkInsPanelTaskLanguageItemName: string = `CheckInsPanel.Task`;
    public readonly checkInsPanelCheckOutAddressLanguageItemName: string = `CheckInsPanel.CheckOutAddress`;
    public readonly checkInsPanelCheckOutLanguageItemName: string = `CheckInsPanel.CheckOut`;
    public readonly checkInsPanelCheckInAddressLanguageItemName: string = `CheckInsPanel.CheckInAddress`;
    public readonly addMounterModalAddHoursLanguageItemName: string = `AddMounterModal.AddHours`;
    public readonly checkInsPanelCheckInLanguageItemName: string = `CheckInsPanel.CheckIn`;
    public readonly linkExpiredLanguageItemName: string = `Link.Expired`;
    public readonly linkUsedLanguageItemName: string = `Link.Used`;
    public readonly checkInsPanelSignOutLanguageItemName: string = `CheckInsPanel.SignOut`;
    public readonly forgotPasswordPageSuccessMessageLanguageItemName: string = `ForgotPasswordPage.SuccessMessage`;
    public readonly forgotPasswordPageResetButtonLanguageItemName: string = `ForgotPasswordPage.ResetButton`;
    public readonly forgotPasswordPageLoginButtonLanguageItemName: string = `ForgotPasswordPage.LoginButton`;
    public readonly forgotPasswordPageHelpTextLanguageItemName: string = `ForgotPasswordPage.HelpText`;
    public readonly forgotPasswordPageEmailInputLanguageItemName: string = `ForgotPasswordPage.EmailInput`;
    public readonly addConstructionsiteWarehouseLanguageItemName: string = `AddConstructionsite.Warehouse`;
    public readonly addConstructionsiteManagerLanguageItemName: string = `AddConstructionsite.Manager`;
    public readonly constructionSitesActivateLanguageItemName: string = `ConstructionSites.Activate`;
    public readonly constructionSitesDeactivateLanguageItemName: string = `ConstructionSites.Deactivate`;
    public readonly addConstructionsiteToolbarAnyTaskStatusLanguageItemName: string = `AddConstructionsiteToolbar.AnyTaskStatus`;
    public readonly addConstructionsiteToolbarAnyStatusLanguageItemName: string = `AddConstructionsiteToolbar.AnyStatus`;
    public readonly addConstructionsiteToolbarSiteLanguageItemName: string = `AddConstructionsiteToolbar.Site`;
    public readonly constructionSitesToolbarCustomerLanguageItemName: string = `ConstructionSitesToolbar.Customer`;
    public readonly addConstructionsiteToolbarAllSalesPersonsLanguageItemName: string = `AddConstructionsiteToolbar.AllSalesPersons`;
    public readonly addConstructionsiteToolbarAllManagersLanguageItemName: string = `AddConstructionsiteToolbar.AllManagers`;
    public readonly constructionSitesCloseLanguageItemName: string = `ConstructionSites.Close`;
    public readonly addConstructionsiteAddSiteLanguageItemName: string = `AddConstructionsite.AddSite`;
    public readonly addConstructionsiteSalesPersonLanguageItemName: string = `AddConstructionsite.SalesPerson`;
    public readonly addTaskModalAddTaskSubtitleLanguageItemName: string = `AddTaskModal.AddTaskSubtitle`;
    public readonly addConstructionsiteToolbarAnySubTaskStatusLanguageItemName: string = `AddConstructionsiteToolbar.AnySubTaskStatus`;
    public readonly addConstructionsiteToolbarFilterLanguageItemName: string = `AddConstructionsiteToolbar.Filter`;
    public readonly myWorkHoursNoReportedHoursLanguageItemName: string = `MyWorkHours.NoReportedHours`;
    public readonly addConstructionsiteToolbarClearFilterLanguageItemName: string = `AddConstructionsiteToolbar.ClearFilter`;
    public readonly genericCustomerNumberLanguageItemName: string = `Generic.CustomerNumber`;
    public readonly constructionSitesStatusLanguageItemName: string = `ConstructionSites.Status`;
    public readonly constructionSitePanelActivateConfirmationLanguageItemName: string = `ConstructionSitePanel.ActivateConfirmation`;
    public readonly constructionSitePanelDeactivateConfirmationLanguageItemName: string = `ConstructionSitePanel.DeactivateConfirmation`;
    public readonly myAuditsApprovedAtLanguageItemName: string = `MyAudits.ApprovedAt`;
    public readonly myAuditsMyAuditLanguageItemName: string = `MyAudits.MyAudit`;
    public readonly myAuditsNoDataLanguageItemName: string = `MyAudits.NoData`;
    public readonly myAuditsActionsApproveLanguageItemName: string = `MyAudits.Actions.Approve`;
    public readonly myAuditsActionsPreviewLanguageItemName: string = `MyAudits.Actions.Preview`;
    public readonly myAuditsActionsDownloadLanguageItemName: string = `MyAudits.Actions.Download`;
    public readonly myAuditsConfirmationApproveLanguageItemName: string = `MyAudits.Confirmation.Approve`;
    public readonly myAuditsReportPreviewLanguageItemName: string = `MyAudits.ReportPreview`;
    public readonly agreementMinimumRentalDaysLanguageItemName: string = `Agreement.MinimumRentalDays`;
    public readonly agreementModuleNameLanguageItemName: string = `AgreementModule.Name`;
    public readonly addAgreementAddAgreementLanguageItemName: string = `AddAgreement.AddAgreement`;
    public readonly addAgreementDescriptionLanguageItemName: string = `AddAgreement.Description`;
    public readonly addAgreementDropdownLabelLanguageItemName: string = `AddAgreement.Dropdown.Label`;
    public readonly addAgreementExtraTaskHourlyCostLanguageItemName: string = `AddAgreement.ExtraTaskHourlyCost`;
    public readonly addAgreementNewContactPersonLanguageItemName: string = `AddAgreement.NewContactPerson`;
    public readonly addAgreementSubtitleLanguageItemName: string = `AddAgreement.Subtitle`;
    public readonly addAgreementTitleLanguageItemName: string = `AddAgreement.Title`;
    public readonly auditModuleApprovedLanguageItemName: string = `AuditModule.Approved`;
    public readonly auditModuleNoAuditLanguageItemName: string = `AuditModule.NoAudit`;
    public readonly auditModuleNotApprovedLanguageItemName: string = `AuditModule.NotApproved`;
    public readonly auditModuleNotPassedLanguageItemName: string = `AuditModule.NotPassed`;
    public readonly auditModulePassedLanguageItemName: string = `AuditModule.Passed`;
    public readonly auditModuleStartAuditLanguageItemName: string = `AuditModule.StartAudit`;
    public readonly auditQuestionInputCommentLanguageItemName: string = `AuditQuestionInput.Comment`;
    public readonly auditQuestionInputCommentRequiredLanguageItemName: string = `AuditQuestionInput.CommentRequired`;
    public readonly auditQuestionInputInsertCommentLanguageItemName: string = `AuditQuestionInput.InsertComment`;
    public readonly auditQuestionInputNeedRepairsLanguageItemName: string = `AuditQuestionInput.NeedRepairs`;
    public readonly auditQuestionInputStepOkLanguageItemName: string = `AuditQuestionInput.StepOk`;
    public readonly enumUserRoleGroupSubcontractorsLanguageItemName: string = `Enum.UserRoleGroup.Subcontractors`;
    public readonly genericCostPoolLanguageItemName: string = `Generic.CostPool`;
    public readonly genericDetailsLanguageItemName: string = `Generic.Details`;
    public readonly genericNameLanguageItemName: string = `Generic.Name`;
    public readonly genericTaskLanguageItemName: string = `Generic.Task`;
    public readonly genericWarehouseLanguageItemName: string = `Generic.Warehouse`;
    public readonly genericTasksLanguageItemName: string = `Generic.Tasks`;
    public readonly genericVatIdLanguageItemName: string = `Generic.VatId`;
    public readonly gridNoDataSubcontractorsLanguageItemName: string = `Grid.NoData.Subcontractors`;
    public readonly invoiceExportModalDownloadFileLanguageItemName: string = `InvoiceExportModal.DownloadFile`;
    public readonly invoiceExportModalSendToPageroLanguageItemName: string = `InvoiceExportModal.SendToPagero`;
    public readonly workDayPanelToolbarAddMounterLanguageItemName: string = `WorkDayPanelToolbar.AddMounter`;
    public readonly invoicesDownloadInvoiceLanguageItemName: string = `Invoices.DownloadInvoice`;
    public readonly invoicesStateLanguageItemName: string = `Invoices.State`;
    public readonly invoicesDueTitleLanguageItemName: string = `Invoices.DueTitle`;
    public readonly invoicesDueLanguageItemName: string = `Invoices.Due`;
    public readonly invoicesNetLanguageItemName: string = `Invoices.Net`;
    public readonly subContractorsSubcontractorLanguageItemName: string = `SubContractors.Subcontractor`;
    public readonly invoicesEntryTitleLanguageItemName: string = `Invoices.EntryTitle`;
    public readonly invoicesEntryLanguageItemName: string = `Invoices.Entry`;
    public readonly invoicesCreatedAtLanguageItemName: string = `Invoices.CreatedAt`;
    public readonly genericNameAndProjectLanguageItemName: string = `Generic.NameAndProject`;
    public readonly invoicesInvoiceCommentLanguageItemName: string = `Invoices.InvoiceComment`;
    public readonly invoicesReferenceLanguageItemName: string = `Invoices.Reference`;
    public readonly invoicesInformationInvoiceRowsLanguageItemName: string = `Invoices.InformationInvoiceRows`;
    public readonly invoiceToolbarExportPageroFormatSubTitleLanguageItemName: string = `InvoiceToolbar.ExportPageroFormatSubTitle`;
    public readonly tasksPanelAddTaskTitleLanguageItemName: string = `TasksPanel.AddTaskTitle`;
    public readonly tasksPanelAddWorkReportTitleLanguageItemName: string = `TasksPanel.AddWorkReportTitle`;
    public readonly invoicesNavLanguageItemName: string = `Invoices.Nav`;
    public readonly invoiceToolbarExportPageroFormatLanguageItemName: string = `InvoiceToolbar.ExportPageroFormat`;
    public readonly invoicesPreviewInvoiceLanguageItemName: string = `Invoices.PreviewInvoice`;
    public readonly invoicesSendToPageroLanguageItemName: string = `Invoices.SendToPagero`;
    public readonly warehousesPageTitleLanguageItemName: string = `Warehouses.PageTitle`;
    public readonly warehousePanelPanelTitleLanguageItemName: string = `WarehousePanel.PanelTitle`;
    public readonly warehousesExternalIdLanguageItemName: string = `Warehouses.ExternalId`;
    public readonly roleNameSubcontractorManagerLanguageItemName: string = `RoleName.SubcontractorManager`;
    public readonly roleNameSubcontractorMounterLanguageItemName: string = `RoleName.SubcontractorMounter`;
    public readonly roleNameSubcontractorHeadMounterLanguageItemName: string = `RoleName.SubcontractorHeadMounter`;
    public readonly myWorkReportNoDataLanguageItemName: string = `MyWorkReport.NoData`;
    public readonly myWorkReportMyReportLanguageItemName: string = `MyWorkReport.MyReport`;
    public readonly myWorkReportDeclineWorkReportLanguageItemName: string = `MyWorkReport.DeclineWorkReport`;
    public readonly myWorkReportApprovedAtLanguageItemName: string = `MyWorkReport.ApprovedAt`;
    public readonly myInvoicesMyInvoicesLanguageItemName: string = `MyInvoices.MyInvoices`;
    public readonly myWorkReportsConfirmationApproveLanguageItemName: string = `MyWorkReports.Confirmation.Approve`;
    public readonly myWorkReportsConfirmationDeclineLanguageItemName: string = `MyWorkReports.Confirmation.Decline`;
    public readonly invoicesListOfInvoicesLanguageItemName: string = `Invoices.ListOfInvoices`;
    public readonly invoicesInvoicesLanguageItemName: string = `Invoices.Invoices`;
    public readonly invoicesCancelInvoiceLanguageItemName: string = `Invoices.CancelInvoice`;
    public readonly invoicesDeleteCreditInvoiceConfirmationLanguageItemName: string = `Invoices.DeleteCreditInvoiceConfirmation`;
    public readonly workDayPanelToolbarExportRowInfoLanguageItemName: string = `WorkDayPanelToolbar.ExportRowInfo`;
    public readonly invoiceToolbarExportNavisionFormatSubTitleLanguageItemName: string = `InvoiceToolbar.ExportNavisionFormatSubTitle`;
    public readonly invoiceToolbarExportNavisionFormatLanguageItemName: string = `InvoiceToolbar.ExportNavisionFormat`;
    public readonly invoiceToolbarPageroLanguageItemName: string = `InvoiceToolbar.Pagero`;
    public readonly invoiceToolbarExportToPageroLanguageItemName: string = `InvoiceToolbar.ExportToPagero`;
    public readonly workDayPanelToolbarAnySalaryHoursSubTextLanguageItemName: string = `WorkDayPanelToolbar.AnySalaryHoursSubText`;
    public readonly workDayPanelToolbarApprovedByManagerLanguageItemName: string = `WorkDayPanelToolbar.ApprovedByManager`;
    public readonly workDayPanelToolbarApprovedByDirectorLanguageItemName: string = `WorkDayPanelToolbar.ApprovedByDirector`;
    public readonly workDayPanelToolbarApprovedByDirectorSubTextLanguageItemName: string = `WorkDayPanelToolbar.ApprovedByDirectorSubText`;
    public readonly workDayPanelToolbarNotApprovedByManagerLanguageItemName: string = `WorkDayPanelToolbar.NotApprovedByManager`;
    public readonly workDayPanelToolbarNotApprovedByManagerSubTextLanguageItemName: string = `WorkDayPanelToolbar.NotApprovedByManagerSubText`;
    public readonly workDayPanelToolbarNotApprovedByDirectorLanguageItemName: string = `WorkDayPanelToolbar.NotApprovedByDirector`;
    public readonly workDayPanelToolbarNotApprovedByDirectorSubTextLanguageItemName: string = `WorkDayPanelToolbar.NotApprovedByDirectorSubText`;
    public readonly workDayPanelToolbarReportTypeLanguageItemName: string = `WorkDayPanelToolbar.ReportType`;
    public readonly workDayPanelToolbarSourceLanguageItemName: string = `WorkDayPanelToolbar.Source`;
    public readonly workDayPanelToolbarApproveLanguageItemName: string = `WorkDayPanelToolbar.Approve`;
    public readonly workDayPanelToolbarDateLanguageItemName: string = `WorkDayPanelToolbar.Date`;
    public readonly workDayPanelToolbarSearchLanguageItemName: string = `WorkDayPanelToolbar.Search`;
    public readonly workDayPanelToolbarExportMepcoLanguageItemName: string = `WorkDayPanelToolbar.ExportMepco`;
    public readonly workDayPanelToolbarAnySalaryHoursLanguageItemName: string = `WorkDayPanelToolbar.AnySalaryHours`;
    public readonly workDayPanelToolbarAssignedWarehousesLanguageItemName: string = `WorkDayPanelToolbar.AssignedWarehouses`;
    public readonly workDayPanelToolbarConstructionSitesInfoSubTextLanguageItemName: string = `WorkDayPanelToolbar.ConstructionSitesInfoSubText`;
    public readonly workDayPanelToolbarExportMepcoSubTextLanguageItemName: string = `WorkDayPanelToolbar.ExportMepcoSubText`;
    public readonly workDayPanelToolbarAnySubTextLanguageItemName: string = `WorkDayPanelToolbar.AnySubText`;
    public readonly invoiceToolbarNavisionTitleLanguageItemName: string = `InvoiceToolbar.NavisionTitle`;
    public readonly invoiceToolbarNavisionLanguageItemName: string = `InvoiceToolbar.Navision`;
    public readonly invoiceToolbarConstructionSiteNameOrNumberLanguageItemName: string = `InvoiceToolbar.ConstructionSiteNameOrNumber`;
    public readonly invoiceToolbarCustomerNameOrNumberLanguageItemName: string = `InvoiceToolbar.CustomerNameOrNumber`;
    public readonly invoiceToolbarInvoiceTitleLanguageItemName: string = `InvoiceToolbar.InvoiceTitle`;
    public readonly invoiceToolbarInvoiceLanguageItemName: string = `InvoiceToolbar.Invoice`;
    public readonly invoiceToolbarAnyStateLanguageItemName: string = `InvoiceToolbar.AnyState`;
    public readonly workDayPanelAllowanceLanguageItemName: string = `WorkDayPanel.Allowance`;
    public readonly workDayPanelEquipmentLanguageItemName: string = `WorkDayPanel.Equipment`;
    public readonly workDayPanelToolbarDailyHoursLanguageItemName: string = `WorkDayPanelToolbar.DailyHours`;
    public readonly workDayPanelToolbarDailyHoursSubTextLanguageItemName: string = `WorkDayPanelToolbar.DailyHoursSubText`;
    public readonly workDayPanelToolbarMonthsLanguageItemName: string = `WorkDayPanelToolbar.Months`;
    public readonly tasksPanelConfirmationExtraModuleLanguageItemName: string = `TasksPanel.Confirmation.ExtraModule`;
    public readonly tasksPanelExtraModuleCreatedLanguageItemName: string = `TasksPanel.ExtraModuleCreated`;
    public readonly formInputContractSalaryHourlyPriceLanguageItemName: string = `Form.Input.ContractSalaryHourlyPrice`;
    public readonly formInputWorkCardIdLanguageItemName: string = `Form.Input.WorkCardId`;
    public readonly formInputCostPoolLanguageItemName: string = `Form.Input.CostPool`;
    public readonly workDayPanelToolbarPeriodsLanguageItemName: string = `WorkDayPanelToolbar.Periods`;
    public readonly workDayPanelToolbarInvoicePeriodsLanguageItemName: string = `WorkDayPanelToolbar.InvoicePeriods`;
    public readonly workDayPanelToolbarSalaryPeriodsLanguageItemName: string = `WorkDayPanelToolbar.SalaryPeriods`;
    public readonly workDayPanelToolbarAnyLanguageItemName: string = `WorkDayPanelToolbar.Any`;
    public readonly workDayPanelToolbarExportTikonLanguageItemName: string = `WorkDayPanelToolbar.ExportTikon`;
    public readonly subContractorsAddSubcontractorLanguageItemName: string = `SubContractors.AddSubcontractor`;
    public readonly subContractorsTitleLanguageItemName: string = `SubContractors.Title`;
    public readonly subContractorsAddNewSubcontractorLanguageItemName: string = `SubContractors.AddNewSubcontractor`;
    public readonly subcontractorCreatedFlyoutLanguageItemName: string = `SubcontractorCreated.Flyout`;
    public readonly subcontractorPanelSubcontractorAddedFlyoutLanguageItemName: string = `SubcontractorPanel.SubcontractorAdded.Flyout`;
    public readonly subcontractorPanelSubcontractorRestoredFlyoutLanguageItemName: string = `SubcontractorPanel.SubcontractorRestored.Flyout`;
    public readonly tasksMountersLanguageItemName: string = `Tasks.Mounters`;
    public readonly tasksTypeLanguageItemName: string = `Tasks.Type`;
    public readonly tasksNameLanguageItemName: string = `Tasks.Name`;
    public readonly tasksStartLanguageItemName: string = `Tasks.Start`;
    public readonly tasksDoneLanguageItemName: string = `Tasks.Done`;
    public readonly tasksHoursLanguageItemName: string = `Tasks.Hours`;
    public readonly tasksExtraHoursLanguageItemName: string = `Tasks.ExtraHours`;
    public readonly tasksDateLanguageItemName: string = `Tasks.Date`;
    public readonly tasksToolbarSearchLanguageItemName: string = `TasksToolbar.Search`;
    public readonly tasksToolbarDateLanguageItemName: string = `TasksToolbar.Date`;
    public readonly tasksToolbarClearFiltersLanguageItemName: string = `TasksToolbar.ClearFilters`;
    public readonly componentSignatureWidgetClearLanguageItemName: string = `Component.SignatureWidget.Clear`;
    public readonly componentSignatureWidgetDoneLanguageItemName: string = `Component.SignatureWidget.Done`;
    public readonly componentModalSaveChangesLanguageItemName: string = `Component.Modal.SaveChanges`;
    public readonly componentModalCloseLanguageItemName: string = `Component.Modal.Close`;
    public readonly componentPageContainerPageHelpLanguageItemName: string = `Component.PageContainer.PageHelp`;
    public readonly subcontractorWorkDayPanelSubcontractorsLanguageItemName: string = `SubcontractorWorkDayPanel.Subcontractors`;
    public readonly subcontractorWorkDayPanelManagersLanguageItemName: string = `SubcontractorWorkDayPanel.Managers`;
    public readonly subcontractorWorkDayPanelMountersLanguageItemName: string = `SubcontractorWorkDayPanel.Mounters`;
    public readonly userManagementUserDeletedLanguageItemName: string = `UserManagement.UserDeleted`;
    public readonly userManagementUserDeletedPermanentlyLanguageItemName: string = `UserManagement.UserDeletedPermanently`;
    public readonly userManagementButtonRestoreLanguageItemName: string = `UserManagement.Button.Restore`;
    public readonly userManagementButtonDeleteLanguageItemName: string = `UserManagement.Button.Delete`;
    public readonly userManagementButtonUnlockLanguageItemName: string = `UserManagement.Button.Unlock`;
    public readonly dashboardCreateTaskDescriptionLanguageItemName: string = `Dashboard.CreateTaskDescription`;
    public readonly dashboardCreateTaskForCurrentSiteDescriptionLanguageItemName: string = `Dashboard.CreateTaskForCurrentSiteDescription`;
    public readonly dashboardSelectTaskLanguageItemName: string = `Dashboard.SelectTask`;
    public readonly dashboardSwitchTaskLanguageItemName: string = `Dashboard.SwitchTask`;
    public readonly dashboardSwitchTaskDescriptionLanguageItemName: string = `Dashboard.SwitchTaskDescription`;
    public readonly rentaTasksDashboardGetManualLanguageItemName: string = `RentaTasks.Dashboard.GetManual`;
    public readonly selectTaskDropdownTaskLabelLanguageItemName: string = `SelectTask.DropdownTask.Label`;
    public readonly selectTaskDropdownTaskDescriptionLanguageItemName: string = `SelectTask.DropdownTask.Description`;
    public readonly selectTaskGetManualLanguageItemName: string = `SelectTask.GetManual`;
    public readonly selectTaskFetchTasksErrorLanguageItemName: string = `SelectTask.FetchTasks.Error`;
    public readonly selectOrganizationDropdownOrganizationLabelLanguageItemName: string = `SelectOrganization.DropdownOrganization.Label`;
    public readonly selectOrganizationDropdownOrganizationDescriptionLanguageItemName: string = `SelectOrganization.DropdownOrganization.Description`;
    public readonly selectOrganizationGetManualLanguageItemName: string = `SelectOrganization.GetManual`;
    public readonly componentNavigationWidgetPreviousLanguageItemName: string = `Component.NavigationWidget.Previous`;
    public readonly componentNavigationWidgetReturnToPreviousLanguageItemName: string = `Component.NavigationWidget.ReturnToPrevious`;
    public readonly componentNavigationWidgetNextLanguageItemName: string = `Component.NavigationWidget.Next`;
    public readonly componentNavigationWidgetGoToNextLanguageItemName: string = `Component.NavigationWidget.GoToNext`;
    public readonly taskAdditionalEquipmentsLanguageItemName: string = `Task.AdditionalEquipments`;
    public readonly taskAdditionalEquipmentsDescriptionLanguageItemName: string = `Task.AdditionalEquipmentsDescription`;
    public readonly taskHoursLanguageItemName: string = `Task.Hours`;
    public readonly taskHoursDescriptionLanguageItemName: string = `Task.HoursDescription`;
    public readonly taskInProgressLanguageItemName: string = `Task.InProgress`;
    public readonly taskDoneLanguageItemName: string = `Task.Done`;
    public readonly taskTaskStatusLanguageItemName: string = `Task.TaskStatus`;
    public readonly taskTaskStatusDescriptionLanguageItemName: string = `Task.TaskStatusDescription`;
    public readonly taskApproveLanguageItemName: string = `Task.Approve`;
    public readonly taskApproveDescriptionLanguageItemName: string = `Task.ApproveDescription`;
    public readonly taskConfirmLanguageItemName: string = `Task.Confirm`;
    public readonly taskGetManualLanguageItemName: string = `Task.GetManual`;
    public readonly distanceTravelDistanceLanguageItemName: string = `Distance.TravelDistance`;
    public readonly distanceTravelDistanceDescriptionLanguageItemName: string = `Distance.TravelDistanceDescription`;
    public readonly distanceSignOutLanguageItemName: string = `Distance.SignOut`;
    public readonly distanceGetManualLanguageItemName: string = `Distance.GetManual`;
    public readonly selectConstructionSiteGetManualLanguageItemName: string = `SelectConstructionSite.GetManual`;
    public readonly selectConstructionSiteConstructionSiteLanguageItemName: string = `SelectConstructionSite.ConstructionSite`;
    public readonly selectConstructionSiteConstructionSiteDescriptionLanguageItemName: string = `SelectConstructionSite.ConstructionSiteDescription`;
    public readonly approveCombineLanguageItemName: string = `Approve.Combine`;
    public readonly approveCombineDescriptionLanguageItemName: string = `Approve.CombineDescription`;
    public readonly approveWorkReportNameLanguageItemName: string = `Approve.WorkReportName`;
    public readonly approveWorkReportNameDescriptionLanguageItemName: string = `Approve.WorkReportNameDescription`;
    public readonly approveGetManualLanguageItemName: string = `Approve.GetManual`;
    public readonly allowanceNoDailyLanguageItemName: string = `Allowance.NoDaily`;
    public readonly allowanceOwnToolsLanguageItemName: string = `Allowance.OwnTools`;
    public readonly allowanceOwnToolsDescriptionLanguageItemName: string = `Allowance.OwnToolsDescription`;
    public readonly allowanceGetManualLanguageItemName: string = `Allowance.GetManual`;
    public readonly signatureApprovalTypeLanguageItemName: string = `Signature.ApprovalType`;
    public readonly signatureApprovalTypeDescriptionLanguageItemName: string = `Signature.ApprovalTypeDescription`;
    public readonly signatureSignatureLanguageItemName: string = `Signature.Signature`;
    public readonly signatureSignatureDescriptionLanguageItemName: string = `Signature.SignatureDescription`;
    public readonly signatureGetManualLanguageItemName: string = `Signature.GetManual`;
    public readonly qrWidgetScanErrorLanguageItemName: string = `QrWidget.Scan.Error`;
    public readonly addConstructionsiteTitleLanguageItemName: string = `AddConstructionsite.Title`;
    public readonly addContactPersonModalCreateLanguageItemName: string = `AddContactPersonModal.Create`;
    public readonly addEquipmentEquipmentListLanguageItemName: string = `AddEquipment.EquipmentList`;
    public readonly addEquipmentProductsLanguageItemName: string = `AddEquipment.Products`;
    public readonly addEquipmentProductsDescriptionLanguageItemName: string = `AddEquipment.ProductsDescription`;
    public readonly addMounterModalTaskLanguageItemName: string = `AddMounterModal.Task`;
    public readonly addTaskStartDateLanguageItemName: string = `AddTask.StartDate`;
    public readonly addTaskStartDateDescriptionLanguageItemName: string = `AddTask.StartDateDescription`;
    public readonly addTaskTaskDescriptionLanguageItemName: string = `AddTask.TaskDescription`;
    public readonly addTaskTaskDescriptionDescriptionLanguageItemName: string = `AddTask.TaskDescriptionDescription`;
    public readonly addTaskTaskNameLanguageItemName: string = `AddTask.TaskName`;
    public readonly addTaskTaskNameDescriptionLanguageItemName: string = `AddTask.TaskNameDescription`;
    public readonly addTaskModalAgreementLanguageItemName: string = `AddTaskModal.Agreement`;
    public readonly addTaskModalChangeTaskLanguageItemName: string = `AddTaskModal.ChangeTask`;
    public readonly addTaskModalCreateExtraModuleLanguageItemName: string = `AddTaskModal.CreateExtraModule`;
    public readonly addTaskModalDeleteLanguageItemName: string = `AddTaskModal.Delete`;
    public readonly addTaskModalDeleteConfirmLanguageItemName: string = `AddTaskModal.Delete.Confirm`;
    public readonly addTaskModalSaveTaskLanguageItemName: string = `AddTaskModal.SaveTask`;
    public readonly addTaskModalSiteOrWarehouseLanguageItemName: string = `AddTaskModal.SiteOrWarehouse`;
    public readonly addWorkReportModalAddCompletedExtraTaskLanguageItemName: string = `AddWorkReportModal.AddCompletedExtraTask`;
    public readonly addWorkReportModalDateTaskCompletedLanguageItemName: string = `AddWorkReportModal.DateTaskCompleted`;
    public readonly addWorkReportModalDescriptionOfTaskLanguageItemName: string = `AddWorkReportModal.DescriptionOfTask`;
    public readonly addWorkReportModalExistingExtraTasksLanguageItemName: string = `AddWorkReportModal.ExistingExtraTasks`;
    public readonly addWorkReportModalRemoveTaskWorkReportLanguageItemName: string = `AddWorkReportModal.RemoveTaskWorkReport`;
    public readonly userManagementSettingsKeyLanguageItemName: string = `UserManagement.SettingsKey`;
    public readonly userManagementSettingsValueLanguageItemName: string = `UserManagement.SettingsValue`;
    public readonly userManagementShowDeletedLanguageItemName: string = `UserManagement.ShowDeleted`;
    public readonly userManagementUserRestoredLanguageItemName: string = `UserManagement.UserRestored`;
    public readonly auditModuleGetManualLanguageItemName: string = `AuditModule.GetManual`;
    public readonly baseInputTotalSizeTooBigLanguageItemName: string = `BaseInput.TotalSizeTooBig`;
    public readonly constructionSiteManagementAddAgreementLanguageItemName: string = `ConstructionSiteManagement.AddAgreement`;
    public readonly constructionSiteAgreementDeactivatedLanguageItemName: string = `ConstructionSiteAgreement.Deactivated`;
    public readonly constructionSiteAgreementContactUserLanguageItemName: string = `ConstructionSiteAgreement.ContactUser`;
    public readonly constructionSitePanelOrganizationContractLanguageItemName: string = `ConstructionSitePanel.OrganizationContract`;
    public readonly constructionSitePanelPaymentTermsLanguageItemName: string = `ConstructionSitePanel.PaymentTerms`;
    public readonly dashboardSwitchSiteLanguageItemName: string = `Dashboard.SwitchSite`;
    public readonly dashboardSwitchSiteDescriptionLanguageItemName: string = `Dashboard.SwitchSiteDescription`;
    public readonly enumExtraChargeTypeAssemblyLanguageItemName: string = `Enum.ExtraChargeType.Assembly`;
    public readonly enumExtraChargeTypeCoverSalesLanguageItemName: string = `Enum.ExtraChargeType.CoverSales`;
    public readonly enumExtraChargeTypeDeliveryLanguageItemName: string = `Enum.ExtraChargeType.Delivery`;
    public readonly enumExtraChargeTypeDismantleLanguageItemName: string = `Enum.ExtraChargeType.Dismantle`;
    public readonly enumExtraChargeTypeOtherEquipmentSalesLanguageItemName: string = `Enum.ExtraChargeType.OtherEquipmentSales`;
    public readonly enumExtraChargeTypeReturnLanguageItemName: string = `Enum.ExtraChargeType.Return`;
    public readonly enumExtraChargeTypeScaffoldingEquipmentSalesLanguageItemName: string = `Enum.ExtraChargeType.ScaffoldingEquipmentSales`;
    public readonly enumExtraChargeUnitHourLanguageItemName: string = `Enum.ExtraChargeUnit.Hour`;
    public readonly enumExtraChargeUnitM2LanguageItemName: string = `Enum.ExtraChargeUnit.M2`;
    public readonly enumExtraChargeUnitPcsLanguageItemName: string = `Enum.ExtraChargeUnit.Pcs`;
    public readonly enumInvoiceRowTypeTaskEquipmentLanguageItemName: string = `Enum.InvoiceRowType.TaskEquipment`;
    public readonly enumInvoiceRowTypeTaskEquipmentDescriptionLanguageItemName: string = `Enum.InvoiceRowType.TaskEquipment.Description`;
    public readonly enumInvoiceRowTypeTaskExtraChargeLanguageItemName: string = `Enum.InvoiceRowType.TaskExtraCharge`;
    public readonly enumInvoiceRowTypeWorkReportsLanguageItemName: string = `Enum.InvoiceRowType.WorkReports`;
    public readonly enumModuleModelModulesLanguageItemName: string = `Enum.ModuleModel.Modules`;
    public readonly formInputMiddlenameLanguageItemName: string = `Form.Input.Middlename`;
    public readonly genericApprovalLanguageItemName: string = `Generic.Approval`;
    public readonly genericConstructionsiteLanguageItemName: string = `Generic.Constructionsite`;
    public readonly genericDateLanguageItemName: string = `Generic.Date`;
    public readonly genericLoadingLanguageItemName: string = `Generic.Loading`;
    public readonly genericUnlockForEditingLanguageItemName: string = `Generic.UnlockForEditing`;
    public readonly imageModalPreviewNotSupportedLanguageItemName: string = `ImageModal.PreviewNotSupported`;
    public readonly invoicesCreditInvoiceCreatedLanguageItemName: string = `Invoices.CreditInvoiceCreated`;
    public readonly invoicesCreditInvoiceCustomerConfirmationLanguageItemName: string = `Invoices.CreditInvoiceCustomerConfirmation`;
    public readonly invoicesExportInfoLanguageItemName: string = `Invoices.ExportInfo`;
    public readonly invoicesNothingSelectedLanguageItemName: string = `Invoices.NothingSelected`;
    public readonly invoicesInvoiceCustomerConfirmationLanguageItemName: string = `Invoices.InvoiceCustomerConfirmation`;
    public readonly invoicesMarkedAsExportedLanguageItemName: string = `Invoices.MarkedAsExported`;
    public readonly invoicesSentNumberLanguageItemName: string = `Invoices.SentNumber`;
    public readonly invoicesSentToAccountingLanguageItemName: string = `Invoices.SentToAccounting`;
    public readonly myAccountPageDataSavedLanguageItemName: string = `MyAccountPage.DataSaved`;
    public readonly myAccountPageFiltersBehaviorLabelLanguageItemName: string = `MyAccountPage.FiltersBehaviorLabel`;
    public readonly myAccountPageMyDocumentsTabTitleLanguageItemName: string = `MyAccountPage.MyDocumentsTabTitle`;
    public readonly myAccountPageMyInfoTabTitleLanguageItemName: string = `MyAccountPage.MyInfoTabTitle`;
    public readonly myAccountPageAcceptanceLanguageItemName: string = `MyAccountPage.Acceptance`;
    public readonly myAccountPageAcceptanceRequiredLanguageItemName: string = `MyAccountPage.Acceptance.Required`;
    public readonly myAccountPageAcceptanceTermsLanguageItemName: string = `MyAccountPage.Acceptance.Terms`;
    public readonly myAccountPageAcceptanceTermsTitleLanguageItemName: string = `MyAccountPage.Acceptance.Terms.Title`;
    public readonly myAccountPageAcceptanceTermsContentLanguageItemName: string = `MyAccountPage.Acceptance.Terms.Content`;
    public readonly myAccountPageAcceptancePrivacyNoticeLanguageItemName: string = `MyAccountPage.Acceptance.PrivacyNotice`;
    public readonly myAccountPageAcceptancePrivacyNoticeTitleLanguageItemName: string = `MyAccountPage.Acceptance.PrivacyNotice.Title`;
    public readonly myAccountPageAcceptancePrivacyNoticeContentLanguageItemName: string = `MyAccountPage.Acceptance.PrivacyNotice.Content`;
    public readonly myAccountPageUserAlreadyExistsLanguageItemName: string = `MyAccountPage.UserAlreadyExists`;
    public readonly organizationPanelExternalAddressLanguageItemName: string = `OrganizationPanel.ExternalAddress`;
    public readonly organizationPanelExternalIdLanguageItemName: string = `OrganizationPanel.ExternalId`;
    public readonly rentaTasksDashboardSignOutLanguageItemName: string = `RentaTasks.Dashboard.SignOut`;
    public readonly sendWorkReportModalEmailExistsLanguageItemName: string = `SendWorkReportModal.EmailExists`;
    public readonly splitModuleSubTitleLanguageItemName: string = `Split.ModuleSubTitle`;
    public readonly splitModuleTitleLanguageItemName: string = `Split.ModuleTitle`;
    public readonly subcontractorPanelDeleteSubcontractorLanguageItemName: string = `SubcontractorPanel.DeleteSubcontractor`;
    public readonly subcontractorPanelRestoreSubcontractorLanguageItemName: string = `SubcontractorPanel.RestoreSubcontractor`;
    public readonly taskExtraChangeGridNoExtraChargesLanguageItemName: string = `TaskExtraChangeGrid.NoExtraCharges`;
    public readonly taskExtraChangePanelExtraChargeTypeLanguageItemName: string = `TaskExtraChangePanel.ExtraChargeType`;
    public readonly tasksPanelAddExtraChargeConfirmationLanguageItemName: string = `TasksPanel.AddExtraCharge.Confirmation`;
    public readonly tasksPanelAddExtraChargeFlyoutLanguageItemName: string = `TasksPanel.AddExtraCharge.Flyout`;
    public readonly tasksPanelAddExtraChargeModalAmountLanguageItemName: string = `TasksPanel.AddExtraChargeModal.Amount`;
    public readonly tasksPanelAddExtraChargeModalPriceLanguageItemName: string = `TasksPanel.AddExtraChargeModal.Price`;
    public readonly tasksPanelAddExtraChargeModalSubmitLanguageItemName: string = `TasksPanel.AddExtraChargeModal.Submit`;
    public readonly tasksPanelAddExtraChargeModalSubtitleLanguageItemName: string = `TasksPanel.AddExtraChargeModal.Subtitle`;
    public readonly tasksPanelAddExtraChargeModalTitleLanguageItemName: string = `TasksPanel.AddExtraChargeModal.Title`;
    public readonly tasksPanelAddExtraChargeModalTypeLanguageItemName: string = `TasksPanel.AddExtraChargeModal.Type`;
    public readonly tasksPanelAddExtraChargeModalUnitLanguageItemName: string = `TasksPanel.AddExtraChargeModal.Unit`;
    public readonly tasksPanelAgreementLanguageItemName: string = `TasksPanel.Agreement`;
    public readonly tasksPanelApproveTaskLanguageItemName: string = `TasksPanel.ApproveTask`;
    public readonly tasksPanelChangeWorkReportTitleLanguageItemName: string = `TasksPanel.ChangeWorkReportTitle`;
    public readonly tasksPanelComplitionDateLanguageItemName: string = `TasksPanel.ComplitionDate`;
    public readonly tasksPanelCostLanguageItemName: string = `TasksPanel.Cost`;
    public readonly tasksPanelCreateExtraModuleLanguageItemName: string = `TasksPanel.CreateExtraModule`;
    public readonly tasksPanelCreateModuleLanguageItemName: string = `TasksPanel.CreateModule`;
    public readonly tasksPanelCreateTaskWorkReportLanguageItemName: string = `TasksPanel.CreateTaskWorkReport`;
    public readonly tasksPanelDateLanguageItemName: string = `TasksPanel.Date`;
    public readonly tasksPanelRentTabTitleLanguageItemName: string = `TasksPanel.RentTabTitle`;
    public readonly tasksPanelSaveWorkReportTitleLanguageItemName: string = `TasksPanel.SaveWorkReportTitle`;
    public readonly tasksPanelTaskExtraChargesLanguageItemName: string = `TasksPanel.TaskExtraCharges`;
    public readonly tasksPanelTaskHoursLanguageItemName: string = `TasksPanel.TaskHours`;
    public readonly taskTooltipsTaskApprovedLanguageItemName: string = `TaskTooltips.TaskApproved`;
    public readonly taskTooltipsTaskInProgressLanguageItemName: string = `TaskTooltips.TaskInProgress`;
    public readonly taskTooltipsTaskInvoicedLanguageItemName: string = `TaskTooltips.TaskInvoiced`;
    public readonly taskTooltipsTaskReadyForInvoicingLanguageItemName: string = `TaskTooltips.TaskReadyForInvoicing`;
    public readonly taskTooltipsTaskWaitingActivationLanguageItemName: string = `TaskTooltips.TaskWaitingActivation`;
    public readonly taskTooltipsTaskWaitingApprovalLanguageItemName: string = `TaskTooltips.TaskWaitingApproval`;
    public readonly topNavConstructionSiteManagementLanguageItemName: string = `TopNav.ConstructionSiteManagement`;
    public readonly validatorsLengthLanguageItemName: string = `Validators.Length`;
    public readonly workDayAllowanceDistanceLanguageItemName: string = `WorkDayAllowance.Distance`;
    public readonly workDayPanelContractLanguageItemName: string = `WorkDayPanel.Contract`;
    public readonly workDayPanelCompensationsLanguageItemName: string = `WorkDayPanel.Compensations`;
    public readonly workDayPanelPassengersDescriptionLanguageItemName: string = `WorkDayPanel.PassengersDescription`;
    public readonly userManagementGridNoInvitationsTextLanguageItemName: string = `UserManagement.Grid.NoInvitationsText`;
    public readonly userManagementButtonResendInvitationLanguageItemName: string = `UserManagement.Button.ResendInvitation`;
    public readonly userManagementButtonResetPasswordLanguageItemName: string = `UserManagement.Button.ResetPassword`;
    public readonly userManagementLabelAuthenticationTypeLanguageItemName: string = `UserManagement.Label.AuthenticationType`;
    public readonly enumAuthTypeEmailLanguageItemName: string = `Enum.AuthType.Email`;
    public readonly enumAuthTypePhoneLanguageItemName: string = `Enum.AuthType.Phone`;
    public readonly userManagementTabInvitationsLanguageItemName: string = `UserManagement.Tab.Invitations`;
    public readonly userManagementConfirmationButtonResetPasswordLanguageItemName: string = `UserManagement.ConfirmationButton.ResetPassword`;
    public readonly userManagementConfirmationButtonResendInvitationLanguageItemName: string = `UserManagement.ConfirmationButton.ResendInvitation`;
    public readonly userManagementAlertUserPasswordInfoLanguageItemName: string = `UserManagement.Alert.UserPasswordInfo`;
    public readonly userManagementGridCreatedByLanguageItemName: string = `UserManagement.Grid.CreatedBy`;
    public readonly userManagementGridTypeLanguageItemName: string = `UserManagement.Grid.Type`;
    public readonly userManagementGridCreatedAtLanguageItemName: string = `UserManagement.Grid.CreatedAt`;
    public readonly userManagementGridExpiresAtLanguageItemName: string = `UserManagement.Grid.ExpiresAt`;
    public readonly userManagementGridProcessedAtLanguageItemName: string = `UserManagement.Grid.ProcessedAt`;
    public readonly userManagementGridReusableLanguageItemName: string = `UserManagement.Grid.Reusable`;
    public readonly userManagementGridAuthTypeLanguageItemName: string = `UserManagement.Grid.AuthType`;
    public readonly userManagementAlertMessageAccountSavedLanguageItemName: string = `UserManagement.AlertMessage.AccountSaved`;
    public readonly userManagementAlertErrorAccountExistLanguageItemName: string = `UserManagement.AlertError.AccountExist`;
    public readonly userManagementAlertErrorPhoneNumberInvalidLanguageItemName: string = `UserManagement.AlertError.PhoneNumberInvalid`;
    public readonly forgotPasswordUsernameInputLanguageItemName: string = `ForgotPassword.UsernameInput`;
    public readonly enumInvitationTypeInvitationLanguageItemName: string = `Enum.InvitationType.Invitation`;
    public readonly enumInvitationTypeResetPasswordLanguageItemName: string = `Enum.InvitationType.ResetPassword`;
    public readonly enumInvitationTypeForgotPasswordLanguageItemName: string = `Enum.InvitationType.ForgotPassword`;
    public readonly userManagementConfirmationButtonRollbackLanguageItemName: string = `UserManagement.ConfirmationButton.Rollback`;
    public readonly addWorkReportModalAttachmentsLanguageItemName: string = `AddWorkReportModal.Attachments`;
    public readonly confirmationDialogCommentLanguageItemName: string = `ConfirmationDialog.Comment`;
    public readonly componentConfirmationDialogAreYouSureLanguageItemName: string = `Component.ConfirmationDialog.AreYouSure`;
    public readonly locationPickerModalTitleLanguageItemName: string = `LocationPickerModal.Title`;
    public readonly locationPickerModalSubtitleLanguageItemName: string = `LocationPickerModal.Subtitle`;
    public readonly locationPickerModalSetLocationLanguageItemName: string = `LocationPickerModal.SetLocation`;
    public readonly rentaTasksControllerSignInExpirationAlertLanguageItemName: string = `RentaTasks.Controller.SignInExpirationAlert`;
    public readonly widgetPwaInstallLanguageItemName: string = `Widget.Pwa.Install`;
    public readonly widgetPwaDescriptionLanguageItemName: string = `Widget.Pwa.Description`;
    public readonly widgetBudgetDataModuleLabelLanguageItemName: string = `Widget.BudgetData.Module.Label`;
    public readonly widgetBudgetDataPerimeterFrameLabelLanguageItemName: string = `Widget.BudgetData.PerimeterFrame.Label`;
    public readonly widgetBudgetDataWeatherShelterLabelLanguageItemName: string = `Widget.BudgetData.WeatherShelter.Label`;
    public readonly tasksPanelAddExtraChargeModalDescriptionLanguageItemName: string = `TasksPanel.AddExtraChargeModal.Description`;
    public readonly addWorkReportModalDeleteConfirmLanguageItemName: string = `AddWorkReportModal.Delete.Confirm`;
    public readonly constructionSitesConfirmationActivateSiteLanguageItemName: string = `ConstructionSites.Confirmation.ActivateSite`;
    public readonly constructionSitesConfirmationDeactivateSiteLanguageItemName: string = `ConstructionSites.Confirmation.DeactivateSite`;
    public readonly addConstructionSiteInvoiceReferenceLanguageItemName: string = `AddConstructionSite.InvoiceReference`;
    public readonly addConstructionSiteHourPriceLanguageItemName: string = `AddConstructionSite.HourPrice`;
    public readonly addConstructionSiteMileagePriceLanguageItemName: string = `AddConstructionSite.MileagePrice`;
    public readonly componentHoursWidgetHoursSpentLanguageItemName: string = `Component.HoursWidget.HoursSpent`;
    public readonly componentHoursWidgetAddOvertimeLanguageItemName: string = `Component.HoursWidget.AddOvertime`;
    public readonly componentHoursWidgetNormalHoursLanguageItemName: string = `Component.HoursWidget.NormalHours`;
    public readonly summaryWidgetTitleLanguageItemName: string = `SummaryWidget.Title`;
    public readonly summaryWidgetOrdererLanguageItemName: string = `SummaryWidget.Orderer`;
    public readonly summaryWidgetApproverLanguageItemName: string = `SummaryWidget.Approver`;
    public readonly summaryWidgetButtonCreateApproverLanguageItemName: string = `SummaryWidget.Button.CreateApprover`;
    public readonly summaryWidgetWorkOrderNameLanguageItemName: string = `SummaryWidget.WorkOrderName`;
    public readonly summaryWidgetWorkOrderDescriptionLanguageItemName: string = `SummaryWidget.WorkOrderDescription`;
    public readonly genericNoDataLanguageItemName: string = `Generic.NoData`;
    public readonly createContractPersonModalSubtitleLanguageItemName: string = `CreateContractPersonModal.Subtitle`;
    public readonly workOrdersPageTitleLanguageItemName: string = `WorkOrders.Page.Title`;
    public readonly workOrdersActiveListNoOrdersLanguageItemName: string = `WorkOrders.ActiveList.NoOrders`;
    public readonly workOrdersActiveListTitleLanguageItemName: string = `WorkOrders.ActiveList.Title`;
    public readonly workOrdersCompletedListNoOrdersLanguageItemName: string = `WorkOrders.CompletedList.NoOrders`;
    public readonly workOrdersCompletedListTitleLanguageItemName: string = `WorkOrders.CompletedList.Title`;
    public readonly workOrdersFiltersConstructionSiteLanguageItemName: string = `WorkOrders.Filters.ConstructionSite`;
    public readonly workOrdersFiltersCustomerLanguageItemName: string = `WorkOrders.Filters.Customer`;
    public readonly workOrdersFiltersDateLanguageItemName: string = `WorkOrders.Filters.Date`;
    public readonly workOrdersFiltersFromLanguageItemName: string = `WorkOrders.Filters.From`;
    public readonly workOrdersFiltersNameLanguageItemName: string = `WorkOrders.Filters.Name`;
    public readonly workOrdersFiltersStatusesLanguageItemName: string = `WorkOrders.Filters.Statuses`;
    public readonly workOrdersFiltersToLanguageItemName: string = `WorkOrders.Filters.To`;
    public readonly workOrdersFiltersButtonApplyLanguageItemName: string = `WorkOrders.FiltersButton.Apply`;
    public readonly workOrdersFiltersButtonClearLanguageItemName: string = `WorkOrders.FiltersButton.Clear`;
    public readonly enumWorkOrderStatusApprovedByCustomerLanguageItemName: string = `Enum.WorkOrderStatus.ApprovedByCustomer`;
    public readonly enumWorkOrderStatusApprovedByManagerLanguageItemName: string = `Enum.WorkOrderStatus.ApprovedByManager`;
    public readonly enumWorkOrderStatusCompletedLanguageItemName: string = `Enum.WorkOrderStatus.Completed`;
    public readonly enumWorkOrderStatusCreatedLanguageItemName: string = `Enum.WorkOrderStatus.Created`;
    public readonly enumWorkOrderStatusDeclinedByCustomerLanguageItemName: string = `Enum.WorkOrderStatus.DeclinedByCustomer`;
    public readonly enumWorkOrderStatusDeclinedByManagerLanguageItemName: string = `Enum.WorkOrderStatus.DeclinedByManager`;
    public readonly enumWorkOrderStatusDeletedLanguageItemName: string = `Enum.WorkOrderStatus.Deleted`;
    public readonly enumWorkOrderStatusHasActiveTasksDescriptionLanguageItemName: string = `Enum.WorkOrderStatus.HasActiveTasks.Description`;
    public readonly enumWorkOrderStatusInvoicedLanguageItemName: string = `Enum.WorkOrderStatus.Invoiced`;
    public readonly enumWorkOrderStatusInProgressLanguageItemName: string = `Enum.WorkOrderStatus.InProgress`;
    public readonly enumWorkOrderStatusInvoiceNotCreatedDescriptionLanguageItemName: string = `Enum.WorkOrderStatus.InvoiceNotCreated.Description`;
    public readonly enumWorkOrderStatusSentToCustomerLanguageItemName: string = `Enum.WorkOrderStatus.SentToCustomer`;
    public readonly enumWorkOrderStatusInvoiceRowsNotApprovedNyManagerDescriptionLanguageItemName: string = `Enum.WorkOrderStatus.InvoiceRowsNotApprovedNyManager.Description`;
    public readonly enumWorkOrderStatusUnknownLanguageItemName: string = `Enum.WorkOrderStatus.Unknown`;
    public readonly enumWorkOrderStatusTaskNotApprovedByManagerDescriptionLanguageItemName: string = `Enum.WorkOrderStatus.TaskNotApprovedByManager.Description`;
    public readonly enumWorkOrderStatusWorkReportNotApprovedByCustomerDescriptionLanguageItemName: string = `Enum.WorkOrderStatus.WorkReportNotApprovedByCustomer.Description`;
    public readonly enumWorkOrderStatusWorkReportNotSentDescriptionLanguageItemName: string = `Enum.WorkOrderStatus.WorkReportNotSent.Description`;
    public readonly enumFiltersBehaviorSystemDefaultLanguageItemName: string = `Enum.FiltersBehavior.SystemDefault`;
    public readonly enumFiltersBehaviorUserSpecifiedLanguageItemName: string = `Enum.FiltersBehavior.UserSpecified`;
    public readonly workOrdersFiltersModalTitleActiveLanguageItemName: string = `WorkOrdersFiltersModal.Title.Active`;
    public readonly workOrdersFiltersModalTitleCompletedLanguageItemName: string = `WorkOrdersFiltersModal.Title.Completed`;
    public readonly workOrdersModalActionsActivateLanguageItemName: string = `WorkOrders.Modal.Actions.Activate`;
    public readonly workOrdersModalActionsApproveLanguageItemName: string = `WorkOrders.Modal.Actions.Approve`;
    public readonly workOrdersModalActionsCompleteLanguageItemName: string = `WorkOrders.Modal.Actions.Complete`;
    public readonly workOrdersModalActionsEditLanguageItemName: string = `WorkOrders.Modal.Actions.Edit`;
    public readonly workOrdersActionsModalTitleLanguageItemName: string = `WorkOrdersActionsModal.Title`;
    public readonly workOrdersAlertMessageWorkOrderActivatedLanguageItemName: string = `WorkOrders.AlertMessage.WorkOrderActivated`;
    public readonly workOrdersAlertMessageWorkOrderCompletedLanguageItemName: string = `WorkOrders.AlertMessage.WorkOrderCompleted`;
    public readonly workOrdersApprovedAlertLanguageItemName: string = `WorkOrders.Approved.Alert`;
    public readonly workOrdersValidationErrorApproverCreationRejectedLanguageItemName: string = `WorkOrders.ValidationError.ApproverCreationRejected`;
    public readonly sendWorkOrderModalButtonSendOrApproveLanguageItemName: string = `SendWorkOrderModal.Button.SendOrApprove`;
    public readonly approveWorkReportTitleLanguageItemName: string = `ApproveWorkReport.Title`;
    public readonly workOrdersOwnerSelectConstructionSiteLanguageItemName: string = `WorkOrders.Owner.SelectConstructionSite`;
    public readonly workOrdersActionsSendLanguageItemName: string = `WorkOrders.Actions.Send`;
    public readonly constructionSiteManagementTabsContractLanguageItemName: string = `ConstructionSiteManagement.Tabs.Contract`;
    public readonly constructionSiteManagementTabsWorkOrdersLanguageItemName: string = `ConstructionSiteManagement.Tabs.WorkOrders`;
    public readonly workOrdersActionsLockLanguageItemName: string = `WorkOrders.Actions.Lock`;
    public readonly workOrdersActionsInvoiceLanguageItemName: string = `WorkOrders.Actions.Invoice`;
    public readonly constructionSitePanelExternalAddressLanguageItemName: string = `ConstructionSitePanel.ExternalAddress`;
    public readonly dashboardGetManualLanguageItemName: string = `Dashboard.GetManual`;
    public readonly constructionSiteManagementGetManualLanguageItemName: string = `ConstructionSiteManagement.GetManual`;
    public readonly roleNameManagerLanguageItemName: string = `RoleName.Manager`;
    public readonly roleNameBusinessManagerLanguageItemName: string = `RoleName.BusinessManager`;
    public readonly workOrdersPanelNewWorkOrderLanguageItemName: string = `WorkOrdersPanel.NewWorkOrder`;
    public readonly rentaTasksWorkOrdersGetManualLanguageItemName: string = `RentaTasks.WorkOrders.GetManual`;
    public readonly workOrderActionsConfirmCompletedActivationLanguageItemName: string = `WorkOrder.Actions.ConfirmCompletedActivation`;
    public readonly workOrderActionsConfirmActivationLanguageItemName: string = `WorkOrder.Actions.ConfirmActivation`;
    public readonly workOrderActionsConfirmCompletionLanguageItemName: string = `WorkOrder.Actions.ConfirmCompletion`;
    public readonly workOrderActionsUnlockLanguageItemName: string = `WorkOrder.Actions.Unlock`;
    public readonly workOrderActionsConfirmInvoiceLanguageItemName: string = `WorkOrder.Actions.ConfirmInvoice`;
    public readonly sendWorkOrderModalApproverTitleLanguageItemName: string = `SendWorkOrderModal.Approver.Title`;
    public readonly sendWorkOrderModalOrdererTitleLanguageItemName: string = `SendWorkOrderModal.Orderer.Title`;
    public readonly sendWorkOrderModalApproverSubtitleLanguageItemName: string = `SendWorkOrderModal.Approver.Subtitle`;
    public readonly sendWorkOrderModalOrdererSubtitleLanguageItemName: string = `SendWorkOrderModal.Orderer.Subtitle`;
    public readonly sendWorkOrderModalButtonAssignLanguageItemName: string = `SendWorkOrderModal.Button.Assign`;
    public readonly sendWorkOrderModalButtonTooltipAssignLanguageItemName: string = `SendWorkOrderModal.Button.Tooltip.Assign`;
    public readonly workOrdersGridNoDataTextLanguageItemName: string = `WorkOrders.Grid.NoDataText`;
    public readonly workDayPanelGridAggregatesNoDataTextLanguageItemName: string = `WorkDayPanel.Grid.Aggregates.NoDataText`;
    public readonly workOrderDetailsPanelGridHoursNoDataTextLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Hours.NoDataText`;
    public readonly workOrderDetailsPanelGridProductUnitLanguageItemName: string = `WorkOrderDetailsPanel.Grid.ProductUnit`;
    public readonly workOrderDetailsPanelGridEquipmentNoDataTextLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Equipment.NoDataText`;
    public readonly contactSupportPageMessageSentLanguageItemName: string = `ContactSupportPage.MessageSent`;
    public readonly contactSupportPageMessageWithIdSentLanguageItemName: string = `ContactSupportPage.MessageWithIdSent`;
    public readonly rentaTasksWorkOrderSignInConfirmLanguageItemName: string = `RentaTasks.WorkOrder.SignIn.Confirm`;
    public readonly rentaTasksWorkOrderSignInAlertLanguageItemName: string = `RentaTasks.WorkOrder.SignIn.Alert`;
    public readonly rentaTasksWorkOrderManualTitleLanguageItemName: string = `RentaTasks.WorkOrder.Manual.Title`;
    public readonly genericKmLanguageItemName: string = `Generic.Km`;
    public readonly genericHoursLanguageItemName: string = `Generic.Hours`;
    public readonly rentaTasksWorkOrderLabelCustomerNameLanguageItemName: string = `RentaTasks.WorkOrder.Label.CustomerName`;
    public readonly rentaTasksWorkOrderLabelConstructionSiteLanguageItemName: string = `RentaTasks.WorkOrder.Label.ConstructionSite`;
    public readonly rentaTasksWorkOrderLabelAddressLanguageItemName: string = `RentaTasks.WorkOrder.Label.Address`;
    public readonly rentaTasksWorkOrderLabelOrdererLanguageItemName: string = `RentaTasks.WorkOrder.Label.Orderer`;
    public readonly rentaTasksWorkOrderLabelOrdererPhoneLanguageItemName: string = `RentaTasks.WorkOrder.Label.OrdererPhone`;
    public readonly rentaTasksWorkOrderLabelApproverLanguageItemName: string = `RentaTasks.WorkOrder.Label.Approver`;
    public readonly rentaTasksWorkOrderLabelApproverPhoneLanguageItemName: string = `RentaTasks.WorkOrder.Label.ApproverPhone`;
    public readonly rentaTasksWorkOrderLabelManagerLanguageItemName: string = `RentaTasks.WorkOrder.Label.Manager`;
    public readonly rentaTasksWorkOrderLabelManagerPhoneLanguageItemName: string = `RentaTasks.WorkOrder.Label.ManagerPhone`;
    public readonly rentaTasksWorkOrderLabelDistanceLanguageItemName: string = `RentaTasks.WorkOrder.Label.Distance`;
    public readonly rentaTasksWorkOrderLabelStatusLanguageItemName: string = `RentaTasks.WorkOrder.Label.Status`;
    public readonly rentaTasksWorkOrderLabelActivationDateLanguageItemName: string = `RentaTasks.WorkOrder.Label.ActivationDate`;
    public readonly rentaTasksWorkOrderLabelCompletionDateLanguageItemName: string = `RentaTasks.WorkOrder.Label.CompletionDate`;
    public readonly rentaTasksWorkOrderButtonLabelSignInLanguageItemName: string = `RentaTasks.WorkOrder.Button.Label.SignIn`;
    public readonly rentaTasksWorkOrderButtonLabelSignOutLanguageItemName: string = `RentaTasks.WorkOrder.Button.Label.SignOut`;
    public readonly rentaTasksWorkOrderButtonLabelAddEquipmentLanguageItemName: string = `RentaTasks.WorkOrder.Button.Label.AddEquipment`;
    public readonly rentaTasksWorkOrderButtonLabelBackLanguageItemName: string = `RentaTasks.WorkOrder.Button.Label.Back`;
    public readonly rentaTasksDashboardRouteWidgetMyWorkOrderLanguageItemName: string = `RentaTasks.Dashboard.RouteWidget.MyWorkOrder`;
    public readonly rentaTasksDashboardRouteWidgetWorkOrdersLanguageItemName: string = `RentaTasks.Dashboard.RouteWidget.WorkOrders`;
    public readonly rentaTasksWorkOrderSignOutAlertLanguageItemName: string = `RentaTasks.WorkOrder.SignOut.Alert`;
    public readonly rentaTasksWorkOrderSaveAlertLanguageItemName: string = `RentaTasks.WorkOrder.Save.Alert`;
    public readonly rentaTasksWorkOrderUpdateEquipmentAlertLanguageItemName: string = `RentaTasks.WorkOrder.UpdateEquipment.Alert`;
    public readonly rentaTasksWorkOrderCompleteAlertLanguageItemName: string = `RentaTasks.WorkOrder.Complete.Alert`;
    public readonly workOrdersFiltersEmployeesLanguageItemName: string = `WorkOrders.Filters.Employees`;
    public readonly workOrdersFiltersManagersLanguageItemName: string = `WorkOrders.Filters.Managers`;
    public readonly rentaTasksDashboardRouteWidgetWorkOrdersDescriptionLanguageItemName: string = `RentaTasks.Dashboard.RouteWidget.WorkOrders.Description`;
    public readonly workOrdersRowsNoAddressLanguageItemName: string = `WorkOrders.Rows.NoAddress`;
    public readonly editContactPersonModalButtonLabelSaveChangesLanguageItemName: string = `EditContactPersonModal.Button.Label.SaveChanges`;
    public readonly editContactPersonModalSubtitleLanguageItemName: string = `EditContactPersonModal.Subtitle`;
    public readonly summaryWidgetButtonEditApproverLanguageItemName: string = `SummaryWidget.Button.EditApprover`;
    public readonly summaryWidgetDropdownNothingSelectedLanguageItemName: string = `SummaryWidget.Dropdown.NothingSelected`;
    public readonly managersNewOrdererLanguageItemName: string = `Managers.NewOrderer`;
    public readonly workOrdersInvoiceReferenceLanguageItemName: string = `WorkOrders.InvoiceReference`;
    public readonly rentaTasksWorkOrderInfoCheckboxWidgetUnscheduledLanguageItemName: string = `RentaTasks.WorkOrderInfo.CheckboxWidget.Unscheduled`;
    public readonly rentaTasksWorkOrderInfoCheckboxWidgetUnscheduledDescriptionLanguageItemName: string = `RentaTasks.WorkOrderInfo.CheckboxWidget.Unscheduled.Description`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsSearchingLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProducts.Searching`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsProductsFoundLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProducts.ProductsFound`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsNoProductsFoundLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProducts.NoProductsFound`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsTextInputPlaceholderSearchLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProducts.TextInput.Placeholder.Search`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsSearchResultLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProducts.SearchResult`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsModalTitleEquipmentLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProductsModal.Title.Equipment`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsModalSubtitleChooseEquipmentLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProductsModal.Subtitle.ChooseEquipment`;
    public readonly taskTooltipsTaskUnscheduledLanguageItemName: string = `TaskTooltips.TaskUnscheduled`;
    public readonly workOrderStatusUnscheduledLanguageItemName: string = `WorkOrderStatus.Unscheduled`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsAddEquipmentLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProducts.AddEquipment`;
    public readonly rentaTasksAddEquipmentAddEquipmentDataProviderCategoryFavoriteLanguageItemName: string = `RentaTasks.AddEquipment.AddEquipmentDataProvider.Category.Favorite`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsNoProductsLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProducts.NoProducts`;
    public readonly rentaTasksWorkOrderLabelInvoiceReferenceLanguageItemName: string = `RentaTasks.WorkOrder.Label.InvoiceReference`;
    public readonly summaryWidgetReferenceLanguageItemName: string = `SummaryWidget.Reference`;
    public readonly rentaTasksWorkOrderButtonActivateLanguageItemName: string = `RentaTasks.WorkOrder.Button.Activate`;
    public readonly rentaTasksWorkOrderAlertWorkOrderNotActivatedLanguageItemName: string = `RentaTasks.WorkOrder.Alert.WorkOrderNotActivated`;
    public readonly workOrderEquipmentAddCustomProductLanguageItemName: string = `WorkOrderEquipment.AddCustomProduct`;
    public readonly rentaTasksAddEquipmentAddCustomProductModalAmountLanguageItemName: string = `RentaTasks.AddEquipment.AddCustomProductModal.Amount`;
    public readonly rentaTasksAddEquipmentAddCustomProductModalPriceLanguageItemName: string = `RentaTasks.AddEquipment.AddCustomProductModal.Price`;
    public readonly rentaTasksAddEquipmentAddCustomProductModalUnitLanguageItemName: string = `RentaTasks.AddEquipment.AddCustomProductModal.Unit`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsAddCustomEquipmentLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProducts.AddCustomEquipment`;
    public readonly rentaTasksAddEquipmentAddCustomProductModalTitleCustomEquipmentLanguageItemName: string = `RentaTasks.AddEquipment.AddCustomProductModal.Title.CustomEquipment`;
    public readonly rentaTasksAddEquipmentAddCustomProductModalSubtitleCustomEquipmentLanguageItemName: string = `RentaTasks.AddEquipment.AddCustomProductModal.Subtitle.CustomEquipment`;
    public readonly genericContactPersonDetailsLanguageItemName: string = `Generic.ContactPersonDetails`;
    public readonly addEquipmentSaveChangesConfirmationLanguageItemName: string = `AddEquipment.SaveChangesConfirmation`;
    public readonly userManagementTitleLanguageItemName: string = `UserManagement.Title`;
    public readonly warehouseManagementTitleLanguageItemName: string = `WarehouseManagement.Title`;
    public readonly addEquipmentSaveButtonLanguageItemName: string = `AddEquipment.SaveButton`;
    public readonly addEquipmentDontSaveButtonLanguageItemName: string = `AddEquipment.DontSaveButton`;
    public readonly addEquipmentCloseButtonLanguageItemName: string = `AddEquipment.CloseButton`;
    public readonly genericActionRestoreLanguageItemName: string = `Generic.Action.Restore`;
    public readonly genericActionDeleteLanguageItemName: string = `Generic.Action.Delete`;
    public readonly genericManagerLanguageItemName: string = `Generic.Manager`;
    public readonly genericAddressLanguageItemName: string = `Generic.Address`;
    public readonly genericShowDeletedLanguageItemName: string = `Generic.ShowDeleted`;
    public readonly genericActionReloadLanguageItemName: string = `Generic.Action.Reload`;
    public readonly warehousesWarehousesTabLanguageItemName: string = `Warehouses.WarehousesTab`;
    public readonly warehousesCostPoolsTabLanguageItemName: string = `Warehouses.CostPoolsTab`;
    public readonly warehousesCostPoolsTitleLanguageItemName: string = `Warehouses.CostPoolsTitle`;
    public readonly warehousesAlertWarehouseAlreadyExistsLanguageItemName: string = `Warehouses.Alert.WarehouseAlreadyExists`;
    public readonly warehousesCostPoolsDataDeleteConfirmationLanguageItemName: string = `Warehouses.CostPoolsData.DeleteConfirmation`;
    public readonly warehousesCostPoolsDataAlertCostPoolAlreadyExistsLanguageItemName: string = `Warehouses.CostPoolsData.Alert.CostPoolAlreadyExists`;
    public readonly warehousesWarehouseDetailsAlertCostPoolAlreadyAssignedLanguageItemName: string = `Warehouses.WarehouseDetails.Alert.CostPoolAlreadyAssigned`;
    public readonly warehousesWarehouseDetailsDeleteConfirmationLanguageItemName: string = `Warehouses.WarehouseDetails.DeleteConfirmation`;
    public readonly warehousesWarehouseDataAlertWarehouseNameAlreadyExistsLanguageItemName: string = `Warehouses.WarehouseData.Alert.WarehouseNameAlreadyExists`;
    public readonly warehousesWarehouseDataDeleteConfirmationLanguageItemName: string = `Warehouses.WarehouseData.DeleteConfirmation`;
    public readonly warehousesWarehouseDataAlertCreateWarehouseLanguageItemName: string = `Warehouses.WarehouseData.Alert.CreateWarehouse`;
    public readonly warehousesWarehouseDataAddNewWarehouseLanguageItemName: string = `Warehouses.WarehouseData.AddNewWarehouse`;
    public readonly genericCostPoolsLanguageItemName: string = `Generic.CostPools`;
    public readonly warehousesCostPoolsDataAddNewCostPoolLanguageItemName: string = `Warehouses.CostPoolsData.AddNewCostPool`;
    public readonly userManagementDropdownMultipleCostPoolsTextLanguageItemName: string = `UserManagement.Dropdown.MultipleCostPoolsText`;
    public readonly genericDescriptionLanguageItemName: string = `Generic.Description`;
    public readonly catalogManagementAddCategoryLanguageItemName: string = `CatalogManagement.AddCategory`;
    public readonly catalogManagementAddProductLanguageItemName: string = `CatalogManagement.AddProduct`;
    public readonly genericPriceLanguageItemName: string = `Generic.Price`;
    public readonly genericUnitLanguageItemName: string = `Generic.Unit`;
    public readonly genericCustomUnitLanguageItemName: string = `Generic.CustomUnit`;
    public readonly genericActionEditLanguageItemName: string = `Generic.Action.Edit`;
    public readonly genericGoIntoLanguageItemName: string = `Generic.GoInto`;
    public readonly genericIconLanguageItemName: string = `Generic.Icon`;
    public readonly genericActionSaveLanguageItemName: string = `Generic.Action.Save`;
    public readonly genericCategoryLanguageItemName: string = `Generic.Category`;
    public readonly genericAbbreviationsVehiclesLanguageItemName: string = `Generic.Abbreviations.Vehicles`;
    public readonly genericAbbreviationsKilometersLanguageItemName: string = `Generic.Abbreviations.Kilometers`;
    public readonly genericAbbreviationsHoursLanguageItemName: string = `Generic.Abbreviations.Hours`;
    public readonly catalogManagementPageTitleLanguageItemName: string = `CatalogManagement.PageTitle`;
    public readonly categoryItemValidationCategoryWithSameNameAlreadyExistsLanguageItemName: string = `CategoryItem.Validation.CategoryWithSameNameAlreadyExists`;
    public readonly productItemValidationProductWithSameNameAlreadyExistsLanguageItemName: string = `ProductItem.Validation.ProductWithSameNameAlreadyExists`;
    public readonly genericExternalIdLanguageItemName: string = `Generic.ExternalId`;
    public readonly catalogManagementConfirmationModalRemoveCategoryLanguageItemName: string = `CatalogManagement.ConfirmationModal.RemoveCategory`;
    public readonly catalogManagementAlertCategoryRemovedSuccessfullyLanguageItemName: string = `CatalogManagement.Alert.CategoryRemovedSuccessfully`;
    public readonly catalogManagementAlertCategoryEditedSuccessfullyLanguageItemName: string = `CatalogManagement.Alert.CategoryEditedSuccessfully`;
    public readonly catalogManagementAlertCategoryCreatedSuccessfullyLanguageItemName: string = `CatalogManagement.Alert.CategoryCreatedSuccessfully`;
    public readonly categoryItemParentCategoryLanguageItemName: string = `CategoryItem.ParentCategory`;
    public readonly catalogManagementAlertProductCreatedSuccessfullyLanguageItemName: string = `CatalogManagement.Alert.ProductCreatedSuccessfully`;
    public readonly catalogManagementAlertProductEditedSuccessfullyLanguageItemName: string = `CatalogManagement.Alert.ProductEditedSuccessfully`;
    public readonly catalogManagementAlertProductRemovedSuccessfullyLanguageItemName: string = `CatalogManagement.Alert.ProductRemovedSuccessfully`;
    public readonly catalogManagementConfirmationModalRemoveProductLanguageItemName: string = `CatalogManagement.ConfirmationModal.RemoveProduct`;
    public readonly productItemValidationProductWithSameExternalIdAlreadyExistsLanguageItemName: string = `ProductItem.Validation.ProductWithSameExternalIdAlreadyExists`;
    public readonly catalogManagementAlertCategoryCreationFailureLanguageItemName: string = `CatalogManagement.Alert.CategoryCreationFailure`;
    public readonly catalogManagementAlertCategoryEditFailureLanguageItemName: string = `CatalogManagement.Alert.CategoryEditFailure`;
    public readonly catalogManagementAlertProductCreationFailureLanguageItemName: string = `CatalogManagement.Alert.ProductCreationFailure`;
    public readonly catalogManagementAlertProductEditFailureLanguageItemName: string = `CatalogManagement.Alert.ProductEditFailure`;
    public readonly productItemProductKeywordsLanguageItemName: string = `ProductItem.Product.Keywords`;
    public readonly workOrdersActionsUnInvoiceLanguageItemName: string = `WorkOrders.Actions.UnInvoice`;
    public readonly workOrderActionsConfirmUnInvoiceLanguageItemName: string = `WorkOrder.Actions.ConfirmUnInvoice`;
    public readonly attachmentsPageGetManualLanguageItemName: string = `AttachmentsPage.GetManual`;
    public readonly attachmentsFiltersModalTitleLanguageItemName: string = `AttachmentsFiltersModal.Title`;
    public readonly attachmentsFiltersModalUploadedAtLanguageItemName: string = `AttachmentsFiltersModal.UploadedAt`;
    public readonly attachmentsFiltersModalUploadedBeforeLanguageItemName: string = `AttachmentsFiltersModal.UploadedBefore`;
    public readonly attachmentsFiltersModalUploadedFromLanguageItemName: string = `AttachmentsFiltersModal.UploadedFrom`;
    public readonly attachmentsListPageGetManualLanguageItemName: string = `AttachmentsListPage.GetManual`;
    public readonly attachmentsTitleLanguageItemName: string = `Attachments.Title`;
    public readonly genericActionPreviewLanguageItemName: string = `Generic.Action.Preview`;
    public readonly workOrderDetailsPanelGridAttachmentsNoDataTextLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Attachments.NoDataText`;
    public readonly workOrderDetailsPanelGridAttachmentsFileTypeLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Attachments.FileType`;
    public readonly workOrderDetailsPanelGridAttachmentsFileNameLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Attachments.FileName`;
    public readonly workOrderDetailsPanelGridAttachmentsPublicLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Attachments.Public`;
    public readonly workOrderDetailsPanelToolbarPublicCheckboxLanguageItemName: string = `WorkOrderDetailsPanel.Toolbar.PublicCheckbox`;
    public readonly workOrderDetailsPanelToolbarAddAttachmentsButtonLanguageItemName: string = `WorkOrderDetailsPanel.Toolbar.AddAttachmentsButton`;
    public readonly workOrderDetailsPanelAttachmentsAddInfoLanguageItemName: string = `WorkOrderDetailsPanel.Attachments.AddInfo`;
    public readonly workOrderDetailsPanelGridAttachmentsConfirmDeleteLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Attachments.ConfirmDelete`;
    public readonly addWorkReportAttachmentModalPublicCheckboxLanguageItemName: string = `AddWorkReportAttachmentModal.PublicCheckbox`;
    public readonly addWorkReportAttachmentModalTitleLanguageItemName: string = `AddWorkReportAttachmentModal.Title`;
    public readonly rentaTasksWorkOrderButtonLabelAttachmentsLanguageItemName: string = `RentaTasks.WorkOrder.Button.Label.Attachments`;
    public readonly genericActionReturnLanguageItemName: string = `Generic.Action.Return`;
    public readonly rentaTasksControllerAlertsRequiredInformationMissingLanguageItemName: string = `RentaTasksController.Alerts.RequiredInformationMissing`;
    public readonly catalogModalAddAndCloseLanguageItemName: string = `Catalog.Modal.AddAndClose`;
    public readonly genericUserEmailExistsLanguageItemName: string = `Generic.UserEmailExists`;
    public readonly genericUserPhoneExistsLanguageItemName: string = `Generic.UserPhoneExists`;
    public readonly tasksPanelCopyTaskTemplateLanguageItemName: string = `TasksPanel.CopyTaskTemplate`;
    public readonly tasksPanelPlannedDoneLanguageItemName: string = `TasksPanel.PlannedDone`;
    public readonly tasksPanelPlannedCompletionDateLanguageItemName: string = `TasksPanel.PlannedCompletionDate`;
    public readonly calendarPageCalendarDataConfirmAssignDialogAddButtonLanguageItemName: string = `CalendarPage.CalendarData.ConfirmAssignDialog.AddButton`;
    public readonly calendarPageCalendarDataConfirmAssignDialogBodyLanguageItemName: string = `CalendarPage.CalendarData.ConfirmAssignDialog.Body`;
    public readonly calendarPageCalendarDataConfirmAssignDialogReplaceButtonLanguageItemName: string = `CalendarPage.CalendarData.ConfirmAssignDialog.ReplaceButton`;
    public readonly calendarPageCalendarDataConfirmAssignDialogTitleLanguageItemName: string = `CalendarPage.CalendarData.ConfirmAssignDialog.Title`;
    public readonly calendarPageCalendarDataUnassignedRowLanguageItemName: string = `CalendarPage.CalendarData.UnassignedRow`;
    public readonly calendarPageNoTeamLabelLanguageItemName: string = `CalendarPage.NoTeamLabel`;
    public readonly calendarPagePersonnelTabLanguageItemName: string = `CalendarPage.PersonnelTab`;
    public readonly calendarPageTeamsListLabelLanguageItemName: string = `CalendarPage.TeamsListLabel`;
    public readonly calendarPageTitleLanguageItemName: string = `CalendarPage.Title`;
    public readonly calendarPageToolbarStatusNotAllocatedLanguageItemName: string = `CalendarPage.Toolbar.Status.NotAllocated`;
    public readonly topNavCalendarLanguageItemName: string = `TopNav.Calendar`;
    public readonly calendarPageToolbarStatusNotStartedLanguageItemName: string = `CalendarPage.Toolbar.Status.NotStarted`;
    public readonly calendarPageToolbarStatusReadyLanguageItemName: string = `CalendarPage.Toolbar.Status.Ready`;
    public readonly calendarPageToolbarStatusStartedLanguageItemName: string = `CalendarPage.Toolbar.Status.Started`;
    public readonly enumCalendarUnitTimeMonthLanguageItemName: string = `Enum.CalendarUnitTime.Month`;
    public readonly enumCalendarUnitTimeWeekLanguageItemName: string = `Enum.CalendarUnitTime.Week`;
    public readonly calendarPageToolbarViewLabelLanguageItemName: string = `CalendarPage.Toolbar.ViewLabel`;
    public readonly calendarPageToolbarTodayButtonLabelLanguageItemName: string = `CalendarPage.Toolbar.TodayButtonLabel`;
    public readonly genericActionAddLanguageItemName: string = `Generic.Action.Add`;
    public readonly genericWorkOrderLanguageItemName: string = `Generic.WorkOrder`;
    public readonly genericWorkOrderEditLanguageItemName: string = `Generic.WorkOrder.Edit`;
    public readonly genericWorkOrderNewLanguageItemName: string = `Generic.WorkOrder.New`;
    public readonly genericConstructionSiteOrWarehouseLanguageItemName: string = `Generic.ConstructionSiteOrWarehouse`;
    public readonly genericNumberLanguageItemName: string = `Generic.Number`;
    public readonly genericStatusLanguageItemName: string = `Generic.Status`;
    public readonly genericInvoiceReferenceLanguageItemName: string = `Generic.InvoiceReference`;
    public readonly genericActionApproveLanguageItemName: string = `Generic.Action.Approve`;
    public readonly genericActionLockLanguageItemName: string = `Generic.Action.Lock`;
    public readonly genericActionUnlockLanguageItemName: string = `Generic.Action.Unlock`;
    public readonly genericActionCompleteLanguageItemName: string = `Generic.Action.Complete`;
    public readonly genericActionInvoiceLanguageItemName: string = `Generic.Action.Invoice`;
    public readonly genericActionUninvoiceLanguageItemName: string = `Generic.Action.Uninvoice`;
    public readonly genericActionSendLanguageItemName: string = `Generic.Action.Send`;
    public readonly genericTypeLanguageItemName: string = `Generic.Type`;
    public readonly genericCostLanguageItemName: string = `Generic.Cost`;
    public readonly genericMountersLanguageItemName: string = `Generic.Mounters`;
    public readonly genericActionActivateLanguageItemName: string = `Generic.Action.Activate`;
    public readonly genericInvoiceLanguageItemName: string = `Generic.Invoice`;
    public readonly genericActionCopyLanguageItemName: string = `Generic.Action.Copy`;
    public readonly genericApproverLanguageItemName: string = `Generic.Approver`;
    public readonly genericOrdererLanguageItemName: string = `Generic.Orderer`;
    public readonly genericCompletionLanguageItemName: string = `Generic.Completion`;
    public readonly genericPlannedCompletionLanguageItemName: string = `Generic.PlannedCompletion`;
    public readonly genericActivationLanguageItemName: string = `Generic.Activation`;
    public readonly genericDefaultLanguageItemName: string = `Generic.Default`;
    public readonly confirmationDialogDiscardUnsavedChangesLanguageItemName: string = `ConfirmationDialog.DiscardUnsavedChanges`;
    public readonly genericWorkOrderCreatedSuccessfullyLanguageItemName: string = `Generic.WorkOrder.CreatedSuccessfully`;
    public readonly genericWorkOrderSavedSuccessfullyLanguageItemName: string = `Generic.WorkOrderSavedSuccessfully`;
    public readonly genericWorkOrderCopiedSuccessfullyLanguageItemName: string = `Generic.WorkOrder.CopiedSuccessfully`;
    public readonly genericWorkOrderLockedSuccessfullyLanguageItemName: string = `Generic.WorkOrder.LockedSuccessfully`;
    public readonly genericWorkOrderUnlockedSuccessfullyLanguageItemName: string = `Generic.WorkOrder.UnlockedSuccessfully`;
    public readonly genericWorkOrderApprovedSuccessfullyLanguageItemName: string = `Generic.WorkOrder.ApprovedSuccessfully`;
    public readonly genericWorkOrderActivatedSuccessfullyLanguageItemName: string = `Generic.WorkOrder.ActivatedSuccessfully`;
    public readonly genericWorkOrderCompletedSuccessfullyLanguageItemName: string = `Generic.WorkOrder.CompletedSuccessfully`;
    public readonly genericWorkOrderCompletionFailedLanguageItemName: string = `Generic.WorkOrder.CompletionFailed`;
    public readonly genericWorkOrderInvoicedSuccessfullyLanguageItemName: string = `Generic.WorkOrder.InvoicedSuccessfully`;
    public readonly genericWorkOrderUninvoicedSuccessfullyLanguageItemName: string = `Generic.WorkOrder.UninvoicedSuccessfully`;
    public readonly genericWorkOrderSendingFailedLanguageItemName: string = `Generic.WorkOrder.SendingFailed`;
    public readonly genericWorkOrderSentSuccessfullyLanguageItemName: string = `Generic.WorkOrder.SentSuccessfully`;
    public readonly genericWorkOrderApprovalFailedLanguageItemName: string = `Generic.WorkOrder.ApprovalFailed`;
    public readonly enumWorkOrderStatusReadyForInvoicingLanguageItemName: string = `Enum.WorkOrderStatus.ReadyForInvoicing`;
    public readonly genericNewLanguageItemName: string = `Generic.New`;
    public readonly adminConsolePageTitleLanguageItemName: string = `AdminConsolePage.Title`;
    public readonly tasksToolbarSearchFieldTooManySearchWordsLanguageItemName: string = `TasksToolbar.SearchField.TooManySearchWords`;
    public readonly tasksToolbarSearchFieldPlaceholderLanguageItemName: string = `TasksToolbar.SearchField.Placeholder`;
    public readonly workOrderTypeManagementPageTitleLanguageItemName: string = `WorkOrderTypeManagement.PageTitle`;
    public readonly genericActionDisableLanguageItemName: string = `Generic.Action.Disable`;
    public readonly genericActionEnableLanguageItemName: string = `Generic.Action.Enable`;
    public readonly genericWorkOrderTypeLabelLanguageItemName: string = `Generic.WorkOrderTypeLabel`;
    public readonly genericNameClarificationLanguageItemName: string = `Generic.NameClarification`;
    public readonly signatureNameClarificationDescriptionLanguageItemName: string = `Signature.NameClarificationDescription`;
    public readonly genericLegendLanguageItemName: string = `Generic.Legend`;
    public readonly addTaskTaskTypeLabelLanguageItemName: string = `AddTask.TaskTypeLabel`;
    public readonly addTaskTaskTypeDescriptionLanguageItemName: string = `AddTask.TaskTypeDescription`;
    public readonly genericNoNameLanguageItemName: string = `Generic.NoName`;
    public readonly workOrdersHoursTabTitleLanguageItemName: string = `WorkOrders.HoursTab.Title`;
    public readonly workOrdersJobSummaryLanguageItemName: string = `WorkOrders.JobSummary`;
    public readonly workOrdersManagerLanguageItemName: string = `WorkOrders.Manager`;
    public readonly workOrdersShowDetailsTitleLanguageItemName: string = `WorkOrders.ShowDetailsTitle`;
    public readonly workOrdersEquipmentsTabTitleLanguageItemName: string = `WorkOrders.EquipmentsTab.Title`;
    public readonly workOrdersDeclineActionLanguageItemName: string = `WorkOrders.DeclineAction`;
    public readonly workOrdersCustomerOrdererLanguageItemName: string = `WorkOrders.CustomerOrderer`;
    public readonly workOrdersApproveActionLanguageItemName: string = `WorkOrders.ApproveAction`;
    public readonly workOrderEquipmentPriceLanguageItemName: string = `WorkOrderEquipment.Price`;
    public readonly workOrderEquipmentNameLanguageItemName: string = `WorkOrderEquipment.Name`;
    public readonly workOrderEquipmentDescriptionLanguageItemName: string = `WorkOrderEquipment.Description`;
    public readonly workOrderEquipmentAmountLanguageItemName: string = `WorkOrderEquipment.Amount`;
    public readonly workOrderEquipmentAddProductLanguageItemName: string = `WorkOrderEquipment.AddProduct`;
    public readonly workOrderDetailsPanelGridHoursHoursPriceInfoTitleLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Hours.HoursPrice.InfoTitle`;
    public readonly workOrderDetailsPanelGridEquipmentPriceInfoTitleLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Equipment.Price.InfoTitle`;
    public readonly workOrderDetailsPanelGridEquipmentConfirmDeleteLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Equipment.ConfirmDelete`;
    public readonly workOrderDetailsPanelGridDistancesVehiclesLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Distances.Vehicles`;
    public readonly workOrderDetailsPanelGridDistancesPriceLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Distances.Price`;
    public readonly workOrderDetailsPanelGridDistancesNoDataTextLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Distances.NoDataText`;
    public readonly workOrderDetailsPanelGridDistancesDistanceLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Distances.Distance`;
    public readonly workOrderDetailsPanelGridDistancesDayLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Distances.Day`;
    public readonly workOrderDetailsPanelGridDistancesCostLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Distances.Cost`;
    public readonly workOrderDetailsPanelGridDistancesConfirmDeleteLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Distances.ConfirmDelete`;
    public readonly activateConstructionSiteDescriptionLanguageItemName: string = `ActivateConstructionSite.Description`;
    public readonly activateConstructionSiteLabelLanguageItemName: string = `ActivateConstructionSite.Label`;
    public readonly activateConstructionSiteSummaryAddressLabelLanguageItemName: string = `ActivateConstructionSite.Summary.AddressLabel`;
    public readonly activateConstructionSiteSummaryCustomerLabelLanguageItemName: string = `ActivateConstructionSite.Summary.CustomerLabel`;
    public readonly activateConstructionSiteSummaryWorksiteNameLabelLanguageItemName: string = `ActivateConstructionSite.Summary.WorksiteNameLabel`;
    public readonly addConstructionsiteDuplicateDeviceIdLanguageItemName: string = `AddConstructionsite.DuplicateDeviceId`;
    public readonly addConstructionsiteFlyoutLanguageItemName: string = `AddConstructionsite.Flyout`;
    public readonly addConstructionsiteRedirectLanguageItemName: string = `AddConstructionsite.Redirect`;
    public readonly addConstructionSiteReferenceLanguageItemName: string = `AddConstructionSite.Reference`;
    public readonly addMounterModalLabelsOvertime100HoursLanguageItemName: string = `AddMounterModal.Labels.Overtime100Hours`;
    public readonly addMounterModalLabelsOvertime50HoursLanguageItemName: string = `AddMounterModal.Labels.Overtime50Hours`;
    public readonly addTaskModalCostEuroLanguageItemName: string = `AddTaskModal.CostEuro`;
    public readonly addTaskModalCreateAndCloseLanguageItemName: string = `AddTaskModal.CreateAndClose`;
    public readonly addTaskModalCreateAndContinueLanguageItemName: string = `AddTaskModal.CreateAndContinue`;
    public readonly addTaskModalCreateTaskLanguageItemName: string = `AddTaskModal.CreateTask`;
    public readonly addTaskModalExtraHoursLanguageItemName: string = `AddTaskModal.ExtraHours`;
    public readonly addTaskModalExtraHoursAutoCalculatedLanguageItemName: string = `AddTaskModal.ExtraHours.AutoCalculated`;
    public readonly addTaskModalValidationCreateTaskFirstLanguageItemName: string = `AddTaskModal.Validation.CreateTaskFirst`;
    public readonly addTaskModalValidationCreateWorkReportFirstLanguageItemName: string = `AddTaskModal.Validation.CreateWorkReportFirst`;
    public readonly addWorkReportModalAttachmentRemoveConfirmationLanguageItemName: string = `AddWorkReportModal.AttachmentRemoveConfirmation`;
    public readonly addTaskModalNameLanguageItemName: string = `AddTaskModal.Name`;
    public readonly addTaskModalPriceEuroLanguageItemName: string = `AddTaskModal.PriceEuro`;
    public readonly addWorkReportModalGridExtraChargesLanguageItemName: string = `AddWorkReportModal.Grid.ExtraCharges`;
    public readonly addWorkReportModalGridExtraChargesTitleLanguageItemName: string = `AddWorkReportModal.Grid.ExtraCharges.Title`;
    public readonly addWorkReportModalValidationCreateWorkReportFirstLanguageItemName: string = `AddWorkReportModal.Validation.CreateWorkReportFirst`;
    public readonly assignMountersManualLanguageItemName: string = `AssignMounters.Manual`;
    public readonly auditModuleContinueLanguageItemName: string = `AuditModule.Continue`;
    public readonly auditModuleEmailReceiversContactPersonLanguageItemName: string = `AuditModule.EmailReceivers.ContactPerson`;
    public readonly auditModuleEmailReceiversNoContactPersonWarningLanguageItemName: string = `AuditModule.EmailReceivers.NoContactPersonWarning`;
    public readonly auditModuleEmailReceiversReceiverLanguageItemName: string = `AuditModule.EmailReceivers.Receiver`;
    public readonly auditModuleNotSentLanguageItemName: string = `AuditModule.NotSent`;
    public readonly auditModulePreviewLanguageItemName: string = `AuditModule.Preview`;
    public readonly auditModuleSentLanguageItemName: string = `AuditModule.Sent`;
    public readonly catalogFlyoutMessageProductMarkedAsDeletedLanguageItemName: string = `Catalog.FlyoutMessage.ProductMarkedAsDeleted`;
    public readonly catalogFlyoutMessageProductPermanentlyRemovedLanguageItemName: string = `Catalog.FlyoutMessage.ProductPermanentlyRemoved`;
    public readonly catalogFlyoutMessageProductRestoredLanguageItemName: string = `Catalog.FlyoutMessage.ProductRestored`;
    public readonly catalogManagementErrorMessageRestoreProductNotExistsLanguageItemName: string = `CatalogManagement.ErrorMessage.Restore.ProductNotExists`;
    public readonly checkInsPanelCheckInAtLanguageItemName: string = `CheckInsPanel.CheckInAt`;
    public readonly checkInsPanelNoDataTextLanguageItemName: string = `CheckInsPanel.NoDataText`;
    public readonly checkInsPanelCheckOutAtLanguageItemName: string = `CheckInsPanel.CheckOutAt`;
    public readonly checkInsPanelSignLanguageItemName: string = `CheckInsPanel.Sign`;
    public readonly componentDropdownAddLanguageItemName: string = `Component.Dropdown.Add`;
    public readonly constructionSitePanelExternalNameLanguageItemName: string = `ConstructionSitePanel.ExternalName`;
    public readonly constructionSitePanelOrganizationContractInvoicesSentLanguageItemName: string = `ConstructionSitePanel.OrganizationContractInvoicesSent`;
    public readonly constructionSitesCancelChangesLanguageItemName: string = `ConstructionSites.CancelChanges`;
    public readonly constructionSitesCommitChangesLanguageItemName: string = `ConstructionSites.CommitChanges`;
    public readonly constructionSitesNameLanguageItemName: string = `ConstructionSites.Name`;
    public readonly constructionSitesToolBarSearchTermFilterWithReferenceLanguageItemName: string = `ConstructionSites.ToolBar.SearchTermFilterWithReference`;
    public readonly dailyHoursModalLabelsDateLanguageItemName: string = `DailyHoursModal.Labels.Date`;
    public readonly dailyHoursModalLabelsMounterLanguageItemName: string = `DailyHoursModal.Labels.Mounter`;
    public readonly dailyHoursModalLabelsNormalHoursLanguageItemName: string = `DailyHoursModal.Labels.NormalHours`;
    public readonly dailyHoursModalLabelsOvertime100HoursLanguageItemName: string = `DailyHoursModal.Labels.Overtime100Hours`;
    public readonly dailyHoursModalLabelsOvertime50HoursLanguageItemName: string = `DailyHoursModal.Labels.Overtime50Hours`;
    public readonly dailyHoursModalSubtitleLanguageItemName: string = `DailyHoursModal.Subtitle`;
    public readonly dailyHoursWidgetButtonsAddHoursLanguageItemName: string = `DailyHoursWidget.Buttons.AddHours`;
    public readonly dailyHoursWidgetDescriptionLanguageItemName: string = `DailyHoursWidget.Description`;
    public readonly dailyHoursWidgetLabelLanguageItemName: string = `DailyHoursWidget.Label`;
    public readonly dailyHoursWidgetLabelsNormalLanguageItemName: string = `DailyHoursWidget.Labels.Normal`;
    public readonly dashboardFlyoutSiteCreatedLanguageItemName: string = `Dashboard.Flyout.SiteCreated`;
    public readonly distanceModalLabelsDateLanguageItemName: string = `DistanceModal.Labels.Date`;
    public readonly distanceModalLabelsValueLanguageItemName: string = `DistanceModal.Labels.Value`;
    public readonly distanceModalLabelsVehiclesLanguageItemName: string = `DistanceModal.Labels.Vehicles`;
    public readonly distanceModalSubtitleLanguageItemName: string = `DistanceModal.Subtitle`;
    public readonly distanceWidgetButtonsAddKilometersLanguageItemName: string = `DistanceWidget.Buttons.AddKilometers`;
    public readonly distanceWidgetDescriptionLanguageItemName: string = `DistanceWidget.Description`;
    public readonly distanceWidgetLabelLanguageItemName: string = `DistanceWidget.Label`;
    public readonly enumInvoiceStateFilterApprovedLanguageItemName: string = `Enum.InvoiceStateFilter.Approved`;
    public readonly enumInvoiceStateFilterApprovedDescriptionLanguageItemName: string = `Enum.InvoiceStateFilter.Approved.Description`;
    public readonly enumInvoiceStateFilterCreatedLanguageItemName: string = `Enum.InvoiceStateFilter.Created`;
    public readonly enumInvoiceStateFilterCreatedDescriptionLanguageItemName: string = `Enum.InvoiceStateFilter.Created.Description`;
    public readonly enumInvoiceStateFilterFailedLanguageItemName: string = `Enum.InvoiceStateFilter.Failed`;
    public readonly enumInvoiceStateFilterFailedDescriptionLanguageItemName: string = `Enum.InvoiceStateFilter.Failed.Description`;
    public readonly enumInvoiceStateFilterLockedLanguageItemName: string = `Enum.InvoiceStateFilter.Locked`;
    public readonly enumInvoiceStateFilterLockedDescriptionLanguageItemName: string = `Enum.InvoiceStateFilter.Locked.Description`;
    public readonly enumInvoiceStateFilterProcessedLanguageItemName: string = `Enum.InvoiceStateFilter.Processed`;
    public readonly enumInvoiceStateFilterProcessedDescriptionLanguageItemName: string = `Enum.InvoiceStateFilter.Processed.Description`;
    public readonly enumInvoiceStateFilterSentDescriptionLanguageItemName: string = `Enum.InvoiceStateFilter.Sent.Description`;
    public readonly enumInvoiceStateFilterSentLanguageItemName: string = `Enum.InvoiceStateFilter.Sent`;
    public readonly enumUserRoleGroupContactPersonsLanguageItemName: string = `Enum.UserRoleGroup.ContactPersons`;
    public readonly enumTaskStatusFilterApprovedByCustomerLanguageItemName: string = `Enum.TaskStatusFilter.ApprovedByCustomer`;
    public readonly enumTaskStatusFilterCompletedLanguageItemName: string = `Enum.TaskStatusFilter.Completed`;
    public readonly enumTaskStatusFilterDeclinedByCustomerLanguageItemName: string = `Enum.TaskStatusFilter.DeclinedByCustomer`;
    public readonly enumTaskStatusFilterInProgressLanguageItemName: string = `Enum.TaskStatusFilter.InProgress`;
    public readonly enumTaskStatusFilterInvoicedLanguageItemName: string = `Enum.TaskStatusFilter.Invoiced`;
    public readonly enumTaskStatusFilterReadyForInvoicingLanguageItemName: string = `Enum.TaskStatusFilter.ReadyForInvoicing`;
    public readonly enumTaskStatusFilterSentToCustomerLanguageItemName: string = `Enum.TaskStatusFilter.SentToCustomer`;
    public readonly enumTaskStatusFilterUnscheduledLanguageItemName: string = `Enum.TaskStatusFilter.Unscheduled`;
    public readonly enumTaskStatusFilterUpcomingLanguageItemName: string = `Enum.TaskStatusFilter.Upcoming`;
    public readonly formInputPostalboxLanguageItemName: string = `Form.Input.Postalbox`;
    public readonly formInputTimeTrackingDeviceIdLanguageItemName: string = `Form.Input.TimeTrackingDeviceId`;
    public readonly genericFileNotFoundLanguageItemName: string = `Generic.FileNotFound`;
    public readonly imageModalDownloadLanguageItemName: string = `ImageModal.Download`;
    public readonly invoicesCostLanguageItemName: string = `Invoices.Cost`;
    public readonly knownSettingsHourPriceLanguageItemName: string = `KnownSettings.HourPrice`;
    public readonly knownSettingsMileagePriceLanguageItemName: string = `KnownSettings.MileagePrice`;
    public readonly managersOrdererSavedSuccessfullyLanguageItemName: string = `Managers.OrdererSavedSuccessfully`;
    public readonly managersStepApproverAddLanguageItemName: string = `ManagersStep.Approver.Add`;
    public readonly managersStepApproverDescriptionLanguageItemName: string = `ManagersStep.Approver.Description`;
    public readonly managersStepApproverLabelLanguageItemName: string = `ManagersStep.Approver.Label`;
    public readonly managersStepApproverNotSpecifiedLanguageItemName: string = `ManagersStep.ApproverNotSpecified`;
    public readonly managersStepApproverSavedLanguageItemName: string = `ManagersStep.ApproverSaved`;
    public readonly managersStepManagerDescriptionLanguageItemName: string = `ManagersStep.Manager.Description`;
    public readonly managersStepManagerLabelLanguageItemName: string = `ManagersStep.Manager.Label`;
    public readonly managersStepManualLanguageItemName: string = `ManagersStep.Manual`;
    public readonly managersStepOrdererAddLanguageItemName: string = `ManagersStep.Orderer.Add`;
    public readonly managersStepOrdererDescriptionLanguageItemName: string = `ManagersStep.Orderer.Description`;
    public readonly managersStepOrdererLabelLanguageItemName: string = `ManagersStep.Orderer.Label`;
    public readonly managersStepOrdererNotSpecifiedLanguageItemName: string = `ManagersStep.OrdererNotSpecified`;
    public readonly managersStepOrdererSaveLanguageItemName: string = `ManagersStep.OrdererSave`;
    public readonly moduleModelCustomLanguageItemName: string = `ModuleModel.Custom`;
    public readonly myWorkHoursLunchHourInstructionsDescriptionLanguageItemName: string = `MyWorkHours.LunchHourInstructionsDescription`;
    public readonly myWorkHoursLunchHourInstructionsTitleLanguageItemName: string = `MyWorkHours.LunchHourInstructionsTitle`;
    public readonly myWorkHoursNoTaskLanguageItemName: string = `MyWorkHours.NoTask`;
    public readonly salaryHoursPanelPriceLanguageItemName: string = `SalaryHoursPanel.Price`;
    public readonly workOrderDetailsHoursGridPriceLanguageItemName: string = `WorkOrderDetailsHoursGrid.Price`;
    public readonly workOrderDetailsHoursGridUserLanguageItemName: string = `WorkOrderDetails.HoursGrid.User`;
    public readonly workOrderDetailsHoursGridOverTime50LanguageItemName: string = `WorkOrderDetails.HoursGrid.OverTime50`;
    public readonly workOrderDetailsHoursGridOverTime100LanguageItemName: string = `WorkOrderDetails.HoursGrid.OverTime100`;
    public readonly workOrderDetailsHoursGridNormalHoursLanguageItemName: string = `WorkOrderDetails.HoursGrid.NormalHours`;
    public readonly workOrderDetailsHoursGridHoursHeaderLanguageItemName: string = `WorkOrderDetails.HoursGrid.HoursHeader`;
    public readonly workOrderDetailsHoursGridDayLanguageItemName: string = `WorkOrderDetails.HoursGrid.Day`;
    public readonly workOrderDetailsDistancesTabTitleLanguageItemName: string = `WorkOrderDetails.DistancesTab.Title`;
    public readonly workOrderDetailsAddHoursLanguageItemName: string = `WorkOrderDetails.AddHours`;
    public readonly workOrderDetailsAddDistanceLanguageItemName: string = `WorkOrderDetails.AddDistance`;
    public readonly workOrderApprovalModalTitleLanguageItemName: string = `WorkOrderApproval.Modal.Title`;
    public readonly workHoursWidgetSummaryLanguageItemName: string = `WorkHoursWidget.Summary`;
    public readonly workOrderLabelsMyHoursLanguageItemName: string = `WorkOrder.Labels.MyHours`;
    public readonly workOrderApprovalEquipmentAmountLanguageItemName: string = `WorkOrderApproval.Equipment.Amount`;
    public readonly workOrderApprovalEquipmentDescriptionLanguageItemName: string = `WorkOrderApproval.Equipment.Description`;
    public readonly workOrderApprovalEquipmentInfoLanguageItemName: string = `WorkOrderApproval.Equipment.Info`;
    public readonly workOrderApprovalEquipmentUnitLanguageItemName: string = `WorkOrderApproval.Equipment.Unit`;
    public readonly workOrderApprovalEquipmentsTableNameLanguageItemName: string = `WorkOrderApproval.EquipmentsTable.Name`;
    public readonly workOrderApprovalHoursDayLanguageItemName: string = `WorkOrderApproval.Hours.Day`;
    public readonly workOrderApprovalHoursNormalHoursLanguageItemName: string = `WorkOrderApproval.Hours.NormalHours`;
    public readonly workOrderApprovalHoursOvertime100HoursLanguageItemName: string = `WorkOrderApproval.Hours.Overtime100Hours`;
    public readonly workOrderApprovalHoursOvertime50HoursLanguageItemName: string = `WorkOrderApproval.Hours.Overtime50Hours`;
    public readonly workOrderApprovalHoursUserLanguageItemName: string = `WorkOrderApproval.Hours.User`;
    public readonly workOrderApprovalHoursTableNameLanguageItemName: string = `WorkOrderApproval.HoursTable.Name`;
    public readonly workOrderApprovalMileagesDateLanguageItemName: string = `WorkOrderApproval.Mileages.Date`;
    public readonly workOrderApprovalMileagesTotalMileagesLanguageItemName: string = `WorkOrderApproval.Mileages.TotalMileages`;
    public readonly workOrderApprovalMileagesVehicleAmountLanguageItemName: string = `WorkOrderApproval.Mileages.VehicleAmount`;
    public readonly workOrderApprovalMileagesTableNameLanguageItemName: string = `WorkOrderApproval.MileagesTable.Name`;
    public readonly workDayPanelSiteOrWarehouseColumnTitleLanguageItemName: string = `WorkDayPanel.SiteOrWarehouseColumn.Title`;
    public readonly workDayPanelNoReportedHoursLanguageItemName: string = `WorkDayPanel.NoReportedHours`;
    public readonly widgetSalaryPeriodDescriptionLanguageItemName: string = `Widget.SalaryPeriod.Description`;
    public readonly widgetSalaryPeriodLabelLanguageItemName: string = `Widget.SalaryPeriod.Label`;
    public readonly userManagementSubcontractorLabelLanguageItemName: string = `UserManagement.Subcontractor.Label`;
    public readonly userManagementOrganizationContractsLabelLanguageItemName: string = `UserManagement.OrganizationContracts.Label`;
    public readonly userManagementAlertErrorWorkCardIdExistsLanguageItemName: string = `UserManagement.AlertError.WorkCardIdExists`;
    public readonly taskTooltipsTaskDeclinedLanguageItemName: string = `TaskTooltips.TaskDeclined`;
    public readonly taskTooltipsNewTaskLanguageItemName: string = `TaskTooltips.NewTask`;
    public readonly tasksPanelPriceLanguageItemName: string = `TasksPanel.Price`;
    public readonly tasksPanelNameLanguageItemName: string = `TasksPanel.Name`;
    public readonly tasksPanelFlyoutChangesSavedLanguageItemName: string = `TasksPanel.Flyout.ChangesSaved`;
    public readonly tasksPanelDeleteTaskLanguageItemName: string = `TasksPanel.DeleteTask`;
    public readonly tasksPanelDeleteHoursLanguageItemName: string = `TasksPanel.DeleteHours`;
    public readonly tasksPanelCommitChangesLanguageItemName: string = `TasksPanel.CommitChanges`;
    public readonly tasksPanelCancelChangesLanguageItemName: string = `TasksPanel.CancelChanges`;
    public readonly tasksPanelAddWorkReportFlyoutLanguageItemName: string = `TasksPanel.AddWorkReport.Flyout`;
    public readonly tasksPanelAddHoursModalNoHoursLanguageItemName: string = `TasksPanel.AddHoursModal.NoHours`;
    public readonly tasksPanelAddHoursModalConfirmationLanguageItemName: string = `TasksPanel.AddHoursModal.Confirmation`;
    public readonly tasksPanelAddHoursModalAddHoursLanguageItemName: string = `TasksPanel.AddHoursModal.AddHours`;
    public readonly tasksPanelAddHoursFlyoutLanguageItemName: string = `TasksPanel.AddHours.Flyout`;
    public readonly tasksPanelAddExtraTaskFlyoutLanguageItemName: string = `TasksPanel.AddExtraTask.Flyout`;
    public readonly taskHoursPanelRestoreDeletedHoursLanguageItemName: string = `TaskHoursPanel.RestoreDeletedHours`;
    public readonly tasksPageManagerCostPoolsLanguageItemName: string = `TasksPage.ManagerCostPools`;
    public readonly tasksPageNotAssignedLanguageItemName: string = `TasksPage.NotAssigned`;
    public readonly tasksPageTaskStatusLanguageItemName: string = `TasksPage.TaskStatus`;
    public readonly tasksPageTaskStatusAnyLanguageItemName: string = `TasksPage.TaskStatus.Any`;
    public readonly tasksPageTaskStatusAnySubtextLanguageItemName: string = `TasksPage.TaskStatus.Any.Subtext`;
    public readonly tasksPageTaskStatusFurtherLanguageItemName: string = `TasksPage.TaskStatus.Further`;
    public readonly tasksPageTaskStatusFurtherSubtextLanguageItemName: string = `TasksPage.TaskStatus.Further.Subtext`;
    public readonly tasksPageTaskStatusOngoingLanguageItemName: string = `TasksPage.TaskStatus.Ongoing`;
    public readonly tasksPageTaskStatusOngoingSubtextLanguageItemName: string = `TasksPage.TaskStatus.Ongoing.Subtext`;
    public readonly taskHoursPanelDeleteHoursLanguageItemName: string = `TaskHoursPanel.DeleteHours`;
    public readonly taskHoursPanelDateLanguageItemName: string = `TaskHoursPanel.Date`;
    public readonly taskHoursPanelCommitChangesLanguageItemName: string = `TaskHoursPanel.CommitChanges`;
    public readonly taskHoursPanelCancelChangesLanguageItemName: string = `TaskHoursPanel.CancelChanges`;
    public readonly taskHoursPanelApproveHoursLanguageItemName: string = `TaskHoursPanel.ApproveHours`;
    public readonly summaryWidgetLabelsDistanceLanguageItemName: string = `SummaryWidget.Labels.Distance`;
    public readonly summaryWidgetLabelsHoursLanguageItemName: string = `SummaryWidget.Labels.Hours`;
    public readonly summaryManualLanguageItemName: string = `Summary.Manual`;
    public readonly rentaTasksWorkOrderSignInFailedAlertLanguageItemName: string = `RentaTasks.WorkOrder.SignIn.FailedAlert`;
    public readonly rentaTasksWorkOrderSignOutFailedAlertLanguageItemName: string = `RentaTasks.WorkOrder.SignOut.FailedAlert`;
    public readonly rentaTasksControllerAlertsApprovedLanguageItemName: string = `RentaTasksController.Alerts.Approved`;
    public readonly rentaTasksControllerAlertsCreatedLanguageItemName: string = `RentaTasksController.Alerts.Created`;
    public readonly rentaTasksControllerStepsTitleSummaryLanguageItemName: string = `RentaTasksController.Steps.TitleSummary`;
    public readonly rentaTasksControllerStepsTitleManagersLanguageItemName: string = `RentaTasksController.Steps.TitleManagers`;
    public readonly rentaTasksControllerStepsTitleHoursAndDistanceLanguageItemName: string = `RentaTasksController.Steps.TitleHoursAndDistance`;
    public readonly rentaTasksControllerStepsTitleEditLanguageItemName: string = `RentaTasksController.Steps.TitleEdit`;
    public readonly rentaTasksControllerStepsTitleApprovingLanguageItemName: string = `RentaTasksController.Steps.TitleApproving`;
    public readonly rentaTasksControllerStepsActivateConstructionSiteTitleSummaryLanguageItemName: string = `RentaTasksController.Steps.ActivateConstructionSite.TitleSummary`;
    public readonly rentaTasksControllerStepsActivateConstructionSiteTitleSelectCustomerLanguageItemName: string = `RentaTasksController.Steps.ActivateConstructionSite.TitleSelectCustomer`;
    public readonly rentaTasksControllerStepsActivateConstructionSiteTitleSelectConstructionSiteLanguageItemName: string = `RentaTasksController.Steps.ActivateConstructionSite.TitleSelectConstructionSite`;
    public readonly rentaTasksControllerStepsActivateConstructionSiteTitleConfirmAddressLanguageItemName: string = `RentaTasksController.Steps.ActivateConstructionSite.TitleConfirmAddress`;
    public readonly rentaTasksControllerNewWorkOrderNameLanguageItemName: string = `RentaTasksController.NewWorkOrderName`;
    public readonly rentaTasksControllerAlertsSignOutFromSiteLanguageItemName: string = `RentaTasksController.Alerts.SignOutFromSite`;
    public readonly rentaTasksControllerAlertsSentToCustomerLanguageItemName: string = `RentaTasksController.Alerts.SentToCustomer`;
    public readonly rentaTasksWorkOrderButtonLabelEditHoursAndDistancesLanguageItemName: string = `RentaTasks.WorkOrder.Button.Label.EditHoursAndDistances`;
    public readonly rentaTasksWorkOrderCompleteFailedAlertLanguageItemName: string = `RentaTasks.WorkOrder.Complete.FailedAlert`;
    public readonly rentaTasksWorkOrderEditFailedAlertLanguageItemName: string = `RentaTasks.WorkOrder.Edit.FailedAlert`;
    public readonly rentaTasksWorkOrderEditHoursAndDistancesAlertLanguageItemName: string = `RentaTasks.WorkOrder.EditHoursAndDistances.Alert`;
    public readonly rentaTasksWorkOrderEditHoursAndDistancesFailedAlertLanguageItemName: string = `RentaTasks.WorkOrder.EditHoursAndDistances.FailedAlert`;
    public readonly organizationPanelIntermediatorLanguageItemName: string = `OrganizationPanel.Intermediator`;
    public readonly organizationPanelNameLanguageItemName: string = `OrganizationPanel.Name`;
    public readonly organizationPanelTransactionIdentifierLanguageItemName: string = `OrganizationPanel.TransactionIdentifier`;
    public readonly organizationPanelVirtualAddressLanguageItemName: string = `OrganizationPanel.VirtualAddress`;
    public readonly rentaTasksWorkOrderAddEquipmentFailedAlertLanguageItemName: string = `RentaTasks.WorkOrder.AddEquipment.FailedAlert`;
    public readonly rentaTasksWorkOrderActivateConstructionSiteAlertLanguageItemName: string = `RentaTasks.WorkOrder.ActivateConstructionSite.Alert`;
    public readonly rentaTasksSignatureAlertLanguageItemName: string = `RentaTasks.Signature.Alert`;
    public readonly rentaTasksSelectTaskNotAssignedLanguageItemName: string = `RentaTasks.SelectTask.NotAssigned`;
    public readonly rentaTasksSelectTaskMyTasksLanguageItemName: string = `RentaTasks.SelectTask.MyTasks`;
    public readonly rentaTasksSelectSiteNotFoundLanguageItemName: string = `RentaTasks.SelectSite.NotFound`;
    public readonly rentaTasksSelectSiteNoAvailableSitesLanguageItemName: string = `RentaTasks.SelectSite.NoAvailableSites`;
    public readonly rentaTasksSelectOrganizationNoOrganizationsLanguageItemName: string = `RentaTasks.SelectOrganization.NoOrganizations`;
    public readonly rentaTasksControllerWorkOrderConcurrencyAlertLanguageItemName: string = `RentaTasks.Controller.WorkOrderConcurrencyAlert`;
    public readonly rentaTasksControllerStepsTitleTaskStatusLanguageItemName: string = `RentaTasks.Controller.Steps.Title.TaskStatus`;
    public readonly rentaTasksControllerStepsTitleSignatureLanguageItemName: string = `RentaTasks.Controller.Steps.Title.Signature`;
    public readonly rentaTasksControllerStepsTitleSelectTaskLanguageItemName: string = `RentaTasks.Controller.Steps.Title.SelectTask`;
    public readonly rentaTasksControllerStepsTitleSelectSiteLanguageItemName: string = `RentaTasks.Controller.Steps.Title.SelectSite`;
    public readonly rentaTasksControllerStepsTitleSelectOrganizationLanguageItemName: string = `RentaTasks.Controller.Steps.Title.SelectOrganization`;
    public readonly rentaTasksControllerStepsTitleNewTaskLanguageItemName: string = `RentaTasks.Controller.Steps.Title.NewTask`;
    public readonly rentaTasksControllerStepsTitleMountersLanguageItemName: string = `RentaTasks.Controller.Steps.Title.Mounters`;
    public readonly rentaTasksControllerStepsTitleEquipmentLanguageItemName: string = `RentaTasks.Controller.Steps.Title.Equipment`;
    public readonly rentaTasksControllerStepsTitleDistanceLanguageItemName: string = `RentaTasks.Controller.Steps.Title.Distance`;
    public readonly rentaTasksControllerStepsTitleApproveLanguageItemName: string = `RentaTasks.Controller.Steps.Title.Approve`;
    public readonly rentaTasksControllerStepsTitleAllowanceLanguageItemName: string = `RentaTasks.Controller.Steps.Title.Allowance`;
    public readonly rentaTasksAssignMounterDropdownWidgetMountersAssignedLanguageItemName: string = `RentaTasks.AssignMounter.DropdownWidget.MountersAssigned`;
    public readonly rentaTasksAssignMounterDropdownWidgetAssignMountersLanguageItemName: string = `RentaTasks.AssignMounter.DropdownWidget.AssignMounters`;
    public readonly rentaTasksApproveDropdownWidgetTasksToCombineLanguageItemName: string = `RentaTasks.Approve.DropdownWidget.TasksToCombine`;
    public readonly rentaTasksApproveDropdownWidgetTasksCombinedLanguageItemName: string = `RentaTasks.Approve.DropdownWidget.TasksCombined`;
    public readonly rentaTasksAddTaskManualLanguageItemName: string = `RentaTasks.AddTask.Manual`;
    public readonly rentaTasksAddEquipmentManualLanguageItemName: string = `RentaTasks.AddEquipment.Manual`;
    public readonly rentaTasksAddEquipmentDropdownWidgetSpecifyAmountLanguageItemName: string = `RentaTasks.AddEquipment.DropdownWidget.SpecifyAmount`;
    public readonly rentaTasksAddEquipmentDropdownWidgetNoEquipmentLanguageItemName: string = `RentaTasks.AddEquipment.DropdownWidget.NoEquipment`;
    public readonly rentaManagementSummaryPageManualLanguageItemName: string = `RentaManagement.SummaryPage.Manual`;
    public readonly rentaManagementSummaryPageDescriptionLanguageItemName: string = `RentaManagement.SummaryPage.Description`;
    public readonly rentaManagementSummaryPageButtonTitleLanguageItemName: string = `RentaManagement.SummaryPage.Button.Title`;
    public readonly rentaManagementSelectSiteNoSiteWithModulesLanguageItemName: string = `RentaManagement.SelectSite.NoSiteWithModules`;
    public readonly rentaManagementSelectModuleNoModulesLanguageItemName: string = `RentaManagement.SelectModule.NoModules`;
    public readonly rentaManagementSelectModuleManualLanguageItemName: string = `RentaManagement.SelectModule.Manual`;
    public readonly rentaManagementSelectModuleDescriptionLanguageItemName: string = `RentaManagement.SelectModule.Description`;
    public readonly rentaManagementSelectAgreementNoAgreementLanguageItemName: string = `RentaManagement.SelectAgreement.NoAgreement`;
    public readonly rentaManagementSelectAgreementManualLanguageItemName: string = `RentaManagement.SelectAgreement.Manual`;
    public readonly rentaManagementSelectAgreementDescriptionLanguageItemName: string = `RentaManagement.SelectAgreement.Description`;
    public readonly rentaManagementSaveAuditSentLanguageItemName: string = `RentaManagement.SaveAudit.Sent`;
    public readonly rentaManagementSaveAuditManualLanguageItemName: string = `RentaManagement.SaveAudit.Manual`;
    public readonly rentaManagementDashboardManualLanguageItemName: string = `RentaManagement.Dashboard.Manual`;
    public readonly rentaManagementDashboardAuditDescriptionLanguageItemName: string = `RentaManagement.Dashboard.Audit.Description`;
    public readonly rentaManagementDashboardAuditLanguageItemName: string = `RentaManagement.Dashboard.Audit`;
    public readonly rentaManagementDashboardAddTaskDescriptionLanguageItemName: string = `RentaManagement.Dashboard.AddTask.Description`;
    public readonly rentaManagementDashboardAddTaskLanguageItemName: string = `RentaManagement.Dashboard.AddTask`;
    public readonly rentaManagementDashboardActivateDescriptionLanguageItemName: string = `RentaManagement.Dashboard.Activate.Description`;
    public readonly rentaManagementDashboardActivateLanguageItemName: string = `RentaManagement.Dashboard.Activate`;
    public readonly rentaManagementControllerStepsTitleSummaryLanguageItemName: string = `RentaManagement.Controller.Steps.Title.Summary`;
    public readonly rentaManagementControllerStepsTitleSelectSiteLanguageItemName: string = `RentaManagement.Controller.Steps.Title.SelectSite`;
    public readonly rentaManagementControllerStepsTitleSelectModuleLanguageItemName: string = `RentaManagement.Controller.Steps.Title.SelectModule`;
    public readonly rentaManagementControllerStepsTitleSelectAgreementLanguageItemName: string = `RentaManagement.Controller.Steps.Title.SelectAgreement`;
    public readonly rentaManagementControllerStepsTitleSaveAuditLanguageItemName: string = `RentaManagement.Controller.Steps.Title.SaveAudit`;
    public readonly rentaManagementControllerStepsTitleParamsLanguageItemName: string = `RentaManagement.Controller.Steps.Title.Params`;
    public readonly rentaManagementControllerStepsTitleGuideLanguageItemName: string = `RentaManagement.Controller.Steps.Title.Guide`;
    public readonly rentaManagementControllerStepsTitleDateLanguageItemName: string = `RentaManagement.Controller.Steps.Title.Date`;
    public readonly rentaManagementControllerStepsTitleCheckLanguageItemName: string = `RentaManagement.Controller.Steps.Title.Check`;
    public readonly rentaManagementControllerStepsTitleAuditLanguageItemName: string = `RentaManagement.Controller.Steps.Title.Audit`;
    public readonly rentaManagementControllerQuestionUprightsLanguageItemName: string = `RentaManagement.Controller.Question.Uprights`;
    public readonly rentaManagementControllerQuestionSideEndBindingsLanguageItemName: string = `RentaManagement.Controller.Question.SideEndBindings`;
    public readonly rentaManagementControllerQuestionSafetyBarriersLanguageItemName: string = `RentaManagement.Controller.Question.SafetyBarriers`;
    public readonly rentaManagementControllerQuestionFoundationLanguageItemName: string = `RentaManagement.Controller.Question.Foundation`;
    public readonly rentaManagementControllerQuestionCoversLanguageItemName: string = `RentaManagement.Controller.Question.Covers`;
    public readonly rentaManagementControllerQuestionCounterTopsLanguageItemName: string = `RentaManagement.Controller.Question.CounterTops`;
    public readonly rentaManagementControllerQuestionBindingsAndSupportersLanguageItemName: string = `RentaManagement.Controller.Question.BindingsAndSupporters`;
    public readonly rentaManagementControllerQuestionAuditCardLanguageItemName: string = `RentaManagement.Controller.Question.AuditCard`;
    public readonly rentaManagementControllerQuestionAscentWaysLanguageItemName: string = `RentaManagement.Controller.Question.AscentWays`;
    public readonly rentaManagementControllerQuestionAnchorageLanguageItemName: string = `RentaManagement.Controller.Question.Anchorage`;
    public readonly rentaManagementAuditParams4SpacingLanguageItemName: string = `RentaManagement.AuditParams4.Spacing`;
    public readonly rentaManagementAuditParams4HighestLanguageItemName: string = `RentaManagement.AuditParams4.Highest`;
    public readonly rentaManagementAuditParams3WindloadLanguageItemName: string = `RentaManagement.AuditParams3.Windload`;
    public readonly rentaManagementAuditParams3WeatherShelterLanguageItemName: string = `RentaManagement.AuditParams3.WeatherShelter`;
    public readonly rentaManagementAuditParams3SnowloadLanguageItemName: string = `RentaManagement.AuditParams3.Snowload`;
    public readonly rentaManagementAuditParams2TypesLanguageItemName: string = `RentaManagement.AuditParams2.Types`;
    public readonly rentaManagementAuditParams2LoadClassLanguageItemName: string = `RentaManagement.AuditParams2.LoadClass`;
    public readonly rentaManagementAuditParams2GuidesLanguageItemName: string = `RentaManagement.AuditParams2.Guides`;
    public readonly rentaManagementAuditParams2CustomLanguageItemName: string = `RentaManagement.AuditParams2.Custom`;
    public readonly rentaManagementAuditParams1HandoverDateLanguageItemName: string = `RentaManagement.AuditParams1.HandoverDate`;
    public readonly rentaManagementAuditParams1AuditorLanguageItemName: string = `RentaManagement.AuditParams1.Auditor`;
    public readonly rentaManagementAuditParams1AuditDateLanguageItemName: string = `RentaManagement.AuditParams1.AuditDate`;
    public readonly rentaManagementAuditModuleHeadingTypeLanguageItemName: string = `RentaManagement.AuditModule.Heading.Type`;
    public readonly rentaManagementAuditModuleHeadingNameLanguageItemName: string = `RentaManagement.AuditModule.Heading.Name`;
    public readonly rentaManagementAuditModuleHeadingIdLanguageItemName: string = `RentaManagement.AuditModule.Heading.Id`;
    public readonly rentaManagementAuditModuleHeadingAuditSentLanguageItemName: string = `RentaManagement.AuditModule.Heading.AuditSent`;
    public readonly rentaManagementAuditModuleHeadingAuditResultLanguageItemName: string = `RentaManagement.AuditModule.Heading.AuditResult`;
    public readonly rentaManagementAuditModuleHeadingAuditDateLanguageItemName: string = `RentaManagement.AuditModule.Heading.AuditDate`;
    public readonly rentaManagementAuditModuleHeadingAuditApprovingLanguageItemName: string = `RentaManagement.AuditModule.Heading.AuditApproving`;
    public readonly rentaManagementAuditModuleHeadingAssemblyLanguageItemName: string = `RentaManagement.AuditModule.Heading.Assembly`;
    public readonly workOrderButtonTitleApproverDetailsLanguageItemName: string = `WorkOrder.Button.Title.ApproverDetails`;
    public readonly workOrderButtonTitleAssignApproverLanguageItemName: string = `WorkOrder.Button.Title.AssignApprover`;
    public readonly workOrderButtonTitleAssignOrdererLanguageItemName: string = `WorkOrder.Button.Title.AssignOrderer`;
    public readonly workOrderButtonTitleOrdererDetailsLanguageItemName: string = `WorkOrder.Button.Title.OrdererDetails`;
    public readonly formDefinitionPageMissingNameLanguageItemName: string = `FormDefinitionPage.MissingName`;
    public readonly formDefinitionPageMinMaxIncorrectLanguageItemName: string = `FormDefinitionPage.MinMaxIncorrect`;
    public readonly formDefinitionPageChecksLanguageItemName: string = `FormDefinitionPage.Checks`;
    public readonly formDefinitionPageRestoredLanguageItemName: string = `FormDefinitionPage.Restored`;
    public readonly formDefinitionPageDeletedPermanentlyLanguageItemName: string = `FormDefinitionPage.DeletedPermanently`;
    public readonly formDefinitionPageMarkedAsDeletedLanguageItemName: string = `FormDefinitionPage.MarkedAsDeleted`;
    public readonly formDefinitionPageValidationErrorsLanguageItemName: string = `FormDefinitionPage.ValidationErrors`;
    public readonly formDefinitionPageErrorsLanguageItemName: string = `FormDefinitionPage.Errors`;
    public readonly formDefinitionPageSavedLanguageItemName: string = `FormDefinitionPage.Saved`;
    public readonly formDefinitionPageIconLanguageItemName: string = `FormDefinitionPage.Icon`;
    public readonly formDefinitionPageGroupLanguageItemName: string = `FormDefinitionPage.Group`;
    public readonly formDefinitionPageNameLanguageItemName: string = `FormDefinitionPage.Name`;
    public readonly formDefinitionPageFormTitleLanguageItemName: string = `FormDefinitionPage.FormTitle`;
    public readonly formDefinitionPageTypeLanguageItemName: string = `FormDefinitionPage.Type`;
    public readonly formDefinitionPageManualLanguageItemName: string = `FormDefinitionPage.Manual`;
    public readonly formDefinitionPageAddNewCheckLanguageItemName: string = `FormDefinitionPage.AddNewCheck`;
    public readonly formDefinitionPageTitleLanguageItemName: string = `FormDefinitionPage.Title`;
    public readonly formDefinitionPageFormNameLanguageItemName: string = `FormDefinitionPage.FormName`;
    public readonly formDefinitionPageCustomTypeLanguageItemName: string = `FormDefinitionPage.CustomType`;
    public readonly formDefinitionPageReportingHeadersLanguageItemName: string = `FormDefinitionPage.ReportingHeaders`;
    public readonly formDefinitionPageWorkOrdersLanguageItemName: string = `FormDefinitionPage.WorkOrders`;
    public readonly formDefinitionPageTimeslotLanguageItemName: string = `FormDefinitionPage.Timeslot`;
    public readonly formDefinitionPageRequireLanguageItemName: string = `FormDefinitionPage.Require`;
    public readonly formDefinitionPageMultipleLanguageItemName: string = `FormDefinitionPage.Multiple`;
    public readonly formDefinitionPageApprovableLanguageItemName: string = `FormDefinitionPage.Approvable`;
    public readonly genericSaveLanguageItemName: string = `Generic.Save`;
    public readonly genericRestoreLanguageItemName: string = `Generic.Restore`;
    public readonly genericDeleteLanguageItemName: string = `Generic.Delete`;
    public readonly genericBackLanguageItemName: string = `Generic.Back`;
    public readonly formDefinitionPageDeleteConfirmationLanguageItemName: string = `FormDefinitionPage.Delete.Confirmation`;
    public readonly enumCustomFormTypeAuditLanguageItemName: string = `Enum.CustomFormType.Audit`;
    public readonly enumCustomFormTypeUndefinedLanguageItemName: string = `Enum.CustomFormType.Undefined`;
    public readonly enumFormHeaderTypeConstructionSiteAddressLanguageItemName: string = `Enum.FormHeaderType.ConstructionSiteAddress`;
    public readonly enumFormHeaderTypeConstructionSiteNameLanguageItemName: string = `Enum.FormHeaderType.ConstructionSiteName`;
    public readonly enumFormHeaderTypeWorkOrderManagerNameLanguageItemName: string = `Enum.FormHeaderType.WorkOrderManagerName`;
    public readonly enumFormHeaderTypeCustomerNameLanguageItemName: string = `Enum.FormHeaderType.CustomerName`;
    public readonly enumFormHeaderTypeWorkOrderManagerEmailLanguageItemName: string = `Enum.FormHeaderType.WorkOrderManagerEmail`;
    public readonly enumFormHeaderTypeCustomerNumberLanguageItemName: string = `Enum.FormHeaderType.CustomerNumber`;
    public readonly enumFormMeasuringOperatorBiggerLanguageItemName: string = `Enum.FormMeasuringOperator.Bigger`;
    public readonly enumFormMeasuringOperatorBiggerOrEqualLanguageItemName: string = `Enum.FormMeasuringOperator.BiggerOrEqual`;
    public readonly enumFormMeasuringOperatorEqualLanguageItemName: string = `Enum.FormMeasuringOperator.Equal`;
    public readonly enumFormMeasuringOperatorLessLanguageItemName: string = `Enum.FormMeasuringOperator.Less`;
    public readonly enumFormMeasuringOperatorLessOrEqualLanguageItemName: string = `Enum.FormMeasuringOperator.LessOrEqual`;
    public readonly enumFormMeasuringOperatorNotEqualLanguageItemName: string = `Enum.FormMeasuringOperator.NotEqual`;
    public readonly enumFormHeaderTypeConstructionSiteNumberLanguageItemName: string = `Enum.FormHeaderType.ConstructionSiteNumber`;
    public readonly enumFormItemTypeChecksLanguageItemName: string = `Enum.FormItemType.Checks`;
    public readonly enumFormItemTypePicturesLanguageItemName: string = `Enum.FormItemType.Pictures`;
    public readonly enumFormItemTypeQuestionLanguageItemName: string = `Enum.FormItemType.Question`;
    public readonly enumFormItemTypeQuestionPicturesLanguageItemName: string = `Enum.FormItemType.QuestionPictures`;
    public readonly enumFormTimeslotTypeAfterLanguageItemName: string = `Enum.FormTimeslotType.After`;
    public readonly enumFormTimeslotTypeAnytimeLanguageItemName: string = `Enum.FormTimeslotType.Anytime`;
    public readonly enumFormTimeslotTypeBeforeLanguageItemName: string = `Enum.FormTimeslotType.Before`;
    public readonly formDefinitionPageCommentRequiredLanguageItemName: string = `FormDefinitionPage.CommentRequired`;
    public readonly formDefinitionPageDefaultLanguageItemName: string = `FormDefinitionPage.Default`;
    public readonly formDefinitionPageMinLanguageItemName: string = `FormDefinitionPage.Min`;
    public readonly formDefinitionPageMaxLanguageItemName: string = `FormDefinitionPage.Max`;
    public readonly formDefinitionPageUnlimitedLanguageItemName: string = `FormDefinitionPage.Unlimited`;
    public readonly formDefinitionPageFormItemMultipleLanguageItemName: string = `FormDefinitionPage.FormItem.Multiple`;
    public readonly formDefinitionPageFormItemRequiredLanguageItemName: string = `FormDefinitionPage.FormItem.Required`;
    public readonly formDefinitionPageRowsLanguageItemName: string = `FormDefinitionPage.Rows`;
    public readonly formDefinitionPageDescriptionLanguageItemName: string = `FormDefinitionPage.Description`;
    public readonly formDefinitionPageItemNameLanguageItemName: string = `FormDefinitionPage.ItemName`;
    public readonly formDefinitionPageMaxLengthLanguageItemName: string = `FormDefinitionPage.MaxLength`;
    public readonly formDefinitionPageMinLengthLanguageItemName: string = `FormDefinitionPage.MinLength`;
    public readonly formDefinitionPageUniquePerProjectLanguageItemName: string = `FormDefinitionPage.UniquePerProject`;
    public readonly formDefinitionPageAddNewOptionLanguageItemName: string = `FormDefinitionPage.AddNewOption`;
    public readonly formDefinitionsPageDefinitionTitleLanguageItemName: string = `FormDefinitionsPage.DefinitionTitle`;
    public readonly formDefinitionsPageAddNewLanguageItemName: string = `FormDefinitionsPage.AddNew`;
    public readonly formDefinitionsPageShowDeletedLanguageItemName: string = `FormDefinitionsPage.ShowDeleted`;
    public readonly formDefinitionsPageSubtitleLanguageItemName: string = `FormDefinitionsPage.Subtitle`;
    public readonly formDefinitionsPageTitleLanguageItemName: string = `FormDefinitionsPage.Title`;
    public readonly enumFormHeaderTypeWorkOrderManagerPhoneLanguageItemName: string = `Enum.FormHeaderType.WorkOrderManagerPhone`;
    public readonly enumFormHeaderTypeWorkOrderOrdererPhoneLanguageItemName: string = `Enum.FormHeaderType.WorkOrderOrdererPhone`;
    public readonly enumFormHeaderTypeWorkOrderOrdererNameLanguageItemName: string = `Enum.FormHeaderType.WorkOrderOrdererName`;
    public readonly enumFormHeaderTypeWorkOrderOrdererEmailLanguageItemName: string = `Enum.FormHeaderType.WorkOrderOrdererEmail`;
    public readonly formModelApprovedLanguageItemName: string = `FormModel.Approved`;
    public readonly formModelSentLanguageItemName: string = `FormModel.Sent`;
    public readonly formModelProcessedLanguageItemName: string = `FormModel.Processed`;
    public readonly formModelInProgressLanguageItemName: string = `FormModel.InProgress`;
    public readonly formModelNewLanguageItemName: string = `FormModel.New`;
    public readonly enumExtraChargeTypeUnitPcsLanguageItemName: string = `Enum.ExtraChargeTypeUnit.Pcs`;
    public readonly enumExtraChargeTypeUnitM2LanguageItemName: string = `Enum.ExtraChargeTypeUnit.M2`;
    public readonly enumExtraChargeTypeUnitM1LanguageItemName: string = `Enum.ExtraChargeTypeUnit.M1`;
    public readonly enumExtraChargeTypeUnitM3LanguageItemName: string = `Enum.ExtraChargeTypeUnit.M3`;
    public readonly enumExtraChargeTypeUnitHLanguageItemName: string = `Enum.ExtraChargeTypeUnit.H`;
    public readonly enumExtraChargeTypeUnitKmLanguageItemName: string = `Enum.ExtraChargeTypeUnit.Km`;
    public readonly extraChargeTypeManagementPageTitleLanguageItemName: string = `ExtraChargeTypeManagement.PageTitle`;
    public readonly genericCommentLanguageItemName: string = `Generic.Comment`;
    public readonly genericUnsupportedImageTypeLanguageItemName: string = `Generic.UnsupportedImageType`;
    public readonly formReceiversPageReportSentToCustomerLanguageItemName: string = `FormReceiversPage.ReportSentToCustomer`;
    public readonly rentaTasksFormSummaryTableChooseReceiversLanguageItemName: string = `RentaTasks.FormSummaryTable.ChooseReceivers`;
    public readonly formSummaryTableDropdownNothingSelectedTextLanguageItemName: string = `FormSummaryTable.Dropdown.NothingSelectedText`;
    public readonly formsListGetManualLanguageItemName: string = `FormsList.GetManual`;
    public readonly formsDataNameLanguageItemName: string = `FormsData.Name`;
    public readonly formsDataTypeLanguageItemName: string = `FormsData.Type`;
    public readonly formsDataWorkOrderLanguageItemName: string = `FormsData.WorkOrder`;
    public readonly formsDataApprovedAtLanguageItemName: string = `FormsData.ApprovedAt`;
    public readonly myFormsApproveFormReportLanguageItemName: string = `MyForms.ApproveFormReport`;
    public readonly myFormsApproveConfirmationLanguageItemName: string = `MyForms.ApproveConfirmation`;
    public readonly myFormsPreviewFormReportLanguageItemName: string = `MyForms.PreviewFormReport`;
    public readonly myFormsDownloadFormReportLanguageItemName: string = `MyForms.DownloadFormReport`;
    public readonly documentPreviewModalFormTitleLanguageItemName: string = `DocumentPreviewModal.Form.Title`;
    public readonly myFormsTitleLanguageItemName: string = `MyForms.Title`;
    public readonly myFormsNoFormReportsLanguageItemName: string = `MyForms.NoFormReports`;
    public readonly formsTabTitleLanguageItemName: string = `Forms.Tab.Title`;
    public readonly formsDataReporterLanguageItemName: string = `FormsData.Reporter`;
    public readonly formsDataStartedAtLanguageItemName: string = `FormsData.StartedAt`;
    public readonly formsDataProcessInfoLanguageItemName: string = `FormsData.ProcessInfo`;
    public readonly formsDataCompletedAtLanguageItemName: string = `FormsData.CompletedAt`;
    public readonly genericActionDownloadLanguageItemName: string = `Generic.Action.Download`;
    public readonly formsDataPassedLanguageItemName: string = `FormsData.Passed`;
    public readonly formsDataApprovalLanguageItemName: string = `FormsData.Approval`;
    public readonly formsDataSentLanguageItemName: string = `FormsData.Sent`;
    public readonly formsDataSentToLanguageItemName: string = `FormsData.SentTo`;
    public readonly formsDataSentAtLanguageItemName: string = `FormsData.SentAt`;
    public readonly formsDataToolbarFiltersApprovalTypeLanguageItemName: string = `FormsData.Toolbar.Filters.ApprovalType`;
    public readonly formsDataToolbarFiltersFromLanguageItemName: string = `FormsData.Toolbar.Filters.From`;
    public readonly formsDataToolbarFiltersReportersLanguageItemName: string = `FormsData.Toolbar.Filters.Reporters`;
    public readonly formsDataToolbarFiltersStatusLanguageItemName: string = `FormsData.Toolbar.Filters.Status`;
    public readonly formsDataToolbarFiltersToLanguageItemName: string = `FormsData.Toolbar.Filters.To`;
    public readonly taskTooltipsTaskBlockedByFormLanguageItemName: string = `TaskTooltips.TaskBlockedByForm`;
    public readonly workOrderStatusBlockedByFormLanguageItemName: string = `WorkOrderStatus.BlockedByForm`;
    public readonly adminExtraChargeTypeInUseTooltipLanguageItemName: string = `AdminExtraChargeType.InUseTooltip`;
    public readonly addExtraChargeModalSubtitleLanguageItemName: string = `AddExtraChargeModal.Subtitle`;
    public readonly addExtraChargeModalTitleLanguageItemName: string = `AddExtraChargeModal.Title`;
    public readonly addExtraChargeModalExtraChargeTypeDropdownLabelLanguageItemName: string = `AddExtraChargeModal.ExtraChargeTypeDropdown.Label`;
    public readonly addExtraChargeModalExtraChargeTypeUnitTextInputLabelLanguageItemName: string = `AddExtraChargeModal.ExtraChargeTypeUnitTextInput.Label`;
    public readonly addExtraChargeModalExtraChargeAmountNumberInputLabelLanguageItemName: string = `AddExtraChargeModal.ExtraChargeAmountNumberInput.Label`;
    public readonly workOrderDetailsPanelExtraChargesTabTitleLanguageItemName: string = `WorkOrderDetailsPanel.ExtraChargesTab.Title`;
    public readonly workOrderDetailsPanelExtraChargesToolbarButtonLabelLanguageItemName: string = `WorkOrderDetailsPanel.ExtraChargesToolbarButton.Label`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsAddExtraChargeLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProducts.AddExtraCharge`;
    public readonly workOrderDetailsPanelGridExtraChargesTypeLanguageItemName: string = `WorkOrderDetailsPanel.Grid.ExtraCharges.Type`;
    public readonly workOrderDetailsPanelGridExtraChargesUnitLanguageItemName: string = `WorkOrderDetailsPanel.Grid.ExtraCharges.Unit`;
    public readonly workOrderDetailsPanelGridExtraChargesAmountLanguageItemName: string = `WorkOrderDetailsPanel.Grid.ExtraCharges.Amount`;
    public readonly rentaTasksControllerAlertErrorFormProcessedByAnotherUserLanguageItemName: string = `RentaTasks.Controller.AlertError.FormProcessedByAnotherUser`;
    public readonly formModalConfirmationUnlockLanguageItemName: string = `FormModal.Confirmation.Unlock`;
    public readonly formModalConfirmationOnCloseLanguageItemName: string = `FormModal.Confirmation.OnClose`;
    public readonly formModalTextProcessedByLanguageItemName: string = `FormModal.Text.ProcessedBy`;
    public readonly formModalTextInProgressByLanguageItemName: string = `FormModal.Text.InProgressBy`;
    public readonly formModalTextFormConductionTimeLanguageItemName: string = `FormModal.Text.FormConductionTime`;
    public readonly formModalTextApprovedByLanguageItemName: string = `FormModal.Text.ApprovedBy`;
    public readonly formModalDropdownShareToLanguageItemName: string = `FormModal.Dropdown.ShareTo`;
    public readonly formModalDropdownFormsLanguageItemName: string = `FormModal.Dropdown.Forms`;
    public readonly formModalSubtitleLanguageItemName: string = `FormModal.Subtitle`;
    public readonly formsListButtonTitleFillLanguageItemName: string = `FormsList.ButtonTitle.Fill`;
    public readonly formsListButtonTitleContinueLanguageItemName: string = `FormsList.ButtonTitle.Continue`;
    public readonly formsListButtonTitleUnlockLanguageItemName: string = `FormsList.ButtonTitle.Unlock`;
    public readonly workOrdersPanelWorkOrderFormsLanguageItemName: string = `WorkOrdersPanel.WorkOrderForms`;
    public readonly workOrdersPanelFlyoutMessageFormSavedLanguageItemName: string = `WorkOrdersPanel.FlyoutMessage.FormSaved`;
    public readonly workOrdersPanelFlyoutWarningTaskNotMappedToFormDefinitionLanguageItemName: string = `WorkOrdersPanel.FlyoutWarning.TaskNotMappedToFormDefinition`;
    public readonly rentaTasksFormWizardPageFormItemNotFoundLanguageItemName: string = `RentaTasks.FormWizardPage.FormItemNotFound`;
    public readonly formReceiversPageSendToReceiversLanguageItemName: string = `FormReceiversPage.SendToReceivers`;
    public readonly formReceiversPageNoContactPersonWarningLanguageItemName: string = `FormReceiversPage.NoContactPersonWarning`;
    public readonly formSummaryPageFormSavedLanguageItemName: string = `FormSummaryPage.FormSaved`;
    public readonly formPreviewPageTitleCompletedFormLanguageItemName: string = `FormPreviewPage.Title.CompletedForm`;
    public readonly formPreviewPageReporterLanguageItemName: string = `FormPreviewPage.Reporter`;
    public readonly formPreviewPageGetManualLanguageItemName: string = `FormPreviewPage.GetManual`;
    public readonly formPreviewPageTitleLanguageItemName: string = `FormPreviewPage.Title`;
    public readonly rentaTasksWorkOrderFormsButtonLanguageItemName: string = `RentaTasks.WorkOrder.Forms.Button`;
    public readonly rentaTasksControllerStepsTitleSendToReceiversLanguageItemName: string = `RentaTasks.Controller.Steps.Title.SendToReceivers`;
    public readonly rentaTasksControllerStepsTitleFormSummaryLanguageItemName: string = `RentaTasks.Controller.Steps.Title.FormSummary`;
    public readonly rentaTasksControllerStepsTitleFormReportingLanguageItemName: string = `RentaTasks.Controller.Steps.Title.FormReporting`;
    public readonly rentaTasksControllerStepsTitleFormPageLanguageItemName: string = `RentaTasks.Controller.Steps.Title.FormPage`;
    public readonly rentaTasksControllerStepsTitleApproveFormLanguageItemName: string = `RentaTasks.Controller.Steps.Title.ApproveForm`;
    public readonly formsListButtonTitleCompletionDateLanguageItemName: string = `FormsList.ButtonTitle.CompletionDate`;
    public readonly genericActionsLanguageItemName: string = `Generic.Actions`;
    public readonly formsListButtonTitleLockedLanguageItemName: string = `FormsList.ButtonTitle.Locked`;
    public readonly workOrderFormsAlertErrorFormUnlockedLanguageItemName: string = `WorkOrderForms.AlertError.FormUnlocked`;
    public readonly workOrderFormsActiveFormsTabLanguageItemName: string = `WorkOrderForms.ActiveFormsTab`;
    public readonly workOrderFormsCompletedFormsTabLanguageItemName: string = `WorkOrderForms.CompletedFormsTab`;
    public readonly enumAttachmentTypeWorkOrderAttachmentLanguageItemName: string = `Enum.AttachmentType.WorkOrderAttachment`;
    public readonly enumAttachmentTypeFormAttachmentLanguageItemName: string = `Enum.AttachmentType.FormAttachment`;
    public readonly enumWorkOrderFormStatusFilterSentLanguageItemName: string = `Enum.WorkOrderFormStatusFilter.Sent`;
    public readonly enumWorkOrderFormStatusFilterProcessedLanguageItemName: string = `Enum.WorkOrderFormStatusFilter.Processed`;
    public readonly enumWorkOrderFormStatusFilterNewLanguageItemName: string = `Enum.WorkOrderFormStatusFilter.New`;
    public readonly enumWorkOrderFormStatusFilterInProgressLanguageItemName: string = `Enum.WorkOrderFormStatusFilter.InProgress`;
    public readonly enumWorkOrderFormStatusFilterApprovedLanguageItemName: string = `Enum.WorkOrderFormStatusFilter.Approved`;
    public readonly widgetMyFormsLabelLanguageItemName: string = `Widget.MyForms.Label`;
    public readonly widgetMyFormsDescriptionLanguageItemName: string = `Widget.MyForms.Description`;
    public readonly topNavFormsLanguageItemName: string = `TopNav.Forms`;
    public readonly workOrdersFiltersCheckboxHideBlockedByFormsLanguageItemName: string = `WorkOrders.Filters.Checkbox.HideBlockedByForms`;
    public readonly enumFormItemTypeTextLanguageItemName: string = `Enum.FormItemType.Text`;
    public readonly enumFormItemTypeResourceLanguageItemName: string = `Enum.FormItemType.Resource`;
    public readonly enumFormItemTypeOptionsLanguageItemName: string = `Enum.FormItemType.Options`;
    public readonly genericOpenLanguageItemName: string = `Generic.Open`;
    public readonly formNavigationStepLanguageItemName: string = `FormNavigation.Step`;
    public readonly genericSearchLanguageItemName: string = `Generic.Search`;
    public readonly extraChargeTypeManagementConfirmationMessageDeletePermanentlyLanguageItemName: string = `ExtraChargeTypeManagement.ConfirmationMessage.DeletePermanently`;
    public readonly extraChargeTypeManagementConfirmationMessageMarkAsDeletedLanguageItemName: string = `ExtraChargeTypeManagement.ConfirmationMessage.MarkAsDeleted`;
    public readonly extraChargeTypeManagementFlyoutMessagePermanentlyDeletedLanguageItemName: string = `ExtraChargeTypeManagement.FlyoutMessage.PermanentlyDeleted`;
    public readonly extraChargeTypeManagementFlyoutMessageMarkedAsDeletedLanguageItemName: string = `ExtraChargeTypeManagement.FlyoutMessage.MarkedAsDeleted`;
    public readonly genericGroupMarkedAsDeletedLanguageItemName: string = `Generic.Group.MarkedAsDeleted`;
    public readonly formDefinitionPageNonConsecutiveGroupsLanguageItemName: string = `FormDefinitionPage.NonConsecutiveGroups`;
    public readonly attachmentsFiltersModalTypeLanguageItemName: string = `AttachmentsFiltersModal.Type`;
    public readonly workOrdersActionsDeleteLanguageItemName: string = `WorkOrders.Actions.Delete`;
    public readonly workOrdersActionsRemoveActivationDateLanguageItemName: string = `WorkOrders.Actions.RemoveActivationDate`;
    public readonly tasksPanelDeleteAttachmentLanguageItemName: string = `TasksPanel.DeleteAttachment`;
    public readonly tasksPanelDeleteDistanceLanguageItemName: string = `TasksPanel.DeleteDistance`;
    public readonly tasksPanelDeleteEquipmentLanguageItemName: string = `TasksPanel.DeleteEquipment`;
    public readonly tasksPanelDeleteExtraChargeLanguageItemName: string = `TasksPanel.DeleteExtraCharge`;
    public readonly formEmailInputReceiverLanguageItemName: string = `Form.EmailInput.Receiver`;
    public readonly formDefinitionsPageIconTooltipCopyFormDefinitionLanguageItemName: string = `FormDefinitionsPage.Icon.Tooltip.CopyFormDefinition`;
    public readonly constructionSitesToolBarSearchTermFilterWithProjectNumberLanguageItemName: string = `ConstructionSites.ToolBar.SearchTermFilterWithProjectNumber`;
    public readonly genericProjectNumberLanguageItemName: string = `Generic.ProjectNumber`;
    public readonly formsListCompletedColumnHeaderPreviewLanguageItemName: string = `FormsList.Completed.ColumnHeader.Preview`;
    public readonly rentaTasksWorkOrderPreviewDetailsFailedAlertLanguageItemName: string = `RentaTasks.WorkOrder.PreviewDetails.FailedAlert`;
    public readonly rentaTasksWorkOrderButtonLabelShowDetailsLanguageItemName: string = `RentaTasks.WorkOrder.Button.Label.ShowDetails`;
    public readonly rentaTasksPreviewDetailsGetManualLanguageItemName: string = `RentaTasks.PreviewDetails.GetManual`;
    public readonly rentaTasksWorkOrderDetailsContactInfoLanguageItemName: string = `RentaTasks.WorkOrderDetails.ContactInfo`;
    public readonly rentaTasksWorkOrderDetailsAssignedMountersLanguageItemName: string = `RentaTasks.WorkOrderDetails.AssignedMounters`;
    public readonly rentaTasksWorkOrderDetailsNoAssignedMountersLanguageItemName: string = `RentaTasks.WorkOrderDetails.NoAssignedMounters`;
    public readonly rentaTasksWorkOrderDetailsNoEquipmentsLanguageItemName: string = `RentaTasks.WorkOrderDetails.NoEquipments`;
    public readonly rentaTasksWorkOrderDetailsEquipmentsLanguageItemName: string = `RentaTasks.WorkOrderDetails.Equipments`;
    public readonly rentaTasksWorkOrderDetailsNoSalaryHoursLanguageItemName: string = `RentaTasks.WorkOrderDetails.NoSalaryHours`;
    public readonly rentaTasksWorkOrderDetailsExtraChargesLanguageItemName: string = `RentaTasks.WorkOrderDetails.ExtraCharges`;
    public readonly rentaTasksWorkOrderDetailsNoExtraChargesLanguageItemName: string = `RentaTasks.WorkOrderDetails.NoExtraCharges`;
    public readonly rentaTasksWorkOrderDetailsDistancesLanguageItemName: string = `RentaTasks.WorkOrderDetails.Distances`;
    public readonly rentaTasksWorkOrderDetailsNoDistancesLanguageItemName: string = `RentaTasks.WorkOrderDetails.NoDistances`;
    public readonly genericAmountLanguageItemName: string = `Generic.Amount`;
    public readonly rentaTasksWorkOrderDetailsSalaryHoursTableNormalHoursLanguageItemName: string = `RentaTasks.WorkOrderDetails.SalaryHoursTable.NormalHours`;
    public readonly rentaTasksWorkOrderDetailsSalaryHoursTableOvertime100LanguageItemName: string = `RentaTasks.WorkOrderDetails.SalaryHoursTable.Overtime100`;
    public readonly rentaTasksWorkOrderDetailsSalaryHoursTableOvertime50LanguageItemName: string = `RentaTasks.WorkOrderDetails.SalaryHoursTable.Overtime50`;
    public readonly rentaTasksWorkOrderDetailsMileagesTableVehiclesAmountLanguageItemName: string = `RentaTasks.WorkOrderDetails.MileagesTable.VehiclesAmount`;
    public readonly rentaTasksWorkOrderDetailsMileagesTableTotalMileagesLanguageItemName: string = `RentaTasks.WorkOrderDetails.MileagesTable.TotalMileages`;
    public readonly rentaTasksWorkOrderDetailsJobSummaryLanguageItemName: string = `RentaTasks.WorkOrderDetails.JobSummary`;
    public readonly genericFullNameLanguageItemName: string = `Generic.FullName`;
    public readonly rentaTasksControllerStepsTitleDetailsPreviewLanguageItemName: string = `RentaTasks.Controller.Steps.Title.DetailsPreview`;
    public readonly genericCustomerNameLanguageItemName: string = `Generic.CustomerName`;
    public readonly formDefinitionPageMountersSignaturesRequiredLanguageItemName: string = `FormDefinitionPage.MountersSignaturesRequired`;
    public readonly mountersSignaturesInstructionMessageLanguageItemName: string = `MountersSignatures.InstructionMessage`;
    public readonly mountersSignaturesValidationMessageLanguageItemName: string = `MountersSignatures.ValidationMessage`;
    public readonly mountersSignaturesSubmitSignaturesLanguageItemName: string = `MountersSignatures.SubmitSignatures`;
    public readonly signatureSigneeNameLanguageItemName: string = `Signature.SigneeName`;
    public readonly signatureSignatureForLanguageItemName: string = `Signature.SignatureFor`;
    public readonly formSummaryTableMountersSignaturesLanguageItemName: string = `FormSummaryTable.MountersSignatures`;
    public readonly mountersSignaturesSummaryErrorLanguageItemName: string = `MountersSignatures.SummaryError`;
    public readonly genericActiveLanguageItemName: string = `Generic.Active`;
    public readonly workOrderDetailsPanelGridAttachmentsAttachmentTypeLanguageItemName: string = `WorkOrderDetailsPanel.Grid.Attachments.AttachmentType`;
    public readonly constructionSiteManagementTabsProjectAttachmentsLanguageItemName: string = `ConstructionSiteManagement.Tabs.ProjectAttachments`;
    public readonly addConstructionSiteAttachmentModalPublicCheckboxLanguageItemName: string = `AddConstructionSiteAttachmentModal.PublicCheckbox`;
    public readonly addConstructionSiteAttachmentModalTitleLanguageItemName: string = `AddConstructionSiteAttachmentModal.Title`;
    public readonly constructionSiteAttachmentsPanelToolbarPublicCheckboxLanguageItemName: string = `ConstructionSiteAttachmentsPanel.Toolbar.PublicCheckbox`;
    public readonly constructionSiteAttachmentsPanelToolbarAddAttachmentsButtonLanguageItemName: string = `ConstructionSiteAttachmentsPanel.Toolbar.AddAttachmentsButton`;
    public readonly constructionSiteAttachmentsGridNoDataTextLanguageItemName: string = `ConstructionSiteAttachmentsGrid.NoDataText`;
    public readonly enumAttachmentTypeConstructionSiteAttachmentLanguageItemName: string = `Enum.AttachmentType.ConstructionSiteAttachment`;
    public readonly constructionSiteAttachmentsGridFileNameLanguageItemName: string = `ConstructionSiteAttachmentsGrid.FileName`;
    public readonly constructionSiteAttachmentsGridFileTypeLanguageItemName: string = `ConstructionSiteAttachmentsGrid.FileType`;
    public readonly constructionSiteAttachmentsGridPublicLanguageItemName: string = `ConstructionSiteAttachmentsGrid.Public`;
    public readonly constructionSiteAttachmentsGridDeleteAttachmentLanguageItemName: string = `ConstructionSiteAttachmentsGrid.DeleteAttachment`;
    public readonly constructionSiteAttachmentsGridConfirmDeleteLanguageItemName: string = `ConstructionSiteAttachmentsGrid.ConfirmDelete`;
    public readonly constructionSiteAttachmentsGridDownloadAttachmentLanguageItemName: string = `ConstructionSiteAttachmentsGrid.DownloadAttachment`;
    public readonly genericWorkingHoursLanguageItemName: string = `Generic.WorkingHours`;
    public readonly formDefinitionPageStepLanguageItemName: string = `FormDefinitionPage.Step`;
    public readonly formDefinitionPageValueStepIncorrectLanguageItemName: string = `FormDefinitionPage.ValueStepIncorrect`;
    public readonly genericDefaultAlarmJobPriceLanguageItemName: string = `Generic.DefaultAlarmJobPrice`;
    public readonly myAccountPageNotificationTabTitleLanguageItemName: string = `MyAccountPage.NotificationTab.Title`;
    public readonly globalNotificationSettingsPageTitleLanguageItemName: string = `GlobalNotificationSettingsPage.Title`;
    public readonly notificationSettingsFlyoutMessageGlobalSettingSavedLanguageItemName: string = `NotificationSettings.FlyoutMessage.GlobalSettingSaved`;
    public readonly notificationSettingsFlyoutMessageUserSettingSavedLanguageItemName: string = `NotificationSettings.FlyoutMessage.UserSettingSaved`;
    public readonly notificationSettingsAlertMessageGlobalSettingsDisabledLanguageItemName: string = `NotificationSettings.AlertMessage.GlobalSettingsDisabled`;
    public readonly notificationSettingsDropdownTypeLanguageItemName: string = `NotificationSettings.Dropdown.Type`;
    public readonly notificationSettingsSwitchEnableLanguageItemName: string = `NotificationSettings.Switch.Enable`;
    public readonly notificationSettingsDropdownMediaTypeLanguageItemName: string = `NotificationSettings.Dropdown.MediaType`;
    public readonly notificationSettingsDropdownIntervalLanguageItemName: string = `NotificationSettings.Dropdown.Interval`;
    public readonly notificationSettingsDateInputSendTimeLanguageItemName: string = `NotificationSettings.DateInput.SendTime`;
    public readonly notificationSettingsDropdownWeeklySendOccurrenceLanguageItemName: string = `NotificationSettings.Dropdown.WeeklySendOccurrence`;
    public readonly notificationSettingsDateInputPausedFromLanguageItemName: string = `NotificationSettings.DateInput.PausedFrom`;
    public readonly notificationSettingsDateInputPausedToLanguageItemName: string = `NotificationSettings.DateInput.PausedTo`;
    public readonly enumNotificationIntervalDailyLanguageItemName: string = `Enum.NotificationInterval.Daily`;
    public readonly enumNotificationIntervalOnDemandLanguageItemName: string = `Enum.NotificationInterval.OnDemand`;
    public readonly enumNotificationIntervalWeeklyLanguageItemName: string = `Enum.NotificationInterval.Weekly`;
    public readonly enumNotificationMediaTypeEmailLanguageItemName: string = `Enum.NotificationMediaType.Email`;
    public readonly enumNotificationMediaTypeEmailAndSmsLanguageItemName: string = `Enum.NotificationMediaType.EmailAndSms`;
    public readonly enumNotificationMediaTypeSmsLanguageItemName: string = `Enum.NotificationMediaType.Sms`;
    public readonly enumDayOfWeekMondayLanguageItemName: string = `Enum.DayOfWeek.Monday`;
    public readonly enumDayOfWeekTuesdayLanguageItemName: string = `Enum.DayOfWeek.Tuesday`;
    public readonly enumDayOfWeekWednesdayLanguageItemName: string = `Enum.DayOfWeek.Wednesday`;
    public readonly enumDayOfWeekThursdayLanguageItemName: string = `Enum.DayOfWeek.Thursday`;
    public readonly enumDayOfWeekFridayLanguageItemName: string = `Enum.DayOfWeek.Friday`;
    public readonly enumDayOfWeekSaturdayLanguageItemName: string = `Enum.DayOfWeek.Saturday`;
    public readonly enumDayOfWeekSundayLanguageItemName: string = `Enum.DayOfWeek.Sunday`;
    public readonly enumNotificationTypeWorkOrdersProcessedApprovalLanguageItemName: string = `Enum.NotificationType.WorkOrdersProcessedApproval`;
    public readonly enumNotificationTypeWorkOrdersPendingApprovalLanguageItemName: string = `Enum.NotificationType.WorkOrdersPendingApproval`;
    public readonly enumNotificationTypeWorkOrderReactivationLanguageItemName: string = `Enum.NotificationType.WorkOrderReactivation`;
    public readonly notificationSettingsNumberInputPendingDaysLanguageItemName: string = `NotificationSettings.NumberInput.PendingDays`;
    public readonly notificationSettingsTextDescriptionLanguageItemName: string = `NotificationSettings.Text.Description`;
    public readonly notificationSettingsNotificationTypeWorkOrdersPendingApprovalDescriptionLanguageItemName: string = `NotificationSettings.NotificationType.WorkOrdersPendingApproval.Description`;
    public readonly notificationSettingsNotificationTypeWorkOrderReactivationDescriptionLanguageItemName: string = `NotificationSettings.NotificationType.WorkOrderReactivation.Description`;
    public readonly notificationSettingsNotificationTypeWorkOrdersProcessedApprovalDescriptionLanguageItemName: string = `NotificationSettings.NotificationType.WorkOrdersProcessedApproval.Description`;
    public readonly formSummaryTableSelectedReceiversHeaderLanguageItemName: string = `FormSummaryTable.SelectedReceiversHeader`;
    public readonly notificationTitleLanguageItemName: string = `Notification.Title`;
    public readonly notificationTitleLoadingLanguageItemName: string = `Notification.Title.Loading`;
    public readonly workOrderCurrentStatusLanguageItemName: string = `WorkOrder.CurrentStatus`;
    public readonly genericSentAtLanguageItemName: string = `Generic.SentAt`;
    public readonly genericSentByLanguageItemName: string = `Generic.SentBy`;
    public readonly genericApprovedAtLanguageItemName: string = `Generic.ApprovedAt`;
    public readonly genericApprovedByLanguageItemName: string = `Generic.ApprovedBy`;
    public readonly workOrderChangeStatusModalTitleReactivateLanguageItemName: string = `WorkOrderChangeStatusModal.Title.Reactivate`;
    public readonly workOrderChangeStatusModalTitleDeclineLanguageItemName: string = `WorkOrderChangeStatusModal.Title.Decline`;
    public readonly genericApprovedOrDeclinedAtLanguageItemName: string = `Generic.ApprovedOrDeclinedAt`;
    public readonly genericApprovedOrDeclinedByLanguageItemName: string = `Generic.ApprovedOrDeclinedBy`;
    public readonly genericFromLanguageItemName: string = `Generic.From`;
    public readonly genericToLanguageItemName: string = `Generic.To`;
    public readonly notificationWorkOrdersPendingApprovalSubtitleLanguageItemName: string = `Notification.WorkOrdersPendingApproval.Subtitle`;
    public readonly workOrderChangeStatusModalPlaceholderCommentReasonLanguageItemName: string = `WorkOrderChangeStatusModal.Placeholder.CommentReason`;
    public readonly statusMessageModalTitleWorkOrderReactivatedLanguageItemName: string = `StatusMessageModal.Title.WorkOrderReactivated`;
    public readonly statusMessageModalTitleWorkReportDeclinedLanguageItemName: string = `StatusMessageModal.Title.WorkReportDeclined`;
    public readonly statusMessageModalCommentedReasonLanguageItemName: string = `StatusMessageModal.CommentedReason`;
    public readonly genericOkLanguageItemName: string = `Generic.Ok`;
    public readonly approveFormPageAlertErrorSignatureIsRequiredLanguageItemName: string = `ApproveFormPage.AlertError.SignatureIsRequired`;
    public readonly rentalEquipmentAddRentalEquipmentLanguageItemName: string = `RentalEquipment.AddRentalEquipment`;
    public readonly rentalEquipmentRentalEquipmentLanguageItemName: string = `RentalEquipment.RentalEquipment`;
    public readonly rentalEquipmentAddRentalEquipmentToWorkOrderLanguageItemName: string = `RentalEquipment.AddRentalEquipmentToWorkOrder`;
    public readonly rentalEquipmentActionTypeLanguageItemName: string = `RentalEquipment.ActionType`;
    public readonly enumRentalItemActionTypeLeaveLanguageItemName: string = `Enum.RentalItemActionType.Leave`;
    public readonly enumRentalItemActionTypeReturnLanguageItemName: string = `Enum.RentalItemActionType.Return`;
    public readonly enumNotificationTypeWorkOrderAssignmentLanguageItemName: string = `Enum.NotificationType.WorkOrderAssignment`;
    public readonly notificationSettingsNotificationTypeWorkOrderAssignmentDescriptionLanguageItemName: string = `NotificationSettings.NotificationType.WorkOrderAssignment.Description`;
    public readonly rentaTasksWorkOrderSignInAlreadySignedInAlertLanguageItemName: string = `RentaTasks.WorkOrder.SignIn.AlreadySignedInAlert`;
    public readonly auditQuestionInputPictureRequiredLanguageItemName: string = `AuditQuestionInput.PictureRequired`;
    public readonly auditQuestionInputPictureOptionalLanguageItemName: string = `AuditQuestionInput.PictureOptional`;
    public readonly genericAlarmJobLanguageItemName: string = `Generic.AlarmJob`;
    public readonly workOrderDetailsHoursGridAddLanguageItemName: string = `WorkOrderDetailsHoursGrid.Add`;
    public readonly dailyHoursModalLabelsIncludeAlarmJobLanguageItemName: string = `DailyHoursModal.Labels.IncludeAlarmJob`;
    public readonly workOrderActionsConfirmApproveSentLanguageItemName: string = `WorkOrder.Actions.ConfirmApproveSent`;
    public readonly workOrderTypeManagementTypeExistsAlertLanguageItemName: string = `WorkOrderTypeManagement.TypeExists.Alert`;
    public readonly userManagementDropdownSubcontractorLanguageItemName: string = `UserManagement.Dropdown.Subcontractor`;
    public readonly userManagementMounterPermissionsCanCreateWorkOrderLanguageItemName: string = `UserManagement.MounterPermissions.CanCreateWorkOrder`;
    public readonly userManagementMounterPermissionsCanCompleteWorkOrderLanguageItemName: string = `UserManagement.MounterPermissions.CanCompleteWorkOrder`;
    public readonly userManagementMounterPermissionsCanProcessFormLanguageItemName: string = `UserManagement.MounterPermissions.CanProcessForm`;
    public readonly addSubcontractorModalValidationErrorSubcontractorAlreadyExistsLanguageItemName: string = `AddSubcontractorModal.ValidationError.SubcontractorAlreadyExists`;
    public readonly subcontractorsPanelConfirmationDeleteSubcontractorLanguageItemName: string = `SubcontractorsPanel.Confirmation.DeleteSubcontractor`;
    public readonly genericDeletedAtLanguageItemName: string = `Generic.DeletedAt`;
    public readonly genericDeletedByLanguageItemName: string = `Generic.DeletedBy`;
    public readonly mobileFormSaveAndCloseLabelLanguageItemName: string = `MobileForm.SaveAndCloseLabel`;
    public readonly mobileFormSaveAndCloseDescriptionLanguageItemName: string = `MobileForm.SaveAndCloseDescription`;
    public readonly genericCreatedByLanguageItemName: string = `Generic.CreatedBy`;
    public readonly genericCreatedAtLanguageItemName: string = `Generic.CreatedAt`;
    public readonly genericSystemLanguageItemName: string = `Generic.System`;
    public readonly workOrderDetailsPanelTabHistoryLanguageItemName: string = `WorkOrderDetailsPanel.Tab.History`;
    public readonly workOrderDetailsPanelWorkOrderStatusesChangedAtLanguageItemName: string = `WorkOrderDetailsPanel.WorkOrderStatuses.ChangedAt`;
    public readonly workOrderDetailsPanelWorkOrderStatusesChangedByLanguageItemName: string = `WorkOrderDetailsPanel.WorkOrderStatuses.ChangedBy`;
    public readonly genericScheduleLanguageItemName: string = `Generic.Schedule`;
    public readonly rentalEquipmentProductWithIdNotAvailableForRentLanguageItemName: string = `RentalEquipment.ProductWithIdNotAvailableForRent`;
    public readonly rentalEquipmentProductInfoRetrievedSuccessfullyLanguageItemName: string = `RentalEquipment.ProductInfoRetrievedSuccessfully`;
    public readonly genericProductWithSameIdHasAlreadyBeenAddedLanguageItemName: string = `Generic.ProductWithSameIdHasAlreadyBeenAdded`;
    public readonly formInputExternalIdLanguageItemName: string = `Form.Input.ExternalId`;
    public readonly workOrderContractTypeDropdownLabelLanguageItemName: string = `WorkOrder.ContractType.DropdownLabel`;
    public readonly enumWorkOrderContractTypeFixedPriceLanguageItemName: string = `Enum.WorkOrderContractType.FixedPrice`;
    public readonly enumWorkOrderContractTypeNormalLanguageItemName: string = `Enum.WorkOrderContractType.Normal`;
    public readonly enumWorkOrderContractTypeWarrantyLanguageItemName: string = `Enum.WorkOrderContractType.Warranty`;
    public readonly workOrderFixedCostLabelLanguageItemName: string = `WorkOrder.FixedCostLabel`;
    public readonly workOrderFixedHoursCostLabelLanguageItemName: string = `WorkOrder.FixedHoursCostLabel`;
    public readonly workOrderFixedTransportationCostLabelLanguageItemName: string = `WorkOrder.FixedTransportationCostLabel`;
    public readonly workOrderFixedProductCostLabelLanguageItemName: string = `WorkOrder.FixedProductCostLabel`;
    public readonly workOrderFixedPriceHeaderLanguageItemName: string = `WorkOrder.FixedPriceHeader`;
    public readonly workOrderHourlyPriceHeaderLanguageItemName: string = `WorkOrder.HourlyPriceHeader`;
    public readonly workOrderPauseStartLabelLanguageItemName: string = `WorkOrder.PauseStart.Label`;
    public readonly workOrderPauseEndLabelLanguageItemName: string = `WorkOrder.PauseEnd.Label`;
    public readonly genericActionPauseTaskLanguageItemName: string = `Generic.Action.PauseTask`;
    public readonly calendarPageCalendarDataPauseOverlayTextLanguageItemName: string = `CalendarPage.CalendarData.PauseOverlay.Text`;
    public readonly genericWorkOrderPausedSuccessfullyLanguageItemName: string = `Generic.WorkOrder.PausedSuccessfully`;
    public readonly genericWorkOrderPauseFailedLanguageItemName: string = `Generic.WorkOrder.PauseFailed`;
    public readonly formSummaryTableApproverSignatureLanguageItemName: string = `FormSummaryTable.ApproverSignature`;
    public readonly newVersionAvailableTitleLanguageItemName: string = `NewVersionAvailable.Title`;
    public readonly newVersionAvailableDescriptionLanguageItemName: string = `NewVersionAvailable.Description`;
    public readonly newVersionAvailableRefreshButtonLanguageItemName: string = `NewVersionAvailable.RefreshButton`;
    public readonly catalogManagementRentalMassProductsPageTitleLanguageItemName: string = `CatalogManagement.RentalMassProductsPageTitle`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsAddRentalMassEquipmentLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProducts.AddRentalMassEquipment`;
    public readonly subcontractorAssignmentModalWarningLanguageItemName: string = `SubcontractorAssignmentModal.Warning`;
    public readonly genericUnassignLanguageItemName: string = `Generic.Unassign`;
    public readonly genericAssignLanguageItemName: string = `Generic.Assign`;
    public readonly assignedMountersWarningModalMountersAreAssignedLanguageItemName: string = `AssignedMountersWarningModal.MountersAreAssigned`;
    public readonly assignedMountersWarningModalAssignedMountersLanguageItemName: string = `AssignedMountersWarningModal.AssignedMounters`;
    public readonly subcontractorAssignmentModalTitleLanguageItemName: string = `SubcontractorAssignmentModal.Title`;
    public readonly genericClearLanguageItemName: string = `Generic.Clear`;
    public readonly genericActionUnpauseTaskLanguageItemName: string = `Generic.Action.UnpauseTask`;
    public readonly genericWorkOrderUnpausedSuccessfullyLanguageItemName: string = `Generic.WorkOrder.UnpausedSuccessfully`;
    public readonly genericWorkOrderUnpauseFailedLanguageItemName: string = `Generic.WorkOrder.UnpauseFailed`;
    public readonly genericTimeLanguageItemName: string = `Generic.Time`;
    public readonly catalogModalAddRentalEquipmentInsteadLanguageItemName: string = `Catalog.Modal.AddRentalEquipmentInstead`;
    public readonly rentaTasksAddEquipmentCategoriesOrProductsModalTitleRentalMassEquipmentLanguageItemName: string = `RentaTasks.AddEquipment.CategoriesOrProductsModal.Title.RentalMassEquipment`;
    public readonly rentalEquipmentAddRentalMassEquipmentLanguageItemName: string = `RentalEquipment.AddRentalMassEquipment`;
    public readonly calendarPageSubContractorMounterSuffixLanguageItemName: string = `CalendarPage.SubContractorMounterSuffix`;
    public readonly enumNotificationTypeWorkOrderDeclinedLanguageItemName: string = `Enum.NotificationType.WorkOrderDeclined`;
    public readonly notificationSettingsNotificationTypeWorkOrderDeclinedDescriptionLanguageItemName: string = `NotificationSettings.NotificationType.WorkOrderDeclined.Description`;
    public readonly regionManagementPageTitleLanguageItemName: string = `RegionManagement.PageTitle`;
    public readonly genericRegionLanguageItemName: string = `Generic.Region`;
    public readonly genericRegionWorkNumbersLanguageItemName: string = `Generic.RegionWorkNumbers`;
    public readonly enumWorkTypeAlertJobHoursLanguageItemName: string = `Enum.WorkType.AlertJobHours`;
    public readonly enumWorkTypeFixedCostLanguageItemName: string = `Enum.WorkType.FixedCost`;
    public readonly enumWorkTypeFixedHoursCostLanguageItemName: string = `Enum.WorkType.FixedHoursCost`;
    public readonly enumWorkTypeFixedProductCostLanguageItemName: string = `Enum.WorkType.FixedProductCost`;
    public readonly enumWorkTypeFixedTransportationCostLanguageItemName: string = `Enum.WorkType.FixedTransportationCost`;
    public readonly enumWorkTypeMileagesLanguageItemName: string = `Enum.WorkType.Mileages`;
    public readonly enumWorkTypeNormalHoursLanguageItemName: string = `Enum.WorkType.NormalHours`;
    public readonly enumWorkTypeOvertime100LanguageItemName: string = `Enum.WorkType.Overtime100`;
    public readonly enumWorkTypeOvertime50LanguageItemName: string = `Enum.WorkType.Overtime50`;
    public readonly formDefinitionPageOptionsLanguageItemName: string = `FormDefinitionPage.Options`;
    public readonly workOrderDetailsPanelTabExternalNotificationsLanguageItemName: string = `WorkOrderDetailsPanel.Tab.ExternalNotifications`;
    public readonly workOrderDetailsPanelGridExternalNotificationsSenderLanguageItemName: string = `WorkOrderDetailsPanel.Grid.ExternalNotifications.Sender`;
    public readonly externalNotificationModalPreviewTitleLanguageItemName: string = `ExternalNotificationModal.PreviewTitle`;
    public readonly enumAttachmentTypeExternalNotificationAttachmentLanguageItemName: string = `Enum.AttachmentType.ExternalNotificationAttachment`;
    public readonly externalNotificationModalTitleLanguageItemName: string = `ExternalNotificationModal.Title`;
    public readonly externalNotificationModalSubtitleLanguageItemName: string = `ExternalNotificationModal.Subtitle`;
    public readonly externalNotificationModalRecipientEmailLanguageItemName: string = `ExternalNotificationModal.RecipientEmail`;
    public readonly externalNotificationModalRequestDateLanguageItemName: string = `ExternalNotificationModal.RequestDate`;
    public readonly externalNotificationModalSendersEmailLanguageItemName: string = `ExternalNotificationModal.SendersEmail`;
    public readonly externalNotificationModalSendersFirstNameLanguageItemName: string = `ExternalNotificationModal.SendersFirstName`;
    public readonly externalNotificationModalSendersLastNameLanguageItemName: string = `ExternalNotificationModal.SendersLastName`;
    public readonly externalNotificationModalSendersPhoneLanguageItemName: string = `ExternalNotificationModal.SendersPhone`;
    public readonly workOrdersActionsNotificationLanguageItemName: string = `WorkOrders.Actions.Notification`;
    public readonly genericWorkOrderRequiredCostPoolLanguageItemName: string = `Generic.WorkOrder.RequiredCostPool`;
    public readonly workOrderContractNoLanguageItemName: string = `WorkOrder.ContractNo`;
    public readonly userManagementUseConstructionSiteCommunicationLanguageLanguageItemName: string = `UserManagement.UseConstructionSiteCommunicationLanguage`;
    public readonly enumCommunicationLanguageEnglishLanguageItemName: string = `Enum.CommunicationLanguage.English`;
    public readonly enumCommunicationLanguageFinnishLanguageItemName: string = `Enum.CommunicationLanguage.Finnish`;
    public readonly enumCommunicationLanguageSwedishLanguageItemName: string = `Enum.CommunicationLanguage.Swedish`;
    public readonly fileTypeImageLanguageItemName: string = `FileType.Image`;
    public readonly fileTypePdfLanguageItemName: string = `FileType.Pdf`;
    public readonly fileTypeWordLanguageItemName: string = `FileType.Word`;
    public readonly fileTypeExcelLanguageItemName: string = `FileType.Excel`;
    public readonly fileTypePowerPointLanguageItemName: string = `FileType.PowerPoint`;
    public readonly fileTypeOpenOfficeTextLanguageItemName: string = `FileType.OpenOfficeText`;
    public readonly fileTypeOpenOfficeSpreadsheetLanguageItemName: string = `FileType.OpenOfficeSpreadsheet`;
    public readonly fileTypeOpenOfficePresentationLanguageItemName: string = `FileType.OpenOfficePresentation`;
    public readonly enumCalendarUnitTimeDayLanguageItemName: string = `Enum.CalendarUnitTime.Day`;
    public readonly userManagementUserSsoInfoLabelLanguageItemName: string = `UserManagement.UserSsoInfoLabel`;
    public readonly newsEditorAddNewLanguageItemName: string = `NewsEditor.AddNew`;
    public readonly newsEditorDeleteConfirmLanguageItemName: string = `NewsEditor.Delete.Confirm`;
    public readonly newsEditorHelpHeaderLanguageItemName: string = `NewsEditor.Help.Header`;
    public readonly newsEditorInputDescriptionLanguageItemName: string = `NewsEditor.Input.Description`;
    public readonly newsEditorInputEnabledLanguageItemName: string = `NewsEditor.Input.Enabled`;
    public readonly newsEditorInputImageLanguageItemName: string = `NewsEditor.Input.Image`;
    public readonly newsEditorInputTitleLanguageItemName: string = `NewsEditor.Input.Title`;
    public readonly newsEditorPageTitleLanguageItemName: string = `NewsEditor.PageTitle`;
    public readonly newsEditorSaveSuccessLanguageItemName: string = `NewsEditor.Save.Success`;
    public readonly enumWorkTypeCustomProductsLanguageItemName: string = `Enum.WorkType.CustomProducts`;
    public readonly workReportWithCommentsActionLabelLanguageItemName: string = `WorkReportWithComments.ActionLabel`;
    public readonly workOrderDetailsHoursGridSubContractorErrorMessageLanguageItemName: string = `WorkOrderDetails.HoursGrid.SubContractorErrorMessage`;
    public readonly workReportWithCommentsConfirmationLanguageItemName: string = `WorkReportWithComments.Confirmation`;
    public readonly workOrderInvoiceWithoutCreatingOrderLanguageItemName: string = `WorkOrder.InvoiceWithoutCreatingOrder`;
    public readonly finlandWorkOrderInvoiceActionLanguageItemName: string = `Finland.WorkOrder.InvoiceAction`;
    public readonly finlandWorkOrderMarkAsInvoicedActionLanguageItemName: string = `Finland.WorkOrder.MarkAsInvoicedAction`;
    public readonly formDefinitionPageItemExportSizeLanguageItemName: string = `FormDefinitionPage.ItemExportSize`;
    public readonly constructionSitePanelERPConstructionSiteIdLanguageItemName: string = `ConstructionSitePanel.ERPConstructionSiteId`;
    public readonly workReportWithCommentsAdditionalReceiverConfirmationLanguageItemName: string = `WorkReportWithComments.AdditionalReceiverConfirmation`;
    public readonly genericEmailPlaceholderLanguageItemName: string = `Generic.EmailPlaceholder`;
    public readonly tasksPageCommentReportReceiverLabelLanguageItemName: string = `TasksPage.CommentReportReceiverLabel`;
    public readonly enumUserRoleGroupSalesPersonsLanguageItemName: string = `Enum.UserRoleGroup.SalesPersons`;
    public readonly roleNameSalesPersonLanguageItemName: string = `RoleName.SalesPerson`;
    public readonly featureFlagManagementFeatureEnabledHeaderLanguageItemName: string = `FeatureFlagManagement.FeatureEnabledHeader`;
    public readonly featureFlagManagementTitleLanguageItemName: string = `FeatureFlagManagement.Title`;
    public readonly featureFlagsINFOBARLanguageItemName: string = `FeatureFlags.INFO_BAR`;
    public readonly featureFlagsAPPLICATIONUPDATEDLanguageItemName: string = `FeatureFlags.APPLICATION_UPDATED`;
    public readonly knownSettingsApplicationUpdatedTextLanguageItemName: string = `KnownSettings.ApplicationUpdatedText`;
    public readonly knownSettingsInfoBarTextLanguageItemName: string = `KnownSettings.InfoBarText`;
    public readonly knownSettingsAlarmJobPriceLanguageItemName: string = `KnownSettings.AlarmJobPrice`;
    public readonly errorPageUserNameLanguageItemName: string = `ErrorPage.UserName`;
    public readonly errorPageRequestIdLanguageItemName: string = `ErrorPage.RequestId`;
    public readonly errorPageDateAndTimeLanguageItemName: string = `ErrorPage.DateAndTime`;
    public readonly offlinePageBodyLanguageItemName: string = `OfflinePage.Body`;
    public readonly offlinePageTitleLanguageItemName: string = `OfflinePage.Title`;
    public readonly copyWorkOrderConfirmationLanguageItemName: string = `CopyWorkOrder.Confirmation`;
    public readonly catalogManagementErrorMessageRestoreCategoryNotExistsLanguageItemName: string = `CatalogManagement.ErrorMessage.Restore.CategoryNotExists`;
    public readonly catalogFlyoutMessageCategoryMarkedAsDeletedLanguageItemName: string = `Catalog.FlyoutMessage.CategoryMarkedAsDeleted`;
    public readonly catalogFlyoutMessageCategoryRestoredLanguageItemName: string = `Catalog.FlyoutMessage.CategoryRestored`;
    public readonly workOrdersButtonMyWorkOrdersLanguageItemName: string = `WorkOrders.Button.MyWorkOrders`;
    public readonly rentaTasksDashboardRouteWidgetCurrentTaskLanguageItemName: string = `RentaTasks.Dashboard.RouteWidget.CurrentTask`;
    public readonly dailyHoursModalMountersAssignedLanguageItemName: string = `DailyHoursModal.Mounters.Assigned`;
    public readonly constructionSitesAgreementsBrokenAgreementsLanguageItemName: string = `ConstructionSites.Agreements.BrokenAgreements`;
    public readonly topNavWorkOrderCreationRequestsLanguageItemName: string = `TopNav.WorkOrderCreationRequests`;
    public readonly enumCalendarUnitTimeTwoWeeksLanguageItemName: string = `Enum.CalendarUnitTime.TwoWeeks`;
    public readonly productItemProductDefaultExternalIdLanguageItemName: string = `ProductItem.Product.DefaultExternalId`;

    constructor() {

        super(
            [
                { code: "fi", label: "Suomi" },
                { code: "en", label: "English" },
                { code: "sv", label: "Svenska" }
            ],
            "fi");
        
        //Initializer
        this.set(this.widgetRentaLinkLabelLanguageItemName, { language: `fi`, value: `Renta Oy Portal` }, { language: `sv`, value: `Renta Oy Portal` }, { language: `en`, value: `Renta Oy Portal` },);
        this.set(this.loginPageSsoButtonLanguageItemName, { language: `fi`, value: `Office 365` }, { language: `sv`, value: `Office 365` }, { language: `en`, value: `Office 365` },);
        this.set(this.dayOfWeekSundayLanguageItemName, { language: `fi`, value: `Sunnuntai` }, { language: `sv`, value: `Söndag` }, { language: `en`, value: `Sunday` },);
        this.set(this.dayOfWeekMondayLanguageItemName, { language: `fi`, value: `Maanantai` }, { language: `sv`, value: `Måndag` }, { language: `en`, value: `Monday` },);
        this.set(this.dayOfWeekTuesdayLanguageItemName, { language: `fi`, value: `Tiistai` }, { language: `sv`, value: `Tisdag` }, { language: `en`, value: `Tuesday` },);
        this.set(this.dayOfWeekWednesdayLanguageItemName, { language: `fi`, value: `Keskiviikko` }, { language: `sv`, value: `Onsdag` }, { language: `en`, value: `Wednesday` },);
        this.set(this.dayOfWeekThursdayLanguageItemName, { language: `fi`, value: `Torstai` }, { language: `sv`, value: `Torsdag` }, { language: `en`, value: `Thursday` },);
        this.set(this.dayOfWeekFridayLanguageItemName, { language: `fi`, value: `Perjantai` }, { language: `sv`, value: `Fredag` }, { language: `en`, value: `Friday` },);
        this.set(this.dayOfWeekSaturdayLanguageItemName, { language: `fi`, value: `Lauantai` }, { language: `sv`, value: `Lördag` }, { language: `en`, value: `Saturday` },);
        this.set(this.topNavFrontpageLanguageItemName, { language: `fi`, value: `Etusivu` }, { language: `sv`, value: `Framsida` }, { language: `en`, value: `Frontpage` },);
        this.set(this.widgetNewSiteLabelLanguageItemName, { language: `fi`, value: `Uusi työmaa` }, { language: `sv`, value: `Ny byggplats` }, { language: `en`, value: `New site` },);
        this.set(this.topNavLoginLanguageItemName, { language: `fi`, value: `Kirjaudu` }, { language: `sv`, value: `Logga in` }, { language: `en`, value: `Login` },);
        this.set(this.topNavEmployeesLanguageItemName, { language: `fi`, value: `Työntekijät` }, { language: `sv`, value: `Anställda` }, { language: `en`, value: `Employees` },);
        this.set(this.topNavWarehouseLanguageItemName, { language: `fi`, value: `Varastot` }, { language: `sv`, value: `Depå` }, { language: `en`, value: `Warehouses` },);
        this.set(this.topNavConstructionSitesLanguageItemName, { language: `fi`, value: `Työmaat` }, { language: `sv`, value: `Byggplatser` }, { language: `en`, value: `Construction sites` },);
        this.set(this.topNavInvoicesLanguageItemName, { language: `fi`, value: `Laskut` }, { language: `sv`, value: `Fakturor` }, { language: `en`, value: `Invoices` },);
        this.set(this.topNavWorkReportsLanguageItemName, { language: `fi`, value: `Työraportit` }, { language: `sv`, value: `Arbetsrapporter` }, { language: `en`, value: `Work reports` },);
        this.set(this.topNavAuditsLanguageItemName, { language: `fi`, value: `Tarkastukset` }, { language: `sv`, value: `Rapporter` }, { language: `en`, value: `Audits` },);
        this.set(this.topNavAdminLanguageItemName, { language: `fi`, value: `Hallinta` }, { language: `sv`, value: `Administration` }, { language: `en`, value: `Admin` },);
        this.set(this.topNavAccountLanguageItemName, { language: `fi`, value: `Tili` }, { language: `sv`, value: `Konto` }, { language: `en`, value: `Account` },);
        this.set(this.topNavLogoutLanguageItemName, { language: `fi`, value: `Kirjaudu ulos` }, { language: `sv`, value: `Logga ut` }, { language: `en`, value: `Logout` },);
        this.set(this.widgetConstructionSitesLabelLanguageItemName, { language: `fi`, value: `Työmaat` }, { language: `sv`, value: `Byggplatser` }, { language: `en`, value: `Construction sites` },);
        this.set(this.widgetConstructionSitesDescriptionLanguageItemName, { language: `fi`, value: `Työmaat: {0}` }, { language: `sv`, value: `Byggplatser: {0}` }, { language: `en`, value: `Construction sites: {0}` },);
        this.set(this.widgetNewSiteDescriptionLanguageItemName, { language: `fi`, value: `Luo uusi työmaa` }, { language: `sv`, value: `Skapa ny byggplats` }, { language: `en`, value: `Create a construction site` },);
        this.set(this.widgetNewTaskLabelLanguageItemName, { language: `fi`, value: `Uusi tehtävä` }, { language: `sv`, value: `Nytt uppdrag` }, { language: `en`, value: `New task` },);
        this.set(this.widgetNewTaskDescriptionLanguageItemName, { language: `fi`, value: `Luo uusi tehtävä` }, { language: `sv`, value: `Skapa nytt uppdrag` }, { language: `en`, value: `Create a task` },);
        this.set(this.widgetEmployeesDescriptionLanguageItemName, { language: `fi`, value: `Työntekijät: {0}` }, { language: `sv`, value: `Anställda: {0}` }, { language: `en`, value: `Employees: {0}` },);
        this.set(this.widgetInvoicesDescriptionLanguageItemName, { language: `fi`, value: `{0:C} € / pv` }, { language: `sv`, value: `{0:C} € / dag` }, { language: `en`, value: `{0:C} € / day` },);
        this.set(this.widgetInvoicingPeriodLabelLanguageItemName, { language: `fi`, value: `Laskutuskausi` }, { language: `sv`, value: `Fakturerings period` }, { language: `en`, value: `Invoicing period` },);
        this.set(this.widgetInvoicingPeriodDescriptionLanguageItemName, { language: `fi`, value: `Päivää jäljellä laskutuskatkoon` }, { language: `sv`, value: `Fakturerings dagar kvar` }, { language: `en`, value: `Invoicing days left` },);
        this.set(this.widgetBudgetDataSet1LabelLanguageItemName, { language: `fi`, value: `Kuukausivuokra viimeiset 12 kuukautta` }, { language: `sv`, value: `Budget, €` }, { language: `en`, value: `Monthly rent for the last 12 months` },);
        this.set(this.widgetBudgetDataSet2LabelLanguageItemName, { language: `fi`, value: `Kuukausivuokran kasvu viimeiset 12 kuukautta` }, { language: `sv`, value: `Vinst, €` }, { language: `en`, value: `Monthly rent growing the last 12 months` },);
        this.set(this.widgetMyWorkReportsLabelLanguageItemName, { language: `fi`, value: `Minun työraporttini` }, { language: `sv`, value: `Mina arbetsrapporter` }, { language: `en`, value: `My work reports` },);
        this.set(this.widgetMyWorkReportsDescriptionLanguageItemName, { language: `fi`, value: `Näytä kaikki työraporttini` }, { language: `sv`, value: `Visa alla arbetsrapporter` }, { language: `en`, value: `View all work reports` },);
        this.set(this.widgetMyInvoicesLabelLanguageItemName, { language: `fi`, value: `Minun laskuni` }, { language: `sv`, value: `Mina fakturor` }, { language: `en`, value: `My invoices` },);
        this.set(this.widgetMyInvoicesDescriptionLanguageItemName, { language: `fi`, value: `Näytä kaikki laskuni` }, { language: `sv`, value: `Visa alla fakturor` }, { language: `en`, value: `View all invoices` },);
        this.set(this.widgetMyAuditsLabelLanguageItemName, { language: `fi`, value: `Minun tarkastukseni` }, { language: `sv`, value: `Mina revisioner` }, { language: `en`, value: `My audits` },);
        this.set(this.widgetMyAuditsDescriptionLanguageItemName, { language: `fi`, value: `Näytä kaikki tarkastusraportit` }, { language: `sv`, value: `Visa alla revisionsrapporter` }, { language: `en`, value: `View all audit reports` },);
        this.set(this.widgetRentaLinkDescriptionLanguageItemName, { language: `fi`, value: `Paikallinen konevuokrausportaali` }, { language: `sv`, value: `Lokal maskin uthyrnings portal` }, { language: `en`, value: `Local machine rental portal` },);
        this.set(this.widgetLoginDescriptionLanguageItemName, { language: `fi`, value: `Kirjaudu sisään` }, { language: `sv`, value: `Logga in` }, { language: `en`, value: `Log in\n` },);
        this.set(this.validatorsEmailLanguageItemName, { language: `fi`, value: `Sähköpostiosoite pitäisi olla oikeassa muodossa` }, { language: `sv`, value: `Epost måste vara korrekt format` }, { language: `en`, value: `Email must be a proper email form` },);
        this.set(this.validatorsPasswordLanguageItemName, { language: `fi`, value: `Salasanassa pitää olla vähintään 8 merkkiä, yksi iso kirjain ja yksi erikoismerkki` }, { language: `sv`, value: `Lösenordet måste innehålla minst 8 tecken, en stor bokstav och ett special tecken` }, { language: `en`, value: `Password must contain at least 1 lowercase, 1 uppercase character, 1 special character and be at least 8 characters long` },);
        this.set(this.validatorsPhoneLanguageItemName, { language: `fi`, value: `Tarkista numero.` }, { language: `sv`, value: `Felaktigt telefonnummer.` }, { language: `en`, value: `Incorrect phone number.` },);
        this.set(this.validatorsRequiredLanguageItemName, { language: `fi`, value: `{0} on pakollinen` }, { language: `sv`, value: `{0} krävs` }, { language: `en`, value: `{0} is required` },);
        this.set(this.validatorsNumberRangeLanguageItemName, { language: `fi`, value: `Arvo pitää olla välistä {0} - {1}.` }, { language: `sv`, value: `Värdet måste vara inom räckvidd {0} - {1}.` }, { language: `en`, value: `Value must be in range {0} - {1}.` },);
        this.set(this.loginPageLoginButtonLanguageItemName, { language: `fi`, value: `Kirjaudu` }, { language: `sv`, value: `Logga in` }, { language: `en`, value: `Login` },);
        this.set(this.loginPageForgotPasswordButtonLanguageItemName, { language: `fi`, value: `Unohditko salasanasi?` }, { language: `sv`, value: `Glömt lösenordet?` }, { language: `en`, value: `Forgot password?` },);
        this.set(this.loginPageEmailInputLanguageItemName, { language: `fi`, value: `Sähköposti` }, { language: `sv`, value: `Epost` }, { language: `en`, value: `Email` },);
        this.set(this.loginPagePasswordInputLanguageItemName, { language: `fi`, value: `Salasana` }, { language: `sv`, value: `Lösenord` }, { language: `en`, value: `Password` },);
        this.set(this.loginPageTitleLanguageItemName, { language: `fi`, value: `Kirjaudu sisään.` }, { language: `sv`, value: `Logga in.` }, { language: `en`, value: `Log in.` },);
        this.set(this.loginPageSubtitleLanguageItemName, { language: `fi`, value: `Kirjaudu käyttäjätunnuksellasi ja salasanallasi.` }, { language: `sv`, value: `Logga in med ditt användarnamn och lösenord.` }, { language: `en`, value: `Log in with your username and password.` },);
        this.set(this.enumLoginResultStatusNotFoundLanguageItemName, { language: `fi`, value: `Väärä käyttäjätunnus tai salasana.` }, { language: `sv`, value: `Fel användarnamn eller lösenord.` }, { language: `en`, value: `Invalid username or password.` },);
        this.set(this.enumLoginResultStatusDeletedLanguageItemName, { language: `fi`, value: `Käyttäjätilisi on poistettu. Ota yhteyttä asiakastukeen.` }, { language: `sv`, value: `Ditt konto har raderats, Ta kontakt med kundservicen.` }, { language: `en`, value: `Your account has been deleted. Contact support to restore your access.` },);
        this.set(this.enumLoginResultStatusLockedLanguageItemName, { language: `fi`, value: `Liian monta yritystä kirjautua sisään. Yritä uudelleen myöhemmin.` }, { language: `sv`, value: `För många inloggnings försök, Försök igen senare.` }, { language: `en`, value: `Too many login attempts. Try again later.` },);
        this.set(this.enumLoginResultStatusSecurityLanguageItemName, { language: `fi`, value: `Käyttäjätilisi on lukittu. Ota yhteyttä asiakastukeen.` }, { language: `sv`, value: `Ditt konto har låsts. Kontakta kundservice.` }, { language: `en`, value: `Your account has been locked. Contact support to restore access.` },);
        this.set(this.errorPageTitleLanguageItemName, { language: `fi`, value: `Tapahtui virhe` }, { language: `sv`, value: `Fel uppstod` }, { language: `en`, value: `Error occured` },);
        this.set(this.errorPageErrorMessageLanguageItemName, { language: `fi`, value: `Jos virhe toistuu, ole yhteydessä asiakaspalveluun. Kun ilmoitat tästä ongelmasta, ilmoita myös nämä tiedot` }, { language: `sv`, value: `Om detta händer igen, kontakta kundservice. När du rapporterar det här problemet, vänligen inkludera även denna information` }, { language: `en`, value: `If this happens again, contact support. When reporting this issue, please also include these information` },);
        this.set(this.errorPageContactSupportLanguageItemName, { language: `fi`, value: `Ota yhteyttä tukeen` }, { language: `sv`, value: `Kontakta kundservice` }, { language: `en`, value: `Contact support` },);
        this.set(this.contactSupportPageTitleLanguageItemName, { language: `fi`, value: `Viesti asiakaspalveluun` }, { language: `sv`, value: `Meddelande till kundservice` }, { language: `en`, value: `Message to support team` },);
        this.set(this.formInputEmailLanguageItemName, { language: `fi`, value: `Sähköposti` }, { language: `sv`, value: `Epost` }, { language: `en`, value: `Email` },);
        this.set(this.formInputReceiverEmailLanguageItemName, { language: `fi`, value: `Vastaanottaja` }, { language: `sv`, value: `Epost` }, { language: `en`, value: `Receiver email` },);
        this.set(this.formInputPhoneLanguageItemName, { language: `fi`, value: `Puhelinnumero` }, { language: `sv`, value: `Telefonnummer` }, { language: `en`, value: `Phone number` },);
        this.set(this.formInputFirstnameLanguageItemName, { language: `fi`, value: `Etunimi` }, { language: `sv`, value: `Förnamn` }, { language: `en`, value: `Firstname` },);
        this.set(this.formInputLastnameLanguageItemName, { language: `fi`, value: `Sukunimi` }, { language: `sv`, value: `Efternamn` }, { language: `en`, value: `Lastname` },);
        this.set(this.formInputMessageLanguageItemName, { language: `fi`, value: `Viesti` }, { language: `sv`, value: `Meddelande` }, { language: `en`, value: `Message` },);
        this.set(this.formInputStreetLanguageItemName, { language: `fi`, value: `Katu` }, { language: `sv`, value: `Gata` }, { language: `en`, value: `Street` },);
        this.set(this.formSendLanguageItemName, { language: `fi`, value: `Lähetä` }, { language: `sv`, value: `Skicka` }, { language: `en`, value: `Send` },);
        this.set(this.topNavContactSupportLanguageItemName, { language: `fi`, value: `Tuki` }, { language: `sv`, value: `Kundtjänst` }, { language: `en`, value: `Support` },);
        this.set(this.topNavWorkOrdersLanguageItemName, { language: `fi`, value: `Työtilaukset` }, { language: `sv`, value: `Arbetsorder` }, { language: `en`, value: `Work orders` },);
        this.set(this.rentaTasksDashboardQRCodeLanguageItemName, { language: `fi`, value: `QR koodi` }, { language: `sv`, value: `QR kod` }, { language: `en`, value: `QR code` },);
        this.set(this.rentaTasksDashboardQRCodeDescriptionLanguageItemName, { language: `fi`, value: `Skannaa QR koodi rakennustyömaan valitsemiseksi` }, { language: `sv`, value: `Skanna QR koden för att välja byggplats` }, { language: `en`, value: `Scan QR code to select construction site` },);
        this.set(this.rentaTasksDashboardCheckInLanguageItemName, { language: `fi`, value: `Ilmoittaudu` }, { language: `sv`, value: `Checka in` }, { language: `en`, value: `Check-in` },);
        this.set(this.enumDailyAllowanceMealLanguageItemName, { language: `fi`, value: `AK` }, { language: `sv`, value: `AK` }, { language: `en`, value: `AK` },);
        this.set(this.enumDailyAllowanceDayLanguageItemName, { language: `fi`, value: `1` }, { language: `sv`, value: `1` }, { language: `en`, value: `1` },);
        this.set(this.enumDailyAllowanceHalfDayLanguageItemName, { language: `fi`, value: `1/2` }, { language: `sv`, value: `1/2` }, { language: `en`, value: `1/2` },);
        this.set(this.enumDailyAllowanceMealDescriptionLanguageItemName, { language: `fi`, value: `Ateriakorvaus` }, { language: `sv`, value: `Hel dag med \nrast` }, { language: `en`, value: `Full day with \nmeal` },);
        this.set(this.enumDailyAllowanceDayDescriptionLanguageItemName, { language: `fi`, value: `Koko päivä` }, { language: `sv`, value: `Hel dag` }, { language: `en`, value: `Full day` },);
        this.set(this.enumDailyAllowanceHalfDayDescriptionLanguageItemName, { language: `fi`, value: `Puoli päivää` }, { language: `sv`, value: `Halv dag` }, { language: `en`, value: `Half of the day` },);
        this.set(this.componentDropdownNothingSelectedLanguageItemName, { language: `fi`, value: `Ei mitään valittu` }, { language: `sv`, value: `Ingenting är valt` }, { language: `en`, value: `Nothing is selected` },);
        this.set(this.componentDropdownMultipleSelectedLanguageItemName, { language: `fi`, value: `{0} valittu` }, { language: `sv`, value: `{0} valt` }, { language: `en`, value: `{0} selected` },);
        this.set(this.dropdownGroupWarehousesLanguageItemName, { language: `fi`, value: `Varastot` }, { language: `sv`, value: `Depå` }, { language: `en`, value: `Warehouses` },);
        this.set(this.dropdownGroupConstructionSitesLanguageItemName, { language: `fi`, value: `Työmaat` }, { language: `sv`, value: `Byggplatser` }, { language: `en`, value: `Construction sites` },);
        this.set(this.rentaTasksDashboardSignInLanguageItemName, { language: `fi`, value: `Kirjaudu sisään` }, { language: `sv`, value: `Logga in` }, { language: `en`, value: `Sign-in` },);
        this.set(this.formInputAddressLanguageItemName, { language: `fi`, value: `Osoite` }, { language: `sv`, value: `Adress` }, { language: `en`, value: `Address` },);
        this.set(this.formInputCityLanguageItemName, { language: `fi`, value: `Kaupunki` }, { language: `sv`, value: `Stad` }, { language: `en`, value: `City` },);
        this.set(this.formInputPostalcodeLanguageItemName, { language: `fi`, value: `Postinumero` }, { language: `sv`, value: `Postnummer` }, { language: `en`, value: `Postal code` },);
        this.set(this.formInputLanguageLanguageItemName, { language: `fi`, value: `Kieli` }, { language: `sv`, value: `Språk` }, { language: `en`, value: `Language` },);
        this.set(this.formSaveLanguageItemName, { language: `fi`, value: `Tallenna` }, { language: `sv`, value: `Spara` }, { language: `en`, value: `Save` },);
        this.set(this.componentDropdownNoItemsLanguageItemName, { language: `fi`, value: `Kohteita ei löytynyt` }, { language: `sv`, value: `Inga objekt hittades` }, { language: `en`, value: `No items found` },);
        this.set(this.componentDropdownNoDataLanguageItemName, { language: `fi`, value: `Ei tietoja` }, { language: `sv`, value: `Ingen information` }, { language: `en`, value: `No data` },);
        this.set(this.componentDropdownFilterResultsLanguageItemName, { language: `fi`, value: `Suodata tulokset` }, { language: `sv`, value: `Filtrera resultat` }, { language: `en`, value: `Filter results` },);
        this.set(this.componentDropdownGetResultsLanguageItemName, { language: `fi`, value: `Aloita kirjoittaminen saadaksesi tuloksia` }, { language: `sv`, value: `Börja skriva för att få resultat` }, { language: `en`, value: `Start typing to get results` },);
        this.set(this.loginPageSsoUserNotFoundLanguageItemName, { language: `fi`, value: `Kirjautuminen epäonnistui, käyttäjää ei löydy.` }, { language: `sv`, value: `Inloggningen misslyckades, avändaren hittades inte.` }, { language: `en`, value: `Login failed, user not found.` },);
        this.set(this.myAccountPageTitleLanguageItemName, { language: `fi`, value: `Tilin tiedot` }, { language: `sv`, value: `Mitt konto` }, { language: `en`, value: `My account` },);
        this.set(this.loginPageSsoFailedLanguageItemName, { language: `fi`, value: `Kirjautuminen epäonnistui, ota yhteyttä asiakaspalveluun.` }, { language: `sv`, value: `Inloggningen misslyckades, kontakta kundtjänsten.` }, { language: `en`, value: `Login failed, contact support to solve the issue.` },);
        this.set(this.enumCustomerApprovalTypeEmailLanguageItemName, { language: `fi`, value: `Sähköposti` }, { language: `sv`, value: `Per email` }, { language: `en`, value: `By email` },);
        this.set(this.enumCustomerApprovalTypePhoneLanguageItemName, { language: `fi`, value: `Valmiiksi hyväksytty` }, { language: `sv`, value: `Per telefon` }, { language: `en`, value: `By phone` },);
        this.set(this.enumCustomerApprovalTypePhoneDescriptionLanguageItemName, { language: `fi`, value: `Asiakas hyväksyy puhelimessa` }, { language: `sv`, value: `Raporten är redan godkännd av kunden per telefon` }, { language: `en`, value: `Report already approved by customer by phone` },);
        this.set(this.enumCustomerApprovalTypeEmailDescriptionLanguageItemName, { language: `fi`, value: `Asiakas hyväksyy sähköpostilla` }, { language: `sv`, value: `Raporten kommer att godkännas av kunden via email` }, { language: `en`, value: `Report will be approved by customer through email` },);
        this.set(this.enumCustomerApprovalTypeSignatureLanguageItemName, { language: `fi`, value: `Allekirjoitus` }, { language: `sv`, value: `Kundens underskrift` }, { language: `en`, value: `Customer signature` },);
        this.set(this.enumCustomerApprovalTypeSignatureDescriptionLanguageItemName, { language: `fi`, value: `Asiakas voi allekirjoittaa sovelluksessa` }, { language: `sv`, value: `Kunden kan skriva under raporten i applikationen` }, { language: `en`, value: `Customer can sign report in the application` },);
        this.set(this.enumDailyAllowanceNoneLanguageItemName, { language: `fi`, value: `0` }, { language: `sv`, value: `0` }, { language: `en`, value: `0` },);
        this.set(this.enumUserDocumentTypeCraneCertificateLanguageItemName, { language: `fi`, value: `Nosturitodistus` }, { language: `sv`, value: `Krancertifikat` }, { language: `en`, value: `Crane certificate` },);
        this.set(this.enumUserDocumentTypeDrivingLicenceLanguageItemName, { language: `fi`, value: `Ajokortti` }, { language: `sv`, value: `Körkort` }, { language: `en`, value: `Driving licence` },);
        this.set(this.enumUserDocumentTypeElectricalSafetyCardLanguageItemName, { language: `fi`, value: `Sähköturvallisuuskortti` }, { language: `sv`, value: `El säkerhets kort` }, { language: `en`, value: `Electrical safety card` },);
        this.set(this.enumUserDocumentTypeFireWorkCardLanguageItemName, { language: `fi`, value: `Tulityökortti` }, { language: `sv`, value: `Het arbeten kort` }, { language: `en`, value: `Fire work card` },);
        this.set(this.enumUserDocumentTypeFirstAidCardLanguageItemName, { language: `fi`, value: `Ensiapukortti` }, { language: `sv`, value: `Första hjälp kort` }, { language: `en`, value: `First aid card` },);
        this.set(this.enumUserDocumentTypeForkliftCardLanguageItemName, { language: `fi`, value: `Trukinajolupa` }, { language: `sv`, value: `Truck kort` }, { language: `en`, value: `Forklift card` },);
        this.set(this.enumUserDocumentTypeIdCardLanguageItemName, { language: `fi`, value: `Valttikortti` }, { language: `sv`, value: `ID-06 kort` }, { language: `en`, value: `Worker id card` },);
        this.set(this.enumUserDocumentTypeLifterCardLanguageItemName, { language: `fi`, value: `Nostin` }, { language: `sv`, value: `Säkra lyft kort` }, { language: `en`, value: `Lifter card` },);
        this.set(this.enumUserDocumentTypeRoadSafetyCardLanguageItemName, { language: `fi`, value: `Tieturvakortti` }, { language: `sv`, value: `Arbete på väg kort` }, { language: `en`, value: `Road safety card` },);
        this.set(this.enumUserDocumentTypeRoofFireWorkCardLanguageItemName, { language: `fi`, value: `Katon palotyökortti` }, { language: `sv`, value: `Tak brandarbets kort` }, { language: `en`, value: `Roof fire work card` },);
        this.set(this.enumUserDocumentTypeWetRoomCertificateLanguageItemName, { language: `fi`, value: `Vesityötodistus` }, { language: `sv`, value: `Våtutrymmes certifikat` }, { language: `en`, value: `Wet room certificate` },);
        this.set(this.enumUserDocumentTypeWorkSafetyCardLanguageItemName, { language: `fi`, value: `Työturvallisuuskortti` }, { language: `sv`, value: `Arbetssäkerhets kort` }, { language: `en`, value: `Work safety card` },);
        this.set(this.enumModuleModelUndefinedLanguageItemName, { language: `fi`, value: `---` }, { language: `sv`, value: `---` }, { language: `en`, value: `---` },);
        this.set(this.enumModuleModelModuleLanguageItemName, { language: `fi`, value: `Moduuli` }, { language: `sv`, value: `Bod` }, { language: `en`, value: `Module` },);
        this.set(this.enumModuleModelPerimeterFrameLanguageItemName, { language: `fi`, value: `Kehäteline` }, { language: `sv`, value: `Ställning` }, { language: `en`, value: `Perimeter frame` },);
        this.set(this.enumModuleModelWeatherShelterLanguageItemName, { language: `fi`, value: `Sääsuoja` }, { language: `sv`, value: `Väderskydd` }, { language: `en`, value: `Weather shelter` },);
        this.set(this.enumUserDocumentLevelFirstLanguageItemName, { language: `fi`, value: `Taso 1` }, { language: `sv`, value: `Nivå 1` }, { language: `en`, value: `First` },);
        this.set(this.enumUserDocumentLevelSecondLanguageItemName, { language: `fi`, value: `Taso 2` }, { language: `sv`, value: `Nivå 2` }, { language: `en`, value: `Second` },);
        this.set(this.formInputFileDragAndDropLanguageItemName, { language: `fi`, value: `Pudota tiedosto tähän tai valitse klikkaamalla` }, { language: `sv`, value: `dra och släpp filen här, eller välj med att klicka` }, { language: `en`, value: `Drag'n'drop file here, or click to select` },);
        this.set(this.formInputFileReadonlyLanguageItemName, { language: `fi`, value: `Tämä tiedosto on vain luettavissa` }, { language: `sv`, value: `Filen är bara läsbar` }, { language: `en`, value: `File is readonly` },);
        this.set(this.formInputFilePreviewLanguageItemName, { language: `fi`, value: `Esikatselu` }, { language: `sv`, value: `Förhandsvisning` }, { language: `en`, value: `Preview` },);
        this.set(this.formInputFileChooseFilesLanguageItemName, { language: `fi`, value: `Valitse tiedosto(t)` }, { language: `sv`, value: `Välj fil(er)` }, { language: `en`, value: `Choose file(s)` },);
        this.set(this.userDocumentSubtitleLanguageItemName, { language: `fi`, value: `Lataa asiakirja tai muokkaa olemassa olevaa` }, { language: `sv`, value: `Ladda upp dokument, eller modifiera existerande` }, { language: `en`, value: `Upload document or modify the existing` },);
        this.set(this.userDocumentTitleLanguageItemName, { language: `fi`, value: `Käyttäjän asiakirja` }, { language: `sv`, value: `Användar dokument` }, { language: `en`, value: `User document` },);
        this.set(this.userDocumentSendHelpTextLanguageItemName, { language: `fi`, value: `Lähetä asiakirja sähköpostilla` }, { language: `sv`, value: `Användar dokument via epost` }, { language: `en`, value: `Send user document by email` },);
        this.set(this.userDocumentSendButtonLanguageItemName, { language: `fi`, value: `Lähetä asiakirja` }, { language: `sv`, value: `Användar dokument` }, { language: `en`, value: `Send document` },);
        this.set(this.userDocumentValidThruLanguageItemName, { language: `fi`, value: `Voimassa` }, { language: `sv`, value: `Giltig till` }, { language: `en`, value: `Valid thru` },);
        this.set(this.userDocumentImageLanguageItemName, { language: `fi`, value: `Asiakirjan kuva` }, { language: `sv`, value: `Dokument bild` }, { language: `en`, value: `Document image` },);
        this.set(this.userDocumentLevelLanguageItemName, { language: `fi`, value: `Taso` }, { language: `sv`, value: `Nivå` }, { language: `en`, value: `Level` },);
        this.set(this.enumDailyAllowanceNoneDescriptionLanguageItemName, { language: `fi`, value: `Ei päivärahaa` }, { language: `sv`, value: `Ingen dagpenning` }, { language: `en`, value: `No daily\nallowance` },);
        this.set(this.myAccountPageSubtitleLanguageItemName, { language: `fi`, value: ` ` }, { language: `sv`, value: ` ` }, { language: `en`, value: ` ` },);
        this.set(this.userDocumentSendSuccessLanguageItemName, { language: `fi`, value: `Dokumentti lähetetty` }, { language: `sv`, value: `Dokument skickat` }, { language: `en`, value: `Document sent successfully` },);
        this.set(this.genericAccessDeniedLanguageItemName, { language: `fi`, value: `Käyttö estetty` }, { language: `sv`, value: `Tillträde beviljas ej` }, { language: `en`, value: `Access denied` },);
        this.set(this.genericDataSavedLanguageItemName, { language: `fi`, value: `Tiedot tallennettu` }, { language: `sv`, value: `Sparad` }, { language: `en`, value: `Saved successfully` },);
        this.set(this.resetPasswordPageTitleLanguageItemName, { language: `fi`, value: `Aseta uusi salasana tunnukselle` }, { language: `sv`, value: `Sätt ett nytt lösenord för ditt konto` }, { language: `en`, value: `Set new password for your account` },);
        this.set(this.resetPasswordConfirmPasswordInputLanguageItemName, { language: `fi`, value: `Vahvista salasana` }, { language: `sv`, value: `Bekräfta lösenord` }, { language: `en`, value: `Confirm password` },);
        this.set(this.resetPasswordPasswordsDontMatchMessageLanguageItemName, { language: `fi`, value: `Salasanat eivät täsmää` }, { language: `sv`, value: `Lösenorden matchar inte` }, { language: `en`, value: `Passwords don't match` },);
        this.set(this.resetPasswordSuccessMessageLanguageItemName, { language: `fi`, value: `Salasana asetettu` }, { language: `sv`, value: `Lösenordet bytt` }, { language: `en`, value: `Password set successfully` },);
        this.set(this.resetPasswordSuccessMessageAndInfoLanguageItemName, { language: `fi`, value: `Salasana asetettu. Sinun on hyväksyttävä käyttöehdot ja tietosuojaseloste voidaksesi käyttää sovellusta.` }, { language: `sv`, value: `Lösenordssats framgångsrikt. Du måste acceptera användarvillkor och integritetsmeddelande för att använda ansökan.` }, { language: `en`, value: `Password set successfully. You must accept terms of usage and privacy notice in order to use application.` },);
        this.set(this.changePasswordCurrentPasswordLanguageItemName, { language: `fi`, value: `Nykyinen salasana` }, { language: `sv`, value: `Nuvarande lösenord` }, { language: `en`, value: `Current password` },);
        this.set(this.changePasswordPageTitleLanguageItemName, { language: `fi`, value: `Vaihda salasana` }, { language: `sv`, value: `Byt lösenord` }, { language: `en`, value: `Change password` },);
        this.set(this.changePasswordButtonLanguageItemName, { language: `fi`, value: `Vaihda salasana` }, { language: `sv`, value: `Byt lösenord` }, { language: `en`, value: `Change password` },);
        this.set(this.changePasswordNewPasswordLanguageItemName, { language: `fi`, value: `Uusi salasana` }, { language: `sv`, value: `Nytt lösenord` }, { language: `en`, value: `New password` },);
        this.set(this.roleNameScaffoldingMounterLanguageItemName, { language: `fi`, value: `Telineet asentaja` }, { language: `sv`, value: `Ställnings montör` }, { language: `en`, value: `Scaffolding mounter` },);
        this.set(this.roleNameMounterLanguageItemName, { language: `fi`, value: `RTP asentaja` }, { language: `sv`, value: `Montör` }, { language: `en`, value: `RTP mounter` },);
        this.set(this.roleNameScaffoldingHeadMounterLanguageItemName, { language: `fi`, value: `Telineet työmaavastaava` }, { language: `sv`, value: `RTP huvud montör` }, { language: `en`, value: `Scaffolding head mounter` },);
        this.set(this.roleNameStpHeadMounterLanguageItemName, { language: `fi`, value: `RTP työmaavastaava` }, { language: `sv`, value: `Montör` }, { language: `en`, value: `RTP head mounter` },);
        this.set(this.roleNameScaffoldingManagerLanguageItemName, { language: `fi`, value: `Telineet työmaajohtaja` }, { language: `sv`, value: `Ställnings manager` }, { language: `en`, value: `Scaffolding manager` },);
        this.set(this.roleNameStpManagerLanguageItemName, { language: `fi`, value: `RTP työmaajohtaja` }, { language: `sv`, value: `RTP Montageledare` }, { language: `en`, value: `RTP manager` },);
        this.set(this.roleNameScaffoldingAdminLanguageItemName, { language: `fi`, value: `Telineet admin` }, { language: `sv`, value: `Ställnings administratör` }, { language: `en`, value: `Scaffolding admin` },);
        this.set(this.roleNameStpAdminLanguageItemName, { language: `fi`, value: `RTP admin` }, { language: `sv`, value: `RTP admin` }, { language: `en`, value: `RTP admin` },);
        this.set(this.enumWorkOrderStatusHasActiveTasksLanguageItemName, { language: `fi`, value: `Aktiivisia tehtäviä` }, { language: `sv`, value: `Har aktiva uppdrag` }, { language: `en`, value: `Has active tasks` },);
        this.set(this.enumWorkOrderStatusWorkReportNotSentLanguageItemName, { language: `fi`, value: `Raporttia ei lähetetty` }, { language: `sv`, value: `Arbets raport inte sänd` }, { language: `en`, value: `Work report not sent` },);
        this.set(this.enumWorkOrderStatusWorkReportNotApprovedByCustomerLanguageItemName, { language: `fi`, value: `Asiakas ei ole hyväksynyt` }, { language: `sv`, value: `Väntar på godkännande från kund` }, { language: `en`, value: `Pending customer approval` },);
        this.set(this.enumWorkOrderStatusTaskNotApprovedByManagerLanguageItemName, { language: `fi`, value: `Esihenkilö ei ole hyväksynyt` }, { language: `sv`, value: `Väntar på godkännande från montageledare` }, { language: `en`, value: `Pending manager approval` },);
        this.set(this.enumWorkOrderStatusInvoiceRowsNotApprovedNyManagerLanguageItemName, { language: `fi`, value: `Laskurivejä hyväksymättä` }, { language: `sv`, value: `Väntar på godkännande av faktura` }, { language: `en`, value: `Pending invoice row approval` },);
        this.set(this.enumWorkOrderStatusInvoiceNotCreatedLanguageItemName, { language: `fi`, value: `Laskuttamatta` }, { language: `sv`, value: `Inte fakturerad` }, { language: `en`, value: `Not billed` },);
        this.set(this.enumTaxRateRate0LanguageItemName, { language: `fi`, value: `0%` }, { language: `sv`, value: `0%` }, { language: `en`, value: `0%` },);
        this.set(this.enumTaxRateRate10LanguageItemName, { language: `fi`, value: `10%` }, { language: `sv`, value: `10%` }, { language: `en`, value: `10%` },);
        this.set(this.enumTaxRateRate14LanguageItemName, { language: `fi`, value: `14%` }, { language: `sv`, value: `14%` }, { language: `en`, value: `14%` },);
        this.set(this.enumTaxRateRate24LanguageItemName, { language: `fi`, value: `24%` }, { language: `sv`, value: `24%` }, { language: `en`, value: `24%` },);
        this.set(this.userManagementAddUserLanguageItemName, { language: `fi`, value: `Lisää käyttäjä` }, { language: `sv`, value: `Lägg till användare` }, { language: `en`, value: `Add user` },);
        this.set(this.userManagementButtonAddNewSubcontractorLanguageItemName, { language: `fi`, value: `Lisää uusi alihankkija` }, { language: `sv`, value: `Lägg till ny underleverantör` }, { language: `en`, value: `Add new subcontractor` },);
        this.set(this.userManagementSettingsTabLanguageItemName, { language: `fi`, value: `Asetukset` }, { language: `sv`, value: `Inställningar` }, { language: `en`, value: `Settings` },);
        this.set(this.userManagementSettingsSavedLanguageItemName, { language: `fi`, value: `Asetukset tallennettu` }, { language: `sv`, value: `Inställningar sparade` }, { language: `en`, value: `Settings saved` },);
        this.set(this.userManagementUsersTabLanguageItemName, { language: `fi`, value: `Käyttäjät` }, { language: `sv`, value: `Användare` }, { language: `en`, value: `Users` },);
        this.set(this.userManagementAlertMessageUnlockUserLanguageItemName, { language: `fi`, value: `Käyttäjätilin "{0}" lukitus avattu.` }, { language: `sv`, value: `Användarkonto "{0}" låst upp framgångsrikt.` }, { language: `en`, value: `User account "{0}" unlocked successfully.` },);
        this.set(this.userManagementConfirmationButtonUnlockUserLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat poistaa käyttäjätilin "{0}" lukituksen?` }, { language: `sv`, value: `Är du säker på att du vill låsa upp användaren "{0}"?` }, { language: `en`, value: `Are you sure you want to unlock user "{0}"?` },);
        this.set(this.userManagementConfirmationButtonDeleteUserLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat poistaa käyttäjätilin "{0}"?` }, { language: `sv`, value: `Är du säker på att du vill ta bort användaren "{0}"?` }, { language: `en`, value: `Are you sure you want to delete user "{0}"?` },);
        this.set(this.userManagementConfirmationButtonRestoreUserLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat palauttaa käyttäjätilin "{0}"?` }, { language: `sv`, value: `Är du säker på att du vill återställa användaren "{0}"?` }, { language: `en`, value: `Are you sure you want to restore user "{0}"?` },);
        this.set(this.enumBusinessAreaScaffoldingLanguageItemName, { language: `fi`, value: `Telineet` }, { language: `sv`, value: `Ställningar` }, { language: `en`, value: `Scaffolding` },);
        this.set(this.enumBusinessAreaStpLanguageItemName, { language: `fi`, value: `Stp` }, { language: `sv`, value: `Stp` }, { language: `en`, value: `Stp` },);
        this.set(this.enumConstructionSiteStatusActiveLanguageItemName, { language: `fi`, value: `Aktiivinen` }, { language: `sv`, value: `Aktiv` }, { language: `en`, value: `Active` },);
        this.set(this.enumConstructionSiteStatusActiveDescriptionLanguageItemName, { language: `fi`, value: `Rakenteilla` }, { language: `sv`, value: `Under konstruktion` }, { language: `en`, value: `Under construction` },);
        this.set(this.enumConstructionSiteStatusClosedDescriptionLanguageItemName, { language: `fi`, value: `Työ on valmis, tai sitä ei ole vielä aloitettu` }, { language: `sv`, value: `Byggandet är färdigt eller inte ännu påbörjat` }, { language: `en`, value: `Construction is completed or not started yet` },);
        this.set(this.enumConstructionSiteStatusInactiveLanguageItemName, { language: `fi`, value: `Ei aktiivinen` }, { language: `sv`, value: `Inaktiv` }, { language: `en`, value: `Inactive` },);
        this.set(this.enumConstructionSiteStatusInactiveDescriptionLanguageItemName, { language: `fi`, value: `Rakentaminen on jäädytetty` }, { language: `sv`, value: `Byggandet är pausad` }, { language: `en`, value: `Construction is frozen` },);
        this.set(this.enumConstructionSiteStatusClosedLanguageItemName, { language: `fi`, value: `Suljettu` }, { language: `sv`, value: `Stängt` }, { language: `en`, value: `Closed` },);
        this.set(this.enumContractTaskTypeAssemblyLanguageItemName, { language: `fi`, value: `Asennus` }, { language: `sv`, value: `Installation` }, { language: `en`, value: `Assembly` },);
        this.set(this.enumContractTaskTypeCoveringLanguageItemName, { language: `fi`, value: `Peite` }, { language: `sv`, value: `Skydd` }, { language: `en`, value: `Covering` },);
        this.set(this.enumContractTaskTypeDeliveryLanguageItemName, { language: `fi`, value: `Toimitus` }, { language: `sv`, value: `Leverans` }, { language: `en`, value: `Delivery` },);
        this.set(this.enumContractTaskTypeDismantleLanguageItemName, { language: `fi`, value: `Purku` }, { language: `sv`, value: `Demontera` }, { language: `en`, value: `Dismantle` },);
        this.set(this.enumContractTaskTypeReturnLanguageItemName, { language: `fi`, value: `Palautus` }, { language: `sv`, value: `Retur` }, { language: `en`, value: `Return` },);
        this.set(this.enumUserRoleGroupAdminsLanguageItemName, { language: `fi`, value: `Järjestelmävalvojat` }, { language: `sv`, value: `Administratörer` }, { language: `en`, value: `Admins` },);
        this.set(this.enumUserRoleGroupAdminsDescriptionLanguageItemName, { language: `fi`, value: `Työmaa- ja yritysvalvojat` }, { language: `sv`, value: `Byggplats- och affärsadministratörer` }, { language: `en`, value: `Site & business administrators` },);
        this.set(this.enumUserRoleGroupEmployeesLanguageItemName, { language: `fi`, value: `Työntekijät` }, { language: `sv`, value: `Anställda` }, { language: `en`, value: `Employees` },);
        this.set(this.enumUserRoleGroupEmployeesDescriptionLanguageItemName, { language: `fi`, value: `Pää asentajat, asentajat & kuljettajat` }, { language: `sv`, value: `Huvud montörer, montörer & chaufförer` }, { language: `en`, value: `Head mounters, mounters & drivers` },);
        this.set(this.enumUserRoleGroupManagersLanguageItemName, { language: `fi`, value: `Työnjohtajat` }, { language: `sv`, value: `Montageledarna` }, { language: `en`, value: `Managers` },);
        this.set(this.enumUserRoleGroupManagersDescriptionLanguageItemName, { language: `fi`, value: `Työmaa johtajat & yhteyshenkilöt` }, { language: `sv`, value: `Byggplats Montageledarna & kontaktpersoner` }, { language: `en`, value: `Site managers & contact persons` },);
        this.set(this.enumWorkDayStateNormalLanguageItemName, { language: `fi`, value: `Normaali` }, { language: `sv`, value: `Normal` }, { language: `en`, value: `Normal` },);
        this.set(this.enumWorkDayStateNormalDescriptionLanguageItemName, { language: `fi`, value: `Normaali työpäivä` }, { language: `sv`, value: `Normal arbetsdag` }, { language: `en`, value: `Normal working day` },);
        this.set(this.enumWorkDayStatePaidDayOffLanguageItemName, { language: `fi`, value: `Maksullinen vapaapäivä` }, { language: `sv`, value: `Betald ledig dag` }, { language: `en`, value: `Paid day off` },);
        this.set(this.enumWorkDayStatePaidDayOffDescriptionLanguageItemName, { language: `fi`, value: `Työntekijällä on palkallinen vapaapäivä` }, { language: `sv`, value: `Anställda har betald ledighet` }, { language: `en`, value: `Employee has paid day off` },);
        this.set(this.enumWorkDayStateSickLeaveLanguageItemName, { language: `fi`, value: `Sairasloma` }, { language: `sv`, value: `Sjukskriven` }, { language: `en`, value: `Sick leave` },);
        this.set(this.enumWorkDayStateSickLeaveDescriptionLanguageItemName, { language: `fi`, value: `Työntekijä sairaslomalla` }, { language: `sv`, value: `Anställd är sjukskriven` }, { language: `en`, value: `Employee is on sick leave` },);
        this.set(this.enumWorkDayStateVacationLanguageItemName, { language: `fi`, value: `Lomapäivä` }, { language: `sv`, value: `Semester` }, { language: `en`, value: `Vacation` },);
        this.set(this.enumWorkDayStateVacationDescriptionLanguageItemName, { language: `fi`, value: `Lomapäivä` }, { language: `sv`, value: `Anställd är på semester` }, { language: `en`, value: `Employee is on vacation` },);
        this.set(this.enumWorkDayStateWeeklyRestLanguageItemName, { language: `fi`, value: `Viikkolepo` }, { language: `sv`, value: `Veckovila` }, { language: `en`, value: `Weekly rest` },);
        this.set(this.enumWorkDayStateWeeklyRestDescriptionLanguageItemName, { language: `fi`, value: `Viikkolepo` }, { language: `sv`, value: `Veckosemester` }, { language: `en`, value: `Weekly holiday` },);
        this.set(this.enumWorkDayStateFlexHoursLanguageItemName, { language: `fi`, value: `Pekkanen` }, { language: `sv`, value: `Flextimmar` }, { language: `en`, value: `Flex hours` },);
        this.set(this.enumWorkDayStateFlexHoursDescriptionLanguageItemName, { language: `fi`, value: `Työajan lyhennysvapaa` }, { language: `sv`, value: `Beskrivning för flexhours` }, { language: `en`, value: `Flex hours` },);
        this.set(this.formInputEmployeeNumberLanguageItemName, { language: `fi`, value: `Käyttäjä-id` }, { language: `sv`, value: `Användar-id` }, { language: `en`, value: `Employee number` },);
        this.set(this.formInputRoleLanguageItemName, { language: `fi`, value: `Rooli` }, { language: `sv`, value: `Roll` }, { language: `en`, value: `Role` },);
        this.set(this.genericActionCancelLanguageItemName, { language: `fi`, value: `Peruuta` }, { language: `sv`, value: `Avbryt` }, { language: `en`, value: `Cancel` },);
        this.set(this.monthAprilLanguageItemName, { language: `fi`, value: `huhtikuu` }, { language: `sv`, value: `April` }, { language: `en`, value: `April` },);
        this.set(this.monthAugustLanguageItemName, { language: `fi`, value: `elokuu` }, { language: `sv`, value: `Augusti` }, { language: `en`, value: `August` },);
        this.set(this.monthDecemberLanguageItemName, { language: `fi`, value: `joulukuu` }, { language: `sv`, value: `December` }, { language: `en`, value: `December` },);
        this.set(this.monthFebruaryLanguageItemName, { language: `fi`, value: `helmikuu` }, { language: `sv`, value: `Februari` }, { language: `en`, value: `February` },);
        this.set(this.monthJanuaryLanguageItemName, { language: `fi`, value: `tammikuu` }, { language: `sv`, value: `Januari` }, { language: `en`, value: `January` },);
        this.set(this.monthJulyLanguageItemName, { language: `fi`, value: `heinäkuu` }, { language: `sv`, value: `Juli` }, { language: `en`, value: `July` },);
        this.set(this.monthJuneLanguageItemName, { language: `fi`, value: `kesäkuu` }, { language: `sv`, value: `Juni` }, { language: `en`, value: `June` },);
        this.set(this.monthMarchLanguageItemName, { language: `fi`, value: `maaliskuu` }, { language: `sv`, value: `Mars` }, { language: `en`, value: `March` },);
        this.set(this.monthMayLanguageItemName, { language: `fi`, value: `toukokuu` }, { language: `sv`, value: `Maj` }, { language: `en`, value: `May` },);
        this.set(this.monthNovemberLanguageItemName, { language: `fi`, value: `marraskuu` }, { language: `sv`, value: `November` }, { language: `en`, value: `November` },);
        this.set(this.monthOctoberLanguageItemName, { language: `fi`, value: `lokakuu` }, { language: `sv`, value: `Oktober` }, { language: `en`, value: `October` },);
        this.set(this.monthSeptemberLanguageItemName, { language: `fi`, value: `syyskuu` }, { language: `sv`, value: `September` }, { language: `en`, value: `September` },);
        this.set(this.roleNameContactPersonLanguageItemName, { language: `fi`, value: `Yhteyshenkilö` }, { language: `sv`, value: `Kontakt person` }, { language: `en`, value: `Contact person` },);
        this.set(this.roleNameScaffoldingDriverLanguageItemName, { language: `fi`, value: `Telineiden kuljettaja` }, { language: `sv`, value: `Ställnings chaufför` }, { language: `en`, value: `Scaffolding driver` },);
        this.set(this.roleNameAdminLanguageItemName, { language: `fi`, value: `Administrator` }, { language: `sv`, value: `Administratör` }, { language: `en`, value: `Admin` },);
        this.set(this.roleNameStpDriverLanguageItemName, { language: `fi`, value: `RTP kuljettaja` }, { language: `sv`, value: `RTP förare` }, { language: `en`, value: `RTP driver` },);
        this.set(this.topNavChangePasswordLanguageItemName, { language: `fi`, value: `Vaihda salasana` }, { language: `sv`, value: `Byt lösenord` }, { language: `en`, value: `Change password` },);
        this.set(this.adminHeaderTitleLanguageItemName, { language: `fi`, value: `Admin Hallinta` }, { language: `sv`, value: `Admin Kontrollpanel` }, { language: `en`, value: `Admin management` },);
        this.set(this.userManagementChooseRoleLanguageItemName, { language: `fi`, value: `Valitse rooli` }, { language: `sv`, value: `Välj en roll` }, { language: `en`, value: `Choose a role` },);
        this.set(this.confirmationDialogAreYouSureLanguageItemName, { language: `fi`, value: `Oletko varma?` }, { language: `sv`, value: `Är du säker?` }, { language: `en`, value: `Are you sure?` },);
        this.set(this.confirmationDialogConfirmLanguageItemName, { language: `fi`, value: `Vahvista` }, { language: `sv`, value: `Bekräfta` }, { language: `en`, value: `Confirm` },);
        this.set(this.confirmationDialogCloseLanguageItemName, { language: `fi`, value: `Sulje` }, { language: `sv`, value: `Stäng` }, { language: `en`, value: `Close` },);
        this.set(this.footerFrontpageLanguageItemName, { language: `fi`, value: `Etusivu` }, { language: `sv`, value: `Framsida` }, { language: `en`, value: `Frontpage` },);
        this.set(this.baseInputDocumentTooBigLanguageItemName, { language: `fi`, value: `Dokumentti tiedosto liian iso` }, { language: `sv`, value: `Dokument filen är för stor` }, { language: `en`, value: `Document file is too big` },);
        this.set(this.baseInputDocumentTypeNotSupportedLanguageItemName, { language: `fi`, value: `Dokumentin tyyppi ei ole tuettu. Valitse tiedosto, joka on {0}` }, { language: `sv`, value: `Dokumenttyp stöds inte. Välj dokument som är {0}.` }, { language: `en`, value: `Document type is not supported, choose file with extension {0}` },);
        this.set(this.changePasswordWeakPasswordMessageLanguageItemName, { language: `fi`, value: `Salasanassa pitää olla yksi erikoismerkki, yksi pieni kirjain ('a'-'z'), yksi iso kirjain ('A'-'Z'), yksi numero ja vähintään 8 merkkiä` }, { language: `sv`, value: `Lösenordet måste innehålla ett special tecken, en liten bokstav ('a'-'z'), en stor bokstav ('A'-'Z'), en nummer och minst 8 tecken` }, { language: `en`, value: `Password must have one non alphanumeric character, one lowercase ('a'-'z') character, one uppercase ('A'-'Z') character, one number and be at least 8 characters long` },);
        this.set(this.changePasswordWrongCurrentMessageLanguageItemName, { language: `fi`, value: `Väärä nykyinen salasana` }, { language: `sv`, value: `Nuvarande lösenord är fel` }, { language: `en`, value: `Wrong current password` },);
        this.set(this.passwordHelpTextLengthLanguageItemName, { language: `fi`, value: `vähintään 8 merkkiä` }, { language: `sv`, value: `åtminstone 8 tecken` }, { language: `en`, value: `at least 8 characters long` },);
        this.set(this.passwordHelpTextLowerCaseLanguageItemName, { language: `fi`, value: `yksi pieni kirjain ('a'-'z')` }, { language: `sv`, value: `en liten bokstav ('a'-'z')` }, { language: `en`, value: `one lowercase ('a'-'z') character` },);
        this.set(this.passwordHelpTextNumberLanguageItemName, { language: `fi`, value: `yksi numero` }, { language: `sv`, value: `ett nummer` }, { language: `en`, value: `one number` },);
        this.set(this.passwordHelpTextPasswordHintsLanguageItemName, { language: `fi`, value: `Salasanassa tulee olla vähintään:` }, { language: `sv`, value: `Lösenordet måste innehålla åtminstone:` }, { language: `en`, value: `Password must have at least:` },);
        this.set(this.passwordHelpTextSpecialCharacterLanguageItemName, { language: `fi`, value: `yksi erikoismerkki` }, { language: `sv`, value: `ett special tecken` }, { language: `en`, value: `one non alphanumeric character` },);
        this.set(this.passwordHelpTextUpperCaseLanguageItemName, { language: `fi`, value: `yksi iso kirjain ('A'-'Z')` }, { language: `sv`, value: `en stor bokstav ('A'-'Z')` }, { language: `en`, value: `one uppercase ('A'-'Z') character` },);
        this.set(this.sendWorkReportSubtitleLanguageItemName, { language: `fi`, value: `uudelle tai olemassa olevalle yhteyshenkilölle` }, { language: `sv`, value: `till ny eller befintlig kontakt person` }, { language: `en`, value: `for approving by email to existing or new contact person` },);
        this.set(this.forgotPasswordPagePageTitleLanguageItemName, { language: `fi`, value: `Unohditko salasanasi?` }, { language: `sv`, value: `Glömt lösenordet?` }, { language: `en`, value: `Forgot password?` },);
        this.set(this.topNavWorkHoursLanguageItemName, { language: `fi`, value: `Työtunnit` }, { language: `sv`, value: `Arbets timmar` }, { language: `en`, value: `Work hours` },);
        this.set(this.gridNoDataWorkReportsLanguageItemName, { language: `fi`, value: `Työraportteja ei ole vielä luotu` }, { language: `sv`, value: `Inga raporter har skapats ännu` }, { language: `en`, value: `No work reports have been created yet` },);
        this.set(this.documentPreviewModalWorkReportTitleLanguageItemName, { language: `fi`, value: `Työraportin esikatselu` }, { language: `sv`, value: `Arbets raports förhandsvisning` }, { language: `en`, value: `Work report preview` },);
        this.set(this.componentFooterContactLanguageItemName, { language: `fi`, value: `Yhteystiedot` }, { language: `sv`, value: `Kontakt information` }, { language: `en`, value: `Contact information` },);
        this.set(this.workDayPanelFixedContractCostLanguageItemName, { language: `fi`, value: `Kiinteä hinta, €` }, { language: `sv`, value: `Fast kontrakt pris, €` }, { language: `en`, value: `Fixed price, €` },);
        this.set(this.addWorkReportModalCreateNewReportSubtitleLanguageItemName, { language: `fi`, value: `Täytä laskutus materiaalilla` }, { language: `sv`, value: `Och fyll den med räknings material` }, { language: `en`, value: `And fill it with invoicing material` },);
        this.set(this.addWorkReportModalCreateNewReportLanguageItemName, { language: `fi`, value: `Luo uusi työraportti` }, { language: `sv`, value: `Skapa ny arbets raport` }, { language: `en`, value: `Create new work report` },);
        this.set(this.addTaskModalWorkReportLanguageItemName, { language: `fi`, value: `Työraportti` }, { language: `sv`, value: `Arbets raport` }, { language: `en`, value: `Work Report` },);
        this.set(this.workDayPanelHalfDayAllowanceLanguageItemName, { language: `fi`, value: `1/2 puolipäivä` }, { language: `sv`, value: `1/2 Halv dag` }, { language: `en`, value: `Half of the day` },);
        this.set(this.workDayPanelWorkDayTypeLanguageItemName, { language: `fi`, value: `Tyyppi` }, { language: `sv`, value: `Typ` }, { language: `en`, value: `Type` },);
        this.set(this.workDayPanelSalaryHoursLanguageItemName, { language: `fi`, value: `Työ\ntunnit` }, { language: `sv`, value: `Arbetstimmar` }, { language: `en`, value: `Working\nhours` },);
        this.set(this.workDayPanelSalaryHoursDescriptionLanguageItemName, { language: `fi`, value: `Palkanmaksuun lähetettävät tunnit` }, { language: `sv`, value: `Timmar som ska överföras till lön` }, { language: `en`, value: `Hours to be transferred to payroll` },);
        this.set(this.componentListLoadingLanguageItemName, { language: `fi`, value: `Ladataan...` }, { language: `sv`, value: `Laddar...` }, { language: `en`, value: `Loading...` },);
        this.set(this.componentFooterFrontpageLanguageItemName, { language: `fi`, value: `Etusivu` }, { language: `sv`, value: `Framsida` }, { language: `en`, value: `Frontpage` },);
        this.set(this.documentPreviewModalInvoiceTitleLanguageItemName, { language: `fi`, value: `Työ- ja kustannusraportin esikatselu` }, { language: `sv`, value: `Arbets- och Kostnadsrapport förhandsgranskning` }, { language: `en`, value: `Work and cost report preview` },);
        this.set(this.gridNoDataTasksLanguageItemName, { language: `fi`, value: `Ei tehtäviä` }, { language: `sv`, value: `Inga uppdrag har skapats ännu` }, { language: `en`, value: `No tasks have been created yet` },);
        this.set(this.gridNoDataModulesLanguageItemName, { language: `fi`, value: `Moduuleja ei ole vielä luotu` }, { language: `sv`, value: `Inga moduler har skapats ännu` }, { language: `en`, value: `No modules have been created yet` },);
        this.set(this.gridNoDataInvoiceRowsLanguageItemName, { language: `fi`, value: `Laskurivejä ei ole vielä luotu` }, { language: `sv`, value: `Inga faktura rader har skapats ännu` }, { language: `en`, value: `No invoice rows have been created yet` },);
        this.set(this.gridNoDataInvoicesLanguageItemName, { language: `fi`, value: `Laskuja ei ole` }, { language: `sv`, value: `Inga fakturor` }, { language: `en`, value: `No invoices` },);
        this.set(this.gridNoItemsLanguageItemName, { language: `fi`, value: `Ei kohteita` }, { language: `sv`, value: `Inga artiklar` }, { language: `en`, value: `No items` },);
        this.set(this.enumInvoiceRowTypeWorkReportLanguageItemName, { language: `fi`, value: `Työraportti` }, { language: `sv`, value: `Arbetsrapport` }, { language: `en`, value: `Work report` },);
        this.set(this.enumInvoiceRowTypeWorkReportDescriptionLanguageItemName, { language: `fi`, value: `3020` }, { language: `sv`, value: `3020` }, { language: `en`, value: `3020` },);
        this.set(this.enumInvoiceRowTypeRentLanguageItemName, { language: `fi`, value: `Vuokra` }, { language: `sv`, value: `Hyra` }, { language: `en`, value: `Rent` },);
        this.set(this.enumInvoiceRowTypeRentDescriptionLanguageItemName, { language: `fi`, value: `3000` }, { language: `sv`, value: `3000` }, { language: `en`, value: `3000` },);
        this.set(this.enumInvoiceRowTypeExtraRentLanguageItemName, { language: `fi`, value: `Minimivuokra` }, { language: `sv`, value: `Extra hyra` }, { language: `en`, value: `Extra rent` },);
        this.set(this.enumInvoiceRowTypeContractTaskLanguageItemName, { language: `fi`, value: `Sopimus tehtävä` }, { language: `sv`, value: `Kontrakt uppgift` }, { language: `en`, value: `Contract task` },);
        this.set(this.enumInvoiceRowTypeContractTaskDescriptionLanguageItemName, { language: `fi`, value: `3030` }, { language: `sv`, value: `3030` }, { language: `en`, value: `3030` },);
        this.set(this.enumInvoiceTypeCreditLanguageItemName, { language: `fi`, value: `Hyvityslasku` }, { language: `sv`, value: `Credit` }, { language: `en`, value: `Credit` },);
        this.set(this.enumInvoiceTypeDebitLanguageItemName, { language: `fi`, value: `Myyntilasku` }, { language: `sv`, value: `Debit` }, { language: `en`, value: `Debit` },);
        this.set(this.enumManualInvoiceRowTypeContractTaskLanguageItemName, { language: `fi`, value: `3030` }, { language: `sv`, value: `3030` }, { language: `en`, value: `3030` },);
        this.set(this.enumManualInvoiceRowTypeContractTaskDescriptionLanguageItemName, { language: `fi`, value: `Sopimus tehtävä` }, { language: `sv`, value: `Avtalsuppgift` }, { language: `en`, value: `Contract task` },);
        this.set(this.enumManualInvoiceRowTypeRentLanguageItemName, { language: `fi`, value: `3000` }, { language: `sv`, value: `3000` }, { language: `en`, value: `3000` },);
        this.set(this.enumManualInvoiceRowTypeRentDescriptionLanguageItemName, { language: `fi`, value: `Vuokra` }, { language: `sv`, value: `Hyra` }, { language: `en`, value: `Rent` },);
        this.set(this.enumManualInvoiceRowTypeWorkReportLanguageItemName, { language: `fi`, value: `3020` }, { language: `sv`, value: `3020` }, { language: `en`, value: `3020` },);
        this.set(this.enumManualInvoiceRowTypeWorkReportDescriptionLanguageItemName, { language: `fi`, value: `Työraportti` }, { language: `sv`, value: `Arbetsrapport` }, { language: `en`, value: `WorkReport` },);
        this.set(this.enumManualInvoiceRowTypeTaskEquipmentLanguageItemName, { language: `fi`, value: `3050` }, { language: `sv`, value: `3050` }, { language: `en`, value: `3050` },);
        this.set(this.enumManualInvoiceRowTypeTaskEquipmentDescriptionLanguageItemName, { language: `fi`, value: `Tarvikkeet` }, { language: `sv`, value: `Utrustning` }, { language: `en`, value: `Equipment` },);
        this.set(this.enumInvoiceStateFailedDescriptionLanguageItemName, { language: `fi`, value: `Epäonnistui käsittelyn aikana laskutusjärjestelmästä` }, { language: `sv`, value: `Misslyckades under fakturerings systemets processerna` }, { language: `en`, value: `Failed during processing by invoicing system` },);
        this.set(this.enumInvoiceStateFailedLanguageItemName, { language: `fi`, value: `Epäonnistui` }, { language: `sv`, value: `Misslyckades` }, { language: `en`, value: `Failed` },);
        this.set(this.enumInvoiceStateProcessedDescriptionLanguageItemName, { language: `fi`, value: `Onnistuneesti käsitelty laskutusjärjestelmästä` }, { language: `sv`, value: `Processerat av faktureringssystemet` }, { language: `en`, value: `Successfully processed by invoicing system` },);
        this.set(this.enumInvoiceStateProcessedLanguageItemName, { language: `fi`, value: `Käsitelty` }, { language: `sv`, value: `Bearbetas` }, { language: `en`, value: `Processed` },);
        this.set(this.enumInvoiceStateSentDescriptionLanguageItemName, { language: `fi`, value: `Lasku lähetetty laskujärjestelmään` }, { language: `sv`, value: `Faktura skickat till faktureringssystemet` }, { language: `en`, value: `Invoice sent to invoicing system` },);
        this.set(this.enumInvoiceStateSentLanguageItemName, { language: `fi`, value: `Lähetetty` }, { language: `sv`, value: `Skickat` }, { language: `en`, value: `Sent` },);
        this.set(this.taskHoursPanelHoursInfoLanguageItemName, { language: `fi`, value: `Automaattisesti lasketut tunnit` }, { language: `sv`, value: `Automatiskt räknade timmar` }, { language: `en`, value: `Automatically counted hours` },);
        this.set(this.taskHoursPanelExtraHoursInfoLanguageItemName, { language: `fi`, value: `Lisätunnit, asentajan ilmoittama` }, { language: `sv`, value: `Extra timmar, raporterat av uppgiftens montör` }, { language: `en`, value: `Extra hours, reported by mounter for the task` },);
        this.set(this.taskHoursPanelNoAccessToHoursLanguageItemName, { language: `fi`, value: `Tehtävä sisältää tunteja, joihin sinulla ei ole pääsyä` }, { language: `sv`, value: `uppdraget innehåller timmar som du inte har tillgång till` }, { language: `en`, value: `Task contains hours that you do not have access to` },);
        this.set(this.invoiceExportModalSendToNavLanguageItemName, { language: `fi`, value: `Lähetä Naville` }, { language: `sv`, value: `Skicka till Nav` }, { language: `en`, value: `Send To Nav` },);
        this.set(this.workDayPanelAutoDistanceLanguageItemName, { language: `fi`, value: `Automaattinen \n etäisyys, km` }, { language: `sv`, value: `Automatisk distans, km` }, { language: `en`, value: `Auto distance\nkm` },);
        this.set(this.addTaskModalAddTaskLanguageItemName, { language: `fi`, value: `Lisää tehtävä` }, { language: `sv`, value: `Lägg till uppdrag` }, { language: `en`, value: `Add task` },);
        this.set(this.addTaskModalDescriptionLanguageItemName, { language: `fi`, value: `Kuvaus` }, { language: `sv`, value: `Beskrivning` }, { language: `en`, value: `Description` },);
        this.set(this.tasksPanelTasksLanguageItemName, { language: `fi`, value: `Tehtävät` }, { language: `sv`, value: `Uppdrag` }, { language: `en`, value: `Tasks` },);
        this.set(this.tasksPanelTypeLanguageItemName, { language: `fi`, value: `Tyyppi` }, { language: `sv`, value: `Typ` }, { language: `en`, value: `Type` },);
        this.set(this.tasksPanelWorkReportDescriptionLanguageItemName, { language: `fi`, value: `Työreportin kuvaus` }, { language: `sv`, value: `Arbets raportens beskrivning` }, { language: `en`, value: `Description of the work report` },);
        this.set(this.tasksPanelCodeLanguageItemName, { language: `fi`, value: `Koodi` }, { language: `sv`, value: `Kod` }, { language: `en`, value: `Code` },);
        this.set(this.tasksPanelRestoreTaskLanguageItemName, { language: `fi`, value: `Palauta poistettu tehtävä` }, { language: `sv`, value: `Återställ raderade uppgifter` }, { language: `en`, value: `Restore deleted task` },);
        this.set(this.myWorkHoursDescriptionLanguageItemName, { language: `fi`, value: `Katso ilmoitetut/hyväksytyt työtunnit` }, { language: `sv`, value: `Kolla raporterade/godkända arbetstimmar` }, { language: `en`, value: `Check reported/approved work hours` },);
        this.set(this.tasksPanelActivateTaskLanguageItemName, { language: `fi`, value: `Aktivoi tehtävä` }, { language: `sv`, value: `Aktivera uppgift` }, { language: `en`, value: `Activate Task` },);
        this.set(this.tasksPanelCompleteTaskLanguageItemName, { language: `fi`, value: `Valmis tehtävä` }, { language: `sv`, value: `Färdig uppgift` }, { language: `en`, value: `Complete Task` },);
        this.set(this.tasksPanelActionsLanguageItemName, { language: `fi`, value: `Toiminnot` }, { language: `sv`, value: `Åtgärder` }, { language: `en`, value: `Actions` },);
        this.set(this.tasksPanelExtraHoursInfoLanguageItemName, { language: `fi`, value: `Tehtävän lisätunnit, automaattisesti laskettu tuntien perusteella` }, { language: `sv`, value: `Uppdragets extra timmar, beräknar automatiskt baserat på montörens inmatade extra timmar` }, { language: `en`, value: `Task extra hours, automatically calculated based on mounters entered extra hours` },);
        this.set(this.tasksPanelForecastInfoLanguageItemName, { language: `fi`, value: `Päivämäärä kun tehtävä pitäisi olla valmis` }, { language: `sv`, value: `Datum när uppdraget borde vara färdig (kontrakt datum)` }, { language: `en`, value: `Date when task should be completed (contract date)` },);
        this.set(this.tasksPanelForecastLanguageItemName, { language: `fi`, value: `Ennuste` }, { language: `sv`, value: `Prognos` }, { language: `en`, value: `Forecast` },);
        this.set(this.tasksPanelDoneLanguageItemName, { language: `fi`, value: `Valmis` }, { language: `sv`, value: `Färdig` }, { language: `en`, value: `Done` },);
        this.set(this.tasksPanelStartInfoLanguageItemName, { language: `fi`, value: `Aloitus päivämäärä (päivämäärä kuin tehtävä on aloitettu)` }, { language: `sv`, value: `Aktiverings datum (datum när uppdraget är påbörjad)` }, { language: `en`, value: `Activation date (date when task is started)` },);
        this.set(this.tasksPanelStartLanguageItemName, { language: `fi`, value: `Alku` }, { language: `sv`, value: `Starta` }, { language: `en`, value: `Start` },);
        this.set(this.tasksPanelInfoMounterHoursLanguageItemName, { language: `fi`, value: `Tiedot asentajan tunneista, sitoutuneet tehtävään` }, { language: `sv`, value: `Information om montörens timmar, gällande uppgiften` }, { language: `en`, value: `Information about mounter's hours, commited to the task` },);
        this.set(this.taskHoursPanelFixedPriceLanguageItemName, { language: `fi`, value: `Kiinteä hinta, €` }, { language: `sv`, value: `Fast pris` }, { language: `en`, value: `Fixed price, €` },);
        this.set(this.addTaskModalMountersLanguageItemName, { language: `fi`, value: `Asentajat` }, { language: `sv`, value: `Montörer` }, { language: `en`, value: `Mounters` },);
        this.set(this.taskHoursPanelContractHoursPriceInfoLanguageItemName, { language: `fi`, value: `Sopimushinta €` }, { language: `sv`, value: `Kontrakt pris` }, { language: `en`, value: `Contract cost €` },);
        this.set(this.taskHoursPanelContractHoursLanguageItemName, { language: `fi`, value: `Tunnit` }, { language: `sv`, value: `Timme` }, { language: `en`, value: `Hours` },);
        this.set(this.taskHoursPanelContractHoursPriceLanguageItemName, { language: `fi`, value: `Hinta, €/h` }, { language: `sv`, value: `Pris, €/h` }, { language: `en`, value: `Price, €/h` },);
        this.set(this.taskHoursPanelOvertimeLanguageItemName, { language: `fi`, value: `Ylityö` }, { language: `sv`, value: `Övertid` }, { language: `en`, value: `Overtime` },);
        this.set(this.taskHoursPanelExtraHoursLanguageItemName, { language: `fi`, value: `Laskutunnit` }, { language: `sv`, value: `Extra \n timmar` }, { language: `en`, value: `Extra \n hours` },);
        this.set(this.enumInvoiceStateApprovedDescriptionLanguageItemName, { language: `fi`, value: `Laskut hyväksytty esimieheltä` }, { language: `sv`, value: `Faktura godkännd av montageledare` }, { language: `en`, value: `Invoice approved by manager` },);
        this.set(this.enumInvoiceStateApprovedLanguageItemName, { language: `fi`, value: `Hyväksytty` }, { language: `sv`, value: `Godkänd` }, { language: `en`, value: `Approved` },);
        this.set(this.enumInvoiceStateCreatedDescriptionLanguageItemName, { language: `fi`, value: `Luo per esimies, ei hyväksytty` }, { language: `sv`, value: `Skapad av montageledare, inte godkänd` }, { language: `en`, value: `Create by manager, not approved` },);
        this.set(this.enumScaffoldingLoadClassTypeClass2DescriptionLanguageItemName, { language: `fi`, value: `Luokka 2 (1.5 kN/m2)` }, { language: `sv`, value: `Klass 2 (1.5 kN/m2)` }, { language: `en`, value: `Class 2 (1.5 kN/m2)` },);
        this.set(this.enumScaffoldingLoadClassTypeClass3LanguageItemName, { language: `fi`, value: `Luokka 3` }, { language: `sv`, value: `Klass 3` }, { language: `en`, value: `Class 3` },);
        this.set(this.enumScaffoldingLoadClassTypeClass3DescriptionLanguageItemName, { language: `fi`, value: `Luokka 3 (2 kN/m2)` }, { language: `sv`, value: `Klass 3 (2 kN/m2)` }, { language: `en`, value: `Class 3 (2 kN/m2)` },);
        this.set(this.enumScaffoldingLoadClassTypeClass4LanguageItemName, { language: `fi`, value: `Luokka 4` }, { language: `sv`, value: `Klass 4` }, { language: `en`, value: `Class 4` },);
        this.set(this.enumScaffoldingLoadClassTypeClass4DescriptionLanguageItemName, { language: `fi`, value: `Luokka 4 (3 kN/m2)` }, { language: `sv`, value: `Klass 4 /3 kN/m2)` }, { language: `en`, value: `Class 4 (3 kN/m2)` },);
        this.set(this.enumScaffoldingLoadClassTypeClass5LanguageItemName, { language: `fi`, value: `Luokka 5` }, { language: `sv`, value: `Klass 5` }, { language: `en`, value: `Class 5` },);
        this.set(this.enumScaffoldingLoadClassTypeClass5DescriptionLanguageItemName, { language: `fi`, value: `Luokka 5 (4.5 kN/m2)` }, { language: `sv`, value: `Klass 5 (4.5 kN/m2)` }, { language: `en`, value: `Class 5 (4.5 kN/m2)` },);
        this.set(this.enumScaffoldingLoadClassTypeClass6LanguageItemName, { language: `fi`, value: `Luokka 6` }, { language: `sv`, value: `Klass 6` }, { language: `en`, value: `Class 6` },);
        this.set(this.enumScaffoldingLoadClassTypeClass6DescriptionLanguageItemName, { language: `fi`, value: `Luokka 6 (6 kN/m2)` }, { language: `sv`, value: `Klass 6 (6 kN/m2)` }, { language: `en`, value: `Class 6 (6 kN/m2)` },);
        this.set(this.enumProductUnitPieceLanguageItemName, { language: `fi`, value: `Kappale` }, { language: `sv`, value: `Stycke` }, { language: `en`, value: `Piece` },);
        this.set(this.enumProductUnitMeterLanguageItemName, { language: `fi`, value: `Metri` }, { language: `sv`, value: `Meter` }, { language: `en`, value: `Meter` },);
        this.set(this.enumProductUnitKilometerLanguageItemName, { language: `fi`, value: `Kilometri` }, { language: `sv`, value: `Kilometer` }, { language: `en`, value: `Kilometer` },);
        this.set(this.enumProductUnitMeter2LanguageItemName, { language: `fi`, value: `Neliömetri` }, { language: `sv`, value: `Kvadratmeter` }, { language: `en`, value: `Square meter` },);
        this.set(this.enumProductUnitLiterLanguageItemName, { language: `fi`, value: `Litra` }, { language: `sv`, value: `Liter` }, { language: `en`, value: `Liter` },);
        this.set(this.enumProductUnitBoxLanguageItemName, { language: `fi`, value: `Laatikko` }, { language: `sv`, value: `Låda` }, { language: `en`, value: `Box` },);
        this.set(this.enumProductUnitPairLanguageItemName, { language: `fi`, value: `Pari` }, { language: `sv`, value: `Par` }, { language: `en`, value: `Pair` },);
        this.set(this.enumProductUnitBottleLanguageItemName, { language: `fi`, value: `Pullo` }, { language: `sv`, value: `Flaska` }, { language: `en`, value: `Bottle` },);
        this.set(this.enumProductUnitCanLanguageItemName, { language: `fi`, value: `Purkki` }, { language: `sv`, value: `Burk` }, { language: `en`, value: `Can` },);
        this.set(this.enumProductUnitBagLanguageItemName, { language: `fi`, value: `Pussi` }, { language: `sv`, value: `Kasse` }, { language: `en`, value: `Bag` },);
        this.set(this.enumProductUnitRollLanguageItemName, { language: `fi`, value: `Rulla` }, { language: `sv`, value: `Rulle` }, { language: `en`, value: `Roll` },);
        this.set(this.enumProductUnitCustomLanguageItemName, { language: `fi`, value: `Mukautettu` }, { language: `sv`, value: `Anpassad` }, { language: `en`, value: `Custom` },);
        this.set(this.sendWorkReportTitleLanguageItemName, { language: `fi`, value: `Lähetä työraportti` }, { language: `sv`, value: `Skicka arbetsraport` }, { language: `en`, value: `Send work report` },);
        this.set(this.sendWorkReportDropdownLabelLanguageItemName, { language: `fi`, value: `Yhteyshenkilö` }, { language: `sv`, value: `Kontakt person` }, { language: `en`, value: `Contact person` },);
        this.set(this.enumPaymentTermsCodeP0LanguageItemName, { language: `fi`, value: `0 pv netto` }, { language: `sv`, value: `0 dagar netto` }, { language: `en`, value: `0 days net` },);
        this.set(this.sendWorkReportDropdownNewContactPersonLanguageItemName, { language: `fi`, value: `Uusi yhteyshenkilö` }, { language: `sv`, value: `Ny kontaktperson` }, { language: `en`, value: `New contact person` },);
        this.set(this.sendWorkReportNewContactPersonLanguageItemName, { language: `fi`, value: `Luo uusi yhteyshenkilö` }, { language: `sv`, value: `Skapa ny kontakt person` }, { language: `en`, value: `Create new contact person` },);
        this.set(this.workHoursWidgetApprovedLanguageItemName, { language: `fi`, value: `Hyväksytty` }, { language: `sv`, value: `Godkänd` }, { language: `en`, value: `Approved` },);
        this.set(this.workHoursWidgetReportedLanguageItemName, { language: `fi`, value: `Ilmoitettu` }, { language: `sv`, value: `Rapporterad` }, { language: `en`, value: `Reported` },);
        this.set(this.workHoursWidgetContractHoursLanguageItemName, { language: `fi`, value: `Urakkatunnit` }, { language: `sv`, value: `Avtalstid` }, { language: `en`, value: `Contract hours` },);
        this.set(this.myWorkHoursLabelLanguageItemName, { language: `fi`, value: `Omat työtunnit` }, { language: `sv`, value: `Mina arbets timmar` }, { language: `en`, value: `My work hours` },);
        this.set(this.enumScaffoldingLoadClassTypeClass2LanguageItemName, { language: `fi`, value: `Luokka 2` }, { language: `sv`, value: `Klass 2` }, { language: `en`, value: `Class 2` },);
        this.set(this.enumScaffoldingLoadClassTypeClass1DescriptionLanguageItemName, { language: `fi`, value: `Luokka 1 (0.75 kN/m2)` }, { language: `sv`, value: `Klass 1 (0.75 kN/m2)` }, { language: `en`, value: `Class 1 (0.75 kN/m2)` },);
        this.set(this.enumScaffoldingLoadClassTypeClass1LanguageItemName, { language: `fi`, value: `Luokka 1` }, { language: `sv`, value: `Klass 1` }, { language: `en`, value: `Class 1` },);
        this.set(this.enumPredefinedDeliveryTaskPackedMaterialTransportLanguageItemName, { language: `fi`, value: `Pakattujen materiaalien kuljetus` }, { language: `sv`, value: `Packad material transport` }, { language: `en`, value: `Packed material transport` },);
        this.set(this.enumInvoiceStateCreatedLanguageItemName, { language: `fi`, value: `Luotu` }, { language: `sv`, value: `Skapad` }, { language: `en`, value: `Created` },);
        this.set(this.workDayPanelPassengersLanguageItemName, { language: `fi`, value: `Matkustajia` }, { language: `sv`, value: `Passagerare` }, { language: `en`, value: `Passengers` },);
        this.set(this.enumPaymentTermsCodeP7LanguageItemName, { language: `fi`, value: `7 pv netto` }, { language: `sv`, value: `7 dagar netto` }, { language: `en`, value: `7 days net` },);
        this.set(this.enumPaymentTermsCodeP60LanguageItemName, { language: `fi`, value: `60 pv netto` }, { language: `sv`, value: `60 dagar netto` }, { language: `en`, value: `60 days net` },);
        this.set(this.enumPaymentTermsCodeP45LanguageItemName, { language: `fi`, value: `45 pv netto` }, { language: `sv`, value: `45 dagar netto` }, { language: `en`, value: `45 days net` },);
        this.set(this.enumPaymentTermsCodeP30LanguageItemName, { language: `fi`, value: `30 pv netto` }, { language: `sv`, value: `30 dagar netto` }, { language: `en`, value: `30 days net` },);
        this.set(this.enumPaymentTermsCodeP21LanguageItemName, { language: `fi`, value: `21 pv netto` }, { language: `sv`, value: `21 dagar netto` }, { language: `en`, value: `21 days net` },);
        this.set(this.enumPaymentTermsCodeP14LanguageItemName, { language: `fi`, value: `14 pv netto` }, { language: `sv`, value: `14 dagar netto` }, { language: `en`, value: `14 days net` },);
        this.set(this.enumConstructionSiteSubContractorTaskStatusWorkReportNotApprovedByCustomerLanguageItemName, { language: `fi`, value: `Työraportti ei ole hyväksytty` }, { language: `sv`, value: `Arbets raport inte godkännd` }, { language: `en`, value: `Work report not approved` },);
        this.set(this.enumConstructionSiteSubContractorTaskStatusWorkReportNotApprovedByCustomerDescriptionLanguageItemName, { language: `fi`, value: `Jotkut työraportit eivät ole hyväksytty asiakkaalta` }, { language: `sv`, value: `Vissa arbets raporter än inte godkända av kunden` }, { language: `en`, value: `Some work reports are not approved by customer` },);
        this.set(this.enumConstructionSiteSubContractorTaskStatusOpenTasksLanguageItemName, { language: `fi`, value: `Avoimet tehtävät` }, { language: `sv`, value: `Öppna uppdrag` }, { language: `en`, value: `Open tasks` },);
        this.set(this.enumConstructionSiteSubContractorTaskStatusOpenTasksDescriptionLanguageItemName, { language: `fi`, value: `Jotkut tehtävistä eivät ole suoritettu` }, { language: `sv`, value: `Vissa uppdrag är inte färdiga` }, { language: `en`, value: `Some tasks are not completed` },);
        this.set(this.enumConstructionSiteSubContractorTaskStatusTaskNotApprovedLanguageItemName, { language: `fi`, value: `Tehtäviä ei ole hyväksytty` }, { language: `sv`, value: `Uppdrag inte godkända` }, { language: `en`, value: `Tasks not approved` },);
        this.set(this.enumConstructionSiteSubContractorTaskStatusTaskNotApprovedDescriptionLanguageItemName, { language: `fi`, value: `Jotkut tehtävistä ei ole hyväksytty esimieheltä` }, { language: `sv`, value: `Vissa uppdrag är inte godkända av montageledare` }, { language: `en`, value: `Some tasks are not approved by manager` },);
        this.set(this.enumConstructionSiteSubContractorTaskStatusWorkReportNotSentDescriptionLanguageItemName, { language: `fi`, value: `Jotkut työraportit ei ole lähetetty asiakkaalle` }, { language: `sv`, value: `Vissa arbets raporter är inte skickade till kunden` }, { language: `en`, value: `Some work reports are not sent to customer` },);
        this.set(this.enumConstructionSiteSubContractorTaskStatusWorkReportNotInvoicedLanguageItemName, { language: `fi`, value: `Työraporttia ei laskutettu` }, { language: `sv`, value: `Arbets raport inte fakturerad` }, { language: `en`, value: `Work reports not invoiced` },);
        this.set(this.enumConstructionSiteSubContractorTaskStatusWorkReportNotInvoicedDescriptionLanguageItemName, { language: `fi`, value: `Jotkut työraportit eivät ole laskuja` }, { language: `sv`, value: `Vissa arbets raporter är inte fakturerade` }, { language: `en`, value: `Some work reports are not invoices` },);
        this.set(this.predefinedTaskGroupMounterLanguageItemName, { language: `fi`, value: `Lisätehtäviä asentajille` }, { language: `sv`, value: `Extra uppdrag för montörer` }, { language: `en`, value: `Extra tasks for mounters` },);
        this.set(this.predefinedTaskGroupDeliveryLanguageItemName, { language: `fi`, value: `Toimitustehtävät` }, { language: `sv`, value: `Leverans uppgift` }, { language: `en`, value: `Delivery tasks` },);
        this.set(this.enumPredefinedExtraTaskAssemblyLanguageItemName, { language: `fi`, value: `Asennus` }, { language: `sv`, value: `Installering` }, { language: `en`, value: `Assembly` },);
        this.set(this.enumPredefinedExtraTaskDismantleLanguageItemName, { language: `fi`, value: `Purku` }, { language: `sv`, value: `Demontera` }, { language: `en`, value: `Dismantle` },);
        this.set(this.enumPredefinedExtraTaskWeatherCoverOpeningLanguageItemName, { language: `fi`, value: `Säänsuojan avaus` }, { language: `sv`, value: `Väderskydds öppning` }, { language: `en`, value: `Weather cover opening` },);
        this.set(this.enumPredefinedExtraTaskExtraWorkLanguageItemName, { language: `fi`, value: `Lisätyö` }, { language: `sv`, value: `Extra arbete` }, { language: `en`, value: `Extra work` },);
        this.set(this.enumPredefinedExtraTaskModificationWorkLanguageItemName, { language: `fi`, value: `Muutostyö` }, { language: `sv`, value: `Modifierings arbete` }, { language: `en`, value: `Modification work` },);
        this.set(this.enumPredefinedExtraTaskRepairWorkLanguageItemName, { language: `fi`, value: `Korjaustyö` }, { language: `sv`, value: `Reparations arbete` }, { language: `en`, value: `Repair work` },);
        this.set(this.enumPredefinedDeliveryTaskDeliveryTransportLanguageItemName, { language: `fi`, value: `Toimituskuljetus` }, { language: `sv`, value: `Leverans transport` }, { language: `en`, value: `Delivery transport` },);
        this.set(this.enumPredefinedDeliveryTaskReturnTransportLanguageItemName, { language: `fi`, value: `Paluukuljetus` }, { language: `sv`, value: `Returnerings transport` }, { language: `en`, value: `Return transport` },);
        this.set(this.enumConstructionSiteSubContractorTaskStatusWorkReportNotSentLanguageItemName, { language: `fi`, value: `Työraportit ei ole lähetetty` }, { language: `sv`, value: `Arbets raporter inte sända` }, { language: `en`, value: `Work reports not sent` },);
        this.set(this.tasksPanelApproveTaskCreateLanguageItemName, { language: `fi`, value: `Hyväksy tehtävä luodaksesi laskurivin` }, { language: `sv`, value: `Godkänn uppdrag för att lägga till fakturerings rad` }, { language: `en`, value: `Approve task to create a invoice row` },);
        this.set(this.salaryHoursPanelOvertimeFiftyLanguageItemName, { language: `fi`, value: `Ylityö 50%` }, { language: `sv`, value: `Övertid 50%` }, { language: `en`, value: `Overtime 50%` },);
        this.set(this.salaryExportModalSendToPayrollLanguageItemName, { language: `fi`, value: `Lähetä palkkalistalle` }, { language: `sv`, value: `Skicka till lönelista` }, { language: `en`, value: `Send to payroll` },);
        this.set(this.salaryHoursPanelNormalHoursLanguageItemName, { language: `fi`, value: `Normaali tunnit` }, { language: `sv`, value: `Normal timmar` }, { language: `en`, value: `Normal hours` },);
        this.set(this.salaryHoursPanelHoursLanguageItemName, { language: `fi`, value: `Tunnit` }, { language: `sv`, value: `Timme` }, { language: `en`, value: `Hours` },);
        this.set(this.salaryHoursPanelTotalLanguageItemName, { language: `fi`, value: `Yhteensä` }, { language: `sv`, value: `Totalt` }, { language: `en`, value: `Total` },);
        this.set(this.workDayPanelAutoHoursLanguageItemName, { language: `fi`, value: `Automaattiset tunnit` }, { language: `sv`, value: `Auto timmar` }, { language: `en`, value: `Auto Hours` },);
        this.set(this.salaryHoursPanelEveningLanguageItemName, { language: `fi`, value: `Ilta` }, { language: `sv`, value: `Kväll` }, { language: `en`, value: `Evening` },);
        this.set(this.addMounterModalAddHoursInfoLanguageItemName, { language: `fi`, value: `Lisää asentajan työtunnit työmaalle tai varastolle` }, { language: `sv`, value: `Lägg till montör arbets timmar för byggplats eller depå` }, { language: `en`, value: `Add mounter working hours for site or warehouse` },);
        this.set(this.tasksPanelSendToCustomerLanguageItemName, { language: `fi`, value: `Lähetä asiakkaalle hyväksyttäväksi` }, { language: `sv`, value: `Skicka till kunden för godkännande` }, { language: `en`, value: `Send to customer for approving` },);
        this.set(this.constructionSitesSitesInfoLanguageItemName, { language: `fi`, value: `Työmaat` }, { language: `sv`, value: `Lista på byggarbetsplatser` }, { language: `en`, value: `Construction sites` },);
        this.set(this.tasksPanelSentToLanguageItemName, { language: `fi`, value: `Lähetä käyttäjälle` }, { language: `sv`, value: `Skicka till` }, { language: `en`, value: `Sent to` },);
        this.set(this.addConstructionsiteProjectNumberLanguageItemName, { language: `fi`, value: `Työnumero` }, { language: `sv`, value: `Projekt nummer` }, { language: `en`, value: `Project number` },);
        this.set(this.tasksPanelRestoreDeletedWorkReportLanguageItemName, { language: `fi`, value: `Palauta poistettu työraportti` }, { language: `sv`, value: `Återställ raderad arbets raport` }, { language: `en`, value: `Restore deleted work report` },);
        this.set(this.tasksPanelDeleteWorkReportLanguageItemName, { language: `fi`, value: `Poista työraportti` }, { language: `sv`, value: `Radera arbets raport` }, { language: `en`, value: `Delete work report` },);
        this.set(this.addMounterModalNoTasksAvailableLanguageItemName, { language: `fi`, value: `Ei tehtäviä saatavilla` }, { language: `sv`, value: `Inga uppdrag tillgängliga` }, { language: `en`, value: `No tasks available` },);
        this.set(this.tasksPanelApproveWorkReportInvoiceLanguageItemName, { language: `fi`, value: `Hyväksy työraportti luodaksesi laskurivin` }, { language: `sv`, value: `Godkänn arbets raport för att skapa faktura rad` }, { language: `en`, value: `Approve work report to create a invoice row` },);
        this.set(this.tasksPanelPreviewWorkReportLanguageItemName, { language: `fi`, value: `Esikatsele työraporttia` }, { language: `sv`, value: `Förhandsgranska arbets raport` }, { language: `en`, value: `Preview work report` },);
        this.set(this.tasksPanelSentAtLanguageItemName, { language: `fi`, value: `Lähetetty` }, { language: `sv`, value: `Skickat` }, { language: `en`, value: `Sent at` },);
        this.set(this.taskHoursPanelMounterLanguageItemName, { language: `fi`, value: `Asentaja` }, { language: `sv`, value: `Montör` }, { language: `en`, value: `Mounter` },);
        this.set(this.constructionSitesSitesLanguageItemName, { language: `fi`, value: `Työmaat` }, { language: `sv`, value: `Byggplatser` }, { language: `en`, value: `Sites` },);
        this.set(this.constructionSitesInvoiceReferenceLanguageItemName, { language: `fi`, value: `Laskuviite` }, { language: `sv`, value: `Fakturerings referens` }, { language: `en`, value: `Invoice reference` },);
        this.set(this.constructionSitesReferenceLanguageItemName, { language: `fi`, value: `Viite` }, { language: `sv`, value: `Referens` }, { language: `en`, value: `Reference` },);
        this.set(this.addConstructionsiteOrganizationLanguageItemName, { language: `fi`, value: `Asiakas` }, { language: `sv`, value: `Organisation` }, { language: `en`, value: `Organization` },);
        this.set(this.tasksPanelDownloadWorkReportLanguageItemName, { language: `fi`, value: `Lataa työraportti` }, { language: `sv`, value: `Ladda ner arbets raport` }, { language: `en`, value: `Download work report` },);
        this.set(this.addMounterModalHoursLanguageItemName, { language: `fi`, value: `Laskutunnit` }, { language: `sv`, value: `Timme` }, { language: `en`, value: `Hours` },);
        this.set(this.checkInsPanelSignInLanguageItemName, { language: `fi`, value: `Kirjautunut` }, { language: `sv`, value: `Loggat in` }, { language: `en`, value: `Sign in at` },);
        this.set(this.checkInsPanelSiteOrWarehouseLanguageItemName, { language: `fi`, value: `Asiakas ja työmaa` }, { language: `sv`, value: `Kund och sajt` }, { language: `en`, value: `Customer and site` },);
        this.set(this.workDayPanelDistanceInfoLanguageItemName, { language: `fi`, value: `Etäisyys laskettu GPS perusteella` }, { language: `sv`, value: `Distans räknat på basen av GPS` }, { language: `en`, value: `Distance calculated based on GPS` },);
        this.set(this.workDayPanelDistanceLanguageItemName, { language: `fi`, value: `Kokonaismatka, km` }, { language: `sv`, value: `Distans, km` }, { language: `en`, value: `Total distance, km` },);
        this.set(this.workDayPanelOwnEquipmentLanguageItemName, { language: `fi`, value: `Omat työkalut` }, { language: `sv`, value: `Egen utrustning` }, { language: `en`, value: `Own equipment` },);
        this.set(this.workDayPanelDailyAllowanceLanguageItemName, { language: `fi`, value: `Korvaukset` }, { language: `sv`, value: `Dagpenning` }, { language: `en`, value: `Daily Allowance` },);
        this.set(this.workDayPanelAggregateDailyAllowanceLanguageItemName, { language: `fi`, value: `Päiväraha` }, { language: `sv`, value: `PL: Daily Allowance` }, { language: `en`, value: `Daily Allowance` },);
        this.set(this.workDayPanelWorkDayLanguageItemName, { language: `fi`, value: `Työpäivä` }, { language: `sv`, value: `Arbets dag` }, { language: `en`, value: `Work Day` },);
        this.set(this.workDayPanelAddNewTaskHoursLanguageItemName, { language: `fi`, value: `Lisää uuden tehtävän tunnit` }, { language: `sv`, value: `Lägg till nya timmar på uppdraget` }, { language: `en`, value: `Add new task hours` },);
        this.set(this.workDayPanelDetailsInfoLanguageItemName, { language: `fi`, value: `Tiedot asentajan kirjautumisesta` }, { language: `sv`, value: `Information om montörens loggning` }, { language: `en`, value: `Information about mounter's check-ins` },);
        this.set(this.workDayPanelDetailsLanguageItemName, { language: `fi`, value: `Tiedot` }, { language: `sv`, value: `Detaljer` }, { language: `en`, value: `Details` },);
        this.set(this.salaryHoursPanelSundayOvertimeLanguageItemName, { language: `fi`, value: `Sunnuntai ylityö` }, { language: `sv`, value: `Söndag övertid` }, { language: `en`, value: `Sunday overtime` },);
        this.set(this.salaryHoursPanelEveningOvertimeLanguageItemName, { language: `fi`, value: `Ilta ylityö` }, { language: `sv`, value: `Kvälls övertid` }, { language: `en`, value: `Evening overtime` },);
        this.set(this.salaryHoursPanelNightLanguageItemName, { language: `fi`, value: `Yö` }, { language: `sv`, value: `Natt` }, { language: `en`, value: `Night` },);
        this.set(this.salaryHoursPanelNightOvertimeLanguageItemName, { language: `fi`, value: `Yö ylityö` }, { language: `sv`, value: `Natt övertid` }, { language: `en`, value: `Night overtime` },);
        this.set(this.salaryHoursPanelMarkAsNormalLanguageItemName, { language: `fi`, value: `Merkitse normaaliksi` }, { language: `sv`, value: `Märka som normal` }, { language: `en`, value: `Mark as normal` },);
        this.set(this.salaryHoursPanelContractHoursLanguageItemName, { language: `fi`, value: `Sopimus tunnit` }, { language: `sv`, value: `Kontrakt timmar` }, { language: `en`, value: `Contract hours` },);
        this.set(this.salaryHoursPanelOvertimeHundredLanguageItemName, { language: `fi`, value: `Ylityö 100%` }, { language: `sv`, value: `Övertid 100%` }, { language: `en`, value: `Overtime 100%` },);
        this.set(this.checkInsPanelTaskLanguageItemName, { language: `fi`, value: `Tehtävä` }, { language: `sv`, value: `Uppgift` }, { language: `en`, value: `Task` },);
        this.set(this.checkInsPanelCheckOutAddressLanguageItemName, { language: `fi`, value: `Uloskirjautumis osoite` }, { language: `sv`, value: `Utloggnings adress` }, { language: `en`, value: `Check out address` },);
        this.set(this.checkInsPanelCheckOutLanguageItemName, { language: `fi`, value: `Tehtävältä ulos kirjautuminen` }, { language: `sv`, value: `Checkat ut kl` }, { language: `en`, value: `Task check out` },);
        this.set(this.checkInsPanelCheckInAddressLanguageItemName, { language: `fi`, value: `Kirjautumis osoite` }, { language: `sv`, value: `Utchecknings adress` }, { language: `en`, value: `Check in address` },);
        this.set(this.addMounterModalAddHoursLanguageItemName, { language: `fi`, value: `Lisää tunnit` }, { language: `sv`, value: `Lägg till timmar` }, { language: `en`, value: `Add hours` },);
        this.set(this.checkInsPanelCheckInLanguageItemName, { language: `fi`, value: `Tehtävälle sisään kirjautuminen` }, { language: `sv`, value: `Loggat in kl` }, { language: `en`, value: `Task check in` },);
        this.set(this.linkExpiredLanguageItemName, { language: `fi`, value: `Linkki vanhentunut` }, { language: `sv`, value: `Länken har gått ut` }, { language: `en`, value: `Link has expired` },);
        this.set(this.linkUsedLanguageItemName, { language: `fi`, value: `Linkki vanhentunut` }, { language: `sv`, value: `Länken har gått ut` }, { language: `en`, value: `Link has expired` },);
        this.set(this.checkInsPanelSignOutLanguageItemName, { language: `fi`, value: `Uloskirjautunut` }, { language: `sv`, value: `Loggat ut kl` }, { language: `en`, value: `Sign out at` },);
        this.set(this.forgotPasswordPageSuccessMessageLanguageItemName, { language: `fi`, value: `Ilmoitus lähetetty, tarkista saapuneet viestit tai sähköpostilaatikko.` }, { language: `sv`, value: `Avisering har skickats, kontrollera dina textmeddelanden eller e-postinkorg.` }, { language: `en`, value: `Notification has been sent. Please check your SMS or mailbox.` },);
        this.set(this.forgotPasswordPageResetButtonLanguageItemName, { language: `fi`, value: `Lähetä` }, { language: `sv`, value: `Skicka` }, { language: `en`, value: `Send` },);
        this.set(this.forgotPasswordPageLoginButtonLanguageItemName, { language: `fi`, value: `Siirry kirjautumiseen` }, { language: `sv`, value: `Gå till inloggning` }, { language: `en`, value: `Go to login` },);
        this.set(this.forgotPasswordPageHelpTextLanguageItemName, { language: `fi`, value: `Ei ongelmaa. Ole hyvä, syötä "käyttäjätunnus" ja lähetämme sinulle ohjeet salasanan asettamiseen.` }, { language: `sv`, value: `Inga problem. Vänligen ange ert "användarnamn" och vi skickar instruktioner på hur ni återställer ert lösenord.` }, { language: `en`, value: `No problem. Please enter your "username" and we will send you instructions on how to reset your password.` },);
        this.set(this.forgotPasswordPageEmailInputLanguageItemName, { language: `fi`, value: `Sähköposti` }, { language: `sv`, value: `Epost` }, { language: `en`, value: `Email` },);
        this.set(this.addConstructionsiteWarehouseLanguageItemName, { language: `fi`, value: `Kustannuspaikka` }, { language: `sv`, value: `Depå` }, { language: `en`, value: `Warehouse` },);
        this.set(this.addConstructionsiteManagerLanguageItemName, { language: `fi`, value: `Työnjohtaja` }, { language: `sv`, value: `Montageledare` }, { language: `en`, value: `Manager` },);
        this.set(this.constructionSitesActivateLanguageItemName, { language: `fi`, value: `Aktivoi` }, { language: `sv`, value: `Aktivera` }, { language: `en`, value: `Activate` },);
        this.set(this.constructionSitesDeactivateLanguageItemName, { language: `fi`, value: `Deaktivoi` }, { language: `sv`, value: `Avaktivera` }, { language: `en`, value: `Deactivate` },);
        this.set(this.addConstructionsiteToolbarAnyTaskStatusLanguageItemName, { language: `fi`, value: `Mikä tahansa tehtävä tila` }, { language: `sv`, value: `Vilken uppdragsstatus som helst` }, { language: `en`, value: `Any task status` },);
        this.set(this.addConstructionsiteToolbarAnyStatusLanguageItemName, { language: `fi`, value: `Mikä tahansa tila` }, { language: `sv`, value: `All status` }, { language: `en`, value: `Any status` },);
        this.set(this.addConstructionsiteToolbarSiteLanguageItemName, { language: `fi`, value: `Työmaa` }, { language: `sv`, value: `Byggplats` }, { language: `en`, value: `Site` },);
        this.set(this.constructionSitesToolbarCustomerLanguageItemName, { language: `fi`, value: `Asiakas` }, { language: `sv`, value: `Kund` }, { language: `en`, value: `Customer` },);
        this.set(this.addConstructionsiteToolbarAllSalesPersonsLanguageItemName, { language: `fi`, value: `Kaikki myyjät` }, { language: `sv`, value: `Alla försäljare` }, { language: `en`, value: `All sales persons` },);
        this.set(this.addConstructionsiteToolbarAllManagersLanguageItemName, { language: `fi`, value: `Kaikki managerit` }, { language: `sv`, value: `Alla montageledare` }, { language: `en`, value: `All managers` },);
        this.set(this.constructionSitesCloseLanguageItemName, { language: `fi`, value: `Sulje` }, { language: `sv`, value: `Stäng` }, { language: `en`, value: `Close` },);
        this.set(this.addConstructionsiteAddSiteLanguageItemName, { language: `fi`, value: `Lisää työmaa` }, { language: `sv`, value: `Lägg till byggplats` }, { language: `en`, value: `Add site` },);
        this.set(this.addConstructionsiteSalesPersonLanguageItemName, { language: `fi`, value: `Myyjä` }, { language: `sv`, value: `Försäljare` }, { language: `en`, value: `Sales person` },);
        this.set(this.addTaskModalAddTaskSubtitleLanguageItemName, { language: `fi`, value: `Lisää uusi tehtävä työmaalle ja määrä työntekijää` }, { language: `sv`, value: `Lägg till uppdrag för byggplats och tilldela montörer` }, { language: `en`, value: `Add new task for construction site and assign mounters` },);
        this.set(this.addConstructionsiteToolbarAnySubTaskStatusLanguageItemName, { language: `fi`, value: `Mikä tahansa aliurakoitsijan tila` }, { language: `sv`, value: `All underleverantör uppdrag status` }, { language: `en`, value: `Any subcontractor task status` },);
        this.set(this.addConstructionsiteToolbarFilterLanguageItemName, { language: `fi`, value: `Suodata` }, { language: `sv`, value: `Filtrera` }, { language: `en`, value: `Filter` },);
        this.set(this.myWorkHoursNoReportedHoursLanguageItemName, { language: `fi`, value: `Ei ilmoitettuja tunteja tälle päivälle` }, { language: `sv`, value: `Inga raporterade timmar för denna dag` }, { language: `en`, value: `No reported hours for this day` },);
        this.set(this.addConstructionsiteToolbarClearFilterLanguageItemName, { language: `fi`, value: `Tyhjennä suodatin` }, { language: `sv`, value: `Töm filter` }, { language: `en`, value: `Clear filter` },);
        this.set(this.genericCustomerNumberLanguageItemName, { language: `fi`, value: `Asiakasnumero` }, { language: `sv`, value: `Kundnummer` }, { language: `en`, value: `Customer number` },);
        this.set(this.constructionSitesStatusLanguageItemName, { language: `fi`, value: `Tila` }, { language: `sv`, value: `Status` }, { language: `en`, value: `Status` },);
        this.set(this.constructionSitePanelActivateConfirmationLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat aktivoida työmaan?` }, { language: `sv`, value: `Är du säker du vill aktivera byggplatsen?` }, { language: `en`, value: `Are you sure that you want to activate this construction site?` },);
        this.set(this.constructionSitePanelDeactivateConfirmationLanguageItemName, { language: `fi`, value: `Oletko varma että haluat poistaa työmaa käytöstä?` }, { language: `sv`, value: `Är du säker du vill deaktivera byggplatsen?` }, { language: `en`, value: `Are you sure that you want to deactivate this construction site?` },);
        this.set(this.myAuditsApprovedAtLanguageItemName, { language: `fi`, value: `Hyväksytty` }, { language: `sv`, value: `Godkännd` }, { language: `en`, value: `Approved at` },);
        this.set(this.myAuditsMyAuditLanguageItemName, { language: `fi`, value: `Minun tarkastukseni` }, { language: `sv`, value: `Mina inspektioner` }, { language: `en`, value: `My audits` },);
        this.set(this.myAuditsNoDataLanguageItemName, { language: `fi`, value: `Tarkastusraporttia ei ole vielä saatu` }, { language: `sv`, value: `Inga inspektionsrapporter mottagna ännu` }, { language: `en`, value: `No audit reports received yet` },);
        this.set(this.myAuditsActionsApproveLanguageItemName, { language: `fi`, value: `Hyväksy tarkastus raporttia` }, { language: `sv`, value: `Godkänn inspektionsrapport` }, { language: `en`, value: `Approve audit report` },);
        this.set(this.myAuditsActionsPreviewLanguageItemName, { language: `fi`, value: `Esikatsele tarkastus raporttia` }, { language: `sv`, value: `Förhandsgranska inspektionsrapporten` }, { language: `en`, value: `Preview audit report` },);
        this.set(this.myAuditsActionsDownloadLanguageItemName, { language: `fi`, value: `Lataa tarkastus raportti` }, { language: `sv`, value: `Ladda ner inspektionsrapport` }, { language: `en`, value: `Download audit report` },);
        this.set(this.myAuditsConfirmationApproveLanguageItemName, { language: `fi`, value: `Haluatko varmasti hyväksyä tarkastusraportin #{0} \"{1}\"` }, { language: `sv`, value: `Är du säker, att du vill godkänna raport #{0} \"{1}\"` }, { language: `en`, value: `Are you sure, you want approve audit report #{0} \"{1}\"` },);
        this.set(this.myAuditsReportPreviewLanguageItemName, { language: `fi`, value: `Tarkastusraportin esikatselu` }, { language: `sv`, value: `Förhandsgranska inspektionsrapporter` }, { language: `en`, value: `Audit report preview` },);
        this.set(this.agreementMinimumRentalDaysLanguageItemName, { language: `fi`, value: `Minimi vuokrapäiviä` }, { language: `sv`, value: `Minsta hyresdagar` }, { language: `en`, value: `Minimum rental days` },);
        this.set(this.agreementModuleNameLanguageItemName, { language: `fi`, value: `Nimi` }, { language: `sv`, value: `Namn` }, { language: `en`, value: `Name` },);
        this.set(this.addAgreementAddAgreementLanguageItemName, { language: `fi`, value: `Lisää sopimus` }, { language: `sv`, value: `Lägg till kontrakt` }, { language: `en`, value: `Add agreement` },);
        this.set(this.addAgreementDescriptionLanguageItemName, { language: `fi`, value: `Kuvaus` }, { language: `sv`, value: `Beskrivning` }, { language: `en`, value: `Description` },);
        this.set(this.addAgreementDropdownLabelLanguageItemName, { language: `fi`, value: `Yhteyshenkilö` }, { language: `sv`, value: `Kontakt person` }, { language: `en`, value: `Contact person` },);
        this.set(this.addAgreementExtraTaskHourlyCostLanguageItemName, { language: `fi`, value: `Oletus tuntihinta` }, { language: `sv`, value: `Standard timpris` }, { language: `en`, value: `Default task hourly price` },);
        this.set(this.addAgreementNewContactPersonLanguageItemName, { language: `fi`, value: `Luo uusi yhteyshenkilö` }, { language: `sv`, value: `Skapa ny kontakt person` }, { language: `en`, value: `Create new contact person` },);
        this.set(this.addAgreementSubtitleLanguageItemName, { language: `fi`, value: `Luo uusi sopimus` }, { language: `sv`, value: `Skapa nytt kontrakt` }, { language: `en`, value: `Create new agreement` },);
        this.set(this.addAgreementTitleLanguageItemName, { language: `fi`, value: `Lisää sopimus` }, { language: `sv`, value: `Lägg till kontrakt` }, { language: `en`, value: `Add agreement` },);
        this.set(this.auditModuleApprovedLanguageItemName, { language: `fi`, value: `Hyväksytty` }, { language: `sv`, value: `Godkänd` }, { language: `en`, value: `Approved` },);
        this.set(this.auditModuleNoAuditLanguageItemName, { language: `fi`, value: `ei tarkastusta` }, { language: `sv`, value: `Ingen granskning` }, { language: `en`, value: `no audit` },);
        this.set(this.auditModuleNotApprovedLanguageItemName, { language: `fi`, value: `Ei hyväksytty` }, { language: `sv`, value: `Ej godkänd` }, { language: `en`, value: `Not approved` },);
        this.set(this.auditModuleNotPassedLanguageItemName, { language: `fi`, value: `Ei läpäisty` }, { language: `sv`, value: `Ej avklarad` }, { language: `en`, value: `Not passed` },);
        this.set(this.auditModulePassedLanguageItemName, { language: `fi`, value: `Läpäisty` }, { language: `sv`, value: `Avklarad` }, { language: `en`, value: `Passed` },);
        this.set(this.auditModuleStartAuditLanguageItemName, { language: `fi`, value: `ALOITA TARKASTUS` }, { language: `sv`, value: `BÖRJA GRANSKNING` }, { language: `en`, value: `START AUDIT` },);
        this.set(this.auditQuestionInputCommentLanguageItemName, { language: `fi`, value: `KOMMENTTI` }, { language: `sv`, value: `KOMMENTAR` }, { language: `en`, value: `COMMENT` },);
        this.set(this.auditQuestionInputCommentRequiredLanguageItemName, { language: `fi`, value: `Kommentti on pakollinen` }, { language: `sv`, value: `Kommentar krävs` }, { language: `en`, value: `Comment is required` },);
        this.set(this.auditQuestionInputInsertCommentLanguageItemName, { language: `fi`, value: `Lisää kommentti tarvittaessa` }, { language: `sv`, value: `Lägg till kommentar vid behov` }, { language: `en`, value: `Insert comment if needed` },);
        this.set(this.auditQuestionInputNeedRepairsLanguageItemName, { language: `fi`, value: `TARVITSEE \nKORJAUSTA` }, { language: `sv`, value: `BEHÖVER \nREPARATION` }, { language: `en`, value: `NEED \nREPAIRS` },);
        this.set(this.auditQuestionInputStepOkLanguageItemName, { language: `fi`, value: `VAIHE OK` }, { language: `sv`, value: `Steg OK` }, { language: `en`, value: `STEP OK` },);
        this.set(this.enumUserRoleGroupSubcontractorsLanguageItemName, { language: `fi`, value: `Aliurakoitsijat` }, { language: `sv`, value: `Underleverantörer` }, { language: `en`, value: `Subcontractors` },);
        this.set(this.genericCostPoolLanguageItemName, { language: `fi`, value: `Kustannuspaikka` }, { language: `sv`, value: `Kostnadspool` }, { language: `en`, value: `Cost pool` },);
        this.set(this.genericDetailsLanguageItemName, { language: `fi`, value: `Tiedot` }, { language: `sv`, value: `Detaljer` }, { language: `en`, value: `Details` },);
        this.set(this.genericNameLanguageItemName, { language: `fi`, value: `Nimi` }, { language: `sv`, value: `Namn` }, { language: `en`, value: `Name` },);
        this.set(this.genericTaskLanguageItemName, { language: `fi`, value: `Tehtävä` }, { language: `sv`, value: `Uppgift` }, { language: `en`, value: `Task` },);
        this.set(this.genericWarehouseLanguageItemName, { language: `fi`, value: `Varasto` }, { language: `sv`, value: `Depå` }, { language: `en`, value: `Warehouse` },);
        this.set(this.genericTasksLanguageItemName, { language: `fi`, value: `Tehtävät` }, { language: `sv`, value: `Uppgifter` }, { language: `en`, value: `Tasks` },);
        this.set(this.genericVatIdLanguageItemName, { language: `fi`, value: `Y-tunnus` }, { language: `sv`, value: `FO-nummer` }, { language: `en`, value: `Business ID` },);
        this.set(this.gridNoDataSubcontractorsLanguageItemName, { language: `fi`, value: `Ei aliurakoitsijoita` }, { language: `sv`, value: `Inga underleverantörer` }, { language: `en`, value: `No subcontractors` },);
        this.set(this.invoiceExportModalDownloadFileLanguageItemName, { language: `fi`, value: `Lataa tiedosto` }, { language: `sv`, value: `Ladda ner fil` }, { language: `en`, value: `Download file` },);
        this.set(this.invoiceExportModalSendToPageroLanguageItemName, { language: `fi`, value: `Lähetä Pageroon` }, { language: `sv`, value: `Skicka till Pagero` }, { language: `en`, value: `Send To Pagero` },);
        this.set(this.workDayPanelToolbarAddMounterLanguageItemName, { language: `fi`, value: `Lisää työntekijä` }, { language: `sv`, value: `Lägg till montör` }, { language: `en`, value: `Add mounter` },);
        this.set(this.invoicesDownloadInvoiceLanguageItemName, { language: `fi`, value: `Lataa lasku` }, { language: `sv`, value: `Ladda ner faktura` }, { language: `en`, value: `Download Invoice` },);
        this.set(this.invoicesStateLanguageItemName, { language: `fi`, value: `Tila` }, { language: `sv`, value: `Status` }, { language: `en`, value: `State` },);
        this.set(this.invoicesDueTitleLanguageItemName, { language: `fi`, value: `Päivä, jonka aikana maksu on suoritettava viimeistään (Maksupäivä 0 Netto)` }, { language: `sv`, value: `Datum då betalningen måste göras senast (betalningsdatum 0 netto)` }, { language: `en`, value: `The date during which the payment must be made at the latest (Payment Date 0 Net)` },);
        this.set(this.invoicesDueLanguageItemName, { language: `fi`, value: `Eräpäivä` }, { language: `sv`, value: `förfallodag` }, { language: `en`, value: `Due` },);
        this.set(this.invoicesNetLanguageItemName, { language: `fi`, value: `Maksuehto` }, { language: `sv`, value: `Netto` }, { language: `en`, value: `Net` },);
        this.set(this.subContractorsSubcontractorLanguageItemName, { language: `fi`, value: `Aliurakoitsija` }, { language: `sv`, value: `Underleverantör` }, { language: `en`, value: `Subcontractor` },);
        this.set(this.invoicesEntryTitleLanguageItemName, { language: `fi`, value: `Päivämäärä, jolloin maksu on siirrettävä asiakkaalle, laskutusjakson viimeinen päivä` }, { language: `sv`, value: `Datumbetalningen ska överföras till en kund, sista faktureringsperiodens dag` }, { language: `en`, value: `The date payment should be transferred to a customer, last day of invoicing period` },);
        this.set(this.invoicesEntryLanguageItemName, { language: `fi`, value: `Kirjaus` }, { language: `sv`, value: `Anteckning` }, { language: `en`, value: `Entry` },);
        this.set(this.invoicesCreatedAtLanguageItemName, { language: `fi`, value: `Luotu` }, { language: `sv`, value: `Skapad` }, { language: `en`, value: `Created at` },);
        this.set(this.genericNameAndProjectLanguageItemName, { language: `fi`, value: `Nimi ja projekti numero` }, { language: `sv`, value: `Namn och projekt nummer` }, { language: `en`, value: `Name and project number` },);
        this.set(this.invoicesInvoiceCommentLanguageItemName, { language: `fi`, value: `Lasku kommentti asiakkaalle` }, { language: `sv`, value: `Faktura kommentar för kund` }, { language: `en`, value: `Invoice comment for customer` },);
        this.set(this.invoicesReferenceLanguageItemName, { language: `fi`, value: `Viite` }, { language: `sv`, value: `Referens` }, { language: `en`, value: `Reference` },);
        this.set(this.invoicesInformationInvoiceRowsLanguageItemName, { language: `fi`, value: `Informaatio lasku rivistä` }, { language: `sv`, value: `Information gällande faktura raderna` }, { language: `en`, value: `Information about invoice rows` },);
        this.set(this.invoiceToolbarExportPageroFormatSubTitleLanguageItemName, { language: `fi`, value: `Kaikki 'Hyväksytyt', mutta ei laskutettu` }, { language: `sv`, value: `Alla 'Godkända' men inte sända räkningar` }, { language: `en`, value: `All 'Approved', but not billed invoices` },);
        this.set(this.tasksPanelAddTaskTitleLanguageItemName, { language: `fi`, value: `Lisää tehtävä` }, { language: `sv`, value: `Lägg till uppdrag` }, { language: `en`, value: `Add task` },);
        this.set(this.tasksPanelAddWorkReportTitleLanguageItemName, { language: `fi`, value: `Lisää työraportti` }, { language: `sv`, value: `Lägg till arbets raport` }, { language: `en`, value: `Add work report` },);
        this.set(this.invoicesNavLanguageItemName, { language: `fi`, value: `NAV` }, { language: `sv`, value: `NAV` }, { language: `en`, value: `NAV` },);
        this.set(this.invoiceToolbarExportPageroFormatLanguageItemName, { language: `fi`, value: `Vie laskut Pageroon` }, { language: `sv`, value: `Exportera fakturor till Pagero` }, { language: `en`, value: `Export invoices to Pagero (F-Invoice)` },);
        this.set(this.invoicesPreviewInvoiceLanguageItemName, { language: `fi`, value: `Esikatsele työ- ja kustannusraporttia` }, { language: `sv`, value: `Förhandsgranska Arbets- och Kostnadsrapport` }, { language: `en`, value: `Preview work and cost report` },);
        this.set(this.invoicesSendToPageroLanguageItemName, { language: `fi`, value: `Lähetä Pagerolle` }, { language: `sv`, value: `Skicka till Pagero` }, { language: `en`, value: `Send to Pagero` },);
        this.set(this.warehousesPageTitleLanguageItemName, { language: `fi`, value: `Varastot` }, { language: `sv`, value: `Depå` }, { language: `en`, value: `Warehouses` },);
        this.set(this.warehousePanelPanelTitleLanguageItemName, { language: `fi`, value: `Varaston tiedot` }, { language: `sv`, value: `Depå detaljer` }, { language: `en`, value: `Warehouse details` },);
        this.set(this.warehousesExternalIdLanguageItemName, { language: `fi`, value: `Varastonumero` }, { language: `sv`, value: `Depå nummer` }, { language: `en`, value: `Warehouse number` },);
        this.set(this.roleNameSubcontractorManagerLanguageItemName, { language: `fi`, value: `Työnjohtaja` }, { language: `sv`, value: `Montageledare` }, { language: `en`, value: `Manager` },);
        this.set(this.roleNameSubcontractorMounterLanguageItemName, { language: `fi`, value: `Asentaja` }, { language: `sv`, value: `Montör` }, { language: `en`, value: `Mounter` },);
        this.set(this.roleNameSubcontractorHeadMounterLanguageItemName, { language: `fi`, value: `Työmaavastaava` }, { language: `sv`, value: `Huvud montör` }, { language: `en`, value: `Head mounter` },);
        this.set(this.myWorkReportNoDataLanguageItemName, { language: `fi`, value: `Työraporttia ei ole vielä saatu` }, { language: `sv`, value: `Inga arbets raporter mottagna ännu` }, { language: `en`, value: `No work reports received yet` },);
        this.set(this.myWorkReportMyReportLanguageItemName, { language: `fi`, value: `Minun Työraporttini` }, { language: `sv`, value: `Mina arbets raporter` }, { language: `en`, value: `My Work Reports` },);
        this.set(this.myWorkReportDeclineWorkReportLanguageItemName, { language: `fi`, value: `Hylkää työraportit (palauta takaisin esimiehelle)` }, { language: `sv`, value: `Avvisa arbetsrapporten till (skicka tillbaka till montageledaren)` }, { language: `en`, value: `Decline work report to (return back to manager)` },);
        this.set(this.myWorkReportApprovedAtLanguageItemName, { language: `fi`, value: `Hyväksytty` }, { language: `sv`, value: `Godkännd` }, { language: `en`, value: `Approved at` },);
        this.set(this.myInvoicesMyInvoicesLanguageItemName, { language: `fi`, value: `Minun laskuni` }, { language: `sv`, value: `Mina fakturor` }, { language: `en`, value: `My Invoices` },);
        this.set(this.myWorkReportsConfirmationApproveLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat hyväksyä työraportin {0}?` }, { language: `sv`, value: `Är du säker, vill du godkänna arbetsrapport {0}?` }, { language: `en`, value: `Are you sure, you want approve work report {0}?` },);
        this.set(this.myWorkReportsConfirmationDeclineLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat hylätä työraportin {0}?` }, { language: `sv`, value: `Är du säker, du vill ha nedgångsarbetsrapport {0}?` }, { language: `en`, value: `Are you sure, you want decline work report {0}?` },);
        this.set(this.invoicesListOfInvoicesLanguageItemName, { language: `fi`, value: `Lista laskuista ja laskujen tiloista` }, { language: `sv`, value: `Lista på fakturor och faktura status` }, { language: `en`, value: `List of invoices and invoice states` },);
        this.set(this.invoicesInvoicesLanguageItemName, { language: `fi`, value: `Laskut` }, { language: `sv`, value: `Fakturor` }, { language: `en`, value: `Invoices` },);
        this.set(this.invoicesCancelInvoiceLanguageItemName, { language: `fi`, value: `Peruuta lasku (luo luottolasku)` }, { language: `sv`, value: `Avbryt faktura (skapa kredit faktura)` }, { language: `en`, value: `Cancel invoice (create credit invoice)` },);
        this.set(this.invoicesDeleteCreditInvoiceConfirmationLanguageItemName, { language: `fi`, value: `Haluatko varmasti\npoistaa hyvityslaskun \n<mark>#{0}</mark> summalle <mark>{1:C}€</mark>\nasiakkaalle\n'<mark>{2}</mark>'?` }, { language: `sv`, value: `Är du säker på att du vill ta bort kreditfaktura \n <mark>#{0} </mark> på <mark> {1:c} € </mark> \nfor kund \n '<mark> {2} </mark> '?` }, { language: `en`, value: `Are you sure\nyou want delete credit invoice\n<mark>#{0}</mark> on <mark>{1:C}€</mark>\nfor customer\n'<mark>{2}</mark>'?` },);
        this.set(this.workDayPanelToolbarExportRowInfoLanguageItemName, { language: `fi`, value: `Olet lähettämässä {0} riviä {1} työntekijälle` }, { language: `sv`, value: `Du skickar {0} rader till {1} anställda` }, { language: `en`, value: `You are going to export {0} rows for {1} employees` },);
        this.set(this.invoiceToolbarExportNavisionFormatSubTitleLanguageItemName, { language: `fi`, value: `Kaikki 'Lähetetyt, mutta ei viedyt laskut` }, { language: `sv`, value: `Alla 'Sända' men inte exporterade fakturor` }, { language: `en`, value: `All 'Sent', but not exported invoices` },);
        this.set(this.invoiceToolbarExportNavisionFormatLanguageItemName, { language: `fi`, value: `Lataa laskut Navision formaatissa` }, { language: `sv`, value: `Exportera faktura i Navision format` }, { language: `en`, value: `Export invoices in Navision format` },);
        this.set(this.invoiceToolbarPageroLanguageItemName, { language: `fi`, value: `Pageroon` }, { language: `sv`, value: `Pagero` }, { language: `en`, value: `Pagero` },);
        this.set(this.invoiceToolbarExportToPageroLanguageItemName, { language: `fi`, value: `Vie Pageroon` }, { language: `sv`, value: `Exportera till Pagero` }, { language: `en`, value: `Export to Pagero` },);
        this.set(this.workDayPanelToolbarAnySalaryHoursSubTextLanguageItemName, { language: `fi`, value: `Kaikki tunnit` }, { language: `sv`, value: `Alla arbets timmar` }, { language: `en`, value: `Any salary hours, not approved, approved, exported` },);
        this.set(this.workDayPanelToolbarApprovedByManagerLanguageItemName, { language: `fi`, value: `Esimiehen hyväksymät` }, { language: `sv`, value: `Godkända av montageledare` }, { language: `en`, value: `Approved by manager` },);
        this.set(this.workDayPanelToolbarApprovedByDirectorLanguageItemName, { language: `fi`, value: `Johtajan hyväksymät` }, { language: `sv`, value: `Godkända av direktören` }, { language: `en`, value: `Approved by director` },);
        this.set(this.workDayPanelToolbarApprovedByDirectorSubTextLanguageItemName, { language: `fi`, value: `Esimiehen ja johtajan hyväksymät` }, { language: `sv`, value: `Godkända av montageledare och direktör` }, { language: `en`, value: `Approved by manager and director (exportable)` },);
        this.set(this.workDayPanelToolbarNotApprovedByManagerLanguageItemName, { language: `fi`, value: `Työnjohtaja ei ole hyväksynyt` }, { language: `sv`, value: `Inte godkända av montageledare` }, { language: `en`, value: `Not approved by manager` },);
        this.set(this.workDayPanelToolbarNotApprovedByManagerSubTextLanguageItemName, { language: `fi`, value: `Hyväksyntä puuttuu` }, { language: `sv`, value: `Inte godkända` }, { language: `en`, value: `Not approved by manager and director (not approved at all)` },);
        this.set(this.workDayPanelToolbarNotApprovedByDirectorLanguageItemName, { language: `fi`, value: `Johtaja ei ole hyväksynyt` }, { language: `sv`, value: `Inte godkända av direktör` }, { language: `en`, value: `Not approved by director` },);
        this.set(this.workDayPanelToolbarNotApprovedByDirectorSubTextLanguageItemName, { language: `fi`, value: `Hyväksyntä puuttuu` }, { language: `sv`, value: `Godkända endast av montageledare` }, { language: `en`, value: `Approved by manager only, not approved by director` },);
        this.set(this.workDayPanelToolbarReportTypeLanguageItemName, { language: `fi`, value: `Näytä:` }, { language: `sv`, value: `Raport typ:` }, { language: `en`, value: `Report type:` },);
        this.set(this.workDayPanelToolbarSourceLanguageItemName, { language: `fi`, value: `Työmaa/Varasto` }, { language: `sv`, value: `Byggplats/Depå` }, { language: `en`, value: `Construction site/Warehouse` },);
        this.set(this.workDayPanelToolbarApproveLanguageItemName, { language: `fi`, value: `Tila:` }, { language: `sv`, value: `Godkänn:` }, { language: `en`, value: `Approve:` },);
        this.set(this.workDayPanelToolbarDateLanguageItemName, { language: `fi`, value: `Päivämäärä:` }, { language: `sv`, value: `Datum:` }, { language: `en`, value: `Date:` },);
        this.set(this.workDayPanelToolbarSearchLanguageItemName, { language: `fi`, value: `Etsi` }, { language: `sv`, value: `Sök` }, { language: `en`, value: `Search` },);
        this.set(this.workDayPanelToolbarExportMepcoLanguageItemName, { language: `fi`, value: `Tallenna Mepco -tiedosto` }, { language: `sv`, value: `Exportera i Mepco format(.csv)` }, { language: `en`, value: `Export salary file in Mepco format (.csv)` },);
        this.set(this.workDayPanelToolbarAnySalaryHoursLanguageItemName, { language: `fi`, value: `Kaikki` }, { language: `sv`, value: `Alla` }, { language: `en`, value: `Any salary hours` },);
        this.set(this.workDayPanelToolbarAssignedWarehousesLanguageItemName, { language: `fi`, value: `Tunnit varastoilta` }, { language: `sv`, value: `Timmar från depå` }, { language: `en`, value: `Assigned warehouses` },);
        this.set(this.workDayPanelToolbarConstructionSitesInfoSubTextLanguageItemName, { language: `fi`, value: `Tunnit työmailta` }, { language: `sv`, value: `Timmar från Byggplatser` }, { language: `en`, value: `Active and assigned construction sites` },);
        this.set(this.workDayPanelToolbarExportMepcoSubTextLanguageItemName, { language: `fi`, value: `Valittuna johtajan hyväksymät rivit` }, { language: `sv`, value: `Välj rader godkända av Montageledaren` }, { language: `en`, value: `Choose rows with state 'Approved by director' to export` },);
        this.set(this.workDayPanelToolbarAnySubTextLanguageItemName, { language: `fi`, value: `Tunnit varastoista ja työmailta` }, { language: `sv`, value: `Timmar från depå och byggplatser` }, { language: `en`, value: `Any construction sites or warehouse` },);
        this.set(this.invoiceToolbarNavisionTitleLanguageItemName, { language: `fi`, value: `Vie Microsoft Dynamics NAV formaattiin` }, { language: `sv`, value: `Exportera till Microsoft Dynamics NAV format` }, { language: `en`, value: `Export to Microsoft Dynamics NAV format` },);
        this.set(this.invoiceToolbarNavisionLanguageItemName, { language: `fi`, value: `Navision` }, { language: `sv`, value: `Navision` }, { language: `en`, value: `Navision` },);
        this.set(this.invoiceToolbarConstructionSiteNameOrNumberLanguageItemName, { language: `fi`, value: `Työmaan nimi tai numero` }, { language: `sv`, value: `Byggarbetsplatsens namn eller nummer` }, { language: `en`, value: `Construction site name or number` },);
        this.set(this.invoiceToolbarCustomerNameOrNumberLanguageItemName, { language: `fi`, value: `Asiakkaan nimi tai numero` }, { language: `sv`, value: `Kunds namn eller nummer` }, { language: `en`, value: `Customer name or number` },);
        this.set(this.invoiceToolbarInvoiceTitleLanguageItemName, { language: `fi`, value: `Laskunumero, koodi tai referenssi` }, { language: `sv`, value: `Faktura nummer, kod eller referens` }, { language: `en`, value: `Invoice number, code or reference` },);
        this.set(this.invoiceToolbarInvoiceLanguageItemName, { language: `fi`, value: `Lasku` }, { language: `sv`, value: `Faktura` }, { language: `en`, value: `Invoice` },);
        this.set(this.invoiceToolbarAnyStateLanguageItemName, { language: `fi`, value: `Mikä tahansa tila` }, { language: `sv`, value: `Alla tillstånd` }, { language: `en`, value: `Any state` },);
        this.set(this.workDayPanelAllowanceLanguageItemName, { language: `fi`, value: `Päiväraha` }, { language: `sv`, value: `Dagpenning` }, { language: `en`, value: `Allowance` },);
        this.set(this.workDayPanelEquipmentLanguageItemName, { language: `fi`, value: `Työkalut` }, { language: `sv`, value: `Verktyg` }, { language: `en`, value: `Equipment` },);
        this.set(this.workDayPanelToolbarDailyHoursLanguageItemName, { language: `fi`, value: `Päivittäiset tunnit` }, { language: `sv`, value: `Dagliga timmar` }, { language: `en`, value: `Daily hours` },);
        this.set(this.workDayPanelToolbarDailyHoursSubTextLanguageItemName, { language: `fi`, value: `Päiväkohtaiset tiedot tunneista.` }, { language: `sv`, value: `Daglig information gällande arbetstagares timmar.` }, { language: `en`, value: `Employees hours per day, construction site & task.` },);
        this.set(this.workDayPanelToolbarMonthsLanguageItemName, { language: `fi`, value: `Kuukaudet` }, { language: `sv`, value: `Månader` }, { language: `en`, value: `Months` },);
        this.set(this.tasksPanelConfirmationExtraModuleLanguageItemName, { language: `fi`, value: `Oletko varma että haluat luoda extra moduuli?` }, { language: `sv`, value: `Är du säker att du vill skapa extra modul för denna uppgift?` }, { language: `en`, value: `Are you sure that you want to create extra module for this task?` },);
        this.set(this.tasksPanelExtraModuleCreatedLanguageItemName, { language: `fi`, value: `Extra moduuli on onnistuneesti luotu` }, { language: `sv`, value: `Extra moduler har skapats` }, { language: `en`, value: `Extra module has been successfully created` },);
        this.set(this.formInputContractSalaryHourlyPriceLanguageItemName, { language: `fi`, value: `Sopimuspalkan tuntihinta` }, { language: `sv`, value: `Kontrakt lön timpris` }, { language: `en`, value: `Contract salary hourly price` },);
        this.set(this.formInputWorkCardIdLanguageItemName, { language: `fi`, value: `Valttikorti-id` }, { language: `sv`, value: `Arbetskorts-id` }, { language: `en`, value: `Work card id` },);
        this.set(this.formInputCostPoolLanguageItemName, { language: `fi`, value: `Kustannuspaikka` }, { language: `sv`, value: `Kostnadspool` }, { language: `en`, value: `Cost pool` },);
        this.set(this.workDayPanelToolbarPeriodsLanguageItemName, { language: `fi`, value: `Palkkakaudet` }, { language: `sv`, value: `Löne perioder` }, { language: `en`, value: `Periods` },);
        this.set(this.workDayPanelToolbarInvoicePeriodsLanguageItemName, { language: `fi`, value: `Laskutusjaksot` }, { language: `sv`, value: `Fakturaperioder` }, { language: `en`, value: `Invoice periods` },);
        this.set(this.workDayPanelToolbarSalaryPeriodsLanguageItemName, { language: `fi`, value: `Palkkajaksot` }, { language: `sv`, value: `Löner` }, { language: `en`, value: `Salary periods` },);
        this.set(this.workDayPanelToolbarAnyLanguageItemName, { language: `fi`, value: `Kummatkin` }, { language: `sv`, value: `Alla` }, { language: `en`, value: `Any` },);
        this.set(this.workDayPanelToolbarExportTikonLanguageItemName, { language: `fi`, value: `Tallenna Mepco -tiedosto` }, { language: `sv`, value: `Exportera löne fil i Mepco format (.csv)` }, { language: `en`, value: `Export salary file in Mepco format (.csv)` },);
        this.set(this.subContractorsAddSubcontractorLanguageItemName, { language: `fi`, value: `Lisää aliurakoitsija` }, { language: `sv`, value: `Lägg till underleverantörer` }, { language: `en`, value: `Add subcontractor` },);
        this.set(this.subContractorsTitleLanguageItemName, { language: `fi`, value: `Aliurakoitsijat` }, { language: `sv`, value: `Underleverantörer` }, { language: `en`, value: `Subcontractors` },);
        this.set(this.subContractorsAddNewSubcontractorLanguageItemName, { language: `fi`, value: `Luo uusi aliurakoitsija` }, { language: `sv`, value: `Skapa ny underleverantör` }, { language: `en`, value: `Create new subcontractor` },);
        this.set(this.subcontractorCreatedFlyoutLanguageItemName, { language: `fi`, value: `Aliurakoitsija {0} luotu onnistuneesti.` }, { language: `sv`, value: `Underleverantör {0} skapas framgångsrikt.` }, { language: `en`, value: `Subcontractor {0} successfully created.` },);
        this.set(this.subcontractorPanelSubcontractorAddedFlyoutLanguageItemName, { language: `fi`, value: `Aliurakoitsija {0} luotu onnistuneesti.` }, { language: `sv`, value: `Underleverantör {0} skapas framgångsrikt (läggs till en webbplats).` }, { language: `en`, value: `Subcontractor {0} successfully created (added to a site).` },);
        this.set(this.subcontractorPanelSubcontractorRestoredFlyoutLanguageItemName, { language: `fi`, value: `Aliurakoitsija {0} palautettu onnistuneesti.` }, { language: `sv`, value: `Underleverantör {0} återställdes framgångsrikt (underleverantör markerades som raderades).` }, { language: `en`, value: `Subcontractor {0} restored successfully (subcontractor was marked as deleted).` },);
        this.set(this.tasksMountersLanguageItemName, { language: `fi`, value: `Asentajat` }, { language: `sv`, value: `Montörer` }, { language: `en`, value: `Mounters` },);
        this.set(this.tasksTypeLanguageItemName, { language: `fi`, value: `Tyyppi` }, { language: `sv`, value: `Typ` }, { language: `en`, value: `Type` },);
        this.set(this.tasksNameLanguageItemName, { language: `fi`, value: `Nimi` }, { language: `sv`, value: `Namn` }, { language: `en`, value: `Name` },);
        this.set(this.tasksStartLanguageItemName, { language: `fi`, value: `Alku` }, { language: `sv`, value: `Starta` }, { language: `en`, value: `Start` },);
        this.set(this.tasksDoneLanguageItemName, { language: `fi`, value: `Valmis` }, { language: `sv`, value: `Färdig` }, { language: `en`, value: `Done` },);
        this.set(this.tasksHoursLanguageItemName, { language: `fi`, value: `Tunnit` }, { language: `sv`, value: `Timmar` }, { language: `en`, value: `Hours` },);
        this.set(this.tasksExtraHoursLanguageItemName, { language: `fi`, value: `Lisätunnit` }, { language: `sv`, value: `Extra \n timmar` }, { language: `en`, value: `Extra hours` },);
        this.set(this.tasksDateLanguageItemName, { language: `fi`, value: `Päivämäärä` }, { language: `sv`, value: `Datum` }, { language: `en`, value: `Date` },);
        this.set(this.tasksToolbarSearchLanguageItemName, { language: `fi`, value: `Etsi` }, { language: `sv`, value: `Sök` }, { language: `en`, value: `Search` },);
        this.set(this.tasksToolbarDateLanguageItemName, { language: `fi`, value: `Päivämäärä:` }, { language: `sv`, value: `Datum:` }, { language: `en`, value: `Date:` },);
        this.set(this.tasksToolbarClearFiltersLanguageItemName, { language: `fi`, value: `Tyhjennä suodattimet` }, { language: `sv`, value: `Töm filters` }, { language: `en`, value: `Clear filters` },);
        this.set(this.componentSignatureWidgetClearLanguageItemName, { language: `fi`, value: `Tyhjennä` }, { language: `sv`, value: `Töm` }, { language: `en`, value: `Clear` },);
        this.set(this.componentSignatureWidgetDoneLanguageItemName, { language: `fi`, value: `Valmis` }, { language: `sv`, value: `Färdig` }, { language: `en`, value: `Done` },);
        this.set(this.componentModalSaveChangesLanguageItemName, { language: `fi`, value: `Tallenna muutokset` }, { language: `sv`, value: `Spara ändringar` }, { language: `en`, value: `Save changes` },);
        this.set(this.componentModalCloseLanguageItemName, { language: `fi`, value: `Sulje` }, { language: `sv`, value: `Stäng` }, { language: `en`, value: `Close` },);
        this.set(this.componentPageContainerPageHelpLanguageItemName, { language: `fi`, value: `Sivun ohje` }, { language: `sv`, value: `Sidhjälp` }, { language: `en`, value: `Page help` },);
        this.set(this.subcontractorWorkDayPanelSubcontractorsLanguageItemName, { language: `fi`, value: `Aliurakoitsijat` }, { language: `sv`, value: `Underleverantörer` }, { language: `en`, value: `Subcontractors` },);
        this.set(this.subcontractorWorkDayPanelManagersLanguageItemName, { language: `fi`, value: `Työnjohtajat` }, { language: `sv`, value: `Montageledarna` }, { language: `en`, value: `Managers` },);
        this.set(this.subcontractorWorkDayPanelMountersLanguageItemName, { language: `fi`, value: `Asentajat` }, { language: `sv`, value: `Montörer` }, { language: `en`, value: `Mounters` },);
        this.set(this.userManagementUserDeletedLanguageItemName, { language: `fi`, value: `Käyttäjä {0} poistettu.` }, { language: `sv`, value: `Användarkonto {0} raderas framgångsrikt.` }, { language: `en`, value: `User account {0} deleted successfully.` },);
        this.set(this.userManagementUserDeletedPermanentlyLanguageItemName, { language: `fi`, value: `Käyttäjätili "{0}" poistettu pysyvästi.` }, { language: `sv`, value: `Användarkonto "{0}" raderades permanent.` }, { language: `en`, value: `User account "{0}" was permanently deleted.` },);
        this.set(this.userManagementButtonRestoreLanguageItemName, { language: `fi`, value: `Palauta` }, { language: `sv`, value: `Återställ` }, { language: `en`, value: `Restore` },);
        this.set(this.userManagementButtonDeleteLanguageItemName, { language: `fi`, value: `Poista` }, { language: `sv`, value: `Radera` }, { language: `en`, value: `Delete` },);
        this.set(this.userManagementButtonUnlockLanguageItemName, { language: `fi`, value: `Avaa lukitus` }, { language: `sv`, value: `Låsa upp` }, { language: `en`, value: `Unlock` },);
        this.set(this.dashboardCreateTaskDescriptionLanguageItemName, { language: `fi`, value: `Luo uusi tehtävä` }, { language: `sv`, value: `Skapa en ny uppgift` }, { language: `en`, value: `Create a new task` },);
        this.set(this.dashboardCreateTaskForCurrentSiteDescriptionLanguageItemName, { language: `fi`, value: `Luo uusi tehtävä tälle työmaalle` }, { language: `sv`, value: `Skapa en nytt uppdrag för den nuvarande byggarbetsplatsen` }, { language: `en`, value: `Create a new task for current construction site` },);
        this.set(this.dashboardSelectTaskLanguageItemName, { language: `fi`, value: `Valitse tehtävä` }, { language: `sv`, value: `Välj en uppgift` }, { language: `en`, value: `Select a task` },);
        this.set(this.dashboardSwitchTaskLanguageItemName, { language: `fi`, value: `Vaihda tehtävä` }, { language: `sv`, value: `Byteuppgift` }, { language: `en`, value: `Switch task` },);
        this.set(this.dashboardSwitchTaskDescriptionLanguageItemName, { language: `fi`, value: `Lopeta nykyinen, ja siirry seuraavaan tehtävään` }, { language: `sv`, value: `Stäng strömmen och växla till nästa uppgift` }, { language: `en`, value: `Close current and switch to next task` },);
        this.set(this.rentaTasksDashboardGetManualLanguageItemName, { language: `fi`, value: `Tervetuloa Renta Task etusivulle. Aloittaaksesi työpäivän, paina Kirjaudu sisään -painiketta.\n\nSisäänkirjautumisen jälkeen voit vaihtaa työmaata tai tehtävää työpäivän aikana.\n\nTyöpäiväsi päätyttyä, paina Kirjaudu ulos painiketta.` }, { language: `sv`, value: `Välkommen till Renta Tasks-instrumentpanelen, tryck in inloggning för att starta din arbetsdag.\n\nEfter inloggning kan du ändra byggplats eller hämta ett nytt uppdrag från samma sida.\n\nNär din arbetsdag är klar trycker du logga ut för att starta utloggning.` }, { language: `en`, value: `Welcome to Renta Tasks dashboard, press Sign-in to start Your workday.\n\nAfter successful login You can change construction site or pickup a new task from the same page.\n\nWhen your workday is finished press Sign-out to start checkout process.` },);
        this.set(this.selectTaskDropdownTaskLabelLanguageItemName, { language: `fi`, value: `Tehtävän` }, { language: `sv`, value: `Uppgift` }, { language: `en`, value: `Task` },);
        this.set(this.selectTaskDropdownTaskDescriptionLanguageItemName, { language: `fi`, value: `Paina valitaksesi tehtävä` }, { language: `sv`, value: `Tryck på för att välja uppgift` }, { language: `en`, value: `Press to select task` },);
        this.set(this.selectTaskGetManualLanguageItemName, { language: `fi`, value: `Valitse tehtävä jota käyt suorittamaan painamalla Tehtävä painiketta` }, { language: `sv`, value: `Välj en uppgift du ska arbeta med från rullgardinsmenyn genom att trycka på Task Widget` }, { language: `en`, value: `Select a task You are going to work on from dropdown menu by pressing on Task widget` },);
        this.set(this.selectTaskFetchTasksErrorLanguageItemName, { language: `fi`, value: `Työmaalla ei ole yhtään aktiivista tehtävää, voit kuitenkin kirjautua työmaalle ilman tehtävä valintaa.\nPyyhkäise oikealle kirjautuaksesi työmaalle.` }, { language: `sv`, value: `Inga uppgifter tillgängliga för vald webbplats. \ndu kan logga in utan val av uppgifter. \nswipe till höger till inloggning.` }, { language: `en`, value: `No tasks available for selected site.\nYou can sign-in without task selection.\nSwipe to right to sign-in.` },);
        this.set(this.selectOrganizationDropdownOrganizationLabelLanguageItemName, { language: `fi`, value: `Asiakas` }, { language: `sv`, value: `Organisation` }, { language: `en`, value: `Organization` },);
        this.set(this.selectOrganizationDropdownOrganizationDescriptionLanguageItemName, { language: `fi`, value: `Paina valitaksesi asiakas` }, { language: `sv`, value: `Tryck för att välja organisation` }, { language: `en`, value: `Press to select organization` },);
        this.set(this.selectOrganizationGetManualLanguageItemName, { language: `fi`, value: `Valitse asiakas, missä aloitat työt painamalla Asiakas painiketta` }, { language: `sv`, value: `Välj en organisation du kommer att arbeta med från rullgardinsmenyn genom att trycka på Organisation Widget` }, { language: `en`, value: `Select a organization You are going to work on from dropdown menu by pressing on Organization widget` },);
        this.set(this.componentNavigationWidgetPreviousLanguageItemName, { language: `fi`, value: `Edellinen` }, { language: `sv`, value: `Föregående` }, { language: `en`, value: `Previous` },);
        this.set(this.componentNavigationWidgetReturnToPreviousLanguageItemName, { language: `fi`, value: `Palaa edelliseen vaiheeseen` }, { language: `sv`, value: `Återgå till föregående steg` }, { language: `en`, value: `Return to previous step` },);
        this.set(this.componentNavigationWidgetNextLanguageItemName, { language: `fi`, value: `Seuraava` }, { language: `sv`, value: `Nästa` }, { language: `en`, value: `Next` },);
        this.set(this.componentNavigationWidgetGoToNextLanguageItemName, { language: `fi`, value: `Siirry seuraavaan vaiheeseen` }, { language: `sv`, value: `Gå till nästa steg` }, { language: `en`, value: `Go to next step` },);
        this.set(this.taskAdditionalEquipmentsLanguageItemName, { language: `fi`, value: `Lisätarvikkeet` }, { language: `sv`, value: `Ytterligare utrustning` }, { language: `en`, value: `Additional equipments` },);
        this.set(this.taskAdditionalEquipmentsDescriptionLanguageItemName, { language: `fi`, value: `Lisää tarvikkeita tehtävälle` }, { language: `sv`, value: `Måste lägga till utrustning till uppgiften` }, { language: `en`, value: `Need to add equipments to the task` },);
        this.set(this.taskHoursLanguageItemName, { language: `fi`, value: `Tunnit` }, { language: `sv`, value: `Timmar` }, { language: `en`, value: `Hours` },);
        this.set(this.taskHoursDescriptionLanguageItemName, { language: `fi`, value: `Tehtävällä käytetty työaika` }, { language: `sv`, value: `Mängden timmar som spenderas för uppgiften` }, { language: `en`, value: `Amount of hours spent for the task` },);
        this.set(this.taskInProgressLanguageItemName, { language: `fi`, value: `Meneillään` }, { language: `sv`, value: `Pågående` }, { language: `en`, value: `In progress` },);
        this.set(this.taskDoneLanguageItemName, { language: `fi`, value: `Valmis` }, { language: `sv`, value: `Färdig` }, { language: `en`, value: `Done` },);
        this.set(this.taskTaskStatusLanguageItemName, { language: `fi`, value: `Tehtävän tila` }, { language: `sv`, value: `Uppdragsstatus` }, { language: `en`, value: `Task status` },);
        this.set(this.taskTaskStatusDescriptionLanguageItemName, { language: `fi`, value: `Näyttää onko tehtävä valmistunut vai kesken` }, { language: `sv`, value: `Anger om uppdraget är klar eller inte` }, { language: `en`, value: `Indicates whether task is finished or not` },);
        this.set(this.taskApproveLanguageItemName, { language: `fi`, value: `Hyväksy` }, { language: `sv`, value: `Godkänna` }, { language: `en`, value: `Approve` },);
        this.set(this.taskApproveDescriptionLanguageItemName, { language: `fi`, value: `Hyväksy tehtävä asiakkaalla` }, { language: `sv`, value: `Godkänna uppdrag av kunden` }, { language: `en`, value: `Approve the task by customer` },);
        this.set(this.taskConfirmLanguageItemName, { language: `fi`, value: `Vahvista` }, { language: `sv`, value: `Bekräfta` }, { language: `en`, value: `Confirm` },);
        this.set(this.taskGetManualLanguageItemName, { language: `fi`, value: `Kirjaudu jokaiselle tehtävälle työpäivän aikana, mitä olet suorittanut ja aseta tehtävien tilat uloskirjausten yhteydessä näiden mukaisesti. Lisätyötehtävissä määritä suoritettu tuntimäärä.\n\nPaina Kirjaudu ulos painiketta päättääksesi työpäiväsi.` }, { language: `sv`, value: `Kolla in varje uppdrag du har arbetat med idag genom att välja mängder timmar som spenderas på det (endast för extra uppgifter)\noch justera den aktuella statusen för uppdraget genom att använda widgets.\nTryck på klar för att avsluta din arbetsdag.` }, { language: `en`, value: `Checkout each task You have been working on today by selecting amount of hours spent on it (for extra tasks only)\nand adjust current status of the task by using widgets.\n\nPress sign-out button to finish Your workday.` },);
        this.set(this.distanceTravelDistanceLanguageItemName, { language: `fi`, value: `Matkan pituus, km` }, { language: `sv`, value: `Reseavstånd, km` }, { language: `en`, value: `Travel distance, km` },);
        this.set(this.distanceTravelDistanceDescriptionLanguageItemName, { language: `fi`, value: `Varmista matkaetäisyys työmaalle` }, { language: `sv`, value: `Verifiera reseavstånd till arbetsplatsen` }, { language: `en`, value: `Verify travel distance to the working site` },);
        this.set(this.distanceSignOutLanguageItemName, { language: `fi`, value: `Kirjaudu ulos` }, { language: `sv`, value: `Logga ut` }, { language: `en`, value: `Sign out` },);
        this.set(this.distanceGetManualLanguageItemName, { language: `fi`, value: `Aseta ajokilometrimäärä mikäli olet käyttänyt omaa ajoneuvoa työmatkoihin. Lisää matkustajien määrä Matkustaja painikkeesta.` }, { language: `sv`, value: `Justera ditt reseavstånd och mängden passagerare med reseavstånd och passagerare widgetar.` }, { language: `en`, value: `Adjust Your travel distance and amount of passengers with Travel distance and Passengers widgets.` },);
        this.set(this.selectConstructionSiteGetManualLanguageItemName, { language: `fi`, value: `Valitse työmaa painamalla Työmaa painiketta, tai skannaa työmaalla oleva QR koodi painamalla QR koodi painiketta. Oletuksena valittuna työmaa, joka on sinua lähimpänä.` }, { language: `sv`, value: `Välj en byggarbetsplats från rullgardinsmenyn genom att klicka på Widget för byggplats eller använd QR -kodskannerwidget. Som standard väljs den närmaste byggarbetsplatsen dragspel till din nuvarande plats.` }, { language: `en`, value: `Select construction site from dropdown menu by clicking on Construction site widget, or use QR code scanner widget. By default the closest construction site is chosen accordion to Your current location.` },);
        this.set(this.selectConstructionSiteConstructionSiteLanguageItemName, { language: `fi`, value: `Työmaa` }, { language: `sv`, value: `Byggarbetsplats` }, { language: `en`, value: `Construction site` },);
        this.set(this.selectConstructionSiteConstructionSiteDescriptionLanguageItemName, { language: `fi`, value: `Paina valitaksesi työmaat` }, { language: `sv`, value: `Tryck för att välja byggplats` }, { language: `en`, value: `Press to select construction site` },);
        this.set(this.approveCombineLanguageItemName, { language: `fi`, value: `Yhdistä` }, { language: `sv`, value: `Kombinera` }, { language: `en`, value: `Combine` },);
        this.set(this.approveCombineDescriptionLanguageItemName, { language: `fi`, value: `Yhdistä nykyinen tehtävä toiseen käsiteltyyn tehtävään hyväksyäksesi` }, { language: `sv`, value: `Kombinera aktuell uppdrag med annan bearbetad uppdrag att godkänna` }, { language: `en`, value: `Combine current task with other processed task to approve` },);
        this.set(this.approveWorkReportNameLanguageItemName, { language: `fi`, value: `Työraportin nimi` }, { language: `sv`, value: `Arbetsrapportnamn` }, { language: `en`, value: `Work report name` },);
        this.set(this.approveWorkReportNameDescriptionLanguageItemName, { language: `fi`, value: `Määritä työraportin nimi` }, { language: `sv`, value: `Ange Namn på arbetsrapporten` }, { language: `en`, value: `specify work report name` },);
        this.set(this.approveGetManualLanguageItemName, { language: `fi`, value: `Aseta ajokilometrimäärä mikäli olet käyttänyt omaa ajoneuvoa työmatkoihin. Lisää matkustajien määrä Matkustaja painikkeesta.` }, { language: `sv`, value: `Justera ditt reseavstånd och mängden passagerare med reseavstånd och passagerare widgetar.` }, { language: `en`, value: `Adjust Your travel distance and amount of passengers with Travel distance and Passengers widgets.` },);
        this.set(this.allowanceNoDailyLanguageItemName, { language: `fi`, value: `Ei päivärahaa` }, { language: `sv`, value: `Ingen dagpenning` }, { language: `en`, value: `No daily allowance` },);
        this.set(this.allowanceOwnToolsLanguageItemName, { language: `fi`, value: `Omat työkalut tai välineet` }, { language: `sv`, value: `Egna verktyg eller utrustning` }, { language: `en`, value: `Own tools or equipment` },);
        this.set(this.allowanceOwnToolsDescriptionLanguageItemName, { language: `fi`, value: `Osoittaa, käytätkö omia työkaluja tai laitteita vai ei` }, { language: `sv`, value: `Anger, om du använder egna verktyg eller utrustning eller inte` }, { language: `en`, value: `Indicates, whether or not you use own tools or equipment` },);
        this.set(this.allowanceGetManualLanguageItemName, { language: `fi`, value: `Valitse päivärahakorvauksesi Päiväraha painikkeesta sekä mahdolliset työkalukorvaukset Omat työkalut tai välineet painikkeesta.` }, { language: `sv`, value: `Välj din dagliga ersättning från rullgardinsmenyn genom att trycka på Widget för daglig tillägg.\nOm egen utrustning användes, tryck på egna verktyg eller utrustningswidget.` }, { language: `en`, value: `Select Your daily allowance from dropdown menu by pressing on Daily allowance widget.\nIf own equipment was used press on Own tools or equipment widget.` },);
        this.set(this.signatureApprovalTypeLanguageItemName, { language: `fi`, value: `Hyväksyntä tyyppi` }, { language: `sv`, value: `Godkännande` }, { language: `en`, value: `Approval type` },);
        this.set(this.signatureApprovalTypeDescriptionLanguageItemName, { language: `fi`, value: `Valitse hyväksyntä tyyppi` }, { language: `sv`, value: `Välj godkännande typ` }, { language: `en`, value: `Choose approval type` },);
        this.set(this.signatureSignatureLanguageItemName, { language: `fi`, value: `Allekirjoitus` }, { language: `sv`, value: `Signatur` }, { language: `en`, value: `Signature` },);
        this.set(this.signatureSignatureDescriptionLanguageItemName, { language: `fi`, value: `Pyydä asiakkaalta allekirjoitus saadaksesi hyväksynnän` }, { language: `sv`, value: `Be kunden att dra sin signatur för att godkänna` }, { language: `en`, value: `Ask customer to draw his signature to approve` },);
        this.set(this.signatureGetManualLanguageItemName, { language: `fi`, value: `Aseta ajokilometrimäärä mikäli olet käyttänyt omaa ajoneuvoa työmatkoihin. Lisää matkustajien määrä Matkustaja painikkeesta.` }, { language: `sv`, value: `Justera ditt reseavstånd och mängden passagerare med reseavstånd och passagerare widgetar.` }, { language: `en`, value: `Adjust Your travel distance and amount of passengers with Travel distance and Passengers widgets.` },);
        this.set(this.qrWidgetScanErrorLanguageItemName, { language: `fi`, value: `QR koodi skanneri ei käytössä. Mahdollisesti kameran käyttöoikeudet puuttuvat laitteeltasi.` }, { language: `sv`, value: `QR-kodskanner inte tillgänglig, förmodligen inga behörigheter för kameran på din mobila enhet.` }, { language: `en`, value: `QR code scanner is not available, probably no permissions to camera on your mobile device.` },);
        this.set(this.addConstructionsiteTitleLanguageItemName, { language: `fi`, value: `Lisää työmaa` }, { language: `sv`, value: `Lägg till byggplats` }, { language: `en`, value: `Add construction site` },);
        this.set(this.addContactPersonModalCreateLanguageItemName, { language: `fi`, value: `Luo` }, { language: `sv`, value: `Skapa` }, { language: `en`, value: `Create` },);
        this.set(this.addEquipmentEquipmentListLanguageItemName, { language: `fi`, value: `Välinelista` }, { language: `sv`, value: `Utrustningslista` }, { language: `en`, value: `Equipment list` },);
        this.set(this.addEquipmentProductsLanguageItemName, { language: `fi`, value: `Tuotteet` }, { language: `sv`, value: `Produkter` }, { language: `en`, value: `Products` },);
        this.set(this.addEquipmentProductsDescriptionLanguageItemName, { language: `fi`, value: `Valitse tuote, jonka haluat lisätä välinelistaan` }, { language: `sv`, value: `Välj produkt att lägga till i utrustningslistan` }, { language: `en`, value: `Choose product to add to equipment list` },);
        this.set(this.addMounterModalTaskLanguageItemName, { language: `fi`, value: `Tehtävä` }, { language: `sv`, value: `Uppgift` }, { language: `en`, value: `Task` },);
        this.set(this.addTaskStartDateLanguageItemName, { language: `fi`, value: `Aloitus päivämäärä` }, { language: `sv`, value: `Start datum` }, { language: `en`, value: `Start date` },);
        this.set(this.addTaskStartDateDescriptionLanguageItemName, { language: `fi`, value: `Määritä päivämäärä milloin tehtävä aloitetaan` }, { language: `sv`, value: `Ange ett datum då uppdraget ska starta` }, { language: `en`, value: `Specify a date when task should be in progress` },);
        this.set(this.addTaskTaskDescriptionLanguageItemName, { language: `fi`, value: `Tehtävän kuvaus` }, { language: `sv`, value: `Uppdragsbeskrivning` }, { language: `en`, value: `Task description` },);
        this.set(this.addTaskTaskDescriptionDescriptionLanguageItemName, { language: `fi`, value: `Määritä tehtävän kuvaus` }, { language: `sv`, value: `Ange beskrivningen av uppgiften` }, { language: `en`, value: `Specify the description of the task` },);
        this.set(this.addTaskTaskNameLanguageItemName, { language: `fi`, value: `Tehtävän nimi` }, { language: `sv`, value: `uppdragsnamn` }, { language: `en`, value: `Task name` },);
        this.set(this.addTaskTaskNameDescriptionLanguageItemName, { language: `fi`, value: `Määritä tehtävän nimi` }, { language: `sv`, value: `Ange uppdragsnamn` }, { language: `en`, value: `Specify the task name` },);
        this.set(this.addTaskModalAgreementLanguageItemName, { language: `fi`, value: `Sopimus` }, { language: `sv`, value: `Avtal` }, { language: `en`, value: `Agreement` },);
        this.set(this.addTaskModalChangeTaskLanguageItemName, { language: `fi`, value: `Muokkaa tehtävää` }, { language: `sv`, value: `Ändra uppgift` }, { language: `en`, value: `Edit task` },);
        this.set(this.addTaskModalCreateExtraModuleLanguageItemName, { language: `fi`, value: `Luo Extra Moduuli` }, { language: `sv`, value: `Skapa extra modul` }, { language: `en`, value: `Create Extra Module` },);
        this.set(this.addTaskModalDeleteLanguageItemName, { language: `fi`, value: `Poista` }, { language: `sv`, value: `Radera` }, { language: `en`, value: `Delete` },);
        this.set(this.addTaskModalDeleteConfirmLanguageItemName, { language: `fi`, value: `Haluatko varmasti poistaa tehtävän?` }, { language: `sv`, value: `Vill du verkligen ta bort den här uppgiften?` }, { language: `en`, value: `Do you really want to delete this task?` },);
        this.set(this.addTaskModalSaveTaskLanguageItemName, { language: `fi`, value: `Tallenna tehtävä` }, { language: `sv`, value: `Spara uppgift` }, { language: `en`, value: `Save task` },);
        this.set(this.addTaskModalSiteOrWarehouseLanguageItemName, { language: `fi`, value: `Työmaa tai varasto` }, { language: `sv`, value: `Byggplats eller depå` }, { language: `en`, value: `Site or warehouse` },);
        this.set(this.addWorkReportModalAddCompletedExtraTaskLanguageItemName, { language: `fi`, value: `Lisää suoritettu extra tehtävä` }, { language: `sv`, value: `Lägg till färdig extra uppgift` }, { language: `en`, value: `Add completed extra task` },);
        this.set(this.addWorkReportModalDateTaskCompletedLanguageItemName, { language: `fi`, value: `Päivämäärä, jolloin tehtävä suoritettiin` }, { language: `sv`, value: `Datum när uppdrag slutfördes` }, { language: `en`, value: `Date when task was completed` },);
        this.set(this.addWorkReportModalDescriptionOfTaskLanguageItemName, { language: `fi`, value: `Tehtävän kuvaus` }, { language: `sv`, value: `Beskrivning av uppgiften` }, { language: `en`, value: `Description of the task` },);
        this.set(this.addWorkReportModalExistingExtraTasksLanguageItemName, { language: `fi`, value: `Olemassa olevat extra tehtävät` }, { language: `sv`, value: `Befintliga extra uppgifter` }, { language: `en`, value: `Existing extra tasks` },);
        this.set(this.addWorkReportModalRemoveTaskWorkReportLanguageItemName, { language: `fi`, value: `Poista tehtävä työraportista` }, { language: `sv`, value: `Ta bort uppdrag från arbetsrapporten` }, { language: `en`, value: `Remove task from work report` },);
        this.set(this.userManagementSettingsKeyLanguageItemName, { language: `fi`, value: `Asetus` }, { language: `sv`, value: `Miljö` }, { language: `en`, value: `Setting` },);
        this.set(this.userManagementSettingsValueLanguageItemName, { language: `fi`, value: `Arvo` }, { language: `sv`, value: `Värde` }, { language: `en`, value: `Value` },);
        this.set(this.userManagementShowDeletedLanguageItemName, { language: `fi`, value: `Näytä poistetut` }, { language: `sv`, value: `Visa bort` }, { language: `en`, value: `Show deleted` },);
        this.set(this.userManagementUserRestoredLanguageItemName, { language: `fi`, value: `Käyttäjä {0} palautettu.` }, { language: `sv`, value: `Användarkonto {0} återställdes framgångsrikt.` }, { language: `en`, value: `User account {0} restored successfully.` },);
        this.set(this.auditModuleGetManualLanguageItemName, { language: `fi`, value: `Luo telinetarkastuspöytäkirja.\nPaina \"Aktivoi\" aloittaaksesi.\nTämä luo ja aktivoi valitun tarkastuspöytäkirjan.\n\nSplitattuja tehtäviä ei voi aktivoida.` }, { language: `sv`, value: `Revisionsmodul.\nTryck på \"Aktivera \" -knappen för det.\nDet kommer att skapa och aktivera uppdrags motsvarande uppgift.\n\nuppdrag som markeras som split kan inte aktiveras.` }, { language: `en`, value: `Audit module.\nPress \"Activate\" button for that.\nIt will create and activate task corresponding task.\n\nTask marked as split cannot be activated.` },);
        this.set(this.baseInputTotalSizeTooBigLanguageItemName, { language: `fi`, value: `Dokumenttien kokonaiskoko on liian iso` }, { language: `sv`, value: `Den totala storleken på dokumenten är för stor` }, { language: `en`, value: `Total size of documents is too big` },);
        this.set(this.constructionSiteManagementAddAgreementLanguageItemName, { language: `fi`, value: `Lisää sopimus` }, { language: `sv`, value: `Lägg till nytt avtal` }, { language: `en`, value: `Add new agreement` },);
        this.set(this.constructionSiteAgreementDeactivatedLanguageItemName, { language: `fi`, value: `Deaktivoitu` }, { language: `sv`, value: `Inaktiverad` }, { language: `en`, value: `Deactivated` },);
        this.set(this.constructionSiteAgreementContactUserLanguageItemName, { language: `fi`, value: `Yhteyshenkilö: ` }, { language: `sv`, value: `Kontakt:` }, { language: `en`, value: `Contact: ` },);
        this.set(this.constructionSitePanelOrganizationContractLanguageItemName, { language: `fi`, value: `Asiakas sopimus` }, { language: `sv`, value: `Organisationskontrakt` }, { language: `en`, value: `Organization Contract` },);
        this.set(this.constructionSitePanelPaymentTermsLanguageItemName, { language: `fi`, value: `Maksuehtojen koodi` }, { language: `sv`, value: `Betalningsvillkorskod` }, { language: `en`, value: `Payment terms code` },);
        this.set(this.dashboardSwitchSiteLanguageItemName, { language: `fi`, value: `Vaihda työmaata` }, { language: `sv`, value: `Byt byggarbetsplats` }, { language: `en`, value: `Switch construction site` },);
        this.set(this.dashboardSwitchSiteDescriptionLanguageItemName, { language: `fi`, value: `Kirjaudu seuraavalle työmaalle` }, { language: `sv`, value: `Incheckning till nästa byggarbetsplats` }, { language: `en`, value: `Check-in to next construction site` },);
        this.set(this.enumExtraChargeTypeAssemblyLanguageItemName, { language: `fi`, value: `Asennus` }, { language: `sv`, value: `hopsättning` }, { language: `en`, value: `Assembly` },);
        this.set(this.enumExtraChargeTypeCoverSalesLanguageItemName, { language: `fi`, value: `Peitemyynti` }, { language: `sv`, value: `Täcka försäljning` }, { language: `en`, value: `Cover sales` },);
        this.set(this.enumExtraChargeTypeDeliveryLanguageItemName, { language: `fi`, value: `Toimitus` }, { language: `sv`, value: `Leverans` }, { language: `en`, value: `Delivery` },);
        this.set(this.enumExtraChargeTypeDismantleLanguageItemName, { language: `fi`, value: `Purku` }, { language: `sv`, value: `Demontera` }, { language: `en`, value: `Dismantle` },);
        this.set(this.enumExtraChargeTypeOtherEquipmentSalesLanguageItemName, { language: `fi`, value: `Muiden varusteiden myynti` }, { language: `sv`, value: `Annan utrustningsförsäljning` }, { language: `en`, value: `Other equipment sales` },);
        this.set(this.enumExtraChargeTypeReturnLanguageItemName, { language: `fi`, value: `Palautus` }, { language: `sv`, value: `Retur` }, { language: `en`, value: `Return` },);
        this.set(this.enumExtraChargeTypeScaffoldingEquipmentSalesLanguageItemName, { language: `fi`, value: `Telinevarusteiden myynti` }, { language: `sv`, value: `Byggnadsställningsutrustning` }, { language: `en`, value: `Scaffolding equipment sales` },);
        this.set(this.enumExtraChargeUnitHourLanguageItemName, { language: `fi`, value: `Tunti` }, { language: `sv`, value: `Timme` }, { language: `en`, value: `Hour` },);
        this.set(this.enumExtraChargeUnitM2LanguageItemName, { language: `fi`, value: `Neliömetri` }, { language: `sv`, value: `Kvadratmeter` }, { language: `en`, value: `Squeare meter` },);
        this.set(this.enumExtraChargeUnitPcsLanguageItemName, { language: `fi`, value: `Kappale` }, { language: `sv`, value: `Bit` }, { language: `en`, value: `Piece` },);
        this.set(this.enumInvoiceRowTypeTaskEquipmentLanguageItemName, { language: `fi`, value: `Tarvikkeet` }, { language: `sv`, value: `Utrustning` }, { language: `en`, value: `Equipment` },);
        this.set(this.enumInvoiceRowTypeTaskEquipmentDescriptionLanguageItemName, { language: `fi`, value: `3050` }, { language: `sv`, value: `3050` }, { language: `en`, value: `3050` },);
        this.set(this.enumInvoiceRowTypeTaskExtraChargeLanguageItemName, { language: `fi`, value: `Lisämaksu` }, { language: `sv`, value: `Extra avgift` }, { language: `en`, value: `Extra charge` },);
        this.set(this.enumInvoiceRowTypeWorkReportsLanguageItemName, { language: `fi`, value: `Työraportit` }, { language: `sv`, value: `Arbets rapporter` }, { language: `en`, value: `Work reports` },);
        this.set(this.enumModuleModelModulesLanguageItemName, { language: `fi`, value: `Moduulit` }, { language: `sv`, value: `Moduler` }, { language: `en`, value: `Modules` },);
        this.set(this.formInputMiddlenameLanguageItemName, { language: `fi`, value: `Toinen nimi` }, { language: `sv`, value: `Mellannamn` }, { language: `en`, value: `Middle name` },);
        this.set(this.genericApprovalLanguageItemName, { language: `fi`, value: `Hyväksyntä` }, { language: `sv`, value: `Godkännande` }, { language: `en`, value: `Approval` },);
        this.set(this.genericConstructionsiteLanguageItemName, { language: `fi`, value: `Työmaa` }, { language: `sv`, value: `Byggarbetsplats` }, { language: `en`, value: `Construction site` },);
        this.set(this.genericDateLanguageItemName, { language: `fi`, value: `Päivämäärä` }, { language: `sv`, value: `Datum` }, { language: `en`, value: `Date` },);
        this.set(this.genericLoadingLanguageItemName, { language: `fi`, value: `Ladataan..` }, { language: `sv`, value: `Laddar..` }, { language: `en`, value: `Loading..` },);
        this.set(this.genericUnlockForEditingLanguageItemName, { language: `fi`, value: `Poista lukitus\n (Hyväksynyt {0}, {1})` }, { language: `sv`, value: `Lås upp för redigering \n (godkänd av {0}, på {1})` }, { language: `en`, value: `Unlock for editing\n (Approved by {0}, at {1})` },);
        this.set(this.imageModalPreviewNotSupportedLanguageItemName, { language: `fi`, value: `Tiedostotyypin esikatselu ei ole tuettu. Vaihtoehtoisesti voit ladata tiedoston` }, { language: `sv`, value: `Förhandsvisning stöds inte för den här typen av fil, men du kan ladda ner den istället` }, { language: `en`, value: `Preview is not supported for this type of file, but you can download it instead` },);
        this.set(this.invoicesCreditInvoiceCreatedLanguageItemName, { language: `fi`, value: `Hyvityslasku {0} luotu.` }, { language: `sv`, value: `Kreditfaktura {0} skapade framgångsrikt.` }, { language: `en`, value: `Credit invoice {0} created successfully.` },);
        this.set(this.invoicesCreditInvoiceCustomerConfirmationLanguageItemName, { language: `fi`, value: `Haluatko varmasti\nhyvityslaskuttaa\n<mark>#{0}</mark> summalla <mark>{1:C}€</mark>\nasiakasta\n'<mark>{2}</mark>'?` }, { language: `sv`, value: `Är du säker på att du vill ha kreditfaktura \n <mark>#{0} </mark> på <mark> {1:C} € </mark> \nfor kund \n '<mark> {2} [/mark ] '?` }, { language: `en`, value: `Are you sure\nyou want credit invoice\n<mark>#{0}</mark> on <mark>{1:C}€</mark>\nfor customer\n'<mark>{2}</mark>'?` },);
        this.set(this.invoicesExportInfoLanguageItemName, { language: `fi`, value: `Olet lähettämässä {0} laskua {1}:lle yritykselle.` }, { language: `sv`, value: `Du kommer att exportera {0} fakturor för {1} företag (er).` }, { language: `en`, value: `You are going to export {0} invoices for {1} company(s).` },);
        this.set(this.invoicesNothingSelectedLanguageItemName, { language: `fi`, value: `Ei mitään valittu.` }, { language: `sv`, value: `Inget valt.` }, { language: `en`, value: `Nothing selected.` },);
        this.set(this.invoicesInvoiceCustomerConfirmationLanguageItemName, { language: `fi`, value: `Haluatko varmasti\nlaskuttaa laskun\n<mark>#{0}</mark> summalla <mark>{1:C}€</mark>\nasiakkaalta\n'<mark>{2}</mark>'?` }, { language: `sv`, value: `Är du säker på att du vill ha fakturor \n <mark>#{0} </mark> på <mark> {1:c} € </mark> \nfor kund \n '<mark> {2} [/mark ] '?` }, { language: `en`, value: `Are you sure\nyou want bill invoice\n<mark>#{0}</mark> on <mark>{1:C}€</mark>\nfor customer\n'<mark>{2}</mark>'?` },);
        this.set(this.invoicesMarkedAsExportedLanguageItemName, { language: `fi`, value: `Laskut merkattu viedyiksi. Tallenna ja vie laskut NAViin.` }, { language: `sv`, value: `Faktura (er) markerade som exporterade. Förvara och överför filen till NAV -systemet.` }, { language: `en`, value: `Invoice(s) marked as exported. Store and transfer the file to NAV system.` },);
        this.set(this.invoicesSentNumberLanguageItemName, { language: `fi`, value: `Laskun numero` }, { language: `sv`, value: `Faktura nummer` }, { language: `en`, value: `Invoice number` },);
        this.set(this.invoicesSentToAccountingLanguageItemName, { language: `fi`, value: `Laskut lähetetty kirjanpitoon.` }, { language: `sv`, value: `Faktura (er) som skickas till redovisningssystemet framgångsrikt.` }, { language: `en`, value: `Invoice(s) sent to accounting system successfully.` },);
        this.set(this.myAccountPageDataSavedLanguageItemName, { language: `fi`, value: `Tilin tiedot tallennettu` }, { language: `sv`, value: `Kontoinformation uppdateras framgångsrikt` }, { language: `en`, value: `Account information updated successfully` },);
        this.set(this.myAccountPageFiltersBehaviorLabelLanguageItemName, { language: `fi`, value: `Filttereiden toiminta` }, { language: `sv`, value: `Filterinställningar` }, { language: `en`, value: `Filters settings` },);
        this.set(this.myAccountPageMyDocumentsTabTitleLanguageItemName, { language: `fi`, value: `Dokumentit` }, { language: `sv`, value: `Mina dokument` }, { language: `en`, value: `My documents` },);
        this.set(this.myAccountPageMyInfoTabTitleLanguageItemName, { language: `fi`, value: `Tilin tiedot` }, { language: `sv`, value: `Min info` }, { language: `en`, value: `My info` },);
        this.set(this.myAccountPageAcceptanceLanguageItemName, { language: `fi`, value: `Olen lukenut ja hyväksyn` }, { language: `sv`, value: `Jag har läst och accepterar` }, { language: `en`, value: `I have read and accept` },);
        this.set(this.myAccountPageAcceptanceRequiredLanguageItemName, { language: `fi`, value: `Sinun on hyväksyttävä käyttöehdot ja tietosuojaseloste voidaksesi käyttää sovellusta` }, { language: `sv`, value: `Du måste acceptera användarvillkor och integritetsmeddelande för att använda ansökan` }, { language: `en`, value: `You must accept terms of usage and privacy notice in order to use application` },);
        this.set(this.myAccountPageAcceptanceTermsLanguageItemName, { language: `fi`, value: `käyttöehdot` }, { language: `sv`, value: `villkor` }, { language: `en`, value: `terms of use` },);
        this.set(this.myAccountPageAcceptanceTermsTitleLanguageItemName, { language: `fi`, value: `RENTA TASK-SOVELLUKSEN KÄYTTÖEHDOT` }, { language: `sv`, value: `Rentapro-applikationer` }, { language: `en`, value: `RENTA TASK-APPLICATIONS TERMS OF SERVICE` },);
        this.set(this.myAccountPageAcceptanceTermsContentLanguageItemName, { language: `fi`, value: `\n1.	Yleistä\n\nRenta Task-sovelluksen (”Sovellus”) omistaa ja sen tarjoaa käyttöön Renta Group Oy ("Renta").\n\nAsentamalla sovelluksen ja/tai käyttämällä sovellusta Rekisteröity Asiakas tai Rekisteröitymätön Käyttäjä hyväksyy nämä käyttöehdot ("Käyttöehdot"). Mikäli Rekisteröity Asiakas tai Rekisteröitymätön Käyttäjä ei hyväksy näitä Käyttöehtoja, Rekisteröityneellä Asiakkaalla tai Rekisteröitymättöllä Käyttäjällä ei ole oikeutta asentaa, avata tai käyttää sovellusta.\n\nRenta pidättää oikeuden muuttaa näitä Käyttöehtoja milloin tahansa ilman ennakkoilmoitusta. Rekisteröityneen Asiakkaan tai Rekisteröitymättömän Käyttäjän katsotaan hyväksyneen päivitetyt Käyttöehdot käyttämällä sovellusta Käyttöehtoihin tehdyn muutoksen jälkeen.\n\n2.	Renta Task-sovellus\n\nSovellus on Rentan Työntekijöilleen (Rekisteröidyt Käyttäjät) ja Rekisteröidyille Asiakkailleen. Sovellusta on mahdollista käyttää joko Rentan työntekijänä (Rekisteröity Käyttäjä) tai vaihtoehtoisesti rekisteröityneenä Asiakkaana asiakaskohtaisella käyttöoikeudella ("Rekisteröity Asiakas").\n\n2.1 Rekisteröityneet Asiakkaat.\nRekisteröityminen Asiakkaaksi edellyttää olemassa olevaa asiakassuhdetta Rentaan. Rentalla on oikeus olla hyväksymättä rekisteröitymistä ja poistaa sovelluksen käyttöoikeus.\nRekisteröityneellä Asiakkaalla on mahdollisuus nähdä ja hyväksyä sovelluksen kautta hänen työmaitaan koskevia työraportteja sekä laskutusta.\n\n2.2 Rekisteröityneet Käyttäjät\nRekisteröityminen Sovellukseen edellyttää olemassa olevaa työsuhdetta Rentaan. Rentalla on oikeus olla hyväksymättä rekisteröitymistä ja purkaa sovelluksen käyttöoikeus.\n\nRekisteröityneellä Käyttäjällä on mahdollisuus suorittaa työnohjauksen kannalta vaadittuja toimenpiteitä sovelluksen kautta.\n\nSovelluksen moitteettoman toiminnan varmistamiseksi Rekisteröityneen Asiakkaan ja Rekisteröidyn Käyttäjän tulee huolehtia siitä, että hänellä on käytössä viimeisin sovellusversio.\n\n3.	Tuotevalikoma ja hinnasto\n\nSovelluksessa esitetty tuotevalikoima vastaa Rentan normaalia tuotevalikoimaa. Tuotevalikoima, tuotteiden saatavuus sekä hintatiedot voivat vaihdella toimipisteittäin. Esitetyt hinnat eivät sisällä arvonlisäveroa. Arvonlisävero lisätään hintoihin laskutuksen yhteydessä\n\nSopimusasiakkaiden asiakaskohtaiset hintatiedot esitetään Sovelluksessa. Hintojen esittämistä voidaan rajata käyttöoikeuksilla.\n\nRenta ei vastaa Sovelluksessa esitettävien hinta- ja tuotetietojen tai muun aineiston mahdollisista virheistä, puutteista tai muista vioista.\n\n4.	Asiakaskohtaiset työraportit\n\n4.1 Asiakaskohtaisen työraportin muodostuminen\nRekisteröityjen Käyttäjien asiakkaan tilauksesta tekemä työ muodostaa järjestelmään työraportin.\n\n4.2 Asiakaskohtaisen työraportin käsittely\nRekisteröityneellä Asiakkaalla on mahdollisuus tarkastella häntä koskevia työraportteja sekä hyväksyä että hylätä suoritetun työn työraportteja. Rentalla on oikeus laskuttaa työt hyväksytyn työraportin mukaisesti.\n\n5.	Asiakaskohtaiset laskut\n\n5.1	Asiakaskohtaisten laskujen tarkastelu\nRekisteröityneellä Asiakkaalla on sovelluksessa mahdollista tarkastella häntä koskevia laskuja. Mahdollisista virheellisistä laskuista tulee reklamoida Rentan ohjeistuksen mukaisesti.\n\n6.	Immateriaalioikeudet\n\nSovellus ja sen sisältö, mukaan lukien mm. tavaramerkit, toiminimet, tuotetiedot ja kuvat, ovat Rentan ja/tai sen yhteistyökumppanien omaisuutta, jota suojaavat mm. tekijänoikeuslaki sekä kansainväliset immateriaalioikeussopimukset. Kaikki oikeudet Sovellukseen ja sen sisältöön pidätetään. Nimenomaisesti todetaan, että Rekisteröitynyt Asiakas tai Rekisteröity Käyttäjä ei saa myöntää sovellukseen alilisenssiä, vuokrata, siirtää tai muuten jaella sovellusta tai sen käyttöoikeuksia muutoin kun miten näissä Käyttöehdoissa on sallittu.\n\nRekisteröityneellä Asiakkaalla tai Rekisteröityneellä Käyttäjällä ei ole oikeutta muuttaa, muunnella, poistaa, kopioida, julkaista, saattaa yleisön saataviin tai siirtää mitään immateriaalioikeuksien kohteita. Asiakkaan oikeus käyttää sovellusta rajoittuu ainoastaan näiden Käyttöehtojen mukaiseen käyttöön.\n\n7.	Käyttöoikeudet ja tunnukset\n\nRekisteröitynyt Asiakas hyväksyy itseään sitoviksi kaikki toimenpiteet, jotka on tehty Sovelluksen kautta Rekisteröityneen Asiakkaan tunnuksilla tai Rekisteröityneen Asiakkaan toimesta tai toimeksiannosta. Rekisteröityneen Asiakkaan tunnusten käyttö Sovelluksessa vastaa Rekisteröityneen Asiakkaan allekirjoitusta.\n\nRekisteröitynyt Asiakas on velvollinen säilyttämään tunnuksia huolellisesti. Mikäli Rekisteröitynyt Asiakas epäilee, että tunnukset tai salasana ovat joutuneet kolmannen osapuolen haltuun, tulee Rekisteröityneen Asiakkaan ilmoittaa siitä välittömästi Rentan yhteyshenkilölle. Yhteyshenkilö poistaa vanhat tunnukset ja avaa uudet. Rekisteröitynyt Asiakas vastaa kaikista käyttäjätunnuksellaan tehdyistä tilauksista sekä tunnuksien vaarantumisesta mahdollisesti aiheutuvista vahingoista.\n\nRenta toimittaa Asiakkaalle tunnukset hyväksyttyään Rekisteröityneen Asiakkaan rekisteröitymisen.\n\nRekisteröityneellä Asiakkaalla ja Rekisteröityneellä Käyttäjällä on vastuu ryhtyä tarpeellisiin toimenpiteisiin, jos hän havaitsee tai hänen tietoonsa saatetaan, että joku käyttäjistä toimii näiden Käyttöehtojen vastaisesti. Renta pidättää itsellään oikeuden lakkauttaa Rekisteröityneen Asiakkaan tai Rekisteröityneen Käyttäjän käyttöoikeuden, jos Rekisteröitynyt Asiakas tai Rekisteröitynyt Käyttäjä käyttää sovellusta näitä Käyttöehtojen vastaisesti.\n\n8.	Rentan vastuu\n\nSovellus sisältöineen tarjotaan Rekisteröityneelle Asiakkaalle ja Rekisteröityneelle Käyttäjälle ”sellaisena kuin se on”. Renta ei vastaa Sovelluksessa välitettävän sisällön virheistä, puutteista tai muista vioista. Renta ei takaa Sovelluksen saatavuutta eikä sen keskeytyksetöntä tai virheetöntä toimintaa. Renta ei vastaa mistään kuluista, menetyksistä tai muista mahdollisista välittömistä tai välillisistä vahingoista, jotka saattavat aiheutua tämän Sovelluksen käyttämisestä, Sovelluksessa annetusta informaatiosta tai siitä, ettei Sovellus ole käytettävissä, jollei pakottavasta lainsäädännöstä muuta johdu. Joka tapauksessa Rentan vastuu on kuitenkin rajoitettu korkeintaan määrään, joka vastaa sovittua vuokrakaluston vuokraa ja/tai palvelun hintaa.\n\n9.	Evästeet\n\nRenta käyttää Sovelluksessa evästeitä (ns. cookie-toiminto). Eväste on Sovelluksen käytön yhteydessä käyttäjän selaimeen tallennettava tekstitiedosto. Evästeet mahdollistavat esimerkiksi Sovelluksen käyttäjämäärien seurannan ja tiedon keräämisen siitä, miten ja milloin Sovellusta käytetään.\n\nRekisteröitynyt Asiakas ja Rekisteröitymätön Käyttäjä voi kytkeä pois evästeiden käytön selaimensa asetuksista. Lisätietoja selainkohtaisista käyttöohjeista saa selaimen valmistajalta. Renta suosittelee evästeiden käyttöä Sovelluksessa parhaan mahdollisen käyttäjäkokemuksen saamiseksi.\n\n10.	Kolmansien osapuolien palvelut\n\nSovellus voi sisältää linkkejä kolmansien osapuolien omistamille tai ylläpitämille sivustoille. Renta ei vastaa tällaisten kolmansien osapuolien sivustojen toiminnasta, sisällöstä, aiheuttamista välittömistä tai välillisistä vahingoista tai muista ominaisuuksista. Näille sivuille siirtyessään käyttäjän tulee hyväksyä näiden sivujen mahdolliset käyttöehdot ja tietosuojaseloste ennen käytön aloittamista.\n\n11.	Henkilötietojen käsittely\n\nRenta käsittelee ja kerää Rekisteröityneiden Asiakkaiden henkilötietoja palvelujen toteuttamiseksi sekä asiakassuhteiden ylläpitämiseksi ja kehittämiseksi. Rentan tietosuojaselosteessa kuvataan henkilötietojen käsittelyä tarkemmin: https://renta.fi/en/privacy-policy-and-cookies\n\nRekisteröitymättömien Käyttäjien henkilötietoja ei kerätä.\n\n12.	Muut ehdot\n\nKonevuokraukseen ja palveluihin sovelletaan Rentan voimassaolevia vuokraehtoja. Vuosisopimusasiakkaiden kanssa noudatetaan vuosisopimusten mukaisia ehtoja. Asiakas sitoutuu jokaisen tilauksen yhteydessä voimassa oleviin toimitusehtoihin.\n\nRenta saattaa muuttaa, päivittää, peruuttaa tai poistaa Sovelluksen, Sovelluksen sisältöä tai osia niistä harkintansa mukaan. Rekisteröityneen Asiakkaan tai Rekisteröityneen Käyttäjän tulee lopettaa Sovelluksen käyttäminen, jos Rekisteröitynyt Asiakas tai Rekisteröitynyt Käyttäjä ei hyväksy muutoksia Sovelluksen Käyttöehdoissa tai tietosuojaselosteessa.\n\nRekisteröityneen Asiakkaan ja Rekisteröitymättömän Käyttäjän tulee käyttää Sovellusta sen sovelluskaupan käyttöehtojen mukaisesti, josta on hankkinut Sovelluksen. Rekisteröitynyt Asiakas ja Rekisteröitynyt Käyttäjä vastaa kaikissa tapauksissa vahingoista, jotka ovat aiheutuneet hänen toimiessaan näiden Käyttöehtojen mukaisesti.\n\nRekisteröitynyt Asiakas ja Rekisteröitynyt Käyttäjä vastaa antamiensa tietojen oikeellisuudesta, käyttäjätunnuksensa ja salasanansa huolellisesta säilyttämisestä sekä laitteensa asianmukaisen tietoturvan järjestämisestä. Rekisteröitynyt Asiakas ja Rekisteröitynyt Käyttäjä vastaa kaikesta tunnuksillaan tapahtuvasta asioinnista Sovelluksessa.\n\nPalvelun käyttämiseen ja näihin ehtoihin sovelletaan Suomen lakia lukuun ottamatta sen lainvalintaa koskevia säännöksiä.\n\nOsapuolet pyrkivät ratkaisemaan erimielisyydet ensisijaisesti neuvotteluteitse. Mikäli sovintoratkaisuun ei päästä, erimielisyydet ratkaistaan Helsingin käräjäoikeudessa. Kuluttaja-asiakas voi viedä erimielisyyden myös kuluttajariitalautakunnan ratkaistavaksi.\n\n13.	Yhteystiedot\n\nJos sinulla on kysyttävää näistä Käyttöehdoista tai Sovelluksesta, ota yhteyttä:\n\nRenta Group Oy\nÄyritie 12 B\n01510 Vantaa\nSuomi\ninfo@renta.fi\nY-Tunnus 2732388-9\n    ` }, { language: `sv`, value: `1 vanligt\n\nRENA -uppgiftsansökan (”ansökan”) ägs och tillhandahålls av Renta Group OY (”Renta”).\n\nGenom att installera applikationen och / eller använda applikationen samtycker den registrerade kunden eller den oregistrerade användaren till dessa användarvillkor ("användarvillkor"). Om den registrerade kunden eller den oregistrerade användaren inte accepterar dessa användarvillkor, har den registrerade kunden eller den oregistrerade användaren inte rätt att installera, öppna eller använda applikationen.\n\nRenta förbehåller sig rätten att ändra dessa användarvillkor när som helst utan föregående meddelande. En registrerad kund eller en oregistrerad användare ska anses ha accepterat de uppdaterade användarvillkoren genom att använda applikationen efter ändringen av användarvillkoren.\n\n2. Renta Task Application\n\nApplikationen är för Rentan -anställda (registrerade användare) och registrerade kunder. Det är möjligt att använda applikationen antingen som anställd hos RENA (registrerad användare) eller alternativt som en registrerad kund med en kundspecifik licens ("Registrerad kund").\n\n2.1 Registrerade kunder.\nAtt registrera sig som kund kräver en befintlig kundrelation med RENA. Renta har rätt att inte acceptera registreringen och återkalla licensen för ansökan.\n\nDen registrerade kunden har möjlighet att se och godkänna arbetsrapporter och fakturering för sina byggarbetsplatser genom applikationen.\n\n2.2 Registrerade användare\nRegistrering för ansökan kräver en befintlig anställningsförhållande med RENA. Renta har rätt att inte acceptera registreringen och återkalla licensen för ansökan.\n\nDen registrerade användaren har möjlighet att utföra de åtgärder som krävs för arbetskontroll genom applikationen.\n\nFör att säkerställa korrekt drift av applikationen måste den registrerade kunden och den registrerade användaren se till att de har den senaste versionen av applikationen.\n\n3. Produktsortiment och prislista\n\nProduktsortimentet som presenteras i applikationen motsvarar Rentas normala produktsortiment. Produktsortiment, produkttillgänglighet och prisinformation kan variera från plats till plats. Priserna inkluderar inte moms om inte annat anges. Moms kommer att läggas till priserna vid fakturering.\n\nKundspecifik prisinformation för kontraktskunder presenteras i ansökan. Presentationen av priser kan begränsas av åtkomsträttigheter.\n\nRenta ansvarar inte för några fel, utelämnanden eller andra defekter i pris- och produktinformationen eller annat material som presenteras i applikationen.\n\n4. Kundspecifika arbetsrapporter\n\n4.1 Generering av en kundspecifik arbetsrapport\nDet arbete som utförs av de registrerade användarna på kundens vägnar utgör en arbetsrapport för systemet.\n\n4.2 Bearbetning av en kundspecifik arbetsrapport\nDen registrerade kunden har möjlighet att se arbetsrapporterna om honom eller henne och att acceptera och avvisa arbetsrapporterna för det utförs. Renta har rätt att fakturera arbetet i enlighet med den godkända arbetsrapporten.\n\n5. Kundspecifika fakturor\n\n5.1 Visa kundspecifika fakturor\nDet är möjligt för en registrerad kund att se fakturor angående honom i applikationen. Eventuella felaktiga fakturor måste omarbetas i enlighet med Rentas instruktioner.\n\n6. immateriella rättigheter\n\nApplikationen och dess innehåll, inklusive t.ex. Varumärken, handelsnamn, produktinformation och bilder tillhör RENA och / eller dess partners, som är skyddade av t.ex. Copyright Law och International Intellectual Property Agreement. Alla rättigheter till ansökan och dess innehåll är reserverade. Det anges uttryckligen att den registrerade kunden eller den registrerade användaren inte kan underlicensera, hyra, överföra eller på annat sätt distribuera ansökan eller dess rättigheter att använda ansökan förutom vad som är tillåtet i dessa användarvillkor.\n\nDen registrerade kunden eller den registrerade användaren ska inte ha rätt att ändra, ändra, radera, kopiera, publicera, göra tillgängligt för allmänheten eller överföra immateriella rättigheter. Din rätt att använda ansökan är begränsad till din användning i enlighet med dessa användarvillkor.\n\n7. Behörigheter och åtkomsträttigheter\n\nDen registrerade kunden accepterar som bindande alla åtgärder som vidtas genom ansökan med den registrerade kundens referenser eller av eller på uppdrag av den registrerade kunden. Användningen av registrerade kunduppgifter i applikationen motsvarar den registrerade kundens signatur.\n\nDen registrerade kunden är skyldig att hålla referenser noggrant lagrade. Om de registrerade kunden misstänker att referenserna har tvingats besittning av en tredje part, ska den registrerade kunden omedelbart informera kontaktpersonen om Renta om situationen. Kontaktpersonen raderar de gamla referenserna och öppnar de nya. Den registrerade kunden ansvarar för alla beställningar som placerats hos sitt användarnamn och för eventuella skador som kan uppstå från att kompromissa med referenser.\n\n8. Rentans ansvar\n\nApplikationen och dess innehåll tillhandahålls till den registrerade kunden och den registrerade användaren "AS är". Renta ansvarar inte för några fel, utelämnanden eller andra defekter i innehållet som överförs i applikationen. Renta garanterar inte tillgängligheten för applikationen eller dess oavbrutna eller felfria drift. Renta ansvarar inte för några kostnader, förluster eller andra möjliga eller indirekta skador som kan uppstå genom användning av denna ansökan, den information som anges i ansökan eller ansökan om inte tillgänglighet, med förbehåll för obligatorisk lagstiftning. I vilket fall som helst är Rentas ansvar begränsat till ett maximalt belopp som motsvarar den överenskomna hyresutrustningens hyres- och / eller servicepris.\n\n9. Kakor\n\nRenta använder cookies i applikationen (så kallad cookie-funktion). En cookie är en textfil lagrad i användarens webbläsare när du använder applikationen. Till exempel gör cookies det möjligt att övervaka antalet användare av applikationen och samla in information om hur och när applikationen används.\n\nDen registrerade kunden och den oregistrerade användaren kan inaktivera användningen av cookies i deras webbläsarinställningar. För mer information om webbläsarspecifika instruktioner, kontakta din webbläsarutvecklare. Renta rekommenderar användning av cookies i applikationen för att få bästa möjliga användarupplevelse.\n\n10. Tredjepartstjänster\n\nAnsökan kan innehålla länkar till webbplatser som ägs eller drivs av tredje parter. Renta ansvarar inte för drift, innehåll, direkta eller indirekta skador eller andra funktioner på sådana tredje parts webbplatser. Genom att komma åt dessa sidor måste användaren acceptera användarvillkoren för dessa sidor och integritetsförklaringen innan de använder dem.\n\n11. Bearbetning av personuppgifter\n\nRenta bearbetar och samlar in personuppgifter från registrerade kunder för att implementera tjänsterna och för att upprätthålla och utveckla kundrelationer. Renas integritetsförklaring beskriver behandlingen av personuppgifter mer detaljerat: https://renta.fi/en/privacy-policy-cookies\n\nPersonuppgifterna för oregistrerade användare kommer inte att samlas in.\n\n12. Andra villkor\n\nRenas giltiga hyresvillkor gäller för maskinuthyrning och tjänster. Villkoren för de årliga kontrakten uppfylls med kunderna i de årliga kontrakten. Kunden samtycker till leveransvillkoren som är giltiga för varje beställning.\n\nRenta kan ändra, uppdatera, avbryta eller radera applikationen, innehållet i applikationen eller delar därav efter eget gottfinnande. Den registrerade kunden eller den registrerade användaren måste sluta använda applikationen om den registrerade kunden eller den registrerade användaren inte accepterar ändringarna i användarvillkoren för applikationen eller integritetsförklaringen.\n\nDen registrerade kunden och den oregistrerade användaren måste använda applikationen i enlighet med användarvillkoren för applikationsbutiken från vilken de har förvärvat applikationen. I alla fall ska den registrerade kunden och den registrerade användaren vara ansvarig för skadestånd orsakade av hans / hennes efterlevnad av dessa användarvillkor.\n\nDen registrerade kunden och den registrerade användaren ansvarar för noggrannheten i den information de tillhandahåller, för noggrann lagring av deras användarnamn och lösenord och för rätt säkerhet för deras utrustning. Den registrerade kunden och den registrerade användaren ansvarar för alla transaktioner i ansökan med sina referenser.\n\nAnvändningen av tjänsten och dessa villkor styrs av finsk lag, med undantag för dess val av lagbestämmelser.\n\nParterna ska sträva efter att lösa sina skillnader främst genom förhandlingar. Om ingen vänlig lösning uppnås kommer tvisterna att avgöras i Helsingfors tingsrätt. Konsumentkunden kan också ta tvisten till Consumer Disputes styrelse för upplösning.\n\n13. Kontakt\n\nOm du har några frågor om dessa användarvillkor eller ansökan, vänligen kontakta:\n\nRenta Group OY\nÄyritie 12 b\n01510 Vantaa\nFinland\ninfo@renta.fi\nBusiness ID 2732388-9` }, { language: `en`, value: `1	Common\n\nThe Renta Task Application (the “Application”) is owned and provided by Renta Group Oy (“Renta”).\n\nBy installing the Application and / or using the Application, the Registered Customer or the Unregistered User agrees to these Terms of Use (the "Terms of Use"). If the Registered Customer or the Unregistered User does not accept these Terms of Use, the Registered Customer or the Unregistered User does not have the right to install, open or use the application.\n\nRenta reserves the right to change these Terms of Use at any time without notice. A registered Customer or an Unregistered User shall be deemed to have accepted the updated Terms of Use by using the application after the change to the Terms of Use.\n\n2.	Renta Task application\n\nThe application is for Rentan Employees (Registered Users) and Registered Customers. It is possible to use the application either as an employee of Renta (Registered User) or alternatively as a registered Customer with a customer-specific license ("Registered Customer").\n\n2.1	Registered Customers.\nRegistering as a Customer requires an existing customer relationship with Renta. Renta has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered Customer has the opportunity to view and approve work reports and invoicing for his construction sites through the application.\n\n2.2	Registered Users\nRegistration for the Application requires an existing employment relationship with Renta. Renta has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered User has the opportunity to perform the actions required for work control through the application.\n\nTo ensure the proper operation of the application, the Registered Customer and the Registered User must ensure that they have the latest version of the application.\n\n3.	Product range and price list\n\nThe product range presented in the application corresponds to Renta's normal product range. Product range, product availability and price information may vary from location to location. Prices do not include VAT unless stated otherwise. VAT will be added to the rates upon invoicing.\n\nCustomer-specific price information for contract customers is presented in the Application. The presentation of prices may be limited by access rights.\n\nRenta is not responsible for any errors, omissions or other defects in the price and product information or other material presented in the Application.\n\n4.	Customer-Specific Work Reports\n\n4.1	Generation of a customer-specific work report\nThe work performed by the Registered Users on behalf of the customer forms a work report for the system.\n\n4.2	Processing a customer-specific work report\nThe Registered Customer has the opportunity to view the work reports concerning him or her and to accept and reject the work reports of the work performed. Renta has the right to invoice the work in accordance with the approved work report.\n\n5.	Customer-specific invoices\n\n5.1	Viewing Customer-Specific Invoices\nIt is possible for a registered Customer to view invoices concerning him in the application. Any incorrect invoices must be reclamed in accordance with Renta's instructions.\n\n6.	Intellectual Property Rights\n\nThe application and its content, including e.g. trademarks, trade names, product information and images are the property of Renta and / or its partners, which are protected by e.g. copyright law and international intellectual property agreements. All rights to the Application and its content are reserved. It is expressly stated that the Registered Customer or the Registered User may not sublicense, rent, transfer or otherwise distribute the Application or its rights to use the Application except as permitted in these Terms of Use.\n\nThe Registered Customer or the Registered User shall not have the right to change, modify, delete, copy, publish, make available to the public or transfer any intellectual property rights. Your right to use the application is limited to your use in accordance with these Terms of Use.\n\n7.	Permissions and access rights\n\nThe Registered Customer accepts as binding all measures taken through the Application with the registered Customer's credentials or by or on behalf of the Registered Customer. The use of Registered Customer credentials in the Application corresponds to the Registered Customer's signature.\n\nThe Registered Customer is obliged to keep the credentials carefully stored. If the Registered Customer suspects that the credentials have been forced to possession of a third party, the Registered Customer shall immediately inform the contact person of Renta about the situation. The contact person deletes the old credentials and opens the new ones. The Registered Customer is responsible for all orders placed with his / her username and for any damages that may result from compromising the credentials.\n\n8.	Rentan's responsibility\n\nThe application and its contents are provided to the Registered Customer and the Registered User “as is”. Renta is not responsible for any errors, omissions or other defects in the content transmitted in the Application. Renta does not guarantee the availability of the Application or its uninterrupted or error-free operation. Renta shall not be liable for any costs, losses or other possible direct or indirect damages that may arise from the use of this Application, the information provided in the Application or the non-availability of the Application, subject to mandatory legislation. In any case, Renta's liability is limited to a maximum amount corresponding to the agreed rental equipment rental and / or service price.\n\n9.	Cookies\n\nRenta uses cookies in the Application (so-called cookie function). A cookie is a text file stored in the user's browser when using the Application. For example, cookies make it possible to monitor the number of users of the Application and to collect information on how and when the Application is used.\n\nThe Registered Customer and the Unregistered User can disable the use of cookies in their browser settings. For more information on browser-specific instructions, contact your browser developer. Renta recommends the use of cookies in the Application in order to obtain the best possible user experience.\n\n10.	Third Party Services\n\nThe application may contain links to sites owned or operated by third parties. Renta is not responsible for the operation, content, direct or indirect damages or other features of such third party sites. By accessing these pages, the user must accept the terms of use of these pages and the Privacy Statement before using them.\n\n11.	Processing of personal data\n\nRenta processes and collects the personal data of Registered Customers in order to implement the services and to maintain and develop customer relationships. Renta's privacy statement describes the processing of personal data in more detail: https://renta.fi/en/privacy-policy-and-cookies\n\nThe personal data of unregistered Users will not be collected.\n\n12.	Other Terms\n\nRenta's valid rental terms apply to machine rental and services. The terms and conditions of the annual contracts are complied with with the customers of the annual contracts. The customer agrees to the delivery terms valid for each order.\n\nRenta may change, update, cancel or delete the Application, the contents of the Application or portions thereof at its sole discretion. The Registered Customer or the Registered User must stop using the Application if the Registered Customer or the Registered User does not accept the changes in the Terms of Use of the Application or the privacy statement.\n\nThe Registered Customer and the Unregistered User must use the Application in accordance with the terms of use of the application store from which they have acquired the Application. In all cases, the Registered Customer and the Registered User shall be liable for damages caused by his / her compliance with these Terms of Use.\n\nThe Registered Customer and the Registered User are responsible for the accuracy of the information they provide, for the careful storage of their username and password, and for the proper security of their equipment. The Registered Customer and the Registered User are responsible for all transactions in the Application with their credentials.\n\nThe use of the service and these terms and conditions are governed by Finnish law, except for its choice of law provisions.\n\nThe parties shall endeavor to resolve their differences primarily through negotiations. If no amicable settlement is reached, the disputes will be settled in the Helsinki District Court. The consumer customer can also take the dispute to the Consumer Disputes Board for resolution.\n\n13.	Contact\n\nIf you have any questions about these Terms of Use or the Application, please contact:\n\nRenta Group Oy\nÄyritie 12 B\n01510 Vantaa\nFinland\ninfo@renta.fi\nBusiness ID 2732388-9` },);
        this.set(this.myAccountPageAcceptancePrivacyNoticeLanguageItemName, { language: `fi`, value: `tietosuojaselosteen` }, { language: `sv`, value: `integritetsmeddelande` }, { language: `en`, value: `privacy notice` },);
        this.set(this.myAccountPageAcceptancePrivacyNoticeTitleLanguageItemName, { language: `fi`, value: `RENTA TASK-SOVELLUKSEN TIETOSUOJASELOSTE` }, { language: `sv`, value: `Rentapro-applikationer sekretesspolicy` }, { language: `en`, value: `RENTA TASK-APPLICATIONS PRIVACY POLICY` },);
        this.set(this.myAccountPageAcceptancePrivacyNoticeContentLanguageItemName, { language: `fi`, value: `\nHenkilötietolaki 22.4.1999/523 10 ja 24 §\nLaadittu: 16.10.2019\n\n1.	Rekisterinpitäjä\nRenta Group Oy\nY-tunnus: 2732388-9\nOsoite: Äyritie 12B, 01510 Vantaa Suomi\n\n2.	Rekisteriasioista vastaava henkilö ja/tai yhteyshenkilö\nTietohallintojohtaja Joel Särkkä\nPuhelinnumero: +35850 323 5569 Sähköposti: joel.sarkka@renta.fi\n\n3.	Rekisterin nimi\nRenta Group Oy:n Renta Task -sovelluksen käyttäjärekisteri.\n\n4.	Henkilötietojen käsittelyn tarkoitus\nRenta Group Oy ja sen tytäryhtiöt käsittelevät henkilötietoja henkilön tunnistamiseen palvelussa, luottotietojen tarkastukseen, suoramarkkinointiin, asiakasviestintään, työsuhteen vaatimusten täyttämiseksi sekä laskutuksen ja henkilökohtaisen asiakaspalvelun mahdollistamiseen.\n\nLisäksi rekisterin sisältäminen henkilötietojen käsittely mahdollistaa palveluun kirjautumisen, palvelun tilaamisen ja sen tuottamisen sekä palvelun kehittämisen.\n\n5.	Rekisterin tietosisältö\nRekisterissä voidaan käsitellä seuraavia tietoja:\n•	Rekisteröidyn perustiedot\n        o	nimi\n        o	henkilötunnus\n        o	postiosoite\n        o	puhelinnumero\n        o	sähköpostiosoite\n        o	Asema yrityksessä\n        o	Rekisteröidyn suostumus suoramarkkinointiin\n        o	Yrityksen tiedot\n•	Asiakkuuteen liittyvät tiedot\n        o	palveluhistoria\n        o	luottotietomerkinnät\n        o	muut asiakkaan syöttämät merkinnät\n•	Teknisen tiedot\n        o	Sijaintitiedot\n        o	IP-osoite\n        o	Laitteen tunnistetiedot\n        o	mainonta-ID\n        o	käyttöjärjestelmä\n        o	selaintyyppi\n        o	muita yksityiskohtia laitteistosta\n\n6.	Säännönmukaiset tietolähteet\nHenkilötietoja kerätään rekisteröidyltä itseltään sekä Intrum luottotietopalvelun kautta.\n\n7.	Säännönmukaiset tietojen luovutukset ja tietojen siirto EU:n tai Euroopan talousalueen ulkopuolelle\nTietoja ei luovuteta EU:n tai ETA-alueen ulkopuolelle.\n\n8.	Evästeiden käyttö verkkopalvelussa\nKäytämme verkkopalvelussa evästeitä. Eväste on pieni, käyttäjän tietokoneelle tallennettava tekstitiedosto, joka mahdollistaa palvelun turvallisen, tehokkaan ja käyttäjäystävällisen käytön.\n\nEvästeiden poiskytkeminen sekä poistaminen ovat mahdollisia selaimen asetuksissa.\n\n9.	Rekisterin suojauksen periaatteet\nRekisterin sisältämät henkilötiedot käsitellään aina luottamuksellisina. Rekisterin sisältämien tietojen käsittelyn periaatteet ovat tietoja käsittelevissä organisaatioissa ohjeistettu ja dokumentoitu.\n\nTietojärjestelmä on suojattu palomuurilla.\n\nVerkkosivustolla tietojen siirto suojataan SSL-suojatulla yhteydellä.\n\n10.	Rekisteröidyn kielto-oikeus\nRekisteröidyllä on oikeus kieltää rekisterinpitäjää käsittelemästä häntä itseään koskevia tietoja suoramainontaa, etämyyntiä ja muuta suoramarkkinointia sekä markkina- ja mielipidetutkimusta samoin kuin henkilömatrikkelia ja sukututkimusta varten. Kielto voidaan asettaa mobiilisovelluksen tai asiakasportaalin kautta.\n\n11.	Rekisteröidyn tarkastusoikeus\nRekisteröidyllä on oikeus tarkastaa rekisteriin tallennetut itseään koskevat tiedot ja saada niistä kopiot ilmaiseksi enintään kerran vuodessa.\n\nTarkastuspyyntö tulee tehdä sähköpostitse sellaisesta sähköpostiosoitteesta, joka voidaan rekisterin avulla varmistaa kuuluvan rekisteröidylle.\n\n12.	Tiedon korjaaminen\nRekisterinpitäjä oikaisee, poistaa tai täydentää rekisterissä olevan, käsittelyn tarkoituksen kannalta virheellisen, tarpeettoman, puutteellisen tai vanhentuneen henkilötiedon oma-aloitteisesti tai rekisteröidyn vaatimuksesta. Lisäksi henkilötietoja voidaan poistaa, mikäli asiakas väärinkäyttää palvelua tai harjoittaa palvelun avulla rikollista tai muuta kiellettyä toimintaa.` }, { language: `sv`, value: `Avsnitt 10 och 24 i lagen om personuppgifter 22.4.1999 / 523\nFörberedd: 16.10.2019\n\n1. Registraren\nRenta Group OY\nBusiness ID: 2732388-9\nAdress: Äyritie 12b, 01510 Vantaa Finland\n\n2. Den person som ansvarar för registrering och / eller kontaktpersonen\nCIO Joel Särkkä\nTelefonnummer: +35850 323 5569\nE -post: joel.sarkka@renta.fi\n\n3. Registrets namn\nAnvändarregister för Renta Group OY: s RENA -uppgiftsapplikation.\n\n4. Syftet med behandlingen av personuppgifter\nRenta Group OY och dess dotterbolag behandlar personuppgifter i personlig identifieringstjänst, kreditinformationsverifiering, direktmarknadsföring, kundkommunikation, för att uppfylla anställningskraven och för att möjliggöra fakturering och personlig kundservice.\n\nDessutom gör det införandet av registret i behandlingen av personuppgifter på att logga in på tjänsten, beställa och producera tjänsten och utveckla tjänsten.\n\n5. Informationsinnehållet i registret\nFöljande information kan behandlas i registret:\n• Grundläggande information om den registrerade datan\no namn\no Personligt identifieringsnummer\no postadress\no Telefonnummer\no e-postadress\no Position i företaget\no Samtycke från de uppgifter som omfattas av direktmarknadsföring\n• Företagsinformation\no Kundrelaterad information\no Servicehistorien\no Kreditdataposter\no Andra poster som anges av kunden\n• Teknisk information\no Platsinformation\no IP -adress\no enhetsidentifiering\no Reklam -ID\no operativsystem\no webbläsartyp\no Andra hårdvaruinformation\n\n6. Regelbundna informationskällor\nPersonlig information samlas in från registranten själv och genom Intrum Credit Information Service.\n\n7. Regelbundna dataöverföringar och dataöverföringar utanför EU eller Europeiska ekonomiska området\nUppgifterna kommer inte att avslöjas utanför EU eller EES.\n\n8. Användning av kakor i onlinetjänsten\nVi använder cookies i onlinetjänsten. En cookie är en liten textfil lagrad på en användares dator som möjliggör säker, effektiv och användarvänlig användning av tjänsten.\n\nDu kan inaktivera och ta bort cookies i webbläsarinställningarna.\n\n9. Registreringssäkerhetsprinciper\nPersonuppgifterna i registret kommer alltid att behandlas som konfidentiella. Principerna för att behandla uppgifterna i registret instrueras och dokumenteras i organisationerna som behandlar uppgifterna.\n\nInformationssystemet är skyddat av en brandvägg.\n\nPå webbplatsen är dataöverföring säkrad med en SSL-säkrad anslutning.\n\n10. Rätten till förbud mot den registrerade\nUppgiftsämnet ska ha rätt att förbjuda styrenheten att behandla personuppgifter om honom eller henne för direkt post, distansförsäljning och annan direkt marknadsföring, såväl som för marknads- och åsiktsforskning, samt för personlig registrering och släktforskning. Förbudet kan ställas in via mobilapplikationen eller kundportalen.\n\n11. Rätten till inspektion av den registrerade datan\nUppgiftsämnet har rätt att inspektera de personuppgifter som lagras i registret och få kopior av det gratis upp till en gång om året.\n\nBegäran om verifiering måste göras via e-post från en e-postadress som kan verifieras av registret för att tillhöra den registrerade.\n\n12. Korrigering av information\nKontrollern ska korrigera, radera eller komplettera personuppgifter i registret som är felaktiga, onödiga, ofullständiga eller föråldrade i syfte att behandla sitt eget initiativ eller på begäran av den registrerade. Dessutom kan personuppgifter raderas om kunden missbrukar tjänsten eller engagerar sig i kriminella eller andra förbjudna aktiviteter med tjänsten.` }, { language: `en`, value: `Sections 10 and 24 of the Personal Data Act 22.4.1999 / 523\nPrepared: 16.10.2019\n\n1.	The Registrar\nRenta Group Oy\nBusiness ID: 2732388-9\nAddress: Äyritie 12B, 01510 Vantaa Finland\n\n2.	The person responsible for registration and / or the contact person\nCIO Joel Särkkä\nPhone number: +35850 323 5569\nEmail: joel.sarkka@renta.fi\n\n3.	Name of the register\nUser register of Renta Group Oy's Renta Task application.\n\n4.	Purpose of the processing of personal data\nRenta Group Oy and its subsidiaries process personal data in the personal identification service, credit information verification, direct marketing, customer communications, to meet employment requirements, and to enable invoicing and personal customer service.\n\nIn addition, the inclusion of the register in the processing of personal data enables logging in to the service, ordering and producing the service, and developing the service.\n\n5.	Information content of the register\nThe following information can be processed in the register:\n•	Basic information of the data subject\n        o	name\n        o	personal identification number\n        o	mail address\n        o	phone number\n        o	e-mail address\n        o	Position in the company\n        o	Consent of the data subject to direct marketing\n•	Company information\n        o	customer related information\n        o	service history\n        o	credit data entries\n        o	 other entries entered by the customer\n•	Technical information\n        o	location information\n        o	IP address\n        o	Device identification\n        o	advertising ID\n        o	operating system\n        o	browser type\n        o	other hardware details\n\n6. Regular sources of information\nPersonal information is collected from the registrant himself and through the Intrum credit information service.\n\n7. Regular data transfers and data transfers outside the EU or the European Economic Area\nThe data will not be disclosed outside the EU or the EEA.\n\n8. Use of cookies in the online service\nWe use cookies in the online service. A cookie is a small text file stored on a user's computer that enables safe, efficient and user-friendly use of the service.\n\nYou can disable and delete cookies in your browser settings.\n\n9. Registry Security Principles\nThe personal data contained in the register will always be treated as confidential. The principles of processing the data contained in the register are instructed and documented in the organizations processing the data.\n\nThe information system is protected by a firewall.\n\nOn the website, data transfer is secured with an SSL-secured connection.\n\n10. Right of prohibition of the data subject\nThe data subject shall have the right to prohibit the controller from processing personal data concerning him or her for direct mail, distance selling and other direct marketing, as well as for market and opinion research, as well as for personal registration and genealogy. The ban can be set via the mobile application or the customer portal.\n\n11. Right of inspection of the data subject\nThe data subject has the right to inspect the personal data stored in the register and to receive copies of it free of charge up to once a year.\n\nThe request for verification must be made by e-mail from an e-mail address that can be verified by the register to belong to the data subject.\n\n12. Correction of information\nThe controller shall correct, delete or supplement personal data in the register that are incorrect, unnecessary, incomplete or out of date for the purpose of processing on its own initiative or at the request of the data subject. In addition, personal data may be deleted if the customer misuses the service or engages in criminal or other prohibited activities using the service.` },);
        this.set(this.myAccountPageUserAlreadyExistsLanguageItemName, { language: `fi`, value: `Käyttäjä, jolla on sama sähköposti- tai puhelinnumero, on jo olemassa.` }, { language: `sv`, value: `Användare med samma e -post eller telefonnummer finns redan.` }, { language: `en`, value: `User with same email or phone number already exists.` },);
        this.set(this.organizationPanelExternalAddressLanguageItemName, { language: `fi`, value: `Osoite` }, { language: `sv`, value: `Extern adress` }, { language: `en`, value: `External address` },);
        this.set(this.organizationPanelExternalIdLanguageItemName, { language: `fi`, value: `Ulkoinen id` }, { language: `sv`, value: `Externt ID` }, { language: `en`, value: `External id` },);
        this.set(this.rentaTasksDashboardSignOutLanguageItemName, { language: `fi`, value: `Kirjaudu ulos` }, { language: `sv`, value: `Logga ut` }, { language: `en`, value: `Sign-out` },);
        this.set(this.sendWorkReportModalEmailExistsLanguageItemName, { language: `fi`, value: `Kyseisellä sähköpostilla tai numerolla löytyy jo käyttäjä` }, { language: `sv`, value: `Användare med tillhandahållen e -post eller telefonnummer finns redan` }, { language: `en`, value: `User with provided email or phone number already exists` },);
        this.set(this.splitModuleSubTitleLanguageItemName, { language: `fi`, value: `Jaa moduuli osiin` }, { language: `sv`, value: `Delad modul på delar` }, { language: `en`, value: `Split module on parts` },);
        this.set(this.splitModuleTitleLanguageItemName, { language: `fi`, value: `Jakaa` }, { language: `sv`, value: `Dela` }, { language: `en`, value: `Split` },);
        this.set(this.subcontractorPanelDeleteSubcontractorLanguageItemName, { language: `fi`, value: `Poista aliurakoitsija varastosta` }, { language: `sv`, value: `Radera underleverantör från depå` }, { language: `en`, value: `Delete subcontractor from warehouse` },);
        this.set(this.subcontractorPanelRestoreSubcontractorLanguageItemName, { language: `fi`, value: `Palauta poistettu aliurakoitsija` }, { language: `sv`, value: `Återställa borttagen underleverantör` }, { language: `en`, value: `Restore deleted subcontractor` },);
        this.set(this.taskExtraChangeGridNoExtraChargesLanguageItemName, { language: `fi`, value: `Ei lisämaksuja` }, { language: `sv`, value: `Inga försäljningsartiklar` }, { language: `en`, value: `No extra charges` },);
        this.set(this.taskExtraChangePanelExtraChargeTypeLanguageItemName, { language: `fi`, value: `Lisämaksutyyppi` }, { language: `sv`, value: `Extra laddningstyp` }, { language: `en`, value: `Extra charge type` },);
        this.set(this.tasksPanelAddExtraChargeConfirmationLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat poistaa lisämaksun?` }, { language: `sv`, value: `Är du säker på att du vill ta bort försäljningsartiklar?` }, { language: `en`, value: `Are you sure that you want to delete extra charge?` },);
        this.set(this.tasksPanelAddExtraChargeFlyoutLanguageItemName, { language: `fi`, value: `Lisämaksu tehtävälle on luotu` }, { language: `sv`, value: `Extra avgift för uppdraget skapades framgångsrikt` }, { language: `en`, value: `Extra charge for task was created successfully` },);
        this.set(this.tasksPanelAddExtraChargeModalAmountLanguageItemName, { language: `fi`, value: `Määrä` }, { language: `sv`, value: `Kvantitet` }, { language: `en`, value: `Amount` },);
        this.set(this.tasksPanelAddExtraChargeModalPriceLanguageItemName, { language: `fi`, value: `Hinta` }, { language: `sv`, value: `Pris` }, { language: `en`, value: `Price` },);
        this.set(this.tasksPanelAddExtraChargeModalSubmitLanguageItemName, { language: `fi`, value: `Lisää lisämaksu` }, { language: `sv`, value: `Lägg till försäljningsartiklar` }, { language: `en`, value: `Add extra charge` },);
        this.set(this.tasksPanelAddExtraChargeModalSubtitleLanguageItemName, { language: `fi`, value: `Lisää tehtävälle lisämaksut` }, { language: `sv`, value: `Lägg till uppgifter försäljningsartiklar` }, { language: `en`, value: `Add tasks extra charges` },);
        this.set(this.tasksPanelAddExtraChargeModalTitleLanguageItemName, { language: `fi`, value: `Tehtävän lisämaksut` }, { language: `sv`, value: `Uppgift försäljningsartiklar` }, { language: `en`, value: `Task extra charges` },);
        this.set(this.tasksPanelAddExtraChargeModalTypeLanguageItemName, { language: `fi`, value: `Tyyppi` }, { language: `sv`, value: `Typ` }, { language: `en`, value: `Type` },);
        this.set(this.tasksPanelAddExtraChargeModalUnitLanguageItemName, { language: `fi`, value: `Yksikkö` }, { language: `sv`, value: `Enhet` }, { language: `en`, value: `Unit` },);
        this.set(this.tasksPanelAgreementLanguageItemName, { language: `fi`, value: `Maksuerätaulukko` }, { language: `sv`, value: `Avtal` }, { language: `en`, value: `Agreement` },);
        this.set(this.tasksPanelApproveTaskLanguageItemName, { language: `fi`, value: `Hyväksy tehtävä ja luo laskurivi` }, { language: `sv`, value: `Godkänn uppdrag för att lägga till fakturerings rad` }, { language: `en`, value: `Approve task to create a invoice row` },);
        this.set(this.tasksPanelChangeWorkReportTitleLanguageItemName, { language: `fi`, value: `Muokkaa Työraporttia` }, { language: `sv`, value: `Ändra arbetsrapport` }, { language: `en`, value: `Change Work Report` },);
        this.set(this.tasksPanelComplitionDateLanguageItemName, { language: `fi`, value: `Tehtävän valmistumis päivämäärä` }, { language: `sv`, value: `Datum när uppdrag slutfördes` }, { language: `en`, value: `Date when task was completed` },);
        this.set(this.tasksPanelCostLanguageItemName, { language: `fi`, value: `Kustannus` }, { language: `sv`, value: `Kostnad` }, { language: `en`, value: `Cost` },);
        this.set(this.tasksPanelCreateExtraModuleLanguageItemName, { language: `fi`, value: `Luo extra moduuli` }, { language: `sv`, value: `Skapa extra modul` }, { language: `en`, value: `Create extra module` },);
        this.set(this.tasksPanelCreateModuleLanguageItemName, { language: `fi`, value: `Luo moduuli` }, { language: `sv`, value: `Skapa modul` }, { language: `en`, value: `Create module` },);
        this.set(this.tasksPanelCreateTaskWorkReportLanguageItemName, { language: `fi`, value: `Luo tehtävä työraporttiin` }, { language: `sv`, value: `Skapa uppdrags arbetsrapport` }, { language: `en`, value: `Create task to work report` },);
        this.set(this.tasksPanelDateLanguageItemName, { language: `fi`, value: `Päivämäärä` }, { language: `sv`, value: `Datum` }, { language: `en`, value: `Date` },);
        this.set(this.tasksPanelRentTabTitleLanguageItemName, { language: `fi`, value: `Vuokra` }, { language: `sv`, value: `Hyr` }, { language: `en`, value: `Rent` },);
        this.set(this.tasksPanelSaveWorkReportTitleLanguageItemName, { language: `fi`, value: `Tallenna Työraportti` }, { language: `sv`, value: `Spara arbetsrapport` }, { language: `en`, value: `Save Work Report` },);
        this.set(this.tasksPanelTaskExtraChargesLanguageItemName, { language: `fi`, value: `Tehtävän lisämaksut` }, { language: `sv`, value: `uppdrag försäljnings artiklar` }, { language: `en`, value: `Task extra charges` },);
        this.set(this.tasksPanelTaskHoursLanguageItemName, { language: `fi`, value: `Tehtävän tunnit` }, { language: `sv`, value: `Arbetstimmar` }, { language: `en`, value: `Task hours` },);
        this.set(this.taskTooltipsTaskApprovedLanguageItemName, { language: `fi`, value: `Tehtävä suoritettu ja hyväksytty` }, { language: `sv`, value: `Uppdraget är klar och godkänd` }, { language: `en`, value: `Task is completed and approved` },);
        this.set(this.taskTooltipsTaskInProgressLanguageItemName, { language: `fi`, value: `Tehtävä tekeillä` }, { language: `sv`, value: `Uppdrag i processen` }, { language: `en`, value: `Task in process` },);
        this.set(this.taskTooltipsTaskInvoicedLanguageItemName, { language: `fi`, value: `Tehtävä laskutettu` }, { language: `sv`, value: `uppdrag faktureras` }, { language: `en`, value: `Task is invoiced` },);
        this.set(this.taskTooltipsTaskReadyForInvoicingLanguageItemName, { language: `fi`, value: `Tehtävä valmiina laskutettavaksi (laskurivi hyväksytty)` }, { language: `sv`, value: `uppdrag är redo att faktureras (fakturadrad skapad och godkänd)` }, { language: `en`, value: `Task is ready to be invoiced (invoice row created and approved)` },);
        this.set(this.taskTooltipsTaskWaitingActivationLanguageItemName, { language: `fi`, value: `Tehtävä odottaa aloituspäivämäärää` }, { language: `sv`, value: `uppdrag väntar på aktiveringsdatum` }, { language: `en`, value: `Task is waiting for activation date` },);
        this.set(this.taskTooltipsTaskWaitingApprovalLanguageItemName, { language: `fi`, value: `Tehtävä suoritettu ja odottaa hyväksyntää` }, { language: `sv`, value: `Uppdraget är klar och väntar på att godkänna` }, { language: `en`, value: `Task is completed, waiting for approving` },);
        this.set(this.topNavConstructionSiteManagementLanguageItemName, { language: `fi`, value: `Työmaan hallinta` }, { language: `sv`, value: `Byggnadshantering` }, { language: `en`, value: `Construction site management` },);
        this.set(this.validatorsLengthLanguageItemName, { language: `fi`, value: `Teksti on lian lyhyt` }, { language: `sv`, value: `Texten är för kort` }, { language: `en`, value: `Text is too short` },);
        this.set(this.workDayAllowanceDistanceLanguageItemName, { language: `fi`, value: `Etäisyys` }, { language: `sv`, value: `Distans` }, { language: `en`, value: `Distance` },);
        this.set(this.workDayPanelContractLanguageItemName, { language: `fi`, value: `Urakka` }, { language: `sv`, value: `Kontrakt` }, { language: `en`, value: `Contract` },);
        this.set(this.workDayPanelCompensationsLanguageItemName, { language: `fi`, value: `Korvaukset` }, { language: `sv`, value: `Kompensationer` }, { language: `en`, value: `Compensations` },);
        this.set(this.workDayPanelPassengersDescriptionLanguageItemName, { language: `fi`, value: `Määrä matkustajia kyydissä` }, { language: `sv`, value: `Mängden människor du reste med` }, { language: `en`, value: `Amount of people you traveled with` },);
        this.set(this.userManagementGridNoInvitationsTextLanguageItemName, { language: `fi`, value: `Yhtään kutsua ei ole lähetetty.` }, { language: `sv`, value: `Inga inbjudningar har skickats` }, { language: `en`, value: `No invitations has been sent` },);
        this.set(this.userManagementButtonResendInvitationLanguageItemName, { language: `fi`, value: `Lähetä kutsu uudelleen` }, { language: `sv`, value: `Återgå till inbjudan` }, { language: `en`, value: `Resend invitation` },);
        this.set(this.userManagementButtonResetPasswordLanguageItemName, { language: `fi`, value: `Aseta salasana uudelleen` }, { language: `sv`, value: `Återställ lösenord` }, { language: `en`, value: `Reset password` },);
        this.set(this.userManagementLabelAuthenticationTypeLanguageItemName, { language: `fi`, value: `Autentikointitapa` }, { language: `sv`, value: `Autentiseringstyp` }, { language: `en`, value: `Authentication type` },);
        this.set(this.enumAuthTypeEmailLanguageItemName, { language: `fi`, value: `Sähköposti` }, { language: `sv`, value: `E-post` }, { language: `en`, value: `Email` },);
        this.set(this.enumAuthTypePhoneLanguageItemName, { language: `fi`, value: `SMS` }, { language: `sv`, value: `SMS` }, { language: `en`, value: `SMS` },);
        this.set(this.userManagementTabInvitationsLanguageItemName, { language: `fi`, value: `Kutsut` }, { language: `sv`, value: `Inbjudningar` }, { language: `en`, value: `Invitations` },);
        this.set(this.userManagementConfirmationButtonResetPasswordLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat uusia salasanan käyttäjätilille "{0}"?` }, { language: `sv`, value: `Är du säker på att du vill återställa lösenord för användaren "{0}"?` }, { language: `en`, value: `Are you sure you want to reset password for user "{0}"?` },);
        this.set(this.userManagementConfirmationButtonResendInvitationLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat luoda käyttäjän "{0}"?` }, { language: `sv`, value: `Är du säker på att du vill bjuda in användare "{0}"?` }, { language: `en`, value: `Are you sure you want to invite user "{0}"?` },);
        this.set(this.userManagementAlertUserPasswordInfoLanguageItemName, { language: `fi`, value: `Käyttäjätilillä "{0}" ei ole salasanaa.` }, { language: `sv`, value: `Användarkonto "{0}" har inget lösenord.` }, { language: `en`, value: `User account "{0}" does not have a password.` },);
        this.set(this.userManagementGridCreatedByLanguageItemName, { language: `fi`, value: `Luonut` }, { language: `sv`, value: `Skapad av` }, { language: `en`, value: `Created by` },);
        this.set(this.userManagementGridTypeLanguageItemName, { language: `fi`, value: `Tyyppi` }, { language: `sv`, value: `Typ` }, { language: `en`, value: `Type` },);
        this.set(this.userManagementGridCreatedAtLanguageItemName, { language: `fi`, value: `Luotu` }, { language: `sv`, value: `Skapad vid` }, { language: `en`, value: `Created at` },);
        this.set(this.userManagementGridExpiresAtLanguageItemName, { language: `fi`, value: `Umpeutuu` }, { language: `sv`, value: `Löper ut på` }, { language: `en`, value: `Expires at` },);
        this.set(this.userManagementGridProcessedAtLanguageItemName, { language: `fi`, value: `Käsitelty` }, { language: `sv`, value: `Bearbetad på` }, { language: `en`, value: `Processed At` },);
        this.set(this.userManagementGridReusableLanguageItemName, { language: `fi`, value: `Uudelleenkäytettävä` }, { language: `sv`, value: `Återanvändbar` }, { language: `en`, value: `Reusable` },);
        this.set(this.userManagementGridAuthTypeLanguageItemName, { language: `fi`, value: `Autentikointitapa` }, { language: `sv`, value: `Autor` }, { language: `en`, value: `Auth type` },);
        this.set(this.userManagementAlertMessageAccountSavedLanguageItemName, { language: `fi`, value: `Käyttäjätili "{0}" tallennettu.` }, { language: `sv`, value: `Användarkonto "{0}" sparat framgångsrikt.` }, { language: `en`, value: `User account "{0}" saved successfully.` },);
        this.set(this.userManagementAlertErrorAccountExistLanguageItemName, { language: `fi`, value: `Käyttäjätili "{0}" on jo olemassa.` }, { language: `sv`, value: `Användarkonto "{0}" finns redan.` }, { language: `en`, value: `User account "{0}" already exist.` },);
        this.set(this.userManagementAlertErrorPhoneNumberInvalidLanguageItemName, { language: `fi`, value: `Puhelinnumero on virheellinen.` }, { language: `sv`, value: `Telefonnummer är ogiltigt.` }, { language: `en`, value: `Phone number is invalid.` },);
        this.set(this.forgotPasswordUsernameInputLanguageItemName, { language: `fi`, value: `Sähköposti tai puhelinnumero` }, { language: `sv`, value: `E -post eller telefonnummer` }, { language: `en`, value: `Email or phone number` },);
        this.set(this.enumInvitationTypeInvitationLanguageItemName, { language: `fi`, value: `Kutsu` }, { language: `sv`, value: `Inbjudan` }, { language: `en`, value: `Invitation` },);
        this.set(this.enumInvitationTypeResetPasswordLanguageItemName, { language: `fi`, value: `Aseta uusi salasana` }, { language: `sv`, value: `Återställ lösenord` }, { language: `en`, value: `Reset password` },);
        this.set(this.enumInvitationTypeForgotPasswordLanguageItemName, { language: `fi`, value: `Unohditko salasanan` }, { language: `sv`, value: `glömt ditt lösenord` }, { language: `en`, value: `Forgot password` },);
        this.set(this.userManagementConfirmationButtonRollbackLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat tyhjätä tehdyt muutokset?` }, { language: `sv`, value: `Är du säker på att du vill återföra osparade ändringar?` }, { language: `en`, value: `Are you sure that you want to rollback unsaved changes?` },);
        this.set(this.addWorkReportModalAttachmentsLanguageItemName, { language: `fi`, value: `Liitteet` }, { language: `sv`, value: `Bilagor` }, { language: `en`, value: `Attachments` },);
        this.set(this.confirmationDialogCommentLanguageItemName, { language: `fi`, value: `Ole hyvä ja kommentoi` }, { language: `sv`, value: `Var vänlig och lämna en kommentar` }, { language: `en`, value: `Please leave a comment` },);
        this.set(this.componentConfirmationDialogAreYouSureLanguageItemName, { language: `fi`, value: `Oletko varma?` }, { language: `sv`, value: `Är du säker?` }, { language: `en`, value: `Are you sure?` },);
        this.set(this.locationPickerModalTitleLanguageItemName, { language: `fi`, value: `Sijaintivalitsin` }, { language: `sv`, value: `Platsväljare` }, { language: `en`, value: `Location picker` },);
        this.set(this.locationPickerModalSubtitleLanguageItemName, { language: `fi`, value: `Valitse sijainti kartalla` }, { language: `sv`, value: `Välj plats på kartan` }, { language: `en`, value: `Choose location on map` },);
        this.set(this.locationPickerModalSetLocationLanguageItemName, { language: `fi`, value: `Aseta sijainti` }, { language: `sv`, value: `Ställ in plats` }, { language: `en`, value: `Set location` },);
        this.set(this.rentaTasksControllerSignInExpirationAlertLanguageItemName, { language: `fi`, value: `Järjestelmä on kirjannut sinut automaattisesti ulos.\nKirjaudu uudestaan työmaalle jatkaaksesi työskentelyä.` }, { language: `sv`, value: `Arbetssessionen har löpt ut!` }, { language: `en`, value: `The working session is expired!\nPlease sign-in to the construction site again to continue work.` },);
        this.set(this.widgetPwaInstallLanguageItemName, { language: `fi`, value: `Asenna` }, { language: `sv`, value: `Installera` }, { language: `en`, value: `Install` },);
        this.set(this.widgetPwaDescriptionLanguageItemName, { language: `fi`, value: `Lisää sovellus aloitusnäytölle` }, { language: `sv`, value: `Lägg till applikation på hemskärmen` }, { language: `en`, value: `Add application to the home screen` },);
        this.set(this.widgetBudgetDataModuleLabelLanguageItemName, { language: `fi`, value: `Moduuli` }, { language: `sv`, value: `Modul` }, { language: `en`, value: `Module` },);
        this.set(this.widgetBudgetDataPerimeterFrameLabelLanguageItemName, { language: `fi`, value: `Kehäteline` }, { language: `sv`, value: `Omkretsram` }, { language: `en`, value: `Perimeter frame` },);
        this.set(this.widgetBudgetDataWeatherShelterLabelLanguageItemName, { language: `fi`, value: `Sääsuoja` }, { language: `sv`, value: `Väderskydd` }, { language: `en`, value: `Weather shelter` },);
        this.set(this.tasksPanelAddExtraChargeModalDescriptionLanguageItemName, { language: `fi`, value: `Kommentti` }, { language: `sv`, value: `Kommentar` }, { language: `en`, value: `Comment` },);
        this.set(this.addWorkReportModalDeleteConfirmLanguageItemName, { language: `fi`, value: `Haluatko varmasti poistaa työraportin?` }, { language: `sv`, value: `Vill du verkligen ta bort den här arbetsrapporten?` }, { language: `en`, value: `Do you really want to delete this work report?` },);
        this.set(this.constructionSitesConfirmationActivateSiteLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat aktivoida työmaan \n "{0}"?` }, { language: `sv`, value: `Är du säker, du vill aktivera byggarbetsplatsen \n "{0}"?` }, { language: `en`, value: `Are you sure, you want to activate construction site \n "{0}"?` },);
        this.set(this.constructionSitesConfirmationDeactivateSiteLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat sulkea työmaan? \n "{0}"?` }, { language: `sv`, value: `Är du säker, du vill inaktivera byggarbetsplatsen \n "{0}"?` }, { language: `en`, value: `Are you sure, you want to deactivate construction site \n "{0}"?` },);
        this.set(this.addConstructionSiteInvoiceReferenceLanguageItemName, { language: `fi`, value: `Laskuviite` }, { language: `sv`, value: `Fakturareferens` }, { language: `en`, value: `Invoice reference` },);
        this.set(this.addConstructionSiteHourPriceLanguageItemName, { language: `fi`, value: `Oletus tuntihinta` }, { language: `sv`, value: `Standardtimpris` }, { language: `en`, value: `Default hour price` },);
        this.set(this.addConstructionSiteMileagePriceLanguageItemName, { language: `fi`, value: `Oletus kilometrikorvaus` }, { language: `sv`, value: `Km kostnad` }, { language: `en`, value: `Default mileage price` },);
        this.set(this.componentHoursWidgetHoursSpentLanguageItemName, { language: `fi`, value: `Tehtävään käytetyt tunnit` }, { language: `sv`, value: `Timmar som spenderas för uppgift` }, { language: `en`, value: `Hours spent for task` },);
        this.set(this.componentHoursWidgetAddOvertimeLanguageItemName, { language: `fi`, value: `Lisää ylityö` }, { language: `sv`, value: `Lägg till övertid` }, { language: `en`, value: `Add overtime` },);
        this.set(this.componentHoursWidgetNormalHoursLanguageItemName, { language: `fi`, value: `Normaali` }, { language: `sv`, value: `Vanligt` }, { language: `en`, value: `Normal` },);
        this.set(this.summaryWidgetTitleLanguageItemName, { language: `fi`, value: `Työraportin yhteenveto` }, { language: `sv`, value: `Sammanfattning av arbetsrapporten` }, { language: `en`, value: `Work report summary` },);
        this.set(this.summaryWidgetOrdererLanguageItemName, { language: `fi`, value: `Tilaaja:` }, { language: `sv`, value: `Beställare:` }, { language: `en`, value: `Orderer:` },);
        this.set(this.summaryWidgetApproverLanguageItemName, { language: `fi`, value: `Työtilauksen kuittaaja:` }, { language: `sv`, value: `Godkännare:` }, { language: `en`, value: `Approver:` },);
        this.set(this.summaryWidgetButtonCreateApproverLanguageItemName, { language: `fi`, value: `Lisää uusi työtilauksen kuittaaja` }, { language: `sv`, value: `Skapa ny godkännare` }, { language: `en`, value: `Create new approver` },);
        this.set(this.summaryWidgetWorkOrderNameLanguageItemName, { language: `fi`, value: `Työraportin nimi:` }, { language: `sv`, value: `Arbetsrapportens namn:` }, { language: `en`, value: `Work report name:` },);
        this.set(this.summaryWidgetWorkOrderDescriptionLanguageItemName, { language: `fi`, value: `Kuvaus:` }, { language: `sv`, value: `Beskrivning:` }, { language: `en`, value: `Description:` },);
        this.set(this.genericNoDataLanguageItemName, { language: `fi`, value: `Ei tietoja` }, { language: `sv`, value: `Inga data` }, { language: `en`, value: `No data` },);
        this.set(this.createContractPersonModalSubtitleLanguageItemName, { language: `fi`, value: `Lisää uusi työtilauksen kuittaaja` }, { language: `sv`, value: `Skapa ny godkännare` }, { language: `en`, value: `Create new approver` },);
        this.set(this.workOrdersPageTitleLanguageItemName, { language: `fi`, value: `Työtilaukset` }, { language: `sv`, value: `Arbetsorder` }, { language: `en`, value: `Work orders` },);
        this.set(this.workOrdersActiveListNoOrdersLanguageItemName, { language: `fi`, value: `Ei aktiivisia työtilauksia` }, { language: `sv`, value: `Inga aktiva arbetsorder.` }, { language: `en`, value: `No active work orders.` },);
        this.set(this.workOrdersActiveListTitleLanguageItemName, { language: `fi`, value: `Aktiivisia työtilauksia: {0}.` }, { language: `sv`, value: `Aktiva arbetsorder: {0}.` }, { language: `en`, value: `Active work orders: {0}.` },);
        this.set(this.workOrdersCompletedListNoOrdersLanguageItemName, { language: `fi`, value: `Ei valmistuneita työtilauksia.` }, { language: `sv`, value: `Inga genomförda arbetsorder.` }, { language: `en`, value: `No completed work orders.` },);
        this.set(this.workOrdersCompletedListTitleLanguageItemName, { language: `fi`, value: `Valmistuneet työtilaukset: {0}.` }, { language: `sv`, value: `Slutförda arbetsordrar: {0}.` }, { language: `en`, value: `Completed work orders: {0}.` },);
        this.set(this.workOrdersFiltersConstructionSiteLanguageItemName, { language: `fi`, value: `Työmaa` }, { language: `sv`, value: `Byggarbetsplats` }, { language: `en`, value: `Construction site` },);
        this.set(this.workOrdersFiltersCustomerLanguageItemName, { language: `fi`, value: `Asiakas` }, { language: `sv`, value: `Kund` }, { language: `en`, value: `Customer` },);
        this.set(this.workOrdersFiltersDateLanguageItemName, { language: `fi`, value: `Päivämäärä` }, { language: `sv`, value: `Datum` }, { language: `en`, value: `Date` },);
        this.set(this.workOrdersFiltersFromLanguageItemName, { language: `fi`, value: `Alkaen` }, { language: `sv`, value: `Från` }, { language: `en`, value: `From` },);
        this.set(this.workOrdersFiltersNameLanguageItemName, { language: `fi`, value: `Työtilauksen nimi` }, { language: `sv`, value: `Arbetsordernamn` }, { language: `en`, value: `Work order name` },);
        this.set(this.workOrdersFiltersStatusesLanguageItemName, { language: `fi`, value: `Työtilauksen tilat` }, { language: `sv`, value: `Arbetsorderstatus` }, { language: `en`, value: `Work order statuses` },);
        this.set(this.workOrdersFiltersToLanguageItemName, { language: `fi`, value: `Päättyen` }, { language: `sv`, value: `Till` }, { language: `en`, value: `To` },);
        this.set(this.workOrdersFiltersButtonApplyLanguageItemName, { language: `fi`, value: `Käytä` }, { language: `sv`, value: `Tillämpa` }, { language: `en`, value: `Apply` },);
        this.set(this.workOrdersFiltersButtonClearLanguageItemName, { language: `fi`, value: `Tyhjennä` }, { language: `sv`, value: `Klar` }, { language: `en`, value: `Clear` },);
        this.set(this.enumWorkOrderStatusApprovedByCustomerLanguageItemName, { language: `fi`, value: `Asiakkaan hyväksymä` }, { language: `sv`, value: `Godkänd av kunden` }, { language: `en`, value: `Approved by customer` },);
        this.set(this.enumWorkOrderStatusApprovedByManagerLanguageItemName, { language: `fi`, value: `Työnjohtajan hyväksymä` }, { language: `sv`, value: `Godkänd av Montageledare` }, { language: `en`, value: `Approved by manager` },);
        this.set(this.enumWorkOrderStatusCompletedLanguageItemName, { language: `fi`, value: `Valmistunut` }, { language: `sv`, value: `Avslutad` }, { language: `en`, value: `Completed` },);
        this.set(this.enumWorkOrderStatusCreatedLanguageItemName, { language: `fi`, value: `Luotu` }, { language: `sv`, value: `Skapad` }, { language: `en`, value: `Created` },);
        this.set(this.enumWorkOrderStatusDeclinedByCustomerLanguageItemName, { language: `fi`, value: `Asiakkaan hylkäämä` }, { language: `sv`, value: `Avvisas av kunden` }, { language: `en`, value: `Declined by customer` },);
        this.set(this.enumWorkOrderStatusDeclinedByManagerLanguageItemName, { language: `fi`, value: `Työnjohtajan hylkäämä` }, { language: `sv`, value: `Avvisas av Montageledare` }, { language: `en`, value: `Declined by manager` },);
        this.set(this.enumWorkOrderStatusDeletedLanguageItemName, { language: `fi`, value: `Poistettu` }, { language: `sv`, value: `Raderade` }, { language: `en`, value: `Deleted` },);
        this.set(this.enumWorkOrderStatusHasActiveTasksDescriptionLanguageItemName, { language: `fi`, value: `Aktiivisia mutta ei valmistuneita tehtäviä` }, { language: `sv`, value: `Har aktiverat, men inte slutförda uppgifter` }, { language: `en`, value: `Has activated, but not completed tasks` },);
        this.set(this.enumWorkOrderStatusInvoicedLanguageItemName, { language: `fi`, value: `Laskutettu` }, { language: `sv`, value: `Fakturerad` }, { language: `en`, value: `Invoiced` },);
        this.set(this.enumWorkOrderStatusInProgressLanguageItemName, { language: `fi`, value: `Käynnissä` }, { language: `sv`, value: `Pågående` }, { language: `en`, value: `In progress` },);
        this.set(this.enumWorkOrderStatusInvoiceNotCreatedDescriptionLanguageItemName, { language: `fi`, value: `Hyväksyttyjä mutta Pagerolle lähettämättömiä laskuja` }, { language: `sv`, value: `Har godkänt, men inte skickat till Pagero -fakturor` }, { language: `en`, value: `Has approved, but not sent to Pagero invoices` },);
        this.set(this.enumWorkOrderStatusSentToCustomerLanguageItemName, { language: `fi`, value: `Lähetetty asiakkaalle` }, { language: `sv`, value: `Skickas till kunden` }, { language: `en`, value: `Sent to customer` },);
        this.set(this.enumWorkOrderStatusInvoiceRowsNotApprovedNyManagerDescriptionLanguageItemName, { language: `fi`, value: `Hyväksymättömiä laskurivejä` }, { language: `sv`, value: `Har inte godkänt fakturarader` }, { language: `en`, value: `Has not approved invoice rows` },);
        this.set(this.enumWorkOrderStatusUnknownLanguageItemName, { language: `fi`, value: `Tuntematon` }, { language: `sv`, value: `Okänd` }, { language: `en`, value: `Unknown` },);
        this.set(this.enumWorkOrderStatusTaskNotApprovedByManagerDescriptionLanguageItemName, { language: `fi`, value: `Valmistuneita mutta hyväksymättömiä tehtäviä` }, { language: `sv`, value: `Har slutfört, men inte godkända uppgifter` }, { language: `en`, value: `Has completed, but not approved tasks` },);
        this.set(this.enumWorkOrderStatusWorkReportNotApprovedByCustomerDescriptionLanguageItemName, { language: `fi`, value: `Hyväksymättömiä työraportteja` }, { language: `sv`, value: `Har inte godkänt arbetsrapporter` }, { language: `en`, value: `Has not approved work reports` },);
        this.set(this.enumWorkOrderStatusWorkReportNotSentDescriptionLanguageItemName, { language: `fi`, value: `Raportteja lähettämättä, joissa hyväksyntätyyppi "sähköposti"` }, { language: `sv`, value: `Har inte skickat arbetsrapporter med godkännande typ "E -post"` }, { language: `en`, value: `Has not sent work reports with approving type "Email"` },);
        this.set(this.enumFiltersBehaviorSystemDefaultLanguageItemName, { language: `fi`, value: `Järjestelmän oletus` }, { language: `sv`, value: ` System Standard` }, { language: `en`, value: `System default` },);
        this.set(this.enumFiltersBehaviorUserSpecifiedLanguageItemName, { language: `fi`, value: `Muista minun valinnat` }, { language: `sv`, value: `Kom ihåg mina val` }, { language: `en`, value: `Remember my selections` },);
        this.set(this.workOrdersFiltersModalTitleActiveLanguageItemName, { language: `fi`, value: `Aktiivisten työtilausten filtterit` }, { language: `sv`, value: `Aktiva arbetsorder filter` }, { language: `en`, value: `Active work orders filters` },);
        this.set(this.workOrdersFiltersModalTitleCompletedLanguageItemName, { language: `fi`, value: `Valmistuneiden työtilausten filtterit` }, { language: `sv`, value: `Avslutade arbetsorderfilter` }, { language: `en`, value: `Completed work orders filters` },);
        this.set(this.workOrdersModalActionsActivateLanguageItemName, { language: `fi`, value: `Aktivoi` }, { language: `sv`, value: `Aktivera` }, { language: `en`, value: `Activate` },);
        this.set(this.workOrdersModalActionsApproveLanguageItemName, { language: `fi`, value: `Hyväksy` }, { language: `sv`, value: `Godkänna` }, { language: `en`, value: `Approve` },);
        this.set(this.workOrdersModalActionsCompleteLanguageItemName, { language: `fi`, value: `Valmista` }, { language: `sv`, value: `Komplett` }, { language: `en`, value: `Complete` },);
        this.set(this.workOrdersModalActionsEditLanguageItemName, { language: `fi`, value: `Muokkaa` }, { language: `sv`, value: `Redigera` }, { language: `en`, value: `Edit` },);
        this.set(this.workOrdersActionsModalTitleLanguageItemName, { language: `fi`, value: `Työtilauksen toiminnot` }, { language: `sv`, value: `Arbetsorderåtgärder` }, { language: `en`, value: `Work order actions` },);
        this.set(this.workOrdersAlertMessageWorkOrderActivatedLanguageItemName, { language: `fi`, value: `Työtilaus "{0}" on aktivoitu` }, { language: `sv`, value: `Arbetsorder "{0}" har aktiverats` }, { language: `en`, value: `Work order "{0}" has been activated` },);
        this.set(this.workOrdersAlertMessageWorkOrderCompletedLanguageItemName, { language: `fi`, value: `Työtilaus "{0}" on valmistunut` }, { language: `sv`, value: `Arbetsorder "{0}" har slutförts` }, { language: `en`, value: `Work order "{0}" has been completed` },);
        this.set(this.workOrdersApprovedAlertLanguageItemName, { language: `fi`, value: `Työtilaus merkitty hyväksytyksi` }, { language: `sv`, value: `Arbetsorder markerad som godkänd` }, { language: `en`, value: `Work order marked as approved` },);
        this.set(this.workOrdersValidationErrorApproverCreationRejectedLanguageItemName, { language: `fi`, value: `Ei voitu luoda hyväksyjää "{0}", ota yhteyttä pääkäyttäjään.` }, { language: `sv`, value: `Kan inte skapa godkännare "{0}". Kontakta administratören.` }, { language: `en`, value: `Cannot create approver "{0}". Please contact administrator.` },);
        this.set(this.sendWorkOrderModalButtonSendOrApproveLanguageItemName, { language: `fi`, value: `Lähetä tai hyväksy` }, { language: `sv`, value: `Skicka eller godkänna` }, { language: `en`, value: `Send or Approve` },);
        this.set(this.approveWorkReportTitleLanguageItemName, { language: `fi`, value: `Merkitse hyväksytyksi` }, { language: `sv`, value: `Mark som godkänd` }, { language: `en`, value: `Mark as approved` },);
        this.set(this.workOrdersOwnerSelectConstructionSiteLanguageItemName, { language: `fi`, value: `Valitse työmaa` }, { language: `sv`, value: `Välj en byggarbetsplats` }, { language: `en`, value: `Select a construction site` },);
        this.set(this.workOrdersActionsSendLanguageItemName, { language: `fi`, value: `Lähetä asiakkaalle` }, { language: `sv`, value: `Skicka till kund` }, { language: `en`, value: `Send to customer` },);
        this.set(this.constructionSiteManagementTabsContractLanguageItemName, { language: `fi`, value: `Työmaan tiedot` }, { language: `sv`, value: `Kundavtal` }, { language: `en`, value: `Customer contract` },);
        this.set(this.constructionSiteManagementTabsWorkOrdersLanguageItemName, { language: `fi`, value: `Työtilaukset` }, { language: `sv`, value: `Arbetsorder` }, { language: `en`, value: `Work orders` },);
        this.set(this.workOrdersActionsLockLanguageItemName, { language: `fi`, value: `Hyväksy laskutettavaksi` }, { language: `sv`, value: `Godkänna fakturering` }, { language: `en`, value: `Approve for invoicing` },);
        this.set(this.workOrdersActionsInvoiceLanguageItemName, { language: `fi`, value: `Laskuta` }, { language: `sv`, value: `Faktura` }, { language: `en`, value: `Invoice` },);
        this.set(this.constructionSitePanelExternalAddressLanguageItemName, { language: `fi`, value: `Ulkoinen osoite` }, { language: `sv`, value: `Extern adress` }, { language: `en`, value: `External address` },);
        this.set(this.dashboardGetManualLanguageItemName, { language: `fi`, value: `Tämä on Renta Taskin etusivu. Etusivulta löydät pikanäppäimet kaikille tarvitsemillesi toiminnoille rooliisi perustuen. Mikäli sinulla on kysymyksiä sovelluksen käytöstä, ota yhteyttä pääkäyttäjään.` }, { language: `sv`, value: `Det här är instrumentpanelsidan med widgetar baserat på din åtkomstroll.` }, { language: `en`, value: `This is Dashboard page with widgets based on Your access role.` },);
        this.set(this.constructionSiteManagementGetManualLanguageItemName, { language: `fi`, value: `Tämä on työmaasivu. Työmaasivulla voit hallinnoida kaikkea työmaahan liittyviä asioita, kuten luoda tehtäviä sekä tarkastaa suoritettuja tehtäviä.` }, { language: `sv`, value: `Detta är en sida för Rentatask -Montageledarna, där de kan skapa nya eller använda befintliga byggarbetsplatser, moduler och uppgifter.` }, { language: `en`, value: `This is a page for RentaTask managers, where they can create new or operate existing construction sites, modules and tasks.` },);
        this.set(this.roleNameManagerLanguageItemName, { language: `fi`, value: `Työnjohtaja` }, { language: `sv`, value: `Montageledare` }, { language: `en`, value: `Manager` },);
        this.set(this.roleNameBusinessManagerLanguageItemName, { language: `fi`, value: `Ylempi työnjohtaja` }, { language: `sv`, value: `Affärsansvarig` }, { language: `en`, value: `Business Manager` },);
        this.set(this.workOrdersPanelNewWorkOrderLanguageItemName, { language: `fi`, value: `Uusi työtilaus` }, { language: `sv`, value: `Ny arbetsorder` }, { language: `en`, value: `New Work Order` },);
        this.set(this.rentaTasksWorkOrdersGetManualLanguageItemName, { language: `fi`, value: `Tämä sivu näyttää kaikki työtilaukset. Voit suodattaa työtilauksia valintasi mukaan sekä käsitellä työtilauksia.` }, { language: `sv`, value: `Den här sidan visar listor över aktiva och färdiga arbetsorder. Du kan filtrera dem, aktivera, redigera, slutföra och godkänna.` }, { language: `en`, value: `This page shows lists of active and completed work orders. You can filter them, activate, edit, complete and approve.` },);
        this.set(this.workOrderActionsConfirmCompletedActivationLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat uudelleen aktivoida hyväksytyn työtilauksen?\nAktivoinnin jälkeen vaaditaan uusi hyväksyntä.` }, { language: `sv`, value: `Är du säker på att du vill aktivera en färdig och godkänd av kundens arbetsorder? Efter aktivering kommer ombekräftelsen att behövas.` }, { language: `en`, value: `Are you sure you want to activate a completed and approved by customer work order? After activation, the re-confirmation will be needed.` },);
        this.set(this.workOrderActionsConfirmActivationLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat aktivoida työtilauksen <mark>{0}</mark>?` }, { language: `sv`, value: `Är du säker på att du vill aktivera arbetsordningen [Mark] {0} [/Mark]?` }, { language: `en`, value: `Are you sure you want to activate the work order <mark>{0}</mark>?` },);
        this.set(this.workOrderActionsConfirmCompletionLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat merkitä työtilauksen <mark>{0}</mark> valmiiksi?` }, { language: `sv`, value: `Är du säker på att du vill slutföra arbetsordern [Mark] {0} [/Mark]?` }, { language: `en`, value: `Are you sure you want to complete the work order <mark>{0}</mark>?` },);
        this.set(this.workOrderActionsUnlockLanguageItemName, { language: `fi`, value: `Avaa työtilauksen lukitus muokataksesi työtilausta.` }, { language: `sv`, value: `Lås upp arbetsorder för att aktivera redigering` }, { language: `en`, value: `Unlock the work order to enable editing` },);
        this.set(this.workOrderActionsConfirmInvoiceLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat merkitä työtilauksen laskutetuksi?` }, { language: `sv`, value: `Är du säker på att du vill markera arbetsordern som fakturerad?` }, { language: `en`, value: `Are you sure you want to mark the work order as invoiced?` },);
        this.set(this.sendWorkOrderModalApproverTitleLanguageItemName, { language: `fi`, value: `Asiakkaan hyväksyjä` }, { language: `sv`, value: `Kundgodkännare` }, { language: `en`, value: `Customer approver` },);
        this.set(this.sendWorkOrderModalOrdererTitleLanguageItemName, { language: `fi`, value: `Asiakkaan tilaaja` }, { language: `sv`, value: `Kundorder` }, { language: `en`, value: `Customer orderer` },);
        this.set(this.sendWorkOrderModalApproverSubtitleLanguageItemName, { language: `fi`, value: `Lisää, luo tai muokkaa hyväksyjää` }, { language: `sv`, value: `Tilldela, skapa eller ändra kundens godkännare` }, { language: `en`, value: `Assign, create or modify the customer approver` },);
        this.set(this.sendWorkOrderModalOrdererSubtitleLanguageItemName, { language: `fi`, value: `Lisää, luo tai muokkaa tilaajaa` }, { language: `sv`, value: `Tilldela, skapa eller ändra kundorderaren` }, { language: `en`, value: `Assign, create or modify the customer orderer` },);
        this.set(this.sendWorkOrderModalButtonAssignLanguageItemName, { language: `fi`, value: `Lisää` }, { language: `sv`, value: `Tilldela` }, { language: `en`, value: `Assign` },);
        this.set(this.sendWorkOrderModalButtonTooltipAssignLanguageItemName, { language: `fi`, value: `Lisää yhteyshenkilö työtilaukselle` }, { language: `sv`, value: `Tilldela kontaktperson för arbetsorder` }, { language: `en`, value: `Assign contact person for work order` },);
        this.set(this.workOrdersGridNoDataTextLanguageItemName, { language: `fi`, value: `Rajauksella ei löydy työtilauksia` }, { language: `sv`, value: `Inga arbetsrapporter hittades enligt filter` }, { language: `en`, value: `No work reports found according to filters` },);
        this.set(this.workDayPanelGridAggregatesNoDataTextLanguageItemName, { language: `fi`, value: `Ei raportoituja tunteja` }, { language: `sv`, value: `Inga rapporterade timmar` }, { language: `en`, value: `No reported hours` },);
        this.set(this.workOrderDetailsPanelGridHoursNoDataTextLanguageItemName, { language: `fi`, value: `Ei raportoituja tunteja` }, { language: `sv`, value: `Inga rapporterade timmar` }, { language: `en`, value: `No reported hours` },);
        this.set(this.workOrderDetailsPanelGridProductUnitLanguageItemName, { language: `fi`, value: `Yksikkö` }, { language: `sv`, value: `Enhet` }, { language: `en`, value: `Unit` },);
        this.set(this.workOrderDetailsPanelGridEquipmentNoDataTextLanguageItemName, { language: `fi`, value: `Ei tarvikkeita` }, { language: `sv`, value: `Ingen utrustning` }, { language: `en`, value: `No equipment` },);
        this.set(this.contactSupportPageMessageSentLanguageItemName, { language: `fi`, value: `Pyyntösi on lähetetty tuelle.` }, { language: `sv`, value: `Er förfrågan har skickats till supporten.` }, { language: `en`, value: `Your request was sent to support team.` },);
        this.set(this.contactSupportPageMessageWithIdSentLanguageItemName, { language: `fi`, value: `Pyyntösi tunnuksella "{0}" on lähetetty tuelle.` }, { language: `sv`, value: `Er förfrågan med id "{0}" har skickats till supporten.` }, { language: `en`, value: `Your request with id "{0}" was sent to support team.` },);
        this.set(this.rentaTasksWorkOrderSignInConfirmLanguageItemName, { language: `fi`, value: `Työtilaus ei ole vielä aktiivinen, oletko varma, että haluat aktivoida ja kirjautua työtilaukselle?` }, { language: `sv`, value: `Arbetsordern är ännu inte aktiv. \nare är du säker på att du vill aktivera och logga in?` }, { language: `en`, value: `The work order is not active yet.\nAre you sure you want to activate and sign in?` },);
        this.set(this.rentaTasksWorkOrderSignInAlertLanguageItemName, { language: `fi`, value: `Kirjautuminen työtilaukselle onnistui` }, { language: `sv`, value: `Du har framgångsrikt loggat in i arbetsordningen.` }, { language: `en`, value: `You have successfully signed in to the work order.` },);
        this.set(this.rentaTasksWorkOrderManualTitleLanguageItemName, { language: `fi`, value: `Työtilauksen kuvaus` }, { language: `sv`, value: `Arbetsbeskrivning` }, { language: `en`, value: `Work order description` },);
        this.set(this.genericKmLanguageItemName, { language: `fi`, value: `{0} km` }, { language: `sv`, value: `{0} km` }, { language: `en`, value: `{0} km` },);
        this.set(this.genericHoursLanguageItemName, { language: `fi`, value: `{0:0.0} t ({1:0.0}/{2:0.0}/{3:0.0})` }, { language: `sv`, value: `{0:0.0} t ({1:0.0}/{2:0.0}/{3:0.0})` }, { language: `en`, value: `{0:0.0} h ({1:0.0}/{2:0.0}/{3:0.0})` },);
        this.set(this.rentaTasksWorkOrderLabelCustomerNameLanguageItemName, { language: `fi`, value: `Asiakas` }, { language: `sv`, value: `Kund` }, { language: `en`, value: `Customer name` },);
        this.set(this.rentaTasksWorkOrderLabelConstructionSiteLanguageItemName, { language: `fi`, value: `Työmaan nimi` }, { language: `sv`, value: `Byggarbetsplats` }, { language: `en`, value: `Construction site` },);
        this.set(this.rentaTasksWorkOrderLabelAddressLanguageItemName, { language: `fi`, value: `Osoite` }, { language: `sv`, value: `Adress` }, { language: `en`, value: `Address` },);
        this.set(this.rentaTasksWorkOrderLabelOrdererLanguageItemName, { language: `fi`, value: `Tilaaja` }, { language: `sv`, value: `Beställare` }, { language: `en`, value: `Orderer` },);
        this.set(this.rentaTasksWorkOrderLabelOrdererPhoneLanguageItemName, { language: `fi`, value: `Tilaajan puhelinnumero` }, { language: `sv`, value: `Ordertelefon` }, { language: `en`, value: `Orderer phone` },);
        this.set(this.rentaTasksWorkOrderLabelApproverLanguageItemName, { language: `fi`, value: `Hyväksyjä` }, { language: `sv`, value: `Godkännande` }, { language: `en`, value: `Approver` },);
        this.set(this.rentaTasksWorkOrderLabelApproverPhoneLanguageItemName, { language: `fi`, value: `Hyväksyjän puhelinnumero` }, { language: `sv`, value: `Godkännande telefon` }, { language: `en`, value: `Approver phone` },);
        this.set(this.rentaTasksWorkOrderLabelManagerLanguageItemName, { language: `fi`, value: `Työnjohtaja` }, { language: `sv`, value: `Montageledare` }, { language: `en`, value: `Manager` },);
        this.set(this.rentaTasksWorkOrderLabelManagerPhoneLanguageItemName, { language: `fi`, value: `Työnjohtajan puhelinnumero` }, { language: `sv`, value: `Montageledare telefon` }, { language: `en`, value: `Manager phone` },);
        this.set(this.rentaTasksWorkOrderLabelDistanceLanguageItemName, { language: `fi`, value: `Matkakorvaukset` }, { language: `sv`, value: `Distans` }, { language: `en`, value: `Distance` },);
        this.set(this.rentaTasksWorkOrderLabelStatusLanguageItemName, { language: `fi`, value: `Tila:` }, { language: `sv`, value: `Status:` }, { language: `en`, value: `Status:` },);
        this.set(this.rentaTasksWorkOrderLabelActivationDateLanguageItemName, { language: `fi`, value: `Aloituspäivä:` }, { language: `sv`, value: `Aktiveringsdatum:` }, { language: `en`, value: `Activation date:` },);
        this.set(this.rentaTasksWorkOrderLabelCompletionDateLanguageItemName, { language: `fi`, value: `Valmistumispäivä:` }, { language: `sv`, value: `Slutdatum:` }, { language: `en`, value: `Completion date:` },);
        this.set(this.rentaTasksWorkOrderButtonLabelSignInLanguageItemName, { language: `fi`, value: `Kirjaudu työtilaukselle` }, { language: `sv`, value: `Logga in` }, { language: `en`, value: `Sign in` },);
        this.set(this.rentaTasksWorkOrderButtonLabelSignOutLanguageItemName, { language: `fi`, value: `Keskeytä työ` }, { language: `sv`, value: `Logga ut` }, { language: `en`, value: `Sign out` },);
        this.set(this.rentaTasksWorkOrderButtonLabelAddEquipmentLanguageItemName, { language: `fi`, value: `Lisää tarvikkeita` }, { language: `sv`, value: `Lägg till utrustning` }, { language: `en`, value: `Add equipment` },);
        this.set(this.rentaTasksWorkOrderButtonLabelBackLanguageItemName, { language: `fi`, value: `Palaa` }, { language: `sv`, value: `Tillbaka` }, { language: `en`, value: `Back` },);
        this.set(this.rentaTasksDashboardRouteWidgetMyWorkOrderLanguageItemName, { language: `fi`, value: `Minun työtilaukseni` }, { language: `sv`, value: `Min arbetsorder` }, { language: `en`, value: `My work order` },);
        this.set(this.rentaTasksDashboardRouteWidgetWorkOrdersLanguageItemName, { language: `fi`, value: `Työtilaukset` }, { language: `sv`, value: `Arbetsorder` }, { language: `en`, value: `Work orders` },);
        this.set(this.rentaTasksWorkOrderSignOutAlertLanguageItemName, { language: `fi`, value: `Olet kirjautunut onnistuneesti työtilaukselta.` }, { language: `sv`, value: `Du har framgångsrikt loggat ut från arbetsordern.` }, { language: `en`, value: `You have successfully signed out from the work order.` },);
        this.set(this.rentaTasksWorkOrderSaveAlertLanguageItemName, { language: `fi`, value: `Työtilaus on tallennettu onnistuneesti.` }, { language: `sv`, value: `Arbetsordern sparas framgångsrikt.` }, { language: `en`, value: `The work order is saved successfully.` },);
        this.set(this.rentaTasksWorkOrderUpdateEquipmentAlertLanguageItemName, { language: `fi`, value: `Työtilaukselle lisätyt tarvikkeet on tallennettu onnistuneesti` }, { language: `sv`, value: `Arbetsorderutrustningen uppdateras framgångsrikt.` }, { language: `en`, value: `The work order equipment is updated successfully.` },);
        this.set(this.rentaTasksWorkOrderCompleteAlertLanguageItemName, { language: `fi`, value: `Työtilaus valmistettu onnistuneesti.` }, { language: `sv`, value: `Arbetsordern slutfördes framgångsrikt.` }, { language: `en`, value: `The work order completed successfully.` },);
        this.set(this.workOrdersFiltersEmployeesLanguageItemName, { language: `fi`, value: `Asentajat` }, { language: `sv`, value: `Anställds` }, { language: `en`, value: `Employees` },);
        this.set(this.workOrdersFiltersManagersLanguageItemName, { language: `fi`, value: `Työnjohtajat` }, { language: `sv`, value: `Montageledarna` }, { language: `en`, value: `Managers` },);
        this.set(this.rentaTasksDashboardRouteWidgetWorkOrdersDescriptionLanguageItemName, { language: `fi`, value: `Tarkastele aktiivisia työtilauksia` }, { language: `sv`, value: `Kontrollera aktiva arbetsorder` }, { language: `en`, value: `Check active work orders` },);
        this.set(this.workOrdersRowsNoAddressLanguageItemName, { language: `fi`, value: `Ei osoitetta` }, { language: `sv`, value: `Ingen adress` }, { language: `en`, value: `No address` },);
        this.set(this.editContactPersonModalButtonLabelSaveChangesLanguageItemName, { language: `fi`, value: `Tallenna muutokset` }, { language: `sv`, value: `Spara ändringar` }, { language: `en`, value: `Save changes` },);
        this.set(this.editContactPersonModalSubtitleLanguageItemName, { language: `fi`, value: `Täytä puuttuvat tiedot` }, { language: `sv`, value: `Fyll i saknad information` }, { language: `en`, value: `Fill in missing information` },);
        this.set(this.summaryWidgetButtonEditApproverLanguageItemName, { language: `fi`, value: `Täytä puuttuvat kuittaajan tiedot` }, { language: `sv`, value: `Fyll i saknad godkännandeinfo` }, { language: `en`, value: `Fill in missing approver info` },);
        this.set(this.summaryWidgetDropdownNothingSelectedLanguageItemName, { language: `fi`, value: `Valitse hyväksyjä` }, { language: `sv`, value: `Välj kundgodkännare` }, { language: `en`, value: `Select customer approver` },);
        this.set(this.managersNewOrdererLanguageItemName, { language: `fi`, value: `Luo uusi tilaaja` }, { language: `sv`, value: `Skapa Neworder` }, { language: `en`, value: `Create new orderer` },);
        this.set(this.workOrdersInvoiceReferenceLanguageItemName, { language: `fi`, value: `Laskuviite` }, { language: `sv`, value: `Fakturareferens` }, { language: `en`, value: `Invoice reference` },);
        this.set(this.rentaTasksWorkOrderInfoCheckboxWidgetUnscheduledLanguageItemName, { language: `fi`, value: `Aikatauluttamaton` }, { language: `sv`, value: `Oplanerad` }, { language: `en`, value: `Unscheduled` },);
        this.set(this.rentaTasksWorkOrderInfoCheckboxWidgetUnscheduledDescriptionLanguageItemName, { language: `fi`, value: `Lisää tai poista aloituspäivämäärä` }, { language: `sv`, value: `Kontrollera att ett aktiveringsdatum är` }, { language: `en`, value: `Check to unschedule an activation date` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsSearchingLanguageItemName, { language: `fi`, value: `Etsitään…` }, { language: `sv`, value: `Sökande…` }, { language: `en`, value: `Searching…` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsProductsFoundLanguageItemName, { language: `fi`, value: `{0} Tuotetta löytynyt` }, { language: `sv`, value: `{0} Produkter hittade:` }, { language: `en`, value: `{0} products found:` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsNoProductsFoundLanguageItemName, { language: `fi`, value: `Hakusanalla ei löytynyt tuotteita` }, { language: `sv`, value: `Inga produkter med given sökterm` }, { language: `en`, value: `No products with given search term` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsTextInputPlaceholderSearchLanguageItemName, { language: `fi`, value: `Etsi` }, { language: `sv`, value: `Sök` }, { language: `en`, value: `Search` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsSearchResultLanguageItemName, { language: `fi`, value: `Hakutulokset: {0}` }, { language: `sv`, value: `Sökresultat: {0}` }, { language: `en`, value: `Search results: {0}` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsModalTitleEquipmentLanguageItemName, { language: `fi`, value: `Tarvike` }, { language: `sv`, value: `Utrustning` }, { language: `en`, value: `Equipment` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsModalSubtitleChooseEquipmentLanguageItemName, { language: `fi`, value: `Valitse tuote työtilaukselle` }, { language: `sv`, value: `Välj produkt att lägga till i utrustningslistan` }, { language: `en`, value: `Choose product to add to equipment list` },);
        this.set(this.taskTooltipsTaskUnscheduledLanguageItemName, { language: `fi`, value: `Työtilausta ei ole aikataulutettu. Aloituspäivämäärä puuttuu.` }, { language: `sv`, value: `Arbetsorder är oplanerad\nAktiveringsdatum anges inte` }, { language: `en`, value: `Work order is unscheduled.\nActivation date is not specified.` },);
        this.set(this.workOrderStatusUnscheduledLanguageItemName, { language: `fi`, value: `Aikatauluttamaton` }, { language: `sv`, value: `Oplanerad` }, { language: `en`, value: `Unscheduled` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsAddEquipmentLanguageItemName, { language: `fi`, value: `Lisää tarvikkeita` }, { language: `sv`, value: `Lägg till utrustning` }, { language: `en`, value: `Add equipment` },);
        this.set(this.rentaTasksAddEquipmentAddEquipmentDataProviderCategoryFavoriteLanguageItemName, { language: `fi`, value: `SUOSIKKI` }, { language: `sv`, value: `FAVORIT` }, { language: `en`, value: `FAVORITE` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsNoProductsLanguageItemName, { language: `fi`, value: `Ei tuotteita` }, { language: `sv`, value: `Inga produkter` }, { language: `en`, value: `No products` },);
        this.set(this.rentaTasksWorkOrderLabelInvoiceReferenceLanguageItemName, { language: `fi`, value: `Viite` }, { language: `sv`, value: `Referens` }, { language: `en`, value: `Reference` },);
        this.set(this.summaryWidgetReferenceLanguageItemName, { language: `fi`, value: `Viite:` }, { language: `sv`, value: `Referens:` }, { language: `en`, value: `Reference:` },);
        this.set(this.rentaTasksWorkOrderButtonActivateLanguageItemName, { language: `fi`, value: `Aktivoi` }, { language: `sv`, value: `Aktivera` }, { language: `en`, value: `Activate` },);
        this.set(this.rentaTasksWorkOrderAlertWorkOrderNotActivatedLanguageItemName, { language: `fi`, value: `Työtilausta ei ole aktivoitu. Työtilauksen tila on \“{0}\“.` }, { language: `sv`, value: `Arbetsorder har inte aktiverats. Arbetsorderstatus: \ "{0} \".` }, { language: `en`, value: `Work order has not been activated. Work order status: \"{0}\".` },);
        this.set(this.workOrderEquipmentAddCustomProductLanguageItemName, { language: `fi`, value: `Lisää muu tuote` }, { language: `sv`, value: `Lägg till anpassad produkt` }, { language: `en`, value: `Add custom product` },);
        this.set(this.rentaTasksAddEquipmentAddCustomProductModalAmountLanguageItemName, { language: `fi`, value: `Määrä` }, { language: `sv`, value: `Antal` }, { language: `en`, value: `Amount` },);
        this.set(this.rentaTasksAddEquipmentAddCustomProductModalPriceLanguageItemName, { language: `fi`, value: `Hinta` }, { language: `sv`, value: `Pris` }, { language: `en`, value: `Price` },);
        this.set(this.rentaTasksAddEquipmentAddCustomProductModalUnitLanguageItemName, { language: `fi`, value: `Yksikkö` }, { language: `sv`, value: `Enhet` }, { language: `en`, value: `Unit` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsAddCustomEquipmentLanguageItemName, { language: `fi`, value: `Lisää muu tuote` }, { language: `sv`, value: `Lägg till anpassad utrustning` }, { language: `en`, value: `Add custom equipment` },);
        this.set(this.rentaTasksAddEquipmentAddCustomProductModalTitleCustomEquipmentLanguageItemName, { language: `fi`, value: `Muu tuote` }, { language: `sv`, value: `Anpassad utrustning` }, { language: `en`, value: `Custom equipment` },);
        this.set(this.rentaTasksAddEquipmentAddCustomProductModalSubtitleCustomEquipmentLanguageItemName, { language: `fi`, value: `Lisää muu tuote työtilaukselle` }, { language: `sv`, value: `Lägg till anpassad utrustning i arbetsordningen` }, { language: `en`, value: `Add custom equipment to work order` },);
        this.set(this.genericContactPersonDetailsLanguageItemName, { language: `fi`, value: `Yhteyshenkilön lisätiedot` }, { language: `sv`, value: `Kontakta personinformation` }, { language: `en`, value: `Contact person details` },);
        this.set(this.addEquipmentSaveChangesConfirmationLanguageItemName, { language: `fi`, value: `Sinulla on tallentamattomia muutoksia, haluatko tallentaa ne ennen poistumista?` }, { language: `sv`, value: `Det finns osparade förändringar, vill du spara dem innan du går ut?` }, { language: `en`, value: `There are unsaved changes, would you like to save them before exiting?` },);
        this.set(this.userManagementTitleLanguageItemName, { language: `fi`, value: `Käyttäjien hallinta` }, { language: `sv`, value: `Användarhantering` }, { language: `en`, value: `User management` },);
        this.set(this.warehouseManagementTitleLanguageItemName, { language: `fi`, value: `Toimipisteiden hallinta` }, { language: `sv`, value: `Depåhantering` }, { language: `en`, value: `Warehouse management` },);
        this.set(this.addEquipmentSaveButtonLanguageItemName, { language: `fi`, value: `Tallenna` }, { language: `sv`, value: `Spara` }, { language: `en`, value: `Save` },);
        this.set(this.addEquipmentDontSaveButtonLanguageItemName, { language: `fi`, value: `Älä tallenna` }, { language: `sv`, value: `Spara inte` }, { language: `en`, value: `Don't save` },);
        this.set(this.addEquipmentCloseButtonLanguageItemName, { language: `fi`, value: `Sulje` }, { language: `sv`, value: `Stäng` }, { language: `en`, value: `Close` },);
        this.set(this.genericActionRestoreLanguageItemName, { language: `fi`, value: `Palauta` }, { language: `sv`, value: `Återställ` }, { language: `en`, value: `Restore` },);
        this.set(this.genericActionDeleteLanguageItemName, { language: `fi`, value: `Poista` }, { language: `sv`, value: `Radera` }, { language: `en`, value: `Delete` },);
        this.set(this.genericManagerLanguageItemName, { language: `fi`, value: `Työnjohtaja` }, { language: `sv`, value: `Montageledare` }, { language: `en`, value: `Manager` },);
        this.set(this.genericAddressLanguageItemName, { language: `fi`, value: `Osoite` }, { language: `sv`, value: `Adress` }, { language: `en`, value: `Address` },);
        this.set(this.genericShowDeletedLanguageItemName, { language: `fi`, value: `Näytä poistetut` }, { language: `sv`, value: `Visa bort` }, { language: `en`, value: `Show deleted` },);
        this.set(this.genericActionReloadLanguageItemName, { language: `fi`, value: `Lataa uudelleen` }, { language: `sv`, value: `Ladda om` }, { language: `en`, value: `Reload` },);
        this.set(this.warehousesWarehousesTabLanguageItemName, { language: `fi`, value: `Varastot` }, { language: `sv`, value: `Depå` }, { language: `en`, value: `Warehouses` },);
        this.set(this.warehousesCostPoolsTabLanguageItemName, { language: `fi`, value: `Kustannuspaikat` }, { language: `sv`, value: `Kostnadspooler` }, { language: `en`, value: `Cost pools` },);
        this.set(this.warehousesCostPoolsTitleLanguageItemName, { language: `fi`, value: `Kustannuspaikat` }, { language: `sv`, value: `Kostnadspooler` }, { language: `en`, value: `Cost pools` },);
        this.set(this.warehousesAlertWarehouseAlreadyExistsLanguageItemName, { language: `fi`, value: `Toimipiste "{0}" on jo olemassa.` }, { language: `sv`, value: `Depå "{0}" finns redan.` }, { language: `en`, value: `Warehouse "{0}" already exists.` },);
        this.set(this.warehousesCostPoolsDataDeleteConfirmationLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat poistaa kustannuspaikan "{0}"?\nKustannuspaikka poistetaan kaikilta toimipisteiltä.` }, { language: `sv`, value: `Är du säker på att du vill ta bort kostnadspoolen "{0}"? \ncost pool kommer att tas bort från alla depå.` }, { language: `en`, value: `Are you sure you want to delete cost pool "{0}"?\nCost pool will be removed from all warehouses.` },);
        this.set(this.warehousesCostPoolsDataAlertCostPoolAlreadyExistsLanguageItemName, { language: `fi`, value: `Kustannuspaikka "{0}" on jo olemassa.` }, { language: `sv`, value: `Kostnadspool "{0}" finns redan.` }, { language: `en`, value: `Cost pool "{0}" already exists.` },);
        this.set(this.warehousesWarehouseDetailsAlertCostPoolAlreadyAssignedLanguageItemName, { language: `fi`, value: `Kustannuspaikka "{0}" on jo lisätty kyseiselle toimipisteelle.` }, { language: `sv`, value: `Kostnadspool "{0}" finns redan under nuvarande depå.` }, { language: `en`, value: `Cost pool "{0}" already exists under current warehouse.` },);
        this.set(this.warehousesWarehouseDetailsDeleteConfirmationLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat poistaa linkityksen kustannuspaikkaan "{0}"?` }, { language: `sv`, value: `Är du säker på att du vill ta bort kartläggning med Cost Pool "{0}"?` }, { language: `en`, value: `Are you sure you want to delete mapping with cost pool "{0}"?` },);
        this.set(this.warehousesWarehouseDataAlertWarehouseNameAlreadyExistsLanguageItemName, { language: `fi`, value: `Muutoksia ei voida tallentaa. Toimipiste "{0}" on jo olemassa.` }, { language: `sv`, value: `Ändringar kan inte sparas. Depå med namnet "{0}" finns redan.` }, { language: `en`, value: `Changes cannot be saved. Warehouse with name "{0}" already exists.` },);
        this.set(this.warehousesWarehouseDataDeleteConfirmationLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat poistaa toimipisteen "{0}"?` }, { language: `sv`, value: `Är du säker på att du vill ta bort depå "{0}"?` }, { language: `en`, value: `Are you sure you want to delete warehouse "{0}"?` },);
        this.set(this.warehousesWarehouseDataAlertCreateWarehouseLanguageItemName, { language: `fi`, value: `Luo toimipiste ennen kustannuspaikkojen lisäämistä.` }, { language: `sv`, value: `Skapa depå innan du tilldelar kostnadspooler till det.` }, { language: `en`, value: `Please create warehouse before assigning cost pools to it.` },);
        this.set(this.warehousesWarehouseDataAddNewWarehouseLanguageItemName, { language: `fi`, value: `Luo toimipiste` }, { language: `sv`, value: `Lägg till nytt depå` }, { language: `en`, value: `Add new warehouse` },);
        this.set(this.genericCostPoolsLanguageItemName, { language: `fi`, value: `Kustannuspaikat` }, { language: `sv`, value: `Kostnadspooler` }, { language: `en`, value: `Cost pools` },);
        this.set(this.warehousesCostPoolsDataAddNewCostPoolLanguageItemName, { language: `fi`, value: `Luo kustannuspaikka` }, { language: `sv`, value: `Lägg till ny kostnadspool` }, { language: `en`, value: `Add new cost pool` },);
        this.set(this.userManagementDropdownMultipleCostPoolsTextLanguageItemName, { language: `fi`, value: `Kaikki kustannuspaikat` }, { language: `sv`, value: `Alla kostnadspooler` }, { language: `en`, value: `All cost pools` },);
        this.set(this.genericDescriptionLanguageItemName, { language: `fi`, value: `Kuvaus` }, { language: `sv`, value: `Beskrivning` }, { language: `en`, value: `Description` },);
        this.set(this.catalogManagementAddCategoryLanguageItemName, { language: `fi`, value: `Lisää kategoria` }, { language: `sv`, value: `Lägg till Kategori` }, { language: `en`, value: `Add category` },);
        this.set(this.catalogManagementAddProductLanguageItemName, { language: `fi`, value: `Lisää tuote` }, { language: `sv`, value: `Lägg till produkt` }, { language: `en`, value: `Add product` },);
        this.set(this.genericPriceLanguageItemName, { language: `fi`, value: `Hinta` }, { language: `sv`, value: `Pris` }, { language: `en`, value: `Price` },);
        this.set(this.genericUnitLanguageItemName, { language: `fi`, value: `Yksikkö` }, { language: `sv`, value: `Enhet` }, { language: `en`, value: `Unit` },);
        this.set(this.genericCustomUnitLanguageItemName, { language: `fi`, value: `Mukautettu yksikkö` }, { language: `sv`, value: `Anpassningsenhet` }, { language: `en`, value: `Custom unit` },);
        this.set(this.genericActionEditLanguageItemName, { language: `fi`, value: `Muokkaa` }, { language: `sv`, value: `Redigera` }, { language: `en`, value: `Edit` },);
        this.set(this.genericGoIntoLanguageItemName, { language: `fi`, value: `Siirry` }, { language: `sv`, value: `Gå in i` }, { language: `en`, value: `Go into` },);
        this.set(this.genericIconLanguageItemName, { language: `fi`, value: `Ikoni` }, { language: `sv`, value: `Ikon` }, { language: `en`, value: `Icon` },);
        this.set(this.genericActionSaveLanguageItemName, { language: `fi`, value: `Tallenna` }, { language: `sv`, value: `Spara` }, { language: `en`, value: `Save` },);
        this.set(this.genericCategoryLanguageItemName, { language: `fi`, value: `Kategoria` }, { language: `sv`, value: `Kategori` }, { language: `en`, value: `Category` },);
        this.set(this.genericAbbreviationsVehiclesLanguageItemName, { language: `fi`, value: `lkm` }, { language: `sv`, value: `v` }, { language: `en`, value: `v` },);
        this.set(this.genericAbbreviationsKilometersLanguageItemName, { language: `fi`, value: `km` }, { language: `sv`, value: `km` }, { language: `en`, value: `km` },);
        this.set(this.genericAbbreviationsHoursLanguageItemName, { language: `fi`, value: `t` }, { language: `sv`, value: `h` }, { language: `en`, value: `h` },);
        this.set(this.catalogManagementPageTitleLanguageItemName, { language: `fi`, value: `Myyntituote katalogin hallinta` }, { language: `sv`, value: `Försäljning av produktkataloghantering` }, { language: `en`, value: `Sales products catalog` },);
        this.set(this.categoryItemValidationCategoryWithSameNameAlreadyExistsLanguageItemName, { language: `fi`, value: `Samanniminen kategoria on jo olemassa` }, { language: `sv`, value: `Kategori med samma namn finns redan` }, { language: `en`, value: `Category with a same name already exists` },);
        this.set(this.productItemValidationProductWithSameNameAlreadyExistsLanguageItemName, { language: `fi`, value: `Samanniminen tuote on jo olemassa` }, { language: `sv`, value: `Produkt med samma namn finns redan` }, { language: `en`, value: `Product with a same name already exists` },);
        this.set(this.genericExternalIdLanguageItemName, { language: `fi`, value: `Ulkoinen Id` }, { language: `sv`, value: `Externt ID` }, { language: `en`, value: `External Id` },);
        this.set(this.catalogManagementConfirmationModalRemoveCategoryLanguageItemName, { language: `fi`, value: `Haluatko varmasti poistaa kategorian "{0}"?` }, { language: `sv`, value: `Är du säker på att du vill ta bort kategorin "{0}"?` }, { language: `en`, value: `Are you sure you want to remove category "{0}"?` },);
        this.set(this.catalogManagementAlertCategoryRemovedSuccessfullyLanguageItemName, { language: `fi`, value: `Kategoria "{0}" poistettu onnistuneesti` }, { language: `sv`, value: `Kategori "{0}" avlägsnas framgångsrikt` }, { language: `en`, value: `Category "{0}" removed successfully` },);
        this.set(this.catalogManagementAlertCategoryEditedSuccessfullyLanguageItemName, { language: `fi`, value: `Kategoria "{0}" muokattu onnistuneesti` }, { language: `sv`, value: `Kategori "{0}" redigerad framgångsrikt` }, { language: `en`, value: `Category "{0}" edited successfully` },);
        this.set(this.catalogManagementAlertCategoryCreatedSuccessfullyLanguageItemName, { language: `fi`, value: `Kategoria "{0}" luotu onnistuneesti` }, { language: `sv`, value: `Kategori "{0}" skapade framgångsrikt` }, { language: `en`, value: `Category "{0}" created successfully` },);
        this.set(this.categoryItemParentCategoryLanguageItemName, { language: `fi`, value: `Emokategoria` }, { language: `sv`, value: `Föräldrakategori` }, { language: `en`, value: `Parent category` },);
        this.set(this.catalogManagementAlertProductCreatedSuccessfullyLanguageItemName, { language: `fi`, value: `Tuote "{0}" luotu onnistuneesti` }, { language: `sv`, value: `Produkt "{0}" skapade framgångsrikt` }, { language: `en`, value: `Product "{0}" created successfully` },);
        this.set(this.catalogManagementAlertProductEditedSuccessfullyLanguageItemName, { language: `fi`, value: `Tuote "{0}" muokattu onnistuneesti` }, { language: `sv`, value: `Produkt "{0}" redigerad framgångsrikt` }, { language: `en`, value: `Product "{0}" edited successfully` },);
        this.set(this.catalogManagementAlertProductRemovedSuccessfullyLanguageItemName, { language: `fi`, value: `Tuote "{0}" poistettu onnistuneesti` }, { language: `sv`, value: `Produkt "{0}" avlägsnad framgångsrikt` }, { language: `en`, value: `Product "{0}" removed successfully` },);
        this.set(this.catalogManagementConfirmationModalRemoveProductLanguageItemName, { language: `fi`, value: `Haluatko varmasti poistaa tuotteen "{0}"?` }, { language: `sv`, value: `Är du säker på att du vill ta bort produkten "{0}"?` }, { language: `en`, value: `Are you sure you want to remove product "{0}"?` },);
        this.set(this.productItemValidationProductWithSameExternalIdAlreadyExistsLanguageItemName, { language: `fi`, value: `Ulkoinen ID on jo käytössä` }, { language: `sv`, value: `Externt ID används redan` }, { language: `en`, value: `External Id is already in use` },);
        this.set(this.catalogManagementAlertCategoryCreationFailureLanguageItemName, { language: `fi`, value: `Kategorian luonti epäonnistui: {0}` }, { language: `sv`, value: `Skapa kategori misslyckades: {0}` }, { language: `en`, value: `Creating category failed: {0}` },);
        this.set(this.catalogManagementAlertCategoryEditFailureLanguageItemName, { language: `fi`, value: `Kategorian tallennus epäonnistui: {0}` }, { language: `sv`, value: `Spara kategori misslyckades: {0}` }, { language: `en`, value: `Saving category failed: {0}` },);
        this.set(this.catalogManagementAlertProductCreationFailureLanguageItemName, { language: `fi`, value: `Tuotteen luonti epäonnistui: {0}` }, { language: `sv`, value: `Skapa produkt misslyckades: {0}` }, { language: `en`, value: `Creating product failed: {0}` },);
        this.set(this.catalogManagementAlertProductEditFailureLanguageItemName, { language: `fi`, value: `Tuotteen tallennus epäonnistui: {0}` }, { language: `sv`, value: `Spara produkten misslyckades: {0}` }, { language: `en`, value: `Saving product failed: {0}` },);
        this.set(this.productItemProductKeywordsLanguageItemName, { language: `fi`, value: `Avainsanat` }, { language: `sv`, value: `Nyckelord` }, { language: `en`, value: `Keywords` },);
        this.set(this.workOrdersActionsUnInvoiceLanguageItemName, { language: `fi`, value: `Peruuta lasku` }, { language: `sv`, value: `Avbryt faktura` }, { language: `en`, value: `Cancel invoice` },);
        this.set(this.workOrderActionsConfirmUnInvoiceLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat peruuttaa laskun?` }, { language: `sv`, value: `Är du säker på att du vill avbryta fakturan?` }, { language: `en`, value: `Are you sure you want to cancel the invoice?` },);
        this.set(this.attachmentsPageGetManualLanguageItemName, { language: `fi`, value: `Liitetiedostot` }, { language: `sv`, value: `Bilagor` }, { language: `en`, value: `Attachments page` },);
        this.set(this.attachmentsFiltersModalTitleLanguageItemName, { language: `fi`, value: `Liitteiden suodattimet` }, { language: `sv`, value: `Bilagor` }, { language: `en`, value: `Attachment filters` },);
        this.set(this.attachmentsFiltersModalUploadedAtLanguageItemName, { language: `fi`, value: `Ladattu` }, { language: `sv`, value: `Uppladdad på` }, { language: `en`, value: `Uploaded at` },);
        this.set(this.attachmentsFiltersModalUploadedBeforeLanguageItemName, { language: `fi`, value: `Ladattu ennen` }, { language: `sv`, value: `Uppladdad innan` }, { language: `en`, value: `Uploaded before` },);
        this.set(this.attachmentsFiltersModalUploadedFromLanguageItemName, { language: `fi`, value: `Ladattu jälkeen` }, { language: `sv`, value: `Uppladdad från` }, { language: `en`, value: `Uploaded from` },);
        this.set(this.attachmentsListPageGetManualLanguageItemName, { language: `fi`, value: `Liitetiedostot` }, { language: `sv`, value: `Bilagelista` }, { language: `en`, value: `Attachments list` },);
        this.set(this.attachmentsTitleLanguageItemName, { language: `fi`, value: `Liitetiedostot` }, { language: `sv`, value: `Bilagor` }, { language: `en`, value: `Attachments` },);
        this.set(this.genericActionPreviewLanguageItemName, { language: `fi`, value: `Esikatsele` }, { language: `sv`, value: `Förhandsvisning` }, { language: `en`, value: `Preview` },);
        this.set(this.workOrderDetailsPanelGridAttachmentsNoDataTextLanguageItemName, { language: `fi`, value: `Ei liitteitä` }, { language: `sv`, value: `Inga bilagor` }, { language: `en`, value: `No attachments` },);
        this.set(this.workOrderDetailsPanelGridAttachmentsFileTypeLanguageItemName, { language: `fi`, value: `Tiedostotyyppi` }, { language: `sv`, value: `Filtyp` }, { language: `en`, value: `File type` },);
        this.set(this.workOrderDetailsPanelGridAttachmentsFileNameLanguageItemName, { language: `fi`, value: `Tiedoston nimi` }, { language: `sv`, value: `Filnamn` }, { language: `en`, value: `File name` },);
        this.set(this.workOrderDetailsPanelGridAttachmentsPublicLanguageItemName, { language: `fi`, value: `Julkinen` }, { language: `sv`, value: `Offentlig` }, { language: `en`, value: `Public` },);
        this.set(this.workOrderDetailsPanelToolbarPublicCheckboxLanguageItemName, { language: `fi`, value: `Julkinen` }, { language: `sv`, value: `Offentlig` }, { language: `en`, value: `Public` },);
        this.set(this.workOrderDetailsPanelToolbarAddAttachmentsButtonLanguageItemName, { language: `fi`, value: `Lisää liitetiedostoja` }, { language: `sv`, value: `Lägg till bilagor` }, { language: `en`, value: `Add attachments` },);
        this.set(this.workOrderDetailsPanelAttachmentsAddInfoLanguageItemName, { language: `fi`, value: `Lisää liitetiedostoja` }, { language: `sv`, value: `Lägg till bilagor` }, { language: `en`, value: `Add attachments` },);
        this.set(this.workOrderDetailsPanelGridAttachmentsConfirmDeleteLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat poistaa liitteen {0}?` }, { language: `sv`, value: `Är du säker på att du vill ta bort {0} bilaga?` }, { language: `en`, value: `Are you sure you want to delete {0} attachment?` },);
        this.set(this.addWorkReportAttachmentModalPublicCheckboxLanguageItemName, { language: `fi`, value: `Julkinen` }, { language: `sv`, value: `Offentlig` }, { language: `en`, value: `Public` },);
        this.set(this.addWorkReportAttachmentModalTitleLanguageItemName, { language: `fi`, value: `Lisää liitetiedostoja` }, { language: `sv`, value: `Lägg till arbetsrapport Bifogning` }, { language: `en`, value: `Add work report attachment` },);
        this.set(this.rentaTasksWorkOrderButtonLabelAttachmentsLanguageItemName, { language: `fi`, value: `Liitteet` }, { language: `sv`, value: `Bilagor` }, { language: `en`, value: `Attachments` },);
        this.set(this.genericActionReturnLanguageItemName, { language: `fi`, value: `Palaa` }, { language: `sv`, value: `Tillbaka` }, { language: `en`, value: `Return` },);
        this.set(this.rentaTasksControllerAlertsRequiredInformationMissingLanguageItemName, { language: `fi`, value: `Pakollisia tietoja ei syötetty, tehtävää ei tallennettu.` }, { language: `sv`, value: `Obligatorisk information saknas, uppdrag inte sparad.` }, { language: `en`, value: `Required information missing, task not saved.` },);
        this.set(this.catalogModalAddAndCloseLanguageItemName, { language: `fi`, value: `Lisää ja sulje` }, { language: `sv`, value: `Spara & Stäng` }, { language: `en`, value: `Add & Close` },);
        this.set(this.genericUserEmailExistsLanguageItemName, { language: `fi`, value: `Syötetty sähköpostiosoite "{0}" on jo olemassa olevalla käyttäjällä.` }, { language: `sv`, value: `Användare med den medföljande e -postmeddelandet "{0}" finns redan.` }, { language: `en`, value: `User with the provided email "{0}" already exists.` },);
        this.set(this.genericUserPhoneExistsLanguageItemName, { language: `fi`, value: `Syötetty matkapuhelinnumero "{0}" on jo olemassa olevalla käyttäjällä.` }, { language: `sv`, value: `Användare med det medföljande telefonnumret "{0}" finns redan.` }, { language: `en`, value: `User with the provided phone number "{0}" already exists.` },);
        this.set(this.tasksPanelCopyTaskTemplateLanguageItemName, { language: `fi`, value: `Kopio työtilaus malli` }, { language: `sv`, value: `Kopiera uppdragsmall` }, { language: `en`, value: `Copy task template` },);
        this.set(this.tasksPanelPlannedDoneLanguageItemName, { language: `fi`, value: `Suunniteltu valmistumispäivä` }, { language: `sv`, value: `Planerat slutdatum` }, { language: `en`, value: `Planned completion date` },);
        this.set(this.tasksPanelPlannedCompletionDateLanguageItemName, { language: `fi`, value: `Suunniteltu valmistumispäivä` }, { language: `sv`, value: `Planerat slutdatum` }, { language: `en`, value: `Planned completion date` },);
        this.set(this.calendarPageCalendarDataConfirmAssignDialogAddButtonLanguageItemName, { language: `fi`, value: `Säilytä nykyinen nimitys` }, { language: `sv`, value: `Behåll befintligt uppdrag` }, { language: `en`, value: `Keep existing assignment` },);
        this.set(this.calendarPageCalendarDataConfirmAssignDialogBodyLanguageItemName, { language: `fi`, value: `Säilytä tai korvaa nykyinen tehtävän nimitys?` }, { language: `sv`, value: `Behåll eller ersätt befintligt uppdrag?` }, { language: `en`, value: `Keep or replace existing assignment?` },);
        this.set(this.calendarPageCalendarDataConfirmAssignDialogReplaceButtonLanguageItemName, { language: `fi`, value: `Korvaa nykyinen nimitys` }, { language: `sv`, value: `Ersätt befintligt uppdrag` }, { language: `en`, value: `Replace existing assignment` },);
        this.set(this.calendarPageCalendarDataConfirmAssignDialogTitleLanguageItemName, { language: `fi`, value: `Vahvista` }, { language: `sv`, value: `Bekräfta` }, { language: `en`, value: `Confirm` },);
        this.set(this.calendarPageCalendarDataUnassignedRowLanguageItemName, { language: `fi`, value: `Nimittämätön` }, { language: `sv`, value: `Otilldelad` }, { language: `en`, value: `Unassigned` },);
        this.set(this.calendarPageNoTeamLabelLanguageItemName, { language: `fi`, value: `Ei tiimiä` }, { language: `sv`, value: `Inget monterlag` }, { language: `en`, value: `No team` },);
        this.set(this.calendarPagePersonnelTabLanguageItemName, { language: `fi`, value: `Henkilöt` }, { language: `sv`, value: `Personal` }, { language: `en`, value: `Personnel` },);
        this.set(this.calendarPageTeamsListLabelLanguageItemName, { language: `fi`, value: `Tiimit` }, { language: `sv`, value: `Monterlag` }, { language: `en`, value: `Teams` },);
        this.set(this.calendarPageTitleLanguageItemName, { language: `fi`, value: `Kalenteri` }, { language: `sv`, value: `Kalenderplanerare` }, { language: `en`, value: `Calendar planner` },);
        this.set(this.calendarPageToolbarStatusNotAllocatedLanguageItemName, { language: `fi`, value: `Ei aikataulutettu` }, { language: `sv`, value: `Inte schemalagd` }, { language: `en`, value: `Not allocated` },);
        this.set(this.topNavCalendarLanguageItemName, { language: `fi`, value: `Kalenteri` }, { language: `sv`, value: `Kalender` }, { language: `en`, value: `Calendar` },);
        this.set(this.calendarPageToolbarStatusNotStartedLanguageItemName, { language: `fi`, value: `Ei aloitettu` }, { language: `sv`, value: `Inte börjat` }, { language: `en`, value: `Not started` },);
        this.set(this.calendarPageToolbarStatusReadyLanguageItemName, { language: `fi`, value: `Valmis` }, { language: `sv`, value: `Redo` }, { language: `en`, value: `Ready` },);
        this.set(this.calendarPageToolbarStatusStartedLanguageItemName, { language: `fi`, value: `Aloitettu` }, { language: `sv`, value: `Satte igång` }, { language: `en`, value: `Started` },);
        this.set(this.enumCalendarUnitTimeMonthLanguageItemName, { language: `fi`, value: `Kuukausi` }, { language: `sv`, value: `Månad` }, { language: `en`, value: `Month` },);
        this.set(this.enumCalendarUnitTimeWeekLanguageItemName, { language: `fi`, value: `Viikko` }, { language: `sv`, value: `Vecka` }, { language: `en`, value: `Week` },);
        this.set(this.calendarPageToolbarViewLabelLanguageItemName, { language: `fi`, value: `Näkymä` }, { language: `sv`, value: `Utsikt` }, { language: `en`, value: `View` },);
        this.set(this.calendarPageToolbarTodayButtonLabelLanguageItemName, { language: `fi`, value: `Tänään` }, { language: `sv`, value: `I dag` }, { language: `en`, value: `Today` },);
        this.set(this.genericActionAddLanguageItemName, { language: `fi`, value: `Lisää` }, { language: `sv`, value: `Lägg till` }, { language: `en`, value: `Add` },);
        this.set(this.genericWorkOrderLanguageItemName, { language: `fi`, value: `Työtilaus` }, { language: `sv`, value: `Arbetsorder` }, { language: `en`, value: `Work order` },);
        this.set(this.genericWorkOrderEditLanguageItemName, { language: `fi`, value: `Muokkaa työtilausta` }, { language: `sv`, value: `Redigera arbetsorder` }, { language: `en`, value: `Edit work order` },);
        this.set(this.genericWorkOrderNewLanguageItemName, { language: `fi`, value: `Uusi työtilaus` }, { language: `sv`, value: `Ny arbetsorder` }, { language: `en`, value: `New work order` },);
        this.set(this.genericConstructionSiteOrWarehouseLanguageItemName, { language: `fi`, value: `Työmaa tai varasto` }, { language: `sv`, value: `Byggplats eller depå` }, { language: `en`, value: `Construction site or warehouse` },);
        this.set(this.genericNumberLanguageItemName, { language: `fi`, value: `Numero` }, { language: `sv`, value: `Siffra` }, { language: `en`, value: `Number` },);
        this.set(this.genericStatusLanguageItemName, { language: `fi`, value: `Tila` }, { language: `sv`, value: `Status` }, { language: `en`, value: `Status` },);
        this.set(this.genericInvoiceReferenceLanguageItemName, { language: `fi`, value: `Laskuviite` }, { language: `sv`, value: `Fakturareferens` }, { language: `en`, value: `Invoice reference` },);
        this.set(this.genericActionApproveLanguageItemName, { language: `fi`, value: `Hyväksy` }, { language: `sv`, value: `Godkänna` }, { language: `en`, value: `Approve` },);
        this.set(this.genericActionLockLanguageItemName, { language: `fi`, value: `Lukitse` }, { language: `sv`, value: `Låsa` }, { language: `en`, value: `Lock` },);
        this.set(this.genericActionUnlockLanguageItemName, { language: `fi`, value: `Poista lukitus` }, { language: `sv`, value: `Låsa upp` }, { language: `en`, value: `Unlock` },);
        this.set(this.genericActionCompleteLanguageItemName, { language: `fi`, value: `Valmista` }, { language: `sv`, value: `Komplett` }, { language: `en`, value: `Complete` },);
        this.set(this.genericActionInvoiceLanguageItemName, { language: `fi`, value: `Laskuta` }, { language: `sv`, value: `Faktura` }, { language: `en`, value: `Invoice` },);
        this.set(this.genericActionUninvoiceLanguageItemName, { language: `fi`, value: `Peruuta lasku` }, { language: `sv`, value: `Stoppa faktura` }, { language: `en`, value: `Uninvoice` },);
        this.set(this.genericActionSendLanguageItemName, { language: `fi`, value: `Lähetä` }, { language: `sv`, value: `Skicka` }, { language: `en`, value: `Send` },);
        this.set(this.genericTypeLanguageItemName, { language: `fi`, value: `Tyyppi` }, { language: `sv`, value: `Typ` }, { language: `en`, value: `Type` },);
        this.set(this.genericCostLanguageItemName, { language: `fi`, value: `Kustannus` }, { language: `sv`, value: `Kostnad` }, { language: `en`, value: `Cost` },);
        this.set(this.genericMountersLanguageItemName, { language: `fi`, value: `Asentajat` }, { language: `sv`, value: `Montör` }, { language: `en`, value: `Mounters` },);
        this.set(this.genericActionActivateLanguageItemName, { language: `fi`, value: `Aktivoi` }, { language: `sv`, value: `Aktivera` }, { language: `en`, value: `Activate` },);
        this.set(this.genericInvoiceLanguageItemName, { language: `fi`, value: `Työ- ja kustannusraportti` }, { language: `sv`, value: `Arbets- och Kostnadsrapport` }, { language: `en`, value: `Work and cost report` },);
        this.set(this.genericActionCopyLanguageItemName, { language: `fi`, value: `Kopioi` }, { language: `sv`, value: `Kopiera` }, { language: `en`, value: `Copy` },);
        this.set(this.genericApproverLanguageItemName, { language: `fi`, value: `Hyväksyjä` }, { language: `sv`, value: `Godkännande` }, { language: `en`, value: `Approver` },);
        this.set(this.genericOrdererLanguageItemName, { language: `fi`, value: `Tilaaja` }, { language: `sv`, value: `Beställare` }, { language: `en`, value: `Orderer` },);
        this.set(this.genericCompletionLanguageItemName, { language: `fi`, value: `Valmistuminen` }, { language: `sv`, value: `Komplettering` }, { language: `en`, value: `Completion` },);
        this.set(this.genericPlannedCompletionLanguageItemName, { language: `fi`, value: `Suunniteltu valmistuminen` }, { language: `sv`, value: `Planerad slutförande` }, { language: `en`, value: `Planned completion` },);
        this.set(this.genericActivationLanguageItemName, { language: `fi`, value: `Aloitus` }, { language: `sv`, value: `Aktivering` }, { language: `en`, value: `Activation` },);
        this.set(this.genericDefaultLanguageItemName, { language: `fi`, value: `Oletus` }, { language: `sv`, value: `Default` }, { language: `en`, value: `Default` },);
        this.set(this.confirmationDialogDiscardUnsavedChangesLanguageItemName, { language: `fi`, value: `Hylkää tallentamattomat muutokset?` }, { language: `sv`, value: `Kassera oavslutade förändringar?` }, { language: `en`, value: `Discard unsaved changes?` },);
        this.set(this.genericWorkOrderCreatedSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilaus luotu onnistuneesti` }, { language: `sv`, value: `Arbetsorder skapades framgångsrikt` }, { language: `en`, value: `Work order created successfully` },);
        this.set(this.genericWorkOrderSavedSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilaus tallennettu onnistuneesti` }, { language: `sv`, value: `Arbetsorder sparas framgångsrikt` }, { language: `en`, value: `Work order saved successfully` },);
        this.set(this.genericWorkOrderCopiedSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilaus kopioitu onnistuneesti` }, { language: `sv`, value: `Arbetsorder kopieras framgångsrikt` }, { language: `en`, value: `Work order copied successfully` },);
        this.set(this.genericWorkOrderLockedSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilaus lukittu onnistuneesti` }, { language: `sv`, value: `Arbetsorder låst framgångsrikt` }, { language: `en`, value: `Work order locked successfully` },);
        this.set(this.genericWorkOrderUnlockedSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilauksen lukitus poistettu onnistuneesti` }, { language: `sv`, value: `Arbetsorder olåst framgångsrikt` }, { language: `en`, value: `Work order unlocked successfully` },);
        this.set(this.genericWorkOrderApprovedSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilaus hyväksytty onnistuneesti` }, { language: `sv`, value: `Arbetsorder godkändes framgångsrikt` }, { language: `en`, value: `Work order approved successfully` },);
        this.set(this.genericWorkOrderActivatedSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilaus aktivoitu onnistuneesti` }, { language: `sv`, value: `Arbetsorder aktiveras framgångsrikt` }, { language: `en`, value: `Work order activated successfully` },);
        this.set(this.genericWorkOrderCompletedSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilaus valmistettu onnistuneesti` }, { language: `sv`, value: `Arbetsorder avslutas framgångsrikt` }, { language: `en`, value: `Work order completed successfully` },);
        this.set(this.genericWorkOrderCompletionFailedLanguageItemName, { language: `fi`, value: `Työtilauksen valmistus epäonnistui` }, { language: `sv`, value: `Avslutningen av arbetsorder misslyckades` }, { language: `en`, value: `Work order completion failed` },);
        this.set(this.genericWorkOrderInvoicedSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilaus laskutettu onnistuneesti` }, { language: `sv`, value: `Arbetsorder fakturerad framgångsrikt` }, { language: `en`, value: `Work order invoiced successfully` },);
        this.set(this.genericWorkOrderUninvoicedSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilauksen laskutus peruutettu onnistuneesti` }, { language: `sv`, value: `Arbetsorderfaktura avbröt framgångsrikt` }, { language: `en`, value: `Work order invoice cancelled successfully` },);
        this.set(this.genericWorkOrderSendingFailedLanguageItemName, { language: `fi`, value: `Työtilauksen lähetys epäonnistui` }, { language: `sv`, value: `Arbetsorder sändning misslyckades` }, { language: `en`, value: `Work order sending failed` },);
        this.set(this.genericWorkOrderSentSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilaus lähetetty onnistuneesti` }, { language: `sv`, value: `Arbetsorder skickas framgångsrikt` }, { language: `en`, value: `Work order sent successfully` },);
        this.set(this.genericWorkOrderApprovalFailedLanguageItemName, { language: `fi`, value: `Työtilauksen hyväksyntä epäonnistui` }, { language: `sv`, value: `Godkännande av arbetsorder misslyckades` }, { language: `en`, value: `Work order approval failed` },);
        this.set(this.enumWorkOrderStatusReadyForInvoicingLanguageItemName, { language: `fi`, value: `Valmis laskutettavaksi` }, { language: `sv`, value: `Redo för fakturering` }, { language: `en`, value: `Ready for invoicing` },);
        this.set(this.genericNewLanguageItemName, { language: `fi`, value: `Uusi` }, { language: `sv`, value: `Ny` }, { language: `en`, value: `New` },);
        this.set(this.adminConsolePageTitleLanguageItemName, { language: `fi`, value: `Hallintakonsoli` }, { language: `sv`, value: `Administratörskonsol` }, { language: `en`, value: `Admin console` },);
        this.set(this.tasksToolbarSearchFieldTooManySearchWordsLanguageItemName, { language: `fi`, value: `Kirjoita korkeintaan viisi hakusanaa` }, { language: `sv`, value: `Skriv hög fem sökord` }, { language: `en`, value: `Write at most five search words` },);
        this.set(this.tasksToolbarSearchFieldPlaceholderLanguageItemName, { language: `fi`, value: `Koodi / Työmaa / Asiakas / Viite` }, { language: `sv`, value: `Kod / Webbplats / Kund / Referens` }, { language: `en`, value: `Code / Site / Customer / Reference` },);
        this.set(this.workOrderTypeManagementPageTitleLanguageItemName, { language: `fi`, value: `Työtilaustyyppien hallinta` }, { language: `sv`, value: `Arbetsordertyphantering` }, { language: `en`, value: `Work order type management` },);
        this.set(this.genericActionDisableLanguageItemName, { language: `fi`, value: `Poista käytöstä` }, { language: `sv`, value: `Inaktivera` }, { language: `en`, value: `Disable` },);
        this.set(this.genericActionEnableLanguageItemName, { language: `fi`, value: `Ota käyttöön` }, { language: `sv`, value: `Gör det möjligt` }, { language: `en`, value: `Enable` },);
        this.set(this.genericWorkOrderTypeLabelLanguageItemName, { language: `fi`, value: `Työtilauksen tyyppi` }, { language: `sv`, value: `Arbetsordertyp` }, { language: `en`, value: `Work order type` },);
        this.set(this.genericNameClarificationLanguageItemName, { language: `fi`, value: `Nimenselvennys` }, { language: `sv`, value: `Namnförtydligande` }, { language: `en`, value: `Name clarification` },);
        this.set(this.signatureNameClarificationDescriptionLanguageItemName, { language: `fi`, value: `Pyydä asiakkaalta allekirjoituksen nimenselvennys saadaksesi hyväksynnän` }, { language: `sv`, value: `Be kunden att skriva sitt signaturnamnsförklaring för att godkänna` }, { language: `en`, value: `Ask customer to write their signature name clarification to approve` },);
        this.set(this.genericLegendLanguageItemName, { language: `fi`, value: `Selite` }, { language: `sv`, value: `Legend` }, { language: `en`, value: `Legend` },);
        this.set(this.addTaskTaskTypeLabelLanguageItemName, { language: `fi`, value: `Tehtävän tyyppi` }, { language: `sv`, value: `Arbetsordertyp` }, { language: `en`, value: `Work order type` },);
        this.set(this.addTaskTaskTypeDescriptionLanguageItemName, { language: `fi`, value: `Valitse tehtävän tyyppi` }, { language: `sv`, value: `Välj arbetsordertyp` }, { language: `en`, value: `Select work order type` },);
        this.set(this.genericNoNameLanguageItemName, { language: `fi`, value: `Ei nimeä` }, { language: `sv`, value: `Inget namn` }, { language: `en`, value: `No name` },);
        this.set(this.workOrdersHoursTabTitleLanguageItemName, { language: `fi`, value: `Tunnit` }, { language: `sv`, value: `Arbetad tid` }, { language: `en`, value: `Hours` },);
        this.set(this.workOrdersJobSummaryLanguageItemName, { language: `fi`, value: `Lisätiedot asiakkaalle` }, { language: `sv`, value: `Anmärkning för kunden` }, { language: `en`, value: `Note for customer` },);
        this.set(this.workOrdersManagerLanguageItemName, { language: `fi`, value: `Työnjohtaja` }, { language: `sv`, value: `Montageledare` }, { language: `en`, value: `Manager` },);
        this.set(this.workOrdersShowDetailsTitleLanguageItemName, { language: `fi`, value: `Näytä tiedot` }, { language: `sv`, value: `Visa informationen` }, { language: `en`, value: `Show details` },);
        this.set(this.workOrdersEquipmentsTabTitleLanguageItemName, { language: `fi`, value: `Tuotteet` }, { language: `sv`, value: `Produkter` }, { language: `en`, value: `Products` },);
        this.set(this.workOrdersDeclineActionLanguageItemName, { language: `fi`, value: `Hylkää työtehtävä` }, { language: `sv`, value: `Nedgång` }, { language: `en`, value: `Decline` },);
        this.set(this.workOrdersCustomerOrdererLanguageItemName, { language: `fi`, value: `Tilaaja` }, { language: `sv`, value: `Beställare` }, { language: `en`, value: `Orderer` },);
        this.set(this.workOrdersApproveActionLanguageItemName, { language: `fi`, value: `Hyväksy työtehtävä` }, { language: `sv`, value: `Godkänna` }, { language: `en`, value: `Approve` },);
        this.set(this.workOrderEquipmentPriceLanguageItemName, { language: `fi`, value: `Hinta` }, { language: `sv`, value: `Pris` }, { language: `en`, value: `Price` },);
        this.set(this.workOrderEquipmentNameLanguageItemName, { language: `fi`, value: `Tuote` }, { language: `sv`, value: `Produkt` }, { language: `en`, value: `Product` },);
        this.set(this.workOrderEquipmentDescriptionLanguageItemName, { language: `fi`, value: `Kuvaus` }, { language: `sv`, value: `Beskrivning` }, { language: `en`, value: `Description` },);
        this.set(this.workOrderEquipmentAmountLanguageItemName, { language: `fi`, value: `Määrä` }, { language: `sv`, value: `Antal` }, { language: `en`, value: `Amount` },);
        this.set(this.workOrderEquipmentAddProductLanguageItemName, { language: `fi`, value: `Lisää tuote` }, { language: `sv`, value: `Lägg till produkt` }, { language: `en`, value: `Add product` },);
        this.set(this.workOrderDetailsPanelGridHoursHoursPriceInfoTitleLanguageItemName, { language: `fi`, value: `Vakio tuntihinta` }, { language: `sv`, value: `Standardtimmar pris` }, { language: `en`, value: `Default hours price` },);
        this.set(this.workOrderDetailsPanelGridEquipmentPriceInfoTitleLanguageItemName, { language: `fi`, value: `Vakio tuotehinta` }, { language: `sv`, value: `Standardproduktpris` }, { language: `en`, value: `Default product price` },);
        this.set(this.workOrderDetailsPanelGridEquipmentConfirmDeleteLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat poistaa tuotteen "{0}"?` }, { language: `sv`, value: `Är du säker på att du vill ta bort utrustningen \ "{0} \"?` }, { language: `en`, value: `Are you sure you want to delete the equipment \"{0}\"?` },);
        this.set(this.workOrderDetailsPanelGridDistancesVehiclesLanguageItemName, { language: `fi`, value: `Ajoneuvojen lkm` }, { language: `sv`, value: `Fordon` }, { language: `en`, value: `Vehicles` },);
        this.set(this.workOrderDetailsPanelGridDistancesPriceLanguageItemName, { language: `fi`, value: `Hinta, €/km` }, { language: `sv`, value: `Pris, €/km` }, { language: `en`, value: `Price, €/km` },);
        this.set(this.workOrderDetailsPanelGridDistancesNoDataTextLanguageItemName, { language: `fi`, value: `Ei raportoituja kilometrejä` }, { language: `sv`, value: `Inga avstånd rapporterade` }, { language: `en`, value: `No distances reported` },);
        this.set(this.workOrderDetailsPanelGridDistancesDistanceLanguageItemName, { language: `fi`, value: `Kokonaismatka, km` }, { language: `sv`, value: `Totalt avstånd, km` }, { language: `en`, value: `Total distance, km` },);
        this.set(this.workOrderDetailsPanelGridDistancesDayLanguageItemName, { language: `fi`, value: `Päivä` }, { language: `sv`, value: `Dag` }, { language: `en`, value: `Day` },);
        this.set(this.workOrderDetailsPanelGridDistancesCostLanguageItemName, { language: `fi`, value: `Kustannus, €` }, { language: `sv`, value: `Kostnad, €` }, { language: `en`, value: `Cost, €` },);
        this.set(this.workOrderDetailsPanelGridDistancesConfirmDeleteLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat poistaa {0} km päivältä {1:dd.MM.yyyy}?` }, { language: `sv`, value: `Är du säker på att du vill ta bort {0} km från datum {1: dd.mm.yyyy}?` }, { language: `en`, value: `Are you sure you want to delete {0} km from date {1:dd.MM.yyyy}?` },);
        this.set(this.activateConstructionSiteDescriptionLanguageItemName, { language: `fi`, value: `Aktivoi TK-Vuokrien työmaa` }, { language: `sv`, value: `Aktivera byggplatsen från ERP -systemet` }, { language: `en`, value: `Activate construction site from ERP system` },);
        this.set(this.activateConstructionSiteLabelLanguageItemName, { language: `fi`, value: `Aktivoi työmaa` }, { language: `sv`, value: `Aktivera arbetsplats` }, { language: `en`, value: `Activate worksite` },);
        this.set(this.activateConstructionSiteSummaryAddressLabelLanguageItemName, { language: `fi`, value: `Osoite` }, { language: `sv`, value: `Adress` }, { language: `en`, value: `Address` },);
        this.set(this.activateConstructionSiteSummaryCustomerLabelLanguageItemName, { language: `fi`, value: `Asiakas` }, { language: `sv`, value: `Kund` }, { language: `en`, value: `Customer` },);
        this.set(this.activateConstructionSiteSummaryWorksiteNameLabelLanguageItemName, { language: `fi`, value: `Työmaa` }, { language: `sv`, value: `Arbetsplats` }, { language: `en`, value: `Worksite` },);
        this.set(this.addConstructionsiteDuplicateDeviceIdLanguageItemName, { language: `fi`, value: `Työaikaseurantalaitteen id on jo rekisteröity toiseen työmaahan tai varastoon` }, { language: `sv`, value: `Time Tracking Device ID är redan registrerad för en annan byggarbetsplats eller depå.` }, { language: `en`, value: `Time tracking device id is already register for another construction site or warehouse.` },);
        this.set(this.addConstructionsiteFlyoutLanguageItemName, { language: `fi`, value: `Työmaa on luotu` }, { language: `sv`, value: `Byggplatsen har skapats` }, { language: `en`, value: `Construction site has been created` },);
        this.set(this.addConstructionsiteRedirectLanguageItemName, { language: `fi`, value: `Uudelleenohjaus työmaan sivulle` }, { language: `sv`, value: `Omdirigera till byggsidan` }, { language: `en`, value: `Redirect to construction site page` },);
        this.set(this.addConstructionSiteReferenceLanguageItemName, { language: `fi`, value: `TKVuokrat Laskuviite` }, { language: `sv`, value: `ERP -referens` }, { language: `en`, value: `ERP Reference` },);
        this.set(this.addMounterModalLabelsOvertime100HoursLanguageItemName, { language: `fi`, value: `Ylityö 100%` }, { language: `sv`, value: `Övertid 100%` }, { language: `en`, value: `Overtime 100%` },);
        this.set(this.addMounterModalLabelsOvertime50HoursLanguageItemName, { language: `fi`, value: `Ylityö 50%` }, { language: `sv`, value: `Övertid 100%` }, { language: `en`, value: `Overtime 50%` },);
        this.set(this.addTaskModalCostEuroLanguageItemName, { language: `fi`, value: `Kustannus, €` }, { language: `sv`, value: `Kostnad, €` }, { language: `en`, value: `Cost, €` },);
        this.set(this.addTaskModalCreateAndCloseLanguageItemName, { language: `fi`, value: `Luo ja sulje` }, { language: `sv`, value: `Skapa och stänga` }, { language: `en`, value: `Create and close` },);
        this.set(this.addTaskModalCreateAndContinueLanguageItemName, { language: `fi`, value: `Luo ja jatka` }, { language: `sv`, value: `Skapa och fortsätta` }, { language: `en`, value: `Create and continue` },);
        this.set(this.addTaskModalCreateTaskLanguageItemName, { language: `fi`, value: `Luo tehtävä` }, { language: `sv`, value: `Skapa uppgift` }, { language: `en`, value: `Create task` },);
        this.set(this.addTaskModalExtraHoursLanguageItemName, { language: `fi`, value: `Lisätunnit` }, { language: `sv`, value: `Extra timmar` }, { language: `en`, value: `Extra hours` },);
        this.set(this.addTaskModalExtraHoursAutoCalculatedLanguageItemName, { language: `fi`, value: `Automaattisesti laskettu` }, { language: `sv`, value: `Automatiskt beräknat` }, { language: `en`, value: `Auto calculated` },);
        this.set(this.addTaskModalValidationCreateTaskFirstLanguageItemName, { language: `fi`, value: `Luo taski, jotta voit lisätä tunnit ja lisämaksut` }, { language: `sv`, value: `Skapa uppdrag först för att aktivera montörs timmar och extra avgift` }, { language: `en`, value: `Create task first to enable mounter hours and extra charges functionality` },);
        this.set(this.addTaskModalValidationCreateWorkReportFirstLanguageItemName, { language: `fi`, value: `Tallenna työraportti, jotta voit lisätä tunnit ja lisämaksut` }, { language: `sv`, value: `Spara arbetsrapporten först för att aktivera mountertimmar och extra avgiftsfunktionalitet` }, { language: `en`, value: `Save work report first to enable mounter hours and extra charges functionality` },);
        this.set(this.addWorkReportModalAttachmentRemoveConfirmationLanguageItemName, { language: `fi`, value: `Oletko varma että haluat poista liitetiedosto?` }, { language: `sv`, value: `Är du säker på att du vill ta bort bilagesfilen?` }, { language: `en`, value: `Are you sure that you want to remove attachment file?` },);
        this.set(this.addTaskModalNameLanguageItemName, { language: `fi`, value: `Nimi` }, { language: `sv`, value: `Namn` }, { language: `en`, value: `Name` },);
        this.set(this.addTaskModalPriceEuroLanguageItemName, { language: `fi`, value: `Hinta, €` }, { language: `sv`, value: `Pris, €` }, { language: `en`, value: `Price, €` },);
        this.set(this.addWorkReportModalGridExtraChargesLanguageItemName, { language: `fi`, value: `Lisämaksut` }, { language: `sv`, value: `Försäljningsartiklar` }, { language: `en`, value: `Extra charges` },);
        this.set(this.addWorkReportModalGridExtraChargesTitleLanguageItemName, { language: `fi`, value: `Tehtävän lisämaksujen kokonaishinta` }, { language: `sv`, value: `Summan av försäljningsartiklar kostnader` }, { language: `en`, value: `Sum of task extra charges costs` },);
        this.set(this.addWorkReportModalValidationCreateWorkReportFirstLanguageItemName, { language: `fi`, value: `Luo työraportti, jotta voit lisätä uusia tehtäviä` }, { language: `sv`, value: `Skapa arbetsrapport först för att aktivera nya uppgifter Funktionalitet` }, { language: `en`, value: `Create work report first to enable creating new tasks functionality` },);
        this.set(this.assignMountersManualLanguageItemName, { language: `fi`, value: `Määritä työtilaukselle asentaja(t), pyyhkäise oikealle tai paina nuolinäppäintä vahvistaaksesi valinnat. Voit jättää asentajat määrittämättä työtilaukselle, jolloin tämä on kaikkien tehtävissä.` }, { language: `sv`, value: `Tilldela Mounters till arbetsordningen, svep höger eller tryck på Nästa när du är klar. Du kan också lämna det öppet för alla genom att inte ange något knäpp.` }, { language: `en`, value: `Assign mounters to the work order, swipe right, or press next when you finished. You can also leave it open for everyone by not specifying any mounter.` },);
        this.set(this.auditModuleContinueLanguageItemName, { language: `fi`, value: `Jatka tarkastusta` }, { language: `sv`, value: `Fortsätt inspektion` }, { language: `en`, value: `Continue inspection` },);
        this.set(this.auditModuleEmailReceiversContactPersonLanguageItemName, { language: `fi`, value: `Yhteyshenkilö` }, { language: `sv`, value: `Kontaktperson` }, { language: `en`, value: `Contact person` },);
        this.set(this.auditModuleEmailReceiversNoContactPersonWarningLanguageItemName, { language: `fi`, value: `Yhteyshenkilö ei ole määritelty sopimuksessa. Tarkastus raportti ei voi lähettää hyväksyttäväksi` }, { language: `sv`, value: `Kontaktperson anges inte på avtalsnivå. Revision kan inte skickas för godkännande` }, { language: `en`, value: `Contact person is not specified on agreement level. Audit can not be sent for approval` },);
        this.set(this.auditModuleEmailReceiversReceiverLanguageItemName, { language: `fi`, value: `Vastaanottaja` }, { language: `sv`, value: `Mottagare` }, { language: `en`, value: `Receiver` },);
        this.set(this.auditModuleNotSentLanguageItemName, { language: `fi`, value: `Ei lähetetty` }, { language: `sv`, value: `Inte skickat` }, { language: `en`, value: `Not sent` },);
        this.set(this.auditModulePreviewLanguageItemName, { language: `fi`, value: `Esikatsele ja lähetä` }, { language: `sv`, value: `Förhandsgranska och skicka` }, { language: `en`, value: `Preview and send` },);
        this.set(this.auditModuleSentLanguageItemName, { language: `fi`, value: `Lähetetty` }, { language: `sv`, value: `Skickad` }, { language: `en`, value: `Sent` },);
        this.set(this.catalogFlyoutMessageProductMarkedAsDeletedLanguageItemName, { language: `fi`, value: `Tuote '{0}' merkitty poistetuksi.` }, { language: `sv`, value: `Produkt '{0}' markerad som raderad.` }, { language: `en`, value: `Product '{0}' marked as deleted.` },);
        this.set(this.catalogFlyoutMessageProductPermanentlyRemovedLanguageItemName, { language: `fi`, value: `Tuote '{0}' poistettu pysyvästi.` }, { language: `sv`, value: `Produkt '{0}' tas bort permanent.` }, { language: `en`, value: `Product '{0}' removed permanently.` },);
        this.set(this.catalogFlyoutMessageProductRestoredLanguageItemName, { language: `fi`, value: `Tuote '{0}' palautettu.` }, { language: `sv`, value: `Produkt '{0}' återställs framgångsrikt.` }, { language: `en`, value: `Product '{0}' successfully restored.` },);
        this.set(this.catalogManagementErrorMessageRestoreProductNotExistsLanguageItemName, { language: `fi`, value: `Tuotetta ei voida palauttaa. Tuotetta tunnuksella '{0}' ei löydy.` }, { language: `sv`, value: `Produkten kan inte återställas. Produkt med id '{0}' finns inte.` }, { language: `en`, value: `'Product cannot be restored. Product with id '{0}' does not exist.` },);
        this.set(this.checkInsPanelCheckInAtLanguageItemName, { language: `fi`, value: `Kirjautunut sisään` }, { language: `sv`, value: `Checka in på` }, { language: `en`, value: `Check in at` },);
        this.set(this.checkInsPanelNoDataTextLanguageItemName, { language: `fi`, value: `Ei kirjautumisia työtilauksella` }, { language: `sv`, value: `Inga inloggningar eller incheckningar är registrerade` }, { language: `en`, value: `No sign-ins or check-ins are registered` },);
        this.set(this.checkInsPanelCheckOutAtLanguageItemName, { language: `fi`, value: `Kirjautui ulos` }, { language: `sv`, value: `Kolla in` }, { language: `en`, value: `Check out at` },);
        this.set(this.checkInsPanelSignLanguageItemName, { language: `fi`, value: `Työmaalle kirjautuminen` }, { language: `sv`, value: `Platsskylt` }, { language: `en`, value: `Site sign` },);
        this.set(this.componentDropdownAddLanguageItemName, { language: `fi`, value: `Lisää` }, { language: `sv`, value: `Lägg till` }, { language: `en`, value: `Add` },);
        this.set(this.constructionSitePanelExternalNameLanguageItemName, { language: `fi`, value: `ERP Nimi` }, { language: `sv`, value: `ERP -namn` }, { language: `en`, value: `ERP name` },);
        this.set(this.constructionSitePanelOrganizationContractInvoicesSentLanguageItemName, { language: `fi`, value: `Asiakas sopimus (Huom! laskuja lähetetty)` }, { language: `sv`, value: `Organisationsavtal (fakturor som redan har skickats!)` }, { language: `en`, value: `Organization Contract (Invoices already sent!)` },);
        this.set(this.constructionSitesCancelChangesLanguageItemName, { language: `fi`, value: `Peruuta` }, { language: `sv`, value: `Avbryt ändringar` }, { language: `en`, value: `Cancel changes` },);
        this.set(this.constructionSitesCommitChangesLanguageItemName, { language: `fi`, value: `Tallenna` }, { language: `sv`, value: `Begå förändringar` }, { language: `en`, value: `Commit changes` },);
        this.set(this.constructionSitesNameLanguageItemName, { language: `fi`, value: `Nimi` }, { language: `sv`, value: `Namn` }, { language: `en`, value: `Name` },);
        this.set(this.constructionSitesToolBarSearchTermFilterWithReferenceLanguageItemName, { language: `fi`, value: `Työmaa / Asiakas / Viite / Osoite` }, { language: `sv`, value: `Webbplats / Kund / Referens / Adress` }, { language: `en`, value: `Site / Customer / Reference / Address` },);
        this.set(this.dailyHoursModalLabelsDateLanguageItemName, { language: `fi`, value: `Päivämäärä` }, { language: `sv`, value: `Datum` }, { language: `en`, value: `Date` },);
        this.set(this.dailyHoursModalLabelsMounterLanguageItemName, { language: `fi`, value: `Asentaja` }, { language: `sv`, value: `Montör` }, { language: `en`, value: `Mounter` },);
        this.set(this.dailyHoursModalLabelsNormalHoursLanguageItemName, { language: `fi`, value: `Tunnit` }, { language: `sv`, value: `Normala timmar` }, { language: `en`, value: `Normal hours` },);
        this.set(this.dailyHoursModalLabelsOvertime100HoursLanguageItemName, { language: `fi`, value: `Ylityö 100%` }, { language: `sv`, value: `Övertid 100%` }, { language: `en`, value: `Overtime 100%` },);
        this.set(this.dailyHoursModalLabelsOvertime50HoursLanguageItemName, { language: `fi`, value: `Ylityö 50%` }, { language: `sv`, value: `Övertid 50%` }, { language: `en`, value: `Overtime 50%` },);
        this.set(this.dailyHoursModalSubtitleLanguageItemName, { language: `fi`, value: `Työtilauksen työtunnit` }, { language: `sv`, value: `Arbetsorder Arbetstid` }, { language: `en`, value: `Work order working hours` },);
        this.set(this.dailyHoursWidgetButtonsAddHoursLanguageItemName, { language: `fi`, value: `Lisää käyttäjän tunteja` }, { language: `sv`, value: `Lägg till användartider` }, { language: `en`, value: `Add user hours` },);
        this.set(this.dailyHoursWidgetDescriptionLanguageItemName, { language: `fi`, value: `Kaikki työtilaukselle kirjatut tunnit` }, { language: `sv`, value: `Total arbetsorder Arbetstid` }, { language: `en`, value: `Total work order working hours` },);
        this.set(this.dailyHoursWidgetLabelLanguageItemName, { language: `fi`, value: `Kaikki tunnit` }, { language: `sv`, value: `Hela timmarna` }, { language: `en`, value: `All hours` },);
        this.set(this.dailyHoursWidgetLabelsNormalLanguageItemName, { language: `fi`, value: `Tunnit` }, { language: `sv`, value: `Vanligt` }, { language: `en`, value: `Normal` },);
        this.set(this.dashboardFlyoutSiteCreatedLanguageItemName, { language: `fi`, value: `Uusi työmaa on luotu` }, { language: `sv`, value: `Ny byggplats har skapats` }, { language: `en`, value: `New construction site has been created` },);
        this.set(this.distanceModalLabelsDateLanguageItemName, { language: `fi`, value: `Päivämäärä` }, { language: `sv`, value: `Datum` }, { language: `en`, value: `Date` },);
        this.set(this.distanceModalLabelsValueLanguageItemName, { language: `fi`, value: `Kokonaismatka, km` }, { language: `sv`, value: `Totalt avstånd, km` }, { language: `en`, value: `Total distance, km` },);
        this.set(this.distanceModalLabelsVehiclesLanguageItemName, { language: `fi`, value: `Ajoneuvojen lukumäärä` }, { language: `sv`, value: `Fordonsbelopp` }, { language: `en`, value: `Vehicles amount` },);
        this.set(this.distanceModalSubtitleLanguageItemName, { language: `fi`, value: `Työtilauksen matkakorvaukset` }, { language: `sv`, value: `Arbetsorderkilometer` }, { language: `en`, value: `Work order kilometer` },);
        this.set(this.distanceWidgetButtonsAddKilometersLanguageItemName, { language: `fi`, value: `Lisää matkakorvauksia` }, { language: `sv`, value: `Lägg till kilometer` }, { language: `en`, value: `Add kilometers` },);
        this.set(this.distanceWidgetDescriptionLanguageItemName, { language: `fi`, value: `Työtilauksen kokonais matkakorvausten määrä` }, { language: `sv`, value: `Totalt arbetsorderavståndsbelopp` }, { language: `en`, value: `Total work order distance amount` },);
        this.set(this.distanceWidgetLabelLanguageItemName, { language: `fi`, value: `Matkakorvaukset` }, { language: `sv`, value: `Distans` }, { language: `en`, value: `Distance` },);
        this.set(this.enumInvoiceStateFilterApprovedLanguageItemName, { language: `fi`, value: `Hyväksytty` }, { language: `sv`, value: `Godkänd` }, { language: `en`, value: `Approved` },);
        this.set(this.enumInvoiceStateFilterApprovedDescriptionLanguageItemName, { language: `fi`, value: `Laskut hyväksytty esimieheltä` }, { language: `sv`, value: `Faktura godkänd av Montageledare` }, { language: `en`, value: `Invoice approved by manager` },);
        this.set(this.enumInvoiceStateFilterCreatedLanguageItemName, { language: `fi`, value: `Luotu` }, { language: `sv`, value: `Skapad` }, { language: `en`, value: `Created` },);
        this.set(this.enumInvoiceStateFilterCreatedDescriptionLanguageItemName, { language: `fi`, value: `Luo per esimies, ei hyväksytty` }, { language: `sv`, value: `Skapa av Montageledare, inte godkänd` }, { language: `en`, value: `Create by manager, not approved` },);
        this.set(this.enumInvoiceStateFilterFailedLanguageItemName, { language: `fi`, value: `Epäonnistui` }, { language: `sv`, value: `Misslyckad` }, { language: `en`, value: `Failed` },);
        this.set(this.enumInvoiceStateFilterFailedDescriptionLanguageItemName, { language: `fi`, value: `Epäonnistui käsittelyn aikana laskutusjärjestelmästä` }, { language: `sv`, value: `Misslyckades under bearbetning av faktureringssystem` }, { language: `en`, value: `Failed during processing by invoicing system` },);
        this.set(this.enumInvoiceStateFilterLockedLanguageItemName, { language: `fi`, value: `Lukittu` }, { language: `sv`, value: `Låst` }, { language: `en`, value: `Locked` },);
        this.set(this.enumInvoiceStateFilterLockedDescriptionLanguageItemName, { language: `fi`, value: `Laskut jotka ovat lukittu ja valmiita lähetettäväksi` }, { language: `sv`, value: `En faktura markerad som låst och redo att skickas` }, { language: `en`, value: `An invoice marked as locked and ready to be sent` },);
        this.set(this.enumInvoiceStateFilterProcessedLanguageItemName, { language: `fi`, value: `Käsitelty` }, { language: `sv`, value: `Bearbetad` }, { language: `en`, value: `Processed` },);
        this.set(this.enumInvoiceStateFilterProcessedDescriptionLanguageItemName, { language: `fi`, value: `Onnistuneesti käsitelty laskutusjärjestelmästä` }, { language: `sv`, value: `Framgångsrikt behandlas av faktureringssystem` }, { language: `en`, value: `Successfully processed by invoicing system` },);
        this.set(this.enumInvoiceStateFilterSentDescriptionLanguageItemName, { language: `fi`, value: `Lasku lähetetty laskujärjestelmään` }, { language: `sv`, value: `Faktura som skickas till faktureringssystem` }, { language: `en`, value: `Invoice sent to invoicing system` },);
        this.set(this.enumInvoiceStateFilterSentLanguageItemName, { language: `fi`, value: `Lähetetty` }, { language: `sv`, value: `Skickad` }, { language: `en`, value: `Sent` },);
        this.set(this.enumUserRoleGroupContactPersonsLanguageItemName, { language: `fi`, value: `Yhteyshenkilöt` }, { language: `sv`, value: `Kontaktpersoner` }, { language: `en`, value: `Contact Persons` },);
        this.set(this.enumTaskStatusFilterApprovedByCustomerLanguageItemName, { language: `fi`, value: `Asiakas hyväksynyt` }, { language: `sv`, value: `Godkännande av kunden` }, { language: `en`, value: `Approved by customer` },);
        this.set(this.enumTaskStatusFilterCompletedLanguageItemName, { language: `fi`, value: `Valmis` }, { language: `sv`, value: `Avslutad` }, { language: `en`, value: `Completed` },);
        this.set(this.enumTaskStatusFilterDeclinedByCustomerLanguageItemName, { language: `fi`, value: `Asiakas hylännyt` }, { language: `sv`, value: `Avvisas av kunden` }, { language: `en`, value: `Declined by customer` },);
        this.set(this.enumTaskStatusFilterInProgressLanguageItemName, { language: `fi`, value: `Käynnissä` }, { language: `sv`, value: `Pågående` }, { language: `en`, value: `In process` },);
        this.set(this.enumTaskStatusFilterInvoicedLanguageItemName, { language: `fi`, value: `Laskutettu` }, { language: `sv`, value: `Fakturerad` }, { language: `en`, value: `Invoiced` },);
        this.set(this.enumTaskStatusFilterReadyForInvoicingLanguageItemName, { language: `fi`, value: `Valmis laskutettavaksi` }, { language: `sv`, value: `Redo för fakturering` }, { language: `en`, value: `Ready for invoicing` },);
        this.set(this.enumTaskStatusFilterSentToCustomerLanguageItemName, { language: `fi`, value: `Lähetetty asiakkaalle` }, { language: `sv`, value: `Skickas till kunden` }, { language: `en`, value: `Sent to customer` },);
        this.set(this.enumTaskStatusFilterUnscheduledLanguageItemName, { language: `fi`, value: `Ei määritetty` }, { language: `sv`, value: `Oplanerad` }, { language: `en`, value: `Unscheduled` },);
        this.set(this.enumTaskStatusFilterUpcomingLanguageItemName, { language: `fi`, value: `Tulossa` }, { language: `sv`, value: `Kommande` }, { language: `en`, value: `Upcoming` },);
        this.set(this.formInputPostalboxLanguageItemName, { language: `fi`, value: `Postilaatikko` }, { language: `sv`, value: `Postlåda` }, { language: `en`, value: `Postal box` },);
        this.set(this.formInputTimeTrackingDeviceIdLanguageItemName, { language: `fi`, value: `Työaikaseurantalaite-id` }, { language: `sv`, value: `Tidspårningsenhets -ID` }, { language: `en`, value: `Time tracking device id` },);
        this.set(this.genericFileNotFoundLanguageItemName, { language: `fi`, value: `Tiedostoa ei löytynyt.` }, { language: `sv`, value: `Filen hittades inte.` }, { language: `en`, value: `File was not found.` },);
        this.set(this.imageModalDownloadLanguageItemName, { language: `fi`, value: `Lataa` }, { language: `sv`, value: `Ladda ner` }, { language: `en`, value: `Download` },);
        this.set(this.invoicesCostLanguageItemName, { language: `fi`, value: `€` }, { language: `sv`, value: `Kostnad, €` }, { language: `en`, value: `Cost, €` },);
        this.set(this.knownSettingsHourPriceLanguageItemName, { language: `fi`, value: `Vakio tuntihinta, €/h` }, { language: `sv`, value: `Standard timpris, €/h` }, { language: `en`, value: `Default hourly price, €/h` },);
        this.set(this.knownSettingsMileagePriceLanguageItemName, { language: `fi`, value: `Vakio kilometrikorvaus, €/km` }, { language: `sv`, value: `Standardkilometerbidrag, €/m` }, { language: `en`, value: `Default kilometer allowance, €/m` },);
        this.set(this.managersOrdererSavedSuccessfullyLanguageItemName, { language: `fi`, value: `Tilaaja on tallennettu onnistuneesti.` }, { language: `sv`, value: `Orderare har räddats framgångsrikt.` }, { language: `en`, value: `Orderer has been saved successfully.` },);
        this.set(this.managersStepApproverAddLanguageItemName, { language: `fi`, value: `Uusi hyväksyjä` }, { language: `sv`, value: `Ny godkännare` }, { language: `en`, value: `New approver` },);
        this.set(this.managersStepApproverDescriptionLanguageItemName, { language: `fi`, value: `Valitse tai luo hyväksyjä` }, { language: `sv`, value: `Välj eller skapa en godkännare` }, { language: `en`, value: `Choose or create an approver` },);
        this.set(this.managersStepApproverLabelLanguageItemName, { language: `fi`, value: `Hyväksyjä` }, { language: `sv`, value: `Kundgodkännare` }, { language: `en`, value: `Customer approver` },);
        this.set(this.managersStepApproverNotSpecifiedLanguageItemName, { language: `fi`, value: `Hyväksyjän yhteystietoja puuttuu!` }, { language: `sv`, value: `Godkännandedata bör anges!` }, { language: `en`, value: `Approver data should be specified!` },);
        this.set(this.managersStepApproverSavedLanguageItemName, { language: `fi`, value: `Hyväksyjä tallennettu onnistuneesti.` }, { language: `sv`, value: `Godkännare har sparats framgångsrikt.` }, { language: `en`, value: `Approver has been saved successfully.` },);
        this.set(this.managersStepManagerDescriptionLanguageItemName, { language: `fi`, value: `Valitse työnjohtaja` }, { language: `sv`, value: `Välj en Montageledare` }, { language: `en`, value: `Choose a manager` },);
        this.set(this.managersStepManagerLabelLanguageItemName, { language: `fi`, value: `Työnjohtaja` }, { language: `sv`, value: `Montageledare` }, { language: `en`, value: `Manager` },);
        this.set(this.managersStepManualLanguageItemName, { language: `fi`, value: `Määritä työtilauksen työnjohtaja, tilaaja ja hyväksyjä. Yhteyshenkilöiden tiedot (sähköposti, matkapuhelinnumero, etu -ja sukunimi) tulee olla täytetty.` }, { language: `sv`, value: `Ange arbetsorderhanteraren, kunden godkännare och kundorder. Kundkontaktinformation (e -post, telefon, för- och efternamn) bör också anges.` }, { language: `en`, value: `Specify the work order manager, customer approver, and customer orderer. Customer contact information (email, phone, first and last name) should also be specified.` },);
        this.set(this.managersStepOrdererAddLanguageItemName, { language: `fi`, value: `Uusi tilaaja` }, { language: `sv`, value: `Ny beställning` }, { language: `en`, value: `New orderer` },);
        this.set(this.managersStepOrdererDescriptionLanguageItemName, { language: `fi`, value: `Valitse tai luo tilaaja` }, { language: `sv`, value: `Välj eller skapa en beställning` }, { language: `en`, value: `Choose or create an orderer` },);
        this.set(this.managersStepOrdererLabelLanguageItemName, { language: `fi`, value: `Tilaaja` }, { language: `sv`, value: `Kundorder` }, { language: `en`, value: `Customer orderer` },);
        this.set(this.managersStepOrdererNotSpecifiedLanguageItemName, { language: `fi`, value: `Tilaajan yhteystietoja puuttuu!` }, { language: `sv`, value: `Beställningsdata bör anges!` }, { language: `en`, value: `Orderer data should be specified!` },);
        this.set(this.managersStepOrdererSaveLanguageItemName, { language: `fi`, value: `Tilaaja tallennettu onnistuneesti.` }, { language: `sv`, value: `Orderare har räddats framgångsrikt.` }, { language: `en`, value: `Orderer has been saved successfully.` },);
        this.set(this.moduleModelCustomLanguageItemName, { language: `fi`, value: `Mukautettu` }, { language: `sv`, value: `Beställnings` }, { language: `en`, value: `Custom` },);
        this.set(this.myWorkHoursLunchHourInstructionsDescriptionLanguageItemName, { language: `fi`, value: `Syötä työtunnit ilman ruokatuntivähennyksiä.` }, { language: `sv`, value: `Ange alla dina arbetstid. Lunchtimmar beräknas automatiskt.` }, { language: `en`, value: `Enter all of your working hours. Lunch hours will be calculated automatically.` },);
        this.set(this.myWorkHoursLunchHourInstructionsTitleLanguageItemName, { language: `fi`, value: `Huomio` }, { language: `sv`, value: `Notera` }, { language: `en`, value: `Note` },);
        this.set(this.myWorkHoursNoTaskLanguageItemName, { language: `fi`, value: `EI VALITTUA TEHTÄVÄÄ` }, { language: `sv`, value: `Inget uppdrag tilldelats` }, { language: `en`, value: `NO TASK ASSIGNED` },);
        this.set(this.salaryHoursPanelPriceLanguageItemName, { language: `fi`, value: `Hinta` }, { language: `sv`, value: `Pris` }, { language: `en`, value: `Price` },);
        this.set(this.workOrderDetailsHoursGridPriceLanguageItemName, { language: `fi`, value: `Hinta` }, { language: `sv`, value: `Pris` }, { language: `en`, value: `Price` },);
        this.set(this.workOrderDetailsHoursGridUserLanguageItemName, { language: `fi`, value: `Käyttäjä` }, { language: `sv`, value: `Användare` }, { language: `en`, value: `User` },);
        this.set(this.workOrderDetailsHoursGridOverTime50LanguageItemName, { language: `fi`, value: `Ylityö 50%` }, { language: `sv`, value: `Övertid 50%` }, { language: `en`, value: `Overtime 50%` },);
        this.set(this.workOrderDetailsHoursGridOverTime100LanguageItemName, { language: `fi`, value: `Ylityö 100%` }, { language: `sv`, value: `Övertid 100%` }, { language: `en`, value: `Overtime 100%` },);
        this.set(this.workOrderDetailsHoursGridNormalHoursLanguageItemName, { language: `fi`, value: `Normaalit` }, { language: `sv`, value: `Vanligt` }, { language: `en`, value: `Normal` },);
        this.set(this.workOrderDetailsHoursGridHoursHeaderLanguageItemName, { language: `fi`, value: `Tunnit` }, { language: `sv`, value: `Timme` }, { language: `en`, value: `Hours` },);
        this.set(this.workOrderDetailsHoursGridDayLanguageItemName, { language: `fi`, value: `Päivä` }, { language: `sv`, value: `Dag` }, { language: `en`, value: `Day` },);
        this.set(this.workOrderDetailsDistancesTabTitleLanguageItemName, { language: `fi`, value: `Matkakulut` }, { language: `sv`, value: `Kostnad servicebil` }, { language: `en`, value: `Mileages` },);
        this.set(this.workOrderDetailsAddHoursLanguageItemName, { language: `fi`, value: `Lisää tunteja` }, { language: `sv`, value: `Lägg till timmar` }, { language: `en`, value: `Add hours` },);
        this.set(this.workOrderDetailsAddDistanceLanguageItemName, { language: `fi`, value: `Lisää kilometrikorvaus` }, { language: `sv`, value: `Lägg till avstånd` }, { language: `en`, value: `Add distance` },);
        this.set(this.workOrderApprovalModalTitleLanguageItemName, { language: `fi`, value: `Työtilauksen "{0}" hyväksyntä` }, { language: `sv`, value: `Arbetsorder "{0}" godkännande` }, { language: `en`, value: `Work order "{0}" approval` },);
        this.set(this.workHoursWidgetSummaryLanguageItemName, { language: `fi`, value: `Tunnit: {0:0.0}` }, { language: `sv`, value: `Arbetstid: {0:0.0}` }, { language: `en`, value: `Working hours: {0:0.0}` },);
        this.set(this.workOrderLabelsMyHoursLanguageItemName, { language: `fi`, value: `Minun tunnit` }, { language: `sv`, value: `Mina timmar` }, { language: `en`, value: `My hours` },);
        this.set(this.workOrderApprovalEquipmentAmountLanguageItemName, { language: `fi`, value: `Määrä` }, { language: `sv`, value: `Kvantitet` }, { language: `en`, value: `Amount` },);
        this.set(this.workOrderApprovalEquipmentDescriptionLanguageItemName, { language: `fi`, value: `Nimi` }, { language: `sv`, value: `Beskrivning` }, { language: `en`, value: `Description` },);
        this.set(this.workOrderApprovalEquipmentInfoLanguageItemName, { language: `fi`, value: `Kuvaus` }, { language: `sv`, value: `Info` }, { language: `en`, value: `Info` },);
        this.set(this.workOrderApprovalEquipmentUnitLanguageItemName, { language: `fi`, value: `Yksikkö` }, { language: `sv`, value: `Enhet` }, { language: `en`, value: `Unit` },);
        this.set(this.workOrderApprovalEquipmentsTableNameLanguageItemName, { language: `fi`, value: `Tarvikkeet` }, { language: `sv`, value: `Utrustning` }, { language: `en`, value: `Equipments` },);
        this.set(this.workOrderApprovalHoursDayLanguageItemName, { language: `fi`, value: `Päivä` }, { language: `sv`, value: `Dag` }, { language: `en`, value: `Day` },);
        this.set(this.workOrderApprovalHoursNormalHoursLanguageItemName, { language: `fi`, value: `Tunnit` }, { language: `sv`, value: `Timme` }, { language: `en`, value: `Hours` },);
        this.set(this.workOrderApprovalHoursOvertime100HoursLanguageItemName, { language: `fi`, value: `Ylityötunnit 100%` }, { language: `sv`, value: `Övertid 100%` }, { language: `en`, value: `Overtime 100%` },);
        this.set(this.workOrderApprovalHoursOvertime50HoursLanguageItemName, { language: `fi`, value: `Ylityötunnit 50%` }, { language: `sv`, value: `Övertid 50%` }, { language: `en`, value: `Overtime 50%` },);
        this.set(this.workOrderApprovalHoursUserLanguageItemName, { language: `fi`, value: `Asentaja` }, { language: `sv`, value: `Montör` }, { language: `en`, value: `Mounter` },);
        this.set(this.workOrderApprovalHoursTableNameLanguageItemName, { language: `fi`, value: `Tunnit` }, { language: `sv`, value: `Timme` }, { language: `en`, value: `Hours` },);
        this.set(this.workOrderApprovalMileagesDateLanguageItemName, { language: `fi`, value: `Päivä` }, { language: `sv`, value: `Dag` }, { language: `en`, value: `Day` },);
        this.set(this.workOrderApprovalMileagesTotalMileagesLanguageItemName, { language: `fi`, value: `Kokonaismatka, km` }, { language: `sv`, value: `Totalt avstånd, km` }, { language: `en`, value: `Total distance, km` },);
        this.set(this.workOrderApprovalMileagesVehicleAmountLanguageItemName, { language: `fi`, value: `Ajoneuvojen lkm` }, { language: `sv`, value: `Fordon` }, { language: `en`, value: `Vehicles` },);
        this.set(this.workOrderApprovalMileagesTableNameLanguageItemName, { language: `fi`, value: `Matkakulut` }, { language: `sv`, value: `Miles` }, { language: `en`, value: `Mileages` },);
        this.set(this.workDayPanelSiteOrWarehouseColumnTitleLanguageItemName, { language: `fi`, value: `"Työnjohtaja: {0}\nOsoite: {1}  "` }, { language: `sv`, value: `"Manager: {0} \naddress: {1}"` }, { language: `en`, value: `"Manager: {0}\nAddress: {1}  "` },);
        this.set(this.workDayPanelNoReportedHoursLanguageItemName, { language: `fi`, value: `Ei raportoituja tunteja` }, { language: `sv`, value: `Inga rapporterade timmar` }, { language: `en`, value: `No reported hours` },);
        this.set(this.widgetSalaryPeriodDescriptionLanguageItemName, { language: `fi`, value: `Palkkajaksoa jäljellä` }, { language: `sv`, value: `Lönedagar kvar` }, { language: `en`, value: `Salary days left` },);
        this.set(this.widgetSalaryPeriodLabelLanguageItemName, { language: `fi`, value: `Palkkajakso` }, { language: `sv`, value: `Löneperiod` }, { language: `en`, value: `Salary period` },);
        this.set(this.userManagementSubcontractorLabelLanguageItemName, { language: `fi`, value: `Aliurakoitsija` }, { language: `sv`, value: `Underleverantör` }, { language: `en`, value: `Subcontractor` },);
        this.set(this.userManagementOrganizationContractsLabelLanguageItemName, { language: `fi`, value: `Asiakkuudet` }, { language: `sv`, value: `Organisationskontrakt` }, { language: `en`, value: `Organization Contracts` },);
        this.set(this.userManagementAlertErrorWorkCardIdExistsLanguageItemName, { language: `fi`, value: `Valttikortti-id "{0}" on jo lisätty toiselle käyttäjälle.` }, { language: `sv`, value: `Arbetskort -ID "{0}" är redan registrerat för ett annat användarkonto.` }, { language: `en`, value: `Work card id "{0}" is already registered for another user account.` },);
        this.set(this.taskTooltipsTaskDeclinedLanguageItemName, { language: `fi`, value: `Asiakas on hylännyt työtilauksen` }, { language: `sv`, value: `Arbetsorder avvisas av kunden` }, { language: `en`, value: `Work order is declined by customer` },);
        this.set(this.taskTooltipsNewTaskLanguageItemName, { language: `fi`, value: `Uusi työtilaus` }, { language: `sv`, value: `Ny arbetsorder` }, { language: `en`, value: `New work order` },);
        this.set(this.tasksPanelPriceLanguageItemName, { language: `fi`, value: `Hinta` }, { language: `sv`, value: `Pris` }, { language: `en`, value: `Price` },);
        this.set(this.tasksPanelNameLanguageItemName, { language: `fi`, value: `Nimi` }, { language: `sv`, value: `Namn` }, { language: `en`, value: `Name` },);
        this.set(this.tasksPanelFlyoutChangesSavedLanguageItemName, { language: `fi`, value: `Muutokset ovat onnistuneesti tallennettu` }, { language: `sv`, value: `Förändringar sparades framgångsrikt` }, { language: `en`, value: `Changes were successfully saved` },);
        this.set(this.tasksPanelDeleteTaskLanguageItemName, { language: `fi`, value: `Poista työtilaus` }, { language: `sv`, value: `Ta bort uppgift` }, { language: `en`, value: `Delete task` },);
        this.set(this.tasksPanelDeleteHoursLanguageItemName, { language: `fi`, value: `Poista tunnit` }, { language: `sv`, value: `Ta bort timmar` }, { language: `en`, value: `Delete hours` },);
        this.set(this.tasksPanelCommitChangesLanguageItemName, { language: `fi`, value: `Tallenna` }, { language: `sv`, value: `Spara ändringar` }, { language: `en`, value: `Save changes` },);
        this.set(this.tasksPanelCancelChangesLanguageItemName, { language: `fi`, value: `Peruuta` }, { language: `sv`, value: `Avbryt ändringar` }, { language: `en`, value: `Cancel changes` },);
        this.set(this.tasksPanelAddWorkReportFlyoutLanguageItemName, { language: `fi`, value: `Työraportti on luotu` }, { language: `sv`, value: `Arbetsrapporten skapades framgångsrikt` }, { language: `en`, value: `Work report was created successfully` },);
        this.set(this.tasksPanelAddHoursModalNoHoursLanguageItemName, { language: `fi`, value: `Ei tunteja` }, { language: `sv`, value: `Inga timmar` }, { language: `en`, value: `No hours` },);
        this.set(this.tasksPanelAddHoursModalConfirmationLanguageItemName, { language: `fi`, value: `Oletko varma että haluat poista asentajan työtunnit?` }, { language: `sv`, value: `Är du säker på att du vill ta bort Mounters arbetstimmar?` }, { language: `en`, value: `Are you sure that you want to delete mounter's working hours?` },);
        this.set(this.tasksPanelAddHoursModalAddHoursLanguageItemName, { language: `fi`, value: `Lisää asentajan tunnit` }, { language: `sv`, value: `Lägg till mountertimmar` }, { language: `en`, value: `Add mounter hours` },);
        this.set(this.tasksPanelAddHoursFlyoutLanguageItemName, { language: `fi`, value: `Asentajan tunnit on lisätty` }, { language: `sv`, value: `Mountertimmar har lagts till framgångsrikt` }, { language: `en`, value: `Mounter hours has been added successfully` },);
        this.set(this.tasksPanelAddExtraTaskFlyoutLanguageItemName, { language: `fi`, value: `Tehtävä on luotu` }, { language: `sv`, value: `Extra uppdrag skapades framgångsrikt` }, { language: `en`, value: `Extra task was created successfully` },);
        this.set(this.taskHoursPanelRestoreDeletedHoursLanguageItemName, { language: `fi`, value: `Palauta poistetut tunnit` }, { language: `sv`, value: `Återställ raderade timmar` }, { language: `en`, value: `Restore deleted hours` },);
        this.set(this.tasksPageManagerCostPoolsLanguageItemName, { language: `fi`, value: `Työnjohtajan kustannuspaikka` }, { language: `sv`, value: `Kostnadspool` }, { language: `en`, value: `Manager Cost pool` },);
        this.set(this.tasksPageNotAssignedLanguageItemName, { language: `fi`, value: `Näytä määrittämättömät` }, { language: `sv`, value: `Visar inte` }, { language: `en`, value: `Show unassigned` },);
        this.set(this.tasksPageTaskStatusLanguageItemName, { language: `fi`, value: `Tehtävän tila` }, { language: `sv`, value: `Uppdragsstatus` }, { language: `en`, value: `Task status` },);
        this.set(this.tasksPageTaskStatusAnyLanguageItemName, { language: `fi`, value: `Kaikki` }, { language: `sv`, value: `Allt` }, { language: `en`, value: `All` },);
        this.set(this.tasksPageTaskStatusAnySubtextLanguageItemName, { language: `fi`, value: `Kaikki tehtävät` }, { language: `sv`, value: `Alla uppgifter` }, { language: `en`, value: `All tasks` },);
        this.set(this.tasksPageTaskStatusFurtherLanguageItemName, { language: `fi`, value: `Tulevat` }, { language: `sv`, value: `Ytterligare` }, { language: `en`, value: `Further` },);
        this.set(this.tasksPageTaskStatusFurtherSubtextLanguageItemName, { language: `fi`, value: `Tulevat tehtävät` }, { language: `sv`, value: `Ytterligare uppgifter` }, { language: `en`, value: `Further tasks` },);
        this.set(this.tasksPageTaskStatusOngoingLanguageItemName, { language: `fi`, value: `Meneillä olevat` }, { language: `sv`, value: `Pågående` }, { language: `en`, value: `Ongoing` },);
        this.set(this.tasksPageTaskStatusOngoingSubtextLanguageItemName, { language: `fi`, value: `Meneillä olevat tehtävät` }, { language: `sv`, value: `Pågående uppgifter` }, { language: `en`, value: `Ongoing tasks` },);
        this.set(this.taskHoursPanelDeleteHoursLanguageItemName, { language: `fi`, value: `Poista tunnit` }, { language: `sv`, value: `Ta bort timmar` }, { language: `en`, value: `Delete hours` },);
        this.set(this.taskHoursPanelDateLanguageItemName, { language: `fi`, value: `Päivämäärä` }, { language: `sv`, value: `Datum` }, { language: `en`, value: `Date` },);
        this.set(this.taskHoursPanelCommitChangesLanguageItemName, { language: `fi`, value: `Tallenna` }, { language: `sv`, value: `Begå förändringar` }, { language: `en`, value: `Commit changes` },);
        this.set(this.taskHoursPanelCancelChangesLanguageItemName, { language: `fi`, value: `Peruuta` }, { language: `sv`, value: `Avbryt ändringar` }, { language: `en`, value: `Cancel changes` },);
        this.set(this.taskHoursPanelApproveHoursLanguageItemName, { language: `fi`, value: `Hyväksy tunnit` }, { language: `sv`, value: `Godkänna timmar` }, { language: `en`, value: `Approve hours` },);
        this.set(this.summaryWidgetLabelsDistanceLanguageItemName, { language: `fi`, value: `Matkakorvaukset: <mark>{0} km</mark>` }, { language: `sv`, value: `Avstånd: <mark>{0} km</mark>` }, { language: `en`, value: `Distance: <mark>{0} km</mark>` },);
        this.set(this.summaryWidgetLabelsHoursLanguageItemName, { language: `fi`, value: `Työtunnit: <mark>{0:0.0} t ({1:0.0}/{2:0.0}/{3:0.0})</mark>` }, { language: `sv`, value: `Arbetstid:  <mark>{0:0.0} h ({1:0.0}/{2:0.0}/{3:0.0})</mark>` }, { language: `en`, value: `Working hours: <mark>{0:0.0} h ({1:0.0}/{2:0.0}/{3:0.0})</mark>` },);
        this.set(this.summaryManualLanguageItemName, { language: `fi`, value: `Tämä on työraportin yhteenveto. Tarkasta yhteenveto huolellisesti ennen hyväksyntää.` }, { language: `sv`, value: `Detta är sammanfattningen av arbetsrapporten. Granska sammanfattningen noggrant före godkännande.` }, { language: `en`, value: `This is the work report summary. Review the summary carefully before approval.` },);
        this.set(this.rentaTasksWorkOrderSignInFailedAlertLanguageItemName, { language: `fi`, value: `Työtilaukselle kirjautuminen epäonnistui, koska työtilauksen tila on muuttunut.` }, { language: `sv`, value: `Kan inte logga in på arbetsordern. Arbetsorderstatusen har ändrats.` }, { language: `en`, value: `Cannot sign-in to the work order. The work order status has been changed.` },);
        this.set(this.rentaTasksWorkOrderSignOutFailedAlertLanguageItemName, { language: `fi`, value: `Työtilausta ei voida muokata koska työtilauksen tila on muuttunut. Sinut on kirjattu työtilakuselta ulos automaattisesti.` }, { language: `sv`, value: `Arbetsordningen kan inte ändras. Arbetsorderstatusen har ändrats. Du har automatiskt loggats ut.` }, { language: `en`, value: `The work order cannot be modified. The work order status has been changed. You have been automatically signed-out.` },);
        this.set(this.rentaTasksControllerAlertsApprovedLanguageItemName, { language: `fi`, value: `Työtilaus {0} hyväksytty.` }, { language: `sv`, value: `Arbetsorder "{0}" godkänd framgångsrikt.` }, { language: `en`, value: `Work order "{0}" approved successfully.` },);
        this.set(this.rentaTasksControllerAlertsCreatedLanguageItemName, { language: `fi`, value: `Työtilaus "{0}" luotu.` }, { language: `sv`, value: `Arbetsordning "{0}" skapade framgångsrikt.` }, { language: `en`, value: `Work order "{0}" created successfully.` },);
        this.set(this.rentaTasksControllerStepsTitleSummaryLanguageItemName, { language: `fi`, value: `Yhteenveto` }, { language: `sv`, value: `Sammanfattning` }, { language: `en`, value: `Summary` },);
        this.set(this.rentaTasksControllerStepsTitleManagersLanguageItemName, { language: `fi`, value: `Hyväksyjät` }, { language: `sv`, value: `Montageledarna` }, { language: `en`, value: `Managers` },);
        this.set(this.rentaTasksControllerStepsTitleHoursAndDistanceLanguageItemName, { language: `fi`, value: `Tunnit ja matkat` }, { language: `sv`, value: `Timmar och avstånd` }, { language: `en`, value: `Hours & distances` },);
        this.set(this.rentaTasksControllerStepsTitleEditLanguageItemName, { language: `fi`, value: `Muokkaa tehtävää` }, { language: `sv`, value: `Redigera uppgift` }, { language: `en`, value: `Edit task` },);
        this.set(this.rentaTasksControllerStepsTitleApprovingLanguageItemName, { language: `fi`, value: `Hyväksyntä` }, { language: `sv`, value: `Godkännande` }, { language: `en`, value: `Approving` },);
        this.set(this.rentaTasksControllerStepsActivateConstructionSiteTitleSummaryLanguageItemName, { language: `fi`, value: `Yhteenveto` }, { language: `sv`, value: `Sammanfattning` }, { language: `en`, value: `Summary` },);
        this.set(this.rentaTasksControllerStepsActivateConstructionSiteTitleSelectCustomerLanguageItemName, { language: `fi`, value: `Valitse asiakas` }, { language: `sv`, value: `Välj kund` }, { language: `en`, value: `Select customer` },);
        this.set(this.rentaTasksControllerStepsActivateConstructionSiteTitleSelectConstructionSiteLanguageItemName, { language: `fi`, value: `Valitse työmaa` }, { language: `sv`, value: `Välj byggplats` }, { language: `en`, value: `Select construction site` },);
        this.set(this.rentaTasksControllerStepsActivateConstructionSiteTitleConfirmAddressLanguageItemName, { language: `fi`, value: `Vahvista osoite` }, { language: `sv`, value: `Bekräfta adress` }, { language: `en`, value: `Confirm address` },);
        this.set(this.rentaTasksControllerNewWorkOrderNameLanguageItemName, { language: `fi`, value: `Uusi työtilaus` }, { language: `sv`, value: `Ny arbetsorder` }, { language: `en`, value: `New work order` },);
        this.set(this.rentaTasksControllerAlertsSignOutFromSiteLanguageItemName, { language: `fi`, value: `Olet kirjautunut ulos työmaalta.` }, { language: `sv`, value: `Du har loggat ut från byggarbetsplatsen.` }, { language: `en`, value: `You have been sign-out from the construction site.` },);
        this.set(this.rentaTasksControllerAlertsSentToCustomerLanguageItemName, { language: `fi`, value: `Työraportti {0} lähetetty asiakkaalle.` }, { language: `sv`, value: `Arbetsrapport "{0}" har skickats till en kund.` }, { language: `en`, value: `Work report "{0}" has been sent to a customer.` },);
        this.set(this.rentaTasksWorkOrderButtonLabelEditHoursAndDistancesLanguageItemName, { language: `fi`, value: `Lisää tunteja ja matkoja` }, { language: `sv`, value: `Lägg till timmar och avstånd` }, { language: `en`, value: `Add hours and distances` },);
        this.set(this.rentaTasksWorkOrderCompleteFailedAlertLanguageItemName, { language: `fi`, value: `Työtilausta ei voida valmistaa. Työtilauksen tila on muuttunut.` }, { language: `sv`, value: `Arbetsordern kan inte slutföras. Arbetsorderstatusen har ändrats.` }, { language: `en`, value: `The work order cannot be completed. The work order status has been changed.` },);
        this.set(this.rentaTasksWorkOrderEditFailedAlertLanguageItemName, { language: `fi`, value: `Työtilausta ei voida muokata. Työtilauksen tila on muuttunut.` }, { language: `sv`, value: `Arbetsordningen kan inte ändras. Arbetsorderstatusen har ändrats.` }, { language: `en`, value: `The work order cannot be modified. The work order status has been changed.` },);
        this.set(this.rentaTasksWorkOrderEditHoursAndDistancesAlertLanguageItemName, { language: `fi`, value: `Työtilauksen tunnit ja matkat on tallennettu onnistuneesti.` }, { language: `sv`, value: `Arbetsordertimmar och avstånd uppdateras framgångsrikt.` }, { language: `en`, value: `The work order hours and distances are updated successfully.` },);
        this.set(this.rentaTasksWorkOrderEditHoursAndDistancesFailedAlertLanguageItemName, { language: `fi`, value: `Työtilauksen tunteja ja matkoja ei voida muokata. Työtilauksen tila on muuttunut.` }, { language: `sv`, value: `Arbetsordertimmar och avstånd kan inte modifieras. Arbetsorderstatusen har ändrats.` }, { language: `en`, value: `The work order hours and distances cannot be modified. The work order status has been changed.` },);
        this.set(this.organizationPanelIntermediatorLanguageItemName, { language: `fi`, value: `Operaattoritunnus` }, { language: `sv`, value: `Mellanhand` }, { language: `en`, value: `Intermediator` },);
        this.set(this.organizationPanelNameLanguageItemName, { language: `fi`, value: `Nimi` }, { language: `sv`, value: `Namn` }, { language: `en`, value: `Name` },);
        this.set(this.organizationPanelTransactionIdentifierLanguageItemName, { language: `fi`, value: `Verkkolaskuosoite` }, { language: `sv`, value: `E-fakturadress` }, { language: `en`, value: `E-invoice address` },);
        this.set(this.organizationPanelVirtualAddressLanguageItemName, { language: `fi`, value: `Virtuaaliosoite (Postilokero)` }, { language: `sv`, value: `Virtuell adress (postlåda)` }, { language: `en`, value: `Virtual address (Postal box)` },);
        this.set(this.rentaTasksWorkOrderAddEquipmentFailedAlertLanguageItemName, { language: `fi`, value: `Työtilauksen tarvikkeita ei voida muokata. Työtilauksen tila on muuttunut.` }, { language: `sv`, value: `Arbetsorderutrustningen kan inte ändras. Arbetsorderstatusen har ändrats.` }, { language: `en`, value: `The work order equipment cannot be modified. The work order status has been changed.` },);
        this.set(this.rentaTasksWorkOrderActivateConstructionSiteAlertLanguageItemName, { language: `fi`, value: `Työmaa aktivoitu onnistuneesti.` }, { language: `sv`, value: `Byggplatsen aktiverades framgångsrikt.` }, { language: `en`, value: `Construction site activated successfully.` },);
        this.set(this.rentaTasksSignatureAlertLanguageItemName, { language: `fi`, value: `Työraportti on lähetetty asiakkaalle` }, { language: `sv`, value: `Arbetsrapporten har skickats till en kund` }, { language: `en`, value: `Work report has been sent to a customer` },);
        this.set(this.rentaTasksSelectTaskNotAssignedLanguageItemName, { language: `fi`, value: `Määrittämättömät` }, { language: `sv`, value: `Inte tilldelats` }, { language: `en`, value: `Not assigned` },);
        this.set(this.rentaTasksSelectTaskMyTasksLanguageItemName, { language: `fi`, value: `Minun tehtävät` }, { language: `sv`, value: `Mina uppgifter` }, { language: `en`, value: `My tasks` },);
        this.set(this.rentaTasksSelectSiteNotFoundLanguageItemName, { language: `fi`, value: `Työmaata ei löydy tai qr-koodia ei voida tunnistaa` }, { language: `sv`, value: `Byggplatsen hittades inte eller QR -kod kan inte erkännas` }, { language: `en`, value: `Construction site not found or qr code cannot be recognized` },);
        this.set(this.rentaTasksSelectSiteNoAvailableSitesLanguageItemName, { language: `fi`, value: `Valitulle asiakkaalle ei ole saatavana työmaita` }, { language: `sv`, value: `Inga byggarbetsplatser tillgängliga för utvalt företag` }, { language: `en`, value: `No construction sites available for selected company` },);
        this.set(this.rentaTasksSelectOrganizationNoOrganizationsLanguageItemName, { language: `fi`, value: `Asiakkaita ei ole saatavilla` }, { language: `sv`, value: `Inga organisationer tillgängliga` }, { language: `en`, value: `No organizations available` },);
        this.set(this.rentaTasksControllerWorkOrderConcurrencyAlertLanguageItemName, { language: `fi`, value: `{0} on muokannut työtilausta {1:D}. Tarkasta työtilauksen tiedot.` }, { language: `sv`, value: `Arbetsordningen modifierades av "{0}" på "{1: d}". Kontrollera WO -detaljerna och fortsätt.` }, { language: `en`, value: `The work order was modified by "{0}" at "{1:D}". Please check the WO details and continue.` },);
        this.set(this.rentaTasksControllerStepsTitleTaskStatusLanguageItemName, { language: `fi`, value: `Tehtävän tila` }, { language: `sv`, value: `Uppdragsstatus` }, { language: `en`, value: `Task status` },);
        this.set(this.rentaTasksControllerStepsTitleSignatureLanguageItemName, { language: `fi`, value: `Allekirjoitus` }, { language: `sv`, value: `Signatur` }, { language: `en`, value: `Signature` },);
        this.set(this.rentaTasksControllerStepsTitleSelectTaskLanguageItemName, { language: `fi`, value: `Valitse tehtävä` }, { language: `sv`, value: `Välj uppgift` }, { language: `en`, value: `Select task` },);
        this.set(this.rentaTasksControllerStepsTitleSelectSiteLanguageItemName, { language: `fi`, value: `Valitse työmaa` }, { language: `sv`, value: `Välj webbplats` }, { language: `en`, value: `Select site` },);
        this.set(this.rentaTasksControllerStepsTitleSelectOrganizationLanguageItemName, { language: `fi`, value: `Valitse asiakas` }, { language: `sv`, value: `Välj klient` }, { language: `en`, value: `Select client` },);
        this.set(this.rentaTasksControllerStepsTitleNewTaskLanguageItemName, { language: `fi`, value: `Uusi tehtävä` }, { language: `sv`, value: `Ny uppgift` }, { language: `en`, value: `New task` },);
        this.set(this.rentaTasksControllerStepsTitleMountersLanguageItemName, { language: `fi`, value: `Asentajat` }, { language: `sv`, value: `Montör` }, { language: `en`, value: `Mounters` },);
        this.set(this.rentaTasksControllerStepsTitleEquipmentLanguageItemName, { language: `fi`, value: `Työkalut` }, { language: `sv`, value: `Utrustning` }, { language: `en`, value: `Equipment` },);
        this.set(this.rentaTasksControllerStepsTitleDistanceLanguageItemName, { language: `fi`, value: `Matka` }, { language: `sv`, value: `Distans` }, { language: `en`, value: `Distance` },);
        this.set(this.rentaTasksControllerStepsTitleApproveLanguageItemName, { language: `fi`, value: `Hyväksy` }, { language: `sv`, value: `Godkänna` }, { language: `en`, value: `Approve` },);
        this.set(this.rentaTasksControllerStepsTitleAllowanceLanguageItemName, { language: `fi`, value: `Korvaukset` }, { language: `sv`, value: `Ersättning` }, { language: `en`, value: `Allowance` },);
        this.set(this.rentaTasksAssignMounterDropdownWidgetMountersAssignedLanguageItemName, { language: `fi`, value: `{0} asentajaa määritetty tehtävälle` }, { language: `sv`, value: `{0} Mounter (er) tilldelade uppgiften` }, { language: `en`, value: `{0} mounter(s) assigned to the task` },);
        this.set(this.rentaTasksAssignMounterDropdownWidgetAssignMountersLanguageItemName, { language: `fi`, value: `Määritä tehtävä asentajille` }, { language: `sv`, value: `Tilldela uppdrag till montör` }, { language: `en`, value: `Assign the task to the mounters` },);
        this.set(this.rentaTasksApproveDropdownWidgetTasksToCombineLanguageItemName, { language: `fi`, value: `Paina valitaksesi yhdistettävät tehtävät` }, { language: `sv`, value: `Tryck för att välja uppgifter för att kombinera` }, { language: `en`, value: `Press to select tasks to combine` },);
        this.set(this.rentaTasksApproveDropdownWidgetTasksCombinedLanguageItemName, { language: `fi`, value: `{0} tehtävää yhdistettynä työraporttiin` }, { language: `sv`, value: `{0} Uppgifter kombinerade till arbetsrapporten` }, { language: `en`, value: `{0} tasks combined to the work report` },);
        this.set(this.rentaTasksAddTaskManualLanguageItemName, { language: `fi`, value: `Luo uusi tehtävä työmaalle.\nMääritä tehtävän nimi (paina widgettiä aloittaaksesi muokkauksen) jne.` }, { language: `sv`, value: `Skapa en nytt uppdrag på byggarbetsplatsen.` }, { language: `en`, value: `Create a new task on the construction site.\nSpecify task name (click on widget to start editing) etc.` },);
        this.set(this.rentaTasksAddEquipmentManualLanguageItemName, { language: `fi`, value: `Lisää tarvikkeita valitulle tehtävälle, pyyhkäise tai paina seuraava mikäli tarvikkeita ei ole tarpeen lisätä.` }, { language: `sv`, value: `Lägg till utrustning till den valda uppgiften, svep eller tryck på Nästa om du inte har ytterligare utrustning att lägga till.` }, { language: `en`, value: `Add equipment to the selected task, swipe or press next if you do not have additional equipments to add.` },);
        this.set(this.rentaTasksAddEquipmentDropdownWidgetSpecifyAmountLanguageItemName, { language: `fi`, value: `{0} valittuna, voit määrittää määrän` }, { language: `sv`, value: `{0} Position (er) kan du ange mängden utrustning` }, { language: `en`, value: `{0} position(s), you can specify amount of equipment` },);
        this.set(this.rentaTasksAddEquipmentDropdownWidgetNoEquipmentLanguageItemName, { language: `fi`, value: `Ei varusteita` }, { language: `sv`, value: `Ingen utrustning` }, { language: `en`, value: `No equipment` },);
        this.set(this.rentaManagementSummaryPageManualLanguageItemName, { language: `fi`, value: `Renta Task 1.0.\nYhteenvetovaihe.` }, { language: `sv`, value: `Renta Task 1.0. \nsummary Wizard Step.` }, { language: `en`, value: `Renta Task 1.0.\nSummary wizard step.` },);
        this.set(this.rentaManagementSummaryPageDescriptionLanguageItemName, { language: `fi`, value: `Paina vaihetta saadaksesi lisätietoja.` }, { language: `sv`, value: `Klicka på Steg för ytterligare information.` }, { language: `en`, value: `Click on step for additional info.` },);
        this.set(this.rentaManagementSummaryPageButtonTitleLanguageItemName, { language: `fi`, value: `Valmis` }, { language: `sv`, value: `Komplett` }, { language: `en`, value: `Complete` },);
        this.set(this.rentaManagementSelectSiteNoSiteWithModulesLanguageItemName, { language: `fi`, value: `Ei aktiivisia työmaita, joilla on aktiivinen sopimus ja olemassa olevat moduulit.` }, { language: `sv`, value: `Inga aktiva byggarbetsplatser med aktivt överenskommelse och befintliga moduler.` }, { language: `en`, value: `No active construction sites with active agreement and existing modules.` },);
        this.set(this.rentaManagementSelectModuleNoModulesLanguageItemName, { language: `fi`, value: `Moduuleja ei ole saatavilla valitulle työmaalle ja sopimukselle.` }, { language: `sv`, value: `Inga webbplatsmoduler tillgängliga för vald webbplats och avtal.` }, { language: `en`, value: `No site modules available for selected site and agreement.` },);
        this.set(this.rentaManagementSelectModuleManualLanguageItemName, { language: `fi`, value: `Valitse alasvetovalikosta moduuli, jolla aiot työskennellä, painamalla widgettiä.` }, { language: `sv`, value: `Välj en webbplatsmodul som du kommer att arbeta med från rullgardinsmenyn genom att trycka på Modul Widget.` }, { language: `en`, value: `Select a site module you are going to work on from dropdown menu by pressing on module widget.` },);
        this.set(this.rentaManagementSelectModuleDescriptionLanguageItemName, { language: `fi`, value: `Paina valitaksesi moduulin` }, { language: `sv`, value: `Tryck på för att välja modul` }, { language: `en`, value: `Press to select module` },);
        this.set(this.rentaManagementSelectAgreementNoAgreementLanguageItemName, { language: `fi`, value: `Valitulle työmaalle ei ole saatavana aktiivisia sopimuksia, joilla olisi moduulit.` }, { language: `sv`, value: `Inga aktiva avtal med befintliga moduler tillgängliga för vald webbplats.` }, { language: `en`, value: `No active agreements with existing modules available for selected site.` },);
        this.set(this.rentaManagementSelectAgreementManualLanguageItemName, { language: `fi`, value: `Valitse alasvetovalikosta sopimus, jolla aiot työskennellä, painamalla widgettiä` }, { language: `sv`, value: `Välj ett webbplatsavtal som du kommer att arbeta med från rullgardinsmenyn genom att trycka på avtal Widget` }, { language: `en`, value: `Select a site agreement you are going to work on from dropdown menu by pressing on Agreement widget` },);
        this.set(this.rentaManagementSelectAgreementDescriptionLanguageItemName, { language: `fi`, value: `Paina valitaksesi sopimuksen` }, { language: `sv`, value: `Tryck på för att välja avtal` }, { language: `en`, value: `Press to select agreement` },);
        this.set(this.rentaManagementSaveAuditSentLanguageItemName, { language: `fi`, value: `Tarkastusraportti on lähetetty asiakkaalle.` }, { language: `sv`, value: `Revisionsrapporten har skickats till kunden.` }, { language: `en`, value: `Audit report has been sent to customer.` },);
        this.set(this.rentaManagementSaveAuditManualLanguageItemName, { language: `fi`, value: `Tarkasta moduulia.\nPaina "Tarkasta" -painiketta.\nSe käynnistää tarkastuksen valitulle tehtävälle.\nJaettulle tehtävälle ei voi luoda tarkastusraporttia.` }, { language: `sv`, value: `Revisionsmodul. \nPRESS "Aktivera" -knappen. \nIT skapar och aktiverar granskning för motsvarande uppgift.` }, { language: `en`, value: `Audit module.\nPress "Activate" button.\nIt will create and activate audit for corresponding task.\nTask marked as splitted cannot be audited.` },);
        this.set(this.rentaManagementDashboardManualLanguageItemName, { language: `fi`, value: `\nTervetuloa Renta Management kojelautaan.\n\nPaina "Aktivoi moduuli" aktivoidaksesi teline moduulin rakennustyömaalla.\n\nPaina "Tarkasta moduuli" tarkistaaksesi rakennustelineiden rakennustelineiden.\n\nLuo uusi lisätehtävä työmaalle painamalla "Lisää tehtävä".\n    ` }, { language: `sv`, value: `Välkommen till Renta Management Dashboard.\n\nTryck på "Aktivera modulen" för att aktivera en ställningsmodul på en byggarbetsplats.\n\nTryck på "Audit Module" för att inspektera en ställningsmodul på en byggarbetsplats.\n\nTryck på "Lägg till uppgift" för att skapa en ny extra uppgift för en byggarbetsplats.` }, { language: `en`, value: `Welcome to Renta Management dashboard.\n\nPress "Activate module" to activate a scaffolding module on a construction site.\n\nPress "Audit module" to inspect a scaffolding module on a construction site.\n\nPress "Add task" to create new extra task for a construction site.\n    ` },);
        this.set(this.rentaManagementDashboardAuditDescriptionLanguageItemName, { language: `fi`, value: `Tarkasta työmaan moduuli` }, { language: `sv`, value: `Revisionsbyggnadssidsmodul` }, { language: `en`, value: `Audit construction site module` },);
        this.set(this.rentaManagementDashboardAuditLanguageItemName, { language: `fi`, value: `Tarkasta moduuli` }, { language: `sv`, value: `Granskningsmodul` }, { language: `en`, value: `Audit module` },);
        this.set(this.rentaManagementDashboardAddTaskDescriptionLanguageItemName, { language: `fi`, value: `Luo uusi tehtävä` }, { language: `sv`, value: `Skapa ny uppgift` }, { language: `en`, value: `Create new task` },);
        this.set(this.rentaManagementDashboardAddTaskLanguageItemName, { language: `fi`, value: `Lisää tehtävä` }, { language: `sv`, value: `Lägga till uppgift` }, { language: `en`, value: `Add task` },);
        this.set(this.rentaManagementDashboardActivateDescriptionLanguageItemName, { language: `fi`, value: `Aktivoi työmaan sopimustehtävät` }, { language: `sv`, value: `Aktivera konstruktionsuppgifter` }, { language: `en`, value: `Activate construction site contract tasks` },);
        this.set(this.rentaManagementDashboardActivateLanguageItemName, { language: `fi`, value: `Aktivoi moduuli` }, { language: `sv`, value: `Aktivera modulen` }, { language: `en`, value: `Activate module` },);
        this.set(this.rentaManagementControllerStepsTitleSummaryLanguageItemName, { language: `fi`, value: `Yhteenveto` }, { language: `sv`, value: `Sammanfattning` }, { language: `en`, value: `Summary` },);
        this.set(this.rentaManagementControllerStepsTitleSelectSiteLanguageItemName, { language: `fi`, value: `Valitse työmaa` }, { language: `sv`, value: `Välj webbplats` }, { language: `en`, value: `Select site` },);
        this.set(this.rentaManagementControllerStepsTitleSelectModuleLanguageItemName, { language: `fi`, value: `Valitse moduuli` }, { language: `sv`, value: `Välj modul` }, { language: `en`, value: `Select module` },);
        this.set(this.rentaManagementControllerStepsTitleSelectAgreementLanguageItemName, { language: `fi`, value: `Valitse sopimus` }, { language: `sv`, value: `Välj avtal` }, { language: `en`, value: `Select agreement` },);
        this.set(this.rentaManagementControllerStepsTitleSaveAuditLanguageItemName, { language: `fi`, value: `Tallenna tarkastusraportti` }, { language: `sv`, value: `Spara revision` }, { language: `en`, value: `Save audit` },);
        this.set(this.rentaManagementControllerStepsTitleParamsLanguageItemName, { language: `fi`, value: `Parametrit` }, { language: `sv`, value: `Paramer` }, { language: `en`, value: `Params` },);
        this.set(this.rentaManagementControllerStepsTitleGuideLanguageItemName, { language: `fi`, value: `Opas` }, { language: `sv`, value: `Guide` }, { language: `en`, value: `Guide` },);
        this.set(this.rentaManagementControllerStepsTitleDateLanguageItemName, { language: `fi`, value: `Päivämäärä` }, { language: `sv`, value: `Datum` }, { language: `en`, value: `Date` },);
        this.set(this.rentaManagementControllerStepsTitleCheckLanguageItemName, { language: `fi`, value: `Tarkastus` }, { language: `sv`, value: `Kolla upp` }, { language: `en`, value: `Check` },);
        this.set(this.rentaManagementControllerStepsTitleAuditLanguageItemName, { language: `fi`, value: `Tarkastus` }, { language: `sv`, value: `Granska` }, { language: `en`, value: `Audit` },);
        this.set(this.rentaManagementControllerQuestionUprightsLanguageItemName, { language: `fi`, value: `Pystytuet` }, { language: `sv`, value: `Stam` }, { language: `en`, value: `Uprights` },);
        this.set(this.rentaManagementControllerQuestionSideEndBindingsLanguageItemName, { language: `fi`, value: `Sivu -ja päätyvinositeet` }, { language: `sv`, value: `Sid- och slutbindning` }, { language: `en`, value: `Side and end binding` },);
        this.set(this.rentaManagementControllerQuestionSafetyBarriersLanguageItemName, { language: `fi`, value: `Suojakaiteet` }, { language: `sv`, value: `Säkerhetsbarriärer` }, { language: `en`, value: `Safety barriers` },);
        this.set(this.rentaManagementControllerQuestionFoundationLanguageItemName, { language: `fi`, value: `Perustus` }, { language: `sv`, value: `fundament` }, { language: `en`, value: `Foundation` },);
        this.set(this.rentaManagementControllerQuestionCoversLanguageItemName, { language: `fi`, value: `Telinepeitteet` }, { language: `sv`, value: `Byggnadsställningar` }, { language: `en`, value: `Scaffolding covers` },);
        this.set(this.rentaManagementControllerQuestionCounterTopsLanguageItemName, { language: `fi`, value: `Työtasot` }, { language: `sv`, value: `Bänkskivor` }, { language: `en`, value: `Counter tops` },);
        this.set(this.rentaManagementControllerQuestionBindingsAndSupportersLanguageItemName, { language: `fi`, value: `Vaakasiteet ja kannattajat` }, { language: `sv`, value: `Horisontella bindningar och supportrar` }, { language: `en`, value: `Horizontal bindings and supporters` },);
        this.set(this.rentaManagementControllerQuestionAuditCardLanguageItemName, { language: `fi`, value: `Telinetarkastuskortti` }, { language: `sv`, value: `Ställningskort` }, { language: `en`, value: `Scaffolding audit card` },);
        this.set(this.rentaManagementControllerQuestionAscentWaysLanguageItemName, { language: `fi`, value: `Nousutiet` }, { language: `sv`, value: `Uppstigningsvägar` }, { language: `en`, value: `Ascent ways` },);
        this.set(this.rentaManagementControllerQuestionAnchorageLanguageItemName, { language: `fi`, value: `Ankkurointi` }, { language: `sv`, value: `Ankring` }, { language: `en`, value: `Anchorage` },);
        this.set(this.rentaManagementAuditParams4SpacingLanguageItemName, { language: `fi`, value: `Tason vali, m` }, { language: `sv`, value: `Nivåavstånd, m` }, { language: `en`, value: `Level spacing, m` },);
        this.set(this.rentaManagementAuditParams4HighestLanguageItemName, { language: `fi`, value: `Korkein taso, m` }, { language: `sv`, value: `Högsta nivå, m` }, { language: `en`, value: `Highest level, m` },);
        this.set(this.rentaManagementAuditParams3WindloadLanguageItemName, { language: `fi`, value: `Tulikuorma max, kN [0..1]` }, { language: `sv`, value: `Vindbelastning max, kn [0..1]` }, { language: `en`, value: `Wind load max, kN [0..1]` },);
        this.set(this.rentaManagementAuditParams3WeatherShelterLanguageItemName, { language: `fi`, value: `Sääsuoja, m²` }, { language: `sv`, value: `Väderskydd, m²` }, { language: `en`, value: `Weather shelter, m²` },);
        this.set(this.rentaManagementAuditParams3SnowloadLanguageItemName, { language: `fi`, value: `Lumikuorma max, kN [0..1]` }, { language: `sv`, value: `Snöbelastning Max, KN [0..1]` }, { language: `en`, value: `Snow load max, kN [0..1]` },);
        this.set(this.rentaManagementAuditParams2TypesLanguageItemName, { language: `fi`, value: `Telineiden tyyppi(t)` }, { language: `sv`, value: `Ställningstyp (er)` }, { language: `en`, value: `Scaffolding type(s)` },);
        this.set(this.rentaManagementAuditParams2LoadClassLanguageItemName, { language: `fi`, value: `Telineiden kuormitusluokka` }, { language: `sv`, value: `Byggnadsställningar` }, { language: `en`, value: `Scaffolding load class` },);
        this.set(this.rentaManagementAuditParams2GuidesLanguageItemName, { language: `fi`, value: `Telineiden käyttöohje` }, { language: `sv`, value: `Byggnadsställningsguide` }, { language: `en`, value: `Scaffolding guide(s)` },);
        this.set(this.rentaManagementAuditParams2CustomLanguageItemName, { language: `fi`, value: `Mukautettu opas` }, { language: `sv`, value: `Anpassningsguide` }, { language: `en`, value: `Custom guide` },);
        this.set(this.rentaManagementAuditParams1HandoverDateLanguageItemName, { language: `fi`, value: `Luovutuspäivä` }, { language: `sv`, value: `Överlämnande` }, { language: `en`, value: `Handover date` },);
        this.set(this.rentaManagementAuditParams1AuditorLanguageItemName, { language: `fi`, value: `Tarkastaja (suunnittelu)` }, { language: `sv`, value: `Revisor (planeringar)` }, { language: `en`, value: `Auditor (plannings)` },);
        this.set(this.rentaManagementAuditParams1AuditDateLanguageItemName, { language: `fi`, value: `Tarkastuspäivä` }, { language: `sv`, value: `Granskningsdatum` }, { language: `en`, value: `Audit date` },);
        this.set(this.rentaManagementAuditModuleHeadingTypeLanguageItemName, { language: `fi`, value: `Moduulin tyyppi:` }, { language: `sv`, value: `Modultyp:` }, { language: `en`, value: `Module type:` },);
        this.set(this.rentaManagementAuditModuleHeadingNameLanguageItemName, { language: `fi`, value: `Moduulin nimi:` }, { language: `sv`, value: `Modulnamn:` }, { language: `en`, value: `Module name:` },);
        this.set(this.rentaManagementAuditModuleHeadingIdLanguageItemName, { language: `fi`, value: `Moduulin id:` }, { language: `sv`, value: `Modul -ID:` }, { language: `en`, value: `Module id:` },);
        this.set(this.rentaManagementAuditModuleHeadingAuditSentLanguageItemName, { language: `fi`, value: `Tarkastus lähetetty:` }, { language: `sv`, value: `Revision skickas:` }, { language: `en`, value: `Audit sent:` },);
        this.set(this.rentaManagementAuditModuleHeadingAuditResultLanguageItemName, { language: `fi`, value: `Tarkastuksen tulos:` }, { language: `sv`, value: `Revisionsresultat:` }, { language: `en`, value: `Audit result:` },);
        this.set(this.rentaManagementAuditModuleHeadingAuditDateLanguageItemName, { language: `fi`, value: `Tarkastuspäivä:` }, { language: `sv`, value: `Revisionsdatum:` }, { language: `en`, value: `Audit date:` },);
        this.set(this.rentaManagementAuditModuleHeadingAuditApprovingLanguageItemName, { language: `fi`, value: `Tarkastuksen hyväksyminen:` }, { language: `sv`, value: `Godkännande av granskning:` }, { language: `en`, value: `Audit approving:` },);
        this.set(this.rentaManagementAuditModuleHeadingAssemblyLanguageItemName, { language: `fi`, value: `Asennustehtävä:` }, { language: `sv`, value: `Monteringsuppgift:` }, { language: `en`, value: `Assembly task:` },);
        this.set(this.workOrderButtonTitleApproverDetailsLanguageItemName, { language: `fi`, value: `Hyväksyjän lisätiedot` }, { language: `sv`, value: `Godkännande detaljer` }, { language: `en`, value: `Approver details` },);
        this.set(this.workOrderButtonTitleAssignApproverLanguageItemName, { language: `fi`, value: `Lisää hyväksyjä` }, { language: `sv`, value: `Tilldela godkännare` }, { language: `en`, value: `Assign approver` },);
        this.set(this.workOrderButtonTitleAssignOrdererLanguageItemName, { language: `fi`, value: `Lisää tilaaja` }, { language: `sv`, value: `Tilldela beställare` }, { language: `en`, value: `Assign orderer` },);
        this.set(this.workOrderButtonTitleOrdererDetailsLanguageItemName, { language: `fi`, value: `Tilaajan lisätiedot` }, { language: `sv`, value: `Beställningsinformation` }, { language: `en`, value: `Orderer details` },);
        this.set(this.formDefinitionPageMissingNameLanguageItemName, { language: `fi`, value: ` puuttuva vaadittu nimi` }, { language: `sv`, value: ` saknas nödvändigt namn` }, { language: `en`, value: ` missing required name` },);
        this.set(this.formDefinitionPageMinMaxIncorrectLanguageItemName, { language: `fi`, value: `min/max arvot määritelty väärin` }, { language: `sv`, value: `min/max värden som anges felaktigt` }, { language: `en`, value: `min/max values specified incorrectly` },);
        this.set(this.formDefinitionPageChecksLanguageItemName, { language: `fi`, value: `Tarkastukset` }, { language: `sv`, value: `Kontroller` }, { language: `en`, value: `Checks` },);
        this.set(this.formDefinitionPageRestoredLanguageItemName, { language: `fi`, value: `Lomake on palautettu` }, { language: `sv`, value: `Formdefinition har återställts` }, { language: `en`, value: `Form definition has been restored` },);
        this.set(this.formDefinitionPageDeletedPermanentlyLanguageItemName, { language: `fi`, value: `Lomake poistettiin pysyvästi` }, { language: `sv`, value: `Formdefinition raderades permanent` }, { language: `en`, value: `Form definition was permanently deleted` },);
        this.set(this.formDefinitionPageMarkedAsDeletedLanguageItemName, { language: `fi`, value: `Lomake on merkitty poistetuksi` }, { language: `sv`, value: `Formdefinition är markerad som raderad` }, { language: `en`, value: `Form definition is marked as deleted` },);
        this.set(this.formDefinitionPageValidationErrorsLanguageItemName, { language: `fi`, value: `Lomaketta ei tallennettu, koska se sisältää virheellisiä määrityksiä.` }, { language: `sv`, value: `Formdefinition sparades inte, eftersom den innehåller valideringsfel.` }, { language: `en`, value: `Form definition was not saved, because it contains validation errors.` },);
        this.set(this.formDefinitionPageErrorsLanguageItemName, { language: `fi`, value: `\nVirheet havaittiin seuraavissa vaiheissa tai kentissä: {0}.` }, { language: `sv`, value: `\nFel upptäcktes i nästa steg eller fält: {0}.` }, { language: `en`, value: `\nErrors were detected in next steps or fields:\n{0}.` },);
        this.set(this.formDefinitionPageSavedLanguageItemName, { language: `fi`, value: `Lomake on tallennettu onnistuneesti.` }, { language: `sv`, value: `Formdefinition har sparats framgångsrikt.` }, { language: `en`, value: `Form definition has been saved successfully.` },);
        this.set(this.formDefinitionPageIconLanguageItemName, { language: `fi`, value: `Ikoni` }, { language: `sv`, value: `Ikon` }, { language: `en`, value: `Icon` },);
        this.set(this.formDefinitionPageGroupLanguageItemName, { language: `fi`, value: `Ryhmä` }, { language: `sv`, value: `Grupp` }, { language: `en`, value: `Group` },);
        this.set(this.formDefinitionPageNameLanguageItemName, { language: `fi`, value: `Nimi` }, { language: `sv`, value: `Namn` }, { language: `en`, value: `Name` },);
        this.set(this.formDefinitionPageFormTitleLanguageItemName, { language: `fi`, value: `Otsikko` }, { language: `sv`, value: `Titel` }, { language: `en`, value: `Title` },);
        this.set(this.formDefinitionPageTypeLanguageItemName, { language: `fi`, value: `Tyyppi` }, { language: `sv`, value: `Typ` }, { language: `en`, value: `Type` },);
        this.set(this.formDefinitionPageManualLanguageItemName, { language: `fi`, value: `Ohje` }, { language: `sv`, value: `Beskrivning` }, { language: `en`, value: `Manual` },);
        this.set(this.formDefinitionPageAddNewCheckLanguageItemName, { language: `fi`, value: `Lisää uusi tarkistus` }, { language: `sv`, value: `Lägg till ny check` }, { language: `en`, value: `Add new check` },);
        this.set(this.formDefinitionPageTitleLanguageItemName, { language: `fi`, value: `Muokkaa lomaketta` }, { language: `sv`, value: `Redigera formulärdefinition` }, { language: `en`, value: `Edit form definition` },);
        this.set(this.formDefinitionPageFormNameLanguageItemName, { language: `fi`, value: `Lomakkeen nimi` }, { language: `sv`, value: `Formnamn` }, { language: `en`, value: `Form name` },);
        this.set(this.formDefinitionPageCustomTypeLanguageItemName, { language: `fi`, value: `Räätälöity tyyppi` }, { language: `sv`, value: `Anpassningstyp` }, { language: `en`, value: `Custom type` },);
        this.set(this.formDefinitionPageReportingHeadersLanguageItemName, { language: `fi`, value: `Raportoinnin otsikot (kohdistus)` }, { language: `sv`, value: `Rapporteringrubriker (mappning)` }, { language: `en`, value: `Reporting headers (mapping)` },);
        this.set(this.formDefinitionPageWorkOrdersLanguageItemName, { language: `fi`, value: `Työtilaukset (kohdistus)` }, { language: `sv`, value: `Arbetsorder (mappning)` }, { language: `en`, value: `Work orders (mapping)` },);
        this.set(this.formDefinitionPageTimeslotLanguageItemName, { language: `fi`, value: `Aikaväli (kohdistus)` }, { language: `sv`, value: `Tidslucka (kartläggning)` }, { language: `en`, value: `Timeslot (mapping)` },);
        this.set(this.formDefinitionPageRequireLanguageItemName, { language: `fi`, value: `Vaaditaan (kohdistus)` }, { language: `sv`, value: `Krävs (kartläggning)` }, { language: `en`, value: `Required (mapping)` },);
        this.set(this.formDefinitionPageMultipleLanguageItemName, { language: `fi`, value: `Useita (kohdistus)` }, { language: `sv`, value: `Flera (mappning)` }, { language: `en`, value: `Multiple (mapping)` },);
        this.set(this.formDefinitionPageApprovableLanguageItemName, { language: `fi`, value: `Hyväksyttävä (kartoitus)` }, { language: `sv`, value: `Godkänd (mappning)` }, { language: `en`, value: `Approvable (mapping)` },);
        this.set(this.genericSaveLanguageItemName, { language: `fi`, value: `Tallenna` }, { language: `sv`, value: `Spara` }, { language: `en`, value: `Save` },);
        this.set(this.genericRestoreLanguageItemName, { language: `fi`, value: `Palauta` }, { language: `sv`, value: `Återställ` }, { language: `en`, value: `Restore` },);
        this.set(this.genericDeleteLanguageItemName, { language: `fi`, value: `Poista` }, { language: `sv`, value: `Radera` }, { language: `en`, value: `Delete` },);
        this.set(this.genericBackLanguageItemName, { language: `fi`, value: `Palaa` }, { language: `sv`, value: `Tillbaka` }, { language: `en`, value: `Back` },);
        this.set(this.formDefinitionPageDeleteConfirmationLanguageItemName, { language: `fi`, value: `Haluatko varmasti poistaa lomakkeen?` }, { language: `sv`, value: `Är du säker på att du vill ta bort formuläret?` }, { language: `en`, value: `Are you sure you want to delete the form?` },);
        this.set(this.enumCustomFormTypeAuditLanguageItemName, { language: `fi`, value: `Auditointi` }, { language: `sv`, value: `Granska` }, { language: `en`, value: `Audit` },);
        this.set(this.enumCustomFormTypeUndefinedLanguageItemName, { language: `fi`, value: `Määrittelemätön` }, { language: `sv`, value: `Odefinierad` }, { language: `en`, value: `Undefined` },);
        this.set(this.enumFormHeaderTypeConstructionSiteAddressLanguageItemName, { language: `fi`, value: `Työmaan osoite` }, { language: `sv`, value: `Projektadress` }, { language: `en`, value: `Project address` },);
        this.set(this.enumFormHeaderTypeConstructionSiteNameLanguageItemName, { language: `fi`, value: `Työmaan nimi` }, { language: `sv`, value: `Projektnamn` }, { language: `en`, value: `Project name` },);
        this.set(this.enumFormHeaderTypeWorkOrderManagerNameLanguageItemName, { language: `fi`, value: `Työnjohtajan nimi` }, { language: `sv`, value: `Namn på arbetsorderansvarig` }, { language: `en`, value: `Work order manager name` },);
        this.set(this.enumFormHeaderTypeCustomerNameLanguageItemName, { language: `fi`, value: `Asiakkaan nimi` }, { language: `sv`, value: `Köparens namn` }, { language: `en`, value: `Customer name` },);
        this.set(this.enumFormHeaderTypeWorkOrderManagerEmailLanguageItemName, { language: `fi`, value: `Työnjohtajan sähköposti` }, { language: `sv`, value: `E-post för arbetsorderansvarig` }, { language: `en`, value: `Work order manager email` },);
        this.set(this.enumFormHeaderTypeCustomerNumberLanguageItemName, { language: `fi`, value: `Asiakasnumero` }, { language: `sv`, value: `Kundnummer` }, { language: `en`, value: `Customer number` },);
        this.set(this.enumFormMeasuringOperatorBiggerLanguageItemName, { language: `fi`, value: `>` }, { language: `sv`, value: `>` }, { language: `en`, value: `>` },);
        this.set(this.enumFormMeasuringOperatorBiggerOrEqualLanguageItemName, { language: `fi`, value: `≥` }, { language: `sv`, value: `≥` }, { language: `en`, value: `≥` },);
        this.set(this.enumFormMeasuringOperatorEqualLanguageItemName, { language: `fi`, value: `=` }, { language: `sv`, value: `=` }, { language: `en`, value: `=` },);
        this.set(this.enumFormMeasuringOperatorLessLanguageItemName, { language: `fi`, value: `<` }, { language: `sv`, value: `<` }, { language: `en`, value: `<` },);
        this.set(this.enumFormMeasuringOperatorLessOrEqualLanguageItemName, { language: `fi`, value: `≤` }, { language: `sv`, value: `≤` }, { language: `en`, value: `≤` },);
        this.set(this.enumFormMeasuringOperatorNotEqualLanguageItemName, { language: `fi`, value: `≠` }, { language: `sv`, value: `≠` }, { language: `en`, value: `≠` },);
        this.set(this.enumFormHeaderTypeConstructionSiteNumberLanguageItemName, { language: `fi`, value: `Projektin numero` }, { language: `sv`, value: `Projektnummer` }, { language: `en`, value: `Project number` },);
        this.set(this.enumFormItemTypeChecksLanguageItemName, { language: `fi`, value: `Tarkastukset` }, { language: `sv`, value: `Kontroller` }, { language: `en`, value: `Checks` },);
        this.set(this.enumFormItemTypePicturesLanguageItemName, { language: `fi`, value: `Kuvat` }, { language: `sv`, value: `Bilder` }, { language: `en`, value: `Pictures` },);
        this.set(this.enumFormItemTypeQuestionLanguageItemName, { language: `fi`, value: `Tarkastus` }, { language: `sv`, value: `Fråga` }, { language: `en`, value: `Question` },);
        this.set(this.enumFormItemTypeQuestionPicturesLanguageItemName, { language: `fi`, value: `Tarkastus kuvilla` }, { language: `sv`, value: `Fråga bilder` }, { language: `en`, value: `Question Pictures` },);
        this.set(this.enumFormTimeslotTypeAfterLanguageItemName, { language: `fi`, value: `Jälkeen` }, { language: `sv`, value: `Efter` }, { language: `en`, value: `After` },);
        this.set(this.enumFormTimeslotTypeAnytimeLanguageItemName, { language: `fi`, value: `Milloin tahansa` }, { language: `sv`, value: `När som helst` }, { language: `en`, value: `Anytime` },);
        this.set(this.enumFormTimeslotTypeBeforeLanguageItemName, { language: `fi`, value: `Ennen` }, { language: `sv`, value: `Innan` }, { language: `en`, value: `Before` },);
        this.set(this.formDefinitionPageCommentRequiredLanguageItemName, { language: `fi`, value: `Viimeinen vaihe vaatii kommentin` }, { language: `sv`, value: `Kommentar krävs för det sista steget` }, { language: `en`, value: `Comment is required for the last step` },);
        this.set(this.formDefinitionPageDefaultLanguageItemName, { language: `fi`, value: `Oletus` }, { language: `sv`, value: `Standard` }, { language: `en`, value: `Default` },);
        this.set(this.formDefinitionPageMinLanguageItemName, { language: `fi`, value: `Minimi` }, { language: `sv`, value: `Min` }, { language: `en`, value: `Min` },);
        this.set(this.formDefinitionPageMaxLanguageItemName, { language: `fi`, value: `Maksimi` }, { language: `sv`, value: `Max` }, { language: `en`, value: `Max` },);
        this.set(this.formDefinitionPageUnlimitedLanguageItemName, { language: `fi`, value: `Ei rajaa` }, { language: `sv`, value: `Obegränsat` }, { language: `en`, value: `Unlimited` },);
        this.set(this.formDefinitionPageFormItemMultipleLanguageItemName, { language: `fi`, value: `Useita` }, { language: `sv`, value: `Flera olika` }, { language: `en`, value: `Multiple` },);
        this.set(this.formDefinitionPageFormItemRequiredLanguageItemName, { language: `fi`, value: `Vaaditaan` }, { language: `sv`, value: `Nödvändig` }, { language: `en`, value: `Required` },);
        this.set(this.formDefinitionPageRowsLanguageItemName, { language: `fi`, value: `Rivit` }, { language: `sv`, value: `Rader` }, { language: `en`, value: `Rows` },);
        this.set(this.formDefinitionPageDescriptionLanguageItemName, { language: `fi`, value: `Kuvaus` }, { language: `sv`, value: `Beskrivning` }, { language: `en`, value: `Description` },);
        this.set(this.formDefinitionPageItemNameLanguageItemName, { language: `fi`, value: `Tuotteen nimi` }, { language: `sv`, value: `Föremålsnamn` }, { language: `en`, value: `Item name` },);
        this.set(this.formDefinitionPageMaxLengthLanguageItemName, { language: `fi`, value: `Maksimi pituus` }, { language: `sv`, value: `Maxlängd` }, { language: `en`, value: `Max length` },);
        this.set(this.formDefinitionPageMinLengthLanguageItemName, { language: `fi`, value: `Minimi pituus` }, { language: `sv`, value: `Minlängd` }, { language: `en`, value: `Min length` },);
        this.set(this.formDefinitionPageUniquePerProjectLanguageItemName, { language: `fi`, value: `Yksilöllinen projektille` }, { language: `sv`, value: `Unikt per projekt` }, { language: `en`, value: `Unique per project` },);
        this.set(this.formDefinitionPageAddNewOptionLanguageItemName, { language: `fi`, value: `Lisää uusi vaihtoehto` }, { language: `sv`, value: `Lägg till nytt alternativ` }, { language: `en`, value: `Add new option` },);
        this.set(this.formDefinitionsPageDefinitionTitleLanguageItemName, { language: `fi`, value: `{0} ({1} vaiheet)` }, { language: `sv`, value: `{0} ({1} steg)` }, { language: `en`, value: `{0} ({1} steps)` },);
        this.set(this.formDefinitionsPageAddNewLanguageItemName, { language: `fi`, value: `Lisää uusi lomake` }, { language: `sv`, value: `Lägg till ny formdefinition` }, { language: `en`, value: `Add new form definition` },);
        this.set(this.formDefinitionsPageShowDeletedLanguageItemName, { language: `fi`, value: `Näytä poistetut` }, { language: `sv`, value: `Visa raderade` }, { language: `en`, value: `Show deleted` },);
        this.set(this.formDefinitionsPageSubtitleLanguageItemName, { language: `fi`, value: `Luettelo lomakkeista` }, { language: `sv`, value: `Lista över formulärdefinitioner` }, { language: `en`, value: `List of form definitions` },);
        this.set(this.formDefinitionsPageTitleLanguageItemName, { language: `fi`, value: `Lomakkeet` }, { language: `sv`, value: `Blanketter/protokoll` }, { language: `en`, value: `Form definitions` },);
        this.set(this.enumFormHeaderTypeWorkOrderManagerPhoneLanguageItemName, { language: `fi`, value: `Työnjohtajan puhelin` }, { language: `sv`, value: `Telefon för arbetsorderansvarig` }, { language: `en`, value: `Work order manager phone` },);
        this.set(this.enumFormHeaderTypeWorkOrderOrdererPhoneLanguageItemName, { language: `fi`, value: `Tilaajan puhelin` }, { language: `sv`, value: `Arbetsordertelefon` }, { language: `en`, value: `Work order orderer phone` },);
        this.set(this.enumFormHeaderTypeWorkOrderOrdererNameLanguageItemName, { language: `fi`, value: `Tilaajan nimi` }, { language: `sv`, value: `Arbetsorderns namn` }, { language: `en`, value: `Work order orderer name` },);
        this.set(this.enumFormHeaderTypeWorkOrderOrdererEmailLanguageItemName, { language: `fi`, value: `Tilaajan sähköposti` }, { language: `sv`, value: `E-post för arbetsorderbeställare` }, { language: `en`, value: `Work order orderer email` },);
        this.set(this.formModelApprovedLanguageItemName, { language: `fi`, value: `Hyväksytty` }, { language: `sv`, value: `Godkänd` }, { language: `en`, value: `Approved` },);
        this.set(this.formModelSentLanguageItemName, { language: `fi`, value: `Lähetetty` }, { language: `sv`, value: `Skickad` }, { language: `en`, value: `Sent` },);
        this.set(this.formModelProcessedLanguageItemName, { language: `fi`, value: `Käsitelty` }, { language: `sv`, value: `Bearbetad` }, { language: `en`, value: `Processed` },);
        this.set(this.formModelInProgressLanguageItemName, { language: `fi`, value: `Käynnissä` }, { language: `sv`, value: `Pågående` }, { language: `en`, value: `In progress` },);
        this.set(this.formModelNewLanguageItemName, { language: `fi`, value: `Uusi` }, { language: `sv`, value: `Ny` }, { language: `en`, value: `New` },);
        this.set(this.enumExtraChargeTypeUnitPcsLanguageItemName, { language: `fi`, value: `Kpl` }, { language: `sv`, value: `Stycke` }, { language: `en`, value: `Piece` },);
        this.set(this.enumExtraChargeTypeUnitM2LanguageItemName, { language: `fi`, value: `Neliömetri` }, { language: `sv`, value: `Kvadratmeter` }, { language: `en`, value: `Square meter` },);
        this.set(this.enumExtraChargeTypeUnitM1LanguageItemName, { language: `fi`, value: `Metri` }, { language: `sv`, value: `Meter` }, { language: `en`, value: `Meter` },);
        this.set(this.enumExtraChargeTypeUnitM3LanguageItemName, { language: `fi`, value: `Kuutiometri` }, { language: `sv`, value: `Kubikmeter` }, { language: `en`, value: `Cubic meter` },);
        this.set(this.enumExtraChargeTypeUnitHLanguageItemName, { language: `fi`, value: `Tunti` }, { language: `sv`, value: `Timme` }, { language: `en`, value: `Hour` },);
        this.set(this.enumExtraChargeTypeUnitKmLanguageItemName, { language: `fi`, value: `Kilometri` }, { language: `sv`, value: `Kilometer` }, { language: `en`, value: `Kilometer` },);
        this.set(this.extraChargeTypeManagementPageTitleLanguageItemName, { language: `fi`, value: `Palvelutyyppien yksiköt` }, { language: `sv`, value: `Service, Enhetstyper` }, { language: `en`, value: `Extra Charge Unit Types` },);
        this.set(this.genericCommentLanguageItemName, { language: `fi`, value: `Kommentti` }, { language: `sv`, value: `Kommentar` }, { language: `en`, value: `Comment` },);
        this.set(this.genericUnsupportedImageTypeLanguageItemName, { language: `fi`, value: `Kuvatyyppiä ei tueta` }, { language: `sv`, value: `Bildtyp stöds inte` }, { language: `en`, value: `Image type is not supported` },);
        this.set(this.formReceiversPageReportSentToCustomerLanguageItemName, { language: `fi`, value: `Lomakeraportti on lähetetty asiakkaalle.` }, { language: `sv`, value: `Blankettrapport har skickats till kund.` }, { language: `en`, value: `Form report has been sent to customer.` },);
        this.set(this.rentaTasksFormSummaryTableChooseReceiversLanguageItemName, { language: `fi`, value: `Valitse vastaanottajat, jotka lähettävät lomakeraportin ensin.` }, { language: `sv`, value: `Välj mottagare att skicka formulärrapporten först.` }, { language: `en`, value: `Choose receivers to send the form report first.` },);
        this.set(this.formSummaryTableDropdownNothingSelectedTextLanguageItemName, { language: `fi`, value: `Valitse vastaanottajat` }, { language: `sv`, value: `Välj mottagare` }, { language: `en`, value: `Choose receivers` },);
        this.set(this.formsListGetManualLanguageItemName, { language: `fi`, value: `Muodostaa portaat` }, { language: `sv`, value: `Formar steg` }, { language: `en`, value: `Forms steps` },);
        this.set(this.formsDataNameLanguageItemName, { language: `fi`, value: `Nimi` }, { language: `sv`, value: `Namn` }, { language: `en`, value: `Name` },);
        this.set(this.formsDataTypeLanguageItemName, { language: `fi`, value: `Tyyppi` }, { language: `sv`, value: `Typ` }, { language: `en`, value: `Type` },);
        this.set(this.formsDataWorkOrderLanguageItemName, { language: `fi`, value: `Työtilaus` }, { language: `sv`, value: `Arbetsorder` }, { language: `en`, value: `Work order` },);
        this.set(this.formsDataApprovedAtLanguageItemName, { language: `fi`, value: `Hyväksytty` }, { language: `sv`, value: `Godkännd` }, { language: `en`, value: `Approved at` },);
        this.set(this.myFormsApproveFormReportLanguageItemName, { language: `fi`, value: `Hyväksy lomakeraportti` }, { language: `sv`, value: `Godkänn blankettrapporten` }, { language: `en`, value: `Approve the form report` },);
        this.set(this.myFormsApproveConfirmationLanguageItemName, { language: `fi`, value: `Oletko varma, haluatko hyväksyä lomakeraportin #{0}?` }, { language: `sv`, value: `Är du säker på att du vill godkänna formulärrapporten #{0}?` }, { language: `en`, value: `Are you sure, you want approve the form report #{0}?` },);
        this.set(this.myFormsPreviewFormReportLanguageItemName, { language: `fi`, value: `Esikatsele lomakeraporttia` }, { language: `sv`, value: `Förhandsgranska formulärrapport` }, { language: `en`, value: `Preview form report` },);
        this.set(this.myFormsDownloadFormReportLanguageItemName, { language: `fi`, value: `Lataa lomakeraportti` }, { language: `sv`, value: `Ladda ner blankettrapport` }, { language: `en`, value: `Download form report` },);
        this.set(this.documentPreviewModalFormTitleLanguageItemName, { language: `fi`, value: `Lomakeraportin esikatselu` }, { language: `sv`, value: `Förhandsgranskning av formulärrapporten` }, { language: `en`, value: `The form report preview` },);
        this.set(this.myFormsTitleLanguageItemName, { language: `fi`, value: `Minun lomakkeeni` }, { language: `sv`, value: `Mina formulär` }, { language: `en`, value: `My forms` },);
        this.set(this.myFormsNoFormReportsLanguageItemName, { language: `fi`, value: `Lomakeraportteja ei ole vielä saatu` }, { language: `sv`, value: `Inga formulärrapporter har inkommit ännu` }, { language: `en`, value: `No form reports received yet` },);
        this.set(this.formsTabTitleLanguageItemName, { language: `fi`, value: `Lomakkeet` }, { language: `sv`, value: `Blanketter` }, { language: `en`, value: `Forms` },);
        this.set(this.formsDataReporterLanguageItemName, { language: `fi`, value: `Raportoija` }, { language: `sv`, value: `Reporter` }, { language: `en`, value: `Reporter` },);
        this.set(this.formsDataStartedAtLanguageItemName, { language: `fi`, value: `Alkoi klo` }, { language: `sv`, value: `Började kl` }, { language: `en`, value: `Started at` },);
        this.set(this.formsDataProcessInfoLanguageItemName, { language: `fi`, value: `Prosessitiedot` }, { language: `sv`, value: `Processinformation` }, { language: `en`, value: `Process info` },);
        this.set(this.formsDataCompletedAtLanguageItemName, { language: `fi`, value: `Valmistui klo` }, { language: `sv`, value: `Avslutad kl` }, { language: `en`, value: `Completed at` },);
        this.set(this.genericActionDownloadLanguageItemName, { language: `fi`, value: `Lataa` }, { language: `sv`, value: `Ladda ner` }, { language: `en`, value: `Download` },);
        this.set(this.formsDataPassedLanguageItemName, { language: `fi`, value: `Läpäisty` }, { language: `sv`, value: `Passerade` }, { language: `en`, value: `Passed` },);
        this.set(this.formsDataApprovalLanguageItemName, { language: `fi`, value: `Hyväksyminen` }, { language: `sv`, value: `Godkännande` }, { language: `en`, value: `Approval` },);
        this.set(this.formsDataSentLanguageItemName, { language: `fi`, value: `Lähetetty` }, { language: `sv`, value: `Skickat` }, { language: `en`, value: `Sent` },);
        this.set(this.formsDataSentToLanguageItemName, { language: `fi`, value: `Lähetä käyttäjälle` }, { language: `sv`, value: `Skickat till` }, { language: `en`, value: `Sent to` },);
        this.set(this.formsDataSentAtLanguageItemName, { language: `fi`, value: `Lähetetty klo` }, { language: `sv`, value: `Skickades kl` }, { language: `en`, value: `Sent at` },);
        this.set(this.formsDataToolbarFiltersApprovalTypeLanguageItemName, { language: `fi`, value: `Hyväksyntätyyppi` }, { language: `sv`, value: `Typ av godkännande` }, { language: `en`, value: `Approval type` },);
        this.set(this.formsDataToolbarFiltersFromLanguageItemName, { language: `fi`, value: `Alkaen` }, { language: `sv`, value: `Från` }, { language: `en`, value: `From` },);
        this.set(this.formsDataToolbarFiltersReportersLanguageItemName, { language: `fi`, value: `Toimittajat` }, { language: `sv`, value: `Reportrar` }, { language: `en`, value: `Reporters` },);
        this.set(this.formsDataToolbarFiltersStatusLanguageItemName, { language: `fi`, value: `Tila` }, { language: `sv`, value: `Status` }, { language: `en`, value: `Status` },);
        this.set(this.formsDataToolbarFiltersToLanguageItemName, { language: `fi`, value: `Päättyen` }, { language: `sv`, value: `Till` }, { language: `en`, value: `To` },);
        this.set(this.taskTooltipsTaskBlockedByFormLanguageItemName, { language: `fi`, value: `Tehtävä on estetty vaaditulla lomakkeella` }, { language: `sv`, value: `Uppdrag blockeras av ett obligatoriskt formulär` }, { language: `en`, value: `Task is blocked by a required form` },);
        this.set(this.workOrderStatusBlockedByFormLanguageItemName, { language: `fi`, value: `Estetty lomakkeella` }, { language: `sv`, value: `Blockerad av formulär` }, { language: `en`, value: `Blocked by form` },);
        this.set(this.adminExtraChargeTypeInUseTooltipLanguageItemName, { language: `fi`, value: `Tuotetta on käytetty työtilauksessa, sitä ei voi muokata tai poistaa.\n\n\n\n\n\n` }, { language: `sv`, value: `Produkten används i arbetsorder, kan inte ändras eller raderas.` }, { language: `en`, value: `Product is used in work order(s), cannot modify or remove.` },);
        this.set(this.addExtraChargeModalSubtitleLanguageItemName, { language: `fi`, value: `lisää lisämaksu työtilaukseen` }, { language: `sv`, value: `lägga till en extra avgift till arbetsordern` }, { language: `en`, value: `Add extra charge to work order` },);
        this.set(this.addExtraChargeModalTitleLanguageItemName, { language: `fi`, value: `Lisämaksu` }, { language: `sv`, value: `Extra avgift` }, { language: `en`, value: `Extra charge` },);
        this.set(this.addExtraChargeModalExtraChargeTypeDropdownLabelLanguageItemName, { language: `fi`, value: `Tyyppi` }, { language: `sv`, value: `Typ` }, { language: `en`, value: `Type` },);
        this.set(this.addExtraChargeModalExtraChargeTypeUnitTextInputLabelLanguageItemName, { language: `fi`, value: `Yksikkö` }, { language: `sv`, value: `Enhet` }, { language: `en`, value: `Unit` },);
        this.set(this.addExtraChargeModalExtraChargeAmountNumberInputLabelLanguageItemName, { language: `fi`, value: `Määrä` }, { language: `sv`, value: `Kkvantitet` }, { language: `en`, value: `Amount` },);
        this.set(this.workOrderDetailsPanelExtraChargesTabTitleLanguageItemName, { language: `fi`, value: `Lisämaksut` }, { language: `sv`, value: `Försäljningsartiklar` }, { language: `en`, value: `Extra charges` },);
        this.set(this.workOrderDetailsPanelExtraChargesToolbarButtonLabelLanguageItemName, { language: `fi`, value: `Lisää lisämaksu` }, { language: `sv`, value: `Lägg till försäljningsartiklar` }, { language: `en`, value: `Add extra charge` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsAddExtraChargeLanguageItemName, { language: `fi`, value: `Lisää lisämaksu` }, { language: `sv`, value: `Lägg till försäljning\nsartiklar` }, { language: `en`, value: `Add extra charge` },);
        this.set(this.workOrderDetailsPanelGridExtraChargesTypeLanguageItemName, { language: `fi`, value: `Tyyppi` }, { language: `sv`, value: `Typ` }, { language: `en`, value: `Type` },);
        this.set(this.workOrderDetailsPanelGridExtraChargesUnitLanguageItemName, { language: `fi`, value: `Yksikkö` }, { language: `sv`, value: `Enhet` }, { language: `en`, value: `Unit` },);
        this.set(this.workOrderDetailsPanelGridExtraChargesAmountLanguageItemName, { language: `fi`, value: `Määrä` }, { language: `sv`, value: `Kvantitet` }, { language: `en`, value: `Amount` },);
        this.set(this.rentaTasksControllerAlertErrorFormProcessedByAnotherUserLanguageItemName, { language: `fi`, value: `Lomaketta ei voitu käynnistää, toinen käyttäjä käsittelee sitä jo` }, { language: `sv`, value: `Det gick inte att starta formuläret, bearbetas redan av en annan användare` }, { language: `en`, value: `Could not start Form, already being processed by another user` },);
        this.set(this.formModalConfirmationUnlockLanguageItemName, { language: `fi`, value: `Haluatko varmasti avata lomakkeen lukituksen?` }, { language: `sv`, value: `Är du säker på att du vill låsa upp formuläret?` }, { language: `en`, value: `Are you sure you want to unlock the form?` },);
        this.set(this.formModalConfirmationOnCloseLanguageItemName, { language: `fi`, value: `Lomakkeessa on tallentamattomia muutoksia. Kaikki tallentamattomat muutokset menetetään!\nOletko varma?` }, { language: `sv`, value: `Det finns osparade ändringar i formuläret. Alla osparade ändringar kommer att gå förlorade!\nÄr du säker?` }, { language: `en`, value: `There are unsaved changed on the form. All unsaved changes will be lost!\nAre you sure?` },);
        this.set(this.formModalTextProcessedByLanguageItemName, { language: `fi`, value: `Käsittelijä:` }, { language: `sv`, value: `Bearbetad av:` }, { language: `en`, value: `Processed by:` },);
        this.set(this.formModalTextInProgressByLanguageItemName, { language: `fi`, value: `Meneillään:` }, { language: `sv`, value: `Pågår av:` }, { language: `en`, value: `In progress by:` },);
        this.set(this.formModalTextFormConductionTimeLanguageItemName, { language: `fi`, value: `Lomakkeen kulkuaika: {0}` }, { language: `sv`, value: `Formulärledningstid: {0}` }, { language: `en`, value: `Form conduction time: {0}` },);
        this.set(this.formModalTextApprovedByLanguageItemName, { language: `fi`, value: `Hyväksyjä: {0}` }, { language: `sv`, value: `Godkänd av: {0}` }, { language: `en`, value: `Approved by: {0}` },);
        this.set(this.formModalDropdownShareToLanguageItemName, { language: `fi`, value: `Jakaa:` }, { language: `sv`, value: `Dela till:` }, { language: `en`, value: `Share to:` },);
        this.set(this.formModalDropdownFormsLanguageItemName, { language: `fi`, value: `Lomakkeet` }, { language: `sv`, value: `Blanketter` }, { language: `en`, value: `Forms` },);
        this.set(this.formModalSubtitleLanguageItemName, { language: `fi`, value: `Tila: {0}` }, { language: `sv`, value: `Status: {0}` }, { language: `en`, value: `Status: {0}` },);
        this.set(this.formsListButtonTitleFillLanguageItemName, { language: `fi`, value: `Täytä` }, { language: `sv`, value: `Fylla` }, { language: `en`, value: `Fill` },);
        this.set(this.formsListButtonTitleContinueLanguageItemName, { language: `fi`, value: `Jatka` }, { language: `sv`, value: `Fortsätta` }, { language: `en`, value: `Continue` },);
        this.set(this.formsListButtonTitleUnlockLanguageItemName, { language: `fi`, value: `Avaa` }, { language: `sv`, value: `Låsa upp` }, { language: `en`, value: `Unlock` },);
        this.set(this.workOrdersPanelWorkOrderFormsLanguageItemName, { language: `fi`, value: `Lomakkeet` }, { language: `sv`, value: `Blanketter` }, { language: `en`, value: `Forms` },);
        this.set(this.workOrdersPanelFlyoutMessageFormSavedLanguageItemName, { language: `fi`, value: `Lomake tallennettu` }, { language: `sv`, value: `Formuläret har sparats` }, { language: `en`, value: `Form saved` },);
        this.set(this.workOrdersPanelFlyoutWarningTaskNotMappedToFormDefinitionLanguageItemName, { language: `fi`, value: `Työtilausta "{0}" ei ole yhdistetty mihinkään määritelmästä.` }, { language: `sv`, value: `Arbetsorder "{0}" är inte mappad till någon form definition.` }, { language: `en`, value: `Work order "{0}" is not mapped to any form definition.` },);
        this.set(this.rentaTasksFormWizardPageFormItemNotFoundLanguageItemName, { language: `fi`, value: `Lomakekohdetta ei löydy nykyiselle vaiheelle!` }, { language: `sv`, value: `Formulärobjekt kan inte hittas för det aktuella steget!` }, { language: `en`, value: `Form item cannot be found for the current step!` },);
        this.set(this.formReceiversPageSendToReceiversLanguageItemName, { language: `fi`, value: `Lähetä lomake vastaanottajille` }, { language: `sv`, value: `Skicka blankett till mottagare` }, { language: `en`, value: `Send form to receivers` },);
        this.set(this.formReceiversPageNoContactPersonWarningLanguageItemName, { language: `fi`, value: `Yhteyshenkilöä ei ole määritelty sopimustasolla. Tarkastusta ei voida lähettää hyväksyttäväksi.` }, { language: `sv`, value: `Kontaktperson anges inte på avtalsnivå. Revision kan inte skickas för godkännande.` }, { language: `en`, value: `Contact person is not specified on agreement level. Audit can not be sent for approval.` },);
        this.set(this.formSummaryPageFormSavedLanguageItemName, { language: `fi`, value: `Lomakeraportti on tallennettu` }, { language: `sv`, value: `Formulärrapporten har sparats` }, { language: `en`, value: `Form report has been saved` },);
        this.set(this.formPreviewPageTitleCompletedFormLanguageItemName, { language: `fi`, value: `Täytetty lomake` }, { language: `sv`, value: `Ifyllt formulär` }, { language: `en`, value: `Completed form` },);
        this.set(this.formPreviewPageReporterLanguageItemName, { language: `fi`, value: `Raportoija` }, { language: `sv`, value: `Reporter` }, { language: `en`, value: `Reporter` },);
        this.set(this.formPreviewPageGetManualLanguageItemName, { language: `fi`, value: `Esikatselulomake` }, { language: `sv`, value: `Förhandsgranskningsformulär` }, { language: `en`, value: `Preview form` },);
        this.set(this.formPreviewPageTitleLanguageItemName, { language: `fi`, value: `AVAA TIEDOT NAPSAUTA VAIHE` }, { language: `sv`, value: `KLICKA PÅ STEG\nFÖR ATT ÖPPNA DETALJER` }, { language: `en`, value: `CLICK THE STEP\nTO OPEN DETAILS` },);
        this.set(this.rentaTasksWorkOrderFormsButtonLanguageItemName, { language: `fi`, value: `Lomakkeet` }, { language: `sv`, value: `Blanketter` }, { language: `en`, value: `Forms` },);
        this.set(this.rentaTasksControllerStepsTitleSendToReceiversLanguageItemName, { language: `fi`, value: `Lähetä vastaanottajille` }, { language: `sv`, value: `Skicka till mottagare` }, { language: `en`, value: `Send to receivers` },);
        this.set(this.rentaTasksControllerStepsTitleFormSummaryLanguageItemName, { language: `fi`, value: `Lomakkeen yhteenveto` }, { language: `sv`, value: `Formulär sammanfattning` }, { language: `en`, value: `Form summary` },);
        this.set(this.rentaTasksControllerStepsTitleFormReportingLanguageItemName, { language: `fi`, value: `Lomakeraportointi` }, { language: `sv`, value: `Formulärrapportering` }, { language: `en`, value: `Form reporting` },);
        this.set(this.rentaTasksControllerStepsTitleFormPageLanguageItemName, { language: `fi`, value: `Lomake` }, { language: `sv`, value: `Form` }, { language: `en`, value: `Form` },);
        this.set(this.rentaTasksControllerStepsTitleApproveFormLanguageItemName, { language: `fi`, value: `Hyväksy lomake` }, { language: `sv`, value: `Godkänn formulär` }, { language: `en`, value: `Approve form` },);
        this.set(this.formsListButtonTitleCompletionDateLanguageItemName, { language: `fi`, value: `Pvm.` }, { language: `sv`, value: `Datum` }, { language: `en`, value: `Date` },);
        this.set(this.genericActionsLanguageItemName, { language: `fi`, value: `Toiminnot` }, { language: `sv`, value: `Handlingar` }, { language: `en`, value: `Actions` },);
        this.set(this.formsListButtonTitleLockedLanguageItemName, { language: `fi`, value: `Lukittu` }, { language: `sv`, value: `Låst` }, { language: `en`, value: `Locked` },);
        this.set(this.workOrderFormsAlertErrorFormUnlockedLanguageItemName, { language: `fi`, value: `Lomakkeen lukitus avattiin` }, { language: `sv`, value: `Formuläret har låsts upp` }, { language: `en`, value: `Form unlocked successfully` },);
        this.set(this.workOrderFormsActiveFormsTabLanguageItemName, { language: `fi`, value: `Aktiiviset lomakkeet` }, { language: `sv`, value: `Aktiva former` }, { language: `en`, value: `Active forms` },);
        this.set(this.workOrderFormsCompletedFormsTabLanguageItemName, { language: `fi`, value: `Täytetyt lomakkeet` }, { language: `sv`, value: `Ifyllda blanketter` }, { language: `en`, value: `Completed forms` },);
        this.set(this.enumAttachmentTypeWorkOrderAttachmentLanguageItemName, { language: `fi`, value: `Työmääräyksen liite` }, { language: `sv`, value: `Arbetsorderbilaga` }, { language: `en`, value: `Work order attachment` },);
        this.set(this.enumAttachmentTypeFormAttachmentLanguageItemName, { language: `fi`, value: `Lomakkeen liite` }, { language: `sv`, value: `Blankettbilaga` }, { language: `en`, value: `Form attachment` },);
        this.set(this.enumWorkOrderFormStatusFilterSentLanguageItemName, { language: `fi`, value: `Lähetetty` }, { language: `sv`, value: `Skickat` }, { language: `en`, value: `Sent` },);
        this.set(this.enumWorkOrderFormStatusFilterProcessedLanguageItemName, { language: `fi`, value: `Käsitelty` }, { language: `sv`, value: `Bearbetas` }, { language: `en`, value: `Processed` },);
        this.set(this.enumWorkOrderFormStatusFilterNewLanguageItemName, { language: `fi`, value: `Uusi` }, { language: `sv`, value: `Ny` }, { language: `en`, value: `New` },);
        this.set(this.enumWorkOrderFormStatusFilterInProgressLanguageItemName, { language: `fi`, value: `Käynnissä` }, { language: `sv`, value: `Pågående` }, { language: `en`, value: `In progress` },);
        this.set(this.enumWorkOrderFormStatusFilterApprovedLanguageItemName, { language: `fi`, value: `Hyväksytty` }, { language: `sv`, value: `Godkänd` }, { language: `en`, value: `Approved` },);
        this.set(this.widgetMyFormsLabelLanguageItemName, { language: `fi`, value: `Minun lomakkeeni` }, { language: `sv`, value: `Mina formulär` }, { language: `en`, value: `My forms` },);
        this.set(this.widgetMyFormsDescriptionLanguageItemName, { language: `fi`, value: `Näytä kaikki lomakeraportit` }, { language: `sv`, value: `Se alla formulärrapporter` }, { language: `en`, value: `View all form reports` },);
        this.set(this.topNavFormsLanguageItemName, { language: `fi`, value: `Lomakkeet` }, { language: `sv`, value: `Blanketter` }, { language: `en`, value: `Forms` },);
        this.set(this.workOrdersFiltersCheckboxHideBlockedByFormsLanguageItemName, { language: `fi`, value: `Piilota lomakkeiden estämä` }, { language: `sv`, value: `Dölj blockerade av formulär` }, { language: `en`, value: `Hide blocked by forms` },);
        this.set(this.enumFormItemTypeTextLanguageItemName, { language: `fi`, value: `Teksti` }, { language: `sv`, value: `Text` }, { language: `en`, value: `Text` },);
        this.set(this.enumFormItemTypeResourceLanguageItemName, { language: `fi`, value: `Resurssi` }, { language: `sv`, value: `Resurs` }, { language: `en`, value: `Resource` },);
        this.set(this.enumFormItemTypeOptionsLanguageItemName, { language: `fi`, value: `Vaihtoehdot` }, { language: `sv`, value: `Alternativ` }, { language: `en`, value: `Options` },);
        this.set(this.genericOpenLanguageItemName, { language: `fi`, value: `Avaa` }, { language: `sv`, value: `Öppna` }, { language: `en`, value: `Open` },);
        this.set(this.formNavigationStepLanguageItemName, { language: `fi`, value: `VAIHE` }, { language: `sv`, value: `STEG` }, { language: `en`, value: `STEP` },);
        this.set(this.genericSearchLanguageItemName, { language: `fi`, value: `Etsi` }, { language: `sv`, value: `Sök` }, { language: `en`, value: `Search` },);
        this.set(this.extraChargeTypeManagementConfirmationMessageDeletePermanentlyLanguageItemName, { language: `fi`, value: `Haluatko varmasti poistaa lisäveloitustyypin "{0}"?\nLisäveloitustyyppi poistetaan pysyvästi.` }, { language: `sv`, value: `Är du säker på att du vill ta bort extradebiteringstypen "{0}"?\nExtradebiteringstypen kommer att tas bort permanent.` }, { language: `en`, value: `Are you sure you want to delete the extra charge type "{0}"?\nExtra charge type will be removed permanently.` },);
        this.set(this.extraChargeTypeManagementConfirmationMessageMarkAsDeletedLanguageItemName, { language: `fi`, value: `Haluatko varmasti merkitä poistetuksi lisäveloitustyypin "{0}"?` }, { language: `sv`, value: `Är du säker på att du vill markera som raderad extra debiteringstyp "{0}"?` }, { language: `en`, value: `Are you sure you want to mark extra charge type "{0}" as deleted?` },);
        this.set(this.extraChargeTypeManagementFlyoutMessagePermanentlyDeletedLanguageItemName, { language: `fi`, value: `"{0}" poistettiin pysyvästi.` }, { language: `sv`, value: `"{0}" raderades permanent.` }, { language: `en`, value: `"{0}" was permanently deleted.` },);
        this.set(this.extraChargeTypeManagementFlyoutMessageMarkedAsDeletedLanguageItemName, { language: `fi`, value: `"{0}" merkittiin poistetuksi.` }, { language: `sv`, value: `"{0}" markerades som borttagen.` }, { language: `en`, value: `"{0}" was marked as deleted.` },);
        this.set(this.genericGroupMarkedAsDeletedLanguageItemName, { language: `fi`, value: `Merkitty poistetuksi` }, { language: `sv`, value: `Markerad som raderad` }, { language: `en`, value: `Marked as deleted` },);
        this.set(this.formDefinitionPageNonConsecutiveGroupsLanguageItemName, { language: `fi`, value: `Vaiheet jotka kuuluvat samaan ryhmään on oltava peräkkäin` }, { language: `sv`, value: `Fasen från samma grupp måste vara i ordningsföljd` }, { language: `en`, value: `Items of the same group must be in consecutive order` },);
        this.set(this.attachmentsFiltersModalTypeLanguageItemName, { language: `fi`, value: `Liitteen tyyppi` }, { language: `sv`, value: `Typ av bilaga` }, { language: `en`, value: `Attachment type` },);
        this.set(this.workOrdersActionsDeleteLanguageItemName, { language: `fi`, value: `Poista työtilaus` }, { language: `sv`, value: `Avlägsna arbetsordern` }, { language: `en`, value: `Delete work order` },);
        this.set(this.workOrdersActionsRemoveActivationDateLanguageItemName, { language: `fi`, value: `Poista aktivointipäivä` }, { language: `sv`, value: `Ta bort aktiveringsdatum` }, { language: `en`, value: `Remove activation date` },);
        this.set(this.tasksPanelDeleteAttachmentLanguageItemName, { language: `fi`, value: `Poista liite` }, { language: `sv`, value: `Ta bort produkter` }, { language: `en`, value: `Delete attachment` },);
        this.set(this.tasksPanelDeleteDistanceLanguageItemName, { language: `fi`, value: `Poista matkakulu` }, { language: `sv`, value: `Ta bort mil` }, { language: `en`, value: `Delete mileage / distance` },);
        this.set(this.tasksPanelDeleteEquipmentLanguageItemName, { language: `fi`, value: `Poista tuote` }, { language: `sv`, value: `Ta bort produkter` }, { language: `en`, value: `Delete products` },);
        this.set(this.tasksPanelDeleteExtraChargeLanguageItemName, { language: `fi`, value: `Poista lisäveloitus` }, { language: `sv`, value: `Ta bort extra avgift` }, { language: `en`, value: `Delete extra charge` },);
        this.set(this.formEmailInputReceiverLanguageItemName, { language: `fi`, value: `Vastaanottaja (vain Renta Task käyttäjät)` }, { language: `sv`, value: `Mottagare (bara Renta Task-användare)` }, { language: `en`, value: `Receiver (Renta Task users only)` },);
        this.set(this.formDefinitionsPageIconTooltipCopyFormDefinitionLanguageItemName, { language: `fi`, value: `Kopioi lomakepohja` }, { language: `sv`, value: `Kopiera form mall` }, { language: `en`, value: `Copy form definition template` },);
        this.set(this.constructionSitesToolBarSearchTermFilterWithProjectNumberLanguageItemName, { language: `fi`, value: `Työmaa / Asiakas / Projektin numero / Osoite` }, { language: `sv`, value: `Webbplats / Kund / Projektnummer / Adress` }, { language: `en`, value: `Site / Customer / Project number / Address` },);
        this.set(this.genericProjectNumberLanguageItemName, { language: `fi`, value: `Projektin numero` }, { language: `sv`, value: `Projektnummer` }, { language: `en`, value: `Project number` },);
        this.set(this.formsListCompletedColumnHeaderPreviewLanguageItemName, { language: `fi`, value: `Esikatselu` }, { language: `sv`, value: `För.vis.` }, { language: `en`, value: `Preview` },);
        this.set(this.rentaTasksWorkOrderPreviewDetailsFailedAlertLanguageItemName, { language: `fi`, value: `Tarkempien tietojen avaaminen epäonnistui. Jos virhe toistuu, ole yhteydessä asiakaspalveluun.` }, { language: `sv`, value: `Kunde inte öppna detaljerad informationsidan. Om detta händer igen, kontakta kundservice.` }, { language: `en`, value: `Failed to open details page. If this happens again, contact support.` },);
        this.set(this.rentaTasksWorkOrderButtonLabelShowDetailsLanguageItemName, { language: `fi`, value: `Näytä tiedot` }, { language: `sv`, value: `Sisa detaljs` }, { language: `en`, value: `Show details` },);
        this.set(this.rentaTasksPreviewDetailsGetManualLanguageItemName, { language: `fi`, value: `Tältä sivulta voit tarkistaa työtilauksen tiedot: tiedot asiakkaalle, valitut asentajat, tuotteet, lisämaksut (jos käytössä), matkakulut.` }, { language: `sv`, value: `På den här sidan kan du visa olika arbetsorderdetaljer: Anmärkning för kunden, tilldelande montörer, utrustning, extra avgifter (om aktiverat), avstånd.` }, { language: `en`, value: `On this page you can check different work order details: note for customer, assigned mounters, equipments, extra charges (if enabled), distances.` },);
        this.set(this.rentaTasksWorkOrderDetailsContactInfoLanguageItemName, { language: `fi`, value: `Yhteystiedot` }, { language: `sv`, value: `Kontakt info` }, { language: `en`, value: `Contact info` },);
        this.set(this.rentaTasksWorkOrderDetailsAssignedMountersLanguageItemName, { language: `fi`, value: `Määrätyt asentajat` }, { language: `sv`, value: `Tilldelade montörer` }, { language: `en`, value: `Assigned mounters` },);
        this.set(this.rentaTasksWorkOrderDetailsNoAssignedMountersLanguageItemName, { language: `fi`, value: `Ei valittuja asentajia` }, { language: `sv`, value: `Inga tilldelade montörer` }, { language: `en`, value: `No assigned mounters` },);
        this.set(this.rentaTasksWorkOrderDetailsNoEquipmentsLanguageItemName, { language: `fi`, value: `Varusteita ei ole vielä lisätty` }, { language: `sv`, value: `Ingen utrustning har lagts till ännu` }, { language: `en`, value: `No equipments have been added yet` },);
        this.set(this.rentaTasksWorkOrderDetailsEquipmentsLanguageItemName, { language: `fi`, value: `Tarvikkeet` }, { language: `sv`, value: `Utrustning` }, { language: `en`, value: `Equipments` },);
        this.set(this.rentaTasksWorkOrderDetailsNoSalaryHoursLanguageItemName, { language: `fi`, value: `Työtunteja ei ole vielä lisätty` }, { language: `sv`, value: `Inga lönetimmar har tillkommit ännu` }, { language: `en`, value: `No salary hours have been added yet` },);
        this.set(this.rentaTasksWorkOrderDetailsExtraChargesLanguageItemName, { language: `fi`, value: `Lisämaksut` }, { language: `sv`, value: `Försäljningsartiklar` }, { language: `en`, value: `Extra charges` },);
        this.set(this.rentaTasksWorkOrderDetailsNoExtraChargesLanguageItemName, { language: `fi`, value: `Lisälaskutusta ei ole vielä lisätty` }, { language: `sv`, value: `Inga extra avgifter har lagts till ännu` }, { language: `en`, value: `No extra charges have been added yet` },);
        this.set(this.rentaTasksWorkOrderDetailsDistancesLanguageItemName, { language: `fi`, value: `Matkakulut` }, { language: `sv`, value: `Kostnad servicebil` }, { language: `en`, value: `Mileages` },);
        this.set(this.rentaTasksWorkOrderDetailsNoDistancesLanguageItemName, { language: `fi`, value: `Matkakuluja ei ole vielä lisätty` }, { language: `sv`, value: `Inga kostnad servicebil har lagts till ännu` }, { language: `en`, value: `No distances have been added yet` },);
        this.set(this.genericAmountLanguageItemName, { language: `fi`, value: `Määrä` }, { language: `sv`, value: `Kkvantitet` }, { language: `en`, value: `Amount` },);
        this.set(this.rentaTasksWorkOrderDetailsSalaryHoursTableNormalHoursLanguageItemName, { language: `fi`, value: `Normaali tunnit` }, { language: `sv`, value: `Normal timmar` }, { language: `en`, value: `Normal hours` },);
        this.set(this.rentaTasksWorkOrderDetailsSalaryHoursTableOvertime100LanguageItemName, { language: `fi`, value: `Ylityö 100%` }, { language: `sv`, value: `Övertid 100%` }, { language: `en`, value: `Overtime 100%` },);
        this.set(this.rentaTasksWorkOrderDetailsSalaryHoursTableOvertime50LanguageItemName, { language: `fi`, value: `Ylityö 50%` }, { language: `sv`, value: `Övertid 50%` }, { language: `en`, value: `Overtime 50%` },);
        this.set(this.rentaTasksWorkOrderDetailsMileagesTableVehiclesAmountLanguageItemName, { language: `fi`, value: `Ajoneuvojen lkm` }, { language: `sv`, value: `Fordon` }, { language: `en`, value: `Vehicles` },);
        this.set(this.rentaTasksWorkOrderDetailsMileagesTableTotalMileagesLanguageItemName, { language: `fi`, value: `Kokonaismatka, km` }, { language: `sv`, value: `Totalt avstånd, km` }, { language: `en`, value: `Total distance, km` },);
        this.set(this.rentaTasksWorkOrderDetailsJobSummaryLanguageItemName, { language: `fi`, value: `Lisätiedot asiakkaalle` }, { language: `sv`, value: `Anmärkning för kunden` }, { language: `en`, value: `Note for customer` },);
        this.set(this.genericFullNameLanguageItemName, { language: `fi`, value: `Koko nimi` }, { language: `sv`, value: `Fullständiga namn` }, { language: `en`, value: `Full name` },);
        this.set(this.rentaTasksControllerStepsTitleDetailsPreviewLanguageItemName, { language: `fi`, value: `Tiedot` }, { language: `sv`, value: `Detaljer` }, { language: `en`, value: `Details` },);
        this.set(this.genericCustomerNameLanguageItemName, { language: `fi`, value: `Asiakkaan nimi` }, { language: `sv`, value: `Köparens namn` }, { language: `en`, value: `Customer name` },);
        this.set(this.formDefinitionPageMountersSignaturesRequiredLanguageItemName, { language: `fi`, value: `Asentajan allekirjoitukset vaaditaan (kartoitus)` }, { language: `sv`, value: `Mounter signaturer krävs (mappning)` }, { language: `en`, value: `Mounter signatures required (mapping)` },);
        this.set(this.mountersSignaturesInstructionMessageLanguageItemName, { language: `fi`, value: `Valitse asentajat pudotusvalikosta lisätäksesi allekirjoituksen. Valinnan poistaminen poistaa luodun allekirjoituksen.` }, { language: `sv`, value: `Vänligen välj mounters från rullgardinsmenyn för att lägga till en signatur. Om du avmarkerar mounter kommer den skapade signaturen att tas bort.` }, { language: `en`, value: `Please select mounters from dropdown to add a signature. Unselecting mounter will remove created signature.` },);
        this.set(this.mountersSignaturesValidationMessageLanguageItemName, { language: `fi`, value: `Varmista, että kaikki valitut asentajat ovat lisänneet allekirjoituksen ja allekirjoittajan nimen` }, { language: `sv`, value: `Se till att alla valda montörer har lagt till signatur och signaturers namn` }, { language: `en`, value: `Please make sure all selected mounters have added signature and Signee name` },);
        this.set(this.mountersSignaturesSubmitSignaturesLanguageItemName, { language: `fi`, value: `Lähetä allekirjoitukset` }, { language: `sv`, value: `Skicka in signaturer` }, { language: `en`, value: `Submit signatures` },);
        this.set(this.signatureSigneeNameLanguageItemName, { language: `fi`, value: `Allekirjoittajan nimi` }, { language: `sv`, value: `Signaturens namn` }, { language: `en`, value: `Signer's name` },);
        this.set(this.signatureSignatureForLanguageItemName, { language: `fi`, value: `Allekirjoitus puolesta` }, { language: `sv`, value: `Signaturen för` }, { language: `en`, value: `Signature for` },);
        this.set(this.formSummaryTableMountersSignaturesLanguageItemName, { language: `fi`, value: `Asentajan allekirjoitukset` }, { language: `sv`, value: `Mounters signaturer` }, { language: `en`, value: `Mounters signatures` },);
        this.set(this.mountersSignaturesSummaryErrorLanguageItemName, { language: `fi`, value: `Lomakkeeseen vaaditaan asentajien allekirjoitukset, mutta niitä ei lisätä.` }, { language: `sv`, value: `Mounters signaturer krävs för formuläret, men ingen läggs till.` }, { language: `en`, value: `Mounters signatures are required for the form, but none is added.` },);
        this.set(this.genericActiveLanguageItemName, { language: `fi`, value: `Aktiivinen` }, { language: `sv`, value: `Aktiv` }, { language: `en`, value: `Active` },);
        this.set(this.workOrderDetailsPanelGridAttachmentsAttachmentTypeLanguageItemName, { language: `fi`, value: `Liitteen tyyppi` }, { language: `sv`, value: `Typ av bilaga` }, { language: `en`, value: `Attachment type` },);
        this.set(this.constructionSiteManagementTabsProjectAttachmentsLanguageItemName, { language: `fi`, value: `Työmaan liitteet` }, { language: `sv`, value: `Projektbilagor` }, { language: `en`, value: `Project attachments` },);
        this.set(this.addConstructionSiteAttachmentModalPublicCheckboxLanguageItemName, { language: `fi`, value: `Julkinen` }, { language: `sv`, value: `Offentlig` }, { language: `en`, value: `Public` },);
        this.set(this.addConstructionSiteAttachmentModalTitleLanguageItemName, { language: `fi`, value: `Lisää työmaan liite` }, { language: `sv`, value: `Lägg till byggplats Bifogning` }, { language: `en`, value: `Add construction site attachment` },);
        this.set(this.constructionSiteAttachmentsPanelToolbarPublicCheckboxLanguageItemName, { language: `fi`, value: `Julkinen` }, { language: `sv`, value: `Offentlig` }, { language: `en`, value: `Public` },);
        this.set(this.constructionSiteAttachmentsPanelToolbarAddAttachmentsButtonLanguageItemName, { language: `fi`, value: `Lisää liitetiedostoja` }, { language: `sv`, value: `Lägg till bilagor` }, { language: `en`, value: `Add attachments` },);
        this.set(this.constructionSiteAttachmentsGridNoDataTextLanguageItemName, { language: `fi`, value: `Ei liitteitä` }, { language: `sv`, value: `Inga bilagor` }, { language: `en`, value: `No attachments` },);
        this.set(this.enumAttachmentTypeConstructionSiteAttachmentLanguageItemName, { language: `fi`, value: `Työmaan liite` }, { language: `sv`, value: `Projektbilaga` }, { language: `en`, value: `Construction site attachment` },);
        this.set(this.constructionSiteAttachmentsGridFileNameLanguageItemName, { language: `fi`, value: `Tiedoston nimi` }, { language: `sv`, value: `Filnamn` }, { language: `en`, value: `File name` },);
        this.set(this.constructionSiteAttachmentsGridFileTypeLanguageItemName, { language: `fi`, value: `Tiedostotyyppi` }, { language: `sv`, value: `Filtyp` }, { language: `en`, value: `File type` },);
        this.set(this.constructionSiteAttachmentsGridPublicLanguageItemName, { language: `fi`, value: `Julkinen` }, { language: `sv`, value: `Offentlig` }, { language: `en`, value: `Public` },);
        this.set(this.constructionSiteAttachmentsGridDeleteAttachmentLanguageItemName, { language: `fi`, value: `Poista liite` }, { language: `sv`, value: `Ta bort produkter` }, { language: `en`, value: `Delete attachment` },);
        this.set(this.constructionSiteAttachmentsGridConfirmDeleteLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat poistaa liitteen {0}?` }, { language: `sv`, value: `Är du säker på att du vill ta bort {0} bilaga?` }, { language: `en`, value: `Are you sure you want to delete {0} attachment?` },);
        this.set(this.constructionSiteAttachmentsGridDownloadAttachmentLanguageItemName, { language: `fi`, value: `Lataa liite` }, { language: `sv`, value: `Ladda ner bilaga` }, { language: `en`, value: `Download attachment` },);
        this.set(this.genericWorkingHoursLanguageItemName, { language: `fi`, value: `Työtunnit` }, { language: `sv`, value: `Arbetstimmar` }, { language: `en`, value: `Working hours` },);
        this.set(this.formDefinitionPageStepLanguageItemName, { language: `fi`, value: `Vaihe` }, { language: `sv`, value: `Steg` }, { language: `en`, value: `Step` },);
        this.set(this.formDefinitionPageValueStepIncorrectLanguageItemName, { language: `fi`, value: `vaihe arvo on oltava suurempi kuin 0` }, { language: `sv`, value: `stegvärdet måste vara större än noll` }, { language: `en`, value: `step value must be greater than 0` },);
        this.set(this.genericDefaultAlarmJobPriceLanguageItemName, { language: `fi`, value: `Oletus hälytystyön hinta` }, { language: `sv`, value: `Standard larm jobb pris` }, { language: `en`, value: `Default alarm job price` },);
        this.set(this.myAccountPageNotificationTabTitleLanguageItemName, { language: `fi`, value: `Ilmoitusten asetukset` }, { language: `sv`, value: `Aviseringsinställningar` }, { language: `en`, value: `Notification settings` },);
        this.set(this.globalNotificationSettingsPageTitleLanguageItemName, { language: `fi`, value: `Yleiset ilmoitusasetukset` }, { language: `sv`, value: `Globala aviseringsinställningar` }, { language: `en`, value: `Global notification settings` },);
        this.set(this.notificationSettingsFlyoutMessageGlobalSettingSavedLanguageItemName, { language: `fi`, value: `Yleisten ilmoitusasetusten tallentaminen onnistui.` }, { language: `sv`, value: `Global aviseringsinställning har sparat` }, { language: `en`, value: `Global notification setting saved successfully.` },);
        this.set(this.notificationSettingsFlyoutMessageUserSettingSavedLanguageItemName, { language: `fi`, value: `Käyttäjän ilmoitusasetusten tallentaminen onnistui.` }, { language: `sv`, value: `Användaraviseringsinställningen har sparats.` }, { language: `en`, value: `User notification setting saved successfully.` },);
        this.set(this.notificationSettingsAlertMessageGlobalSettingsDisabledLanguageItemName, { language: `fi`, value: `Ilmoitustyyppi "{0}" on yleisesti otettu pois käytöstä.` }, { language: `sv`, value: `Aviseringstypen "{0}" är globalt inaktiverad.` }, { language: `en`, value: `Notifications type of "{0}" are globally disabled.` },);
        this.set(this.notificationSettingsDropdownTypeLanguageItemName, { language: `fi`, value: `Ilmoituksen tyyppi:` }, { language: `sv`, value: `Aviseringstyp:` }, { language: `en`, value: `Notification type:` },);
        this.set(this.notificationSettingsSwitchEnableLanguageItemName, { language: `fi`, value: `Ilmoitukset on/off:` }, { language: `sv`, value: `Aviserings on/off:` }, { language: `en`, value: `Notifications on/off:` },);
        this.set(this.notificationSettingsDropdownMediaTypeLanguageItemName, { language: `fi`, value: `Median tyyppi:` }, { language: `sv`, value: `Mediatyp:` }, { language: `en`, value: `Media type:` },);
        this.set(this.notificationSettingsDropdownIntervalLanguageItemName, { language: `fi`, value: `Aikaväli:` }, { language: `sv`, value: `Intervall:` }, { language: `en`, value: `Interval:` },);
        this.set(this.notificationSettingsDateInputSendTimeLanguageItemName, { language: `fi`, value: `Ilmoitusten saapumisaika:` }, { language: `sv`, value: `Tid för aviseringar:` }, { language: `en`, value: `Notifications occurrence time:` },);
        this.set(this.notificationSettingsDropdownWeeklySendOccurrenceLanguageItemName, { language: `fi`, value: `Viikonpäivä ilmoituksen saapumiselle:` }, { language: `sv`, value: `Händelse på veckodag:` }, { language: `en`, value: `Week day(s) occurrence:` },);
        this.set(this.notificationSettingsDateInputPausedFromLanguageItemName, { language: `fi`, value: `Ilmoitukset keskeytetty alkaen:` }, { language: `sv`, value: `Aviseringar pausade från:` }, { language: `en`, value: `Notifications paused from:` },);
        this.set(this.notificationSettingsDateInputPausedToLanguageItemName, { language: `fi`, value: `Imoitukset keskeytetty tähän asti:` }, { language: `sv`, value: `Aviseringar pausade till:` }, { language: `en`, value: `Notifications paused until:` },);
        this.set(this.enumNotificationIntervalDailyLanguageItemName, { language: `fi`, value: `Päivittäin` }, { language: `sv`, value: `Dagligen` }, { language: `en`, value: `Daily` },);
        this.set(this.enumNotificationIntervalOnDemandLanguageItemName, { language: `fi`, value: `Tarvittaessa` }, { language: `sv`, value: `På begäran` }, { language: `en`, value: `On-demand` },);
        this.set(this.enumNotificationIntervalWeeklyLanguageItemName, { language: `fi`, value: `Viikottain` }, { language: `sv`, value: `Varje vecka` }, { language: `en`, value: `Weekly` },);
        this.set(this.enumNotificationMediaTypeEmailLanguageItemName, { language: `fi`, value: `Sähköposti` }, { language: `sv`, value: `E-post` }, { language: `en`, value: `Email` },);
        this.set(this.enumNotificationMediaTypeEmailAndSmsLanguageItemName, { language: `fi`, value: `Sähköposti ja SMS` }, { language: `sv`, value: `E-post och SMS` }, { language: `en`, value: `Email and SMS` },);
        this.set(this.enumNotificationMediaTypeSmsLanguageItemName, { language: `fi`, value: `SMS` }, { language: `sv`, value: `SMS` }, { language: `en`, value: `SMS` },);
        this.set(this.enumDayOfWeekMondayLanguageItemName, { language: `fi`, value: `Maanantai` }, { language: `sv`, value: `Måndag` }, { language: `en`, value: `Monday` },);
        this.set(this.enumDayOfWeekTuesdayLanguageItemName, { language: `fi`, value: `Tiistai` }, { language: `sv`, value: `Tisdag` }, { language: `en`, value: `Tuesday` },);
        this.set(this.enumDayOfWeekWednesdayLanguageItemName, { language: `fi`, value: `Keskiviikko` }, { language: `sv`, value: `Onsdag` }, { language: `en`, value: `Wednesday` },);
        this.set(this.enumDayOfWeekThursdayLanguageItemName, { language: `fi`, value: `Torstai` }, { language: `sv`, value: `Torsdag` }, { language: `en`, value: `Thursday` },);
        this.set(this.enumDayOfWeekFridayLanguageItemName, { language: `fi`, value: `Perjantai` }, { language: `sv`, value: `Fredag` }, { language: `en`, value: `Friday` },);
        this.set(this.enumDayOfWeekSaturdayLanguageItemName, { language: `fi`, value: `Lauantai` }, { language: `sv`, value: `Lördag` }, { language: `en`, value: `Saturday` },);
        this.set(this.enumDayOfWeekSundayLanguageItemName, { language: `fi`, value: `Sunnuntai` }, { language: `sv`, value: `Söndag` }, { language: `en`, value: `Sunday` },);
        this.set(this.enumNotificationTypeWorkOrdersProcessedApprovalLanguageItemName, { language: `fi`, value: `Työtilausprosessin hyväksyntä` }, { language: `sv`, value: `Arbetsorder behandlade godkännande` }, { language: `en`, value: `Work orders processed approval` },);
        this.set(this.enumNotificationTypeWorkOrdersPendingApprovalLanguageItemName, { language: `fi`, value: `Työtilaukset odottavat hyväksyntää` }, { language: `sv`, value: `Arbetsorder väntar på godkännande` }, { language: `en`, value: `Work orders pending approval` },);
        this.set(this.enumNotificationTypeWorkOrderReactivationLanguageItemName, { language: `fi`, value: `Työtilauksen uudelleen aktivointi` }, { language: `sv`, value: `Återaktivering av arbetsorder` }, { language: `en`, value: `Work order reactivation` },);
        this.set(this.notificationSettingsNumberInputPendingDaysLanguageItemName, { language: `fi`, value: `Odotettavat päivät` }, { language: `sv`, value: `Väntande dagar` }, { language: `en`, value: `Pending days` },);
        this.set(this.notificationSettingsTextDescriptionLanguageItemName, { language: `fi`, value: `Imoitusasetustyypin selite:` }, { language: `sv`, value: `Beskrivning av typ av meddelandeinställning:` }, { language: `en`, value: `Notification setting type description:` },);
        this.set(this.notificationSettingsNotificationTypeWorkOrdersPendingApprovalDescriptionLanguageItemName, { language: `fi`, value: `Ilmoitus managerille työtilauksista jotka odottavat asiakkaan hyväksyntää.` }, { language: `sv`, value: `Meddelande till Montageledare om arbetsorder som väntar på godkännande av kunden.` }, { language: `en`, value: `Notification for the managers of work orders which are pending approval by the customer.` },);
        this.set(this.notificationSettingsNotificationTypeWorkOrderReactivationDescriptionLanguageItemName, { language: `fi`, value: `Ilmoitukset asentajalle kun työ uudelleen aktivoidaan managerin toimesta.` }, { language: `sv`, value: `Meddelande till montörerna när arbetsordern återaktiveras av Montageledare.` }, { language: `en`, value: `Notification for the mounters when the work order gets reactivated by the manager.` },);
        this.set(this.notificationSettingsNotificationTypeWorkOrdersProcessedApprovalDescriptionLanguageItemName, { language: `fi`, value: `Ilmoitus managerille, kun asiakas hyväksyy/hylkää työtilauksen.` }, { language: `sv`, value: `Meddelande till Montageledarnana när arbetsorder godkänns/avvisas av kunden.` }, { language: `en`, value: `Notification for the managers when work orders get approved/declined by the customer.` },);
        this.set(this.formSummaryTableSelectedReceiversHeaderLanguageItemName, { language: `fi`, value: `Lähetetään osoitteeseen:` }, { language: `sv`, value: `Kommer att skickas till:` }, { language: `en`, value: `Will be sent to:` },);
        this.set(this.notificationTitleLanguageItemName, { language: `fi`, value: `Ilmoitus ({0})` }, { language: `sv`, value: `Underrättelse ({0})` }, { language: `en`, value: `Notification ({0})` },);
        this.set(this.notificationTitleLoadingLanguageItemName, { language: `fi`, value: `Ilmoitusta ladataan...` }, { language: `sv`, value: `Meddelanden laddas...` }, { language: `en`, value: `Notification loading...` },);
        this.set(this.workOrderCurrentStatusLanguageItemName, { language: `fi`, value: `Nykyinen tila` }, { language: `sv`, value: `Nuvarande status` }, { language: `en`, value: `Current status` },);
        this.set(this.genericSentAtLanguageItemName, { language: `fi`, value: `Lähetetty` }, { language: `sv`, value: `Skickat i` }, { language: `en`, value: `Sent at` },);
        this.set(this.genericSentByLanguageItemName, { language: `fi`, value: `Lähettäjä` }, { language: `sv`, value: `Skickat av` }, { language: `en`, value: `Sent by` },);
        this.set(this.genericApprovedAtLanguageItemName, { language: `fi`, value: `Hyväksytty` }, { language: `sv`, value: `Godkänd i` }, { language: `en`, value: `Approved at` },);
        this.set(this.genericApprovedByLanguageItemName, { language: `fi`, value: `Hyväksyjä` }, { language: `sv`, value: `Godkänd av` }, { language: `en`, value: `Approved by` },);
        this.set(this.workOrderChangeStatusModalTitleReactivateLanguageItemName, { language: `fi`, value: `Lähetä ilmoitus asentajille` }, { language: `sv`, value: `Skicka meddelande till montör(er)` }, { language: `en`, value: `Send notification to mounter(s)` },);
        this.set(this.workOrderChangeStatusModalTitleDeclineLanguageItemName, { language: `fi`, value: `Lähetä ilmoitus työmaajohtajalle` }, { language: `sv`, value: `Skicka meddelande till projektledare(r)` }, { language: `en`, value: `Send notification to manager(s)` },);
        this.set(this.genericApprovedOrDeclinedAtLanguageItemName, { language: `fi`, value: `Hyväksytty/Hylätty` }, { language: `sv`, value: `Godkänd/Avvisad i` }, { language: `en`, value: `Approved/Declined At` },);
        this.set(this.genericApprovedOrDeclinedByLanguageItemName, { language: `fi`, value: `Hyväksyjä/Hylkääjä` }, { language: `sv`, value: `Godkänd/Avvisad av` }, { language: `en`, value: `Approved/Declined By` },);
        this.set(this.genericFromLanguageItemName, { language: `fi`, value: `Alkaen` }, { language: `sv`, value: `Från` }, { language: `en`, value: `From` },);
        this.set(this.genericToLanguageItemName, { language: `fi`, value: `Päättyen` }, { language: `sv`, value: `Till` }, { language: `en`, value: `To` },);
        this.set(this.notificationWorkOrdersPendingApprovalSubtitleLanguageItemName, { language: `fi`, value: `Työtilaukset, jotka odottavat asiakkaan hyväksyntää` }, { language: `sv`, value: `Arbetsorder(er) som väntar på kundens godkännande` }, { language: `en`, value: `Work order(s) that are waiting for customer approval` },);
        this.set(this.workOrderChangeStatusModalPlaceholderCommentReasonLanguageItemName, { language: `fi`, value: `Ole hyvä, kommentoi syy` }, { language: `sv`, value: `Snälla, kommentera en anledning` }, { language: `en`, value: `Please, comment a reason` },);
        this.set(this.statusMessageModalTitleWorkOrderReactivatedLanguageItemName, { language: `fi`, value: `Työtilaus on uudelleenaktivoitu.` }, { language: `sv`, value: `Arbetsordern har återaktiverats.` }, { language: `en`, value: `Work order has been reactivated.` },);
        this.set(this.statusMessageModalTitleWorkReportDeclinedLanguageItemName, { language: `fi`, value: `Työtilaus on hylätty.` }, { language: `sv`, value: `Arbetsrapporten har avvisats.` }, { language: `en`, value: `The work report has been declined.` },);
        this.set(this.statusMessageModalCommentedReasonLanguageItemName, { language: `fi`, value: `Hylkäyksen kommentoitu syy: {0}` }, { language: `sv`, value: `Kommenterad anledning: {0}` }, { language: `en`, value: `Commented reason: {0}` },);
        this.set(this.genericOkLanguageItemName, { language: `fi`, value: `Ok` }, { language: `sv`, value: `Ok` }, { language: `en`, value: `Ok` },);
        this.set(this.approveFormPageAlertErrorSignatureIsRequiredLanguageItemName, { language: `fi`, value: `Allekirjoitus vaaditaan ennen lomakkeen valmistamista.` }, { language: `sv`, value: `Underskrift krävs för att fylla i formuläret.` }, { language: `en`, value: `Signature is required to complete form.”` },);
        this.set(this.rentalEquipmentAddRentalEquipmentLanguageItemName, { language: `fi`, value: `Lisää yksittäinen vuokratuote` }, { language: `sv`, value: `Lägga till individuell hyrutrustning` }, { language: `en`, value: `Add individual rental equipment` },);
        this.set(this.rentalEquipmentRentalEquipmentLanguageItemName, { language: `fi`, value: `Vuokratuote` }, { language: `sv`, value: `Uthyrningsutrustning` }, { language: `en`, value: `Rental equipment` },);
        this.set(this.rentalEquipmentAddRentalEquipmentToWorkOrderLanguageItemName, { language: `fi`, value: `Lisää yksittäinen vuokratuote työtilaukseen` }, { language: `sv`, value: `Lägg till individuell hyrutrustning till arbetsordern` }, { language: `en`, value: `Add individual rental equipment to work order` },);
        this.set(this.rentalEquipmentActionTypeLanguageItemName, { language: `fi`, value: `Toiminnon tyyppi` }, { language: `sv`, value: `Typ av operation` }, { language: `en`, value: `Action type` },);
        this.set(this.enumRentalItemActionTypeLeaveLanguageItemName, { language: `fi`, value: `Toimitus` }, { language: `sv`, value: `Lämna` }, { language: `en`, value: `Leave` },);
        this.set(this.enumRentalItemActionTypeReturnLanguageItemName, { language: `fi`, value: `Palautus` }, { language: `sv`, value: `Lämna tillbaka` }, { language: `en`, value: `Return` },);
        this.set(this.enumNotificationTypeWorkOrderAssignmentLanguageItemName, { language: `fi`, value: `Työtilauksen toimeksianto` }, { language: `sv`, value: `Tilldelning av arbetsorder` }, { language: `en`, value: `Work order assignment` },);
        this.set(this.notificationSettingsNotificationTypeWorkOrderAssignmentDescriptionLanguageItemName, { language: `fi`, value: `Ilmoitus asentajalle kun hänet on lisätty työtilaukseen.` }, { language: `sv`, value: `Meddelande till montören när de har tilldelats en arbetsorder.` }, { language: `en`, value: `Notification for the mounter when they have been assigned to a work order.` },);
        this.set(this.rentaTasksWorkOrderSignInAlreadySignedInAlertLanguageItemName, { language: `fi`, value: `Ei voi kirjautua sisään. Olet jo kirjautunut toiseen työtilaukseen.` }, { language: `sv`, value: `Det går inte att logga in. Du är redan inloggad på en annan arbetsorder.` }, { language: `en`, value: `Cannot sign-in. You are already signed-in to another work order.` },);
        this.set(this.auditQuestionInputPictureRequiredLanguageItemName, { language: `fi`, value: `Kuva on pakollinen` }, { language: `sv`, value: `Bild krävs` }, { language: `en`, value: `Picture is required` },);
        this.set(this.auditQuestionInputPictureOptionalLanguageItemName, { language: `fi`, value: `Lisää kuva tarvittaessa` }, { language: `sv`, value: `Lägg till bild vid behov` }, { language: `en`, value: `Add picture if needed` },);
        this.set(this.genericAlarmJobLanguageItemName, { language: `fi`, value: `Hälytystyö` }, { language: `sv`, value: `Larmjobb` }, { language: `en`, value: `Alarm job` },);
        this.set(this.workOrderDetailsHoursGridAddLanguageItemName, { language: `fi`, value: `Lisää` }, { language: `sv`, value: `Lägg till` }, { language: `en`, value: `Add` },);
        this.set(this.dailyHoursModalLabelsIncludeAlarmJobLanguageItemName, { language: `fi`, value: `Lisää hälytystyö` }, { language: `sv`, value: `Lägg till larmjobb` }, { language: `en`, value: `Include alarm job` },);
        this.set(this.workOrderActionsConfirmApproveSentLanguageItemName, { language: `fi`, value: `Työtilaus on lähetetty asiakkaalle hyväksyttäväksi. Oletko varma että haluat merkitä sen asiakkaan hyväksymäksi?` }, { language: `sv`, value: `Arbetsordern har skickats till kunden för godkännande. Är du säker på att du vill markera den som accepterad av kunden?` }, { language: `en`, value: `Work order has been sent to the customer for approval. Are you sure you want to mark it as approved by the customer?` },);
        this.set(this.workOrderTypeManagementTypeExistsAlertLanguageItemName, { language: `fi`, value: `Työtilaustyyppi {0} on jo olemassa` }, { language: `sv`, value: `Arbetsordertyp {0} finns redan` }, { language: `en`, value: `Work order type {0} already exists` },);
        this.set(this.userManagementDropdownSubcontractorLanguageItemName, { language: `fi`, value: `Alihankkija` }, { language: `sv`, value: `Underleverantör` }, { language: `en`, value: `Subcontractor` },);
        this.set(this.userManagementMounterPermissionsCanCreateWorkOrderLanguageItemName, { language: `fi`, value: `Voi luoda \ntyötilauksia` }, { language: `sv`, value: `Kan skapa arbetsorder` }, { language: `en`, value: `Can create work orders` },);
        this.set(this.userManagementMounterPermissionsCanCompleteWorkOrderLanguageItemName, { language: `fi`, value: `Voi merkitä \ntyötilauksen valmiiksi` }, { language: `sv`, value: `Kan slutföra arbetsorder` }, { language: `en`, value: `Can complete work orders` },);
        this.set(this.userManagementMounterPermissionsCanProcessFormLanguageItemName, { language: `fi`, value: `Voi käsitellä \nlomakkeita` }, { language: `sv`, value: `Kan bearbeta blanketter` }, { language: `en`, value: `Can process forms` },);
        this.set(this.addSubcontractorModalValidationErrorSubcontractorAlreadyExistsLanguageItemName, { language: `fi`, value: `Alihankkija on jo olemassa` }, { language: `sv`, value: `Underleverantör finns redan` }, { language: `en`, value: `Subcontractor already exists` },);
        this.set(this.subcontractorsPanelConfirmationDeleteSubcontractorLanguageItemName, { language: `fi`, value: `Oletko varma, että haluat poistaa alihankkijan '{0}'?` }, { language: `sv`, value: `Är du säker på att du vill raderade underleverantören '{0}'?` }, { language: `en`, value: `Are you sure, you want to delete the subcontractor '{0}'?` },);
        this.set(this.genericDeletedAtLanguageItemName, { language: `fi`, value: `Poistettu` }, { language: `sv`, value: `Raderade tid` }, { language: `en`, value: `Deleted at` },);
        this.set(this.genericDeletedByLanguageItemName, { language: `fi`, value: `Poisti` }, { language: `sv`, value: `Raderad av` }, { language: `en`, value: `Deleted by` },);
        this.set(this.mobileFormSaveAndCloseLabelLanguageItemName, { language: `fi`, value: `Tallenna ja sulje` }, { language: `sv`, value: `Spara och stäng` }, { language: `en`, value: `Save and close` },);
        this.set(this.mobileFormSaveAndCloseDescriptionLanguageItemName, { language: `fi`, value: `Tallenna ja sulje ja palaa takaisin` }, { language: `sv`, value: `Spara och stäng och returnera` }, { language: `en`, value: `Save and close and return` },);
        this.set(this.genericCreatedByLanguageItemName, { language: `fi`, value: `Luonut` }, { language: `sv`, value: `Skapad av` }, { language: `en`, value: `Created by` },);
        this.set(this.genericCreatedAtLanguageItemName, { language: `fi`, value: `Luotu` }, { language: `sv`, value: `Skapad vid` }, { language: `en`, value: `Created at` },);
        this.set(this.genericSystemLanguageItemName, { language: `fi`, value: `Järjestelmä` }, { language: `sv`, value: `System` }, { language: `en`, value: `System` },);
        this.set(this.workOrderDetailsPanelTabHistoryLanguageItemName, { language: `fi`, value: `Historia` }, { language: `sv`, value: `Historia` }, { language: `en`, value: `History` },);
        this.set(this.workOrderDetailsPanelWorkOrderStatusesChangedAtLanguageItemName, { language: `fi`, value: `Vaihdettu klo` }, { language: `sv`, value: `Ändrade kl` }, { language: `en`, value: `Changed at` },);
        this.set(this.workOrderDetailsPanelWorkOrderStatusesChangedByLanguageItemName, { language: `fi`, value: `Muuttanut` }, { language: `sv`, value: `Ändrad av` }, { language: `en`, value: `Changed by` },);
        this.set(this.genericScheduleLanguageItemName, { language: `fi`, value: `Aikataulu` }, { language: `sv`, value: `Tidtabell` }, { language: `en`, value: `Schedule` },);
        this.set(this.rentalEquipmentProductWithIdNotAvailableForRentLanguageItemName, { language: `fi`, value: `Tuote id:llä "{0}" ei ole vuokrattavissa` }, { language: `sv`, value: `Produkt med id "{0}" är inte tillgänglig för uthyrning` }, { language: `en`, value: `Product with id "{0}" is not available for rent` },);
        this.set(this.rentalEquipmentProductInfoRetrievedSuccessfullyLanguageItemName, { language: `fi`, value: `Tuotteen tiedot haettiin onnistuneesti` }, { language: `sv`, value: `Produktinformation har hämtats framgångsrikt` }, { language: `en`, value: `Product info retrieved successfully` },);
        this.set(this.genericProductWithSameIdHasAlreadyBeenAddedLanguageItemName, { language: `fi`, value: `Tuote jolla on sama id on jo lisätty` }, { language: `sv`, value: `Produkt med samma id har redan lagts till` }, { language: `en`, value: `Product with same id has already been added` },);
        this.set(this.formInputExternalIdLanguageItemName, { language: `fi`, value: `Ulkoinen-id` }, { language: `sv`, value: `Externt-id` }, { language: `en`, value: `External id` },);
        this.set(this.workOrderContractTypeDropdownLabelLanguageItemName, { language: `fi`, value: `Sopimustyyppi` }, { language: `sv`, value: `Kontraktstyp` }, { language: `en`, value: `Contract type` },);
        this.set(this.enumWorkOrderContractTypeFixedPriceLanguageItemName, { language: `fi`, value: `Kiinteä hinta` }, { language: `sv`, value: `Fast pris` }, { language: `en`, value: `Fixed price` },);
        this.set(this.enumWorkOrderContractTypeNormalLanguageItemName, { language: `fi`, value: `Tuntityö` }, { language: `sv`, value: `Timarbete` }, { language: `en`, value: `Hourly work` },);
        this.set(this.enumWorkOrderContractTypeWarrantyLanguageItemName, { language: `fi`, value: `Takuutyö` }, { language: `sv`, value: `Garanti` }, { language: `en`, value: `Warranty` },);
        this.set(this.workOrderFixedCostLabelLanguageItemName, { language: `fi`, value: `Kiinteä hinta` }, { language: `sv`, value: `Fast pris kostnad` }, { language: `en`, value: `Fixed cost` },);
        this.set(this.workOrderFixedHoursCostLabelLanguageItemName, { language: `fi`, value: `Työkustannus` }, { language: `sv`, value: `Arbetskostnad` }, { language: `en`, value: `Hours cost` },);
        this.set(this.workOrderFixedTransportationCostLabelLanguageItemName, { language: `fi`, value: `Kuljetuskustannus` }, { language: `sv`, value: `Transportkostnad` }, { language: `en`, value: `Transportation cost` },);
        this.set(this.workOrderFixedProductCostLabelLanguageItemName, { language: `fi`, value: `Tuotekustannus` }, { language: `sv`, value: `Produkter kostar` }, { language: `en`, value: `Product cost` },);
        this.set(this.workOrderFixedPriceHeaderLanguageItemName, { language: `fi`, value: `Urakkahinnat` }, { language: `sv`, value: `Fast prissättning` }, { language: `en`, value: `Contract prices` },);
        this.set(this.workOrderHourlyPriceHeaderLanguageItemName, { language: `fi`, value: `Tuntityöhinnat` }, { language: `sv`, value: `Timarbete priser` }, { language: `en`, value: `Hourly work prices` },);
        this.set(this.workOrderPauseStartLabelLanguageItemName, { language: `fi`, value: `Aloita tehtävän tauko` }, { language: `sv`, value: `Starta aktivitetspaus` }, { language: `en`, value: `Start task pause` },);
        this.set(this.workOrderPauseEndLabelLanguageItemName, { language: `fi`, value: `Lopeta tehtävän tauko` }, { language: `sv`, value: `Avsluta aktivitetspaus` }, { language: `en`, value: `End task pause` },);
        this.set(this.genericActionPauseTaskLanguageItemName, { language: `fi`, value: `Keskeytä tehtävä` }, { language: `sv`, value: `Pausa uppgiften` }, { language: `en`, value: ` Pause task` },);
        this.set(this.calendarPageCalendarDataPauseOverlayTextLanguageItemName, { language: `fi`, value: `Keskeytetty {0} - {1}` }, { language: `sv`, value: `Pausad från {0} till {1}` }, { language: `en`, value: `Paused from {0} to {1}` },);
        this.set(this.genericWorkOrderPausedSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilaus keskeytettiin onnistuneesti` }, { language: `sv`, value: `Arbetsorder har pausats` }, { language: `en`, value: `Work order paused successfully` },);
        this.set(this.genericWorkOrderPauseFailedLanguageItemName, { language: `fi`, value: `Työmääräyksen keskeyttäminen epäonnistui` }, { language: `sv`, value: `Det gick inte att pausa arbetsordern` }, { language: `en`, value: `Failed to pause work order` },);
        this.set(this.formSummaryTableApproverSignatureLanguageItemName, { language: `fi`, value: `Hyväksyjän allekirjoitus` }, { language: `sv`, value: `Godkännarens underskrift` }, { language: `en`, value: `Approver's signature` },);
        this.set(this.newVersionAvailableTitleLanguageItemName, { language: `fi`, value: `Päivitä` }, { language: `sv`, value: `En ny version av applikationen är tillgänglig` }, { language: `en`, value: `A new version of the application is available` },);
        this.set(this.newVersionAvailableDescriptionLanguageItemName, { language: `fi`, value: `Selainikkuna pitää päivittää että kaikki muutokset astuvat voimaan` }, { language: `sv`, value: `Webbläsarfönstret måste uppdateras för att alla ändringar ska träda i kraft` }, { language: `en`, value: `The browser window must be refreshed for all changes to take effect` },);
        this.set(this.newVersionAvailableRefreshButtonLanguageItemName, { language: `fi`, value: `Uusi versio sovelluksesta saatavilla` }, { language: `sv`, value: `Uppdatering` }, { language: `en`, value: `Update` },);
        this.set(this.catalogManagementRentalMassProductsPageTitleLanguageItemName, { language: `fi`, value: `Vuokratuotteet` }, { language: `sv`, value: `Katalog för hyresobjekt` }, { language: `en`, value: `Rental items catalog` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsAddRentalMassEquipmentLanguageItemName, { language: `fi`, value: `Lisää massavuokratuotteita` }, { language: `sv`, value: `Lägga till en massa hyra objekt` }, { language: `en`, value: `Add mass rental items` },);
        this.set(this.subcontractorAssignmentModalWarningLanguageItemName, { language: `fi`, value: `Valittu asentaja kuuluu alihankkijayritykselle, jota ei ole vielä kiinnitetty sopimukseen. Jos haluat antaa työtilauksen asentajalle, sopimukselle lisätään myös alihankkijayritys.` }, { language: `sv`, value: `Den valda montören tillhör ett underleverantörsföretag som ännu inte är tilldelat kontraktet. Om du vill tilldela arbetsordern till montören kommer ett underleverantörsföretag att tilldelas kontraktet också.` }, { language: `en`, value: `The selected mounter belongs to a subcontractor company that is not yet assigned to the contract. If you want to assign the work order to the mounter, a subcontractor company will be assigned to the contract as well. ` },);
        this.set(this.genericUnassignLanguageItemName, { language: `fi`, value: `Poista määritys` }, { language: `sv`, value: `Ta bort tilldelning` }, { language: `en`, value: `Unassign` },);
        this.set(this.genericAssignLanguageItemName, { language: `fi`, value: `Määritä` }, { language: `sv`, value: `Tilldela` }, { language: `en`, value: `Assign` },);
        this.set(this.assignedMountersWarningModalMountersAreAssignedLanguageItemName, { language: `fi`, value: `Alihankkijaa ei voida poistaa ennen kuin kaikki alihankkijan asentajille määrätyt työtilaukset on poistettu tai osoitettu toiselle asentajalle.` }, { language: `sv`, value: `En underleverantör kan inte tas bort förrän alla arbetsordrar som har tilldelats underleverantörsmontörerna inte har tilldelats` }, { language: `en`, value: `A subcontractor can’t be removed until all the work orders that have been assigned to the subcontractor mounters are unassigned.` },);
        this.set(this.assignedMountersWarningModalAssignedMountersLanguageItemName, { language: `fi`, value: `Määrätyt työtilaukset` }, { language: `sv`, value: `Tilldelade montörer` }, { language: `en`, value: `Assigned mounters` },);
        this.set(this.subcontractorAssignmentModalTitleLanguageItemName, { language: `fi`, value: `Lisää alihankkija` }, { language: `sv`, value: `Lägg till underleverantör` }, { language: `en`, value: `Add Subcontractor` },);
        this.set(this.genericClearLanguageItemName, { language: `fi`, value: `Tyhjennä` }, { language: `sv`, value: `Töm` }, { language: `en`, value: `Clear` },);
        this.set(this.genericActionUnpauseTaskLanguageItemName, { language: `fi`, value: `Lopeta työtilauksen tauko` }, { language: `sv`, value: `Avsluta arbetsorderpausen` }, { language: `en`, value: `End the work order pause` },);
        this.set(this.genericWorkOrderUnpausedSuccessfullyLanguageItemName, { language: `fi`, value: `Työtilauksen tauon lopetus onnistui` }, { language: `sv`, value: `Att avsluta arbetsorderpausen lyckades` }, { language: `en`, value: `Ending the work order pause was successful` },);
        this.set(this.genericWorkOrderUnpauseFailedLanguageItemName, { language: `fi`, value: `Työtilauksen tauon lopetus epäonnistui` }, { language: `sv`, value: `Att avsluta arbetsorderpausen misslyckades` }, { language: `en`, value: `Ending the work order pause was unsuccessful` },);
        this.set(this.genericTimeLanguageItemName, { language: `fi`, value: `Aika` }, { language: `sv`, value: `Tid` }, { language: `en`, value: `Time` },);
        this.set(this.catalogModalAddRentalEquipmentInsteadLanguageItemName, { language: `fi`, value: `Lisää sen sijaan vuokralaitteet` }, { language: `sv`, value: `Lägg till hyrutrustning istället` }, { language: `en`, value: `Add rental equipment instead` },);
        this.set(this.rentaTasksAddEquipmentCategoriesOrProductsModalTitleRentalMassEquipmentLanguageItemName, { language: `fi`, value: `Massavuokratuotteita` }, { language: `sv`, value: `Massa hyra objekt` }, { language: `en`, value: `Mass rental items` },);
        this.set(this.rentalEquipmentAddRentalMassEquipmentLanguageItemName, { language: `fi`, value: `Lisää massavuokratuotteita` }, { language: `sv`, value: `Lägga till en massa hyra objekt` }, { language: `en`, value: `Add mass rental items` },);
        this.set(this.calendarPageSubContractorMounterSuffixLanguageItemName, { language: `fi`, value: `AU` }, { language: `sv`, value: `UL` }, { language: `en`, value: `SUB` },);
        this.set(this.enumNotificationTypeWorkOrderDeclinedLanguageItemName, { language: `fi`, value: `Työtilauksen hylkäys asiakkaalta` }, { language: `sv`, value: `Arbetsorder avvisad av kund` }, { language: `en`, value: `Rejection of the WO from the customer` },);
        this.set(this.notificationSettingsNotificationTypeWorkOrderDeclinedDescriptionLanguageItemName, { language: `fi`, value: `Ilmoitus työnjohtajalle kun asiakas hylkää työtilauksen` }, { language: `sv`, value: `Notis till montageledare när kunden nekar arbetsordern` }, { language: `en`, value: `Notification to the manager when the customer rejects the work order.` },);
        this.set(this.regionManagementPageTitleLanguageItemName, { language: `fi`, value: `Alueiden hallinta` }, { language: `sv`, value: `Regions inställningar ` }, { language: `en`, value: `Region management` },);
        this.set(this.genericRegionLanguageItemName, { language: `fi`, value: `Alue` }, { language: `sv`, value: `Region` }, { language: `en`, value: `Region` },);
        this.set(this.genericRegionWorkNumbersLanguageItemName, { language: `fi`, value: `Työnumerot` }, { language: `sv`, value: `Resultatenhet Region` }, { language: `en`, value: `Region work numbers` },);
        this.set(this.enumWorkTypeAlertJobHoursLanguageItemName, { language: `fi`, value: `Hälytystyötunnit` }, { language: `sv`, value: `Akutarbetstimmar` }, { language: `en`, value: `Alert job hours` },);
        this.set(this.enumWorkTypeFixedCostLanguageItemName, { language: `fi`, value: `Kiinteä hinta` }, { language: `sv`, value: `offerttimmar` }, { language: `en`, value: `Fixed cost` },);
        this.set(this.enumWorkTypeFixedHoursCostLanguageItemName, { language: `fi`, value: `Työkustannus` }, { language: `sv`, value: `Offertpris` }, { language: `en`, value: `Fixed cost` },);
        this.set(this.enumWorkTypeFixedProductCostLanguageItemName, { language: `fi`, value: `Tuotekustannus` }, { language: `sv`, value: `Offertpris matrial` }, { language: `en`, value: `Fixed product cost` },);
        this.set(this.enumWorkTypeFixedTransportationCostLanguageItemName, { language: `fi`, value: `Kuljetuskustannus` }, { language: `sv`, value: `Offertpris transporter` }, { language: `en`, value: `Fixed transportation cost` },);
        this.set(this.enumWorkTypeMileagesLanguageItemName, { language: `fi`, value: `Matkakulut` }, { language: `sv`, value: `mil` }, { language: `en`, value: `Mileages` },);
        this.set(this.enumWorkTypeNormalHoursLanguageItemName, { language: `fi`, value: `Normaalit tunnit` }, { language: `sv`, value: `Timmar` }, { language: `en`, value: `Hours` },);
        this.set(this.enumWorkTypeOvertime100LanguageItemName, { language: `fi`, value: `Ylityö 100%` }, { language: `sv`, value: `Övertid 100%` }, { language: `en`, value: `Overtime 100%` },);
        this.set(this.enumWorkTypeOvertime50LanguageItemName, { language: `fi`, value: `Ylityö 50%` }, { language: `sv`, value: `Övertid 50%` }, { language: `en`, value: `Overtime 50%` },);
        this.set(this.formDefinitionPageOptionsLanguageItemName, { language: `fi`, value: `Vaihtoehdot` }, { language: `sv`, value: `Alternativ` }, { language: `en`, value: `Options` },);
        this.set(this.workOrderDetailsPanelTabExternalNotificationsLanguageItemName, { language: `fi`, value: `Lähetetyt ilmoitukset` }, { language: `sv`, value: `Externa mottagare av arbetsorder` }, { language: `en`, value: `External notifications` },);
        this.set(this.workOrderDetailsPanelGridExternalNotificationsSenderLanguageItemName, { language: `fi`, value: `Lähettäjä` }, { language: `sv`, value: `Avsändare` }, { language: `en`, value: `Sender` },);
        this.set(this.externalNotificationModalPreviewTitleLanguageItemName, { language: `fi`, value: `Esikatselu` }, { language: `sv`, value: `Förhandsgranskning` }, { language: `en`, value: `Notification preview` },);
        this.set(this.enumAttachmentTypeExternalNotificationAttachmentLanguageItemName, { language: `fi`, value: `Lähetetyn ilmoituksen liite` }, { language: `sv`, value: `Bifogat till externa ` }, { language: `en`, value: `External notification attachment` },);
        this.set(this.externalNotificationModalTitleLanguageItemName, { language: `fi`, value: `Lähetä ilmoitus` }, { language: `sv`, value: `sänd notis` }, { language: `en`, value: `Send notification` },);
        this.set(this.externalNotificationModalSubtitleLanguageItemName, { language: `fi`, value: `Ilmoitus sisältää työtilausraportin liitteenä` }, { language: `sv`, value: `Notis innehåller arbetsorder` }, { language: `en`, value: `Notification contains the work order report as an attachment` },);
        this.set(this.externalNotificationModalRecipientEmailLanguageItemName, { language: `fi`, value: `Vastaanottajan sähköposti` }, { language: `sv`, value: `Mottagares mail adress` }, { language: `en`, value: `Recipient's email` },);
        this.set(this.externalNotificationModalRequestDateLanguageItemName, { language: `fi`, value: `Noutopäivämäärä` }, { language: `sv`, value: `Önskat datum` }, { language: `en`, value: `Request date` },);
        this.set(this.externalNotificationModalSendersEmailLanguageItemName, { language: `fi`, value: `Lähettäjän sähköposti` }, { language: `sv`, value: `Avsändares mail` }, { language: `en`, value: `Sender's email` },);
        this.set(this.externalNotificationModalSendersFirstNameLanguageItemName, { language: `fi`, value: `Lähettäjän etunimi` }, { language: `sv`, value: `Avsändares förnamn` }, { language: `en`, value: `Sender's first name` },);
        this.set(this.externalNotificationModalSendersLastNameLanguageItemName, { language: `fi`, value: `Lähettäjän sukunimi` }, { language: `sv`, value: `Avsändares efternamn` }, { language: `en`, value: `Sender's last name` },);
        this.set(this.externalNotificationModalSendersPhoneLanguageItemName, { language: `fi`, value: `Lähettäjän puhelinnumero` }, { language: `sv`, value: `Avsändares telefonnummer` }, { language: `en`, value: `Sender's phone number` },);
        this.set(this.workOrdersActionsNotificationLanguageItemName, { language: `fi`, value: `Lähetä ilmoitus` }, { language: `sv`, value: `Skicka till extern` }, { language: `en`, value: `Send external notification` },);
        this.set(this.genericWorkOrderRequiredCostPoolLanguageItemName, { language: `fi`, value: `Syötä kunstannuspaikka jatkaaksesi` }, { language: `sv`, value: `Kostnadspool krävs för att fortsätta` }, { language: `en`, value: `Cost pool is required to proceed` },);
        this.set(this.workOrderContractNoLanguageItemName, { language: `fi`, value: `Sopimusnumero` }, { language: `sv`, value: `Kontraktsnr` }, { language: `en`, value: `Contract No` },);
        this.set(this.userManagementUseConstructionSiteCommunicationLanguageLanguageItemName, { language: `fi`, value: `Käytä työmaalle valittua kieltä sähköposteissa` }, { language: `sv`, value: `Använd byggarbetsplatsens språk i e-postmeddelanden` }, { language: `en`, value: `Use construction site language in emails` },);
        this.set(this.enumCommunicationLanguageEnglishLanguageItemName, { language: `fi`, value: `Englanti` }, { language: `sv`, value: `Engelsk` }, { language: `en`, value: `English` },);
        this.set(this.enumCommunicationLanguageFinnishLanguageItemName, { language: `fi`, value: `Suomi` }, { language: `sv`, value: `Finska` }, { language: `en`, value: `Finnish` },);
        this.set(this.enumCommunicationLanguageSwedishLanguageItemName, { language: `fi`, value: `Ruotsi` }, { language: `sv`, value: `Svenska` }, { language: `en`, value: `Swedish` },);
        this.set(this.fileTypeImageLanguageItemName, { language: `fi`, value: `Kuva` }, { language: `sv`, value: `Bild` }, { language: `en`, value: `Image` },);
        this.set(this.fileTypePdfLanguageItemName, { language: `fi`, value: `PDF` }, { language: `sv`, value: `PDF` }, { language: `en`, value: `PDF` },);
        this.set(this.fileTypeWordLanguageItemName, { language: `fi`, value: `Word` }, { language: `sv`, value: `Word` }, { language: `en`, value: `Word` },);
        this.set(this.fileTypeExcelLanguageItemName, { language: `fi`, value: `Excel` }, { language: `sv`, value: `Excel` }, { language: `en`, value: `Excel` },);
        this.set(this.fileTypePowerPointLanguageItemName, { language: `fi`, value: `PowerPoint` }, { language: `sv`, value: `PowerPoint` }, { language: `en`, value: `PowerPoint` },);
        this.set(this.fileTypeOpenOfficeTextLanguageItemName, { language: `fi`, value: `OpenOffice Teksti` }, { language: `sv`, value: `Openoffice text` }, { language: `en`, value: `OpenOffice text` },);
        this.set(this.fileTypeOpenOfficeSpreadsheetLanguageItemName, { language: `fi`, value: `OpenOffice laskentataulukko` }, { language: `sv`, value: `OpenOffice kalkylblad` }, { language: `en`, value: `OpenOffice spreadsheet` },);
        this.set(this.fileTypeOpenOfficePresentationLanguageItemName, { language: `fi`, value: `OpenOffice esitys` }, { language: `sv`, value: `OpenOffice presentation` }, { language: `en`, value: `OpenOffice presentation` },);
        this.set(this.enumCalendarUnitTimeDayLanguageItemName, { language: `fi`, value: `Päivä` }, { language: `sv`, value: `Dag` }, { language: `en`, value: `Day` },);
        this.set(this.userManagementUserSsoInfoLabelLanguageItemName, { language: `fi`, value: `Käyttäjällä on O365 kirjautuminen käytössä` }, { language: `sv`, value: `Användaren har aktiverat O365-inloggning` }, { language: `en`, value: `User has activated O365 login` },);
        this.set(this.newsEditorAddNewLanguageItemName, { language: `fi`, value: `Lisää uusi` }, { language: `sv`, value: `Lägg till ny` }, { language: `en`, value: `Add new` },);
        this.set(this.newsEditorDeleteConfirmLanguageItemName, { language: `fi`, value: `Haluatko poistaa tämän uutisen?` }, { language: `sv`, value: `Är du säker att du vill ta bort nyheten?` }, { language: `en`, value: `Are you sure you want to remove this news?` },);
        this.set(this.newsEditorHelpHeaderLanguageItemName, { language: `fi`, value: `Tässä on lyhyt muistilista editorin käyttämiseen. Vasemmalla oleva tulkitaan ja näytetään oikealla.` }, { language: `sv`, value: `Här är en kort instruktion för syntaxen som används i nyhetsredigeraren. Koden till vänster tolkas och återges till höger.` }, { language: `en`, value: `Here is a short cheat sheet for the markdown syntax used in the news editor. Code on the left is interpreted and rendered on the right.` },);
        this.set(this.newsEditorInputDescriptionLanguageItemName, { language: `fi`, value: `Teksti` }, { language: `sv`, value: `Beskrivning` }, { language: `en`, value: `Description` },);
        this.set(this.newsEditorInputEnabledLanguageItemName, { language: `fi`, value: `Käytössä` }, { language: `sv`, value: `Aktiverad` }, { language: `en`, value: `Enabled` },);
        this.set(this.newsEditorInputImageLanguageItemName, { language: `fi`, value: `Kuva` }, { language: `sv`, value: `Bild` }, { language: `en`, value: `Image` },);
        this.set(this.newsEditorInputTitleLanguageItemName, { language: `fi`, value: `Otsikko` }, { language: `sv`, value: `Titel` }, { language: `en`, value: `Title` },);
        this.set(this.newsEditorPageTitleLanguageItemName, { language: `fi`, value: `Uutiset` }, { language: `sv`, value: `Redaktör` }, { language: `en`, value: `News editor` },);
        this.set(this.newsEditorSaveSuccessLanguageItemName, { language: `fi`, value: `Tallennus onnistui` }, { language: `sv`, value: `Sparad` }, { language: `en`, value: `Save success` },);
        this.set(this.enumWorkTypeCustomProductsLanguageItemName, { language: `fi`, value: `Välitysmyynti` }, { language: `sv`, value: `Anpassad produkt` }, { language: `en`, value: `Custom product` },);
        this.set(this.workReportWithCommentsActionLabelLanguageItemName, { language: `fi`, value: `Työtilausraportti kommenteilla` }, { language: `sv`, value: `Arbetsrapport med kommentarer` }, { language: `en`, value: `Work order report with comments` },);
        this.set(this.workOrderDetailsHoursGridSubContractorErrorMessageLanguageItemName, { language: `fi`, value: `Ole hyvä ja lisää ensin asentaja tälle työtilaukselle ennen tuntien lisäämistä.` }, { language: `sv`, value: `Lägg till en monteringsanordning till denna arbetsorder först.` }, { language: `en`, value: `Please add a mounter to this work order first.` },);
        this.set(this.workReportWithCommentsConfirmationLanguageItemName, { language: `fi`, value: `Raportti on liian suuri ladattavaksi suoraan, mutta voimme lähettää sen sinulle sähköpostitse. Haluatko, että lähetämme raportin sähköpostiisi?` }, { language: `sv`, value: `Rapporten är för stor för att laddas ner direkt, men vi kan skicka den till din e-post. Vill du att vi skickar rapporten till din e-post?` }, { language: `en`, value: `The report is too large to download directly, but we can send it to your email. Would you like us to send the report to your email?` },);
        this.set(this.workOrderInvoiceWithoutCreatingOrderLanguageItemName, { language: `fi`, value: `Merkitse laskutetuksi` }, { language: `sv`, value: `Markera som fakturerad` }, { language: `en`, value: `Mark as invoiced` },);
        this.set(this.finlandWorkOrderInvoiceActionLanguageItemName, { language: `fi`, value: `Laskuta (TK)` }, { language: `sv`, value: `Faktura(TK)` }, { language: `en`, value: `Invoice (TK)` },);
        this.set(this.finlandWorkOrderMarkAsInvoicedActionLanguageItemName, { language: `fi`, value: `Merkitse laskutetuksi` }, { language: `sv`, value: `Markera som fakturerad` }, { language: `en`, value: `Mark as invoiced` },);
        this.set(this.formDefinitionPageItemExportSizeLanguageItemName, { language: `fi`, value: `Kohteen tulostuskoko` }, { language: `sv`, value: `Objektets utskriftsstorlek` }, { language: `en`, value: `Item print size` },);
        this.set(this.constructionSitePanelERPConstructionSiteIdLanguageItemName, { language: `fi`, value: `ERP-työmaan tunniste` }, { language: `sv`, value: `ERP-byggarbetsplats-ID` }, { language: `en`, value: `ERP Construction Site ID` },);
        this.set(this.workReportWithCommentsAdditionalReceiverConfirmationLanguageItemName, { language: `fi`, value: `Olet lähettämässä raporttia annettuun sähköpostiin. Oletko varma?` }, { language: `sv`, value: `Du skickar rapporten med kommentarer till en extra mottagare. Är du säker?` }, { language: `en`, value: `You are sending the report with comments to an additional receiver. Are you sure?` },);
        this.set(this.genericEmailPlaceholderLanguageItemName, { language: `fi`, value: `vastaanottaja@email.com` }, { language: `sv`, value: `mottagare@email.com` }, { language: `en`, value: `receiver@email.com` },);
        this.set(this.tasksPageCommentReportReceiverLabelLanguageItemName, { language: `fi`, value: `Raportin vastaanottaja` }, { language: `sv`, value: `Mottagare av kommentarer` }, { language: `en`, value: `Comment report receiver` },);
        this.set(this.enumUserRoleGroupSalesPersonsLanguageItemName, { language: `fi`, value: `Myyntiedustajat` }, { language: `sv`, value: `Säljare` }, { language: `en`, value: `Sales Persons` },);
        this.set(this.roleNameSalesPersonLanguageItemName, { language: `fi`, value: `Myyntiedustaja` }, { language: `sv`, value: `Försäljare` }, { language: `en`, value: `Sales person` },);
        this.set(this.featureFlagManagementFeatureEnabledHeaderLanguageItemName, { language: `fi`, value: `Aktivoitu` }, { language: `sv`, value: `Aktivera` }, { language: `en`, value: `Enabled` },);
        this.set(this.featureFlagManagementTitleLanguageItemName, { language: `fi`, value: `Feature Flag` }, { language: `sv`, value: `Feature Flag` }, { language: `en`, value: `Feature Flag` },);
        this.set(this.featureFlagsINFOBARLanguageItemName, { language: `fi`, value: `Tiedotuspalkki` }, { language: `sv`, value: `Informationsfält` }, { language: `en`, value: `Information bar` },);
        this.set(this.featureFlagsAPPLICATIONUPDATEDLanguageItemName, { language: `fi`, value: `Näytä sovellus päivitetty teksti` }, { language: `sv`, value: `Visa applikationens uppdaterade text` }, { language: `en`, value: `Show application updated text` },);
        this.set(this.knownSettingsApplicationUpdatedTextLanguageItemName, { language: `fi`, value: `Sovellus päivitetty teksti` }, { language: `sv`, value: `Appen uppdaterad text` }, { language: `en`, value: `Application updated text` },);
        this.set(this.knownSettingsInfoBarTextLanguageItemName, { language: `fi`, value: `Sovelluksen päivitys tulossa teksti` }, { language: `sv`, value: `Informationsfältets text` }, { language: `en`, value: `Information bar text` },);
        this.set(this.knownSettingsAlarmJobPriceLanguageItemName, { language: `fi`, value: `Hälytystyön hinta` }, { language: `sv`, value: `Pris för akutjobb` }, { language: `en`, value: `Alarm job price` },);
        this.set(this.errorPageUserNameLanguageItemName, { language: `fi`, value: `Käyttäjänimi ` }, { language: `sv`, value: `Användarnamn ` }, { language: `en`, value: `Username ` },);
        this.set(this.errorPageRequestIdLanguageItemName, { language: `fi`, value: `Tunniste ` }, { language: `sv`, value: `Identifierare ` }, { language: `en`, value: `Identifier ` },);
        this.set(this.errorPageDateAndTimeLanguageItemName, { language: `fi`, value: `Aika ja päivä ` }, { language: `sv`, value: `Datum och tid ` }, { language: `en`, value: `Date and time ` },);
        this.set(this.offlinePageBodyLanguageItemName, { language: `fi`, value: `Näyttää siltä, että sinulla ei ole tällä hetkellä toimivaa internetyhteyttä.` }, { language: `sv`, value: `Det verkar som att du inte har en fungerande internetanslutning.` }, { language: `en`, value: `It looks like you don't have a working internet connection at the moment.` },);
        this.set(this.offlinePageTitleLanguageItemName, { language: `fi`, value: `Ei internetyhteyttä` }, { language: `sv`, value: `Ingen internetuppkoppling` }, { language: `en`, value: `No internet connection` },);
        this.set(this.copyWorkOrderConfirmationLanguageItemName, { language: `fi`, value: `Luodaanko kopio työtilauksesta?` }, { language: `sv`, value: `Skapa en kopia av arbetsordern?` }, { language: `en`, value: `Create a copy of the work order?` },);
        this.set(this.catalogManagementErrorMessageRestoreCategoryNotExistsLanguageItemName, { language: `fi`, value: `Kategoria ei voida palauttaa. Kategoria tunnuksella '{0}' ei löydy.` }, { language: `sv`, value: `Kategori kan inte återställas. Kategori med id '{0}' finns inte.` }, { language: `en`, value: `Category cannot be restored. Category with id '{0}' does not exist.` },);
        this.set(this.catalogFlyoutMessageCategoryMarkedAsDeletedLanguageItemName, { language: `fi`, value: `Kategoria '{0}' merkitty poistetuksi.` }, { language: `sv`, value: `Kategori '{0}' markerad som raderad.` }, { language: `en`, value: `Category '{0}' marked as deleted.` },);
        this.set(this.catalogFlyoutMessageCategoryRestoredLanguageItemName, { language: `fi`, value: `Kategoria '{0}' palautettu.` }, { language: `sv`, value: `Kategori '{0}' återställs framgångsrikt.` }, { language: `en`, value: `Category '{0}' successfully restored.` },);
        this.set(this.workOrdersButtonMyWorkOrdersLanguageItemName, { language: `fi`, value: `Työmääräykseni` }, { language: `sv`, value: `Mina arbetsorder` }, { language: `en`, value: `My Work Orders` },);
        this.set(this.rentaTasksDashboardRouteWidgetCurrentTaskLanguageItemName, { language: `fi`, value: `Nykyinen tehtävä` }, { language: `sv`, value: `Aktuell uppgift` }, { language: `en`, value: `Current task` },);
        this.set(this.dailyHoursModalMountersAssignedLanguageItemName, { language: `fi`, value: `Määrätyt kiinnikkeet` }, { language: `sv`, value: `Tilldelade montörer` }, { language: `en`, value: `Assigned mounters` },);
        this.set(this.constructionSitesAgreementsBrokenAgreementsLanguageItemName, { language: `fi`, value: `Seuraavia liitteitä ei voitu ladata` }, { language: `sv`, value: `Följande bilagor kunde inte laddas upp` }, { language: `en`, value: `The following attachments could not be uploaded` },);
        this.set(this.topNavWorkOrderCreationRequestsLanguageItemName, { language: `fi`, value: `Työtilauspyynnöt` }, { language: `sv`, value: `Arbetsorderförfrågningar` }, { language: `en`, value: `Work order requests` },);
        this.set(this.enumCalendarUnitTimeTwoWeeksLanguageItemName, { language: `fi`, value: `2 viikkoa` }, { language: `sv`, value: `2 veckor` }, { language: `en`, value: `2 weeks` },);
        this.set(this.productItemProductDefaultExternalIdLanguageItemName, { language: `fi`, value: `Oletusulkoinen tunnus` }, { language: `sv`, value: `Externt standard-id` }, { language: `en`, value: `Default External Id` },);
    }

    /**
    /* "Widget.RentaLink.Label" (Renta Oy Portal)
    */
    public get widgetRentaLinkLabel() : string {
        return this.get(this.widgetRentaLinkLabelLanguageItemName);
    }

    /**
    /* "LoginPage.SsoButton" (Office 365)
    */
    public get loginPageSsoButton() : string {
        return this.get(this.loginPageSsoButtonLanguageItemName);
    }

    /**
    /* "DayOfWeek.Sunday" (Sunday)
    */
    public get dayOfWeekSunday() : string {
        return this.get(this.dayOfWeekSundayLanguageItemName);
    }

    /**
    /* "DayOfWeek.Monday" (Monday)
    */
    public get dayOfWeekMonday() : string {
        return this.get(this.dayOfWeekMondayLanguageItemName);
    }

    /**
    /* "DayOfWeek.Tuesday" (Tuesday)
    */
    public get dayOfWeekTuesday() : string {
        return this.get(this.dayOfWeekTuesdayLanguageItemName);
    }

    /**
    /* "DayOfWeek.Wednesday" (Wednesday)
    */
    public get dayOfWeekWednesday() : string {
        return this.get(this.dayOfWeekWednesdayLanguageItemName);
    }

    /**
    /* "DayOfWeek.Thursday" (Thursday)
    */
    public get dayOfWeekThursday() : string {
        return this.get(this.dayOfWeekThursdayLanguageItemName);
    }

    /**
    /* "DayOfWeek.Friday" (Friday)
    */
    public get dayOfWeekFriday() : string {
        return this.get(this.dayOfWeekFridayLanguageItemName);
    }

    /**
    /* "DayOfWeek.Saturday" (Saturday)
    */
    public get dayOfWeekSaturday() : string {
        return this.get(this.dayOfWeekSaturdayLanguageItemName);
    }

    /**
    /* "TopNav.Frontpage" (Frontpage)
    */
    public get topNavFrontpage() : string {
        return this.get(this.topNavFrontpageLanguageItemName);
    }

    /**
    /* "Widget.NewSite.Label" (New site)
    */
    public get widgetNewSiteLabel() : string {
        return this.get(this.widgetNewSiteLabelLanguageItemName);
    }

    /**
    /* "TopNav.Login" (Login)
    */
    public get topNavLogin() : string {
        return this.get(this.topNavLoginLanguageItemName);
    }

    /**
    /* "TopNav.Employees" (Employees)
    */
    public get topNavEmployees() : string {
        return this.get(this.topNavEmployeesLanguageItemName);
    }

    /**
    /* "TopNav.Warehouse" (Warehouses)
    */
    public get topNavWarehouse() : string {
        return this.get(this.topNavWarehouseLanguageItemName);
    }

    /**
    /* "TopNav.ConstructionSites" (Construction sites)
    */
    public get topNavConstructionSites() : string {
        return this.get(this.topNavConstructionSitesLanguageItemName);
    }

    /**
    /* "TopNav.Invoices" (Invoices)
    */
    public get topNavInvoices() : string {
        return this.get(this.topNavInvoicesLanguageItemName);
    }

    /**
    /* "TopNav.WorkReports" (Work reports)
    */
    public get topNavWorkReports() : string {
        return this.get(this.topNavWorkReportsLanguageItemName);
    }

    /**
    /* "TopNav.Audits" (Audits)
    */
    public get topNavAudits() : string {
        return this.get(this.topNavAuditsLanguageItemName);
    }

    /**
    /* "TopNav.Admin" (Admin)
    */
    public get topNavAdmin() : string {
        return this.get(this.topNavAdminLanguageItemName);
    }

    /**
    /* "TopNav.Account" (Account)
    */
    public get topNavAccount() : string {
        return this.get(this.topNavAccountLanguageItemName);
    }

    /**
    /* "TopNav.Logout" (Logout)
    */
    public get topNavLogout() : string {
        return this.get(this.topNavLogoutLanguageItemName);
    }

    /**
    /* "Widget.ConstructionSites.Label" (Construction sites)
    */
    public get widgetConstructionSitesLabel() : string {
        return this.get(this.widgetConstructionSitesLabelLanguageItemName);
    }

    /**
    /* "Widget.ConstructionSites.Description" (Construction sites: {0})
    */
    public get widgetConstructionSitesDescription() : string {
        return this.get(this.widgetConstructionSitesDescriptionLanguageItemName);
    }

    /**
    /* "Widget.NewSite.Description" (Create a construction site)
    */
    public get widgetNewSiteDescription() : string {
        return this.get(this.widgetNewSiteDescriptionLanguageItemName);
    }

    /**
    /* "Widget.NewTask.Label" (New task)
    */
    public get widgetNewTaskLabel() : string {
        return this.get(this.widgetNewTaskLabelLanguageItemName);
    }

    /**
    /* "Widget.NewTask.Description" (Create a task)
    */
    public get widgetNewTaskDescription() : string {
        return this.get(this.widgetNewTaskDescriptionLanguageItemName);
    }

    /**
    /* "Widget.Employees.Description" (Employees: {0})
    */
    public get widgetEmployeesDescription() : string {
        return this.get(this.widgetEmployeesDescriptionLanguageItemName);
    }

    /**
    /* "Widget.Invoices.Description" ({0:C} € / day)
    */
    public get widgetInvoicesDescription() : string {
        return this.get(this.widgetInvoicesDescriptionLanguageItemName);
    }

    /**
    /* "Widget.InvoicingPeriod.Label" (Invoicing period)
    */
    public get widgetInvoicingPeriodLabel() : string {
        return this.get(this.widgetInvoicingPeriodLabelLanguageItemName);
    }

    /**
    /* "Widget.InvoicingPeriod.Description" (Invoicing days left)
    */
    public get widgetInvoicingPeriodDescription() : string {
        return this.get(this.widgetInvoicingPeriodDescriptionLanguageItemName);
    }

    /**
    /* "Widget.BudgetData.Set1Label" (Monthly rent for the last 12 months)
    */
    public get widgetBudgetDataSet1Label() : string {
        return this.get(this.widgetBudgetDataSet1LabelLanguageItemName);
    }

    /**
    /* "Widget.BudgetData.Set2Label" (Monthly rent growing the last 12 months)
    */
    public get widgetBudgetDataSet2Label() : string {
        return this.get(this.widgetBudgetDataSet2LabelLanguageItemName);
    }

    /**
    /* "Widget.MyWorkReports.Label" (My work reports)
    */
    public get widgetMyWorkReportsLabel() : string {
        return this.get(this.widgetMyWorkReportsLabelLanguageItemName);
    }

    /**
    /* "Widget.MyWorkReports.Description" (View all work reports)
    */
    public get widgetMyWorkReportsDescription() : string {
        return this.get(this.widgetMyWorkReportsDescriptionLanguageItemName);
    }

    /**
    /* "Widget.MyInvoices.Label" (My invoices)
    */
    public get widgetMyInvoicesLabel() : string {
        return this.get(this.widgetMyInvoicesLabelLanguageItemName);
    }

    /**
    /* "Widget.MyInvoices.Description" (View all invoices)
    */
    public get widgetMyInvoicesDescription() : string {
        return this.get(this.widgetMyInvoicesDescriptionLanguageItemName);
    }

    /**
    /* "Widget.MyAudits.Label" (My audits)
    */
    public get widgetMyAuditsLabel() : string {
        return this.get(this.widgetMyAuditsLabelLanguageItemName);
    }

    /**
    /* "Widget.MyAudits.Description" (View all audit reports)
    */
    public get widgetMyAuditsDescription() : string {
        return this.get(this.widgetMyAuditsDescriptionLanguageItemName);
    }

    /**
    /* "Widget.RentaLink.Description" (Local machine rental portal)
    */
    public get widgetRentaLinkDescription() : string {
        return this.get(this.widgetRentaLinkDescriptionLanguageItemName);
    }

    /**
    /* "Widget.Login.Description" (Log in\n)
    */
    public get widgetLoginDescription() : string {
        return this.get(this.widgetLoginDescriptionLanguageItemName);
    }

    /**
    /* "Validators.Email" (Email must be a proper email form)
    */
    public get validatorsEmail() : string {
        return this.get(this.validatorsEmailLanguageItemName);
    }

    /**
    /* "Validators.Password" (Password must contain at least 1 lowercase, 1 uppercase character, 1 special character and be at least 8 characters long)
    */
    public get validatorsPassword() : string {
        return this.get(this.validatorsPasswordLanguageItemName);
    }

    /**
    /* "Validators.Phone" (Incorrect phone number.)
    */
    public get validatorsPhone() : string {
        return this.get(this.validatorsPhoneLanguageItemName);
    }

    /**
    /* "Validators.Required" ({0} is required)
    */
    public get validatorsRequired() : string {
        return this.get(this.validatorsRequiredLanguageItemName);
    }

    /**
    /* "Validators.NumberRange" (Value must be in range {0} - {1}.)
    */
    public get validatorsNumberRange() : string {
        return this.get(this.validatorsNumberRangeLanguageItemName);
    }

    /**
    /* "LoginPage.LoginButton" (Login)
    */
    public get loginPageLoginButton() : string {
        return this.get(this.loginPageLoginButtonLanguageItemName);
    }

    /**
    /* "LoginPage.ForgotPasswordButton" (Forgot password?)
    */
    public get loginPageForgotPasswordButton() : string {
        return this.get(this.loginPageForgotPasswordButtonLanguageItemName);
    }

    /**
    /* "LoginPage.EmailInput" (Email)
    */
    public get loginPageEmailInput() : string {
        return this.get(this.loginPageEmailInputLanguageItemName);
    }

    /**
    /* "LoginPage.PasswordInput" (Password)
    */
    public get loginPagePasswordInput() : string {
        return this.get(this.loginPagePasswordInputLanguageItemName);
    }

    /**
    /* "LoginPage.Title" (Log in.)
    */
    public get loginPageTitle() : string {
        return this.get(this.loginPageTitleLanguageItemName);
    }

    /**
    /* "LoginPage.Subtitle" (Log in with your username and password.)
    */
    public get loginPageSubtitle() : string {
        return this.get(this.loginPageSubtitleLanguageItemName);
    }

    /**
    /* "Enum.LoginResultStatus.NotFound" (Invalid username or password.)
    */
    public get enumLoginResultStatusNotFound() : string {
        return this.get(this.enumLoginResultStatusNotFoundLanguageItemName);
    }

    /**
    /* "Enum.LoginResultStatus.Deleted" (Your account has been deleted. Contact support to restore your access.)
    */
    public get enumLoginResultStatusDeleted() : string {
        return this.get(this.enumLoginResultStatusDeletedLanguageItemName);
    }

    /**
    /* "Enum.LoginResultStatus.Locked" (Too many login attempts. Try again later.)
    */
    public get enumLoginResultStatusLocked() : string {
        return this.get(this.enumLoginResultStatusLockedLanguageItemName);
    }

    /**
    /* "Enum.LoginResultStatus.Security" (Your account has been locked. Contact support to restore access.)
    */
    public get enumLoginResultStatusSecurity() : string {
        return this.get(this.enumLoginResultStatusSecurityLanguageItemName);
    }

    /**
    /* "ErrorPage.Title" (Error occured)
    */
    public get errorPageTitle() : string {
        return this.get(this.errorPageTitleLanguageItemName);
    }

    /**
    /* "ErrorPage.ErrorMessage" (If this happens again, contact support. When reporting this issue, please also include these information)
    */
    public get errorPageErrorMessage() : string {
        return this.get(this.errorPageErrorMessageLanguageItemName);
    }

    /**
    /* "ErrorPage.ContactSupport" (Contact support)
    */
    public get errorPageContactSupport() : string {
        return this.get(this.errorPageContactSupportLanguageItemName);
    }

    /**
    /* "ContactSupportPage.Title" (Message to support team)
    */
    public get contactSupportPageTitle() : string {
        return this.get(this.contactSupportPageTitleLanguageItemName);
    }

    /**
    /* "Form.Input.Email" (Email)
    */
    public get formInputEmail() : string {
        return this.get(this.formInputEmailLanguageItemName);
    }

    /**
    /* "Form.Input.ReceiverEmail" (Receiver email)
    */
    public get formInputReceiverEmail() : string {
        return this.get(this.formInputReceiverEmailLanguageItemName);
    }

    /**
    /* "Form.Input.Phone" (Phone number)
    */
    public get formInputPhone() : string {
        return this.get(this.formInputPhoneLanguageItemName);
    }

    /**
    /* "Form.Input.Firstname" (Firstname)
    */
    public get formInputFirstname() : string {
        return this.get(this.formInputFirstnameLanguageItemName);
    }

    /**
    /* "Form.Input.Lastname" (Lastname)
    */
    public get formInputLastname() : string {
        return this.get(this.formInputLastnameLanguageItemName);
    }

    /**
    /* "Form.Input.Message" (Message)
    */
    public get formInputMessage() : string {
        return this.get(this.formInputMessageLanguageItemName);
    }

    /**
    /* "Form.Input.Street" (Street)
    */
    public get formInputStreet() : string {
        return this.get(this.formInputStreetLanguageItemName);
    }

    /**
    /* "Form.Send" (Send)
    */
    public get formSend() : string {
        return this.get(this.formSendLanguageItemName);
    }

    /**
    /* "TopNav.ContactSupport" (Support)
    */
    public get topNavContactSupport() : string {
        return this.get(this.topNavContactSupportLanguageItemName);
    }

    /**
    /* "TopNav.WorkOrders" (Work orders)
    */
    public get topNavWorkOrders() : string {
        return this.get(this.topNavWorkOrdersLanguageItemName);
    }

    /**
    /* "RentaTasks.Dashboard.QRCode" (QR code)
    */
    public get rentaTasksDashboardQRCode() : string {
        return this.get(this.rentaTasksDashboardQRCodeLanguageItemName);
    }

    /**
    /* "RentaTasks.Dashboard.QRCodeDescription" (Scan QR code to select construction site)
    */
    public get rentaTasksDashboardQRCodeDescription() : string {
        return this.get(this.rentaTasksDashboardQRCodeDescriptionLanguageItemName);
    }

    /**
    /* "RentaTasks.Dashboard.CheckIn" (Check-in)
    */
    public get rentaTasksDashboardCheckIn() : string {
        return this.get(this.rentaTasksDashboardCheckInLanguageItemName);
    }

    /**
    /* "Enum.DailyAllowance.Meal" (AK)
    */
    public get enumDailyAllowanceMeal() : string {
        return this.get(this.enumDailyAllowanceMealLanguageItemName);
    }

    /**
    /* "Enum.DailyAllowance.Day" (1)
    */
    public get enumDailyAllowanceDay() : string {
        return this.get(this.enumDailyAllowanceDayLanguageItemName);
    }

    /**
    /* "Enum.DailyAllowance.HalfDay" (1/2)
    */
    public get enumDailyAllowanceHalfDay() : string {
        return this.get(this.enumDailyAllowanceHalfDayLanguageItemName);
    }

    /**
    /* "Enum.DailyAllowance.Meal.Description" (Full day with \nmeal)
    */
    public get enumDailyAllowanceMealDescription() : string {
        return this.get(this.enumDailyAllowanceMealDescriptionLanguageItemName);
    }

    /**
    /* "Enum.DailyAllowance.Day.Description" (Full day)
    */
    public get enumDailyAllowanceDayDescription() : string {
        return this.get(this.enumDailyAllowanceDayDescriptionLanguageItemName);
    }

    /**
    /* "Enum.DailyAllowance.HalfDay.Description" (Half of the day)
    */
    public get enumDailyAllowanceHalfDayDescription() : string {
        return this.get(this.enumDailyAllowanceHalfDayDescriptionLanguageItemName);
    }

    /**
    /* "Component.Dropdown.NothingSelected" (Nothing is selected)
    */
    public get componentDropdownNothingSelected() : string {
        return this.get(this.componentDropdownNothingSelectedLanguageItemName);
    }

    /**
    /* "Component.Dropdown.MultipleSelected" ({0} selected)
    */
    public get componentDropdownMultipleSelected() : string {
        return this.get(this.componentDropdownMultipleSelectedLanguageItemName);
    }

    /**
    /* "Dropdown.Group.Warehouses" (Warehouses)
    */
    public get dropdownGroupWarehouses() : string {
        return this.get(this.dropdownGroupWarehousesLanguageItemName);
    }

    /**
    /* "Dropdown.Group.ConstructionSites" (Construction sites)
    */
    public get dropdownGroupConstructionSites() : string {
        return this.get(this.dropdownGroupConstructionSitesLanguageItemName);
    }

    /**
    /* "RentaTasks.Dashboard.SignIn" (Sign-in)
    */
    public get rentaTasksDashboardSignIn() : string {
        return this.get(this.rentaTasksDashboardSignInLanguageItemName);
    }

    /**
    /* "Form.Input.Address" (Address)
    */
    public get formInputAddress() : string {
        return this.get(this.formInputAddressLanguageItemName);
    }

    /**
    /* "Form.Input.City" (City)
    */
    public get formInputCity() : string {
        return this.get(this.formInputCityLanguageItemName);
    }

    /**
    /* "Form.Input.Postalcode" (Postal code)
    */
    public get formInputPostalcode() : string {
        return this.get(this.formInputPostalcodeLanguageItemName);
    }

    /**
    /* "Form.Input.Language" (Language)
    */
    public get formInputLanguage() : string {
        return this.get(this.formInputLanguageLanguageItemName);
    }

    /**
    /* "Form.Save" (Save)
    */
    public get formSave() : string {
        return this.get(this.formSaveLanguageItemName);
    }

    /**
    /* "Component.Dropdown.NoItems" (No items found)
    */
    public get componentDropdownNoItems() : string {
        return this.get(this.componentDropdownNoItemsLanguageItemName);
    }

    /**
    /* "Component.Dropdown.NoData" (No data)
    */
    public get componentDropdownNoData() : string {
        return this.get(this.componentDropdownNoDataLanguageItemName);
    }

    /**
    /* "Component.Dropdown.FilterResults" (Filter results)
    */
    public get componentDropdownFilterResults() : string {
        return this.get(this.componentDropdownFilterResultsLanguageItemName);
    }

    /**
    /* "Component.Dropdown.GetResults" (Start typing to get results)
    */
    public get componentDropdownGetResults() : string {
        return this.get(this.componentDropdownGetResultsLanguageItemName);
    }

    /**
    /* "LoginPage.Sso.UserNotFound" (Login failed, user not found.)
    */
    public get loginPageSsoUserNotFound() : string {
        return this.get(this.loginPageSsoUserNotFoundLanguageItemName);
    }

    /**
    /* "MyAccountPage.Title" (My account)
    */
    public get myAccountPageTitle() : string {
        return this.get(this.myAccountPageTitleLanguageItemName);
    }

    /**
    /* "LoginPage.Sso.Failed" (Login failed, contact support to solve the issue.)
    */
    public get loginPageSsoFailed() : string {
        return this.get(this.loginPageSsoFailedLanguageItemName);
    }

    /**
    /* "Enum.CustomerApprovalType.Email" (By email)
    */
    public get enumCustomerApprovalTypeEmail() : string {
        return this.get(this.enumCustomerApprovalTypeEmailLanguageItemName);
    }

    /**
    /* "Enum.CustomerApprovalType.Phone" (By phone)
    */
    public get enumCustomerApprovalTypePhone() : string {
        return this.get(this.enumCustomerApprovalTypePhoneLanguageItemName);
    }

    /**
    /* "Enum.CustomerApprovalType.Phone.Description" (Report already approved by customer by phone)
    */
    public get enumCustomerApprovalTypePhoneDescription() : string {
        return this.get(this.enumCustomerApprovalTypePhoneDescriptionLanguageItemName);
    }

    /**
    /* "Enum.CustomerApprovalType.Email.Description" (Report will be approved by customer through email)
    */
    public get enumCustomerApprovalTypeEmailDescription() : string {
        return this.get(this.enumCustomerApprovalTypeEmailDescriptionLanguageItemName);
    }

    /**
    /* "Enum.CustomerApprovalType.Signature" (Customer signature)
    */
    public get enumCustomerApprovalTypeSignature() : string {
        return this.get(this.enumCustomerApprovalTypeSignatureLanguageItemName);
    }

    /**
    /* "Enum.CustomerApprovalType.Signature.Description" (Customer can sign report in the application)
    */
    public get enumCustomerApprovalTypeSignatureDescription() : string {
        return this.get(this.enumCustomerApprovalTypeSignatureDescriptionLanguageItemName);
    }

    /**
    /* "Enum.DailyAllowance.None" (0)
    */
    public get enumDailyAllowanceNone() : string {
        return this.get(this.enumDailyAllowanceNoneLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentType.CraneCertificate" (Crane certificate)
    */
    public get enumUserDocumentTypeCraneCertificate() : string {
        return this.get(this.enumUserDocumentTypeCraneCertificateLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentType.DrivingLicence" (Driving licence)
    */
    public get enumUserDocumentTypeDrivingLicence() : string {
        return this.get(this.enumUserDocumentTypeDrivingLicenceLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentType.ElectricalSafetyCard" (Electrical safety card)
    */
    public get enumUserDocumentTypeElectricalSafetyCard() : string {
        return this.get(this.enumUserDocumentTypeElectricalSafetyCardLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentType.FireWorkCard" (Fire work card)
    */
    public get enumUserDocumentTypeFireWorkCard() : string {
        return this.get(this.enumUserDocumentTypeFireWorkCardLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentType.FirstAidCard" (First aid card)
    */
    public get enumUserDocumentTypeFirstAidCard() : string {
        return this.get(this.enumUserDocumentTypeFirstAidCardLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentType.ForkliftCard" (Forklift card)
    */
    public get enumUserDocumentTypeForkliftCard() : string {
        return this.get(this.enumUserDocumentTypeForkliftCardLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentType.IdCard" (Worker id card)
    */
    public get enumUserDocumentTypeIdCard() : string {
        return this.get(this.enumUserDocumentTypeIdCardLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentType.LifterCard" (Lifter card)
    */
    public get enumUserDocumentTypeLifterCard() : string {
        return this.get(this.enumUserDocumentTypeLifterCardLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentType.RoadSafetyCard" (Road safety card)
    */
    public get enumUserDocumentTypeRoadSafetyCard() : string {
        return this.get(this.enumUserDocumentTypeRoadSafetyCardLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentType.RoofFireWorkCard" (Roof fire work card)
    */
    public get enumUserDocumentTypeRoofFireWorkCard() : string {
        return this.get(this.enumUserDocumentTypeRoofFireWorkCardLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentType.WetRoomCertificate" (Wet room certificate)
    */
    public get enumUserDocumentTypeWetRoomCertificate() : string {
        return this.get(this.enumUserDocumentTypeWetRoomCertificateLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentType.WorkSafetyCard" (Work safety card)
    */
    public get enumUserDocumentTypeWorkSafetyCard() : string {
        return this.get(this.enumUserDocumentTypeWorkSafetyCardLanguageItemName);
    }

    /**
    /* "Enum.ModuleModel.Undefined" (---)
    */
    public get enumModuleModelUndefined() : string {
        return this.get(this.enumModuleModelUndefinedLanguageItemName);
    }

    /**
    /* "Enum.ModuleModel.Module" (Module)
    */
    public get enumModuleModelModule() : string {
        return this.get(this.enumModuleModelModuleLanguageItemName);
    }

    /**
    /* "Enum.ModuleModel.PerimeterFrame" (Perimeter frame)
    */
    public get enumModuleModelPerimeterFrame() : string {
        return this.get(this.enumModuleModelPerimeterFrameLanguageItemName);
    }

    /**
    /* "Enum.ModuleModel.WeatherShelter" (Weather shelter)
    */
    public get enumModuleModelWeatherShelter() : string {
        return this.get(this.enumModuleModelWeatherShelterLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentLevel.First" (First)
    */
    public get enumUserDocumentLevelFirst() : string {
        return this.get(this.enumUserDocumentLevelFirstLanguageItemName);
    }

    /**
    /* "Enum.UserDocumentLevel.Second" (Second)
    */
    public get enumUserDocumentLevelSecond() : string {
        return this.get(this.enumUserDocumentLevelSecondLanguageItemName);
    }

    /**
    /* "Form.Input.File.DragAndDrop" (Drag'n'drop file here, or click to select)
    */
    public get formInputFileDragAndDrop() : string {
        return this.get(this.formInputFileDragAndDropLanguageItemName);
    }

    /**
    /* "Form.Input.File.Readonly" (File is readonly)
    */
    public get formInputFileReadonly() : string {
        return this.get(this.formInputFileReadonlyLanguageItemName);
    }

    /**
    /* "Form.Input.File.Preview" (Preview)
    */
    public get formInputFilePreview() : string {
        return this.get(this.formInputFilePreviewLanguageItemName);
    }

    /**
    /* "Form.Input.File.ChooseFiles" (Choose file(s))
    */
    public get formInputFileChooseFiles() : string {
        return this.get(this.formInputFileChooseFilesLanguageItemName);
    }

    /**
    /* "UserDocument.Subtitle" (Upload document or modify the existing)
    */
    public get userDocumentSubtitle() : string {
        return this.get(this.userDocumentSubtitleLanguageItemName);
    }

    /**
    /* "UserDocument.Title" (User document)
    */
    public get userDocumentTitle() : string {
        return this.get(this.userDocumentTitleLanguageItemName);
    }

    /**
    /* "UserDocument.Send.HelpText" (Send user document by email)
    */
    public get userDocumentSendHelpText() : string {
        return this.get(this.userDocumentSendHelpTextLanguageItemName);
    }

    /**
    /* "UserDocument.Send.Button" (Send document)
    */
    public get userDocumentSendButton() : string {
        return this.get(this.userDocumentSendButtonLanguageItemName);
    }

    /**
    /* "UserDocument.ValidThru" (Valid thru)
    */
    public get userDocumentValidThru() : string {
        return this.get(this.userDocumentValidThruLanguageItemName);
    }

    /**
    /* "UserDocument.Image" (Document image)
    */
    public get userDocumentImage() : string {
        return this.get(this.userDocumentImageLanguageItemName);
    }

    /**
    /* "UserDocument.Level" (Level)
    */
    public get userDocumentLevel() : string {
        return this.get(this.userDocumentLevelLanguageItemName);
    }

    /**
    /* "Enum.DailyAllowance.None.Description" (No daily\nallowance)
    */
    public get enumDailyAllowanceNoneDescription() : string {
        return this.get(this.enumDailyAllowanceNoneDescriptionLanguageItemName);
    }

    /**
    /* "MyAccountPage.Subtitle" ( )
    */
    public get myAccountPageSubtitle() : string {
        return this.get(this.myAccountPageSubtitleLanguageItemName);
    }

    /**
    /* "UserDocumentSendSuccess" (Document sent successfully)
    */
    public get userDocumentSendSuccess() : string {
        return this.get(this.userDocumentSendSuccessLanguageItemName);
    }

    /**
    /* "Generic.AccessDenied" (Access denied)
    */
    public get genericAccessDenied() : string {
        return this.get(this.genericAccessDeniedLanguageItemName);
    }

    /**
    /* "Generic.DataSaved" (Saved successfully)
    */
    public get genericDataSaved() : string {
        return this.get(this.genericDataSavedLanguageItemName);
    }

    /**
    /* "ResetPassword.PageTitle" (Set new password for your account)
    */
    public get resetPasswordPageTitle() : string {
        return this.get(this.resetPasswordPageTitleLanguageItemName);
    }

    /**
    /* "ResetPassword.ConfirmPasswordInput" (Confirm password)
    */
    public get resetPasswordConfirmPasswordInput() : string {
        return this.get(this.resetPasswordConfirmPasswordInputLanguageItemName);
    }

    /**
    /* "ResetPassword.PasswordsDontMatchMessage" (Passwords don't match)
    */
    public get resetPasswordPasswordsDontMatchMessage() : string {
        return this.get(this.resetPasswordPasswordsDontMatchMessageLanguageItemName);
    }

    /**
    /* "ResetPassword.SuccessMessage" (Password set successfully)
    */
    public get resetPasswordSuccessMessage() : string {
        return this.get(this.resetPasswordSuccessMessageLanguageItemName);
    }

    /**
    /* "ResetPassword.SuccessMessageAndInfo" (Password set successfully. You must accept terms of usage and privacy notice in order to use application.)
    */
    public get resetPasswordSuccessMessageAndInfo() : string {
        return this.get(this.resetPasswordSuccessMessageAndInfoLanguageItemName);
    }

    /**
    /* "ChangePassword.CurrentPassword" (Current password)
    */
    public get changePasswordCurrentPassword() : string {
        return this.get(this.changePasswordCurrentPasswordLanguageItemName);
    }

    /**
    /* "ChangePassword.PageTitle" (Change password)
    */
    public get changePasswordPageTitle() : string {
        return this.get(this.changePasswordPageTitleLanguageItemName);
    }

    /**
    /* "ChangePassword.Button" (Change password)
    */
    public get changePasswordButton() : string {
        return this.get(this.changePasswordButtonLanguageItemName);
    }

    /**
    /* "ChangePassword.NewPassword" (New password)
    */
    public get changePasswordNewPassword() : string {
        return this.get(this.changePasswordNewPasswordLanguageItemName);
    }

    /**
    /* "RoleName.ScaffoldingMounter" (Scaffolding mounter)
    */
    public get roleNameScaffoldingMounter() : string {
        return this.get(this.roleNameScaffoldingMounterLanguageItemName);
    }

    /**
    /* "RoleName.Mounter" (RTP mounter)
    */
    public get roleNameMounter() : string {
        return this.get(this.roleNameMounterLanguageItemName);
    }

    /**
    /* "RoleName.ScaffoldingHeadMounter" (Scaffolding head mounter)
    */
    public get roleNameScaffoldingHeadMounter() : string {
        return this.get(this.roleNameScaffoldingHeadMounterLanguageItemName);
    }

    /**
    /* "RoleName.StpHeadMounter" (RTP head mounter)
    */
    public get roleNameStpHeadMounter() : string {
        return this.get(this.roleNameStpHeadMounterLanguageItemName);
    }

    /**
    /* "RoleName.ScaffoldingManager" (Scaffolding manager)
    */
    public get roleNameScaffoldingManager() : string {
        return this.get(this.roleNameScaffoldingManagerLanguageItemName);
    }

    /**
    /* "RoleName.StpManager" (RTP manager)
    */
    public get roleNameStpManager() : string {
        return this.get(this.roleNameStpManagerLanguageItemName);
    }

    /**
    /* "RoleName.ScaffoldingAdmin" (Scaffolding admin)
    */
    public get roleNameScaffoldingAdmin() : string {
        return this.get(this.roleNameScaffoldingAdminLanguageItemName);
    }

    /**
    /* "RoleName.StpAdmin" (RTP admin)
    */
    public get roleNameStpAdmin() : string {
        return this.get(this.roleNameStpAdminLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.HasActiveTasks" (Has active tasks)
    */
    public get enumWorkOrderStatusHasActiveTasks() : string {
        return this.get(this.enumWorkOrderStatusHasActiveTasksLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.WorkReportNotSent" (Work report not sent)
    */
    public get enumWorkOrderStatusWorkReportNotSent() : string {
        return this.get(this.enumWorkOrderStatusWorkReportNotSentLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.WorkReportNotApprovedByCustomer" (Pending customer approval)
    */
    public get enumWorkOrderStatusWorkReportNotApprovedByCustomer() : string {
        return this.get(this.enumWorkOrderStatusWorkReportNotApprovedByCustomerLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.TaskNotApprovedByManager" (Pending manager approval)
    */
    public get enumWorkOrderStatusTaskNotApprovedByManager() : string {
        return this.get(this.enumWorkOrderStatusTaskNotApprovedByManagerLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.InvoiceRowsNotApprovedNyManager" (Pending invoice row approval)
    */
    public get enumWorkOrderStatusInvoiceRowsNotApprovedNyManager() : string {
        return this.get(this.enumWorkOrderStatusInvoiceRowsNotApprovedNyManagerLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.InvoiceNotCreated" (Not billed)
    */
    public get enumWorkOrderStatusInvoiceNotCreated() : string {
        return this.get(this.enumWorkOrderStatusInvoiceNotCreatedLanguageItemName);
    }

    /**
    /* "Enum.TaxRate.Rate0" (0%)
    */
    public get enumTaxRateRate0() : string {
        return this.get(this.enumTaxRateRate0LanguageItemName);
    }

    /**
    /* "Enum.TaxRate.Rate10" (10%)
    */
    public get enumTaxRateRate10() : string {
        return this.get(this.enumTaxRateRate10LanguageItemName);
    }

    /**
    /* "Enum.TaxRate.Rate14" (14%)
    */
    public get enumTaxRateRate14() : string {
        return this.get(this.enumTaxRateRate14LanguageItemName);
    }

    /**
    /* "Enum.TaxRate.Rate24" (24%)
    */
    public get enumTaxRateRate24() : string {
        return this.get(this.enumTaxRateRate24LanguageItemName);
    }

    /**
    /* "UserManagement.AddUser" (Add user)
    */
    public get userManagementAddUser() : string {
        return this.get(this.userManagementAddUserLanguageItemName);
    }

    /**
    /* "UserManagement.Button.AddNewSubcontractor" (Add new subcontractor)
    */
    public get userManagementButtonAddNewSubcontractor() : string {
        return this.get(this.userManagementButtonAddNewSubcontractorLanguageItemName);
    }

    /**
    /* "UserManagement.Settings.Tab" (Settings)
    */
    public get userManagementSettingsTab() : string {
        return this.get(this.userManagementSettingsTabLanguageItemName);
    }

    /**
    /* "UserManagement.SettingsSaved" (Settings saved)
    */
    public get userManagementSettingsSaved() : string {
        return this.get(this.userManagementSettingsSavedLanguageItemName);
    }

    /**
    /* "UserManagement.Users.Tab" (Users)
    */
    public get userManagementUsersTab() : string {
        return this.get(this.userManagementUsersTabLanguageItemName);
    }

    /**
    /* "UserManagement.AlertMessage.UnlockUser" (User account "{0}" unlocked successfully.)
    */
    public get userManagementAlertMessageUnlockUser() : string {
        return this.get(this.userManagementAlertMessageUnlockUserLanguageItemName);
    }

    /**
    /* "UserManagement.ConfirmationButton.UnlockUser" (Are you sure you want to unlock user "{0}"?)
    */
    public get userManagementConfirmationButtonUnlockUser() : string {
        return this.get(this.userManagementConfirmationButtonUnlockUserLanguageItemName);
    }

    /**
    /* "UserManagement.ConfirmationButton.DeleteUser" (Are you sure you want to delete user "{0}"?)
    */
    public get userManagementConfirmationButtonDeleteUser() : string {
        return this.get(this.userManagementConfirmationButtonDeleteUserLanguageItemName);
    }

    /**
    /* "UserManagement.ConfirmationButton.RestoreUser" (Are you sure you want to restore user "{0}"?)
    */
    public get userManagementConfirmationButtonRestoreUser() : string {
        return this.get(this.userManagementConfirmationButtonRestoreUserLanguageItemName);
    }

    /**
    /* "Enum.BusinessArea.Scaffolding" (Scaffolding)
    */
    public get enumBusinessAreaScaffolding() : string {
        return this.get(this.enumBusinessAreaScaffoldingLanguageItemName);
    }

    /**
    /* "Enum.BusinessArea.Stp" (Stp)
    */
    public get enumBusinessAreaStp() : string {
        return this.get(this.enumBusinessAreaStpLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteStatus.Active" (Active)
    */
    public get enumConstructionSiteStatusActive() : string {
        return this.get(this.enumConstructionSiteStatusActiveLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteStatus.Active.Description" (Under construction)
    */
    public get enumConstructionSiteStatusActiveDescription() : string {
        return this.get(this.enumConstructionSiteStatusActiveDescriptionLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteStatus.Closed.Description" (Construction is completed or not started yet)
    */
    public get enumConstructionSiteStatusClosedDescription() : string {
        return this.get(this.enumConstructionSiteStatusClosedDescriptionLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteStatus.Inactive" (Inactive)
    */
    public get enumConstructionSiteStatusInactive() : string {
        return this.get(this.enumConstructionSiteStatusInactiveLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteStatus.Inactive.Description" (Construction is frozen)
    */
    public get enumConstructionSiteStatusInactiveDescription() : string {
        return this.get(this.enumConstructionSiteStatusInactiveDescriptionLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteStatus.Closed" (Closed)
    */
    public get enumConstructionSiteStatusClosed() : string {
        return this.get(this.enumConstructionSiteStatusClosedLanguageItemName);
    }

    /**
    /* "Enum.ContractTaskType.Assembly" (Assembly)
    */
    public get enumContractTaskTypeAssembly() : string {
        return this.get(this.enumContractTaskTypeAssemblyLanguageItemName);
    }

    /**
    /* "Enum.ContractTaskType.Covering" (Covering)
    */
    public get enumContractTaskTypeCovering() : string {
        return this.get(this.enumContractTaskTypeCoveringLanguageItemName);
    }

    /**
    /* "Enum.ContractTaskType.Delivery" (Delivery)
    */
    public get enumContractTaskTypeDelivery() : string {
        return this.get(this.enumContractTaskTypeDeliveryLanguageItemName);
    }

    /**
    /* "Enum.ContractTaskType.Dismantle" (Dismantle)
    */
    public get enumContractTaskTypeDismantle() : string {
        return this.get(this.enumContractTaskTypeDismantleLanguageItemName);
    }

    /**
    /* "Enum.ContractTaskType.Return" (Return)
    */
    public get enumContractTaskTypeReturn() : string {
        return this.get(this.enumContractTaskTypeReturnLanguageItemName);
    }

    /**
    /* "Enum.UserRoleGroup.Admins" (Admins)
    */
    public get enumUserRoleGroupAdmins() : string {
        return this.get(this.enumUserRoleGroupAdminsLanguageItemName);
    }

    /**
    /* "Enum.UserRoleGroup.Admins.Description" (Site & business administrators)
    */
    public get enumUserRoleGroupAdminsDescription() : string {
        return this.get(this.enumUserRoleGroupAdminsDescriptionLanguageItemName);
    }

    /**
    /* "Enum.UserRoleGroup.Employees" (Employees)
    */
    public get enumUserRoleGroupEmployees() : string {
        return this.get(this.enumUserRoleGroupEmployeesLanguageItemName);
    }

    /**
    /* "Enum.UserRoleGroup.Employees.Description" (Head mounters, mounters & drivers)
    */
    public get enumUserRoleGroupEmployeesDescription() : string {
        return this.get(this.enumUserRoleGroupEmployeesDescriptionLanguageItemName);
    }

    /**
    /* "Enum.UserRoleGroup.Managers" (Managers)
    */
    public get enumUserRoleGroupManagers() : string {
        return this.get(this.enumUserRoleGroupManagersLanguageItemName);
    }

    /**
    /* "Enum.UserRoleGroup.Managers.Description" (Site managers & contact persons)
    */
    public get enumUserRoleGroupManagersDescription() : string {
        return this.get(this.enumUserRoleGroupManagersDescriptionLanguageItemName);
    }

    /**
    /* "Enum.WorkDayState.Normal" (Normal)
    */
    public get enumWorkDayStateNormal() : string {
        return this.get(this.enumWorkDayStateNormalLanguageItemName);
    }

    /**
    /* "Enum.WorkDayState.Normal.Description" (Normal working day)
    */
    public get enumWorkDayStateNormalDescription() : string {
        return this.get(this.enumWorkDayStateNormalDescriptionLanguageItemName);
    }

    /**
    /* "Enum.WorkDayState.PaidDayOff" (Paid day off)
    */
    public get enumWorkDayStatePaidDayOff() : string {
        return this.get(this.enumWorkDayStatePaidDayOffLanguageItemName);
    }

    /**
    /* "Enum.WorkDayState.PaidDayOff.Description" (Employee has paid day off)
    */
    public get enumWorkDayStatePaidDayOffDescription() : string {
        return this.get(this.enumWorkDayStatePaidDayOffDescriptionLanguageItemName);
    }

    /**
    /* "Enum.WorkDayState.SickLeave" (Sick leave)
    */
    public get enumWorkDayStateSickLeave() : string {
        return this.get(this.enumWorkDayStateSickLeaveLanguageItemName);
    }

    /**
    /* "Enum.WorkDayState.SickLeave.Description" (Employee is on sick leave)
    */
    public get enumWorkDayStateSickLeaveDescription() : string {
        return this.get(this.enumWorkDayStateSickLeaveDescriptionLanguageItemName);
    }

    /**
    /* "Enum.WorkDayState.Vacation" (Vacation)
    */
    public get enumWorkDayStateVacation() : string {
        return this.get(this.enumWorkDayStateVacationLanguageItemName);
    }

    /**
    /* "Enum.WorkDayState.Vacation.Description" (Employee is on vacation)
    */
    public get enumWorkDayStateVacationDescription() : string {
        return this.get(this.enumWorkDayStateVacationDescriptionLanguageItemName);
    }

    /**
    /* "Enum.WorkDayState.WeeklyRest" (Weekly rest)
    */
    public get enumWorkDayStateWeeklyRest() : string {
        return this.get(this.enumWorkDayStateWeeklyRestLanguageItemName);
    }

    /**
    /* "Enum.WorkDayState.WeeklyRest.Description" (Weekly holiday)
    */
    public get enumWorkDayStateWeeklyRestDescription() : string {
        return this.get(this.enumWorkDayStateWeeklyRestDescriptionLanguageItemName);
    }

    /**
    /* "Enum.WorkDayState.FlexHours" (Flex hours)
    */
    public get enumWorkDayStateFlexHours() : string {
        return this.get(this.enumWorkDayStateFlexHoursLanguageItemName);
    }

    /**
    /* "Enum.WorkDayState.FlexHours.Description" (Flex hours)
    */
    public get enumWorkDayStateFlexHoursDescription() : string {
        return this.get(this.enumWorkDayStateFlexHoursDescriptionLanguageItemName);
    }

    /**
    /* "Form.Input.EmployeeNumber" (Employee number)
    */
    public get formInputEmployeeNumber() : string {
        return this.get(this.formInputEmployeeNumberLanguageItemName);
    }

    /**
    /* "Form.Input.Role" (Role)
    */
    public get formInputRole() : string {
        return this.get(this.formInputRoleLanguageItemName);
    }

    /**
    /* "Generic.Action.Cancel" (Cancel)
    */
    public get genericActionCancel() : string {
        return this.get(this.genericActionCancelLanguageItemName);
    }

    /**
    /* "Month.April" (April)
    */
    public get monthApril() : string {
        return this.get(this.monthAprilLanguageItemName);
    }

    /**
    /* "Month.August" (August)
    */
    public get monthAugust() : string {
        return this.get(this.monthAugustLanguageItemName);
    }

    /**
    /* "Month.December" (December)
    */
    public get monthDecember() : string {
        return this.get(this.monthDecemberLanguageItemName);
    }

    /**
    /* "Month.February" (February)
    */
    public get monthFebruary() : string {
        return this.get(this.monthFebruaryLanguageItemName);
    }

    /**
    /* "Month.January" (January)
    */
    public get monthJanuary() : string {
        return this.get(this.monthJanuaryLanguageItemName);
    }

    /**
    /* "Month.July" (July)
    */
    public get monthJuly() : string {
        return this.get(this.monthJulyLanguageItemName);
    }

    /**
    /* "Month.June" (June)
    */
    public get monthJune() : string {
        return this.get(this.monthJuneLanguageItemName);
    }

    /**
    /* "Month.March" (March)
    */
    public get monthMarch() : string {
        return this.get(this.monthMarchLanguageItemName);
    }

    /**
    /* "Month.May" (May)
    */
    public get monthMay() : string {
        return this.get(this.monthMayLanguageItemName);
    }

    /**
    /* "Month.November" (November)
    */
    public get monthNovember() : string {
        return this.get(this.monthNovemberLanguageItemName);
    }

    /**
    /* "Month.October" (October)
    */
    public get monthOctober() : string {
        return this.get(this.monthOctoberLanguageItemName);
    }

    /**
    /* "Month.September" (September)
    */
    public get monthSeptember() : string {
        return this.get(this.monthSeptemberLanguageItemName);
    }

    /**
    /* "RoleName.ContactPerson" (Contact person)
    */
    public get roleNameContactPerson() : string {
        return this.get(this.roleNameContactPersonLanguageItemName);
    }

    /**
    /* "RoleName.ScaffoldingDriver" (Scaffolding driver)
    */
    public get roleNameScaffoldingDriver() : string {
        return this.get(this.roleNameScaffoldingDriverLanguageItemName);
    }

    /**
    /* "RoleName.Admin" (Admin)
    */
    public get roleNameAdmin() : string {
        return this.get(this.roleNameAdminLanguageItemName);
    }

    /**
    /* "RoleName.StpDriver" (RTP driver)
    */
    public get roleNameStpDriver() : string {
        return this.get(this.roleNameStpDriverLanguageItemName);
    }

    /**
    /* "TopNav.ChangePassword" (Change password)
    */
    public get topNavChangePassword() : string {
        return this.get(this.topNavChangePasswordLanguageItemName);
    }

    /**
    /* "Admin.HeaderTitle" (Admin management)
    */
    public get adminHeaderTitle() : string {
        return this.get(this.adminHeaderTitleLanguageItemName);
    }

    /**
    /* "UserManagement.ChooseRole" (Choose a role)
    */
    public get userManagementChooseRole() : string {
        return this.get(this.userManagementChooseRoleLanguageItemName);
    }

    /**
    /* "ConfirmationDialog.AreYouSure" (Are you sure?)
    */
    public get confirmationDialogAreYouSure() : string {
        return this.get(this.confirmationDialogAreYouSureLanguageItemName);
    }

    /**
    /* "ConfirmationDialog.Confirm" (Confirm)
    */
    public get confirmationDialogConfirm() : string {
        return this.get(this.confirmationDialogConfirmLanguageItemName);
    }

    /**
    /* "ConfirmationDialog.Close" (Close)
    */
    public get confirmationDialogClose() : string {
        return this.get(this.confirmationDialogCloseLanguageItemName);
    }

    /**
    /* "Footer.Frontpage" (Frontpage)
    */
    public get footerFrontpage() : string {
        return this.get(this.footerFrontpageLanguageItemName);
    }

    /**
    /* "BaseInput.DocumentTooBig" (Document file is too big)
    */
    public get baseInputDocumentTooBig() : string {
        return this.get(this.baseInputDocumentTooBigLanguageItemName);
    }

    /**
    /* "BaseInput.DocumentTypeNotSupported" (Document type is not supported, choose file with extension {0})
    */
    public get baseInputDocumentTypeNotSupported() : string {
        return this.get(this.baseInputDocumentTypeNotSupportedLanguageItemName);
    }

    /**
    /* "ChangePassword.WeakPasswordMessage" (Password must have one non alphanumeric character, one lowercase ('a'-'z') character, one uppercase ('A'-'Z') character, one number and be at least 8 characters long)
    */
    public get changePasswordWeakPasswordMessage() : string {
        return this.get(this.changePasswordWeakPasswordMessageLanguageItemName);
    }

    /**
    /* "ChangePassword.WrongCurrentMessage" (Wrong current password)
    */
    public get changePasswordWrongCurrentMessage() : string {
        return this.get(this.changePasswordWrongCurrentMessageLanguageItemName);
    }

    /**
    /* "Password.HelpText.Length" (at least 8 characters long)
    */
    public get passwordHelpTextLength() : string {
        return this.get(this.passwordHelpTextLengthLanguageItemName);
    }

    /**
    /* "Password.HelpText.LowerCase" (one lowercase ('a'-'z') character)
    */
    public get passwordHelpTextLowerCase() : string {
        return this.get(this.passwordHelpTextLowerCaseLanguageItemName);
    }

    /**
    /* "Password.HelpText.Number" (one number)
    */
    public get passwordHelpTextNumber() : string {
        return this.get(this.passwordHelpTextNumberLanguageItemName);
    }

    /**
    /* "Password.HelpText.PasswordHints" (Password must have at least:)
    */
    public get passwordHelpTextPasswordHints() : string {
        return this.get(this.passwordHelpTextPasswordHintsLanguageItemName);
    }

    /**
    /* "Password.HelpText.SpecialCharacter" (one non alphanumeric character)
    */
    public get passwordHelpTextSpecialCharacter() : string {
        return this.get(this.passwordHelpTextSpecialCharacterLanguageItemName);
    }

    /**
    /* "Password.HelpText.UpperCase" (one uppercase ('A'-'Z') character)
    */
    public get passwordHelpTextUpperCase() : string {
        return this.get(this.passwordHelpTextUpperCaseLanguageItemName);
    }

    /**
    /* "SendWorkReport.Subtitle" (for approving by email to existing or new contact person)
    */
    public get sendWorkReportSubtitle() : string {
        return this.get(this.sendWorkReportSubtitleLanguageItemName);
    }

    /**
    /* "ForgotPasswordPage.PageTitle" (Forgot password?)
    */
    public get forgotPasswordPagePageTitle() : string {
        return this.get(this.forgotPasswordPagePageTitleLanguageItemName);
    }

    /**
    /* "TopNav.WorkHours" (Work hours)
    */
    public get topNavWorkHours() : string {
        return this.get(this.topNavWorkHoursLanguageItemName);
    }

    /**
    /* "Grid.NoData.WorkReports" (No work reports have been created yet)
    */
    public get gridNoDataWorkReports() : string {
        return this.get(this.gridNoDataWorkReportsLanguageItemName);
    }

    /**
    /* "DocumentPreviewModal.WorkReport.Title" (Work report preview)
    */
    public get documentPreviewModalWorkReportTitle() : string {
        return this.get(this.documentPreviewModalWorkReportTitleLanguageItemName);
    }

    /**
    /* "Component.Footer.Contact" (Contact information)
    */
    public get componentFooterContact() : string {
        return this.get(this.componentFooterContactLanguageItemName);
    }

    /**
    /* "WorkDayPanel.FixedContractCost" (Fixed price, €)
    */
    public get workDayPanelFixedContractCost() : string {
        return this.get(this.workDayPanelFixedContractCostLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.CreateNewReportSubtitle" (And fill it with invoicing material)
    */
    public get addWorkReportModalCreateNewReportSubtitle() : string {
        return this.get(this.addWorkReportModalCreateNewReportSubtitleLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.CreateNewReport" (Create new work report)
    */
    public get addWorkReportModalCreateNewReport() : string {
        return this.get(this.addWorkReportModalCreateNewReportLanguageItemName);
    }

    /**
    /* "AddTaskModal.WorkReport" (Work Report)
    */
    public get addTaskModalWorkReport() : string {
        return this.get(this.addTaskModalWorkReportLanguageItemName);
    }

    /**
    /* "WorkDayPanel.HalfDayAllowance" (Half of the day)
    */
    public get workDayPanelHalfDayAllowance() : string {
        return this.get(this.workDayPanelHalfDayAllowanceLanguageItemName);
    }

    /**
    /* "WorkDayPanel.WorkDayType" (Type)
    */
    public get workDayPanelWorkDayType() : string {
        return this.get(this.workDayPanelWorkDayTypeLanguageItemName);
    }

    /**
    /* "WorkDayPanel.SalaryHours" (Working\nhours)
    */
    public get workDayPanelSalaryHours() : string {
        return this.get(this.workDayPanelSalaryHoursLanguageItemName);
    }

    /**
    /* "WorkDayPanel.SalaryHours.Description" (Hours to be transferred to payroll)
    */
    public get workDayPanelSalaryHoursDescription() : string {
        return this.get(this.workDayPanelSalaryHoursDescriptionLanguageItemName);
    }

    /**
    /* "Component.List.Loading" (Loading...)
    */
    public get componentListLoading() : string {
        return this.get(this.componentListLoadingLanguageItemName);
    }

    /**
    /* "Component.Footer.Frontpage" (Frontpage)
    */
    public get componentFooterFrontpage() : string {
        return this.get(this.componentFooterFrontpageLanguageItemName);
    }

    /**
    /* "DocumentPreviewModal.Invoice.Title" (Work and cost report preview)
    */
    public get documentPreviewModalInvoiceTitle() : string {
        return this.get(this.documentPreviewModalInvoiceTitleLanguageItemName);
    }

    /**
    /* "Grid.NoData.Tasks" (No tasks have been created yet)
    */
    public get gridNoDataTasks() : string {
        return this.get(this.gridNoDataTasksLanguageItemName);
    }

    /**
    /* "Grid.NoData.Modules" (No modules have been created yet)
    */
    public get gridNoDataModules() : string {
        return this.get(this.gridNoDataModulesLanguageItemName);
    }

    /**
    /* "Grid.NoData.InvoiceRows" (No invoice rows have been created yet)
    */
    public get gridNoDataInvoiceRows() : string {
        return this.get(this.gridNoDataInvoiceRowsLanguageItemName);
    }

    /**
    /* "Grid.NoData.Invoices" (No invoices)
    */
    public get gridNoDataInvoices() : string {
        return this.get(this.gridNoDataInvoicesLanguageItemName);
    }

    /**
    /* "Grid.NoItems" (No items)
    */
    public get gridNoItems() : string {
        return this.get(this.gridNoItemsLanguageItemName);
    }

    /**
    /* "Enum.InvoiceRowType.WorkReport" (Work report)
    */
    public get enumInvoiceRowTypeWorkReport() : string {
        return this.get(this.enumInvoiceRowTypeWorkReportLanguageItemName);
    }

    /**
    /* "Enum.InvoiceRowType.WorkReport.Description" (3020)
    */
    public get enumInvoiceRowTypeWorkReportDescription() : string {
        return this.get(this.enumInvoiceRowTypeWorkReportDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceRowType.Rent" (Rent)
    */
    public get enumInvoiceRowTypeRent() : string {
        return this.get(this.enumInvoiceRowTypeRentLanguageItemName);
    }

    /**
    /* "Enum.InvoiceRowType.Rent.Description" (3000)
    */
    public get enumInvoiceRowTypeRentDescription() : string {
        return this.get(this.enumInvoiceRowTypeRentDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceRowType.ExtraRent" (Extra rent)
    */
    public get enumInvoiceRowTypeExtraRent() : string {
        return this.get(this.enumInvoiceRowTypeExtraRentLanguageItemName);
    }

    /**
    /* "Enum.InvoiceRowType.ContractTask" (Contract task)
    */
    public get enumInvoiceRowTypeContractTask() : string {
        return this.get(this.enumInvoiceRowTypeContractTaskLanguageItemName);
    }

    /**
    /* "Enum.InvoiceRowType.ContractTask.Description" (3030)
    */
    public get enumInvoiceRowTypeContractTaskDescription() : string {
        return this.get(this.enumInvoiceRowTypeContractTaskDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceType.Credit" (Credit)
    */
    public get enumInvoiceTypeCredit() : string {
        return this.get(this.enumInvoiceTypeCreditLanguageItemName);
    }

    /**
    /* "Enum.InvoiceType.Debit" (Debit)
    */
    public get enumInvoiceTypeDebit() : string {
        return this.get(this.enumInvoiceTypeDebitLanguageItemName);
    }

    /**
    /* "Enum.ManualInvoiceRowType.ContractTask" (3030)
    */
    public get enumManualInvoiceRowTypeContractTask() : string {
        return this.get(this.enumManualInvoiceRowTypeContractTaskLanguageItemName);
    }

    /**
    /* "Enum.ManualInvoiceRowType.ContractTask.Description" (Contract task)
    */
    public get enumManualInvoiceRowTypeContractTaskDescription() : string {
        return this.get(this.enumManualInvoiceRowTypeContractTaskDescriptionLanguageItemName);
    }

    /**
    /* "Enum.ManualInvoiceRowType.Rent" (3000)
    */
    public get enumManualInvoiceRowTypeRent() : string {
        return this.get(this.enumManualInvoiceRowTypeRentLanguageItemName);
    }

    /**
    /* "Enum.ManualInvoiceRowType.Rent.Description" (Rent)
    */
    public get enumManualInvoiceRowTypeRentDescription() : string {
        return this.get(this.enumManualInvoiceRowTypeRentDescriptionLanguageItemName);
    }

    /**
    /* "Enum.ManualInvoiceRowType.WorkReport" (3020)
    */
    public get enumManualInvoiceRowTypeWorkReport() : string {
        return this.get(this.enumManualInvoiceRowTypeWorkReportLanguageItemName);
    }

    /**
    /* "Enum.ManualInvoiceRowType.WorkReport.Description" (WorkReport)
    */
    public get enumManualInvoiceRowTypeWorkReportDescription() : string {
        return this.get(this.enumManualInvoiceRowTypeWorkReportDescriptionLanguageItemName);
    }

    /**
    /* "Enum.ManualInvoiceRowType.TaskEquipment" (3050)
    */
    public get enumManualInvoiceRowTypeTaskEquipment() : string {
        return this.get(this.enumManualInvoiceRowTypeTaskEquipmentLanguageItemName);
    }

    /**
    /* "Enum.ManualInvoiceRowType.TaskEquipment.Description" (Equipment)
    */
    public get enumManualInvoiceRowTypeTaskEquipmentDescription() : string {
        return this.get(this.enumManualInvoiceRowTypeTaskEquipmentDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceState.Failed.Description" (Failed during processing by invoicing system)
    */
    public get enumInvoiceStateFailedDescription() : string {
        return this.get(this.enumInvoiceStateFailedDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceState.Failed" (Failed)
    */
    public get enumInvoiceStateFailed() : string {
        return this.get(this.enumInvoiceStateFailedLanguageItemName);
    }

    /**
    /* "Enum.InvoiceState.Processed.Description" (Successfully processed by invoicing system)
    */
    public get enumInvoiceStateProcessedDescription() : string {
        return this.get(this.enumInvoiceStateProcessedDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceState.Processed" (Processed)
    */
    public get enumInvoiceStateProcessed() : string {
        return this.get(this.enumInvoiceStateProcessedLanguageItemName);
    }

    /**
    /* "Enum.InvoiceState.Sent.Description" (Invoice sent to invoicing system)
    */
    public get enumInvoiceStateSentDescription() : string {
        return this.get(this.enumInvoiceStateSentDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceState.Sent" (Sent)
    */
    public get enumInvoiceStateSent() : string {
        return this.get(this.enumInvoiceStateSentLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.HoursInfo" (Automatically counted hours)
    */
    public get taskHoursPanelHoursInfo() : string {
        return this.get(this.taskHoursPanelHoursInfoLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.ExtraHoursInfo" (Extra hours, reported by mounter for the task)
    */
    public get taskHoursPanelExtraHoursInfo() : string {
        return this.get(this.taskHoursPanelExtraHoursInfoLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.NoAccessToHours" (Task contains hours that you do not have access to)
    */
    public get taskHoursPanelNoAccessToHours() : string {
        return this.get(this.taskHoursPanelNoAccessToHoursLanguageItemName);
    }

    /**
    /* "InvoiceExportModal.SendToNav" (Send To Nav)
    */
    public get invoiceExportModalSendToNav() : string {
        return this.get(this.invoiceExportModalSendToNavLanguageItemName);
    }

    /**
    /* "WorkDayPanel.AutoDistance" (Auto distance\nkm)
    */
    public get workDayPanelAutoDistance() : string {
        return this.get(this.workDayPanelAutoDistanceLanguageItemName);
    }

    /**
    /* "AddTaskModal.AddTask" (Add task)
    */
    public get addTaskModalAddTask() : string {
        return this.get(this.addTaskModalAddTaskLanguageItemName);
    }

    /**
    /* "AddTaskModal.Description" (Description)
    */
    public get addTaskModalDescription() : string {
        return this.get(this.addTaskModalDescriptionLanguageItemName);
    }

    /**
    /* "TasksPanel.Tasks" (Tasks)
    */
    public get tasksPanelTasks() : string {
        return this.get(this.tasksPanelTasksLanguageItemName);
    }

    /**
    /* "TasksPanel.Type" (Type)
    */
    public get tasksPanelType() : string {
        return this.get(this.tasksPanelTypeLanguageItemName);
    }

    /**
    /* "TasksPanel.WorkReportDescription" (Description of the work report)
    */
    public get tasksPanelWorkReportDescription() : string {
        return this.get(this.tasksPanelWorkReportDescriptionLanguageItemName);
    }

    /**
    /* "TasksPanel.Code" (Code)
    */
    public get tasksPanelCode() : string {
        return this.get(this.tasksPanelCodeLanguageItemName);
    }

    /**
    /* "TasksPanel.RestoreTask" (Restore deleted task)
    */
    public get tasksPanelRestoreTask() : string {
        return this.get(this.tasksPanelRestoreTaskLanguageItemName);
    }

    /**
    /* "MyWorkHours.Description" (Check reported/approved work hours)
    */
    public get myWorkHoursDescription() : string {
        return this.get(this.myWorkHoursDescriptionLanguageItemName);
    }

    /**
    /* "TasksPanel.ActivateTask" (Activate Task)
    */
    public get tasksPanelActivateTask() : string {
        return this.get(this.tasksPanelActivateTaskLanguageItemName);
    }

    /**
    /* "TasksPanel.CompleteTask" (Complete Task)
    */
    public get tasksPanelCompleteTask() : string {
        return this.get(this.tasksPanelCompleteTaskLanguageItemName);
    }

    /**
    /* "TasksPanel.Actions" (Actions)
    */
    public get tasksPanelActions() : string {
        return this.get(this.tasksPanelActionsLanguageItemName);
    }

    /**
    /* "TasksPanel.ExtraHoursInfo" (Task extra hours, automatically calculated based on mounters entered extra hours)
    */
    public get tasksPanelExtraHoursInfo() : string {
        return this.get(this.tasksPanelExtraHoursInfoLanguageItemName);
    }

    /**
    /* "TasksPanel.ForecastInfo" (Date when task should be completed (contract date))
    */
    public get tasksPanelForecastInfo() : string {
        return this.get(this.tasksPanelForecastInfoLanguageItemName);
    }

    /**
    /* "TasksPanel.Forecast" (Forecast)
    */
    public get tasksPanelForecast() : string {
        return this.get(this.tasksPanelForecastLanguageItemName);
    }

    /**
    /* "TasksPanel.Done" (Done)
    */
    public get tasksPanelDone() : string {
        return this.get(this.tasksPanelDoneLanguageItemName);
    }

    /**
    /* "TasksPanel.StartInfo" (Activation date (date when task is started))
    */
    public get tasksPanelStartInfo() : string {
        return this.get(this.tasksPanelStartInfoLanguageItemName);
    }

    /**
    /* "TasksPanel.Start" (Start)
    */
    public get tasksPanelStart() : string {
        return this.get(this.tasksPanelStartLanguageItemName);
    }

    /**
    /* "TasksPanel.InfoMounterHours" (Information about mounter's hours, commited to the task)
    */
    public get tasksPanelInfoMounterHours() : string {
        return this.get(this.tasksPanelInfoMounterHoursLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.FixedPrice" (Fixed price, €)
    */
    public get taskHoursPanelFixedPrice() : string {
        return this.get(this.taskHoursPanelFixedPriceLanguageItemName);
    }

    /**
    /* "AddTaskModal.Mounters" (Mounters)
    */
    public get addTaskModalMounters() : string {
        return this.get(this.addTaskModalMountersLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.ContractHoursPriceInfo" (Contract cost €)
    */
    public get taskHoursPanelContractHoursPriceInfo() : string {
        return this.get(this.taskHoursPanelContractHoursPriceInfoLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.ContractHours" (Hours)
    */
    public get taskHoursPanelContractHours() : string {
        return this.get(this.taskHoursPanelContractHoursLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.ContractHoursPrice" (Price, €/h)
    */
    public get taskHoursPanelContractHoursPrice() : string {
        return this.get(this.taskHoursPanelContractHoursPriceLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.Overtime" (Overtime)
    */
    public get taskHoursPanelOvertime() : string {
        return this.get(this.taskHoursPanelOvertimeLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.ExtraHours" (Extra \n hours)
    */
    public get taskHoursPanelExtraHours() : string {
        return this.get(this.taskHoursPanelExtraHoursLanguageItemName);
    }

    /**
    /* "Enum.InvoiceState.Approved.Description" (Invoice approved by manager)
    */
    public get enumInvoiceStateApprovedDescription() : string {
        return this.get(this.enumInvoiceStateApprovedDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceState.Approved" (Approved)
    */
    public get enumInvoiceStateApproved() : string {
        return this.get(this.enumInvoiceStateApprovedLanguageItemName);
    }

    /**
    /* "Enum.InvoiceState.Created.Description" (Create by manager, not approved)
    */
    public get enumInvoiceStateCreatedDescription() : string {
        return this.get(this.enumInvoiceStateCreatedDescriptionLanguageItemName);
    }

    /**
    /* "Enum.ScaffoldingLoadClassType.Class2.Description" (Class 2 (1.5 kN/m2))
    */
    public get enumScaffoldingLoadClassTypeClass2Description() : string {
        return this.get(this.enumScaffoldingLoadClassTypeClass2DescriptionLanguageItemName);
    }

    /**
    /* "Enum.ScaffoldingLoadClassType.Class3" (Class 3)
    */
    public get enumScaffoldingLoadClassTypeClass3() : string {
        return this.get(this.enumScaffoldingLoadClassTypeClass3LanguageItemName);
    }

    /**
    /* "Enum.ScaffoldingLoadClassType.Class3.Description" (Class 3 (2 kN/m2))
    */
    public get enumScaffoldingLoadClassTypeClass3Description() : string {
        return this.get(this.enumScaffoldingLoadClassTypeClass3DescriptionLanguageItemName);
    }

    /**
    /* "Enum.ScaffoldingLoadClassType.Class4" (Class 4)
    */
    public get enumScaffoldingLoadClassTypeClass4() : string {
        return this.get(this.enumScaffoldingLoadClassTypeClass4LanguageItemName);
    }

    /**
    /* "Enum.ScaffoldingLoadClassType.Class4.Description" (Class 4 (3 kN/m2))
    */
    public get enumScaffoldingLoadClassTypeClass4Description() : string {
        return this.get(this.enumScaffoldingLoadClassTypeClass4DescriptionLanguageItemName);
    }

    /**
    /* "Enum.ScaffoldingLoadClassType.Class5" (Class 5)
    */
    public get enumScaffoldingLoadClassTypeClass5() : string {
        return this.get(this.enumScaffoldingLoadClassTypeClass5LanguageItemName);
    }

    /**
    /* "Enum.ScaffoldingLoadClassType.Class5.Description" (Class 5 (4.5 kN/m2))
    */
    public get enumScaffoldingLoadClassTypeClass5Description() : string {
        return this.get(this.enumScaffoldingLoadClassTypeClass5DescriptionLanguageItemName);
    }

    /**
    /* "Enum.ScaffoldingLoadClassType.Class6" (Class 6)
    */
    public get enumScaffoldingLoadClassTypeClass6() : string {
        return this.get(this.enumScaffoldingLoadClassTypeClass6LanguageItemName);
    }

    /**
    /* "Enum.ScaffoldingLoadClassType.Class6.Description" (Class 6 (6 kN/m2))
    */
    public get enumScaffoldingLoadClassTypeClass6Description() : string {
        return this.get(this.enumScaffoldingLoadClassTypeClass6DescriptionLanguageItemName);
    }

    /**
    /* "Enum.ProductUnit.Piece" (Piece)
    */
    public get enumProductUnitPiece() : string {
        return this.get(this.enumProductUnitPieceLanguageItemName);
    }

    /**
    /* "Enum.ProductUnit.Meter" (Meter)
    */
    public get enumProductUnitMeter() : string {
        return this.get(this.enumProductUnitMeterLanguageItemName);
    }

    /**
    /* "Enum.ProductUnit.Kilometer" (Kilometer)
    */
    public get enumProductUnitKilometer() : string {
        return this.get(this.enumProductUnitKilometerLanguageItemName);
    }

    /**
    /* "Enum.ProductUnit.Meter2" (Square meter)
    */
    public get enumProductUnitMeter2() : string {
        return this.get(this.enumProductUnitMeter2LanguageItemName);
    }

    /**
    /* "Enum.ProductUnit.Liter" (Liter)
    */
    public get enumProductUnitLiter() : string {
        return this.get(this.enumProductUnitLiterLanguageItemName);
    }

    /**
    /* "Enum.ProductUnit.Box" (Box)
    */
    public get enumProductUnitBox() : string {
        return this.get(this.enumProductUnitBoxLanguageItemName);
    }

    /**
    /* "Enum.ProductUnit.Pair" (Pair)
    */
    public get enumProductUnitPair() : string {
        return this.get(this.enumProductUnitPairLanguageItemName);
    }

    /**
    /* "Enum.ProductUnit.Bottle" (Bottle)
    */
    public get enumProductUnitBottle() : string {
        return this.get(this.enumProductUnitBottleLanguageItemName);
    }

    /**
    /* "Enum.ProductUnit.Can" (Can)
    */
    public get enumProductUnitCan() : string {
        return this.get(this.enumProductUnitCanLanguageItemName);
    }

    /**
    /* "Enum.ProductUnit.Bag" (Bag)
    */
    public get enumProductUnitBag() : string {
        return this.get(this.enumProductUnitBagLanguageItemName);
    }

    /**
    /* "Enum.ProductUnit.Roll" (Roll)
    */
    public get enumProductUnitRoll() : string {
        return this.get(this.enumProductUnitRollLanguageItemName);
    }

    /**
    /* "Enum.ProductUnit.Custom" (Custom)
    */
    public get enumProductUnitCustom() : string {
        return this.get(this.enumProductUnitCustomLanguageItemName);
    }

    /**
    /* "SendWorkReport.Title" (Send work report)
    */
    public get sendWorkReportTitle() : string {
        return this.get(this.sendWorkReportTitleLanguageItemName);
    }

    /**
    /* "SendWorkReport.Dropdown.Label" (Contact person)
    */
    public get sendWorkReportDropdownLabel() : string {
        return this.get(this.sendWorkReportDropdownLabelLanguageItemName);
    }

    /**
    /* "Enum.PaymentTermsCode.P0" (0 days net)
    */
    public get enumPaymentTermsCodeP0() : string {
        return this.get(this.enumPaymentTermsCodeP0LanguageItemName);
    }

    /**
    /* "SendWorkReport.Dropdown.NewContactPerson" (New contact person)
    */
    public get sendWorkReportDropdownNewContactPerson() : string {
        return this.get(this.sendWorkReportDropdownNewContactPersonLanguageItemName);
    }

    /**
    /* "SendWorkReport.NewContactPerson" (Create new contact person)
    */
    public get sendWorkReportNewContactPerson() : string {
        return this.get(this.sendWorkReportNewContactPersonLanguageItemName);
    }

    /**
    /* "WorkHoursWidget.Approved" (Approved)
    */
    public get workHoursWidgetApproved() : string {
        return this.get(this.workHoursWidgetApprovedLanguageItemName);
    }

    /**
    /* "WorkHoursWidget.Reported" (Reported)
    */
    public get workHoursWidgetReported() : string {
        return this.get(this.workHoursWidgetReportedLanguageItemName);
    }

    /**
    /* "WorkHoursWidget.ContractHours" (Contract hours)
    */
    public get workHoursWidgetContractHours() : string {
        return this.get(this.workHoursWidgetContractHoursLanguageItemName);
    }

    /**
    /* "MyWorkHours.Label" (My work hours)
    */
    public get myWorkHoursLabel() : string {
        return this.get(this.myWorkHoursLabelLanguageItemName);
    }

    /**
    /* "Enum.ScaffoldingLoadClassType.Class2" (Class 2)
    */
    public get enumScaffoldingLoadClassTypeClass2() : string {
        return this.get(this.enumScaffoldingLoadClassTypeClass2LanguageItemName);
    }

    /**
    /* "Enum.ScaffoldingLoadClassType.Class1.Description" (Class 1 (0.75 kN/m2))
    */
    public get enumScaffoldingLoadClassTypeClass1Description() : string {
        return this.get(this.enumScaffoldingLoadClassTypeClass1DescriptionLanguageItemName);
    }

    /**
    /* "Enum.ScaffoldingLoadClassType.Class1" (Class 1)
    */
    public get enumScaffoldingLoadClassTypeClass1() : string {
        return this.get(this.enumScaffoldingLoadClassTypeClass1LanguageItemName);
    }

    /**
    /* "Enum.PredefinedDeliveryTask.PackedMaterialTransport" (Packed material transport)
    */
    public get enumPredefinedDeliveryTaskPackedMaterialTransport() : string {
        return this.get(this.enumPredefinedDeliveryTaskPackedMaterialTransportLanguageItemName);
    }

    /**
    /* "Enum.InvoiceState.Created" (Created)
    */
    public get enumInvoiceStateCreated() : string {
        return this.get(this.enumInvoiceStateCreatedLanguageItemName);
    }

    /**
    /* "WorkDayPanel.Passengers" (Passengers)
    */
    public get workDayPanelPassengers() : string {
        return this.get(this.workDayPanelPassengersLanguageItemName);
    }

    /**
    /* "Enum.PaymentTermsCode.P7" (7 days net)
    */
    public get enumPaymentTermsCodeP7() : string {
        return this.get(this.enumPaymentTermsCodeP7LanguageItemName);
    }

    /**
    /* "Enum.PaymentTermsCode.P60" (60 days net)
    */
    public get enumPaymentTermsCodeP60() : string {
        return this.get(this.enumPaymentTermsCodeP60LanguageItemName);
    }

    /**
    /* "Enum.PaymentTermsCode.P45" (45 days net)
    */
    public get enumPaymentTermsCodeP45() : string {
        return this.get(this.enumPaymentTermsCodeP45LanguageItemName);
    }

    /**
    /* "Enum.PaymentTermsCode.P30" (30 days net)
    */
    public get enumPaymentTermsCodeP30() : string {
        return this.get(this.enumPaymentTermsCodeP30LanguageItemName);
    }

    /**
    /* "Enum.PaymentTermsCode.P21" (21 days net)
    */
    public get enumPaymentTermsCodeP21() : string {
        return this.get(this.enumPaymentTermsCodeP21LanguageItemName);
    }

    /**
    /* "Enum.PaymentTermsCode.P14" (14 days net)
    */
    public get enumPaymentTermsCodeP14() : string {
        return this.get(this.enumPaymentTermsCodeP14LanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteSubContractorTaskStatus.WorkReportNotApprovedByCustomer" (Work report not approved)
    */
    public get enumConstructionSiteSubContractorTaskStatusWorkReportNotApprovedByCustomer() : string {
        return this.get(this.enumConstructionSiteSubContractorTaskStatusWorkReportNotApprovedByCustomerLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteSubContractorTaskStatus.WorkReportNotApprovedByCustomer.Description" (Some work reports are not approved by customer)
    */
    public get enumConstructionSiteSubContractorTaskStatusWorkReportNotApprovedByCustomerDescription() : string {
        return this.get(this.enumConstructionSiteSubContractorTaskStatusWorkReportNotApprovedByCustomerDescriptionLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteSubContractorTaskStatus.OpenTasks" (Open tasks)
    */
    public get enumConstructionSiteSubContractorTaskStatusOpenTasks() : string {
        return this.get(this.enumConstructionSiteSubContractorTaskStatusOpenTasksLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteSubContractorTaskStatus.OpenTasks.Description" (Some tasks are not completed)
    */
    public get enumConstructionSiteSubContractorTaskStatusOpenTasksDescription() : string {
        return this.get(this.enumConstructionSiteSubContractorTaskStatusOpenTasksDescriptionLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteSubContractorTaskStatus.TaskNotApproved" (Tasks not approved)
    */
    public get enumConstructionSiteSubContractorTaskStatusTaskNotApproved() : string {
        return this.get(this.enumConstructionSiteSubContractorTaskStatusTaskNotApprovedLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteSubContractorTaskStatus.TaskNotApproved.Description" (Some tasks are not approved by manager)
    */
    public get enumConstructionSiteSubContractorTaskStatusTaskNotApprovedDescription() : string {
        return this.get(this.enumConstructionSiteSubContractorTaskStatusTaskNotApprovedDescriptionLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteSubContractorTaskStatus.WorkReportNotSent.Description" (Some work reports are not sent to customer)
    */
    public get enumConstructionSiteSubContractorTaskStatusWorkReportNotSentDescription() : string {
        return this.get(this.enumConstructionSiteSubContractorTaskStatusWorkReportNotSentDescriptionLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteSubContractorTaskStatus.WorkReportNotInvoiced" (Work reports not invoiced)
    */
    public get enumConstructionSiteSubContractorTaskStatusWorkReportNotInvoiced() : string {
        return this.get(this.enumConstructionSiteSubContractorTaskStatusWorkReportNotInvoicedLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteSubContractorTaskStatus.WorkReportNotInvoiced.Description" (Some work reports are not invoices)
    */
    public get enumConstructionSiteSubContractorTaskStatusWorkReportNotInvoicedDescription() : string {
        return this.get(this.enumConstructionSiteSubContractorTaskStatusWorkReportNotInvoicedDescriptionLanguageItemName);
    }

    /**
    /* "PredefinedTaskGroup.Mounter" (Extra tasks for mounters)
    */
    public get predefinedTaskGroupMounter() : string {
        return this.get(this.predefinedTaskGroupMounterLanguageItemName);
    }

    /**
    /* "PredefinedTaskGroup.Delivery" (Delivery tasks)
    */
    public get predefinedTaskGroupDelivery() : string {
        return this.get(this.predefinedTaskGroupDeliveryLanguageItemName);
    }

    /**
    /* "Enum.PredefinedExtraTask.Assembly" (Assembly)
    */
    public get enumPredefinedExtraTaskAssembly() : string {
        return this.get(this.enumPredefinedExtraTaskAssemblyLanguageItemName);
    }

    /**
    /* "Enum.PredefinedExtraTask.Dismantle" (Dismantle)
    */
    public get enumPredefinedExtraTaskDismantle() : string {
        return this.get(this.enumPredefinedExtraTaskDismantleLanguageItemName);
    }

    /**
    /* "Enum.PredefinedExtraTask.WeatherCoverOpening" (Weather cover opening)
    */
    public get enumPredefinedExtraTaskWeatherCoverOpening() : string {
        return this.get(this.enumPredefinedExtraTaskWeatherCoverOpeningLanguageItemName);
    }

    /**
    /* "Enum.PredefinedExtraTask.ExtraWork" (Extra work)
    */
    public get enumPredefinedExtraTaskExtraWork() : string {
        return this.get(this.enumPredefinedExtraTaskExtraWorkLanguageItemName);
    }

    /**
    /* "Enum.PredefinedExtraTask.ModificationWork" (Modification work)
    */
    public get enumPredefinedExtraTaskModificationWork() : string {
        return this.get(this.enumPredefinedExtraTaskModificationWorkLanguageItemName);
    }

    /**
    /* "Enum.PredefinedExtraTask.RepairWork" (Repair work)
    */
    public get enumPredefinedExtraTaskRepairWork() : string {
        return this.get(this.enumPredefinedExtraTaskRepairWorkLanguageItemName);
    }

    /**
    /* "Enum.PredefinedDeliveryTask.DeliveryTransport" (Delivery transport)
    */
    public get enumPredefinedDeliveryTaskDeliveryTransport() : string {
        return this.get(this.enumPredefinedDeliveryTaskDeliveryTransportLanguageItemName);
    }

    /**
    /* "Enum.PredefinedDeliveryTask.ReturnTransport" (Return transport)
    */
    public get enumPredefinedDeliveryTaskReturnTransport() : string {
        return this.get(this.enumPredefinedDeliveryTaskReturnTransportLanguageItemName);
    }

    /**
    /* "Enum.ConstructionSiteSubContractorTaskStatus.WorkReportNotSent" (Work reports not sent)
    */
    public get enumConstructionSiteSubContractorTaskStatusWorkReportNotSent() : string {
        return this.get(this.enumConstructionSiteSubContractorTaskStatusWorkReportNotSentLanguageItemName);
    }

    /**
    /* "TasksPanel.ApproveTaskCreate" (Approve task to create a invoice row)
    */
    public get tasksPanelApproveTaskCreate() : string {
        return this.get(this.tasksPanelApproveTaskCreateLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.OvertimeFifty" (Overtime 50%)
    */
    public get salaryHoursPanelOvertimeFifty() : string {
        return this.get(this.salaryHoursPanelOvertimeFiftyLanguageItemName);
    }

    /**
    /* "SalaryExportModal.SendToPayroll" (Send to payroll)
    */
    public get salaryExportModalSendToPayroll() : string {
        return this.get(this.salaryExportModalSendToPayrollLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.NormalHours" (Normal hours)
    */
    public get salaryHoursPanelNormalHours() : string {
        return this.get(this.salaryHoursPanelNormalHoursLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.Hours" (Hours)
    */
    public get salaryHoursPanelHours() : string {
        return this.get(this.salaryHoursPanelHoursLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.Total" (Total)
    */
    public get salaryHoursPanelTotal() : string {
        return this.get(this.salaryHoursPanelTotalLanguageItemName);
    }

    /**
    /* "WorkDayPanel.AutoHours" (Auto Hours)
    */
    public get workDayPanelAutoHours() : string {
        return this.get(this.workDayPanelAutoHoursLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.Evening" (Evening)
    */
    public get salaryHoursPanelEvening() : string {
        return this.get(this.salaryHoursPanelEveningLanguageItemName);
    }

    /**
    /* "AddMounterModal.AddHoursInfo" (Add mounter working hours for site or warehouse)
    */
    public get addMounterModalAddHoursInfo() : string {
        return this.get(this.addMounterModalAddHoursInfoLanguageItemName);
    }

    /**
    /* "TasksPanel.SendToCustomer" (Send to customer for approving)
    */
    public get tasksPanelSendToCustomer() : string {
        return this.get(this.tasksPanelSendToCustomerLanguageItemName);
    }

    /**
    /* "ConstructionSites.SitesInfo" (Construction sites)
    */
    public get constructionSitesSitesInfo() : string {
        return this.get(this.constructionSitesSitesInfoLanguageItemName);
    }

    /**
    /* "TasksPanel.SentTo" (Sent to)
    */
    public get tasksPanelSentTo() : string {
        return this.get(this.tasksPanelSentToLanguageItemName);
    }

    /**
    /* "AddConstructionsite.ProjectNumber" (Project number)
    */
    public get addConstructionsiteProjectNumber() : string {
        return this.get(this.addConstructionsiteProjectNumberLanguageItemName);
    }

    /**
    /* "TasksPanel.RestoreDeletedWorkReport" (Restore deleted work report)
    */
    public get tasksPanelRestoreDeletedWorkReport() : string {
        return this.get(this.tasksPanelRestoreDeletedWorkReportLanguageItemName);
    }

    /**
    /* "TasksPanel.DeleteWorkReport" (Delete work report)
    */
    public get tasksPanelDeleteWorkReport() : string {
        return this.get(this.tasksPanelDeleteWorkReportLanguageItemName);
    }

    /**
    /* "AddMounterModal.NoTasksAvailable" (No tasks available)
    */
    public get addMounterModalNoTasksAvailable() : string {
        return this.get(this.addMounterModalNoTasksAvailableLanguageItemName);
    }

    /**
    /* "TasksPanel.ApproveWorkReportInvoice" (Approve work report to create a invoice row)
    */
    public get tasksPanelApproveWorkReportInvoice() : string {
        return this.get(this.tasksPanelApproveWorkReportInvoiceLanguageItemName);
    }

    /**
    /* "TasksPanel.PreviewWorkReport" (Preview work report)
    */
    public get tasksPanelPreviewWorkReport() : string {
        return this.get(this.tasksPanelPreviewWorkReportLanguageItemName);
    }

    /**
    /* "TasksPanel.SentAt" (Sent at)
    */
    public get tasksPanelSentAt() : string {
        return this.get(this.tasksPanelSentAtLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.Mounter" (Mounter)
    */
    public get taskHoursPanelMounter() : string {
        return this.get(this.taskHoursPanelMounterLanguageItemName);
    }

    /**
    /* "ConstructionSites.Sites" (Sites)
    */
    public get constructionSitesSites() : string {
        return this.get(this.constructionSitesSitesLanguageItemName);
    }

    /**
    /* "ConstructionSites.InvoiceReference" (Invoice reference)
    */
    public get constructionSitesInvoiceReference() : string {
        return this.get(this.constructionSitesInvoiceReferenceLanguageItemName);
    }

    /**
    /* "ConstructionSites.Reference" (Reference)
    */
    public get constructionSitesReference() : string {
        return this.get(this.constructionSitesReferenceLanguageItemName);
    }

    /**
    /* "AddConstructionsite.Organization" (Organization)
    */
    public get addConstructionsiteOrganization() : string {
        return this.get(this.addConstructionsiteOrganizationLanguageItemName);
    }

    /**
    /* "TasksPanel.DownloadWorkReport" (Download work report)
    */
    public get tasksPanelDownloadWorkReport() : string {
        return this.get(this.tasksPanelDownloadWorkReportLanguageItemName);
    }

    /**
    /* "AddMounterModal.Hours" (Hours)
    */
    public get addMounterModalHours() : string {
        return this.get(this.addMounterModalHoursLanguageItemName);
    }

    /**
    /* "CheckInsPanel.SignIn" (Sign in at)
    */
    public get checkInsPanelSignIn() : string {
        return this.get(this.checkInsPanelSignInLanguageItemName);
    }

    /**
    /* "CheckInsPanel.SiteOrWarehouse" (Customer and site)
    */
    public get checkInsPanelSiteOrWarehouse() : string {
        return this.get(this.checkInsPanelSiteOrWarehouseLanguageItemName);
    }

    /**
    /* "WorkDayPanel.DistanceInfo" (Distance calculated based on GPS)
    */
    public get workDayPanelDistanceInfo() : string {
        return this.get(this.workDayPanelDistanceInfoLanguageItemName);
    }

    /**
    /* "WorkDayPanel.Distance" (Total distance, km)
    */
    public get workDayPanelDistance() : string {
        return this.get(this.workDayPanelDistanceLanguageItemName);
    }

    /**
    /* "WorkDayPanel.OwnEquipment" (Own equipment)
    */
    public get workDayPanelOwnEquipment() : string {
        return this.get(this.workDayPanelOwnEquipmentLanguageItemName);
    }

    /**
    /* "WorkDayPanel.DailyAllowance" (Daily Allowance)
    */
    public get workDayPanelDailyAllowance() : string {
        return this.get(this.workDayPanelDailyAllowanceLanguageItemName);
    }

    /**
    /* "WorkDayPanel.Aggregate.DailyAllowance" (Daily Allowance)
    */
    public get workDayPanelAggregateDailyAllowance() : string {
        return this.get(this.workDayPanelAggregateDailyAllowanceLanguageItemName);
    }

    /**
    /* "WorkDayPanel.WorkDay" (Work Day)
    */
    public get workDayPanelWorkDay() : string {
        return this.get(this.workDayPanelWorkDayLanguageItemName);
    }

    /**
    /* "WorkDayPanel.AddNewTaskHours" (Add new task hours)
    */
    public get workDayPanelAddNewTaskHours() : string {
        return this.get(this.workDayPanelAddNewTaskHoursLanguageItemName);
    }

    /**
    /* "WorkDayPanel.DetailsInfo" (Information about mounter's check-ins)
    */
    public get workDayPanelDetailsInfo() : string {
        return this.get(this.workDayPanelDetailsInfoLanguageItemName);
    }

    /**
    /* "WorkDayPanel.Details" (Details)
    */
    public get workDayPanelDetails() : string {
        return this.get(this.workDayPanelDetailsLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.SundayOvertime" (Sunday overtime)
    */
    public get salaryHoursPanelSundayOvertime() : string {
        return this.get(this.salaryHoursPanelSundayOvertimeLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.EveningOvertime" (Evening overtime)
    */
    public get salaryHoursPanelEveningOvertime() : string {
        return this.get(this.salaryHoursPanelEveningOvertimeLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.Night" (Night)
    */
    public get salaryHoursPanelNight() : string {
        return this.get(this.salaryHoursPanelNightLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.NightOvertime" (Night overtime)
    */
    public get salaryHoursPanelNightOvertime() : string {
        return this.get(this.salaryHoursPanelNightOvertimeLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.MarkAsNormal" (Mark as normal)
    */
    public get salaryHoursPanelMarkAsNormal() : string {
        return this.get(this.salaryHoursPanelMarkAsNormalLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.ContractHours" (Contract hours)
    */
    public get salaryHoursPanelContractHours() : string {
        return this.get(this.salaryHoursPanelContractHoursLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.OvertimeHundred" (Overtime 100%)
    */
    public get salaryHoursPanelOvertimeHundred() : string {
        return this.get(this.salaryHoursPanelOvertimeHundredLanguageItemName);
    }

    /**
    /* "CheckInsPanel.Task" (Task)
    */
    public get checkInsPanelTask() : string {
        return this.get(this.checkInsPanelTaskLanguageItemName);
    }

    /**
    /* "CheckInsPanel.CheckOutAddress" (Check out address)
    */
    public get checkInsPanelCheckOutAddress() : string {
        return this.get(this.checkInsPanelCheckOutAddressLanguageItemName);
    }

    /**
    /* "CheckInsPanel.CheckOut" (Task check out)
    */
    public get checkInsPanelCheckOut() : string {
        return this.get(this.checkInsPanelCheckOutLanguageItemName);
    }

    /**
    /* "CheckInsPanel.CheckInAddress" (Check in address)
    */
    public get checkInsPanelCheckInAddress() : string {
        return this.get(this.checkInsPanelCheckInAddressLanguageItemName);
    }

    /**
    /* "AddMounterModal.AddHours" (Add hours)
    */
    public get addMounterModalAddHours() : string {
        return this.get(this.addMounterModalAddHoursLanguageItemName);
    }

    /**
    /* "CheckInsPanel.CheckIn" (Task check in)
    */
    public get checkInsPanelCheckIn() : string {
        return this.get(this.checkInsPanelCheckInLanguageItemName);
    }

    /**
    /* "Link.Expired" (Link has expired)
    */
    public get linkExpired() : string {
        return this.get(this.linkExpiredLanguageItemName);
    }

    /**
    /* "Link.Used" (Link has expired)
    */
    public get linkUsed() : string {
        return this.get(this.linkUsedLanguageItemName);
    }

    /**
    /* "CheckInsPanel.SignOut" (Sign out at)
    */
    public get checkInsPanelSignOut() : string {
        return this.get(this.checkInsPanelSignOutLanguageItemName);
    }

    /**
    /* "ForgotPasswordPage.SuccessMessage" (Notification has been sent. Please check your SMS or mailbox.)
    */
    public get forgotPasswordPageSuccessMessage() : string {
        return this.get(this.forgotPasswordPageSuccessMessageLanguageItemName);
    }

    /**
    /* "ForgotPasswordPage.ResetButton" (Send)
    */
    public get forgotPasswordPageResetButton() : string {
        return this.get(this.forgotPasswordPageResetButtonLanguageItemName);
    }

    /**
    /* "ForgotPasswordPage.LoginButton" (Go to login)
    */
    public get forgotPasswordPageLoginButton() : string {
        return this.get(this.forgotPasswordPageLoginButtonLanguageItemName);
    }

    /**
    /* "ForgotPasswordPage.HelpText" (No problem. Please enter your "username" and we will send you instructions on how to reset your password.)
    */
    public get forgotPasswordPageHelpText() : string {
        return this.get(this.forgotPasswordPageHelpTextLanguageItemName);
    }

    /**
    /* "ForgotPasswordPage.EmailInput" (Email)
    */
    public get forgotPasswordPageEmailInput() : string {
        return this.get(this.forgotPasswordPageEmailInputLanguageItemName);
    }

    /**
    /* "AddConstructionsite.Warehouse" (Warehouse)
    */
    public get addConstructionsiteWarehouse() : string {
        return this.get(this.addConstructionsiteWarehouseLanguageItemName);
    }

    /**
    /* "AddConstructionsite.Manager" (Manager)
    */
    public get addConstructionsiteManager() : string {
        return this.get(this.addConstructionsiteManagerLanguageItemName);
    }

    /**
    /* "ConstructionSites.Activate" (Activate)
    */
    public get constructionSitesActivate() : string {
        return this.get(this.constructionSitesActivateLanguageItemName);
    }

    /**
    /* "ConstructionSites.Deactivate" (Deactivate)
    */
    public get constructionSitesDeactivate() : string {
        return this.get(this.constructionSitesDeactivateLanguageItemName);
    }

    /**
    /* "AddConstructionsiteToolbar.AnyTaskStatus" (Any task status)
    */
    public get addConstructionsiteToolbarAnyTaskStatus() : string {
        return this.get(this.addConstructionsiteToolbarAnyTaskStatusLanguageItemName);
    }

    /**
    /* "AddConstructionsiteToolbar.AnyStatus" (Any status)
    */
    public get addConstructionsiteToolbarAnyStatus() : string {
        return this.get(this.addConstructionsiteToolbarAnyStatusLanguageItemName);
    }

    /**
    /* "AddConstructionsiteToolbar.Site" (Site)
    */
    public get addConstructionsiteToolbarSite() : string {
        return this.get(this.addConstructionsiteToolbarSiteLanguageItemName);
    }

    /**
    /* "ConstructionSitesToolbar.Customer" (Customer)
    */
    public get constructionSitesToolbarCustomer() : string {
        return this.get(this.constructionSitesToolbarCustomerLanguageItemName);
    }

    /**
    /* "AddConstructionsiteToolbar.AllSalesPersons" (All sales persons)
    */
    public get addConstructionsiteToolbarAllSalesPersons() : string {
        return this.get(this.addConstructionsiteToolbarAllSalesPersonsLanguageItemName);
    }

    /**
    /* "AddConstructionsiteToolbar.AllManagers" (All managers)
    */
    public get addConstructionsiteToolbarAllManagers() : string {
        return this.get(this.addConstructionsiteToolbarAllManagersLanguageItemName);
    }

    /**
    /* "ConstructionSites.Close" (Close)
    */
    public get constructionSitesClose() : string {
        return this.get(this.constructionSitesCloseLanguageItemName);
    }

    /**
    /* "AddConstructionsite.AddSite" (Add site)
    */
    public get addConstructionsiteAddSite() : string {
        return this.get(this.addConstructionsiteAddSiteLanguageItemName);
    }

    /**
    /* "AddConstructionsite.SalesPerson" (Sales person)
    */
    public get addConstructionsiteSalesPerson() : string {
        return this.get(this.addConstructionsiteSalesPersonLanguageItemName);
    }

    /**
    /* "AddTaskModal.AddTaskSubtitle" (Add new task for construction site and assign mounters)
    */
    public get addTaskModalAddTaskSubtitle() : string {
        return this.get(this.addTaskModalAddTaskSubtitleLanguageItemName);
    }

    /**
    /* "AddConstructionsiteToolbar.AnySubTaskStatus" (Any subcontractor task status)
    */
    public get addConstructionsiteToolbarAnySubTaskStatus() : string {
        return this.get(this.addConstructionsiteToolbarAnySubTaskStatusLanguageItemName);
    }

    /**
    /* "AddConstructionsiteToolbar.Filter" (Filter)
    */
    public get addConstructionsiteToolbarFilter() : string {
        return this.get(this.addConstructionsiteToolbarFilterLanguageItemName);
    }

    /**
    /* "MyWorkHours.NoReportedHours" (No reported hours for this day)
    */
    public get myWorkHoursNoReportedHours() : string {
        return this.get(this.myWorkHoursNoReportedHoursLanguageItemName);
    }

    /**
    /* "AddConstructionsiteToolbar.ClearFilter" (Clear filter)
    */
    public get addConstructionsiteToolbarClearFilter() : string {
        return this.get(this.addConstructionsiteToolbarClearFilterLanguageItemName);
    }

    /**
    /* "Generic.CustomerNumber" (Customer number)
    */
    public get genericCustomerNumber() : string {
        return this.get(this.genericCustomerNumberLanguageItemName);
    }

    /**
    /* "ConstructionSites.Status" (Status)
    */
    public get constructionSitesStatus() : string {
        return this.get(this.constructionSitesStatusLanguageItemName);
    }

    /**
    /* "ConstructionSitePanel.ActivateConfirmation" (Are you sure that you want to activate this construction site?)
    */
    public get constructionSitePanelActivateConfirmation() : string {
        return this.get(this.constructionSitePanelActivateConfirmationLanguageItemName);
    }

    /**
    /* "ConstructionSitePanel.DeactivateConfirmation" (Are you sure that you want to deactivate this construction site?)
    */
    public get constructionSitePanelDeactivateConfirmation() : string {
        return this.get(this.constructionSitePanelDeactivateConfirmationLanguageItemName);
    }

    /**
    /* "MyAudits.ApprovedAt" (Approved at)
    */
    public get myAuditsApprovedAt() : string {
        return this.get(this.myAuditsApprovedAtLanguageItemName);
    }

    /**
    /* "MyAudits.MyAudit" (My audits)
    */
    public get myAuditsMyAudit() : string {
        return this.get(this.myAuditsMyAuditLanguageItemName);
    }

    /**
    /* "MyAudits.NoData" (No audit reports received yet)
    */
    public get myAuditsNoData() : string {
        return this.get(this.myAuditsNoDataLanguageItemName);
    }

    /**
    /* "MyAudits.Actions.Approve" (Approve audit report)
    */
    public get myAuditsActionsApprove() : string {
        return this.get(this.myAuditsActionsApproveLanguageItemName);
    }

    /**
    /* "MyAudits.Actions.Preview" (Preview audit report)
    */
    public get myAuditsActionsPreview() : string {
        return this.get(this.myAuditsActionsPreviewLanguageItemName);
    }

    /**
    /* "MyAudits.Actions.Download" (Download audit report)
    */
    public get myAuditsActionsDownload() : string {
        return this.get(this.myAuditsActionsDownloadLanguageItemName);
    }

    /**
    /* "MyAudits.Confirmation.Approve" (Are you sure, you want approve audit report #{0} \"{1}\")
    */
    public get myAuditsConfirmationApprove() : string {
        return this.get(this.myAuditsConfirmationApproveLanguageItemName);
    }

    /**
    /* "MyAudits.ReportPreview" (Audit report preview)
    */
    public get myAuditsReportPreview() : string {
        return this.get(this.myAuditsReportPreviewLanguageItemName);
    }

    /**
    /* "Agreement.MinimumRentalDays" (Minimum rental days)
    */
    public get agreementMinimumRentalDays() : string {
        return this.get(this.agreementMinimumRentalDaysLanguageItemName);
    }

    /**
    /* "AgreementModule.Name" (Name)
    */
    public get agreementModuleName() : string {
        return this.get(this.agreementModuleNameLanguageItemName);
    }

    /**
    /* "AddAgreement.AddAgreement" (Add agreement)
    */
    public get addAgreementAddAgreement() : string {
        return this.get(this.addAgreementAddAgreementLanguageItemName);
    }

    /**
    /* "AddAgreement.Description" (Description)
    */
    public get addAgreementDescription() : string {
        return this.get(this.addAgreementDescriptionLanguageItemName);
    }

    /**
    /* "AddAgreement.Dropdown.Label" (Contact person)
    */
    public get addAgreementDropdownLabel() : string {
        return this.get(this.addAgreementDropdownLabelLanguageItemName);
    }

    /**
    /* "AddAgreement.ExtraTaskHourlyCost" (Default task hourly price)
    */
    public get addAgreementExtraTaskHourlyCost() : string {
        return this.get(this.addAgreementExtraTaskHourlyCostLanguageItemName);
    }

    /**
    /* "AddAgreement.NewContactPerson" (Create new contact person)
    */
    public get addAgreementNewContactPerson() : string {
        return this.get(this.addAgreementNewContactPersonLanguageItemName);
    }

    /**
    /* "AddAgreement.Subtitle" (Create new agreement)
    */
    public get addAgreementSubtitle() : string {
        return this.get(this.addAgreementSubtitleLanguageItemName);
    }

    /**
    /* "AddAgreement.Title" (Add agreement)
    */
    public get addAgreementTitle() : string {
        return this.get(this.addAgreementTitleLanguageItemName);
    }

    /**
    /* "AuditModule.Approved" (Approved)
    */
    public get auditModuleApproved() : string {
        return this.get(this.auditModuleApprovedLanguageItemName);
    }

    /**
    /* "AuditModule.NoAudit" (no audit)
    */
    public get auditModuleNoAudit() : string {
        return this.get(this.auditModuleNoAuditLanguageItemName);
    }

    /**
    /* "AuditModule.NotApproved" (Not approved)
    */
    public get auditModuleNotApproved() : string {
        return this.get(this.auditModuleNotApprovedLanguageItemName);
    }

    /**
    /* "AuditModule.NotPassed" (Not passed)
    */
    public get auditModuleNotPassed() : string {
        return this.get(this.auditModuleNotPassedLanguageItemName);
    }

    /**
    /* "AuditModule.Passed" (Passed)
    */
    public get auditModulePassed() : string {
        return this.get(this.auditModulePassedLanguageItemName);
    }

    /**
    /* "AuditModule.StartAudit" (START AUDIT)
    */
    public get auditModuleStartAudit() : string {
        return this.get(this.auditModuleStartAuditLanguageItemName);
    }

    /**
    /* "AuditQuestionInput.Comment" (COMMENT)
    */
    public get auditQuestionInputComment() : string {
        return this.get(this.auditQuestionInputCommentLanguageItemName);
    }

    /**
    /* "AuditQuestionInput.CommentRequired" (Comment is required)
    */
    public get auditQuestionInputCommentRequired() : string {
        return this.get(this.auditQuestionInputCommentRequiredLanguageItemName);
    }

    /**
    /* "AuditQuestionInput.InsertComment" (Insert comment if needed)
    */
    public get auditQuestionInputInsertComment() : string {
        return this.get(this.auditQuestionInputInsertCommentLanguageItemName);
    }

    /**
    /* "AuditQuestionInput.NeedRepairs" (NEED \nREPAIRS)
    */
    public get auditQuestionInputNeedRepairs() : string {
        return this.get(this.auditQuestionInputNeedRepairsLanguageItemName);
    }

    /**
    /* "AuditQuestionInput.StepOk" (STEP OK)
    */
    public get auditQuestionInputStepOk() : string {
        return this.get(this.auditQuestionInputStepOkLanguageItemName);
    }

    /**
    /* "Enum.UserRoleGroup.Subcontractors" (Subcontractors)
    */
    public get enumUserRoleGroupSubcontractors() : string {
        return this.get(this.enumUserRoleGroupSubcontractorsLanguageItemName);
    }

    /**
    /* "Generic.CostPool" (Cost pool)
    */
    public get genericCostPool() : string {
        return this.get(this.genericCostPoolLanguageItemName);
    }

    /**
    /* "Generic.Details" (Details)
    */
    public get genericDetails() : string {
        return this.get(this.genericDetailsLanguageItemName);
    }

    /**
    /* "Generic.Name" (Name)
    */
    public get genericName() : string {
        return this.get(this.genericNameLanguageItemName);
    }

    /**
    /* "Generic.Task" (Task)
    */
    public get genericTask() : string {
        return this.get(this.genericTaskLanguageItemName);
    }

    /**
    /* "Generic.Warehouse" (Warehouse)
    */
    public get genericWarehouse() : string {
        return this.get(this.genericWarehouseLanguageItemName);
    }

    /**
    /* "Generic.Tasks" (Tasks)
    */
    public get genericTasks() : string {
        return this.get(this.genericTasksLanguageItemName);
    }

    /**
    /* "Generic.VatId" (Business ID)
    */
    public get genericVatId() : string {
        return this.get(this.genericVatIdLanguageItemName);
    }

    /**
    /* "Grid.NoData.Subcontractors" (No subcontractors)
    */
    public get gridNoDataSubcontractors() : string {
        return this.get(this.gridNoDataSubcontractorsLanguageItemName);
    }

    /**
    /* "InvoiceExportModal.DownloadFile" (Download file)
    */
    public get invoiceExportModalDownloadFile() : string {
        return this.get(this.invoiceExportModalDownloadFileLanguageItemName);
    }

    /**
    /* "InvoiceExportModal.SendToPagero" (Send To Pagero)
    */
    public get invoiceExportModalSendToPagero() : string {
        return this.get(this.invoiceExportModalSendToPageroLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.AddMounter" (Add mounter)
    */
    public get workDayPanelToolbarAddMounter() : string {
        return this.get(this.workDayPanelToolbarAddMounterLanguageItemName);
    }

    /**
    /* "Invoices.DownloadInvoice" (Download Invoice)
    */
    public get invoicesDownloadInvoice() : string {
        return this.get(this.invoicesDownloadInvoiceLanguageItemName);
    }

    /**
    /* "Invoices.State" (State)
    */
    public get invoicesState() : string {
        return this.get(this.invoicesStateLanguageItemName);
    }

    /**
    /* "Invoices.DueTitle" (The date during which the payment must be made at the latest (Payment Date 0 Net))
    */
    public get invoicesDueTitle() : string {
        return this.get(this.invoicesDueTitleLanguageItemName);
    }

    /**
    /* "Invoices.Due" (Due)
    */
    public get invoicesDue() : string {
        return this.get(this.invoicesDueLanguageItemName);
    }

    /**
    /* "Invoices.Net" (Net)
    */
    public get invoicesNet() : string {
        return this.get(this.invoicesNetLanguageItemName);
    }

    /**
    /* "SubContractors.Subcontractor" (Subcontractor)
    */
    public get subContractorsSubcontractor() : string {
        return this.get(this.subContractorsSubcontractorLanguageItemName);
    }

    /**
    /* "Invoices.EntryTitle" (The date payment should be transferred to a customer, last day of invoicing period)
    */
    public get invoicesEntryTitle() : string {
        return this.get(this.invoicesEntryTitleLanguageItemName);
    }

    /**
    /* "Invoices.Entry" (Entry)
    */
    public get invoicesEntry() : string {
        return this.get(this.invoicesEntryLanguageItemName);
    }

    /**
    /* "Invoices.CreatedAt" (Created at)
    */
    public get invoicesCreatedAt() : string {
        return this.get(this.invoicesCreatedAtLanguageItemName);
    }

    /**
    /* "Generic.NameAndProject" (Name and project number)
    */
    public get genericNameAndProject() : string {
        return this.get(this.genericNameAndProjectLanguageItemName);
    }

    /**
    /* "Invoices.InvoiceComment" (Invoice comment for customer)
    */
    public get invoicesInvoiceComment() : string {
        return this.get(this.invoicesInvoiceCommentLanguageItemName);
    }

    /**
    /* "Invoices.Reference" (Reference)
    */
    public get invoicesReference() : string {
        return this.get(this.invoicesReferenceLanguageItemName);
    }

    /**
    /* "Invoices.InformationInvoiceRows" (Information about invoice rows)
    */
    public get invoicesInformationInvoiceRows() : string {
        return this.get(this.invoicesInformationInvoiceRowsLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.ExportPageroFormatSubTitle" (All 'Approved', but not billed invoices)
    */
    public get invoiceToolbarExportPageroFormatSubTitle() : string {
        return this.get(this.invoiceToolbarExportPageroFormatSubTitleLanguageItemName);
    }

    /**
    /* "TasksPanel.AddTaskTitle" (Add task)
    */
    public get tasksPanelAddTaskTitle() : string {
        return this.get(this.tasksPanelAddTaskTitleLanguageItemName);
    }

    /**
    /* "TasksPanel.AddWorkReportTitle" (Add work report)
    */
    public get tasksPanelAddWorkReportTitle() : string {
        return this.get(this.tasksPanelAddWorkReportTitleLanguageItemName);
    }

    /**
    /* "Invoices.Nav" (NAV)
    */
    public get invoicesNav() : string {
        return this.get(this.invoicesNavLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.ExportPageroFormat" (Export invoices to Pagero (F-Invoice))
    */
    public get invoiceToolbarExportPageroFormat() : string {
        return this.get(this.invoiceToolbarExportPageroFormatLanguageItemName);
    }

    /**
    /* "Invoices.PreviewInvoice" (Preview work and cost report)
    */
    public get invoicesPreviewInvoice() : string {
        return this.get(this.invoicesPreviewInvoiceLanguageItemName);
    }

    /**
    /* "Invoices.SendToPagero" (Send to Pagero)
    */
    public get invoicesSendToPagero() : string {
        return this.get(this.invoicesSendToPageroLanguageItemName);
    }

    /**
    /* "Warehouses.PageTitle" (Warehouses)
    */
    public get warehousesPageTitle() : string {
        return this.get(this.warehousesPageTitleLanguageItemName);
    }

    /**
    /* "WarehousePanel.PanelTitle" (Warehouse details)
    */
    public get warehousePanelPanelTitle() : string {
        return this.get(this.warehousePanelPanelTitleLanguageItemName);
    }

    /**
    /* "Warehouses.ExternalId" (Warehouse number)
    */
    public get warehousesExternalId() : string {
        return this.get(this.warehousesExternalIdLanguageItemName);
    }

    /**
    /* "RoleName.SubcontractorManager" (Manager)
    */
    public get roleNameSubcontractorManager() : string {
        return this.get(this.roleNameSubcontractorManagerLanguageItemName);
    }

    /**
    /* "RoleName.SubcontractorMounter" (Mounter)
    */
    public get roleNameSubcontractorMounter() : string {
        return this.get(this.roleNameSubcontractorMounterLanguageItemName);
    }

    /**
    /* "RoleName.SubcontractorHeadMounter" (Head mounter)
    */
    public get roleNameSubcontractorHeadMounter() : string {
        return this.get(this.roleNameSubcontractorHeadMounterLanguageItemName);
    }

    /**
    /* "MyWorkReport.NoData" (No work reports received yet)
    */
    public get myWorkReportNoData() : string {
        return this.get(this.myWorkReportNoDataLanguageItemName);
    }

    /**
    /* "MyWorkReport.MyReport" (My Work Reports)
    */
    public get myWorkReportMyReport() : string {
        return this.get(this.myWorkReportMyReportLanguageItemName);
    }

    /**
    /* "MyWorkReport.DeclineWorkReport" (Decline work report to (return back to manager))
    */
    public get myWorkReportDeclineWorkReport() : string {
        return this.get(this.myWorkReportDeclineWorkReportLanguageItemName);
    }

    /**
    /* "MyWorkReport.ApprovedAt" (Approved at)
    */
    public get myWorkReportApprovedAt() : string {
        return this.get(this.myWorkReportApprovedAtLanguageItemName);
    }

    /**
    /* "MyInvoices.MyInvoices" (My Invoices)
    */
    public get myInvoicesMyInvoices() : string {
        return this.get(this.myInvoicesMyInvoicesLanguageItemName);
    }

    /**
    /* "MyWorkReports.Confirmation.Approve" (Are you sure, you want approve work report {0}?)
    */
    public get myWorkReportsConfirmationApprove() : string {
        return this.get(this.myWorkReportsConfirmationApproveLanguageItemName);
    }

    /**
    /* "MyWorkReports.Confirmation.Decline" (Are you sure, you want decline work report {0}?)
    */
    public get myWorkReportsConfirmationDecline() : string {
        return this.get(this.myWorkReportsConfirmationDeclineLanguageItemName);
    }

    /**
    /* "Invoices.ListOfInvoices" (List of invoices and invoice states)
    */
    public get invoicesListOfInvoices() : string {
        return this.get(this.invoicesListOfInvoicesLanguageItemName);
    }

    /**
    /* "Invoices.Invoices" (Invoices)
    */
    public get invoicesInvoices() : string {
        return this.get(this.invoicesInvoicesLanguageItemName);
    }

    /**
    /* "Invoices.CancelInvoice" (Cancel invoice (create credit invoice))
    */
    public get invoicesCancelInvoice() : string {
        return this.get(this.invoicesCancelInvoiceLanguageItemName);
    }

    /**
    /* "Invoices.DeleteCreditInvoiceConfirmation" (Are you sure\nyou want delete credit invoice\n<mark>#{0}</mark> on <mark>{1:C}€</mark>\nfor customer\n'<mark>{2}</mark>'?)
    */
    public get invoicesDeleteCreditInvoiceConfirmation() : string {
        return this.get(this.invoicesDeleteCreditInvoiceConfirmationLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.ExportRowInfo" (You are going to export {0} rows for {1} employees)
    */
    public get workDayPanelToolbarExportRowInfo() : string {
        return this.get(this.workDayPanelToolbarExportRowInfoLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.ExportNavisionFormatSubTitle" (All 'Sent', but not exported invoices)
    */
    public get invoiceToolbarExportNavisionFormatSubTitle() : string {
        return this.get(this.invoiceToolbarExportNavisionFormatSubTitleLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.ExportNavisionFormat" (Export invoices in Navision format)
    */
    public get invoiceToolbarExportNavisionFormat() : string {
        return this.get(this.invoiceToolbarExportNavisionFormatLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.Pagero" (Pagero)
    */
    public get invoiceToolbarPagero() : string {
        return this.get(this.invoiceToolbarPageroLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.ExportToPagero" (Export to Pagero)
    */
    public get invoiceToolbarExportToPagero() : string {
        return this.get(this.invoiceToolbarExportToPageroLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.AnySalaryHoursSubText" (Any salary hours, not approved, approved, exported)
    */
    public get workDayPanelToolbarAnySalaryHoursSubText() : string {
        return this.get(this.workDayPanelToolbarAnySalaryHoursSubTextLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.ApprovedByManager" (Approved by manager)
    */
    public get workDayPanelToolbarApprovedByManager() : string {
        return this.get(this.workDayPanelToolbarApprovedByManagerLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.ApprovedByDirector" (Approved by director)
    */
    public get workDayPanelToolbarApprovedByDirector() : string {
        return this.get(this.workDayPanelToolbarApprovedByDirectorLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.ApprovedByDirectorSubText" (Approved by manager and director (exportable))
    */
    public get workDayPanelToolbarApprovedByDirectorSubText() : string {
        return this.get(this.workDayPanelToolbarApprovedByDirectorSubTextLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.NotApprovedByManager" (Not approved by manager)
    */
    public get workDayPanelToolbarNotApprovedByManager() : string {
        return this.get(this.workDayPanelToolbarNotApprovedByManagerLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.NotApprovedByManagerSubText" (Not approved by manager and director (not approved at all))
    */
    public get workDayPanelToolbarNotApprovedByManagerSubText() : string {
        return this.get(this.workDayPanelToolbarNotApprovedByManagerSubTextLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.NotApprovedByDirector" (Not approved by director)
    */
    public get workDayPanelToolbarNotApprovedByDirector() : string {
        return this.get(this.workDayPanelToolbarNotApprovedByDirectorLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.NotApprovedByDirectorSubText" (Approved by manager only, not approved by director)
    */
    public get workDayPanelToolbarNotApprovedByDirectorSubText() : string {
        return this.get(this.workDayPanelToolbarNotApprovedByDirectorSubTextLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.ReportType" (Report type:)
    */
    public get workDayPanelToolbarReportType() : string {
        return this.get(this.workDayPanelToolbarReportTypeLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.Source" (Construction site/Warehouse)
    */
    public get workDayPanelToolbarSource() : string {
        return this.get(this.workDayPanelToolbarSourceLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.Approve" (Approve:)
    */
    public get workDayPanelToolbarApprove() : string {
        return this.get(this.workDayPanelToolbarApproveLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.Date" (Date:)
    */
    public get workDayPanelToolbarDate() : string {
        return this.get(this.workDayPanelToolbarDateLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.Search" (Search)
    */
    public get workDayPanelToolbarSearch() : string {
        return this.get(this.workDayPanelToolbarSearchLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.ExportMepco" (Export salary file in Mepco format (.csv))
    */
    public get workDayPanelToolbarExportMepco() : string {
        return this.get(this.workDayPanelToolbarExportMepcoLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.AnySalaryHours" (Any salary hours)
    */
    public get workDayPanelToolbarAnySalaryHours() : string {
        return this.get(this.workDayPanelToolbarAnySalaryHoursLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.AssignedWarehouses" (Assigned warehouses)
    */
    public get workDayPanelToolbarAssignedWarehouses() : string {
        return this.get(this.workDayPanelToolbarAssignedWarehousesLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.ConstructionSitesInfoSubText" (Active and assigned construction sites)
    */
    public get workDayPanelToolbarConstructionSitesInfoSubText() : string {
        return this.get(this.workDayPanelToolbarConstructionSitesInfoSubTextLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.ExportMepcoSubText" (Choose rows with state 'Approved by director' to export)
    */
    public get workDayPanelToolbarExportMepcoSubText() : string {
        return this.get(this.workDayPanelToolbarExportMepcoSubTextLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.AnySubText" (Any construction sites or warehouse)
    */
    public get workDayPanelToolbarAnySubText() : string {
        return this.get(this.workDayPanelToolbarAnySubTextLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.NavisionTitle" (Export to Microsoft Dynamics NAV format)
    */
    public get invoiceToolbarNavisionTitle() : string {
        return this.get(this.invoiceToolbarNavisionTitleLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.Navision" (Navision)
    */
    public get invoiceToolbarNavision() : string {
        return this.get(this.invoiceToolbarNavisionLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.ConstructionSiteNameOrNumber" (Construction site name or number)
    */
    public get invoiceToolbarConstructionSiteNameOrNumber() : string {
        return this.get(this.invoiceToolbarConstructionSiteNameOrNumberLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.CustomerNameOrNumber" (Customer name or number)
    */
    public get invoiceToolbarCustomerNameOrNumber() : string {
        return this.get(this.invoiceToolbarCustomerNameOrNumberLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.InvoiceTitle" (Invoice number, code or reference)
    */
    public get invoiceToolbarInvoiceTitle() : string {
        return this.get(this.invoiceToolbarInvoiceTitleLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.Invoice" (Invoice)
    */
    public get invoiceToolbarInvoice() : string {
        return this.get(this.invoiceToolbarInvoiceLanguageItemName);
    }

    /**
    /* "InvoiceToolbar.AnyState" (Any state)
    */
    public get invoiceToolbarAnyState() : string {
        return this.get(this.invoiceToolbarAnyStateLanguageItemName);
    }

    /**
    /* "WorkDayPanel.Allowance" (Allowance)
    */
    public get workDayPanelAllowance() : string {
        return this.get(this.workDayPanelAllowanceLanguageItemName);
    }

    /**
    /* "WorkDayPanel.Equipment" (Equipment)
    */
    public get workDayPanelEquipment() : string {
        return this.get(this.workDayPanelEquipmentLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.DailyHours" (Daily hours)
    */
    public get workDayPanelToolbarDailyHours() : string {
        return this.get(this.workDayPanelToolbarDailyHoursLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.DailyHoursSubText" (Employees hours per day, construction site & task.)
    */
    public get workDayPanelToolbarDailyHoursSubText() : string {
        return this.get(this.workDayPanelToolbarDailyHoursSubTextLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.Months" (Months)
    */
    public get workDayPanelToolbarMonths() : string {
        return this.get(this.workDayPanelToolbarMonthsLanguageItemName);
    }

    /**
    /* "TasksPanel.Confirmation.ExtraModule" (Are you sure that you want to create extra module for this task?)
    */
    public get tasksPanelConfirmationExtraModule() : string {
        return this.get(this.tasksPanelConfirmationExtraModuleLanguageItemName);
    }

    /**
    /* "TasksPanel.ExtraModuleCreated" (Extra module has been successfully created)
    */
    public get tasksPanelExtraModuleCreated() : string {
        return this.get(this.tasksPanelExtraModuleCreatedLanguageItemName);
    }

    /**
    /* "Form.Input.ContractSalaryHourlyPrice" (Contract salary hourly price)
    */
    public get formInputContractSalaryHourlyPrice() : string {
        return this.get(this.formInputContractSalaryHourlyPriceLanguageItemName);
    }

    /**
    /* "Form.Input.WorkCardId" (Work card id)
    */
    public get formInputWorkCardId() : string {
        return this.get(this.formInputWorkCardIdLanguageItemName);
    }

    /**
    /* "Form.Input.CostPool" (Cost pool)
    */
    public get formInputCostPool() : string {
        return this.get(this.formInputCostPoolLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.Periods" (Periods)
    */
    public get workDayPanelToolbarPeriods() : string {
        return this.get(this.workDayPanelToolbarPeriodsLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.InvoicePeriods" (Invoice periods)
    */
    public get workDayPanelToolbarInvoicePeriods() : string {
        return this.get(this.workDayPanelToolbarInvoicePeriodsLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.SalaryPeriods" (Salary periods)
    */
    public get workDayPanelToolbarSalaryPeriods() : string {
        return this.get(this.workDayPanelToolbarSalaryPeriodsLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.Any" (Any)
    */
    public get workDayPanelToolbarAny() : string {
        return this.get(this.workDayPanelToolbarAnyLanguageItemName);
    }

    /**
    /* "WorkDayPanelToolbar.ExportTikon" (Export salary file in Mepco format (.csv))
    */
    public get workDayPanelToolbarExportTikon() : string {
        return this.get(this.workDayPanelToolbarExportTikonLanguageItemName);
    }

    /**
    /* "SubContractors.AddSubcontractor" (Add subcontractor)
    */
    public get subContractorsAddSubcontractor() : string {
        return this.get(this.subContractorsAddSubcontractorLanguageItemName);
    }

    /**
    /* "SubContractors.Title" (Subcontractors)
    */
    public get subContractorsTitle() : string {
        return this.get(this.subContractorsTitleLanguageItemName);
    }

    /**
    /* "SubContractors.AddNewSubcontractor" (Create new subcontractor)
    */
    public get subContractorsAddNewSubcontractor() : string {
        return this.get(this.subContractorsAddNewSubcontractorLanguageItemName);
    }

    /**
    /* "SubcontractorCreated.Flyout" (Subcontractor {0} successfully created.)
    */
    public get subcontractorCreatedFlyout() : string {
        return this.get(this.subcontractorCreatedFlyoutLanguageItemName);
    }

    /**
    /* "SubcontractorPanel.SubcontractorAdded.Flyout" (Subcontractor {0} successfully created (added to a site).)
    */
    public get subcontractorPanelSubcontractorAddedFlyout() : string {
        return this.get(this.subcontractorPanelSubcontractorAddedFlyoutLanguageItemName);
    }

    /**
    /* "SubcontractorPanel.SubcontractorRestored.Flyout" (Subcontractor {0} restored successfully (subcontractor was marked as deleted).)
    */
    public get subcontractorPanelSubcontractorRestoredFlyout() : string {
        return this.get(this.subcontractorPanelSubcontractorRestoredFlyoutLanguageItemName);
    }

    /**
    /* "Tasks.Mounters" (Mounters)
    */
    public get tasksMounters() : string {
        return this.get(this.tasksMountersLanguageItemName);
    }

    /**
    /* "Tasks.Type" (Type)
    */
    public get tasksType() : string {
        return this.get(this.tasksTypeLanguageItemName);
    }

    /**
    /* "Tasks.Name" (Name)
    */
    public get tasksName() : string {
        return this.get(this.tasksNameLanguageItemName);
    }

    /**
    /* "Tasks.Start" (Start)
    */
    public get tasksStart() : string {
        return this.get(this.tasksStartLanguageItemName);
    }

    /**
    /* "Tasks.Done" (Done)
    */
    public get tasksDone() : string {
        return this.get(this.tasksDoneLanguageItemName);
    }

    /**
    /* "Tasks.Hours" (Hours)
    */
    public get tasksHours() : string {
        return this.get(this.tasksHoursLanguageItemName);
    }

    /**
    /* "Tasks.ExtraHours" (Extra hours)
    */
    public get tasksExtraHours() : string {
        return this.get(this.tasksExtraHoursLanguageItemName);
    }

    /**
    /* "Tasks.Date" (Date)
    */
    public get tasksDate() : string {
        return this.get(this.tasksDateLanguageItemName);
    }

    /**
    /* "TasksToolbar.Search" (Search)
    */
    public get tasksToolbarSearch() : string {
        return this.get(this.tasksToolbarSearchLanguageItemName);
    }

    /**
    /* "TasksToolbar.Date" (Date:)
    */
    public get tasksToolbarDate() : string {
        return this.get(this.tasksToolbarDateLanguageItemName);
    }

    /**
    /* "TasksToolbar.ClearFilters" (Clear filters)
    */
    public get tasksToolbarClearFilters() : string {
        return this.get(this.tasksToolbarClearFiltersLanguageItemName);
    }

    /**
    /* "Component.SignatureWidget.Clear" (Clear)
    */
    public get componentSignatureWidgetClear() : string {
        return this.get(this.componentSignatureWidgetClearLanguageItemName);
    }

    /**
    /* "Component.SignatureWidget.Done" (Done)
    */
    public get componentSignatureWidgetDone() : string {
        return this.get(this.componentSignatureWidgetDoneLanguageItemName);
    }

    /**
    /* "Component.Modal.SaveChanges" (Save changes)
    */
    public get componentModalSaveChanges() : string {
        return this.get(this.componentModalSaveChangesLanguageItemName);
    }

    /**
    /* "Component.Modal.Close" (Close)
    */
    public get componentModalClose() : string {
        return this.get(this.componentModalCloseLanguageItemName);
    }

    /**
    /* "Component.PageContainer.PageHelp" (Page help)
    */
    public get componentPageContainerPageHelp() : string {
        return this.get(this.componentPageContainerPageHelpLanguageItemName);
    }

    /**
    /* "SubcontractorWorkDayPanel.Subcontractors" (Subcontractors)
    */
    public get subcontractorWorkDayPanelSubcontractors() : string {
        return this.get(this.subcontractorWorkDayPanelSubcontractorsLanguageItemName);
    }

    /**
    /* "SubcontractorWorkDayPanel.Managers" (Managers)
    */
    public get subcontractorWorkDayPanelManagers() : string {
        return this.get(this.subcontractorWorkDayPanelManagersLanguageItemName);
    }

    /**
    /* "SubcontractorWorkDayPanel.Mounters" (Mounters)
    */
    public get subcontractorWorkDayPanelMounters() : string {
        return this.get(this.subcontractorWorkDayPanelMountersLanguageItemName);
    }

    /**
    /* "UserManagement.UserDeleted" (User account {0} deleted successfully.)
    */
    public get userManagementUserDeleted() : string {
        return this.get(this.userManagementUserDeletedLanguageItemName);
    }

    /**
    /* "UserManagement.UserDeletedPermanently" (User account "{0}" was permanently deleted.)
    */
    public get userManagementUserDeletedPermanently() : string {
        return this.get(this.userManagementUserDeletedPermanentlyLanguageItemName);
    }

    /**
    /* "UserManagement.Button.Restore" (Restore)
    */
    public get userManagementButtonRestore() : string {
        return this.get(this.userManagementButtonRestoreLanguageItemName);
    }

    /**
    /* "UserManagement.Button.Delete" (Delete)
    */
    public get userManagementButtonDelete() : string {
        return this.get(this.userManagementButtonDeleteLanguageItemName);
    }

    /**
    /* "UserManagement.Button.Unlock" (Unlock)
    */
    public get userManagementButtonUnlock() : string {
        return this.get(this.userManagementButtonUnlockLanguageItemName);
    }

    /**
    /* "Dashboard.CreateTaskDescription" (Create a new task)
    */
    public get dashboardCreateTaskDescription() : string {
        return this.get(this.dashboardCreateTaskDescriptionLanguageItemName);
    }

    /**
    /* "Dashboard.CreateTaskForCurrentSiteDescription" (Create a new task for current construction site)
    */
    public get dashboardCreateTaskForCurrentSiteDescription() : string {
        return this.get(this.dashboardCreateTaskForCurrentSiteDescriptionLanguageItemName);
    }

    /**
    /* "Dashboard.SelectTask" (Select a task)
    */
    public get dashboardSelectTask() : string {
        return this.get(this.dashboardSelectTaskLanguageItemName);
    }

    /**
    /* "Dashboard.SwitchTask" (Switch task)
    */
    public get dashboardSwitchTask() : string {
        return this.get(this.dashboardSwitchTaskLanguageItemName);
    }

    /**
    /* "Dashboard.SwitchTaskDescription" (Close current and switch to next task)
    */
    public get dashboardSwitchTaskDescription() : string {
        return this.get(this.dashboardSwitchTaskDescriptionLanguageItemName);
    }

    /**
    /* "RentaTasks.Dashboard.GetManual" (Welcome to Renta Tasks dashboard, press Sign-in to start Your workday.\n\nAfter successful login You can change construction site or pickup a new task from the same page.\n\nWhen your workday is finished press Sign-out to start checkout process.)
    */
    public get rentaTasksDashboardGetManual() : string {
        return this.get(this.rentaTasksDashboardGetManualLanguageItemName);
    }

    /**
    /* "SelectTask.DropdownTask.Label" (Task)
    */
    public get selectTaskDropdownTaskLabel() : string {
        return this.get(this.selectTaskDropdownTaskLabelLanguageItemName);
    }

    /**
    /* "SelectTask.DropdownTask.Description" (Press to select task)
    */
    public get selectTaskDropdownTaskDescription() : string {
        return this.get(this.selectTaskDropdownTaskDescriptionLanguageItemName);
    }

    /**
    /* "SelectTask.GetManual" (Select a task You are going to work on from dropdown menu by pressing on Task widget)
    */
    public get selectTaskGetManual() : string {
        return this.get(this.selectTaskGetManualLanguageItemName);
    }

    /**
    /* "SelectTask.FetchTasks.Error" (No tasks available for selected site.\nYou can sign-in without task selection.\nSwipe to right to sign-in.)
    */
    public get selectTaskFetchTasksError() : string {
        return this.get(this.selectTaskFetchTasksErrorLanguageItemName);
    }

    /**
    /* "SelectOrganization.DropdownOrganization.Label" (Organization)
    */
    public get selectOrganizationDropdownOrganizationLabel() : string {
        return this.get(this.selectOrganizationDropdownOrganizationLabelLanguageItemName);
    }

    /**
    /* "SelectOrganization.DropdownOrganization.Description" (Press to select organization)
    */
    public get selectOrganizationDropdownOrganizationDescription() : string {
        return this.get(this.selectOrganizationDropdownOrganizationDescriptionLanguageItemName);
    }

    /**
    /* "SelectOrganization.GetManual" (Select a organization You are going to work on from dropdown menu by pressing on Organization widget)
    */
    public get selectOrganizationGetManual() : string {
        return this.get(this.selectOrganizationGetManualLanguageItemName);
    }

    /**
    /* "Component.NavigationWidget.Previous" (Previous)
    */
    public get componentNavigationWidgetPrevious() : string {
        return this.get(this.componentNavigationWidgetPreviousLanguageItemName);
    }

    /**
    /* "Component.NavigationWidget.ReturnToPrevious" (Return to previous step)
    */
    public get componentNavigationWidgetReturnToPrevious() : string {
        return this.get(this.componentNavigationWidgetReturnToPreviousLanguageItemName);
    }

    /**
    /* "Component.NavigationWidget.Next" (Next)
    */
    public get componentNavigationWidgetNext() : string {
        return this.get(this.componentNavigationWidgetNextLanguageItemName);
    }

    /**
    /* "Component.NavigationWidget.GoToNext" (Go to next step)
    */
    public get componentNavigationWidgetGoToNext() : string {
        return this.get(this.componentNavigationWidgetGoToNextLanguageItemName);
    }

    /**
    /* "Task.AdditionalEquipments" (Additional equipments)
    */
    public get taskAdditionalEquipments() : string {
        return this.get(this.taskAdditionalEquipmentsLanguageItemName);
    }

    /**
    /* "Task.AdditionalEquipmentsDescription" (Need to add equipments to the task)
    */
    public get taskAdditionalEquipmentsDescription() : string {
        return this.get(this.taskAdditionalEquipmentsDescriptionLanguageItemName);
    }

    /**
    /* "Task.Hours" (Hours)
    */
    public get taskHours() : string {
        return this.get(this.taskHoursLanguageItemName);
    }

    /**
    /* "Task.HoursDescription" (Amount of hours spent for the task)
    */
    public get taskHoursDescription() : string {
        return this.get(this.taskHoursDescriptionLanguageItemName);
    }

    /**
    /* "Task.InProgress" (In progress)
    */
    public get taskInProgress() : string {
        return this.get(this.taskInProgressLanguageItemName);
    }

    /**
    /* "Task.Done" (Done)
    */
    public get taskDone() : string {
        return this.get(this.taskDoneLanguageItemName);
    }

    /**
    /* "Task.TaskStatus" (Task status)
    */
    public get taskTaskStatus() : string {
        return this.get(this.taskTaskStatusLanguageItemName);
    }

    /**
    /* "Task.TaskStatusDescription" (Indicates whether task is finished or not)
    */
    public get taskTaskStatusDescription() : string {
        return this.get(this.taskTaskStatusDescriptionLanguageItemName);
    }

    /**
    /* "Task.Approve" (Approve)
    */
    public get taskApprove() : string {
        return this.get(this.taskApproveLanguageItemName);
    }

    /**
    /* "Task.ApproveDescription" (Approve the task by customer)
    */
    public get taskApproveDescription() : string {
        return this.get(this.taskApproveDescriptionLanguageItemName);
    }

    /**
    /* "Task.Confirm" (Confirm)
    */
    public get taskConfirm() : string {
        return this.get(this.taskConfirmLanguageItemName);
    }

    /**
    /* "Task.GetManual" (Checkout each task You have been working on today by selecting amount of hours spent on it (for extra tasks only)\nand adjust current status of the task by using widgets.\n\nPress sign-out button to finish Your workday.)
    */
    public get taskGetManual() : string {
        return this.get(this.taskGetManualLanguageItemName);
    }

    /**
    /* "Distance.TravelDistance" (Travel distance, km)
    */
    public get distanceTravelDistance() : string {
        return this.get(this.distanceTravelDistanceLanguageItemName);
    }

    /**
    /* "Distance.TravelDistanceDescription" (Verify travel distance to the working site)
    */
    public get distanceTravelDistanceDescription() : string {
        return this.get(this.distanceTravelDistanceDescriptionLanguageItemName);
    }

    /**
    /* "Distance.SignOut" (Sign out)
    */
    public get distanceSignOut() : string {
        return this.get(this.distanceSignOutLanguageItemName);
    }

    /**
    /* "Distance.GetManual" (Adjust Your travel distance and amount of passengers with Travel distance and Passengers widgets.)
    */
    public get distanceGetManual() : string {
        return this.get(this.distanceGetManualLanguageItemName);
    }

    /**
    /* "SelectConstructionSite.GetManual" (Select construction site from dropdown menu by clicking on Construction site widget, or use QR code scanner widget. By default the closest construction site is chosen accordion to Your current location.)
    */
    public get selectConstructionSiteGetManual() : string {
        return this.get(this.selectConstructionSiteGetManualLanguageItemName);
    }

    /**
    /* "SelectConstructionSite.ConstructionSite" (Construction site)
    */
    public get selectConstructionSiteConstructionSite() : string {
        return this.get(this.selectConstructionSiteConstructionSiteLanguageItemName);
    }

    /**
    /* "SelectConstructionSite.ConstructionSiteDescription" (Press to select construction site)
    */
    public get selectConstructionSiteConstructionSiteDescription() : string {
        return this.get(this.selectConstructionSiteConstructionSiteDescriptionLanguageItemName);
    }

    /**
    /* "Approve.Combine" (Combine)
    */
    public get approveCombine() : string {
        return this.get(this.approveCombineLanguageItemName);
    }

    /**
    /* "Approve.CombineDescription" (Combine current task with other processed task to approve)
    */
    public get approveCombineDescription() : string {
        return this.get(this.approveCombineDescriptionLanguageItemName);
    }

    /**
    /* "Approve.WorkReportName" (Work report name)
    */
    public get approveWorkReportName() : string {
        return this.get(this.approveWorkReportNameLanguageItemName);
    }

    /**
    /* "Approve.WorkReportNameDescription" (specify work report name)
    */
    public get approveWorkReportNameDescription() : string {
        return this.get(this.approveWorkReportNameDescriptionLanguageItemName);
    }

    /**
    /* "Approve.GetManual" (Adjust Your travel distance and amount of passengers with Travel distance and Passengers widgets.)
    */
    public get approveGetManual() : string {
        return this.get(this.approveGetManualLanguageItemName);
    }

    /**
    /* "Allowance.NoDaily" (No daily allowance)
    */
    public get allowanceNoDaily() : string {
        return this.get(this.allowanceNoDailyLanguageItemName);
    }

    /**
    /* "Allowance.OwnTools" (Own tools or equipment)
    */
    public get allowanceOwnTools() : string {
        return this.get(this.allowanceOwnToolsLanguageItemName);
    }

    /**
    /* "Allowance.OwnToolsDescription" (Indicates, whether or not you use own tools or equipment)
    */
    public get allowanceOwnToolsDescription() : string {
        return this.get(this.allowanceOwnToolsDescriptionLanguageItemName);
    }

    /**
    /* "Allowance.GetManual" (Select Your daily allowance from dropdown menu by pressing on Daily allowance widget.\nIf own equipment was used press on Own tools or equipment widget.)
    */
    public get allowanceGetManual() : string {
        return this.get(this.allowanceGetManualLanguageItemName);
    }

    /**
    /* "Signature.ApprovalType" (Approval type)
    */
    public get signatureApprovalType() : string {
        return this.get(this.signatureApprovalTypeLanguageItemName);
    }

    /**
    /* "Signature.ApprovalTypeDescription" (Choose approval type)
    */
    public get signatureApprovalTypeDescription() : string {
        return this.get(this.signatureApprovalTypeDescriptionLanguageItemName);
    }

    /**
    /* "Signature.Signature" (Signature)
    */
    public get signatureSignature() : string {
        return this.get(this.signatureSignatureLanguageItemName);
    }

    /**
    /* "Signature.SignatureDescription" (Ask customer to draw his signature to approve)
    */
    public get signatureSignatureDescription() : string {
        return this.get(this.signatureSignatureDescriptionLanguageItemName);
    }

    /**
    /* "Signature.GetManual" (Adjust Your travel distance and amount of passengers with Travel distance and Passengers widgets.)
    */
    public get signatureGetManual() : string {
        return this.get(this.signatureGetManualLanguageItemName);
    }

    /**
    /* "QrWidget.Scan.Error" (QR code scanner is not available, probably no permissions to camera on your mobile device.)
    */
    public get qrWidgetScanError() : string {
        return this.get(this.qrWidgetScanErrorLanguageItemName);
    }

    /**
    /* "AddConstructionsite.Title" (Add construction site)
    */
    public get addConstructionsiteTitle() : string {
        return this.get(this.addConstructionsiteTitleLanguageItemName);
    }

    /**
    /* "AddContactPersonModal.Create" (Create)
    */
    public get addContactPersonModalCreate() : string {
        return this.get(this.addContactPersonModalCreateLanguageItemName);
    }

    /**
    /* "AddEquipment.EquipmentList" (Equipment list)
    */
    public get addEquipmentEquipmentList() : string {
        return this.get(this.addEquipmentEquipmentListLanguageItemName);
    }

    /**
    /* "AddEquipment.Products" (Products)
    */
    public get addEquipmentProducts() : string {
        return this.get(this.addEquipmentProductsLanguageItemName);
    }

    /**
    /* "AddEquipment.ProductsDescription" (Choose product to add to equipment list)
    */
    public get addEquipmentProductsDescription() : string {
        return this.get(this.addEquipmentProductsDescriptionLanguageItemName);
    }

    /**
    /* "AddMounterModal.Task" (Task)
    */
    public get addMounterModalTask() : string {
        return this.get(this.addMounterModalTaskLanguageItemName);
    }

    /**
    /* "AddTask.StartDate" (Start date)
    */
    public get addTaskStartDate() : string {
        return this.get(this.addTaskStartDateLanguageItemName);
    }

    /**
    /* "AddTask.StartDateDescription" (Specify a date when task should be in progress)
    */
    public get addTaskStartDateDescription() : string {
        return this.get(this.addTaskStartDateDescriptionLanguageItemName);
    }

    /**
    /* "AddTask.TaskDescription" (Task description)
    */
    public get addTaskTaskDescription() : string {
        return this.get(this.addTaskTaskDescriptionLanguageItemName);
    }

    /**
    /* "AddTask.TaskDescriptionDescription" (Specify the description of the task)
    */
    public get addTaskTaskDescriptionDescription() : string {
        return this.get(this.addTaskTaskDescriptionDescriptionLanguageItemName);
    }

    /**
    /* "AddTask.TaskName" (Task name)
    */
    public get addTaskTaskName() : string {
        return this.get(this.addTaskTaskNameLanguageItemName);
    }

    /**
    /* "AddTask.TaskNameDescription" (Specify the task name)
    */
    public get addTaskTaskNameDescription() : string {
        return this.get(this.addTaskTaskNameDescriptionLanguageItemName);
    }

    /**
    /* "AddTaskModal.Agreement" (Agreement)
    */
    public get addTaskModalAgreement() : string {
        return this.get(this.addTaskModalAgreementLanguageItemName);
    }

    /**
    /* "AddTaskModal.ChangeTask" (Edit task)
    */
    public get addTaskModalChangeTask() : string {
        return this.get(this.addTaskModalChangeTaskLanguageItemName);
    }

    /**
    /* "AddTaskModal.CreateExtraModule" (Create Extra Module)
    */
    public get addTaskModalCreateExtraModule() : string {
        return this.get(this.addTaskModalCreateExtraModuleLanguageItemName);
    }

    /**
    /* "AddTaskModal.Delete" (Delete)
    */
    public get addTaskModalDelete() : string {
        return this.get(this.addTaskModalDeleteLanguageItemName);
    }

    /**
    /* "AddTaskModal.Delete.Confirm" (Do you really want to delete this task?)
    */
    public get addTaskModalDeleteConfirm() : string {
        return this.get(this.addTaskModalDeleteConfirmLanguageItemName);
    }

    /**
    /* "AddTaskModal.SaveTask" (Save task)
    */
    public get addTaskModalSaveTask() : string {
        return this.get(this.addTaskModalSaveTaskLanguageItemName);
    }

    /**
    /* "AddTaskModal.SiteOrWarehouse" (Site or warehouse)
    */
    public get addTaskModalSiteOrWarehouse() : string {
        return this.get(this.addTaskModalSiteOrWarehouseLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.AddCompletedExtraTask" (Add completed extra task)
    */
    public get addWorkReportModalAddCompletedExtraTask() : string {
        return this.get(this.addWorkReportModalAddCompletedExtraTaskLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.DateTaskCompleted" (Date when task was completed)
    */
    public get addWorkReportModalDateTaskCompleted() : string {
        return this.get(this.addWorkReportModalDateTaskCompletedLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.DescriptionOfTask" (Description of the task)
    */
    public get addWorkReportModalDescriptionOfTask() : string {
        return this.get(this.addWorkReportModalDescriptionOfTaskLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.ExistingExtraTasks" (Existing extra tasks)
    */
    public get addWorkReportModalExistingExtraTasks() : string {
        return this.get(this.addWorkReportModalExistingExtraTasksLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.RemoveTaskWorkReport" (Remove task from work report)
    */
    public get addWorkReportModalRemoveTaskWorkReport() : string {
        return this.get(this.addWorkReportModalRemoveTaskWorkReportLanguageItemName);
    }

    /**
    /* "UserManagement.SettingsKey" (Setting)
    */
    public get userManagementSettingsKey() : string {
        return this.get(this.userManagementSettingsKeyLanguageItemName);
    }

    /**
    /* "UserManagement.SettingsValue" (Value)
    */
    public get userManagementSettingsValue() : string {
        return this.get(this.userManagementSettingsValueLanguageItemName);
    }

    /**
    /* "UserManagement.ShowDeleted" (Show deleted)
    */
    public get userManagementShowDeleted() : string {
        return this.get(this.userManagementShowDeletedLanguageItemName);
    }

    /**
    /* "UserManagement.UserRestored" (User account {0} restored successfully.)
    */
    public get userManagementUserRestored() : string {
        return this.get(this.userManagementUserRestoredLanguageItemName);
    }

    /**
    /* "AuditModule.GetManual" (Audit module.\nPress \"Activate\" button for that.\nIt will create and activate task corresponding task.\n\nTask marked as split cannot be activated.)
    */
    public get auditModuleGetManual() : string {
        return this.get(this.auditModuleGetManualLanguageItemName);
    }

    /**
    /* "BaseInput.TotalSizeTooBig" (Total size of documents is too big)
    */
    public get baseInputTotalSizeTooBig() : string {
        return this.get(this.baseInputTotalSizeTooBigLanguageItemName);
    }

    /**
    /* "ConstructionSiteManagement.AddAgreement" (Add new agreement)
    */
    public get constructionSiteManagementAddAgreement() : string {
        return this.get(this.constructionSiteManagementAddAgreementLanguageItemName);
    }

    /**
    /* "ConstructionSiteAgreement.Deactivated" (Deactivated)
    */
    public get constructionSiteAgreementDeactivated() : string {
        return this.get(this.constructionSiteAgreementDeactivatedLanguageItemName);
    }

    /**
    /* "ConstructionSiteAgreement.ContactUser" (Contact: )
    */
    public get constructionSiteAgreementContactUser() : string {
        return this.get(this.constructionSiteAgreementContactUserLanguageItemName);
    }

    /**
    /* "ConstructionSitePanel.OrganizationContract" (Organization Contract)
    */
    public get constructionSitePanelOrganizationContract() : string {
        return this.get(this.constructionSitePanelOrganizationContractLanguageItemName);
    }

    /**
    /* "ConstructionSitePanel.PaymentTerms" (Payment terms code)
    */
    public get constructionSitePanelPaymentTerms() : string {
        return this.get(this.constructionSitePanelPaymentTermsLanguageItemName);
    }

    /**
    /* "Dashboard.SwitchSite" (Switch construction site)
    */
    public get dashboardSwitchSite() : string {
        return this.get(this.dashboardSwitchSiteLanguageItemName);
    }

    /**
    /* "Dashboard.SwitchSiteDescription" (Check-in to next construction site)
    */
    public get dashboardSwitchSiteDescription() : string {
        return this.get(this.dashboardSwitchSiteDescriptionLanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeType.Assembly" (Assembly)
    */
    public get enumExtraChargeTypeAssembly() : string {
        return this.get(this.enumExtraChargeTypeAssemblyLanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeType.CoverSales" (Cover sales)
    */
    public get enumExtraChargeTypeCoverSales() : string {
        return this.get(this.enumExtraChargeTypeCoverSalesLanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeType.Delivery" (Delivery)
    */
    public get enumExtraChargeTypeDelivery() : string {
        return this.get(this.enumExtraChargeTypeDeliveryLanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeType.Dismantle" (Dismantle)
    */
    public get enumExtraChargeTypeDismantle() : string {
        return this.get(this.enumExtraChargeTypeDismantleLanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeType.OtherEquipmentSales" (Other equipment sales)
    */
    public get enumExtraChargeTypeOtherEquipmentSales() : string {
        return this.get(this.enumExtraChargeTypeOtherEquipmentSalesLanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeType.Return" (Return)
    */
    public get enumExtraChargeTypeReturn() : string {
        return this.get(this.enumExtraChargeTypeReturnLanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeType.ScaffoldingEquipmentSales" (Scaffolding equipment sales)
    */
    public get enumExtraChargeTypeScaffoldingEquipmentSales() : string {
        return this.get(this.enumExtraChargeTypeScaffoldingEquipmentSalesLanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeUnit.Hour" (Hour)
    */
    public get enumExtraChargeUnitHour() : string {
        return this.get(this.enumExtraChargeUnitHourLanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeUnit.M2" (Squeare meter)
    */
    public get enumExtraChargeUnitM2() : string {
        return this.get(this.enumExtraChargeUnitM2LanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeUnit.Pcs" (Piece)
    */
    public get enumExtraChargeUnitPcs() : string {
        return this.get(this.enumExtraChargeUnitPcsLanguageItemName);
    }

    /**
    /* "Enum.InvoiceRowType.TaskEquipment" (Equipment)
    */
    public get enumInvoiceRowTypeTaskEquipment() : string {
        return this.get(this.enumInvoiceRowTypeTaskEquipmentLanguageItemName);
    }

    /**
    /* "Enum.InvoiceRowType.TaskEquipment.Description" (3050)
    */
    public get enumInvoiceRowTypeTaskEquipmentDescription() : string {
        return this.get(this.enumInvoiceRowTypeTaskEquipmentDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceRowType.TaskExtraCharge" (Extra charge)
    */
    public get enumInvoiceRowTypeTaskExtraCharge() : string {
        return this.get(this.enumInvoiceRowTypeTaskExtraChargeLanguageItemName);
    }

    /**
    /* "Enum.InvoiceRowType.WorkReports" (Work reports)
    */
    public get enumInvoiceRowTypeWorkReports() : string {
        return this.get(this.enumInvoiceRowTypeWorkReportsLanguageItemName);
    }

    /**
    /* "Enum.ModuleModel.Modules" (Modules)
    */
    public get enumModuleModelModules() : string {
        return this.get(this.enumModuleModelModulesLanguageItemName);
    }

    /**
    /* "Form.Input.Middlename" (Middle name)
    */
    public get formInputMiddlename() : string {
        return this.get(this.formInputMiddlenameLanguageItemName);
    }

    /**
    /* "Generic.Approval" (Approval)
    */
    public get genericApproval() : string {
        return this.get(this.genericApprovalLanguageItemName);
    }

    /**
    /* "Generic.Constructionsite" (Construction site)
    */
    public get genericConstructionsite() : string {
        return this.get(this.genericConstructionsiteLanguageItemName);
    }

    /**
    /* "Generic.Date" (Date)
    */
    public get genericDate() : string {
        return this.get(this.genericDateLanguageItemName);
    }

    /**
    /* "Generic.Loading" (Loading..)
    */
    public get genericLoading() : string {
        return this.get(this.genericLoadingLanguageItemName);
    }

    /**
    /* "Generic.UnlockForEditing" (Unlock for editing\n (Approved by {0}, at {1}))
    */
    public get genericUnlockForEditing() : string {
        return this.get(this.genericUnlockForEditingLanguageItemName);
    }

    /**
    /* "ImageModal.PreviewNotSupported" (Preview is not supported for this type of file, but you can download it instead)
    */
    public get imageModalPreviewNotSupported() : string {
        return this.get(this.imageModalPreviewNotSupportedLanguageItemName);
    }

    /**
    /* "Invoices.CreditInvoiceCreated" (Credit invoice {0} created successfully.)
    */
    public get invoicesCreditInvoiceCreated() : string {
        return this.get(this.invoicesCreditInvoiceCreatedLanguageItemName);
    }

    /**
    /* "Invoices.CreditInvoiceCustomerConfirmation" (Are you sure\nyou want credit invoice\n<mark>#{0}</mark> on <mark>{1:C}€</mark>\nfor customer\n'<mark>{2}</mark>'?)
    */
    public get invoicesCreditInvoiceCustomerConfirmation() : string {
        return this.get(this.invoicesCreditInvoiceCustomerConfirmationLanguageItemName);
    }

    /**
    /* "Invoices.ExportInfo" (You are going to export {0} invoices for {1} company(s).)
    */
    public get invoicesExportInfo() : string {
        return this.get(this.invoicesExportInfoLanguageItemName);
    }

    /**
    /* "Invoices.NothingSelected" (Nothing selected.)
    */
    public get invoicesNothingSelected() : string {
        return this.get(this.invoicesNothingSelectedLanguageItemName);
    }

    /**
    /* "Invoices.InvoiceCustomerConfirmation" (Are you sure\nyou want bill invoice\n<mark>#{0}</mark> on <mark>{1:C}€</mark>\nfor customer\n'<mark>{2}</mark>'?)
    */
    public get invoicesInvoiceCustomerConfirmation() : string {
        return this.get(this.invoicesInvoiceCustomerConfirmationLanguageItemName);
    }

    /**
    /* "Invoices.MarkedAsExported" (Invoice(s) marked as exported. Store and transfer the file to NAV system.)
    */
    public get invoicesMarkedAsExported() : string {
        return this.get(this.invoicesMarkedAsExportedLanguageItemName);
    }

    /**
    /* "Invoices.SentNumber" (Invoice number)
    */
    public get invoicesSentNumber() : string {
        return this.get(this.invoicesSentNumberLanguageItemName);
    }

    /**
    /* "Invoices.SentToAccounting" (Invoice(s) sent to accounting system successfully.)
    */
    public get invoicesSentToAccounting() : string {
        return this.get(this.invoicesSentToAccountingLanguageItemName);
    }

    /**
    /* "MyAccountPage.DataSaved" (Account information updated successfully)
    */
    public get myAccountPageDataSaved() : string {
        return this.get(this.myAccountPageDataSavedLanguageItemName);
    }

    /**
    /* "MyAccountPage.FiltersBehaviorLabel" (Filters settings)
    */
    public get myAccountPageFiltersBehaviorLabel() : string {
        return this.get(this.myAccountPageFiltersBehaviorLabelLanguageItemName);
    }

    /**
    /* "MyAccountPage.MyDocumentsTabTitle" (My documents)
    */
    public get myAccountPageMyDocumentsTabTitle() : string {
        return this.get(this.myAccountPageMyDocumentsTabTitleLanguageItemName);
    }

    /**
    /* "MyAccountPage.MyInfoTabTitle" (My info)
    */
    public get myAccountPageMyInfoTabTitle() : string {
        return this.get(this.myAccountPageMyInfoTabTitleLanguageItemName);
    }

    /**
    /* "MyAccountPage.Acceptance" (I have read and accept)
    */
    public get myAccountPageAcceptance() : string {
        return this.get(this.myAccountPageAcceptanceLanguageItemName);
    }

    /**
    /* "MyAccountPage.Acceptance.Required" (You must accept terms of usage and privacy notice in order to use application)
    */
    public get myAccountPageAcceptanceRequired() : string {
        return this.get(this.myAccountPageAcceptanceRequiredLanguageItemName);
    }

    /**
    /* "MyAccountPage.Acceptance.Terms" (terms of use)
    */
    public get myAccountPageAcceptanceTerms() : string {
        return this.get(this.myAccountPageAcceptanceTermsLanguageItemName);
    }

    /**
    /* "MyAccountPage.Acceptance.Terms.Title" (RENTA TASK-APPLICATIONS TERMS OF SERVICE)
    */
    public get myAccountPageAcceptanceTermsTitle() : string {
        return this.get(this.myAccountPageAcceptanceTermsTitleLanguageItemName);
    }

    /**
    /* "MyAccountPage.Acceptance.Terms.Content" (1	Common\n\nThe Renta Task Application (the “Application”) is owned and provided by Renta Group Oy (“Renta”).\n\nBy installing the Application and / or using the Application, the Registered Customer or the Unregistered User agrees to these Terms of Use (the "Terms of Use"). If the Registered Customer or the Unregistered User does not accept these Terms of Use, the Registered Customer or the Unregistered User does not have the right to install, open or use the application.\n\nRenta reserves the right to change these Terms of Use at any time without notice. A registered Customer or an Unregistered User shall be deemed to have accepted the updated Terms of Use by using the application after the change to the Terms of Use.\n\n2.	Renta Task application\n\nThe application is for Rentan Employees (Registered Users) and Registered Customers. It is possible to use the application either as an employee of Renta (Registered User) or alternatively as a registered Customer with a customer-specific license ("Registered Customer").\n\n2.1	Registered Customers.\nRegistering as a Customer requires an existing customer relationship with Renta. Renta has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered Customer has the opportunity to view and approve work reports and invoicing for his construction sites through the application.\n\n2.2	Registered Users\nRegistration for the Application requires an existing employment relationship with Renta. Renta has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered User has the opportunity to perform the actions required for work control through the application.\n\nTo ensure the proper operation of the application, the Registered Customer and the Registered User must ensure that they have the latest version of the application.\n\n3.	Product range and price list\n\nThe product range presented in the application corresponds to Renta's normal product range. Product range, product availability and price information may vary from location to location. Prices do not include VAT unless stated otherwise. VAT will be added to the rates upon invoicing.\n\nCustomer-specific price information for contract customers is presented in the Application. The presentation of prices may be limited by access rights.\n\nRenta is not responsible for any errors, omissions or other defects in the price and product information or other material presented in the Application.\n\n4.	Customer-Specific Work Reports\n\n4.1	Generation of a customer-specific work report\nThe work performed by the Registered Users on behalf of the customer forms a work report for the system.\n\n4.2	Processing a customer-specific work report\nThe Registered Customer has the opportunity to view the work reports concerning him or her and to accept and reject the work reports of the work performed. Renta has the right to invoice the work in accordance with the approved work report.\n\n5.	Customer-specific invoices\n\n5.1	Viewing Customer-Specific Invoices\nIt is possible for a registered Customer to view invoices concerning him in the application. Any incorrect invoices must be reclamed in accordance with Renta's instructions.\n\n6.	Intellectual Property Rights\n\nThe application and its content, including e.g. trademarks, trade names, product information and images are the property of Renta and / or its partners, which are protected by e.g. copyright law and international intellectual property agreements. All rights to the Application and its content are reserved. It is expressly stated that the Registered Customer or the Registered User may not sublicense, rent, transfer or otherwise distribute the Application or its rights to use the Application except as permitted in these Terms of Use.\n\nThe Registered Customer or the Registered User shall not have the right to change, modify, delete, copy, publish, make available to the public or transfer any intellectual property rights. Your right to use the application is limited to your use in accordance with these Terms of Use.\n\n7.	Permissions and access rights\n\nThe Registered Customer accepts as binding all measures taken through the Application with the registered Customer's credentials or by or on behalf of the Registered Customer. The use of Registered Customer credentials in the Application corresponds to the Registered Customer's signature.\n\nThe Registered Customer is obliged to keep the credentials carefully stored. If the Registered Customer suspects that the credentials have been forced to possession of a third party, the Registered Customer shall immediately inform the contact person of Renta about the situation. The contact person deletes the old credentials and opens the new ones. The Registered Customer is responsible for all orders placed with his / her username and for any damages that may result from compromising the credentials.\n\n8.	Rentan's responsibility\n\nThe application and its contents are provided to the Registered Customer and the Registered User “as is”. Renta is not responsible for any errors, omissions or other defects in the content transmitted in the Application. Renta does not guarantee the availability of the Application or its uninterrupted or error-free operation. Renta shall not be liable for any costs, losses or other possible direct or indirect damages that may arise from the use of this Application, the information provided in the Application or the non-availability of the Application, subject to mandatory legislation. In any case, Renta's liability is limited to a maximum amount corresponding to the agreed rental equipment rental and / or service price.\n\n9.	Cookies\n\nRenta uses cookies in the Application (so-called cookie function). A cookie is a text file stored in the user's browser when using the Application. For example, cookies make it possible to monitor the number of users of the Application and to collect information on how and when the Application is used.\n\nThe Registered Customer and the Unregistered User can disable the use of cookies in their browser settings. For more information on browser-specific instructions, contact your browser developer. Renta recommends the use of cookies in the Application in order to obtain the best possible user experience.\n\n10.	Third Party Services\n\nThe application may contain links to sites owned or operated by third parties. Renta is not responsible for the operation, content, direct or indirect damages or other features of such third party sites. By accessing these pages, the user must accept the terms of use of these pages and the Privacy Statement before using them.\n\n11.	Processing of personal data\n\nRenta processes and collects the personal data of Registered Customers in order to implement the services and to maintain and develop customer relationships. Renta's privacy statement describes the processing of personal data in more detail: https://renta.fi/en/privacy-policy-and-cookies\n\nThe personal data of unregistered Users will not be collected.\n\n12.	Other Terms\n\nRenta's valid rental terms apply to machine rental and services. The terms and conditions of the annual contracts are complied with with the customers of the annual contracts. The customer agrees to the delivery terms valid for each order.\n\nRenta may change, update, cancel or delete the Application, the contents of the Application or portions thereof at its sole discretion. The Registered Customer or the Registered User must stop using the Application if the Registered Customer or the Registered User does not accept the changes in the Terms of Use of the Application or the privacy statement.\n\nThe Registered Customer and the Unregistered User must use the Application in accordance with the terms of use of the application store from which they have acquired the Application. In all cases, the Registered Customer and the Registered User shall be liable for damages caused by his / her compliance with these Terms of Use.\n\nThe Registered Customer and the Registered User are responsible for the accuracy of the information they provide, for the careful storage of their username and password, and for the proper security of their equipment. The Registered Customer and the Registered User are responsible for all transactions in the Application with their credentials.\n\nThe use of the service and these terms and conditions are governed by Finnish law, except for its choice of law provisions.\n\nThe parties shall endeavor to resolve their differences primarily through negotiations. If no amicable settlement is reached, the disputes will be settled in the Helsinki District Court. The consumer customer can also take the dispute to the Consumer Disputes Board for resolution.\n\n13.	Contact\n\nIf you have any questions about these Terms of Use or the Application, please contact:\n\nRenta Group Oy\nÄyritie 12 B\n01510 Vantaa\nFinland\ninfo@renta.fi\nBusiness ID 2732388-9)
    */
    public get myAccountPageAcceptanceTermsContent() : string {
        return this.get(this.myAccountPageAcceptanceTermsContentLanguageItemName);
    }

    /**
    /* "MyAccountPage.Acceptance.PrivacyNotice" (privacy notice)
    */
    public get myAccountPageAcceptancePrivacyNotice() : string {
        return this.get(this.myAccountPageAcceptancePrivacyNoticeLanguageItemName);
    }

    /**
    /* "MyAccountPage.Acceptance.PrivacyNotice.Title" (RENTA TASK-APPLICATIONS PRIVACY POLICY)
    */
    public get myAccountPageAcceptancePrivacyNoticeTitle() : string {
        return this.get(this.myAccountPageAcceptancePrivacyNoticeTitleLanguageItemName);
    }

    /**
    /* "MyAccountPage.Acceptance.PrivacyNotice.Content" (Sections 10 and 24 of the Personal Data Act 22.4.1999 / 523\nPrepared: 16.10.2019\n\n1.	The Registrar\nRenta Group Oy\nBusiness ID: 2732388-9\nAddress: Äyritie 12B, 01510 Vantaa Finland\n\n2.	The person responsible for registration and / or the contact person\nCIO Joel Särkkä\nPhone number: +35850 323 5569\nEmail: joel.sarkka@renta.fi\n\n3.	Name of the register\nUser register of Renta Group Oy's Renta Task application.\n\n4.	Purpose of the processing of personal data\nRenta Group Oy and its subsidiaries process personal data in the personal identification service, credit information verification, direct marketing, customer communications, to meet employment requirements, and to enable invoicing and personal customer service.\n\nIn addition, the inclusion of the register in the processing of personal data enables logging in to the service, ordering and producing the service, and developing the service.\n\n5.	Information content of the register\nThe following information can be processed in the register:\n•	Basic information of the data subject\n        o	name\n        o	personal identification number\n        o	mail address\n        o	phone number\n        o	e-mail address\n        o	Position in the company\n        o	Consent of the data subject to direct marketing\n•	Company information\n        o	customer related information\n        o	service history\n        o	credit data entries\n        o	 other entries entered by the customer\n•	Technical information\n        o	location information\n        o	IP address\n        o	Device identification\n        o	advertising ID\n        o	operating system\n        o	browser type\n        o	other hardware details\n\n6. Regular sources of information\nPersonal information is collected from the registrant himself and through the Intrum credit information service.\n\n7. Regular data transfers and data transfers outside the EU or the European Economic Area\nThe data will not be disclosed outside the EU or the EEA.\n\n8. Use of cookies in the online service\nWe use cookies in the online service. A cookie is a small text file stored on a user's computer that enables safe, efficient and user-friendly use of the service.\n\nYou can disable and delete cookies in your browser settings.\n\n9. Registry Security Principles\nThe personal data contained in the register will always be treated as confidential. The principles of processing the data contained in the register are instructed and documented in the organizations processing the data.\n\nThe information system is protected by a firewall.\n\nOn the website, data transfer is secured with an SSL-secured connection.\n\n10. Right of prohibition of the data subject\nThe data subject shall have the right to prohibit the controller from processing personal data concerning him or her for direct mail, distance selling and other direct marketing, as well as for market and opinion research, as well as for personal registration and genealogy. The ban can be set via the mobile application or the customer portal.\n\n11. Right of inspection of the data subject\nThe data subject has the right to inspect the personal data stored in the register and to receive copies of it free of charge up to once a year.\n\nThe request for verification must be made by e-mail from an e-mail address that can be verified by the register to belong to the data subject.\n\n12. Correction of information\nThe controller shall correct, delete or supplement personal data in the register that are incorrect, unnecessary, incomplete or out of date for the purpose of processing on its own initiative or at the request of the data subject. In addition, personal data may be deleted if the customer misuses the service or engages in criminal or other prohibited activities using the service.)
    */
    public get myAccountPageAcceptancePrivacyNoticeContent() : string {
        return this.get(this.myAccountPageAcceptancePrivacyNoticeContentLanguageItemName);
    }

    /**
    /* "MyAccountPage.UserAlreadyExists" (User with same email or phone number already exists.)
    */
    public get myAccountPageUserAlreadyExists() : string {
        return this.get(this.myAccountPageUserAlreadyExistsLanguageItemName);
    }

    /**
    /* "OrganizationPanel.ExternalAddress" (External address)
    */
    public get organizationPanelExternalAddress() : string {
        return this.get(this.organizationPanelExternalAddressLanguageItemName);
    }

    /**
    /* "OrganizationPanel.ExternalId" (External id)
    */
    public get organizationPanelExternalId() : string {
        return this.get(this.organizationPanelExternalIdLanguageItemName);
    }

    /**
    /* "RentaTasks.Dashboard.SignOut" (Sign-out)
    */
    public get rentaTasksDashboardSignOut() : string {
        return this.get(this.rentaTasksDashboardSignOutLanguageItemName);
    }

    /**
    /* "SendWorkReportModal.EmailExists" (User with provided email or phone number already exists)
    */
    public get sendWorkReportModalEmailExists() : string {
        return this.get(this.sendWorkReportModalEmailExistsLanguageItemName);
    }

    /**
    /* "Split.ModuleSubTitle" (Split module on parts)
    */
    public get splitModuleSubTitle() : string {
        return this.get(this.splitModuleSubTitleLanguageItemName);
    }

    /**
    /* "Split.ModuleTitle" (Split)
    */
    public get splitModuleTitle() : string {
        return this.get(this.splitModuleTitleLanguageItemName);
    }

    /**
    /* "SubcontractorPanel.DeleteSubcontractor" (Delete subcontractor from warehouse)
    */
    public get subcontractorPanelDeleteSubcontractor() : string {
        return this.get(this.subcontractorPanelDeleteSubcontractorLanguageItemName);
    }

    /**
    /* "SubcontractorPanel.RestoreSubcontractor" (Restore deleted subcontractor)
    */
    public get subcontractorPanelRestoreSubcontractor() : string {
        return this.get(this.subcontractorPanelRestoreSubcontractorLanguageItemName);
    }

    /**
    /* "TaskExtraChangeGrid.NoExtraCharges" (No extra charges)
    */
    public get taskExtraChangeGridNoExtraCharges() : string {
        return this.get(this.taskExtraChangeGridNoExtraChargesLanguageItemName);
    }

    /**
    /* "TaskExtraChangePanel.ExtraChargeType" (Extra charge type)
    */
    public get taskExtraChangePanelExtraChargeType() : string {
        return this.get(this.taskExtraChangePanelExtraChargeTypeLanguageItemName);
    }

    /**
    /* "TasksPanel.AddExtraCharge.Confirmation" (Are you sure that you want to delete extra charge?)
    */
    public get tasksPanelAddExtraChargeConfirmation() : string {
        return this.get(this.tasksPanelAddExtraChargeConfirmationLanguageItemName);
    }

    /**
    /* "TasksPanel.AddExtraCharge.Flyout" (Extra charge for task was created successfully)
    */
    public get tasksPanelAddExtraChargeFlyout() : string {
        return this.get(this.tasksPanelAddExtraChargeFlyoutLanguageItemName);
    }

    /**
    /* "TasksPanel.AddExtraChargeModal.Amount" (Amount)
    */
    public get tasksPanelAddExtraChargeModalAmount() : string {
        return this.get(this.tasksPanelAddExtraChargeModalAmountLanguageItemName);
    }

    /**
    /* "TasksPanel.AddExtraChargeModal.Price" (Price)
    */
    public get tasksPanelAddExtraChargeModalPrice() : string {
        return this.get(this.tasksPanelAddExtraChargeModalPriceLanguageItemName);
    }

    /**
    /* "TasksPanel.AddExtraChargeModal.Submit" (Add extra charge)
    */
    public get tasksPanelAddExtraChargeModalSubmit() : string {
        return this.get(this.tasksPanelAddExtraChargeModalSubmitLanguageItemName);
    }

    /**
    /* "TasksPanel.AddExtraChargeModal.Subtitle" (Add tasks extra charges)
    */
    public get tasksPanelAddExtraChargeModalSubtitle() : string {
        return this.get(this.tasksPanelAddExtraChargeModalSubtitleLanguageItemName);
    }

    /**
    /* "TasksPanel.AddExtraChargeModal.Title" (Task extra charges)
    */
    public get tasksPanelAddExtraChargeModalTitle() : string {
        return this.get(this.tasksPanelAddExtraChargeModalTitleLanguageItemName);
    }

    /**
    /* "TasksPanel.AddExtraChargeModal.Type" (Type)
    */
    public get tasksPanelAddExtraChargeModalType() : string {
        return this.get(this.tasksPanelAddExtraChargeModalTypeLanguageItemName);
    }

    /**
    /* "TasksPanel.AddExtraChargeModal.Unit" (Unit)
    */
    public get tasksPanelAddExtraChargeModalUnit() : string {
        return this.get(this.tasksPanelAddExtraChargeModalUnitLanguageItemName);
    }

    /**
    /* "TasksPanel.Agreement" (Agreement)
    */
    public get tasksPanelAgreement() : string {
        return this.get(this.tasksPanelAgreementLanguageItemName);
    }

    /**
    /* "TasksPanel.ApproveTask" (Approve task to create a invoice row)
    */
    public get tasksPanelApproveTask() : string {
        return this.get(this.tasksPanelApproveTaskLanguageItemName);
    }

    /**
    /* "TasksPanel.ChangeWorkReportTitle" (Change Work Report)
    */
    public get tasksPanelChangeWorkReportTitle() : string {
        return this.get(this.tasksPanelChangeWorkReportTitleLanguageItemName);
    }

    /**
    /* "TasksPanel.ComplitionDate" (Date when task was completed)
    */
    public get tasksPanelComplitionDate() : string {
        return this.get(this.tasksPanelComplitionDateLanguageItemName);
    }

    /**
    /* "TasksPanel.Cost" (Cost)
    */
    public get tasksPanelCost() : string {
        return this.get(this.tasksPanelCostLanguageItemName);
    }

    /**
    /* "TasksPanel.CreateExtraModule" (Create extra module)
    */
    public get tasksPanelCreateExtraModule() : string {
        return this.get(this.tasksPanelCreateExtraModuleLanguageItemName);
    }

    /**
    /* "TasksPanel.CreateModule" (Create module)
    */
    public get tasksPanelCreateModule() : string {
        return this.get(this.tasksPanelCreateModuleLanguageItemName);
    }

    /**
    /* "TasksPanel.CreateTaskWorkReport" (Create task to work report)
    */
    public get tasksPanelCreateTaskWorkReport() : string {
        return this.get(this.tasksPanelCreateTaskWorkReportLanguageItemName);
    }

    /**
    /* "TasksPanel.Date" (Date)
    */
    public get tasksPanelDate() : string {
        return this.get(this.tasksPanelDateLanguageItemName);
    }

    /**
    /* "TasksPanel.RentTabTitle" (Rent)
    */
    public get tasksPanelRentTabTitle() : string {
        return this.get(this.tasksPanelRentTabTitleLanguageItemName);
    }

    /**
    /* "TasksPanel.SaveWorkReportTitle" (Save Work Report)
    */
    public get tasksPanelSaveWorkReportTitle() : string {
        return this.get(this.tasksPanelSaveWorkReportTitleLanguageItemName);
    }

    /**
    /* "TasksPanel.TaskExtraCharges" (Task extra charges)
    */
    public get tasksPanelTaskExtraCharges() : string {
        return this.get(this.tasksPanelTaskExtraChargesLanguageItemName);
    }

    /**
    /* "TasksPanel.TaskHours" (Task hours)
    */
    public get tasksPanelTaskHours() : string {
        return this.get(this.tasksPanelTaskHoursLanguageItemName);
    }

    /**
    /* "TaskTooltips.TaskApproved" (Task is completed and approved)
    */
    public get taskTooltipsTaskApproved() : string {
        return this.get(this.taskTooltipsTaskApprovedLanguageItemName);
    }

    /**
    /* "TaskTooltips.TaskInProgress" (Task in process)
    */
    public get taskTooltipsTaskInProgress() : string {
        return this.get(this.taskTooltipsTaskInProgressLanguageItemName);
    }

    /**
    /* "TaskTooltips.TaskInvoiced" (Task is invoiced)
    */
    public get taskTooltipsTaskInvoiced() : string {
        return this.get(this.taskTooltipsTaskInvoicedLanguageItemName);
    }

    /**
    /* "TaskTooltips.TaskReadyForInvoicing" (Task is ready to be invoiced (invoice row created and approved))
    */
    public get taskTooltipsTaskReadyForInvoicing() : string {
        return this.get(this.taskTooltipsTaskReadyForInvoicingLanguageItemName);
    }

    /**
    /* "TaskTooltips.TaskWaitingActivation" (Task is waiting for activation date)
    */
    public get taskTooltipsTaskWaitingActivation() : string {
        return this.get(this.taskTooltipsTaskWaitingActivationLanguageItemName);
    }

    /**
    /* "TaskTooltips.TaskWaitingApproval" (Task is completed, waiting for approving)
    */
    public get taskTooltipsTaskWaitingApproval() : string {
        return this.get(this.taskTooltipsTaskWaitingApprovalLanguageItemName);
    }

    /**
    /* "TopNav.ConstructionSiteManagement" (Construction site management)
    */
    public get topNavConstructionSiteManagement() : string {
        return this.get(this.topNavConstructionSiteManagementLanguageItemName);
    }

    /**
    /* "Validators.Length" (Text is too short)
    */
    public get validatorsLength() : string {
        return this.get(this.validatorsLengthLanguageItemName);
    }

    /**
    /* "WorkDayAllowance.Distance" (Distance)
    */
    public get workDayAllowanceDistance() : string {
        return this.get(this.workDayAllowanceDistanceLanguageItemName);
    }

    /**
    /* "WorkDayPanel.Contract" (Contract)
    */
    public get workDayPanelContract() : string {
        return this.get(this.workDayPanelContractLanguageItemName);
    }

    /**
    /* "WorkDayPanel.Compensations" (Compensations)
    */
    public get workDayPanelCompensations() : string {
        return this.get(this.workDayPanelCompensationsLanguageItemName);
    }

    /**
    /* "WorkDayPanel.PassengersDescription" (Amount of people you traveled with)
    */
    public get workDayPanelPassengersDescription() : string {
        return this.get(this.workDayPanelPassengersDescriptionLanguageItemName);
    }

    /**
    /* "UserManagement.Grid.NoInvitationsText" (No invitations has been sent)
    */
    public get userManagementGridNoInvitationsText() : string {
        return this.get(this.userManagementGridNoInvitationsTextLanguageItemName);
    }

    /**
    /* "UserManagement.Button.ResendInvitation" (Resend invitation)
    */
    public get userManagementButtonResendInvitation() : string {
        return this.get(this.userManagementButtonResendInvitationLanguageItemName);
    }

    /**
    /* "UserManagement.Button.ResetPassword" (Reset password)
    */
    public get userManagementButtonResetPassword() : string {
        return this.get(this.userManagementButtonResetPasswordLanguageItemName);
    }

    /**
    /* "UserManagement.Label.AuthenticationType" (Authentication type)
    */
    public get userManagementLabelAuthenticationType() : string {
        return this.get(this.userManagementLabelAuthenticationTypeLanguageItemName);
    }

    /**
    /* "Enum.AuthType.Email" (Email)
    */
    public get enumAuthTypeEmail() : string {
        return this.get(this.enumAuthTypeEmailLanguageItemName);
    }

    /**
    /* "Enum.AuthType.Phone" (SMS)
    */
    public get enumAuthTypePhone() : string {
        return this.get(this.enumAuthTypePhoneLanguageItemName);
    }

    /**
    /* "UserManagement.Tab.Invitations" (Invitations)
    */
    public get userManagementTabInvitations() : string {
        return this.get(this.userManagementTabInvitationsLanguageItemName);
    }

    /**
    /* "UserManagement.ConfirmationButton.ResetPassword" (Are you sure you want to reset password for user "{0}"?)
    */
    public get userManagementConfirmationButtonResetPassword() : string {
        return this.get(this.userManagementConfirmationButtonResetPasswordLanguageItemName);
    }

    /**
    /* "UserManagement.ConfirmationButton.ResendInvitation" (Are you sure you want to invite user "{0}"?)
    */
    public get userManagementConfirmationButtonResendInvitation() : string {
        return this.get(this.userManagementConfirmationButtonResendInvitationLanguageItemName);
    }

    /**
    /* "UserManagement.Alert.UserPasswordInfo" (User account "{0}" does not have a password.)
    */
    public get userManagementAlertUserPasswordInfo() : string {
        return this.get(this.userManagementAlertUserPasswordInfoLanguageItemName);
    }

    /**
    /* "UserManagement.Grid.CreatedBy" (Created by)
    */
    public get userManagementGridCreatedBy() : string {
        return this.get(this.userManagementGridCreatedByLanguageItemName);
    }

    /**
    /* "UserManagement.Grid.Type" (Type)
    */
    public get userManagementGridType() : string {
        return this.get(this.userManagementGridTypeLanguageItemName);
    }

    /**
    /* "UserManagement.Grid.CreatedAt" (Created at)
    */
    public get userManagementGridCreatedAt() : string {
        return this.get(this.userManagementGridCreatedAtLanguageItemName);
    }

    /**
    /* "UserManagement.Grid.ExpiresAt" (Expires at)
    */
    public get userManagementGridExpiresAt() : string {
        return this.get(this.userManagementGridExpiresAtLanguageItemName);
    }

    /**
    /* "UserManagement.Grid.ProcessedAt" (Processed At)
    */
    public get userManagementGridProcessedAt() : string {
        return this.get(this.userManagementGridProcessedAtLanguageItemName);
    }

    /**
    /* "UserManagement.Grid.Reusable" (Reusable)
    */
    public get userManagementGridReusable() : string {
        return this.get(this.userManagementGridReusableLanguageItemName);
    }

    /**
    /* "UserManagement.Grid.AuthType" (Auth type)
    */
    public get userManagementGridAuthType() : string {
        return this.get(this.userManagementGridAuthTypeLanguageItemName);
    }

    /**
    /* "UserManagement.AlertMessage.AccountSaved" (User account "{0}" saved successfully.)
    */
    public get userManagementAlertMessageAccountSaved() : string {
        return this.get(this.userManagementAlertMessageAccountSavedLanguageItemName);
    }

    /**
    /* "UserManagement.AlertError.AccountExist" (User account "{0}" already exist.)
    */
    public get userManagementAlertErrorAccountExist() : string {
        return this.get(this.userManagementAlertErrorAccountExistLanguageItemName);
    }

    /**
    /* "UserManagement.AlertError.PhoneNumberInvalid" (Phone number is invalid.)
    */
    public get userManagementAlertErrorPhoneNumberInvalid() : string {
        return this.get(this.userManagementAlertErrorPhoneNumberInvalidLanguageItemName);
    }

    /**
    /* "ForgotPassword.UsernameInput" (Email or phone number)
    */
    public get forgotPasswordUsernameInput() : string {
        return this.get(this.forgotPasswordUsernameInputLanguageItemName);
    }

    /**
    /* "Enum.InvitationType.Invitation" (Invitation)
    */
    public get enumInvitationTypeInvitation() : string {
        return this.get(this.enumInvitationTypeInvitationLanguageItemName);
    }

    /**
    /* "Enum.InvitationType.ResetPassword" (Reset password)
    */
    public get enumInvitationTypeResetPassword() : string {
        return this.get(this.enumInvitationTypeResetPasswordLanguageItemName);
    }

    /**
    /* "Enum.InvitationType.ForgotPassword" (Forgot password)
    */
    public get enumInvitationTypeForgotPassword() : string {
        return this.get(this.enumInvitationTypeForgotPasswordLanguageItemName);
    }

    /**
    /* "UserManagement.ConfirmationButton.Rollback" (Are you sure that you want to rollback unsaved changes?)
    */
    public get userManagementConfirmationButtonRollback() : string {
        return this.get(this.userManagementConfirmationButtonRollbackLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.Attachments" (Attachments)
    */
    public get addWorkReportModalAttachments() : string {
        return this.get(this.addWorkReportModalAttachmentsLanguageItemName);
    }

    /**
    /* "ConfirmationDialog.Comment" (Please leave a comment)
    */
    public get confirmationDialogComment() : string {
        return this.get(this.confirmationDialogCommentLanguageItemName);
    }

    /**
    /* "Component.ConfirmationDialog.AreYouSure" (Are you sure?)
    */
    public get componentConfirmationDialogAreYouSure() : string {
        return this.get(this.componentConfirmationDialogAreYouSureLanguageItemName);
    }

    /**
    /* "LocationPickerModal.Title" (Location picker)
    */
    public get locationPickerModalTitle() : string {
        return this.get(this.locationPickerModalTitleLanguageItemName);
    }

    /**
    /* "LocationPickerModal.Subtitle" (Choose location on map)
    */
    public get locationPickerModalSubtitle() : string {
        return this.get(this.locationPickerModalSubtitleLanguageItemName);
    }

    /**
    /* "LocationPickerModal.SetLocation" (Set location)
    */
    public get locationPickerModalSetLocation() : string {
        return this.get(this.locationPickerModalSetLocationLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.SignInExpirationAlert" (The working session is expired!\nPlease sign-in to the construction site again to continue work.)
    */
    public get rentaTasksControllerSignInExpirationAlert() : string {
        return this.get(this.rentaTasksControllerSignInExpirationAlertLanguageItemName);
    }

    /**
    /* "Widget.Pwa.Install" (Install)
    */
    public get widgetPwaInstall() : string {
        return this.get(this.widgetPwaInstallLanguageItemName);
    }

    /**
    /* "Widget.Pwa.Description" (Add application to the home screen)
    */
    public get widgetPwaDescription() : string {
        return this.get(this.widgetPwaDescriptionLanguageItemName);
    }

    /**
    /* "Widget.BudgetData.Module.Label" (Module)
    */
    public get widgetBudgetDataModuleLabel() : string {
        return this.get(this.widgetBudgetDataModuleLabelLanguageItemName);
    }

    /**
    /* "Widget.BudgetData.PerimeterFrame.Label" (Perimeter frame)
    */
    public get widgetBudgetDataPerimeterFrameLabel() : string {
        return this.get(this.widgetBudgetDataPerimeterFrameLabelLanguageItemName);
    }

    /**
    /* "Widget.BudgetData.WeatherShelter.Label" (Weather shelter)
    */
    public get widgetBudgetDataWeatherShelterLabel() : string {
        return this.get(this.widgetBudgetDataWeatherShelterLabelLanguageItemName);
    }

    /**
    /* "TasksPanel.AddExtraChargeModal.Description" (Comment)
    */
    public get tasksPanelAddExtraChargeModalDescription() : string {
        return this.get(this.tasksPanelAddExtraChargeModalDescriptionLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.Delete.Confirm" (Do you really want to delete this work report?)
    */
    public get addWorkReportModalDeleteConfirm() : string {
        return this.get(this.addWorkReportModalDeleteConfirmLanguageItemName);
    }

    /**
    /* "ConstructionSites.Confirmation.ActivateSite" (Are you sure, you want to activate construction site \n "{0}"?)
    */
    public get constructionSitesConfirmationActivateSite() : string {
        return this.get(this.constructionSitesConfirmationActivateSiteLanguageItemName);
    }

    /**
    /* "ConstructionSites.Confirmation.DeactivateSite" (Are you sure, you want to deactivate construction site \n "{0}"?)
    */
    public get constructionSitesConfirmationDeactivateSite() : string {
        return this.get(this.constructionSitesConfirmationDeactivateSiteLanguageItemName);
    }

    /**
    /* "AddConstructionSite.InvoiceReference" (Invoice reference)
    */
    public get addConstructionSiteInvoiceReference() : string {
        return this.get(this.addConstructionSiteInvoiceReferenceLanguageItemName);
    }

    /**
    /* "AddConstructionSite.HourPrice" (Default hour price)
    */
    public get addConstructionSiteHourPrice() : string {
        return this.get(this.addConstructionSiteHourPriceLanguageItemName);
    }

    /**
    /* "AddConstructionSite.MileagePrice" (Default mileage price)
    */
    public get addConstructionSiteMileagePrice() : string {
        return this.get(this.addConstructionSiteMileagePriceLanguageItemName);
    }

    /**
    /* "Component.HoursWidget.HoursSpent" (Hours spent for task)
    */
    public get componentHoursWidgetHoursSpent() : string {
        return this.get(this.componentHoursWidgetHoursSpentLanguageItemName);
    }

    /**
    /* "Component.HoursWidget.AddOvertime" (Add overtime)
    */
    public get componentHoursWidgetAddOvertime() : string {
        return this.get(this.componentHoursWidgetAddOvertimeLanguageItemName);
    }

    /**
    /* "Component.HoursWidget.NormalHours" (Normal)
    */
    public get componentHoursWidgetNormalHours() : string {
        return this.get(this.componentHoursWidgetNormalHoursLanguageItemName);
    }

    /**
    /* "SummaryWidget.Title" (Work report summary)
    */
    public get summaryWidgetTitle() : string {
        return this.get(this.summaryWidgetTitleLanguageItemName);
    }

    /**
    /* "SummaryWidget.Orderer" (Orderer:)
    */
    public get summaryWidgetOrderer() : string {
        return this.get(this.summaryWidgetOrdererLanguageItemName);
    }

    /**
    /* "SummaryWidget.Approver" (Approver:)
    */
    public get summaryWidgetApprover() : string {
        return this.get(this.summaryWidgetApproverLanguageItemName);
    }

    /**
    /* "SummaryWidget.Button.CreateApprover" (Create new approver)
    */
    public get summaryWidgetButtonCreateApprover() : string {
        return this.get(this.summaryWidgetButtonCreateApproverLanguageItemName);
    }

    /**
    /* "SummaryWidget.WorkOrderName" (Work report name:)
    */
    public get summaryWidgetWorkOrderName() : string {
        return this.get(this.summaryWidgetWorkOrderNameLanguageItemName);
    }

    /**
    /* "SummaryWidget.WorkOrderDescription" (Description:)
    */
    public get summaryWidgetWorkOrderDescription() : string {
        return this.get(this.summaryWidgetWorkOrderDescriptionLanguageItemName);
    }

    /**
    /* "Generic.NoData" (No data)
    */
    public get genericNoData() : string {
        return this.get(this.genericNoDataLanguageItemName);
    }

    /**
    /* "CreateContractPersonModal.Subtitle" (Create new approver)
    */
    public get createContractPersonModalSubtitle() : string {
        return this.get(this.createContractPersonModalSubtitleLanguageItemName);
    }

    /**
    /* "WorkOrders.Page.Title" (Work orders)
    */
    public get workOrdersPageTitle() : string {
        return this.get(this.workOrdersPageTitleLanguageItemName);
    }

    /**
    /* "WorkOrders.ActiveList.NoOrders" (No active work orders.)
    */
    public get workOrdersActiveListNoOrders() : string {
        return this.get(this.workOrdersActiveListNoOrdersLanguageItemName);
    }

    /**
    /* "WorkOrders.ActiveList.Title" (Active work orders: {0}.)
    */
    public get workOrdersActiveListTitle() : string {
        return this.get(this.workOrdersActiveListTitleLanguageItemName);
    }

    /**
    /* "WorkOrders.CompletedList.NoOrders" (No completed work orders.)
    */
    public get workOrdersCompletedListNoOrders() : string {
        return this.get(this.workOrdersCompletedListNoOrdersLanguageItemName);
    }

    /**
    /* "WorkOrders.CompletedList.Title" (Completed work orders: {0}.)
    */
    public get workOrdersCompletedListTitle() : string {
        return this.get(this.workOrdersCompletedListTitleLanguageItemName);
    }

    /**
    /* "WorkOrders.Filters.ConstructionSite" (Construction site)
    */
    public get workOrdersFiltersConstructionSite() : string {
        return this.get(this.workOrdersFiltersConstructionSiteLanguageItemName);
    }

    /**
    /* "WorkOrders.Filters.Customer" (Customer)
    */
    public get workOrdersFiltersCustomer() : string {
        return this.get(this.workOrdersFiltersCustomerLanguageItemName);
    }

    /**
    /* "WorkOrders.Filters.Date" (Date)
    */
    public get workOrdersFiltersDate() : string {
        return this.get(this.workOrdersFiltersDateLanguageItemName);
    }

    /**
    /* "WorkOrders.Filters.From" (From)
    */
    public get workOrdersFiltersFrom() : string {
        return this.get(this.workOrdersFiltersFromLanguageItemName);
    }

    /**
    /* "WorkOrders.Filters.Name" (Work order name)
    */
    public get workOrdersFiltersName() : string {
        return this.get(this.workOrdersFiltersNameLanguageItemName);
    }

    /**
    /* "WorkOrders.Filters.Statuses" (Work order statuses)
    */
    public get workOrdersFiltersStatuses() : string {
        return this.get(this.workOrdersFiltersStatusesLanguageItemName);
    }

    /**
    /* "WorkOrders.Filters.To" (To)
    */
    public get workOrdersFiltersTo() : string {
        return this.get(this.workOrdersFiltersToLanguageItemName);
    }

    /**
    /* "WorkOrders.FiltersButton.Apply" (Apply)
    */
    public get workOrdersFiltersButtonApply() : string {
        return this.get(this.workOrdersFiltersButtonApplyLanguageItemName);
    }

    /**
    /* "WorkOrders.FiltersButton.Clear" (Clear)
    */
    public get workOrdersFiltersButtonClear() : string {
        return this.get(this.workOrdersFiltersButtonClearLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.ApprovedByCustomer" (Approved by customer)
    */
    public get enumWorkOrderStatusApprovedByCustomer() : string {
        return this.get(this.enumWorkOrderStatusApprovedByCustomerLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.ApprovedByManager" (Approved by manager)
    */
    public get enumWorkOrderStatusApprovedByManager() : string {
        return this.get(this.enumWorkOrderStatusApprovedByManagerLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.Completed" (Completed)
    */
    public get enumWorkOrderStatusCompleted() : string {
        return this.get(this.enumWorkOrderStatusCompletedLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.Created" (Created)
    */
    public get enumWorkOrderStatusCreated() : string {
        return this.get(this.enumWorkOrderStatusCreatedLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.DeclinedByCustomer" (Declined by customer)
    */
    public get enumWorkOrderStatusDeclinedByCustomer() : string {
        return this.get(this.enumWorkOrderStatusDeclinedByCustomerLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.DeclinedByManager" (Declined by manager)
    */
    public get enumWorkOrderStatusDeclinedByManager() : string {
        return this.get(this.enumWorkOrderStatusDeclinedByManagerLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.Deleted" (Deleted)
    */
    public get enumWorkOrderStatusDeleted() : string {
        return this.get(this.enumWorkOrderStatusDeletedLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.HasActiveTasks.Description" (Has activated, but not completed tasks)
    */
    public get enumWorkOrderStatusHasActiveTasksDescription() : string {
        return this.get(this.enumWorkOrderStatusHasActiveTasksDescriptionLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.Invoiced" (Invoiced)
    */
    public get enumWorkOrderStatusInvoiced() : string {
        return this.get(this.enumWorkOrderStatusInvoicedLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.InProgress" (In progress)
    */
    public get enumWorkOrderStatusInProgress() : string {
        return this.get(this.enumWorkOrderStatusInProgressLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.InvoiceNotCreated.Description" (Has approved, but not sent to Pagero invoices)
    */
    public get enumWorkOrderStatusInvoiceNotCreatedDescription() : string {
        return this.get(this.enumWorkOrderStatusInvoiceNotCreatedDescriptionLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.SentToCustomer" (Sent to customer)
    */
    public get enumWorkOrderStatusSentToCustomer() : string {
        return this.get(this.enumWorkOrderStatusSentToCustomerLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.InvoiceRowsNotApprovedNyManager.Description" (Has not approved invoice rows)
    */
    public get enumWorkOrderStatusInvoiceRowsNotApprovedNyManagerDescription() : string {
        return this.get(this.enumWorkOrderStatusInvoiceRowsNotApprovedNyManagerDescriptionLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.Unknown" (Unknown)
    */
    public get enumWorkOrderStatusUnknown() : string {
        return this.get(this.enumWorkOrderStatusUnknownLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.TaskNotApprovedByManager.Description" (Has completed, but not approved tasks)
    */
    public get enumWorkOrderStatusTaskNotApprovedByManagerDescription() : string {
        return this.get(this.enumWorkOrderStatusTaskNotApprovedByManagerDescriptionLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.WorkReportNotApprovedByCustomer.Description" (Has not approved work reports)
    */
    public get enumWorkOrderStatusWorkReportNotApprovedByCustomerDescription() : string {
        return this.get(this.enumWorkOrderStatusWorkReportNotApprovedByCustomerDescriptionLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.WorkReportNotSent.Description" (Has not sent work reports with approving type "Email")
    */
    public get enumWorkOrderStatusWorkReportNotSentDescription() : string {
        return this.get(this.enumWorkOrderStatusWorkReportNotSentDescriptionLanguageItemName);
    }

    /**
    /* "Enum.FiltersBehavior.SystemDefault" (System default)
    */
    public get enumFiltersBehaviorSystemDefault() : string {
        return this.get(this.enumFiltersBehaviorSystemDefaultLanguageItemName);
    }

    /**
    /* "Enum.FiltersBehavior.UserSpecified" (Remember my selections)
    */
    public get enumFiltersBehaviorUserSpecified() : string {
        return this.get(this.enumFiltersBehaviorUserSpecifiedLanguageItemName);
    }

    /**
    /* "WorkOrdersFiltersModal.Title.Active" (Active work orders filters)
    */
    public get workOrdersFiltersModalTitleActive() : string {
        return this.get(this.workOrdersFiltersModalTitleActiveLanguageItemName);
    }

    /**
    /* "WorkOrdersFiltersModal.Title.Completed" (Completed work orders filters)
    */
    public get workOrdersFiltersModalTitleCompleted() : string {
        return this.get(this.workOrdersFiltersModalTitleCompletedLanguageItemName);
    }

    /**
    /* "WorkOrders.Modal.Actions.Activate" (Activate)
    */
    public get workOrdersModalActionsActivate() : string {
        return this.get(this.workOrdersModalActionsActivateLanguageItemName);
    }

    /**
    /* "WorkOrders.Modal.Actions.Approve" (Approve)
    */
    public get workOrdersModalActionsApprove() : string {
        return this.get(this.workOrdersModalActionsApproveLanguageItemName);
    }

    /**
    /* "WorkOrders.Modal.Actions.Complete" (Complete)
    */
    public get workOrdersModalActionsComplete() : string {
        return this.get(this.workOrdersModalActionsCompleteLanguageItemName);
    }

    /**
    /* "WorkOrders.Modal.Actions.Edit" (Edit)
    */
    public get workOrdersModalActionsEdit() : string {
        return this.get(this.workOrdersModalActionsEditLanguageItemName);
    }

    /**
    /* "WorkOrdersActionsModal.Title" (Work order actions)
    */
    public get workOrdersActionsModalTitle() : string {
        return this.get(this.workOrdersActionsModalTitleLanguageItemName);
    }

    /**
    /* "WorkOrders.AlertMessage.WorkOrderActivated" (Work order "{0}" has been activated)
    */
    public get workOrdersAlertMessageWorkOrderActivated() : string {
        return this.get(this.workOrdersAlertMessageWorkOrderActivatedLanguageItemName);
    }

    /**
    /* "WorkOrders.AlertMessage.WorkOrderCompleted" (Work order "{0}" has been completed)
    */
    public get workOrdersAlertMessageWorkOrderCompleted() : string {
        return this.get(this.workOrdersAlertMessageWorkOrderCompletedLanguageItemName);
    }

    /**
    /* "WorkOrders.Approved.Alert" (Work order marked as approved)
    */
    public get workOrdersApprovedAlert() : string {
        return this.get(this.workOrdersApprovedAlertLanguageItemName);
    }

    /**
    /* "WorkOrders.ValidationError.ApproverCreationRejected" (Cannot create approver "{0}". Please contact administrator.)
    */
    public get workOrdersValidationErrorApproverCreationRejected() : string {
        return this.get(this.workOrdersValidationErrorApproverCreationRejectedLanguageItemName);
    }

    /**
    /* "SendWorkOrderModal.Button.SendOrApprove" (Send or Approve)
    */
    public get sendWorkOrderModalButtonSendOrApprove() : string {
        return this.get(this.sendWorkOrderModalButtonSendOrApproveLanguageItemName);
    }

    /**
    /* "ApproveWorkReport.Title" (Mark as approved)
    */
    public get approveWorkReportTitle() : string {
        return this.get(this.approveWorkReportTitleLanguageItemName);
    }

    /**
    /* "WorkOrders.Owner.SelectConstructionSite" (Select a construction site)
    */
    public get workOrdersOwnerSelectConstructionSite() : string {
        return this.get(this.workOrdersOwnerSelectConstructionSiteLanguageItemName);
    }

    /**
    /* "WorkOrders.Actions.Send" (Send to customer)
    */
    public get workOrdersActionsSend() : string {
        return this.get(this.workOrdersActionsSendLanguageItemName);
    }

    /**
    /* "ConstructionSiteManagement.Tabs.Contract" (Customer contract)
    */
    public get constructionSiteManagementTabsContract() : string {
        return this.get(this.constructionSiteManagementTabsContractLanguageItemName);
    }

    /**
    /* "ConstructionSiteManagement.Tabs.WorkOrders" (Work orders)
    */
    public get constructionSiteManagementTabsWorkOrders() : string {
        return this.get(this.constructionSiteManagementTabsWorkOrdersLanguageItemName);
    }

    /**
    /* "WorkOrders.Actions.Lock" (Approve for invoicing)
    */
    public get workOrdersActionsLock() : string {
        return this.get(this.workOrdersActionsLockLanguageItemName);
    }

    /**
    /* "WorkOrders.Actions.Invoice" (Invoice)
    */
    public get workOrdersActionsInvoice() : string {
        return this.get(this.workOrdersActionsInvoiceLanguageItemName);
    }

    /**
    /* "ConstructionSitePanel.ExternalAddress" (External address)
    */
    public get constructionSitePanelExternalAddress() : string {
        return this.get(this.constructionSitePanelExternalAddressLanguageItemName);
    }

    /**
    /* "Dashboard.GetManual" (This is Dashboard page with widgets based on Your access role.)
    */
    public get dashboardGetManual() : string {
        return this.get(this.dashboardGetManualLanguageItemName);
    }

    /**
    /* "ConstructionSiteManagement.GetManual" (This is a page for RentaTask managers, where they can create new or operate existing construction sites, modules and tasks.)
    */
    public get constructionSiteManagementGetManual() : string {
        return this.get(this.constructionSiteManagementGetManualLanguageItemName);
    }

    /**
    /* "RoleName.Manager" (Manager)
    */
    public get roleNameManager() : string {
        return this.get(this.roleNameManagerLanguageItemName);
    }

    /**
    /* "RoleName.BusinessManager" (Business Manager)
    */
    public get roleNameBusinessManager() : string {
        return this.get(this.roleNameBusinessManagerLanguageItemName);
    }

    /**
    /* "WorkOrdersPanel.NewWorkOrder" (New Work Order)
    */
    public get workOrdersPanelNewWorkOrder() : string {
        return this.get(this.workOrdersPanelNewWorkOrderLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrders.GetManual" (This page shows lists of active and completed work orders. You can filter them, activate, edit, complete and approve.)
    */
    public get rentaTasksWorkOrdersGetManual() : string {
        return this.get(this.rentaTasksWorkOrdersGetManualLanguageItemName);
    }

    /**
    /* "WorkOrder.Actions.ConfirmCompletedActivation" (Are you sure you want to activate a completed and approved by customer work order? After activation, the re-confirmation will be needed.)
    */
    public get workOrderActionsConfirmCompletedActivation() : string {
        return this.get(this.workOrderActionsConfirmCompletedActivationLanguageItemName);
    }

    /**
    /* "WorkOrder.Actions.ConfirmActivation" (Are you sure you want to activate the work order <mark>{0}</mark>?)
    */
    public get workOrderActionsConfirmActivation() : string {
        return this.get(this.workOrderActionsConfirmActivationLanguageItemName);
    }

    /**
    /* "WorkOrder.Actions.ConfirmCompletion" (Are you sure you want to complete the work order <mark>{0}</mark>?)
    */
    public get workOrderActionsConfirmCompletion() : string {
        return this.get(this.workOrderActionsConfirmCompletionLanguageItemName);
    }

    /**
    /* "WorkOrder.Actions.Unlock" (Unlock the work order to enable editing)
    */
    public get workOrderActionsUnlock() : string {
        return this.get(this.workOrderActionsUnlockLanguageItemName);
    }

    /**
    /* "WorkOrder.Actions.ConfirmInvoice" (Are you sure you want to mark the work order as invoiced?)
    */
    public get workOrderActionsConfirmInvoice() : string {
        return this.get(this.workOrderActionsConfirmInvoiceLanguageItemName);
    }

    /**
    /* "SendWorkOrderModal.Approver.Title" (Customer approver)
    */
    public get sendWorkOrderModalApproverTitle() : string {
        return this.get(this.sendWorkOrderModalApproverTitleLanguageItemName);
    }

    /**
    /* "SendWorkOrderModal.Orderer.Title" (Customer orderer)
    */
    public get sendWorkOrderModalOrdererTitle() : string {
        return this.get(this.sendWorkOrderModalOrdererTitleLanguageItemName);
    }

    /**
    /* "SendWorkOrderModal.Approver.Subtitle" (Assign, create or modify the customer approver)
    */
    public get sendWorkOrderModalApproverSubtitle() : string {
        return this.get(this.sendWorkOrderModalApproverSubtitleLanguageItemName);
    }

    /**
    /* "SendWorkOrderModal.Orderer.Subtitle" (Assign, create or modify the customer orderer)
    */
    public get sendWorkOrderModalOrdererSubtitle() : string {
        return this.get(this.sendWorkOrderModalOrdererSubtitleLanguageItemName);
    }

    /**
    /* "SendWorkOrderModal.Button.Assign" (Assign)
    */
    public get sendWorkOrderModalButtonAssign() : string {
        return this.get(this.sendWorkOrderModalButtonAssignLanguageItemName);
    }

    /**
    /* "SendWorkOrderModal.Button.Tooltip.Assign" (Assign contact person for work order)
    */
    public get sendWorkOrderModalButtonTooltipAssign() : string {
        return this.get(this.sendWorkOrderModalButtonTooltipAssignLanguageItemName);
    }

    /**
    /* "WorkOrders.Grid.NoDataText" (No work reports found according to filters)
    */
    public get workOrdersGridNoDataText() : string {
        return this.get(this.workOrdersGridNoDataTextLanguageItemName);
    }

    /**
    /* "WorkDayPanel.Grid.Aggregates.NoDataText" (No reported hours)
    */
    public get workDayPanelGridAggregatesNoDataText() : string {
        return this.get(this.workDayPanelGridAggregatesNoDataTextLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Hours.NoDataText" (No reported hours)
    */
    public get workOrderDetailsPanelGridHoursNoDataText() : string {
        return this.get(this.workOrderDetailsPanelGridHoursNoDataTextLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.ProductUnit" (Unit)
    */
    public get workOrderDetailsPanelGridProductUnit() : string {
        return this.get(this.workOrderDetailsPanelGridProductUnitLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Equipment.NoDataText" (No equipment)
    */
    public get workOrderDetailsPanelGridEquipmentNoDataText() : string {
        return this.get(this.workOrderDetailsPanelGridEquipmentNoDataTextLanguageItemName);
    }

    /**
    /* "ContactSupportPage.MessageSent" (Your request was sent to support team.)
    */
    public get contactSupportPageMessageSent() : string {
        return this.get(this.contactSupportPageMessageSentLanguageItemName);
    }

    /**
    /* "ContactSupportPage.MessageWithIdSent" (Your request with id "{0}" was sent to support team.)
    */
    public get contactSupportPageMessageWithIdSent() : string {
        return this.get(this.contactSupportPageMessageWithIdSentLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.SignIn.Confirm" (The work order is not active yet.\nAre you sure you want to activate and sign in?)
    */
    public get rentaTasksWorkOrderSignInConfirm() : string {
        return this.get(this.rentaTasksWorkOrderSignInConfirmLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.SignIn.Alert" (You have successfully signed in to the work order.)
    */
    public get rentaTasksWorkOrderSignInAlert() : string {
        return this.get(this.rentaTasksWorkOrderSignInAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Manual.Title" (Work order description)
    */
    public get rentaTasksWorkOrderManualTitle() : string {
        return this.get(this.rentaTasksWorkOrderManualTitleLanguageItemName);
    }

    /**
    /* "Generic.Km" ({0} km)
    */
    public get genericKm() : string {
        return this.get(this.genericKmLanguageItemName);
    }

    /**
    /* "Generic.Hours" ({0:0.0} h ({1:0.0}/{2:0.0}/{3:0.0}))
    */
    public get genericHours() : string {
        return this.get(this.genericHoursLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.CustomerName" (Customer name)
    */
    public get rentaTasksWorkOrderLabelCustomerName() : string {
        return this.get(this.rentaTasksWorkOrderLabelCustomerNameLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.ConstructionSite" (Construction site)
    */
    public get rentaTasksWorkOrderLabelConstructionSite() : string {
        return this.get(this.rentaTasksWorkOrderLabelConstructionSiteLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.Address" (Address)
    */
    public get rentaTasksWorkOrderLabelAddress() : string {
        return this.get(this.rentaTasksWorkOrderLabelAddressLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.Orderer" (Orderer)
    */
    public get rentaTasksWorkOrderLabelOrderer() : string {
        return this.get(this.rentaTasksWorkOrderLabelOrdererLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.OrdererPhone" (Orderer phone)
    */
    public get rentaTasksWorkOrderLabelOrdererPhone() : string {
        return this.get(this.rentaTasksWorkOrderLabelOrdererPhoneLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.Approver" (Approver)
    */
    public get rentaTasksWorkOrderLabelApprover() : string {
        return this.get(this.rentaTasksWorkOrderLabelApproverLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.ApproverPhone" (Approver phone)
    */
    public get rentaTasksWorkOrderLabelApproverPhone() : string {
        return this.get(this.rentaTasksWorkOrderLabelApproverPhoneLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.Manager" (Manager)
    */
    public get rentaTasksWorkOrderLabelManager() : string {
        return this.get(this.rentaTasksWorkOrderLabelManagerLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.ManagerPhone" (Manager phone)
    */
    public get rentaTasksWorkOrderLabelManagerPhone() : string {
        return this.get(this.rentaTasksWorkOrderLabelManagerPhoneLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.Distance" (Distance)
    */
    public get rentaTasksWorkOrderLabelDistance() : string {
        return this.get(this.rentaTasksWorkOrderLabelDistanceLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.Status" (Status:)
    */
    public get rentaTasksWorkOrderLabelStatus() : string {
        return this.get(this.rentaTasksWorkOrderLabelStatusLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.ActivationDate" (Activation date:)
    */
    public get rentaTasksWorkOrderLabelActivationDate() : string {
        return this.get(this.rentaTasksWorkOrderLabelActivationDateLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.CompletionDate" (Completion date:)
    */
    public get rentaTasksWorkOrderLabelCompletionDate() : string {
        return this.get(this.rentaTasksWorkOrderLabelCompletionDateLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Button.Label.SignIn" (Sign in)
    */
    public get rentaTasksWorkOrderButtonLabelSignIn() : string {
        return this.get(this.rentaTasksWorkOrderButtonLabelSignInLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Button.Label.SignOut" (Sign out)
    */
    public get rentaTasksWorkOrderButtonLabelSignOut() : string {
        return this.get(this.rentaTasksWorkOrderButtonLabelSignOutLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Button.Label.AddEquipment" (Add equipment)
    */
    public get rentaTasksWorkOrderButtonLabelAddEquipment() : string {
        return this.get(this.rentaTasksWorkOrderButtonLabelAddEquipmentLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Button.Label.Back" (Back)
    */
    public get rentaTasksWorkOrderButtonLabelBack() : string {
        return this.get(this.rentaTasksWorkOrderButtonLabelBackLanguageItemName);
    }

    /**
    /* "RentaTasks.Dashboard.RouteWidget.MyWorkOrder" (My work order)
    */
    public get rentaTasksDashboardRouteWidgetMyWorkOrder() : string {
        return this.get(this.rentaTasksDashboardRouteWidgetMyWorkOrderLanguageItemName);
    }

    /**
    /* "RentaTasks.Dashboard.RouteWidget.WorkOrders" (Work orders)
    */
    public get rentaTasksDashboardRouteWidgetWorkOrders() : string {
        return this.get(this.rentaTasksDashboardRouteWidgetWorkOrdersLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.SignOut.Alert" (You have successfully signed out from the work order.)
    */
    public get rentaTasksWorkOrderSignOutAlert() : string {
        return this.get(this.rentaTasksWorkOrderSignOutAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Save.Alert" (The work order is saved successfully.)
    */
    public get rentaTasksWorkOrderSaveAlert() : string {
        return this.get(this.rentaTasksWorkOrderSaveAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.UpdateEquipment.Alert" (The work order equipment is updated successfully.)
    */
    public get rentaTasksWorkOrderUpdateEquipmentAlert() : string {
        return this.get(this.rentaTasksWorkOrderUpdateEquipmentAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Complete.Alert" (The work order completed successfully.)
    */
    public get rentaTasksWorkOrderCompleteAlert() : string {
        return this.get(this.rentaTasksWorkOrderCompleteAlertLanguageItemName);
    }

    /**
    /* "WorkOrders.Filters.Employees" (Employees)
    */
    public get workOrdersFiltersEmployees() : string {
        return this.get(this.workOrdersFiltersEmployeesLanguageItemName);
    }

    /**
    /* "WorkOrders.Filters.Managers" (Managers)
    */
    public get workOrdersFiltersManagers() : string {
        return this.get(this.workOrdersFiltersManagersLanguageItemName);
    }

    /**
    /* "RentaTasks.Dashboard.RouteWidget.WorkOrders.Description" (Check active work orders)
    */
    public get rentaTasksDashboardRouteWidgetWorkOrdersDescription() : string {
        return this.get(this.rentaTasksDashboardRouteWidgetWorkOrdersDescriptionLanguageItemName);
    }

    /**
    /* "WorkOrders.Rows.NoAddress" (No address)
    */
    public get workOrdersRowsNoAddress() : string {
        return this.get(this.workOrdersRowsNoAddressLanguageItemName);
    }

    /**
    /* "EditContactPersonModal.Button.Label.SaveChanges" (Save changes)
    */
    public get editContactPersonModalButtonLabelSaveChanges() : string {
        return this.get(this.editContactPersonModalButtonLabelSaveChangesLanguageItemName);
    }

    /**
    /* "EditContactPersonModal.Subtitle" (Fill in missing information)
    */
    public get editContactPersonModalSubtitle() : string {
        return this.get(this.editContactPersonModalSubtitleLanguageItemName);
    }

    /**
    /* "SummaryWidget.Button.EditApprover" (Fill in missing approver info)
    */
    public get summaryWidgetButtonEditApprover() : string {
        return this.get(this.summaryWidgetButtonEditApproverLanguageItemName);
    }

    /**
    /* "SummaryWidget.Dropdown.NothingSelected" (Select customer approver)
    */
    public get summaryWidgetDropdownNothingSelected() : string {
        return this.get(this.summaryWidgetDropdownNothingSelectedLanguageItemName);
    }

    /**
    /* "Managers.NewOrderer" (Create new orderer)
    */
    public get managersNewOrderer() : string {
        return this.get(this.managersNewOrdererLanguageItemName);
    }

    /**
    /* "WorkOrders.InvoiceReference" (Invoice reference)
    */
    public get workOrdersInvoiceReference() : string {
        return this.get(this.workOrdersInvoiceReferenceLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderInfo.CheckboxWidget.Unscheduled" (Unscheduled)
    */
    public get rentaTasksWorkOrderInfoCheckboxWidgetUnscheduled() : string {
        return this.get(this.rentaTasksWorkOrderInfoCheckboxWidgetUnscheduledLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderInfo.CheckboxWidget.Unscheduled.Description" (Check to unschedule an activation date)
    */
    public get rentaTasksWorkOrderInfoCheckboxWidgetUnscheduledDescription() : string {
        return this.get(this.rentaTasksWorkOrderInfoCheckboxWidgetUnscheduledDescriptionLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProducts.Searching" (Searching…)
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsSearching() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsSearchingLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProducts.ProductsFound" ({0} products found:)
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsProductsFound() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsProductsFoundLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProducts.NoProductsFound" (No products with given search term)
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsNoProductsFound() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsNoProductsFoundLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProducts.TextInput.Placeholder.Search" (Search)
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsTextInputPlaceholderSearch() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsTextInputPlaceholderSearchLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProducts.SearchResult" (Search results: {0})
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsSearchResult() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsSearchResultLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProductsModal.Title.Equipment" (Equipment)
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsModalTitleEquipment() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsModalTitleEquipmentLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProductsModal.Subtitle.ChooseEquipment" (Choose product to add to equipment list)
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsModalSubtitleChooseEquipment() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsModalSubtitleChooseEquipmentLanguageItemName);
    }

    /**
    /* "TaskTooltips.TaskUnscheduled" (Work order is unscheduled.\nActivation date is not specified.)
    */
    public get taskTooltipsTaskUnscheduled() : string {
        return this.get(this.taskTooltipsTaskUnscheduledLanguageItemName);
    }

    /**
    /* "WorkOrderStatus.Unscheduled" (Unscheduled)
    */
    public get workOrderStatusUnscheduled() : string {
        return this.get(this.workOrderStatusUnscheduledLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProducts.AddEquipment" (Add equipment)
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsAddEquipment() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsAddEquipmentLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.AddEquipmentDataProvider.Category.Favorite" (FAVORITE)
    */
    public get rentaTasksAddEquipmentAddEquipmentDataProviderCategoryFavorite() : string {
        return this.get(this.rentaTasksAddEquipmentAddEquipmentDataProviderCategoryFavoriteLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProducts.NoProducts" (No products)
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsNoProducts() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsNoProductsLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Label.InvoiceReference" (Reference)
    */
    public get rentaTasksWorkOrderLabelInvoiceReference() : string {
        return this.get(this.rentaTasksWorkOrderLabelInvoiceReferenceLanguageItemName);
    }

    /**
    /* "SummaryWidget.Reference" (Reference:)
    */
    public get summaryWidgetReference() : string {
        return this.get(this.summaryWidgetReferenceLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Button.Activate" (Activate)
    */
    public get rentaTasksWorkOrderButtonActivate() : string {
        return this.get(this.rentaTasksWorkOrderButtonActivateLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Alert.WorkOrderNotActivated" (Work order has not been activated. Work order status: \"{0}\".)
    */
    public get rentaTasksWorkOrderAlertWorkOrderNotActivated() : string {
        return this.get(this.rentaTasksWorkOrderAlertWorkOrderNotActivatedLanguageItemName);
    }

    /**
    /* "WorkOrderEquipment.AddCustomProduct" (Add custom product)
    */
    public get workOrderEquipmentAddCustomProduct() : string {
        return this.get(this.workOrderEquipmentAddCustomProductLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.AddCustomProductModal.Amount" (Amount)
    */
    public get rentaTasksAddEquipmentAddCustomProductModalAmount() : string {
        return this.get(this.rentaTasksAddEquipmentAddCustomProductModalAmountLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.AddCustomProductModal.Price" (Price)
    */
    public get rentaTasksAddEquipmentAddCustomProductModalPrice() : string {
        return this.get(this.rentaTasksAddEquipmentAddCustomProductModalPriceLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.AddCustomProductModal.Unit" (Unit)
    */
    public get rentaTasksAddEquipmentAddCustomProductModalUnit() : string {
        return this.get(this.rentaTasksAddEquipmentAddCustomProductModalUnitLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProducts.AddCustomEquipment" (Add custom equipment)
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsAddCustomEquipment() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsAddCustomEquipmentLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.AddCustomProductModal.Title.CustomEquipment" (Custom equipment)
    */
    public get rentaTasksAddEquipmentAddCustomProductModalTitleCustomEquipment() : string {
        return this.get(this.rentaTasksAddEquipmentAddCustomProductModalTitleCustomEquipmentLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.AddCustomProductModal.Subtitle.CustomEquipment" (Add custom equipment to work order)
    */
    public get rentaTasksAddEquipmentAddCustomProductModalSubtitleCustomEquipment() : string {
        return this.get(this.rentaTasksAddEquipmentAddCustomProductModalSubtitleCustomEquipmentLanguageItemName);
    }

    /**
    /* "Generic.ContactPersonDetails" (Contact person details)
    */
    public get genericContactPersonDetails() : string {
        return this.get(this.genericContactPersonDetailsLanguageItemName);
    }

    /**
    /* "AddEquipment.SaveChangesConfirmation" (There are unsaved changes, would you like to save them before exiting?)
    */
    public get addEquipmentSaveChangesConfirmation() : string {
        return this.get(this.addEquipmentSaveChangesConfirmationLanguageItemName);
    }

    /**
    /* "UserManagement.Title" (User management)
    */
    public get userManagementTitle() : string {
        return this.get(this.userManagementTitleLanguageItemName);
    }

    /**
    /* "WarehouseManagement.Title" (Warehouse management)
    */
    public get warehouseManagementTitle() : string {
        return this.get(this.warehouseManagementTitleLanguageItemName);
    }

    /**
    /* "AddEquipment.SaveButton" (Save)
    */
    public get addEquipmentSaveButton() : string {
        return this.get(this.addEquipmentSaveButtonLanguageItemName);
    }

    /**
    /* "AddEquipment.DontSaveButton" (Don't save)
    */
    public get addEquipmentDontSaveButton() : string {
        return this.get(this.addEquipmentDontSaveButtonLanguageItemName);
    }

    /**
    /* "AddEquipment.CloseButton" (Close)
    */
    public get addEquipmentCloseButton() : string {
        return this.get(this.addEquipmentCloseButtonLanguageItemName);
    }

    /**
    /* "Generic.Action.Restore" (Restore)
    */
    public get genericActionRestore() : string {
        return this.get(this.genericActionRestoreLanguageItemName);
    }

    /**
    /* "Generic.Action.Delete" (Delete)
    */
    public get genericActionDelete() : string {
        return this.get(this.genericActionDeleteLanguageItemName);
    }

    /**
    /* "Generic.Manager" (Manager)
    */
    public get genericManager() : string {
        return this.get(this.genericManagerLanguageItemName);
    }

    /**
    /* "Generic.Address" (Address)
    */
    public get genericAddress() : string {
        return this.get(this.genericAddressLanguageItemName);
    }

    /**
    /* "Generic.ShowDeleted" (Show deleted)
    */
    public get genericShowDeleted() : string {
        return this.get(this.genericShowDeletedLanguageItemName);
    }

    /**
    /* "Generic.Action.Reload" (Reload)
    */
    public get genericActionReload() : string {
        return this.get(this.genericActionReloadLanguageItemName);
    }

    /**
    /* "Warehouses.WarehousesTab" (Warehouses)
    */
    public get warehousesWarehousesTab() : string {
        return this.get(this.warehousesWarehousesTabLanguageItemName);
    }

    /**
    /* "Warehouses.CostPoolsTab" (Cost pools)
    */
    public get warehousesCostPoolsTab() : string {
        return this.get(this.warehousesCostPoolsTabLanguageItemName);
    }

    /**
    /* "Warehouses.CostPoolsTitle" (Cost pools)
    */
    public get warehousesCostPoolsTitle() : string {
        return this.get(this.warehousesCostPoolsTitleLanguageItemName);
    }

    /**
    /* "Warehouses.Alert.WarehouseAlreadyExists" (Warehouse "{0}" already exists.)
    */
    public get warehousesAlertWarehouseAlreadyExists() : string {
        return this.get(this.warehousesAlertWarehouseAlreadyExistsLanguageItemName);
    }

    /**
    /* "Warehouses.CostPoolsData.DeleteConfirmation" (Are you sure you want to delete cost pool "{0}"?\nCost pool will be removed from all warehouses.)
    */
    public get warehousesCostPoolsDataDeleteConfirmation() : string {
        return this.get(this.warehousesCostPoolsDataDeleteConfirmationLanguageItemName);
    }

    /**
    /* "Warehouses.CostPoolsData.Alert.CostPoolAlreadyExists" (Cost pool "{0}" already exists.)
    */
    public get warehousesCostPoolsDataAlertCostPoolAlreadyExists() : string {
        return this.get(this.warehousesCostPoolsDataAlertCostPoolAlreadyExistsLanguageItemName);
    }

    /**
    /* "Warehouses.WarehouseDetails.Alert.CostPoolAlreadyAssigned" (Cost pool "{0}" already exists under current warehouse.)
    */
    public get warehousesWarehouseDetailsAlertCostPoolAlreadyAssigned() : string {
        return this.get(this.warehousesWarehouseDetailsAlertCostPoolAlreadyAssignedLanguageItemName);
    }

    /**
    /* "Warehouses.WarehouseDetails.DeleteConfirmation" (Are you sure you want to delete mapping with cost pool "{0}"?)
    */
    public get warehousesWarehouseDetailsDeleteConfirmation() : string {
        return this.get(this.warehousesWarehouseDetailsDeleteConfirmationLanguageItemName);
    }

    /**
    /* "Warehouses.WarehouseData.Alert.WarehouseNameAlreadyExists" (Changes cannot be saved. Warehouse with name "{0}" already exists.)
    */
    public get warehousesWarehouseDataAlertWarehouseNameAlreadyExists() : string {
        return this.get(this.warehousesWarehouseDataAlertWarehouseNameAlreadyExistsLanguageItemName);
    }

    /**
    /* "Warehouses.WarehouseData.DeleteConfirmation" (Are you sure you want to delete warehouse "{0}"?)
    */
    public get warehousesWarehouseDataDeleteConfirmation() : string {
        return this.get(this.warehousesWarehouseDataDeleteConfirmationLanguageItemName);
    }

    /**
    /* "Warehouses.WarehouseData.Alert.CreateWarehouse" (Please create warehouse before assigning cost pools to it.)
    */
    public get warehousesWarehouseDataAlertCreateWarehouse() : string {
        return this.get(this.warehousesWarehouseDataAlertCreateWarehouseLanguageItemName);
    }

    /**
    /* "Warehouses.WarehouseData.AddNewWarehouse" (Add new warehouse)
    */
    public get warehousesWarehouseDataAddNewWarehouse() : string {
        return this.get(this.warehousesWarehouseDataAddNewWarehouseLanguageItemName);
    }

    /**
    /* "Generic.CostPools" (Cost pools)
    */
    public get genericCostPools() : string {
        return this.get(this.genericCostPoolsLanguageItemName);
    }

    /**
    /* "Warehouses.CostPoolsData.AddNewCostPool" (Add new cost pool)
    */
    public get warehousesCostPoolsDataAddNewCostPool() : string {
        return this.get(this.warehousesCostPoolsDataAddNewCostPoolLanguageItemName);
    }

    /**
    /* "UserManagement.Dropdown.MultipleCostPoolsText" (All cost pools)
    */
    public get userManagementDropdownMultipleCostPoolsText() : string {
        return this.get(this.userManagementDropdownMultipleCostPoolsTextLanguageItemName);
    }

    /**
    /* "Generic.Description" (Description)
    */
    public get genericDescription() : string {
        return this.get(this.genericDescriptionLanguageItemName);
    }

    /**
    /* "CatalogManagement.AddCategory" (Add category)
    */
    public get catalogManagementAddCategory() : string {
        return this.get(this.catalogManagementAddCategoryLanguageItemName);
    }

    /**
    /* "CatalogManagement.AddProduct" (Add product)
    */
    public get catalogManagementAddProduct() : string {
        return this.get(this.catalogManagementAddProductLanguageItemName);
    }

    /**
    /* "Generic.Price" (Price)
    */
    public get genericPrice() : string {
        return this.get(this.genericPriceLanguageItemName);
    }

    /**
    /* "Generic.Unit" (Unit)
    */
    public get genericUnit() : string {
        return this.get(this.genericUnitLanguageItemName);
    }

    /**
    /* "Generic.CustomUnit" (Custom unit)
    */
    public get genericCustomUnit() : string {
        return this.get(this.genericCustomUnitLanguageItemName);
    }

    /**
    /* "Generic.Action.Edit" (Edit)
    */
    public get genericActionEdit() : string {
        return this.get(this.genericActionEditLanguageItemName);
    }

    /**
    /* "Generic.GoInto" (Go into)
    */
    public get genericGoInto() : string {
        return this.get(this.genericGoIntoLanguageItemName);
    }

    /**
    /* "Generic.Icon" (Icon)
    */
    public get genericIcon() : string {
        return this.get(this.genericIconLanguageItemName);
    }

    /**
    /* "Generic.Action.Save" (Save)
    */
    public get genericActionSave() : string {
        return this.get(this.genericActionSaveLanguageItemName);
    }

    /**
    /* "Generic.Category" (Category)
    */
    public get genericCategory() : string {
        return this.get(this.genericCategoryLanguageItemName);
    }

    /**
    /* "Generic.Abbreviations.Vehicles" (v)
    */
    public get genericAbbreviationsVehicles() : string {
        return this.get(this.genericAbbreviationsVehiclesLanguageItemName);
    }

    /**
    /* "Generic.Abbreviations.Kilometers" (km)
    */
    public get genericAbbreviationsKilometers() : string {
        return this.get(this.genericAbbreviationsKilometersLanguageItemName);
    }

    /**
    /* "Generic.Abbreviations.Hours" (h)
    */
    public get genericAbbreviationsHours() : string {
        return this.get(this.genericAbbreviationsHoursLanguageItemName);
    }

    /**
    /* "CatalogManagement.PageTitle" (Sales products catalog)
    */
    public get catalogManagementPageTitle() : string {
        return this.get(this.catalogManagementPageTitleLanguageItemName);
    }

    /**
    /* "CategoryItem.Validation.CategoryWithSameNameAlreadyExists" (Category with a same name already exists)
    */
    public get categoryItemValidationCategoryWithSameNameAlreadyExists() : string {
        return this.get(this.categoryItemValidationCategoryWithSameNameAlreadyExistsLanguageItemName);
    }

    /**
    /* "ProductItem.Validation.ProductWithSameNameAlreadyExists" (Product with a same name already exists)
    */
    public get productItemValidationProductWithSameNameAlreadyExists() : string {
        return this.get(this.productItemValidationProductWithSameNameAlreadyExistsLanguageItemName);
    }

    /**
    /* "Generic.ExternalId" (External Id)
    */
    public get genericExternalId() : string {
        return this.get(this.genericExternalIdLanguageItemName);
    }

    /**
    /* "CatalogManagement.ConfirmationModal.RemoveCategory" (Are you sure you want to remove category "{0}"?)
    */
    public get catalogManagementConfirmationModalRemoveCategory() : string {
        return this.get(this.catalogManagementConfirmationModalRemoveCategoryLanguageItemName);
    }

    /**
    /* "CatalogManagement.Alert.CategoryRemovedSuccessfully" (Category "{0}" removed successfully)
    */
    public get catalogManagementAlertCategoryRemovedSuccessfully() : string {
        return this.get(this.catalogManagementAlertCategoryRemovedSuccessfullyLanguageItemName);
    }

    /**
    /* "CatalogManagement.Alert.CategoryEditedSuccessfully" (Category "{0}" edited successfully)
    */
    public get catalogManagementAlertCategoryEditedSuccessfully() : string {
        return this.get(this.catalogManagementAlertCategoryEditedSuccessfullyLanguageItemName);
    }

    /**
    /* "CatalogManagement.Alert.CategoryCreatedSuccessfully" (Category "{0}" created successfully)
    */
    public get catalogManagementAlertCategoryCreatedSuccessfully() : string {
        return this.get(this.catalogManagementAlertCategoryCreatedSuccessfullyLanguageItemName);
    }

    /**
    /* "CategoryItem.ParentCategory" (Parent category)
    */
    public get categoryItemParentCategory() : string {
        return this.get(this.categoryItemParentCategoryLanguageItemName);
    }

    /**
    /* "CatalogManagement.Alert.ProductCreatedSuccessfully" (Product "{0}" created successfully)
    */
    public get catalogManagementAlertProductCreatedSuccessfully() : string {
        return this.get(this.catalogManagementAlertProductCreatedSuccessfullyLanguageItemName);
    }

    /**
    /* "CatalogManagement.Alert.ProductEditedSuccessfully" (Product "{0}" edited successfully)
    */
    public get catalogManagementAlertProductEditedSuccessfully() : string {
        return this.get(this.catalogManagementAlertProductEditedSuccessfullyLanguageItemName);
    }

    /**
    /* "CatalogManagement.Alert.ProductRemovedSuccessfully" (Product "{0}" removed successfully)
    */
    public get catalogManagementAlertProductRemovedSuccessfully() : string {
        return this.get(this.catalogManagementAlertProductRemovedSuccessfullyLanguageItemName);
    }

    /**
    /* "CatalogManagement.ConfirmationModal.RemoveProduct" (Are you sure you want to remove product "{0}"?)
    */
    public get catalogManagementConfirmationModalRemoveProduct() : string {
        return this.get(this.catalogManagementConfirmationModalRemoveProductLanguageItemName);
    }

    /**
    /* "ProductItem.Validation.ProductWithSameExternalIdAlreadyExists" (External Id is already in use)
    */
    public get productItemValidationProductWithSameExternalIdAlreadyExists() : string {
        return this.get(this.productItemValidationProductWithSameExternalIdAlreadyExistsLanguageItemName);
    }

    /**
    /* "CatalogManagement.Alert.CategoryCreationFailure" (Creating category failed: {0})
    */
    public get catalogManagementAlertCategoryCreationFailure() : string {
        return this.get(this.catalogManagementAlertCategoryCreationFailureLanguageItemName);
    }

    /**
    /* "CatalogManagement.Alert.CategoryEditFailure" (Saving category failed: {0})
    */
    public get catalogManagementAlertCategoryEditFailure() : string {
        return this.get(this.catalogManagementAlertCategoryEditFailureLanguageItemName);
    }

    /**
    /* "CatalogManagement.Alert.ProductCreationFailure" (Creating product failed: {0})
    */
    public get catalogManagementAlertProductCreationFailure() : string {
        return this.get(this.catalogManagementAlertProductCreationFailureLanguageItemName);
    }

    /**
    /* "CatalogManagement.Alert.ProductEditFailure" (Saving product failed: {0})
    */
    public get catalogManagementAlertProductEditFailure() : string {
        return this.get(this.catalogManagementAlertProductEditFailureLanguageItemName);
    }

    /**
    /* "ProductItem.Product.Keywords" (Keywords)
    */
    public get productItemProductKeywords() : string {
        return this.get(this.productItemProductKeywordsLanguageItemName);
    }

    /**
    /* "WorkOrders.Actions.UnInvoice" (Cancel invoice)
    */
    public get workOrdersActionsUnInvoice() : string {
        return this.get(this.workOrdersActionsUnInvoiceLanguageItemName);
    }

    /**
    /* "WorkOrder.Actions.ConfirmUnInvoice" (Are you sure you want to cancel the invoice?)
    */
    public get workOrderActionsConfirmUnInvoice() : string {
        return this.get(this.workOrderActionsConfirmUnInvoiceLanguageItemName);
    }

    /**
    /* "AttachmentsPage.GetManual" (Attachments page)
    */
    public get attachmentsPageGetManual() : string {
        return this.get(this.attachmentsPageGetManualLanguageItemName);
    }

    /**
    /* "AttachmentsFiltersModal.Title" (Attachment filters)
    */
    public get attachmentsFiltersModalTitle() : string {
        return this.get(this.attachmentsFiltersModalTitleLanguageItemName);
    }

    /**
    /* "AttachmentsFiltersModal.UploadedAt" (Uploaded at)
    */
    public get attachmentsFiltersModalUploadedAt() : string {
        return this.get(this.attachmentsFiltersModalUploadedAtLanguageItemName);
    }

    /**
    /* "AttachmentsFiltersModal.UploadedBefore" (Uploaded before)
    */
    public get attachmentsFiltersModalUploadedBefore() : string {
        return this.get(this.attachmentsFiltersModalUploadedBeforeLanguageItemName);
    }

    /**
    /* "AttachmentsFiltersModal.UploadedFrom" (Uploaded from)
    */
    public get attachmentsFiltersModalUploadedFrom() : string {
        return this.get(this.attachmentsFiltersModalUploadedFromLanguageItemName);
    }

    /**
    /* "AttachmentsListPage.GetManual" (Attachments list)
    */
    public get attachmentsListPageGetManual() : string {
        return this.get(this.attachmentsListPageGetManualLanguageItemName);
    }

    /**
    /* "Attachments.Title" (Attachments)
    */
    public get attachmentsTitle() : string {
        return this.get(this.attachmentsTitleLanguageItemName);
    }

    /**
    /* "Generic.Action.Preview" (Preview)
    */
    public get genericActionPreview() : string {
        return this.get(this.genericActionPreviewLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Attachments.NoDataText" (No attachments)
    */
    public get workOrderDetailsPanelGridAttachmentsNoDataText() : string {
        return this.get(this.workOrderDetailsPanelGridAttachmentsNoDataTextLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Attachments.FileType" (File type)
    */
    public get workOrderDetailsPanelGridAttachmentsFileType() : string {
        return this.get(this.workOrderDetailsPanelGridAttachmentsFileTypeLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Attachments.FileName" (File name)
    */
    public get workOrderDetailsPanelGridAttachmentsFileName() : string {
        return this.get(this.workOrderDetailsPanelGridAttachmentsFileNameLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Attachments.Public" (Public)
    */
    public get workOrderDetailsPanelGridAttachmentsPublic() : string {
        return this.get(this.workOrderDetailsPanelGridAttachmentsPublicLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Toolbar.PublicCheckbox" (Public)
    */
    public get workOrderDetailsPanelToolbarPublicCheckbox() : string {
        return this.get(this.workOrderDetailsPanelToolbarPublicCheckboxLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Toolbar.AddAttachmentsButton" (Add attachments)
    */
    public get workOrderDetailsPanelToolbarAddAttachmentsButton() : string {
        return this.get(this.workOrderDetailsPanelToolbarAddAttachmentsButtonLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Attachments.AddInfo" (Add attachments)
    */
    public get workOrderDetailsPanelAttachmentsAddInfo() : string {
        return this.get(this.workOrderDetailsPanelAttachmentsAddInfoLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Attachments.ConfirmDelete" (Are you sure you want to delete {0} attachment?)
    */
    public get workOrderDetailsPanelGridAttachmentsConfirmDelete() : string {
        return this.get(this.workOrderDetailsPanelGridAttachmentsConfirmDeleteLanguageItemName);
    }

    /**
    /* "AddWorkReportAttachmentModal.PublicCheckbox" (Public)
    */
    public get addWorkReportAttachmentModalPublicCheckbox() : string {
        return this.get(this.addWorkReportAttachmentModalPublicCheckboxLanguageItemName);
    }

    /**
    /* "AddWorkReportAttachmentModal.Title" (Add work report attachment)
    */
    public get addWorkReportAttachmentModalTitle() : string {
        return this.get(this.addWorkReportAttachmentModalTitleLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Button.Label.Attachments" (Attachments)
    */
    public get rentaTasksWorkOrderButtonLabelAttachments() : string {
        return this.get(this.rentaTasksWorkOrderButtonLabelAttachmentsLanguageItemName);
    }

    /**
    /* "Generic.Action.Return" (Return)
    */
    public get genericActionReturn() : string {
        return this.get(this.genericActionReturnLanguageItemName);
    }

    /**
    /* "RentaTasksController.Alerts.RequiredInformationMissing" (Required information missing, task not saved.)
    */
    public get rentaTasksControllerAlertsRequiredInformationMissing() : string {
        return this.get(this.rentaTasksControllerAlertsRequiredInformationMissingLanguageItemName);
    }

    /**
    /* "Catalog.Modal.AddAndClose" (Add & Close)
    */
    public get catalogModalAddAndClose() : string {
        return this.get(this.catalogModalAddAndCloseLanguageItemName);
    }

    /**
    /* "Generic.UserEmailExists" (User with the provided email "{0}" already exists.)
    */
    public get genericUserEmailExists() : string {
        return this.get(this.genericUserEmailExistsLanguageItemName);
    }

    /**
    /* "Generic.UserPhoneExists" (User with the provided phone number "{0}" already exists.)
    */
    public get genericUserPhoneExists() : string {
        return this.get(this.genericUserPhoneExistsLanguageItemName);
    }

    /**
    /* "TasksPanel.CopyTaskTemplate" (Copy task template)
    */
    public get tasksPanelCopyTaskTemplate() : string {
        return this.get(this.tasksPanelCopyTaskTemplateLanguageItemName);
    }

    /**
    /* "TasksPanel.PlannedDone" (Planned completion date)
    */
    public get tasksPanelPlannedDone() : string {
        return this.get(this.tasksPanelPlannedDoneLanguageItemName);
    }

    /**
    /* "TasksPanel.PlannedCompletionDate" (Planned completion date)
    */
    public get tasksPanelPlannedCompletionDate() : string {
        return this.get(this.tasksPanelPlannedCompletionDateLanguageItemName);
    }

    /**
    /* "CalendarPage.CalendarData.ConfirmAssignDialog.AddButton" (Keep existing assignment)
    */
    public get calendarPageCalendarDataConfirmAssignDialogAddButton() : string {
        return this.get(this.calendarPageCalendarDataConfirmAssignDialogAddButtonLanguageItemName);
    }

    /**
    /* "CalendarPage.CalendarData.ConfirmAssignDialog.Body" (Keep or replace existing assignment?)
    */
    public get calendarPageCalendarDataConfirmAssignDialogBody() : string {
        return this.get(this.calendarPageCalendarDataConfirmAssignDialogBodyLanguageItemName);
    }

    /**
    /* "CalendarPage.CalendarData.ConfirmAssignDialog.ReplaceButton" (Replace existing assignment)
    */
    public get calendarPageCalendarDataConfirmAssignDialogReplaceButton() : string {
        return this.get(this.calendarPageCalendarDataConfirmAssignDialogReplaceButtonLanguageItemName);
    }

    /**
    /* "CalendarPage.CalendarData.ConfirmAssignDialog.Title" (Confirm)
    */
    public get calendarPageCalendarDataConfirmAssignDialogTitle() : string {
        return this.get(this.calendarPageCalendarDataConfirmAssignDialogTitleLanguageItemName);
    }

    /**
    /* "CalendarPage.CalendarData.UnassignedRow" (Unassigned)
    */
    public get calendarPageCalendarDataUnassignedRow() : string {
        return this.get(this.calendarPageCalendarDataUnassignedRowLanguageItemName);
    }

    /**
    /* "CalendarPage.NoTeamLabel" (No team)
    */
    public get calendarPageNoTeamLabel() : string {
        return this.get(this.calendarPageNoTeamLabelLanguageItemName);
    }

    /**
    /* "CalendarPage.PersonnelTab" (Personnel)
    */
    public get calendarPagePersonnelTab() : string {
        return this.get(this.calendarPagePersonnelTabLanguageItemName);
    }

    /**
    /* "CalendarPage.TeamsListLabel" (Teams)
    */
    public get calendarPageTeamsListLabel() : string {
        return this.get(this.calendarPageTeamsListLabelLanguageItemName);
    }

    /**
    /* "CalendarPage.Title" (Calendar planner)
    */
    public get calendarPageTitle() : string {
        return this.get(this.calendarPageTitleLanguageItemName);
    }

    /**
    /* "CalendarPage.Toolbar.Status.NotAllocated" (Not allocated)
    */
    public get calendarPageToolbarStatusNotAllocated() : string {
        return this.get(this.calendarPageToolbarStatusNotAllocatedLanguageItemName);
    }

    /**
    /* "TopNav.Calendar" (Calendar)
    */
    public get topNavCalendar() : string {
        return this.get(this.topNavCalendarLanguageItemName);
    }

    /**
    /* "CalendarPage.Toolbar.Status.NotStarted" (Not started)
    */
    public get calendarPageToolbarStatusNotStarted() : string {
        return this.get(this.calendarPageToolbarStatusNotStartedLanguageItemName);
    }

    /**
    /* "CalendarPage.Toolbar.Status.Ready" (Ready)
    */
    public get calendarPageToolbarStatusReady() : string {
        return this.get(this.calendarPageToolbarStatusReadyLanguageItemName);
    }

    /**
    /* "CalendarPage.Toolbar.Status.Started" (Started)
    */
    public get calendarPageToolbarStatusStarted() : string {
        return this.get(this.calendarPageToolbarStatusStartedLanguageItemName);
    }

    /**
    /* "Enum.CalendarUnitTime.Month" (Month)
    */
    public get enumCalendarUnitTimeMonth() : string {
        return this.get(this.enumCalendarUnitTimeMonthLanguageItemName);
    }

    /**
    /* "Enum.CalendarUnitTime.Week" (Week)
    */
    public get enumCalendarUnitTimeWeek() : string {
        return this.get(this.enumCalendarUnitTimeWeekLanguageItemName);
    }

    /**
    /* "CalendarPage.Toolbar.ViewLabel" (View)
    */
    public get calendarPageToolbarViewLabel() : string {
        return this.get(this.calendarPageToolbarViewLabelLanguageItemName);
    }

    /**
    /* "CalendarPage.Toolbar.TodayButtonLabel" (Today)
    */
    public get calendarPageToolbarTodayButtonLabel() : string {
        return this.get(this.calendarPageToolbarTodayButtonLabelLanguageItemName);
    }

    /**
    /* "Generic.Action.Add" (Add)
    */
    public get genericActionAdd() : string {
        return this.get(this.genericActionAddLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder" (Work order)
    */
    public get genericWorkOrder() : string {
        return this.get(this.genericWorkOrderLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.Edit" (Edit work order)
    */
    public get genericWorkOrderEdit() : string {
        return this.get(this.genericWorkOrderEditLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.New" (New work order)
    */
    public get genericWorkOrderNew() : string {
        return this.get(this.genericWorkOrderNewLanguageItemName);
    }

    /**
    /* "Generic.ConstructionSiteOrWarehouse" (Construction site or warehouse)
    */
    public get genericConstructionSiteOrWarehouse() : string {
        return this.get(this.genericConstructionSiteOrWarehouseLanguageItemName);
    }

    /**
    /* "Generic.Number" (Number)
    */
    public get genericNumber() : string {
        return this.get(this.genericNumberLanguageItemName);
    }

    /**
    /* "Generic.Status" (Status)
    */
    public get genericStatus() : string {
        return this.get(this.genericStatusLanguageItemName);
    }

    /**
    /* "Generic.InvoiceReference" (Invoice reference)
    */
    public get genericInvoiceReference() : string {
        return this.get(this.genericInvoiceReferenceLanguageItemName);
    }

    /**
    /* "Generic.Action.Approve" (Approve)
    */
    public get genericActionApprove() : string {
        return this.get(this.genericActionApproveLanguageItemName);
    }

    /**
    /* "Generic.Action.Lock" (Lock)
    */
    public get genericActionLock() : string {
        return this.get(this.genericActionLockLanguageItemName);
    }

    /**
    /* "Generic.Action.Unlock" (Unlock)
    */
    public get genericActionUnlock() : string {
        return this.get(this.genericActionUnlockLanguageItemName);
    }

    /**
    /* "Generic.Action.Complete" (Complete)
    */
    public get genericActionComplete() : string {
        return this.get(this.genericActionCompleteLanguageItemName);
    }

    /**
    /* "Generic.Action.Invoice" (Invoice)
    */
    public get genericActionInvoice() : string {
        return this.get(this.genericActionInvoiceLanguageItemName);
    }

    /**
    /* "Generic.Action.Uninvoice" (Uninvoice)
    */
    public get genericActionUninvoice() : string {
        return this.get(this.genericActionUninvoiceLanguageItemName);
    }

    /**
    /* "Generic.Action.Send" (Send)
    */
    public get genericActionSend() : string {
        return this.get(this.genericActionSendLanguageItemName);
    }

    /**
    /* "Generic.Type" (Type)
    */
    public get genericType() : string {
        return this.get(this.genericTypeLanguageItemName);
    }

    /**
    /* "Generic.Cost" (Cost)
    */
    public get genericCost() : string {
        return this.get(this.genericCostLanguageItemName);
    }

    /**
    /* "Generic.Mounters" (Mounters)
    */
    public get genericMounters() : string {
        return this.get(this.genericMountersLanguageItemName);
    }

    /**
    /* "Generic.Action.Activate" (Activate)
    */
    public get genericActionActivate() : string {
        return this.get(this.genericActionActivateLanguageItemName);
    }

    /**
    /* "Generic.Invoice" (Work and cost report)
    */
    public get genericInvoice() : string {
        return this.get(this.genericInvoiceLanguageItemName);
    }

    /**
    /* "Generic.Action.Copy" (Copy)
    */
    public get genericActionCopy() : string {
        return this.get(this.genericActionCopyLanguageItemName);
    }

    /**
    /* "Generic.Approver" (Approver)
    */
    public get genericApprover() : string {
        return this.get(this.genericApproverLanguageItemName);
    }

    /**
    /* "Generic.Orderer" (Orderer)
    */
    public get genericOrderer() : string {
        return this.get(this.genericOrdererLanguageItemName);
    }

    /**
    /* "Generic.Completion" (Completion)
    */
    public get genericCompletion() : string {
        return this.get(this.genericCompletionLanguageItemName);
    }

    /**
    /* "Generic.PlannedCompletion" (Planned completion)
    */
    public get genericPlannedCompletion() : string {
        return this.get(this.genericPlannedCompletionLanguageItemName);
    }

    /**
    /* "Generic.Activation" (Activation)
    */
    public get genericActivation() : string {
        return this.get(this.genericActivationLanguageItemName);
    }

    /**
    /* "Generic.Default" (Default)
    */
    public get genericDefault() : string {
        return this.get(this.genericDefaultLanguageItemName);
    }

    /**
    /* "ConfirmationDialog.DiscardUnsavedChanges" (Discard unsaved changes?)
    */
    public get confirmationDialogDiscardUnsavedChanges() : string {
        return this.get(this.confirmationDialogDiscardUnsavedChangesLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.CreatedSuccessfully" (Work order created successfully)
    */
    public get genericWorkOrderCreatedSuccessfully() : string {
        return this.get(this.genericWorkOrderCreatedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrderSavedSuccessfully" (Work order saved successfully)
    */
    public get genericWorkOrderSavedSuccessfully() : string {
        return this.get(this.genericWorkOrderSavedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.CopiedSuccessfully" (Work order copied successfully)
    */
    public get genericWorkOrderCopiedSuccessfully() : string {
        return this.get(this.genericWorkOrderCopiedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.LockedSuccessfully" (Work order locked successfully)
    */
    public get genericWorkOrderLockedSuccessfully() : string {
        return this.get(this.genericWorkOrderLockedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.UnlockedSuccessfully" (Work order unlocked successfully)
    */
    public get genericWorkOrderUnlockedSuccessfully() : string {
        return this.get(this.genericWorkOrderUnlockedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.ApprovedSuccessfully" (Work order approved successfully)
    */
    public get genericWorkOrderApprovedSuccessfully() : string {
        return this.get(this.genericWorkOrderApprovedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.ActivatedSuccessfully" (Work order activated successfully)
    */
    public get genericWorkOrderActivatedSuccessfully() : string {
        return this.get(this.genericWorkOrderActivatedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.CompletedSuccessfully" (Work order completed successfully)
    */
    public get genericWorkOrderCompletedSuccessfully() : string {
        return this.get(this.genericWorkOrderCompletedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.CompletionFailed" (Work order completion failed)
    */
    public get genericWorkOrderCompletionFailed() : string {
        return this.get(this.genericWorkOrderCompletionFailedLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.InvoicedSuccessfully" (Work order invoiced successfully)
    */
    public get genericWorkOrderInvoicedSuccessfully() : string {
        return this.get(this.genericWorkOrderInvoicedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.UninvoicedSuccessfully" (Work order invoice cancelled successfully)
    */
    public get genericWorkOrderUninvoicedSuccessfully() : string {
        return this.get(this.genericWorkOrderUninvoicedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.SendingFailed" (Work order sending failed)
    */
    public get genericWorkOrderSendingFailed() : string {
        return this.get(this.genericWorkOrderSendingFailedLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.SentSuccessfully" (Work order sent successfully)
    */
    public get genericWorkOrderSentSuccessfully() : string {
        return this.get(this.genericWorkOrderSentSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.ApprovalFailed" (Work order approval failed)
    */
    public get genericWorkOrderApprovalFailed() : string {
        return this.get(this.genericWorkOrderApprovalFailedLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderStatus.ReadyForInvoicing" (Ready for invoicing)
    */
    public get enumWorkOrderStatusReadyForInvoicing() : string {
        return this.get(this.enumWorkOrderStatusReadyForInvoicingLanguageItemName);
    }

    /**
    /* "Generic.New" (New)
    */
    public get genericNew() : string {
        return this.get(this.genericNewLanguageItemName);
    }

    /**
    /* "AdminConsolePage.Title" (Admin console)
    */
    public get adminConsolePageTitle() : string {
        return this.get(this.adminConsolePageTitleLanguageItemName);
    }

    /**
    /* "TasksToolbar.SearchField.TooManySearchWords" (Write at most five search words)
    */
    public get tasksToolbarSearchFieldTooManySearchWords() : string {
        return this.get(this.tasksToolbarSearchFieldTooManySearchWordsLanguageItemName);
    }

    /**
    /* "TasksToolbar.SearchField.Placeholder" (Code / Site / Customer / Reference)
    */
    public get tasksToolbarSearchFieldPlaceholder() : string {
        return this.get(this.tasksToolbarSearchFieldPlaceholderLanguageItemName);
    }

    /**
    /* "WorkOrderTypeManagement.PageTitle" (Work order type management)
    */
    public get workOrderTypeManagementPageTitle() : string {
        return this.get(this.workOrderTypeManagementPageTitleLanguageItemName);
    }

    /**
    /* "Generic.Action.Disable" (Disable)
    */
    public get genericActionDisable() : string {
        return this.get(this.genericActionDisableLanguageItemName);
    }

    /**
    /* "Generic.Action.Enable" (Enable)
    */
    public get genericActionEnable() : string {
        return this.get(this.genericActionEnableLanguageItemName);
    }

    /**
    /* "Generic.WorkOrderTypeLabel" (Work order type)
    */
    public get genericWorkOrderTypeLabel() : string {
        return this.get(this.genericWorkOrderTypeLabelLanguageItemName);
    }

    /**
    /* "Generic.NameClarification" (Name clarification)
    */
    public get genericNameClarification() : string {
        return this.get(this.genericNameClarificationLanguageItemName);
    }

    /**
    /* "Signature.NameClarificationDescription" (Ask customer to write their signature name clarification to approve)
    */
    public get signatureNameClarificationDescription() : string {
        return this.get(this.signatureNameClarificationDescriptionLanguageItemName);
    }

    /**
    /* "Generic.Legend" (Legend)
    */
    public get genericLegend() : string {
        return this.get(this.genericLegendLanguageItemName);
    }

    /**
    /* "AddTask.TaskTypeLabel" (Work order type)
    */
    public get addTaskTaskTypeLabel() : string {
        return this.get(this.addTaskTaskTypeLabelLanguageItemName);
    }

    /**
    /* "AddTask.TaskTypeDescription" (Select work order type)
    */
    public get addTaskTaskTypeDescription() : string {
        return this.get(this.addTaskTaskTypeDescriptionLanguageItemName);
    }

    /**
    /* "Generic.NoName" (No name)
    */
    public get genericNoName() : string {
        return this.get(this.genericNoNameLanguageItemName);
    }

    /**
    /* "WorkOrders.HoursTab.Title" (Hours)
    */
    public get workOrdersHoursTabTitle() : string {
        return this.get(this.workOrdersHoursTabTitleLanguageItemName);
    }

    /**
    /* "WorkOrders.JobSummary" (Note for customer)
    */
    public get workOrdersJobSummary() : string {
        return this.get(this.workOrdersJobSummaryLanguageItemName);
    }

    /**
    /* "WorkOrders.Manager" (Manager)
    */
    public get workOrdersManager() : string {
        return this.get(this.workOrdersManagerLanguageItemName);
    }

    /**
    /* "WorkOrders.ShowDetailsTitle" (Show details)
    */
    public get workOrdersShowDetailsTitle() : string {
        return this.get(this.workOrdersShowDetailsTitleLanguageItemName);
    }

    /**
    /* "WorkOrders.EquipmentsTab.Title" (Products)
    */
    public get workOrdersEquipmentsTabTitle() : string {
        return this.get(this.workOrdersEquipmentsTabTitleLanguageItemName);
    }

    /**
    /* "WorkOrders.DeclineAction" (Decline)
    */
    public get workOrdersDeclineAction() : string {
        return this.get(this.workOrdersDeclineActionLanguageItemName);
    }

    /**
    /* "WorkOrders.CustomerOrderer" (Orderer)
    */
    public get workOrdersCustomerOrderer() : string {
        return this.get(this.workOrdersCustomerOrdererLanguageItemName);
    }

    /**
    /* "WorkOrders.ApproveAction" (Approve)
    */
    public get workOrdersApproveAction() : string {
        return this.get(this.workOrdersApproveActionLanguageItemName);
    }

    /**
    /* "WorkOrderEquipment.Price" (Price)
    */
    public get workOrderEquipmentPrice() : string {
        return this.get(this.workOrderEquipmentPriceLanguageItemName);
    }

    /**
    /* "WorkOrderEquipment.Name" (Product)
    */
    public get workOrderEquipmentName() : string {
        return this.get(this.workOrderEquipmentNameLanguageItemName);
    }

    /**
    /* "WorkOrderEquipment.Description" (Description)
    */
    public get workOrderEquipmentDescription() : string {
        return this.get(this.workOrderEquipmentDescriptionLanguageItemName);
    }

    /**
    /* "WorkOrderEquipment.Amount" (Amount)
    */
    public get workOrderEquipmentAmount() : string {
        return this.get(this.workOrderEquipmentAmountLanguageItemName);
    }

    /**
    /* "WorkOrderEquipment.AddProduct" (Add product)
    */
    public get workOrderEquipmentAddProduct() : string {
        return this.get(this.workOrderEquipmentAddProductLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Hours.HoursPrice.InfoTitle" (Default hours price)
    */
    public get workOrderDetailsPanelGridHoursHoursPriceInfoTitle() : string {
        return this.get(this.workOrderDetailsPanelGridHoursHoursPriceInfoTitleLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Equipment.Price.InfoTitle" (Default product price)
    */
    public get workOrderDetailsPanelGridEquipmentPriceInfoTitle() : string {
        return this.get(this.workOrderDetailsPanelGridEquipmentPriceInfoTitleLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Equipment.ConfirmDelete" (Are you sure you want to delete the equipment \"{0}\"?)
    */
    public get workOrderDetailsPanelGridEquipmentConfirmDelete() : string {
        return this.get(this.workOrderDetailsPanelGridEquipmentConfirmDeleteLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Distances.Vehicles" (Vehicles)
    */
    public get workOrderDetailsPanelGridDistancesVehicles() : string {
        return this.get(this.workOrderDetailsPanelGridDistancesVehiclesLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Distances.Price" (Price, €/km)
    */
    public get workOrderDetailsPanelGridDistancesPrice() : string {
        return this.get(this.workOrderDetailsPanelGridDistancesPriceLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Distances.NoDataText" (No distances reported)
    */
    public get workOrderDetailsPanelGridDistancesNoDataText() : string {
        return this.get(this.workOrderDetailsPanelGridDistancesNoDataTextLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Distances.Distance" (Total distance, km)
    */
    public get workOrderDetailsPanelGridDistancesDistance() : string {
        return this.get(this.workOrderDetailsPanelGridDistancesDistanceLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Distances.Day" (Day)
    */
    public get workOrderDetailsPanelGridDistancesDay() : string {
        return this.get(this.workOrderDetailsPanelGridDistancesDayLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Distances.Cost" (Cost, €)
    */
    public get workOrderDetailsPanelGridDistancesCost() : string {
        return this.get(this.workOrderDetailsPanelGridDistancesCostLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Distances.ConfirmDelete" (Are you sure you want to delete {0} km from date {1:dd.MM.yyyy}?)
    */
    public get workOrderDetailsPanelGridDistancesConfirmDelete() : string {
        return this.get(this.workOrderDetailsPanelGridDistancesConfirmDeleteLanguageItemName);
    }

    /**
    /* "ActivateConstructionSite.Description" (Activate construction site from ERP system)
    */
    public get activateConstructionSiteDescription() : string {
        return this.get(this.activateConstructionSiteDescriptionLanguageItemName);
    }

    /**
    /* "ActivateConstructionSite.Label" (Activate worksite)
    */
    public get activateConstructionSiteLabel() : string {
        return this.get(this.activateConstructionSiteLabelLanguageItemName);
    }

    /**
    /* "ActivateConstructionSite.Summary.AddressLabel" (Address)
    */
    public get activateConstructionSiteSummaryAddressLabel() : string {
        return this.get(this.activateConstructionSiteSummaryAddressLabelLanguageItemName);
    }

    /**
    /* "ActivateConstructionSite.Summary.CustomerLabel" (Customer)
    */
    public get activateConstructionSiteSummaryCustomerLabel() : string {
        return this.get(this.activateConstructionSiteSummaryCustomerLabelLanguageItemName);
    }

    /**
    /* "ActivateConstructionSite.Summary.WorksiteNameLabel" (Worksite)
    */
    public get activateConstructionSiteSummaryWorksiteNameLabel() : string {
        return this.get(this.activateConstructionSiteSummaryWorksiteNameLabelLanguageItemName);
    }

    /**
    /* "AddConstructionsite.DuplicateDeviceId" (Time tracking device id is already register for another construction site or warehouse.)
    */
    public get addConstructionsiteDuplicateDeviceId() : string {
        return this.get(this.addConstructionsiteDuplicateDeviceIdLanguageItemName);
    }

    /**
    /* "AddConstructionsite.Flyout" (Construction site has been created)
    */
    public get addConstructionsiteFlyout() : string {
        return this.get(this.addConstructionsiteFlyoutLanguageItemName);
    }

    /**
    /* "AddConstructionsite.Redirect" (Redirect to construction site page)
    */
    public get addConstructionsiteRedirect() : string {
        return this.get(this.addConstructionsiteRedirectLanguageItemName);
    }

    /**
    /* "AddConstructionSite.Reference" (ERP Reference)
    */
    public get addConstructionSiteReference() : string {
        return this.get(this.addConstructionSiteReferenceLanguageItemName);
    }

    /**
    /* "AddMounterModal.Labels.Overtime100Hours" (Overtime 100%)
    */
    public get addMounterModalLabelsOvertime100Hours() : string {
        return this.get(this.addMounterModalLabelsOvertime100HoursLanguageItemName);
    }

    /**
    /* "AddMounterModal.Labels.Overtime50Hours" (Overtime 50%)
    */
    public get addMounterModalLabelsOvertime50Hours() : string {
        return this.get(this.addMounterModalLabelsOvertime50HoursLanguageItemName);
    }

    /**
    /* "AddTaskModal.CostEuro" (Cost, €)
    */
    public get addTaskModalCostEuro() : string {
        return this.get(this.addTaskModalCostEuroLanguageItemName);
    }

    /**
    /* "AddTaskModal.CreateAndClose" (Create and close)
    */
    public get addTaskModalCreateAndClose() : string {
        return this.get(this.addTaskModalCreateAndCloseLanguageItemName);
    }

    /**
    /* "AddTaskModal.CreateAndContinue" (Create and continue)
    */
    public get addTaskModalCreateAndContinue() : string {
        return this.get(this.addTaskModalCreateAndContinueLanguageItemName);
    }

    /**
    /* "AddTaskModal.CreateTask" (Create task)
    */
    public get addTaskModalCreateTask() : string {
        return this.get(this.addTaskModalCreateTaskLanguageItemName);
    }

    /**
    /* "AddTaskModal.ExtraHours" (Extra hours)
    */
    public get addTaskModalExtraHours() : string {
        return this.get(this.addTaskModalExtraHoursLanguageItemName);
    }

    /**
    /* "AddTaskModal.ExtraHours.AutoCalculated" (Auto calculated)
    */
    public get addTaskModalExtraHoursAutoCalculated() : string {
        return this.get(this.addTaskModalExtraHoursAutoCalculatedLanguageItemName);
    }

    /**
    /* "AddTaskModal.Validation.CreateTaskFirst" (Create task first to enable mounter hours and extra charges functionality)
    */
    public get addTaskModalValidationCreateTaskFirst() : string {
        return this.get(this.addTaskModalValidationCreateTaskFirstLanguageItemName);
    }

    /**
    /* "AddTaskModal.Validation.CreateWorkReportFirst" (Save work report first to enable mounter hours and extra charges functionality)
    */
    public get addTaskModalValidationCreateWorkReportFirst() : string {
        return this.get(this.addTaskModalValidationCreateWorkReportFirstLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.AttachmentRemoveConfirmation" (Are you sure that you want to remove attachment file?)
    */
    public get addWorkReportModalAttachmentRemoveConfirmation() : string {
        return this.get(this.addWorkReportModalAttachmentRemoveConfirmationLanguageItemName);
    }

    /**
    /* "AddTaskModal.Name" (Name)
    */
    public get addTaskModalName() : string {
        return this.get(this.addTaskModalNameLanguageItemName);
    }

    /**
    /* "AddTaskModal.PriceEuro" (Price, €)
    */
    public get addTaskModalPriceEuro() : string {
        return this.get(this.addTaskModalPriceEuroLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.Grid.ExtraCharges" (Extra charges)
    */
    public get addWorkReportModalGridExtraCharges() : string {
        return this.get(this.addWorkReportModalGridExtraChargesLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.Grid.ExtraCharges.Title" (Sum of task extra charges costs)
    */
    public get addWorkReportModalGridExtraChargesTitle() : string {
        return this.get(this.addWorkReportModalGridExtraChargesTitleLanguageItemName);
    }

    /**
    /* "AddWorkReportModal.Validation.CreateWorkReportFirst" (Create work report first to enable creating new tasks functionality)
    */
    public get addWorkReportModalValidationCreateWorkReportFirst() : string {
        return this.get(this.addWorkReportModalValidationCreateWorkReportFirstLanguageItemName);
    }

    /**
    /* "AssignMounters.Manual" (Assign mounters to the work order, swipe right, or press next when you finished. You can also leave it open for everyone by not specifying any mounter.)
    */
    public get assignMountersManual() : string {
        return this.get(this.assignMountersManualLanguageItemName);
    }

    /**
    /* "AuditModule.Continue" (Continue inspection)
    */
    public get auditModuleContinue() : string {
        return this.get(this.auditModuleContinueLanguageItemName);
    }

    /**
    /* "AuditModule.EmailReceivers.ContactPerson" (Contact person)
    */
    public get auditModuleEmailReceiversContactPerson() : string {
        return this.get(this.auditModuleEmailReceiversContactPersonLanguageItemName);
    }

    /**
    /* "AuditModule.EmailReceivers.NoContactPersonWarning" (Contact person is not specified on agreement level. Audit can not be sent for approval)
    */
    public get auditModuleEmailReceiversNoContactPersonWarning() : string {
        return this.get(this.auditModuleEmailReceiversNoContactPersonWarningLanguageItemName);
    }

    /**
    /* "AuditModule.EmailReceivers.Receiver" (Receiver)
    */
    public get auditModuleEmailReceiversReceiver() : string {
        return this.get(this.auditModuleEmailReceiversReceiverLanguageItemName);
    }

    /**
    /* "AuditModule.NotSent" (Not sent)
    */
    public get auditModuleNotSent() : string {
        return this.get(this.auditModuleNotSentLanguageItemName);
    }

    /**
    /* "AuditModule.Preview" (Preview and send)
    */
    public get auditModulePreview() : string {
        return this.get(this.auditModulePreviewLanguageItemName);
    }

    /**
    /* "AuditModule.Sent" (Sent)
    */
    public get auditModuleSent() : string {
        return this.get(this.auditModuleSentLanguageItemName);
    }

    /**
    /* "Catalog.FlyoutMessage.ProductMarkedAsDeleted" (Product '{0}' marked as deleted.)
    */
    public get catalogFlyoutMessageProductMarkedAsDeleted() : string {
        return this.get(this.catalogFlyoutMessageProductMarkedAsDeletedLanguageItemName);
    }

    /**
    /* "Catalog.FlyoutMessage.ProductPermanentlyRemoved" (Product '{0}' removed permanently.)
    */
    public get catalogFlyoutMessageProductPermanentlyRemoved() : string {
        return this.get(this.catalogFlyoutMessageProductPermanentlyRemovedLanguageItemName);
    }

    /**
    /* "Catalog.FlyoutMessage.ProductRestored" (Product '{0}' successfully restored.)
    */
    public get catalogFlyoutMessageProductRestored() : string {
        return this.get(this.catalogFlyoutMessageProductRestoredLanguageItemName);
    }

    /**
    /* "CatalogManagement.ErrorMessage.Restore.ProductNotExists" ('Product cannot be restored. Product with id '{0}' does not exist.)
    */
    public get catalogManagementErrorMessageRestoreProductNotExists() : string {
        return this.get(this.catalogManagementErrorMessageRestoreProductNotExistsLanguageItemName);
    }

    /**
    /* "CheckInsPanel.CheckInAt" (Check in at)
    */
    public get checkInsPanelCheckInAt() : string {
        return this.get(this.checkInsPanelCheckInAtLanguageItemName);
    }

    /**
    /* "CheckInsPanel.NoDataText" (No sign-ins or check-ins are registered)
    */
    public get checkInsPanelNoDataText() : string {
        return this.get(this.checkInsPanelNoDataTextLanguageItemName);
    }

    /**
    /* "CheckInsPanel.CheckOutAt" (Check out at)
    */
    public get checkInsPanelCheckOutAt() : string {
        return this.get(this.checkInsPanelCheckOutAtLanguageItemName);
    }

    /**
    /* "CheckInsPanel.Sign" (Site sign)
    */
    public get checkInsPanelSign() : string {
        return this.get(this.checkInsPanelSignLanguageItemName);
    }

    /**
    /* "Component.Dropdown.Add" (Add)
    */
    public get componentDropdownAdd() : string {
        return this.get(this.componentDropdownAddLanguageItemName);
    }

    /**
    /* "ConstructionSitePanel.ExternalName" (ERP name)
    */
    public get constructionSitePanelExternalName() : string {
        return this.get(this.constructionSitePanelExternalNameLanguageItemName);
    }

    /**
    /* "ConstructionSitePanel.OrganizationContractInvoicesSent" (Organization Contract (Invoices already sent!))
    */
    public get constructionSitePanelOrganizationContractInvoicesSent() : string {
        return this.get(this.constructionSitePanelOrganizationContractInvoicesSentLanguageItemName);
    }

    /**
    /* "ConstructionSites.CancelChanges" (Cancel changes)
    */
    public get constructionSitesCancelChanges() : string {
        return this.get(this.constructionSitesCancelChangesLanguageItemName);
    }

    /**
    /* "ConstructionSites.CommitChanges" (Commit changes)
    */
    public get constructionSitesCommitChanges() : string {
        return this.get(this.constructionSitesCommitChangesLanguageItemName);
    }

    /**
    /* "ConstructionSites.Name" (Name)
    */
    public get constructionSitesName() : string {
        return this.get(this.constructionSitesNameLanguageItemName);
    }

    /**
    /* "ConstructionSites.ToolBar.SearchTermFilterWithReference" (Site / Customer / Reference / Address)
    */
    public get constructionSitesToolBarSearchTermFilterWithReference() : string {
        return this.get(this.constructionSitesToolBarSearchTermFilterWithReferenceLanguageItemName);
    }

    /**
    /* "DailyHoursModal.Labels.Date" (Date)
    */
    public get dailyHoursModalLabelsDate() : string {
        return this.get(this.dailyHoursModalLabelsDateLanguageItemName);
    }

    /**
    /* "DailyHoursModal.Labels.Mounter" (Mounter)
    */
    public get dailyHoursModalLabelsMounter() : string {
        return this.get(this.dailyHoursModalLabelsMounterLanguageItemName);
    }

    /**
    /* "DailyHoursModal.Labels.NormalHours" (Normal hours)
    */
    public get dailyHoursModalLabelsNormalHours() : string {
        return this.get(this.dailyHoursModalLabelsNormalHoursLanguageItemName);
    }

    /**
    /* "DailyHoursModal.Labels.Overtime100Hours" (Overtime 100%)
    */
    public get dailyHoursModalLabelsOvertime100Hours() : string {
        return this.get(this.dailyHoursModalLabelsOvertime100HoursLanguageItemName);
    }

    /**
    /* "DailyHoursModal.Labels.Overtime50Hours" (Overtime 50%)
    */
    public get dailyHoursModalLabelsOvertime50Hours() : string {
        return this.get(this.dailyHoursModalLabelsOvertime50HoursLanguageItemName);
    }

    /**
    /* "DailyHoursModal.Subtitle" (Work order working hours)
    */
    public get dailyHoursModalSubtitle() : string {
        return this.get(this.dailyHoursModalSubtitleLanguageItemName);
    }

    /**
    /* "DailyHoursWidget.Buttons.AddHours" (Add user hours)
    */
    public get dailyHoursWidgetButtonsAddHours() : string {
        return this.get(this.dailyHoursWidgetButtonsAddHoursLanguageItemName);
    }

    /**
    /* "DailyHoursWidget.Description" (Total work order working hours)
    */
    public get dailyHoursWidgetDescription() : string {
        return this.get(this.dailyHoursWidgetDescriptionLanguageItemName);
    }

    /**
    /* "DailyHoursWidget.Label" (All hours)
    */
    public get dailyHoursWidgetLabel() : string {
        return this.get(this.dailyHoursWidgetLabelLanguageItemName);
    }

    /**
    /* "DailyHoursWidget.Labels.Normal" (Normal)
    */
    public get dailyHoursWidgetLabelsNormal() : string {
        return this.get(this.dailyHoursWidgetLabelsNormalLanguageItemName);
    }

    /**
    /* "Dashboard.Flyout.SiteCreated" (New construction site has been created)
    */
    public get dashboardFlyoutSiteCreated() : string {
        return this.get(this.dashboardFlyoutSiteCreatedLanguageItemName);
    }

    /**
    /* "DistanceModal.Labels.Date" (Date)
    */
    public get distanceModalLabelsDate() : string {
        return this.get(this.distanceModalLabelsDateLanguageItemName);
    }

    /**
    /* "DistanceModal.Labels.Value" (Total distance, km)
    */
    public get distanceModalLabelsValue() : string {
        return this.get(this.distanceModalLabelsValueLanguageItemName);
    }

    /**
    /* "DistanceModal.Labels.Vehicles" (Vehicles amount)
    */
    public get distanceModalLabelsVehicles() : string {
        return this.get(this.distanceModalLabelsVehiclesLanguageItemName);
    }

    /**
    /* "DistanceModal.Subtitle" (Work order kilometer)
    */
    public get distanceModalSubtitle() : string {
        return this.get(this.distanceModalSubtitleLanguageItemName);
    }

    /**
    /* "DistanceWidget.Buttons.AddKilometers" (Add kilometers)
    */
    public get distanceWidgetButtonsAddKilometers() : string {
        return this.get(this.distanceWidgetButtonsAddKilometersLanguageItemName);
    }

    /**
    /* "DistanceWidget.Description" (Total work order distance amount)
    */
    public get distanceWidgetDescription() : string {
        return this.get(this.distanceWidgetDescriptionLanguageItemName);
    }

    /**
    /* "DistanceWidget.Label" (Distance)
    */
    public get distanceWidgetLabel() : string {
        return this.get(this.distanceWidgetLabelLanguageItemName);
    }

    /**
    /* "Enum.InvoiceStateFilter.Approved" (Approved)
    */
    public get enumInvoiceStateFilterApproved() : string {
        return this.get(this.enumInvoiceStateFilterApprovedLanguageItemName);
    }

    /**
    /* "Enum.InvoiceStateFilter.Approved.Description" (Invoice approved by manager)
    */
    public get enumInvoiceStateFilterApprovedDescription() : string {
        return this.get(this.enumInvoiceStateFilterApprovedDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceStateFilter.Created" (Created)
    */
    public get enumInvoiceStateFilterCreated() : string {
        return this.get(this.enumInvoiceStateFilterCreatedLanguageItemName);
    }

    /**
    /* "Enum.InvoiceStateFilter.Created.Description" (Create by manager, not approved)
    */
    public get enumInvoiceStateFilterCreatedDescription() : string {
        return this.get(this.enumInvoiceStateFilterCreatedDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceStateFilter.Failed" (Failed)
    */
    public get enumInvoiceStateFilterFailed() : string {
        return this.get(this.enumInvoiceStateFilterFailedLanguageItemName);
    }

    /**
    /* "Enum.InvoiceStateFilter.Failed.Description" (Failed during processing by invoicing system)
    */
    public get enumInvoiceStateFilterFailedDescription() : string {
        return this.get(this.enumInvoiceStateFilterFailedDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceStateFilter.Locked" (Locked)
    */
    public get enumInvoiceStateFilterLocked() : string {
        return this.get(this.enumInvoiceStateFilterLockedLanguageItemName);
    }

    /**
    /* "Enum.InvoiceStateFilter.Locked.Description" (An invoice marked as locked and ready to be sent)
    */
    public get enumInvoiceStateFilterLockedDescription() : string {
        return this.get(this.enumInvoiceStateFilterLockedDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceStateFilter.Processed" (Processed)
    */
    public get enumInvoiceStateFilterProcessed() : string {
        return this.get(this.enumInvoiceStateFilterProcessedLanguageItemName);
    }

    /**
    /* "Enum.InvoiceStateFilter.Processed.Description" (Successfully processed by invoicing system)
    */
    public get enumInvoiceStateFilterProcessedDescription() : string {
        return this.get(this.enumInvoiceStateFilterProcessedDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceStateFilter.Sent.Description" (Invoice sent to invoicing system)
    */
    public get enumInvoiceStateFilterSentDescription() : string {
        return this.get(this.enumInvoiceStateFilterSentDescriptionLanguageItemName);
    }

    /**
    /* "Enum.InvoiceStateFilter.Sent" (Sent)
    */
    public get enumInvoiceStateFilterSent() : string {
        return this.get(this.enumInvoiceStateFilterSentLanguageItemName);
    }

    /**
    /* "Enum.UserRoleGroup.ContactPersons" (Contact Persons)
    */
    public get enumUserRoleGroupContactPersons() : string {
        return this.get(this.enumUserRoleGroupContactPersonsLanguageItemName);
    }

    /**
    /* "Enum.TaskStatusFilter.ApprovedByCustomer" (Approved by customer)
    */
    public get enumTaskStatusFilterApprovedByCustomer() : string {
        return this.get(this.enumTaskStatusFilterApprovedByCustomerLanguageItemName);
    }

    /**
    /* "Enum.TaskStatusFilter.Completed" (Completed)
    */
    public get enumTaskStatusFilterCompleted() : string {
        return this.get(this.enumTaskStatusFilterCompletedLanguageItemName);
    }

    /**
    /* "Enum.TaskStatusFilter.DeclinedByCustomer" (Declined by customer)
    */
    public get enumTaskStatusFilterDeclinedByCustomer() : string {
        return this.get(this.enumTaskStatusFilterDeclinedByCustomerLanguageItemName);
    }

    /**
    /* "Enum.TaskStatusFilter.InProgress" (In process)
    */
    public get enumTaskStatusFilterInProgress() : string {
        return this.get(this.enumTaskStatusFilterInProgressLanguageItemName);
    }

    /**
    /* "Enum.TaskStatusFilter.Invoiced" (Invoiced)
    */
    public get enumTaskStatusFilterInvoiced() : string {
        return this.get(this.enumTaskStatusFilterInvoicedLanguageItemName);
    }

    /**
    /* "Enum.TaskStatusFilter.ReadyForInvoicing" (Ready for invoicing)
    */
    public get enumTaskStatusFilterReadyForInvoicing() : string {
        return this.get(this.enumTaskStatusFilterReadyForInvoicingLanguageItemName);
    }

    /**
    /* "Enum.TaskStatusFilter.SentToCustomer" (Sent to customer)
    */
    public get enumTaskStatusFilterSentToCustomer() : string {
        return this.get(this.enumTaskStatusFilterSentToCustomerLanguageItemName);
    }

    /**
    /* "Enum.TaskStatusFilter.Unscheduled" (Unscheduled)
    */
    public get enumTaskStatusFilterUnscheduled() : string {
        return this.get(this.enumTaskStatusFilterUnscheduledLanguageItemName);
    }

    /**
    /* "Enum.TaskStatusFilter.Upcoming" (Upcoming)
    */
    public get enumTaskStatusFilterUpcoming() : string {
        return this.get(this.enumTaskStatusFilterUpcomingLanguageItemName);
    }

    /**
    /* "Form.Input.Postalbox" (Postal box)
    */
    public get formInputPostalbox() : string {
        return this.get(this.formInputPostalboxLanguageItemName);
    }

    /**
    /* "Form.Input.TimeTrackingDeviceId" (Time tracking device id)
    */
    public get formInputTimeTrackingDeviceId() : string {
        return this.get(this.formInputTimeTrackingDeviceIdLanguageItemName);
    }

    /**
    /* "Generic.FileNotFound" (File was not found.)
    */
    public get genericFileNotFound() : string {
        return this.get(this.genericFileNotFoundLanguageItemName);
    }

    /**
    /* "ImageModal.Download" (Download)
    */
    public get imageModalDownload() : string {
        return this.get(this.imageModalDownloadLanguageItemName);
    }

    /**
    /* "Invoices.Cost" (Cost, €)
    */
    public get invoicesCost() : string {
        return this.get(this.invoicesCostLanguageItemName);
    }

    /**
    /* "KnownSettings.HourPrice" (Default hourly price, €/h)
    */
    public get knownSettingsHourPrice() : string {
        return this.get(this.knownSettingsHourPriceLanguageItemName);
    }

    /**
    /* "KnownSettings.MileagePrice" (Default kilometer allowance, €/m)
    */
    public get knownSettingsMileagePrice() : string {
        return this.get(this.knownSettingsMileagePriceLanguageItemName);
    }

    /**
    /* "Managers.OrdererSavedSuccessfully" (Orderer has been saved successfully.)
    */
    public get managersOrdererSavedSuccessfully() : string {
        return this.get(this.managersOrdererSavedSuccessfullyLanguageItemName);
    }

    /**
    /* "ManagersStep.Approver.Add" (New approver)
    */
    public get managersStepApproverAdd() : string {
        return this.get(this.managersStepApproverAddLanguageItemName);
    }

    /**
    /* "ManagersStep.Approver.Description" (Choose or create an approver)
    */
    public get managersStepApproverDescription() : string {
        return this.get(this.managersStepApproverDescriptionLanguageItemName);
    }

    /**
    /* "ManagersStep.Approver.Label" (Customer approver)
    */
    public get managersStepApproverLabel() : string {
        return this.get(this.managersStepApproverLabelLanguageItemName);
    }

    /**
    /* "ManagersStep.ApproverNotSpecified" (Approver data should be specified!)
    */
    public get managersStepApproverNotSpecified() : string {
        return this.get(this.managersStepApproverNotSpecifiedLanguageItemName);
    }

    /**
    /* "ManagersStep.ApproverSaved" (Approver has been saved successfully.)
    */
    public get managersStepApproverSaved() : string {
        return this.get(this.managersStepApproverSavedLanguageItemName);
    }

    /**
    /* "ManagersStep.Manager.Description" (Choose a manager)
    */
    public get managersStepManagerDescription() : string {
        return this.get(this.managersStepManagerDescriptionLanguageItemName);
    }

    /**
    /* "ManagersStep.Manager.Label" (Manager)
    */
    public get managersStepManagerLabel() : string {
        return this.get(this.managersStepManagerLabelLanguageItemName);
    }

    /**
    /* "ManagersStep.Manual" (Specify the work order manager, customer approver, and customer orderer. Customer contact information (email, phone, first and last name) should also be specified.)
    */
    public get managersStepManual() : string {
        return this.get(this.managersStepManualLanguageItemName);
    }

    /**
    /* "ManagersStep.Orderer.Add" (New orderer)
    */
    public get managersStepOrdererAdd() : string {
        return this.get(this.managersStepOrdererAddLanguageItemName);
    }

    /**
    /* "ManagersStep.Orderer.Description" (Choose or create an orderer)
    */
    public get managersStepOrdererDescription() : string {
        return this.get(this.managersStepOrdererDescriptionLanguageItemName);
    }

    /**
    /* "ManagersStep.Orderer.Label" (Customer orderer)
    */
    public get managersStepOrdererLabel() : string {
        return this.get(this.managersStepOrdererLabelLanguageItemName);
    }

    /**
    /* "ManagersStep.OrdererNotSpecified" (Orderer data should be specified!)
    */
    public get managersStepOrdererNotSpecified() : string {
        return this.get(this.managersStepOrdererNotSpecifiedLanguageItemName);
    }

    /**
    /* "ManagersStep.OrdererSave" (Orderer has been saved successfully.)
    */
    public get managersStepOrdererSave() : string {
        return this.get(this.managersStepOrdererSaveLanguageItemName);
    }

    /**
    /* "ModuleModel.Custom" (Custom)
    */
    public get moduleModelCustom() : string {
        return this.get(this.moduleModelCustomLanguageItemName);
    }

    /**
    /* "MyWorkHours.LunchHourInstructionsDescription" (Enter all of your working hours. Lunch hours will be calculated automatically.)
    */
    public get myWorkHoursLunchHourInstructionsDescription() : string {
        return this.get(this.myWorkHoursLunchHourInstructionsDescriptionLanguageItemName);
    }

    /**
    /* "MyWorkHours.LunchHourInstructionsTitle" (Note)
    */
    public get myWorkHoursLunchHourInstructionsTitle() : string {
        return this.get(this.myWorkHoursLunchHourInstructionsTitleLanguageItemName);
    }

    /**
    /* "MyWorkHours.NoTask" (NO TASK ASSIGNED)
    */
    public get myWorkHoursNoTask() : string {
        return this.get(this.myWorkHoursNoTaskLanguageItemName);
    }

    /**
    /* "SalaryHoursPanel.Price" (Price)
    */
    public get salaryHoursPanelPrice() : string {
        return this.get(this.salaryHoursPanelPriceLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsHoursGrid.Price" (Price)
    */
    public get workOrderDetailsHoursGridPrice() : string {
        return this.get(this.workOrderDetailsHoursGridPriceLanguageItemName);
    }

    /**
    /* "WorkOrderDetails.HoursGrid.User" (User)
    */
    public get workOrderDetailsHoursGridUser() : string {
        return this.get(this.workOrderDetailsHoursGridUserLanguageItemName);
    }

    /**
    /* "WorkOrderDetails.HoursGrid.OverTime50" (Overtime 50%)
    */
    public get workOrderDetailsHoursGridOverTime50() : string {
        return this.get(this.workOrderDetailsHoursGridOverTime50LanguageItemName);
    }

    /**
    /* "WorkOrderDetails.HoursGrid.OverTime100" (Overtime 100%)
    */
    public get workOrderDetailsHoursGridOverTime100() : string {
        return this.get(this.workOrderDetailsHoursGridOverTime100LanguageItemName);
    }

    /**
    /* "WorkOrderDetails.HoursGrid.NormalHours" (Normal)
    */
    public get workOrderDetailsHoursGridNormalHours() : string {
        return this.get(this.workOrderDetailsHoursGridNormalHoursLanguageItemName);
    }

    /**
    /* "WorkOrderDetails.HoursGrid.HoursHeader" (Hours)
    */
    public get workOrderDetailsHoursGridHoursHeader() : string {
        return this.get(this.workOrderDetailsHoursGridHoursHeaderLanguageItemName);
    }

    /**
    /* "WorkOrderDetails.HoursGrid.Day" (Day)
    */
    public get workOrderDetailsHoursGridDay() : string {
        return this.get(this.workOrderDetailsHoursGridDayLanguageItemName);
    }

    /**
    /* "WorkOrderDetails.DistancesTab.Title" (Mileages)
    */
    public get workOrderDetailsDistancesTabTitle() : string {
        return this.get(this.workOrderDetailsDistancesTabTitleLanguageItemName);
    }

    /**
    /* "WorkOrderDetails.AddHours" (Add hours)
    */
    public get workOrderDetailsAddHours() : string {
        return this.get(this.workOrderDetailsAddHoursLanguageItemName);
    }

    /**
    /* "WorkOrderDetails.AddDistance" (Add distance)
    */
    public get workOrderDetailsAddDistance() : string {
        return this.get(this.workOrderDetailsAddDistanceLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Modal.Title" (Work order "{0}" approval)
    */
    public get workOrderApprovalModalTitle() : string {
        return this.get(this.workOrderApprovalModalTitleLanguageItemName);
    }

    /**
    /* "WorkHoursWidget.Summary" (Working hours: {0:0.0})
    */
    public get workHoursWidgetSummary() : string {
        return this.get(this.workHoursWidgetSummaryLanguageItemName);
    }

    /**
    /* "WorkOrder.Labels.MyHours" (My hours)
    */
    public get workOrderLabelsMyHours() : string {
        return this.get(this.workOrderLabelsMyHoursLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Equipment.Amount" (Amount)
    */
    public get workOrderApprovalEquipmentAmount() : string {
        return this.get(this.workOrderApprovalEquipmentAmountLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Equipment.Description" (Description)
    */
    public get workOrderApprovalEquipmentDescription() : string {
        return this.get(this.workOrderApprovalEquipmentDescriptionLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Equipment.Info" (Info)
    */
    public get workOrderApprovalEquipmentInfo() : string {
        return this.get(this.workOrderApprovalEquipmentInfoLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Equipment.Unit" (Unit)
    */
    public get workOrderApprovalEquipmentUnit() : string {
        return this.get(this.workOrderApprovalEquipmentUnitLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.EquipmentsTable.Name" (Equipments)
    */
    public get workOrderApprovalEquipmentsTableName() : string {
        return this.get(this.workOrderApprovalEquipmentsTableNameLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Hours.Day" (Day)
    */
    public get workOrderApprovalHoursDay() : string {
        return this.get(this.workOrderApprovalHoursDayLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Hours.NormalHours" (Hours)
    */
    public get workOrderApprovalHoursNormalHours() : string {
        return this.get(this.workOrderApprovalHoursNormalHoursLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Hours.Overtime100Hours" (Overtime 100%)
    */
    public get workOrderApprovalHoursOvertime100Hours() : string {
        return this.get(this.workOrderApprovalHoursOvertime100HoursLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Hours.Overtime50Hours" (Overtime 50%)
    */
    public get workOrderApprovalHoursOvertime50Hours() : string {
        return this.get(this.workOrderApprovalHoursOvertime50HoursLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Hours.User" (Mounter)
    */
    public get workOrderApprovalHoursUser() : string {
        return this.get(this.workOrderApprovalHoursUserLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.HoursTable.Name" (Hours)
    */
    public get workOrderApprovalHoursTableName() : string {
        return this.get(this.workOrderApprovalHoursTableNameLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Mileages.Date" (Day)
    */
    public get workOrderApprovalMileagesDate() : string {
        return this.get(this.workOrderApprovalMileagesDateLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Mileages.TotalMileages" (Total distance, km)
    */
    public get workOrderApprovalMileagesTotalMileages() : string {
        return this.get(this.workOrderApprovalMileagesTotalMileagesLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.Mileages.VehicleAmount" (Vehicles)
    */
    public get workOrderApprovalMileagesVehicleAmount() : string {
        return this.get(this.workOrderApprovalMileagesVehicleAmountLanguageItemName);
    }

    /**
    /* "WorkOrderApproval.MileagesTable.Name" (Mileages)
    */
    public get workOrderApprovalMileagesTableName() : string {
        return this.get(this.workOrderApprovalMileagesTableNameLanguageItemName);
    }

    /**
    /* "WorkDayPanel.SiteOrWarehouseColumn.Title" ("Manager: {0}\nAddress: {1}  ")
    */
    public get workDayPanelSiteOrWarehouseColumnTitle() : string {
        return this.get(this.workDayPanelSiteOrWarehouseColumnTitleLanguageItemName);
    }

    /**
    /* "WorkDayPanel.NoReportedHours" (No reported hours)
    */
    public get workDayPanelNoReportedHours() : string {
        return this.get(this.workDayPanelNoReportedHoursLanguageItemName);
    }

    /**
    /* "Widget.SalaryPeriod.Description" (Salary days left)
    */
    public get widgetSalaryPeriodDescription() : string {
        return this.get(this.widgetSalaryPeriodDescriptionLanguageItemName);
    }

    /**
    /* "Widget.SalaryPeriod.Label" (Salary period)
    */
    public get widgetSalaryPeriodLabel() : string {
        return this.get(this.widgetSalaryPeriodLabelLanguageItemName);
    }

    /**
    /* "UserManagement.Subcontractor.Label" (Subcontractor)
    */
    public get userManagementSubcontractorLabel() : string {
        return this.get(this.userManagementSubcontractorLabelLanguageItemName);
    }

    /**
    /* "UserManagement.OrganizationContracts.Label" (Organization Contracts)
    */
    public get userManagementOrganizationContractsLabel() : string {
        return this.get(this.userManagementOrganizationContractsLabelLanguageItemName);
    }

    /**
    /* "UserManagement.AlertError.WorkCardIdExists" (Work card id "{0}" is already registered for another user account.)
    */
    public get userManagementAlertErrorWorkCardIdExists() : string {
        return this.get(this.userManagementAlertErrorWorkCardIdExistsLanguageItemName);
    }

    /**
    /* "TaskTooltips.TaskDeclined" (Work order is declined by customer)
    */
    public get taskTooltipsTaskDeclined() : string {
        return this.get(this.taskTooltipsTaskDeclinedLanguageItemName);
    }

    /**
    /* "TaskTooltips.NewTask" (New work order)
    */
    public get taskTooltipsNewTask() : string {
        return this.get(this.taskTooltipsNewTaskLanguageItemName);
    }

    /**
    /* "TasksPanel.Price" (Price)
    */
    public get tasksPanelPrice() : string {
        return this.get(this.tasksPanelPriceLanguageItemName);
    }

    /**
    /* "TasksPanel.Name" (Name)
    */
    public get tasksPanelName() : string {
        return this.get(this.tasksPanelNameLanguageItemName);
    }

    /**
    /* "TasksPanel.Flyout.ChangesSaved" (Changes were successfully saved)
    */
    public get tasksPanelFlyoutChangesSaved() : string {
        return this.get(this.tasksPanelFlyoutChangesSavedLanguageItemName);
    }

    /**
    /* "TasksPanel.DeleteTask" (Delete task)
    */
    public get tasksPanelDeleteTask() : string {
        return this.get(this.tasksPanelDeleteTaskLanguageItemName);
    }

    /**
    /* "TasksPanel.DeleteHours" (Delete hours)
    */
    public get tasksPanelDeleteHours() : string {
        return this.get(this.tasksPanelDeleteHoursLanguageItemName);
    }

    /**
    /* "TasksPanel.CommitChanges" (Save changes)
    */
    public get tasksPanelCommitChanges() : string {
        return this.get(this.tasksPanelCommitChangesLanguageItemName);
    }

    /**
    /* "TasksPanel.CancelChanges" (Cancel changes)
    */
    public get tasksPanelCancelChanges() : string {
        return this.get(this.tasksPanelCancelChangesLanguageItemName);
    }

    /**
    /* "TasksPanel.AddWorkReport.Flyout" (Work report was created successfully)
    */
    public get tasksPanelAddWorkReportFlyout() : string {
        return this.get(this.tasksPanelAddWorkReportFlyoutLanguageItemName);
    }

    /**
    /* "TasksPanel.AddHoursModal.NoHours" (No hours)
    */
    public get tasksPanelAddHoursModalNoHours() : string {
        return this.get(this.tasksPanelAddHoursModalNoHoursLanguageItemName);
    }

    /**
    /* "TasksPanel.AddHoursModal.Confirmation" (Are you sure that you want to delete mounter's working hours?)
    */
    public get tasksPanelAddHoursModalConfirmation() : string {
        return this.get(this.tasksPanelAddHoursModalConfirmationLanguageItemName);
    }

    /**
    /* "TasksPanel.AddHoursModal.AddHours" (Add mounter hours)
    */
    public get tasksPanelAddHoursModalAddHours() : string {
        return this.get(this.tasksPanelAddHoursModalAddHoursLanguageItemName);
    }

    /**
    /* "TasksPanel.AddHours.Flyout" (Mounter hours has been added successfully)
    */
    public get tasksPanelAddHoursFlyout() : string {
        return this.get(this.tasksPanelAddHoursFlyoutLanguageItemName);
    }

    /**
    /* "TasksPanel.AddExtraTask.Flyout" (Extra task was created successfully)
    */
    public get tasksPanelAddExtraTaskFlyout() : string {
        return this.get(this.tasksPanelAddExtraTaskFlyoutLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.RestoreDeletedHours" (Restore deleted hours)
    */
    public get taskHoursPanelRestoreDeletedHours() : string {
        return this.get(this.taskHoursPanelRestoreDeletedHoursLanguageItemName);
    }

    /**
    /* "TasksPage.ManagerCostPools" (Manager Cost pool)
    */
    public get tasksPageManagerCostPools() : string {
        return this.get(this.tasksPageManagerCostPoolsLanguageItemName);
    }

    /**
    /* "TasksPage.NotAssigned" (Show unassigned)
    */
    public get tasksPageNotAssigned() : string {
        return this.get(this.tasksPageNotAssignedLanguageItemName);
    }

    /**
    /* "TasksPage.TaskStatus" (Task status)
    */
    public get tasksPageTaskStatus() : string {
        return this.get(this.tasksPageTaskStatusLanguageItemName);
    }

    /**
    /* "TasksPage.TaskStatus.Any" (All)
    */
    public get tasksPageTaskStatusAny() : string {
        return this.get(this.tasksPageTaskStatusAnyLanguageItemName);
    }

    /**
    /* "TasksPage.TaskStatus.Any.Subtext" (All tasks)
    */
    public get tasksPageTaskStatusAnySubtext() : string {
        return this.get(this.tasksPageTaskStatusAnySubtextLanguageItemName);
    }

    /**
    /* "TasksPage.TaskStatus.Further" (Further)
    */
    public get tasksPageTaskStatusFurther() : string {
        return this.get(this.tasksPageTaskStatusFurtherLanguageItemName);
    }

    /**
    /* "TasksPage.TaskStatus.Further.Subtext" (Further tasks)
    */
    public get tasksPageTaskStatusFurtherSubtext() : string {
        return this.get(this.tasksPageTaskStatusFurtherSubtextLanguageItemName);
    }

    /**
    /* "TasksPage.TaskStatus.Ongoing" (Ongoing)
    */
    public get tasksPageTaskStatusOngoing() : string {
        return this.get(this.tasksPageTaskStatusOngoingLanguageItemName);
    }

    /**
    /* "TasksPage.TaskStatus.Ongoing.Subtext" (Ongoing tasks)
    */
    public get tasksPageTaskStatusOngoingSubtext() : string {
        return this.get(this.tasksPageTaskStatusOngoingSubtextLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.DeleteHours" (Delete hours)
    */
    public get taskHoursPanelDeleteHours() : string {
        return this.get(this.taskHoursPanelDeleteHoursLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.Date" (Date)
    */
    public get taskHoursPanelDate() : string {
        return this.get(this.taskHoursPanelDateLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.CommitChanges" (Commit changes)
    */
    public get taskHoursPanelCommitChanges() : string {
        return this.get(this.taskHoursPanelCommitChangesLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.CancelChanges" (Cancel changes)
    */
    public get taskHoursPanelCancelChanges() : string {
        return this.get(this.taskHoursPanelCancelChangesLanguageItemName);
    }

    /**
    /* "TaskHoursPanel.ApproveHours" (Approve hours)
    */
    public get taskHoursPanelApproveHours() : string {
        return this.get(this.taskHoursPanelApproveHoursLanguageItemName);
    }

    /**
    /* "SummaryWidget.Labels.Distance" (Distance: <mark>{0} km</mark>)
    */
    public get summaryWidgetLabelsDistance() : string {
        return this.get(this.summaryWidgetLabelsDistanceLanguageItemName);
    }

    /**
    /* "SummaryWidget.Labels.Hours" (Working hours: <mark>{0:0.0} h ({1:0.0}/{2:0.0}/{3:0.0})</mark>)
    */
    public get summaryWidgetLabelsHours() : string {
        return this.get(this.summaryWidgetLabelsHoursLanguageItemName);
    }

    /**
    /* "Summary.Manual" (This is the work report summary. Review the summary carefully before approval.)
    */
    public get summaryManual() : string {
        return this.get(this.summaryManualLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.SignIn.FailedAlert" (Cannot sign-in to the work order. The work order status has been changed.)
    */
    public get rentaTasksWorkOrderSignInFailedAlert() : string {
        return this.get(this.rentaTasksWorkOrderSignInFailedAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.SignOut.FailedAlert" (The work order cannot be modified. The work order status has been changed. You have been automatically signed-out.)
    */
    public get rentaTasksWorkOrderSignOutFailedAlert() : string {
        return this.get(this.rentaTasksWorkOrderSignOutFailedAlertLanguageItemName);
    }

    /**
    /* "RentaTasksController.Alerts.Approved" (Work order "{0}" approved successfully.)
    */
    public get rentaTasksControllerAlertsApproved() : string {
        return this.get(this.rentaTasksControllerAlertsApprovedLanguageItemName);
    }

    /**
    /* "RentaTasksController.Alerts.Created" (Work order "{0}" created successfully.)
    */
    public get rentaTasksControllerAlertsCreated() : string {
        return this.get(this.rentaTasksControllerAlertsCreatedLanguageItemName);
    }

    /**
    /* "RentaTasksController.Steps.TitleSummary" (Summary)
    */
    public get rentaTasksControllerStepsTitleSummary() : string {
        return this.get(this.rentaTasksControllerStepsTitleSummaryLanguageItemName);
    }

    /**
    /* "RentaTasksController.Steps.TitleManagers" (Managers)
    */
    public get rentaTasksControllerStepsTitleManagers() : string {
        return this.get(this.rentaTasksControllerStepsTitleManagersLanguageItemName);
    }

    /**
    /* "RentaTasksController.Steps.TitleHoursAndDistance" (Hours & distances)
    */
    public get rentaTasksControllerStepsTitleHoursAndDistance() : string {
        return this.get(this.rentaTasksControllerStepsTitleHoursAndDistanceLanguageItemName);
    }

    /**
    /* "RentaTasksController.Steps.TitleEdit" (Edit task)
    */
    public get rentaTasksControllerStepsTitleEdit() : string {
        return this.get(this.rentaTasksControllerStepsTitleEditLanguageItemName);
    }

    /**
    /* "RentaTasksController.Steps.TitleApproving" (Approving)
    */
    public get rentaTasksControllerStepsTitleApproving() : string {
        return this.get(this.rentaTasksControllerStepsTitleApprovingLanguageItemName);
    }

    /**
    /* "RentaTasksController.Steps.ActivateConstructionSite.TitleSummary" (Summary)
    */
    public get rentaTasksControllerStepsActivateConstructionSiteTitleSummary() : string {
        return this.get(this.rentaTasksControllerStepsActivateConstructionSiteTitleSummaryLanguageItemName);
    }

    /**
    /* "RentaTasksController.Steps.ActivateConstructionSite.TitleSelectCustomer" (Select customer)
    */
    public get rentaTasksControllerStepsActivateConstructionSiteTitleSelectCustomer() : string {
        return this.get(this.rentaTasksControllerStepsActivateConstructionSiteTitleSelectCustomerLanguageItemName);
    }

    /**
    /* "RentaTasksController.Steps.ActivateConstructionSite.TitleSelectConstructionSite" (Select construction site)
    */
    public get rentaTasksControllerStepsActivateConstructionSiteTitleSelectConstructionSite() : string {
        return this.get(this.rentaTasksControllerStepsActivateConstructionSiteTitleSelectConstructionSiteLanguageItemName);
    }

    /**
    /* "RentaTasksController.Steps.ActivateConstructionSite.TitleConfirmAddress" (Confirm address)
    */
    public get rentaTasksControllerStepsActivateConstructionSiteTitleConfirmAddress() : string {
        return this.get(this.rentaTasksControllerStepsActivateConstructionSiteTitleConfirmAddressLanguageItemName);
    }

    /**
    /* "RentaTasksController.NewWorkOrderName" (New work order)
    */
    public get rentaTasksControllerNewWorkOrderName() : string {
        return this.get(this.rentaTasksControllerNewWorkOrderNameLanguageItemName);
    }

    /**
    /* "RentaTasksController.Alerts.SignOutFromSite" (You have been sign-out from the construction site.)
    */
    public get rentaTasksControllerAlertsSignOutFromSite() : string {
        return this.get(this.rentaTasksControllerAlertsSignOutFromSiteLanguageItemName);
    }

    /**
    /* "RentaTasksController.Alerts.SentToCustomer" (Work report "{0}" has been sent to a customer.)
    */
    public get rentaTasksControllerAlertsSentToCustomer() : string {
        return this.get(this.rentaTasksControllerAlertsSentToCustomerLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Button.Label.EditHoursAndDistances" (Add hours and distances)
    */
    public get rentaTasksWorkOrderButtonLabelEditHoursAndDistances() : string {
        return this.get(this.rentaTasksWorkOrderButtonLabelEditHoursAndDistancesLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Complete.FailedAlert" (The work order cannot be completed. The work order status has been changed.)
    */
    public get rentaTasksWorkOrderCompleteFailedAlert() : string {
        return this.get(this.rentaTasksWorkOrderCompleteFailedAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Edit.FailedAlert" (The work order cannot be modified. The work order status has been changed.)
    */
    public get rentaTasksWorkOrderEditFailedAlert() : string {
        return this.get(this.rentaTasksWorkOrderEditFailedAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.EditHoursAndDistances.Alert" (The work order hours and distances are updated successfully.)
    */
    public get rentaTasksWorkOrderEditHoursAndDistancesAlert() : string {
        return this.get(this.rentaTasksWorkOrderEditHoursAndDistancesAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.EditHoursAndDistances.FailedAlert" (The work order hours and distances cannot be modified. The work order status has been changed.)
    */
    public get rentaTasksWorkOrderEditHoursAndDistancesFailedAlert() : string {
        return this.get(this.rentaTasksWorkOrderEditHoursAndDistancesFailedAlertLanguageItemName);
    }

    /**
    /* "OrganizationPanel.Intermediator" (Intermediator)
    */
    public get organizationPanelIntermediator() : string {
        return this.get(this.organizationPanelIntermediatorLanguageItemName);
    }

    /**
    /* "OrganizationPanel.Name" (Name)
    */
    public get organizationPanelName() : string {
        return this.get(this.organizationPanelNameLanguageItemName);
    }

    /**
    /* "OrganizationPanel.TransactionIdentifier" (E-invoice address)
    */
    public get organizationPanelTransactionIdentifier() : string {
        return this.get(this.organizationPanelTransactionIdentifierLanguageItemName);
    }

    /**
    /* "OrganizationPanel.VirtualAddress" (Virtual address (Postal box))
    */
    public get organizationPanelVirtualAddress() : string {
        return this.get(this.organizationPanelVirtualAddressLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.AddEquipment.FailedAlert" (The work order equipment cannot be modified. The work order status has been changed.)
    */
    public get rentaTasksWorkOrderAddEquipmentFailedAlert() : string {
        return this.get(this.rentaTasksWorkOrderAddEquipmentFailedAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.ActivateConstructionSite.Alert" (Construction site activated successfully.)
    */
    public get rentaTasksWorkOrderActivateConstructionSiteAlert() : string {
        return this.get(this.rentaTasksWorkOrderActivateConstructionSiteAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.Signature.Alert" (Work report has been sent to a customer)
    */
    public get rentaTasksSignatureAlert() : string {
        return this.get(this.rentaTasksSignatureAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.SelectTask.NotAssigned" (Not assigned)
    */
    public get rentaTasksSelectTaskNotAssigned() : string {
        return this.get(this.rentaTasksSelectTaskNotAssignedLanguageItemName);
    }

    /**
    /* "RentaTasks.SelectTask.MyTasks" (My tasks)
    */
    public get rentaTasksSelectTaskMyTasks() : string {
        return this.get(this.rentaTasksSelectTaskMyTasksLanguageItemName);
    }

    /**
    /* "RentaTasks.SelectSite.NotFound" (Construction site not found or qr code cannot be recognized)
    */
    public get rentaTasksSelectSiteNotFound() : string {
        return this.get(this.rentaTasksSelectSiteNotFoundLanguageItemName);
    }

    /**
    /* "RentaTasks.SelectSite.NoAvailableSites" (No construction sites available for selected company)
    */
    public get rentaTasksSelectSiteNoAvailableSites() : string {
        return this.get(this.rentaTasksSelectSiteNoAvailableSitesLanguageItemName);
    }

    /**
    /* "RentaTasks.SelectOrganization.NoOrganizations" (No organizations available)
    */
    public get rentaTasksSelectOrganizationNoOrganizations() : string {
        return this.get(this.rentaTasksSelectOrganizationNoOrganizationsLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.WorkOrderConcurrencyAlert" (The work order was modified by "{0}" at "{1:D}". Please check the WO details and continue.)
    */
    public get rentaTasksControllerWorkOrderConcurrencyAlert() : string {
        return this.get(this.rentaTasksControllerWorkOrderConcurrencyAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.TaskStatus" (Task status)
    */
    public get rentaTasksControllerStepsTitleTaskStatus() : string {
        return this.get(this.rentaTasksControllerStepsTitleTaskStatusLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.Signature" (Signature)
    */
    public get rentaTasksControllerStepsTitleSignature() : string {
        return this.get(this.rentaTasksControllerStepsTitleSignatureLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.SelectTask" (Select task)
    */
    public get rentaTasksControllerStepsTitleSelectTask() : string {
        return this.get(this.rentaTasksControllerStepsTitleSelectTaskLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.SelectSite" (Select site)
    */
    public get rentaTasksControllerStepsTitleSelectSite() : string {
        return this.get(this.rentaTasksControllerStepsTitleSelectSiteLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.SelectOrganization" (Select client)
    */
    public get rentaTasksControllerStepsTitleSelectOrganization() : string {
        return this.get(this.rentaTasksControllerStepsTitleSelectOrganizationLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.NewTask" (New task)
    */
    public get rentaTasksControllerStepsTitleNewTask() : string {
        return this.get(this.rentaTasksControllerStepsTitleNewTaskLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.Mounters" (Mounters)
    */
    public get rentaTasksControllerStepsTitleMounters() : string {
        return this.get(this.rentaTasksControllerStepsTitleMountersLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.Equipment" (Equipment)
    */
    public get rentaTasksControllerStepsTitleEquipment() : string {
        return this.get(this.rentaTasksControllerStepsTitleEquipmentLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.Distance" (Distance)
    */
    public get rentaTasksControllerStepsTitleDistance() : string {
        return this.get(this.rentaTasksControllerStepsTitleDistanceLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.Approve" (Approve)
    */
    public get rentaTasksControllerStepsTitleApprove() : string {
        return this.get(this.rentaTasksControllerStepsTitleApproveLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.Allowance" (Allowance)
    */
    public get rentaTasksControllerStepsTitleAllowance() : string {
        return this.get(this.rentaTasksControllerStepsTitleAllowanceLanguageItemName);
    }

    /**
    /* "RentaTasks.AssignMounter.DropdownWidget.MountersAssigned" ({0} mounter(s) assigned to the task)
    */
    public get rentaTasksAssignMounterDropdownWidgetMountersAssigned() : string {
        return this.get(this.rentaTasksAssignMounterDropdownWidgetMountersAssignedLanguageItemName);
    }

    /**
    /* "RentaTasks.AssignMounter.DropdownWidget.AssignMounters" (Assign the task to the mounters)
    */
    public get rentaTasksAssignMounterDropdownWidgetAssignMounters() : string {
        return this.get(this.rentaTasksAssignMounterDropdownWidgetAssignMountersLanguageItemName);
    }

    /**
    /* "RentaTasks.Approve.DropdownWidget.TasksToCombine" (Press to select tasks to combine)
    */
    public get rentaTasksApproveDropdownWidgetTasksToCombine() : string {
        return this.get(this.rentaTasksApproveDropdownWidgetTasksToCombineLanguageItemName);
    }

    /**
    /* "RentaTasks.Approve.DropdownWidget.TasksCombined" ({0} tasks combined to the work report)
    */
    public get rentaTasksApproveDropdownWidgetTasksCombined() : string {
        return this.get(this.rentaTasksApproveDropdownWidgetTasksCombinedLanguageItemName);
    }

    /**
    /* "RentaTasks.AddTask.Manual" (Create a new task on the construction site.\nSpecify task name (click on widget to start editing) etc.)
    */
    public get rentaTasksAddTaskManual() : string {
        return this.get(this.rentaTasksAddTaskManualLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.Manual" (Add equipment to the selected task, swipe or press next if you do not have additional equipments to add.)
    */
    public get rentaTasksAddEquipmentManual() : string {
        return this.get(this.rentaTasksAddEquipmentManualLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.DropdownWidget.SpecifyAmount" ({0} position(s), you can specify amount of equipment)
    */
    public get rentaTasksAddEquipmentDropdownWidgetSpecifyAmount() : string {
        return this.get(this.rentaTasksAddEquipmentDropdownWidgetSpecifyAmountLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.DropdownWidget.NoEquipment" (No equipment)
    */
    public get rentaTasksAddEquipmentDropdownWidgetNoEquipment() : string {
        return this.get(this.rentaTasksAddEquipmentDropdownWidgetNoEquipmentLanguageItemName);
    }

    /**
    /* "RentaManagement.SummaryPage.Manual" (Renta Task 1.0.\nSummary wizard step.)
    */
    public get rentaManagementSummaryPageManual() : string {
        return this.get(this.rentaManagementSummaryPageManualLanguageItemName);
    }

    /**
    /* "RentaManagement.SummaryPage.Description" (Click on step for additional info.)
    */
    public get rentaManagementSummaryPageDescription() : string {
        return this.get(this.rentaManagementSummaryPageDescriptionLanguageItemName);
    }

    /**
    /* "RentaManagement.SummaryPage.Button.Title" (Complete)
    */
    public get rentaManagementSummaryPageButtonTitle() : string {
        return this.get(this.rentaManagementSummaryPageButtonTitleLanguageItemName);
    }

    /**
    /* "RentaManagement.SelectSite.NoSiteWithModules" (No active construction sites with active agreement and existing modules.)
    */
    public get rentaManagementSelectSiteNoSiteWithModules() : string {
        return this.get(this.rentaManagementSelectSiteNoSiteWithModulesLanguageItemName);
    }

    /**
    /* "RentaManagement.SelectModule.NoModules" (No site modules available for selected site and agreement.)
    */
    public get rentaManagementSelectModuleNoModules() : string {
        return this.get(this.rentaManagementSelectModuleNoModulesLanguageItemName);
    }

    /**
    /* "RentaManagement.SelectModule.Manual" (Select a site module you are going to work on from dropdown menu by pressing on module widget.)
    */
    public get rentaManagementSelectModuleManual() : string {
        return this.get(this.rentaManagementSelectModuleManualLanguageItemName);
    }

    /**
    /* "RentaManagement.SelectModule.Description" (Press to select module)
    */
    public get rentaManagementSelectModuleDescription() : string {
        return this.get(this.rentaManagementSelectModuleDescriptionLanguageItemName);
    }

    /**
    /* "RentaManagement.SelectAgreement.NoAgreement" (No active agreements with existing modules available for selected site.)
    */
    public get rentaManagementSelectAgreementNoAgreement() : string {
        return this.get(this.rentaManagementSelectAgreementNoAgreementLanguageItemName);
    }

    /**
    /* "RentaManagement.SelectAgreement.Manual" (Select a site agreement you are going to work on from dropdown menu by pressing on Agreement widget)
    */
    public get rentaManagementSelectAgreementManual() : string {
        return this.get(this.rentaManagementSelectAgreementManualLanguageItemName);
    }

    /**
    /* "RentaManagement.SelectAgreement.Description" (Press to select agreement)
    */
    public get rentaManagementSelectAgreementDescription() : string {
        return this.get(this.rentaManagementSelectAgreementDescriptionLanguageItemName);
    }

    /**
    /* "RentaManagement.SaveAudit.Sent" (Audit report has been sent to customer.)
    */
    public get rentaManagementSaveAuditSent() : string {
        return this.get(this.rentaManagementSaveAuditSentLanguageItemName);
    }

    /**
    /* "RentaManagement.SaveAudit.Manual" (Audit module.\nPress "Activate" button.\nIt will create and activate audit for corresponding task.\nTask marked as splitted cannot be audited.)
    */
    public get rentaManagementSaveAuditManual() : string {
        return this.get(this.rentaManagementSaveAuditManualLanguageItemName);
    }

    /**
    /* "RentaManagement.Dashboard.Manual" (Welcome to Renta Management dashboard.\n\nPress "Activate module" to activate a scaffolding module on a construction site.\n\nPress "Audit module" to inspect a scaffolding module on a construction site.\n\nPress "Add task" to create new extra task for a construction site.\n    )
    */
    public get rentaManagementDashboardManual() : string {
        return this.get(this.rentaManagementDashboardManualLanguageItemName);
    }

    /**
    /* "RentaManagement.Dashboard.Audit.Description" (Audit construction site module)
    */
    public get rentaManagementDashboardAuditDescription() : string {
        return this.get(this.rentaManagementDashboardAuditDescriptionLanguageItemName);
    }

    /**
    /* "RentaManagement.Dashboard.Audit" (Audit module)
    */
    public get rentaManagementDashboardAudit() : string {
        return this.get(this.rentaManagementDashboardAuditLanguageItemName);
    }

    /**
    /* "RentaManagement.Dashboard.AddTask.Description" (Create new task)
    */
    public get rentaManagementDashboardAddTaskDescription() : string {
        return this.get(this.rentaManagementDashboardAddTaskDescriptionLanguageItemName);
    }

    /**
    /* "RentaManagement.Dashboard.AddTask" (Add task)
    */
    public get rentaManagementDashboardAddTask() : string {
        return this.get(this.rentaManagementDashboardAddTaskLanguageItemName);
    }

    /**
    /* "RentaManagement.Dashboard.Activate.Description" (Activate construction site contract tasks)
    */
    public get rentaManagementDashboardActivateDescription() : string {
        return this.get(this.rentaManagementDashboardActivateDescriptionLanguageItemName);
    }

    /**
    /* "RentaManagement.Dashboard.Activate" (Activate module)
    */
    public get rentaManagementDashboardActivate() : string {
        return this.get(this.rentaManagementDashboardActivateLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Steps.Title.Summary" (Summary)
    */
    public get rentaManagementControllerStepsTitleSummary() : string {
        return this.get(this.rentaManagementControllerStepsTitleSummaryLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Steps.Title.SelectSite" (Select site)
    */
    public get rentaManagementControllerStepsTitleSelectSite() : string {
        return this.get(this.rentaManagementControllerStepsTitleSelectSiteLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Steps.Title.SelectModule" (Select module)
    */
    public get rentaManagementControllerStepsTitleSelectModule() : string {
        return this.get(this.rentaManagementControllerStepsTitleSelectModuleLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Steps.Title.SelectAgreement" (Select agreement)
    */
    public get rentaManagementControllerStepsTitleSelectAgreement() : string {
        return this.get(this.rentaManagementControllerStepsTitleSelectAgreementLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Steps.Title.SaveAudit" (Save audit)
    */
    public get rentaManagementControllerStepsTitleSaveAudit() : string {
        return this.get(this.rentaManagementControllerStepsTitleSaveAuditLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Steps.Title.Params" (Params)
    */
    public get rentaManagementControllerStepsTitleParams() : string {
        return this.get(this.rentaManagementControllerStepsTitleParamsLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Steps.Title.Guide" (Guide)
    */
    public get rentaManagementControllerStepsTitleGuide() : string {
        return this.get(this.rentaManagementControllerStepsTitleGuideLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Steps.Title.Date" (Date)
    */
    public get rentaManagementControllerStepsTitleDate() : string {
        return this.get(this.rentaManagementControllerStepsTitleDateLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Steps.Title.Check" (Check)
    */
    public get rentaManagementControllerStepsTitleCheck() : string {
        return this.get(this.rentaManagementControllerStepsTitleCheckLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Steps.Title.Audit" (Audit)
    */
    public get rentaManagementControllerStepsTitleAudit() : string {
        return this.get(this.rentaManagementControllerStepsTitleAuditLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Question.Uprights" (Uprights)
    */
    public get rentaManagementControllerQuestionUprights() : string {
        return this.get(this.rentaManagementControllerQuestionUprightsLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Question.SideEndBindings" (Side and end binding)
    */
    public get rentaManagementControllerQuestionSideEndBindings() : string {
        return this.get(this.rentaManagementControllerQuestionSideEndBindingsLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Question.SafetyBarriers" (Safety barriers)
    */
    public get rentaManagementControllerQuestionSafetyBarriers() : string {
        return this.get(this.rentaManagementControllerQuestionSafetyBarriersLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Question.Foundation" (Foundation)
    */
    public get rentaManagementControllerQuestionFoundation() : string {
        return this.get(this.rentaManagementControllerQuestionFoundationLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Question.Covers" (Scaffolding covers)
    */
    public get rentaManagementControllerQuestionCovers() : string {
        return this.get(this.rentaManagementControllerQuestionCoversLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Question.CounterTops" (Counter tops)
    */
    public get rentaManagementControllerQuestionCounterTops() : string {
        return this.get(this.rentaManagementControllerQuestionCounterTopsLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Question.BindingsAndSupporters" (Horizontal bindings and supporters)
    */
    public get rentaManagementControllerQuestionBindingsAndSupporters() : string {
        return this.get(this.rentaManagementControllerQuestionBindingsAndSupportersLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Question.AuditCard" (Scaffolding audit card)
    */
    public get rentaManagementControllerQuestionAuditCard() : string {
        return this.get(this.rentaManagementControllerQuestionAuditCardLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Question.AscentWays" (Ascent ways)
    */
    public get rentaManagementControllerQuestionAscentWays() : string {
        return this.get(this.rentaManagementControllerQuestionAscentWaysLanguageItemName);
    }

    /**
    /* "RentaManagement.Controller.Question.Anchorage" (Anchorage)
    */
    public get rentaManagementControllerQuestionAnchorage() : string {
        return this.get(this.rentaManagementControllerQuestionAnchorageLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditParams4.Spacing" (Level spacing, m)
    */
    public get rentaManagementAuditParams4Spacing() : string {
        return this.get(this.rentaManagementAuditParams4SpacingLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditParams4.Highest" (Highest level, m)
    */
    public get rentaManagementAuditParams4Highest() : string {
        return this.get(this.rentaManagementAuditParams4HighestLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditParams3.Windload" (Wind load max, kN [0..1])
    */
    public get rentaManagementAuditParams3Windload() : string {
        return this.get(this.rentaManagementAuditParams3WindloadLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditParams3.WeatherShelter" (Weather shelter, m²)
    */
    public get rentaManagementAuditParams3WeatherShelter() : string {
        return this.get(this.rentaManagementAuditParams3WeatherShelterLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditParams3.Snowload" (Snow load max, kN [0..1])
    */
    public get rentaManagementAuditParams3Snowload() : string {
        return this.get(this.rentaManagementAuditParams3SnowloadLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditParams2.Types" (Scaffolding type(s))
    */
    public get rentaManagementAuditParams2Types() : string {
        return this.get(this.rentaManagementAuditParams2TypesLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditParams2.LoadClass" (Scaffolding load class)
    */
    public get rentaManagementAuditParams2LoadClass() : string {
        return this.get(this.rentaManagementAuditParams2LoadClassLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditParams2.Guides" (Scaffolding guide(s))
    */
    public get rentaManagementAuditParams2Guides() : string {
        return this.get(this.rentaManagementAuditParams2GuidesLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditParams2.Custom" (Custom guide)
    */
    public get rentaManagementAuditParams2Custom() : string {
        return this.get(this.rentaManagementAuditParams2CustomLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditParams1.HandoverDate" (Handover date)
    */
    public get rentaManagementAuditParams1HandoverDate() : string {
        return this.get(this.rentaManagementAuditParams1HandoverDateLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditParams1.Auditor" (Auditor (plannings))
    */
    public get rentaManagementAuditParams1Auditor() : string {
        return this.get(this.rentaManagementAuditParams1AuditorLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditParams1.AuditDate" (Audit date)
    */
    public get rentaManagementAuditParams1AuditDate() : string {
        return this.get(this.rentaManagementAuditParams1AuditDateLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditModule.Heading.Type" (Module type:)
    */
    public get rentaManagementAuditModuleHeadingType() : string {
        return this.get(this.rentaManagementAuditModuleHeadingTypeLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditModule.Heading.Name" (Module name:)
    */
    public get rentaManagementAuditModuleHeadingName() : string {
        return this.get(this.rentaManagementAuditModuleHeadingNameLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditModule.Heading.Id" (Module id:)
    */
    public get rentaManagementAuditModuleHeadingId() : string {
        return this.get(this.rentaManagementAuditModuleHeadingIdLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditModule.Heading.AuditSent" (Audit sent:)
    */
    public get rentaManagementAuditModuleHeadingAuditSent() : string {
        return this.get(this.rentaManagementAuditModuleHeadingAuditSentLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditModule.Heading.AuditResult" (Audit result:)
    */
    public get rentaManagementAuditModuleHeadingAuditResult() : string {
        return this.get(this.rentaManagementAuditModuleHeadingAuditResultLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditModule.Heading.AuditDate" (Audit date:)
    */
    public get rentaManagementAuditModuleHeadingAuditDate() : string {
        return this.get(this.rentaManagementAuditModuleHeadingAuditDateLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditModule.Heading.AuditApproving" (Audit approving:)
    */
    public get rentaManagementAuditModuleHeadingAuditApproving() : string {
        return this.get(this.rentaManagementAuditModuleHeadingAuditApprovingLanguageItemName);
    }

    /**
    /* "RentaManagement.AuditModule.Heading.Assembly" (Assembly task:)
    */
    public get rentaManagementAuditModuleHeadingAssembly() : string {
        return this.get(this.rentaManagementAuditModuleHeadingAssemblyLanguageItemName);
    }

    /**
    /* "WorkOrder.Button.Title.ApproverDetails" (Approver details)
    */
    public get workOrderButtonTitleApproverDetails() : string {
        return this.get(this.workOrderButtonTitleApproverDetailsLanguageItemName);
    }

    /**
    /* "WorkOrder.Button.Title.AssignApprover" (Assign approver)
    */
    public get workOrderButtonTitleAssignApprover() : string {
        return this.get(this.workOrderButtonTitleAssignApproverLanguageItemName);
    }

    /**
    /* "WorkOrder.Button.Title.AssignOrderer" (Assign orderer)
    */
    public get workOrderButtonTitleAssignOrderer() : string {
        return this.get(this.workOrderButtonTitleAssignOrdererLanguageItemName);
    }

    /**
    /* "WorkOrder.Button.Title.OrdererDetails" (Orderer details)
    */
    public get workOrderButtonTitleOrdererDetails() : string {
        return this.get(this.workOrderButtonTitleOrdererDetailsLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.MissingName" ( missing required name)
    */
    public get formDefinitionPageMissingName() : string {
        return this.get(this.formDefinitionPageMissingNameLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.MinMaxIncorrect" (min/max values specified incorrectly)
    */
    public get formDefinitionPageMinMaxIncorrect() : string {
        return this.get(this.formDefinitionPageMinMaxIncorrectLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Checks" (Checks)
    */
    public get formDefinitionPageChecks() : string {
        return this.get(this.formDefinitionPageChecksLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Restored" (Form definition has been restored)
    */
    public get formDefinitionPageRestored() : string {
        return this.get(this.formDefinitionPageRestoredLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.DeletedPermanently" (Form definition was permanently deleted)
    */
    public get formDefinitionPageDeletedPermanently() : string {
        return this.get(this.formDefinitionPageDeletedPermanentlyLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.MarkedAsDeleted" (Form definition is marked as deleted)
    */
    public get formDefinitionPageMarkedAsDeleted() : string {
        return this.get(this.formDefinitionPageMarkedAsDeletedLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.ValidationErrors" (Form definition was not saved, because it contains validation errors.)
    */
    public get formDefinitionPageValidationErrors() : string {
        return this.get(this.formDefinitionPageValidationErrorsLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Errors" (\nErrors were detected in next steps or fields:\n{0}.)
    */
    public get formDefinitionPageErrors() : string {
        return this.get(this.formDefinitionPageErrorsLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Saved" (Form definition has been saved successfully.)
    */
    public get formDefinitionPageSaved() : string {
        return this.get(this.formDefinitionPageSavedLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Icon" (Icon)
    */
    public get formDefinitionPageIcon() : string {
        return this.get(this.formDefinitionPageIconLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Group" (Group)
    */
    public get formDefinitionPageGroup() : string {
        return this.get(this.formDefinitionPageGroupLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Name" (Name)
    */
    public get formDefinitionPageName() : string {
        return this.get(this.formDefinitionPageNameLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.FormTitle" (Title)
    */
    public get formDefinitionPageFormTitle() : string {
        return this.get(this.formDefinitionPageFormTitleLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Type" (Type)
    */
    public get formDefinitionPageType() : string {
        return this.get(this.formDefinitionPageTypeLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Manual" (Manual)
    */
    public get formDefinitionPageManual() : string {
        return this.get(this.formDefinitionPageManualLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.AddNewCheck" (Add new check)
    */
    public get formDefinitionPageAddNewCheck() : string {
        return this.get(this.formDefinitionPageAddNewCheckLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Title" (Edit form definition)
    */
    public get formDefinitionPageTitle() : string {
        return this.get(this.formDefinitionPageTitleLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.FormName" (Form name)
    */
    public get formDefinitionPageFormName() : string {
        return this.get(this.formDefinitionPageFormNameLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.CustomType" (Custom type)
    */
    public get formDefinitionPageCustomType() : string {
        return this.get(this.formDefinitionPageCustomTypeLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.ReportingHeaders" (Reporting headers (mapping))
    */
    public get formDefinitionPageReportingHeaders() : string {
        return this.get(this.formDefinitionPageReportingHeadersLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.WorkOrders" (Work orders (mapping))
    */
    public get formDefinitionPageWorkOrders() : string {
        return this.get(this.formDefinitionPageWorkOrdersLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Timeslot" (Timeslot (mapping))
    */
    public get formDefinitionPageTimeslot() : string {
        return this.get(this.formDefinitionPageTimeslotLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Require" (Required (mapping))
    */
    public get formDefinitionPageRequire() : string {
        return this.get(this.formDefinitionPageRequireLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Multiple" (Multiple (mapping))
    */
    public get formDefinitionPageMultiple() : string {
        return this.get(this.formDefinitionPageMultipleLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Approvable" (Approvable (mapping))
    */
    public get formDefinitionPageApprovable() : string {
        return this.get(this.formDefinitionPageApprovableLanguageItemName);
    }

    /**
    /* "Generic.Save" (Save)
    */
    public get genericSave() : string {
        return this.get(this.genericSaveLanguageItemName);
    }

    /**
    /* "Generic.Restore" (Restore)
    */
    public get genericRestore() : string {
        return this.get(this.genericRestoreLanguageItemName);
    }

    /**
    /* "Generic.Delete" (Delete)
    */
    public get genericDelete() : string {
        return this.get(this.genericDeleteLanguageItemName);
    }

    /**
    /* "Generic.Back" (Back)
    */
    public get genericBack() : string {
        return this.get(this.genericBackLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Delete.Confirmation" (Are you sure you want to delete the form?)
    */
    public get formDefinitionPageDeleteConfirmation() : string {
        return this.get(this.formDefinitionPageDeleteConfirmationLanguageItemName);
    }

    /**
    /* "Enum.CustomFormType.Audit" (Audit)
    */
    public get enumCustomFormTypeAudit() : string {
        return this.get(this.enumCustomFormTypeAuditLanguageItemName);
    }

    /**
    /* "Enum.CustomFormType.Undefined" (Undefined)
    */
    public get enumCustomFormTypeUndefined() : string {
        return this.get(this.enumCustomFormTypeUndefinedLanguageItemName);
    }

    /**
    /* "Enum.FormHeaderType.ConstructionSiteAddress" (Project address)
    */
    public get enumFormHeaderTypeConstructionSiteAddress() : string {
        return this.get(this.enumFormHeaderTypeConstructionSiteAddressLanguageItemName);
    }

    /**
    /* "Enum.FormHeaderType.ConstructionSiteName" (Project name)
    */
    public get enumFormHeaderTypeConstructionSiteName() : string {
        return this.get(this.enumFormHeaderTypeConstructionSiteNameLanguageItemName);
    }

    /**
    /* "Enum.FormHeaderType.WorkOrderManagerName" (Work order manager name)
    */
    public get enumFormHeaderTypeWorkOrderManagerName() : string {
        return this.get(this.enumFormHeaderTypeWorkOrderManagerNameLanguageItemName);
    }

    /**
    /* "Enum.FormHeaderType.CustomerName" (Customer name)
    */
    public get enumFormHeaderTypeCustomerName() : string {
        return this.get(this.enumFormHeaderTypeCustomerNameLanguageItemName);
    }

    /**
    /* "Enum.FormHeaderType.WorkOrderManagerEmail" (Work order manager email)
    */
    public get enumFormHeaderTypeWorkOrderManagerEmail() : string {
        return this.get(this.enumFormHeaderTypeWorkOrderManagerEmailLanguageItemName);
    }

    /**
    /* "Enum.FormHeaderType.CustomerNumber" (Customer number)
    */
    public get enumFormHeaderTypeCustomerNumber() : string {
        return this.get(this.enumFormHeaderTypeCustomerNumberLanguageItemName);
    }

    /**
    /* "Enum.FormMeasuringOperator.Bigger" (>)
    */
    public get enumFormMeasuringOperatorBigger() : string {
        return this.get(this.enumFormMeasuringOperatorBiggerLanguageItemName);
    }

    /**
    /* "Enum.FormMeasuringOperator.BiggerOrEqual" (≥)
    */
    public get enumFormMeasuringOperatorBiggerOrEqual() : string {
        return this.get(this.enumFormMeasuringOperatorBiggerOrEqualLanguageItemName);
    }

    /**
    /* "Enum.FormMeasuringOperator.Equal" (=)
    */
    public get enumFormMeasuringOperatorEqual() : string {
        return this.get(this.enumFormMeasuringOperatorEqualLanguageItemName);
    }

    /**
    /* "Enum.FormMeasuringOperator.Less" (<)
    */
    public get enumFormMeasuringOperatorLess() : string {
        return this.get(this.enumFormMeasuringOperatorLessLanguageItemName);
    }

    /**
    /* "Enum.FormMeasuringOperator.LessOrEqual" (≤)
    */
    public get enumFormMeasuringOperatorLessOrEqual() : string {
        return this.get(this.enumFormMeasuringOperatorLessOrEqualLanguageItemName);
    }

    /**
    /* "Enum.FormMeasuringOperator.NotEqual" (≠)
    */
    public get enumFormMeasuringOperatorNotEqual() : string {
        return this.get(this.enumFormMeasuringOperatorNotEqualLanguageItemName);
    }

    /**
    /* "Enum.FormHeaderType.ConstructionSiteNumber" (Project number)
    */
    public get enumFormHeaderTypeConstructionSiteNumber() : string {
        return this.get(this.enumFormHeaderTypeConstructionSiteNumberLanguageItemName);
    }

    /**
    /* "Enum.FormItemType.Checks" (Checks)
    */
    public get enumFormItemTypeChecks() : string {
        return this.get(this.enumFormItemTypeChecksLanguageItemName);
    }

    /**
    /* "Enum.FormItemType.Pictures" (Pictures)
    */
    public get enumFormItemTypePictures() : string {
        return this.get(this.enumFormItemTypePicturesLanguageItemName);
    }

    /**
    /* "Enum.FormItemType.Question" (Question)
    */
    public get enumFormItemTypeQuestion() : string {
        return this.get(this.enumFormItemTypeQuestionLanguageItemName);
    }

    /**
    /* "Enum.FormItemType.QuestionPictures" (Question Pictures)
    */
    public get enumFormItemTypeQuestionPictures() : string {
        return this.get(this.enumFormItemTypeQuestionPicturesLanguageItemName);
    }

    /**
    /* "Enum.FormTimeslotType.After" (After)
    */
    public get enumFormTimeslotTypeAfter() : string {
        return this.get(this.enumFormTimeslotTypeAfterLanguageItemName);
    }

    /**
    /* "Enum.FormTimeslotType.Anytime" (Anytime)
    */
    public get enumFormTimeslotTypeAnytime() : string {
        return this.get(this.enumFormTimeslotTypeAnytimeLanguageItemName);
    }

    /**
    /* "Enum.FormTimeslotType.Before" (Before)
    */
    public get enumFormTimeslotTypeBefore() : string {
        return this.get(this.enumFormTimeslotTypeBeforeLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.CommentRequired" (Comment is required for the last step)
    */
    public get formDefinitionPageCommentRequired() : string {
        return this.get(this.formDefinitionPageCommentRequiredLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Default" (Default)
    */
    public get formDefinitionPageDefault() : string {
        return this.get(this.formDefinitionPageDefaultLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Min" (Min)
    */
    public get formDefinitionPageMin() : string {
        return this.get(this.formDefinitionPageMinLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Max" (Max)
    */
    public get formDefinitionPageMax() : string {
        return this.get(this.formDefinitionPageMaxLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Unlimited" (Unlimited)
    */
    public get formDefinitionPageUnlimited() : string {
        return this.get(this.formDefinitionPageUnlimitedLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.FormItem.Multiple" (Multiple)
    */
    public get formDefinitionPageFormItemMultiple() : string {
        return this.get(this.formDefinitionPageFormItemMultipleLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.FormItem.Required" (Required)
    */
    public get formDefinitionPageFormItemRequired() : string {
        return this.get(this.formDefinitionPageFormItemRequiredLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Rows" (Rows)
    */
    public get formDefinitionPageRows() : string {
        return this.get(this.formDefinitionPageRowsLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Description" (Description)
    */
    public get formDefinitionPageDescription() : string {
        return this.get(this.formDefinitionPageDescriptionLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.ItemName" (Item name)
    */
    public get formDefinitionPageItemName() : string {
        return this.get(this.formDefinitionPageItemNameLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.MaxLength" (Max length)
    */
    public get formDefinitionPageMaxLength() : string {
        return this.get(this.formDefinitionPageMaxLengthLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.MinLength" (Min length)
    */
    public get formDefinitionPageMinLength() : string {
        return this.get(this.formDefinitionPageMinLengthLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.UniquePerProject" (Unique per project)
    */
    public get formDefinitionPageUniquePerProject() : string {
        return this.get(this.formDefinitionPageUniquePerProjectLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.AddNewOption" (Add new option)
    */
    public get formDefinitionPageAddNewOption() : string {
        return this.get(this.formDefinitionPageAddNewOptionLanguageItemName);
    }

    /**
    /* "FormDefinitionsPage.DefinitionTitle" ({0} ({1} steps))
    */
    public get formDefinitionsPageDefinitionTitle() : string {
        return this.get(this.formDefinitionsPageDefinitionTitleLanguageItemName);
    }

    /**
    /* "FormDefinitionsPage.AddNew" (Add new form definition)
    */
    public get formDefinitionsPageAddNew() : string {
        return this.get(this.formDefinitionsPageAddNewLanguageItemName);
    }

    /**
    /* "FormDefinitionsPage.ShowDeleted" (Show deleted)
    */
    public get formDefinitionsPageShowDeleted() : string {
        return this.get(this.formDefinitionsPageShowDeletedLanguageItemName);
    }

    /**
    /* "FormDefinitionsPage.Subtitle" (List of form definitions)
    */
    public get formDefinitionsPageSubtitle() : string {
        return this.get(this.formDefinitionsPageSubtitleLanguageItemName);
    }

    /**
    /* "FormDefinitionsPage.Title" (Form definitions)
    */
    public get formDefinitionsPageTitle() : string {
        return this.get(this.formDefinitionsPageTitleLanguageItemName);
    }

    /**
    /* "Enum.FormHeaderType.WorkOrderManagerPhone" (Work order manager phone)
    */
    public get enumFormHeaderTypeWorkOrderManagerPhone() : string {
        return this.get(this.enumFormHeaderTypeWorkOrderManagerPhoneLanguageItemName);
    }

    /**
    /* "Enum.FormHeaderType.WorkOrderOrdererPhone" (Work order orderer phone)
    */
    public get enumFormHeaderTypeWorkOrderOrdererPhone() : string {
        return this.get(this.enumFormHeaderTypeWorkOrderOrdererPhoneLanguageItemName);
    }

    /**
    /* "Enum.FormHeaderType.WorkOrderOrdererName" (Work order orderer name)
    */
    public get enumFormHeaderTypeWorkOrderOrdererName() : string {
        return this.get(this.enumFormHeaderTypeWorkOrderOrdererNameLanguageItemName);
    }

    /**
    /* "Enum.FormHeaderType.WorkOrderOrdererEmail" (Work order orderer email)
    */
    public get enumFormHeaderTypeWorkOrderOrdererEmail() : string {
        return this.get(this.enumFormHeaderTypeWorkOrderOrdererEmailLanguageItemName);
    }

    /**
    /* "FormModel.Approved" (Approved)
    */
    public get formModelApproved() : string {
        return this.get(this.formModelApprovedLanguageItemName);
    }

    /**
    /* "FormModel.Sent" (Sent)
    */
    public get formModelSent() : string {
        return this.get(this.formModelSentLanguageItemName);
    }

    /**
    /* "FormModel.Processed" (Processed)
    */
    public get formModelProcessed() : string {
        return this.get(this.formModelProcessedLanguageItemName);
    }

    /**
    /* "FormModel.InProgress" (In progress)
    */
    public get formModelInProgress() : string {
        return this.get(this.formModelInProgressLanguageItemName);
    }

    /**
    /* "FormModel.New" (New)
    */
    public get formModelNew() : string {
        return this.get(this.formModelNewLanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeTypeUnit.Pcs" (Piece)
    */
    public get enumExtraChargeTypeUnitPcs() : string {
        return this.get(this.enumExtraChargeTypeUnitPcsLanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeTypeUnit.M2" (Square meter)
    */
    public get enumExtraChargeTypeUnitM2() : string {
        return this.get(this.enumExtraChargeTypeUnitM2LanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeTypeUnit.M1" (Meter)
    */
    public get enumExtraChargeTypeUnitM1() : string {
        return this.get(this.enumExtraChargeTypeUnitM1LanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeTypeUnit.M3" (Cubic meter)
    */
    public get enumExtraChargeTypeUnitM3() : string {
        return this.get(this.enumExtraChargeTypeUnitM3LanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeTypeUnit.H" (Hour)
    */
    public get enumExtraChargeTypeUnitH() : string {
        return this.get(this.enumExtraChargeTypeUnitHLanguageItemName);
    }

    /**
    /* "Enum.ExtraChargeTypeUnit.Km" (Kilometer)
    */
    public get enumExtraChargeTypeUnitKm() : string {
        return this.get(this.enumExtraChargeTypeUnitKmLanguageItemName);
    }

    /**
    /* "ExtraChargeTypeManagement.PageTitle" (Extra Charge Unit Types)
    */
    public get extraChargeTypeManagementPageTitle() : string {
        return this.get(this.extraChargeTypeManagementPageTitleLanguageItemName);
    }

    /**
    /* "Generic.Comment" (Comment)
    */
    public get genericComment() : string {
        return this.get(this.genericCommentLanguageItemName);
    }

    /**
    /* "Generic.UnsupportedImageType" (Image type is not supported)
    */
    public get genericUnsupportedImageType() : string {
        return this.get(this.genericUnsupportedImageTypeLanguageItemName);
    }

    /**
    /* "FormReceiversPage.ReportSentToCustomer" (Form report has been sent to customer.)
    */
    public get formReceiversPageReportSentToCustomer() : string {
        return this.get(this.formReceiversPageReportSentToCustomerLanguageItemName);
    }

    /**
    /* "RentaTasks.FormSummaryTable.ChooseReceivers" (Choose receivers to send the form report first.)
    */
    public get rentaTasksFormSummaryTableChooseReceivers() : string {
        return this.get(this.rentaTasksFormSummaryTableChooseReceiversLanguageItemName);
    }

    /**
    /* "FormSummaryTable.Dropdown.NothingSelectedText" (Choose receivers)
    */
    public get formSummaryTableDropdownNothingSelectedText() : string {
        return this.get(this.formSummaryTableDropdownNothingSelectedTextLanguageItemName);
    }

    /**
    /* "FormsList.GetManual" (Forms steps)
    */
    public get formsListGetManual() : string {
        return this.get(this.formsListGetManualLanguageItemName);
    }

    /**
    /* "FormsData.Name" (Name)
    */
    public get formsDataName() : string {
        return this.get(this.formsDataNameLanguageItemName);
    }

    /**
    /* "FormsData.Type" (Type)
    */
    public get formsDataType() : string {
        return this.get(this.formsDataTypeLanguageItemName);
    }

    /**
    /* "FormsData.WorkOrder" (Work order)
    */
    public get formsDataWorkOrder() : string {
        return this.get(this.formsDataWorkOrderLanguageItemName);
    }

    /**
    /* "FormsData.ApprovedAt" (Approved at)
    */
    public get formsDataApprovedAt() : string {
        return this.get(this.formsDataApprovedAtLanguageItemName);
    }

    /**
    /* "MyForms.ApproveFormReport" (Approve the form report)
    */
    public get myFormsApproveFormReport() : string {
        return this.get(this.myFormsApproveFormReportLanguageItemName);
    }

    /**
    /* "MyForms.ApproveConfirmation" (Are you sure, you want approve the form report #{0}?)
    */
    public get myFormsApproveConfirmation() : string {
        return this.get(this.myFormsApproveConfirmationLanguageItemName);
    }

    /**
    /* "MyForms.PreviewFormReport" (Preview form report)
    */
    public get myFormsPreviewFormReport() : string {
        return this.get(this.myFormsPreviewFormReportLanguageItemName);
    }

    /**
    /* "MyForms.DownloadFormReport" (Download form report)
    */
    public get myFormsDownloadFormReport() : string {
        return this.get(this.myFormsDownloadFormReportLanguageItemName);
    }

    /**
    /* "DocumentPreviewModal.Form.Title" (The form report preview)
    */
    public get documentPreviewModalFormTitle() : string {
        return this.get(this.documentPreviewModalFormTitleLanguageItemName);
    }

    /**
    /* "MyForms.Title" (My forms)
    */
    public get myFormsTitle() : string {
        return this.get(this.myFormsTitleLanguageItemName);
    }

    /**
    /* "MyForms.NoFormReports" (No form reports received yet)
    */
    public get myFormsNoFormReports() : string {
        return this.get(this.myFormsNoFormReportsLanguageItemName);
    }

    /**
    /* "Forms.Tab.Title" (Forms)
    */
    public get formsTabTitle() : string {
        return this.get(this.formsTabTitleLanguageItemName);
    }

    /**
    /* "FormsData.Reporter" (Reporter)
    */
    public get formsDataReporter() : string {
        return this.get(this.formsDataReporterLanguageItemName);
    }

    /**
    /* "FormsData.StartedAt" (Started at)
    */
    public get formsDataStartedAt() : string {
        return this.get(this.formsDataStartedAtLanguageItemName);
    }

    /**
    /* "FormsData.ProcessInfo" (Process info)
    */
    public get formsDataProcessInfo() : string {
        return this.get(this.formsDataProcessInfoLanguageItemName);
    }

    /**
    /* "FormsData.CompletedAt" (Completed at)
    */
    public get formsDataCompletedAt() : string {
        return this.get(this.formsDataCompletedAtLanguageItemName);
    }

    /**
    /* "Generic.Action.Download" (Download)
    */
    public get genericActionDownload() : string {
        return this.get(this.genericActionDownloadLanguageItemName);
    }

    /**
    /* "FormsData.Passed" (Passed)
    */
    public get formsDataPassed() : string {
        return this.get(this.formsDataPassedLanguageItemName);
    }

    /**
    /* "FormsData.Approval" (Approval)
    */
    public get formsDataApproval() : string {
        return this.get(this.formsDataApprovalLanguageItemName);
    }

    /**
    /* "FormsData.Sent" (Sent)
    */
    public get formsDataSent() : string {
        return this.get(this.formsDataSentLanguageItemName);
    }

    /**
    /* "FormsData.SentTo" (Sent to)
    */
    public get formsDataSentTo() : string {
        return this.get(this.formsDataSentToLanguageItemName);
    }

    /**
    /* "FormsData.SentAt" (Sent at)
    */
    public get formsDataSentAt() : string {
        return this.get(this.formsDataSentAtLanguageItemName);
    }

    /**
    /* "FormsData.Toolbar.Filters.ApprovalType" (Approval type)
    */
    public get formsDataToolbarFiltersApprovalType() : string {
        return this.get(this.formsDataToolbarFiltersApprovalTypeLanguageItemName);
    }

    /**
    /* "FormsData.Toolbar.Filters.From" (From)
    */
    public get formsDataToolbarFiltersFrom() : string {
        return this.get(this.formsDataToolbarFiltersFromLanguageItemName);
    }

    /**
    /* "FormsData.Toolbar.Filters.Reporters" (Reporters)
    */
    public get formsDataToolbarFiltersReporters() : string {
        return this.get(this.formsDataToolbarFiltersReportersLanguageItemName);
    }

    /**
    /* "FormsData.Toolbar.Filters.Status" (Status)
    */
    public get formsDataToolbarFiltersStatus() : string {
        return this.get(this.formsDataToolbarFiltersStatusLanguageItemName);
    }

    /**
    /* "FormsData.Toolbar.Filters.To" (To)
    */
    public get formsDataToolbarFiltersTo() : string {
        return this.get(this.formsDataToolbarFiltersToLanguageItemName);
    }

    /**
    /* "TaskTooltips.TaskBlockedByForm" (Task is blocked by a required form)
    */
    public get taskTooltipsTaskBlockedByForm() : string {
        return this.get(this.taskTooltipsTaskBlockedByFormLanguageItemName);
    }

    /**
    /* "WorkOrderStatus.BlockedByForm" (Blocked by form)
    */
    public get workOrderStatusBlockedByForm() : string {
        return this.get(this.workOrderStatusBlockedByFormLanguageItemName);
    }

    /**
    /* "AdminExtraChargeType.InUseTooltip" (Product is used in work order(s), cannot modify or remove.)
    */
    public get adminExtraChargeTypeInUseTooltip() : string {
        return this.get(this.adminExtraChargeTypeInUseTooltipLanguageItemName);
    }

    /**
    /* "AddExtraChargeModal.Subtitle" (Add extra charge to work order)
    */
    public get addExtraChargeModalSubtitle() : string {
        return this.get(this.addExtraChargeModalSubtitleLanguageItemName);
    }

    /**
    /* "AddExtraChargeModal.Title" (Extra charge)
    */
    public get addExtraChargeModalTitle() : string {
        return this.get(this.addExtraChargeModalTitleLanguageItemName);
    }

    /**
    /* "AddExtraChargeModal.ExtraChargeTypeDropdown.Label" (Type)
    */
    public get addExtraChargeModalExtraChargeTypeDropdownLabel() : string {
        return this.get(this.addExtraChargeModalExtraChargeTypeDropdownLabelLanguageItemName);
    }

    /**
    /* "AddExtraChargeModal.ExtraChargeTypeUnitTextInput.Label" (Unit)
    */
    public get addExtraChargeModalExtraChargeTypeUnitTextInputLabel() : string {
        return this.get(this.addExtraChargeModalExtraChargeTypeUnitTextInputLabelLanguageItemName);
    }

    /**
    /* "AddExtraChargeModal.ExtraChargeAmountNumberInput.Label" (Amount)
    */
    public get addExtraChargeModalExtraChargeAmountNumberInputLabel() : string {
        return this.get(this.addExtraChargeModalExtraChargeAmountNumberInputLabelLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.ExtraChargesTab.Title" (Extra charges)
    */
    public get workOrderDetailsPanelExtraChargesTabTitle() : string {
        return this.get(this.workOrderDetailsPanelExtraChargesTabTitleLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.ExtraChargesToolbarButton.Label" (Add extra charge)
    */
    public get workOrderDetailsPanelExtraChargesToolbarButtonLabel() : string {
        return this.get(this.workOrderDetailsPanelExtraChargesToolbarButtonLabelLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProducts.AddExtraCharge" (Add extra charge)
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsAddExtraCharge() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsAddExtraChargeLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.ExtraCharges.Type" (Type)
    */
    public get workOrderDetailsPanelGridExtraChargesType() : string {
        return this.get(this.workOrderDetailsPanelGridExtraChargesTypeLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.ExtraCharges.Unit" (Unit)
    */
    public get workOrderDetailsPanelGridExtraChargesUnit() : string {
        return this.get(this.workOrderDetailsPanelGridExtraChargesUnitLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.ExtraCharges.Amount" (Amount)
    */
    public get workOrderDetailsPanelGridExtraChargesAmount() : string {
        return this.get(this.workOrderDetailsPanelGridExtraChargesAmountLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.AlertError.FormProcessedByAnotherUser" (Could not start Form, already being processed by another user)
    */
    public get rentaTasksControllerAlertErrorFormProcessedByAnotherUser() : string {
        return this.get(this.rentaTasksControllerAlertErrorFormProcessedByAnotherUserLanguageItemName);
    }

    /**
    /* "FormModal.Confirmation.Unlock" (Are you sure you want to unlock the form?)
    */
    public get formModalConfirmationUnlock() : string {
        return this.get(this.formModalConfirmationUnlockLanguageItemName);
    }

    /**
    /* "FormModal.Confirmation.OnClose" (There are unsaved changed on the form. All unsaved changes will be lost!\nAre you sure?)
    */
    public get formModalConfirmationOnClose() : string {
        return this.get(this.formModalConfirmationOnCloseLanguageItemName);
    }

    /**
    /* "FormModal.Text.ProcessedBy" (Processed by:)
    */
    public get formModalTextProcessedBy() : string {
        return this.get(this.formModalTextProcessedByLanguageItemName);
    }

    /**
    /* "FormModal.Text.InProgressBy" (In progress by:)
    */
    public get formModalTextInProgressBy() : string {
        return this.get(this.formModalTextInProgressByLanguageItemName);
    }

    /**
    /* "FormModal.Text.FormConductionTime" (Form conduction time: {0})
    */
    public get formModalTextFormConductionTime() : string {
        return this.get(this.formModalTextFormConductionTimeLanguageItemName);
    }

    /**
    /* "FormModal.Text.ApprovedBy" (Approved by: {0})
    */
    public get formModalTextApprovedBy() : string {
        return this.get(this.formModalTextApprovedByLanguageItemName);
    }

    /**
    /* "FormModal.Dropdown.ShareTo" (Share to:)
    */
    public get formModalDropdownShareTo() : string {
        return this.get(this.formModalDropdownShareToLanguageItemName);
    }

    /**
    /* "FormModal.Dropdown.Forms" (Forms)
    */
    public get formModalDropdownForms() : string {
        return this.get(this.formModalDropdownFormsLanguageItemName);
    }

    /**
    /* "FormModal.Subtitle" (Status: {0})
    */
    public get formModalSubtitle() : string {
        return this.get(this.formModalSubtitleLanguageItemName);
    }

    /**
    /* "FormsList.ButtonTitle.Fill" (Fill)
    */
    public get formsListButtonTitleFill() : string {
        return this.get(this.formsListButtonTitleFillLanguageItemName);
    }

    /**
    /* "FormsList.ButtonTitle.Continue" (Continue)
    */
    public get formsListButtonTitleContinue() : string {
        return this.get(this.formsListButtonTitleContinueLanguageItemName);
    }

    /**
    /* "FormsList.ButtonTitle.Unlock" (Unlock)
    */
    public get formsListButtonTitleUnlock() : string {
        return this.get(this.formsListButtonTitleUnlockLanguageItemName);
    }

    /**
    /* "WorkOrdersPanel.WorkOrderForms" (Forms)
    */
    public get workOrdersPanelWorkOrderForms() : string {
        return this.get(this.workOrdersPanelWorkOrderFormsLanguageItemName);
    }

    /**
    /* "WorkOrdersPanel.FlyoutMessage.FormSaved" (Form saved)
    */
    public get workOrdersPanelFlyoutMessageFormSaved() : string {
        return this.get(this.workOrdersPanelFlyoutMessageFormSavedLanguageItemName);
    }

    /**
    /* "WorkOrdersPanel.FlyoutWarning.TaskNotMappedToFormDefinition" (Work order "{0}" is not mapped to any form definition.)
    */
    public get workOrdersPanelFlyoutWarningTaskNotMappedToFormDefinition() : string {
        return this.get(this.workOrdersPanelFlyoutWarningTaskNotMappedToFormDefinitionLanguageItemName);
    }

    /**
    /* "RentaTasks.FormWizardPage.FormItemNotFound" (Form item cannot be found for the current step!)
    */
    public get rentaTasksFormWizardPageFormItemNotFound() : string {
        return this.get(this.rentaTasksFormWizardPageFormItemNotFoundLanguageItemName);
    }

    /**
    /* "FormReceiversPage.SendToReceivers" (Send form to receivers)
    */
    public get formReceiversPageSendToReceivers() : string {
        return this.get(this.formReceiversPageSendToReceiversLanguageItemName);
    }

    /**
    /* "FormReceiversPage.NoContactPersonWarning" (Contact person is not specified on agreement level. Audit can not be sent for approval.)
    */
    public get formReceiversPageNoContactPersonWarning() : string {
        return this.get(this.formReceiversPageNoContactPersonWarningLanguageItemName);
    }

    /**
    /* "FormSummaryPage.FormSaved" (Form report has been saved)
    */
    public get formSummaryPageFormSaved() : string {
        return this.get(this.formSummaryPageFormSavedLanguageItemName);
    }

    /**
    /* "FormPreviewPage.Title.CompletedForm" (Completed form)
    */
    public get formPreviewPageTitleCompletedForm() : string {
        return this.get(this.formPreviewPageTitleCompletedFormLanguageItemName);
    }

    /**
    /* "FormPreviewPage.Reporter" (Reporter)
    */
    public get formPreviewPageReporter() : string {
        return this.get(this.formPreviewPageReporterLanguageItemName);
    }

    /**
    /* "FormPreviewPage.GetManual" (Preview form)
    */
    public get formPreviewPageGetManual() : string {
        return this.get(this.formPreviewPageGetManualLanguageItemName);
    }

    /**
    /* "FormPreviewPage.Title" (CLICK THE STEP\nTO OPEN DETAILS)
    */
    public get formPreviewPageTitle() : string {
        return this.get(this.formPreviewPageTitleLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Forms.Button" (Forms)
    */
    public get rentaTasksWorkOrderFormsButton() : string {
        return this.get(this.rentaTasksWorkOrderFormsButtonLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.SendToReceivers" (Send to receivers)
    */
    public get rentaTasksControllerStepsTitleSendToReceivers() : string {
        return this.get(this.rentaTasksControllerStepsTitleSendToReceiversLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.FormSummary" (Form summary)
    */
    public get rentaTasksControllerStepsTitleFormSummary() : string {
        return this.get(this.rentaTasksControllerStepsTitleFormSummaryLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.FormReporting" (Form reporting)
    */
    public get rentaTasksControllerStepsTitleFormReporting() : string {
        return this.get(this.rentaTasksControllerStepsTitleFormReportingLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.FormPage" (Form)
    */
    public get rentaTasksControllerStepsTitleFormPage() : string {
        return this.get(this.rentaTasksControllerStepsTitleFormPageLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.ApproveForm" (Approve form)
    */
    public get rentaTasksControllerStepsTitleApproveForm() : string {
        return this.get(this.rentaTasksControllerStepsTitleApproveFormLanguageItemName);
    }

    /**
    /* "FormsList.ButtonTitle.CompletionDate" (Date)
    */
    public get formsListButtonTitleCompletionDate() : string {
        return this.get(this.formsListButtonTitleCompletionDateLanguageItemName);
    }

    /**
    /* "Generic.Actions" (Actions)
    */
    public get genericActions() : string {
        return this.get(this.genericActionsLanguageItemName);
    }

    /**
    /* "FormsList.ButtonTitle.Locked" (Locked)
    */
    public get formsListButtonTitleLocked() : string {
        return this.get(this.formsListButtonTitleLockedLanguageItemName);
    }

    /**
    /* "WorkOrderForms.AlertError.FormUnlocked" (Form unlocked successfully)
    */
    public get workOrderFormsAlertErrorFormUnlocked() : string {
        return this.get(this.workOrderFormsAlertErrorFormUnlockedLanguageItemName);
    }

    /**
    /* "WorkOrderForms.ActiveFormsTab" (Active forms)
    */
    public get workOrderFormsActiveFormsTab() : string {
        return this.get(this.workOrderFormsActiveFormsTabLanguageItemName);
    }

    /**
    /* "WorkOrderForms.CompletedFormsTab" (Completed forms)
    */
    public get workOrderFormsCompletedFormsTab() : string {
        return this.get(this.workOrderFormsCompletedFormsTabLanguageItemName);
    }

    /**
    /* "Enum.AttachmentType.WorkOrderAttachment" (Work order attachment)
    */
    public get enumAttachmentTypeWorkOrderAttachment() : string {
        return this.get(this.enumAttachmentTypeWorkOrderAttachmentLanguageItemName);
    }

    /**
    /* "Enum.AttachmentType.FormAttachment" (Form attachment)
    */
    public get enumAttachmentTypeFormAttachment() : string {
        return this.get(this.enumAttachmentTypeFormAttachmentLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderFormStatusFilter.Sent" (Sent)
    */
    public get enumWorkOrderFormStatusFilterSent() : string {
        return this.get(this.enumWorkOrderFormStatusFilterSentLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderFormStatusFilter.Processed" (Processed)
    */
    public get enumWorkOrderFormStatusFilterProcessed() : string {
        return this.get(this.enumWorkOrderFormStatusFilterProcessedLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderFormStatusFilter.New" (New)
    */
    public get enumWorkOrderFormStatusFilterNew() : string {
        return this.get(this.enumWorkOrderFormStatusFilterNewLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderFormStatusFilter.InProgress" (In progress)
    */
    public get enumWorkOrderFormStatusFilterInProgress() : string {
        return this.get(this.enumWorkOrderFormStatusFilterInProgressLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderFormStatusFilter.Approved" (Approved)
    */
    public get enumWorkOrderFormStatusFilterApproved() : string {
        return this.get(this.enumWorkOrderFormStatusFilterApprovedLanguageItemName);
    }

    /**
    /* "Widget.MyForms.Label" (My forms)
    */
    public get widgetMyFormsLabel() : string {
        return this.get(this.widgetMyFormsLabelLanguageItemName);
    }

    /**
    /* "Widget.MyForms.Description" (View all form reports)
    */
    public get widgetMyFormsDescription() : string {
        return this.get(this.widgetMyFormsDescriptionLanguageItemName);
    }

    /**
    /* "TopNav.Forms" (Forms)
    */
    public get topNavForms() : string {
        return this.get(this.topNavFormsLanguageItemName);
    }

    /**
    /* "WorkOrders.Filters.Checkbox.HideBlockedByForms" (Hide blocked by forms)
    */
    public get workOrdersFiltersCheckboxHideBlockedByForms() : string {
        return this.get(this.workOrdersFiltersCheckboxHideBlockedByFormsLanguageItemName);
    }

    /**
    /* "Enum.FormItemType.Text" (Text)
    */
    public get enumFormItemTypeText() : string {
        return this.get(this.enumFormItemTypeTextLanguageItemName);
    }

    /**
    /* "Enum.FormItemType.Resource" (Resource)
    */
    public get enumFormItemTypeResource() : string {
        return this.get(this.enumFormItemTypeResourceLanguageItemName);
    }

    /**
    /* "Enum.FormItemType.Options" (Options)
    */
    public get enumFormItemTypeOptions() : string {
        return this.get(this.enumFormItemTypeOptionsLanguageItemName);
    }

    /**
    /* "Generic.Open" (Open)
    */
    public get genericOpen() : string {
        return this.get(this.genericOpenLanguageItemName);
    }

    /**
    /* "FormNavigation.Step" (STEP)
    */
    public get formNavigationStep() : string {
        return this.get(this.formNavigationStepLanguageItemName);
    }

    /**
    /* "Generic.Search" (Search)
    */
    public get genericSearch() : string {
        return this.get(this.genericSearchLanguageItemName);
    }

    /**
    /* "ExtraChargeTypeManagement.ConfirmationMessage.DeletePermanently" (Are you sure you want to delete the extra charge type "{0}"?\nExtra charge type will be removed permanently.)
    */
    public get extraChargeTypeManagementConfirmationMessageDeletePermanently() : string {
        return this.get(this.extraChargeTypeManagementConfirmationMessageDeletePermanentlyLanguageItemName);
    }

    /**
    /* "ExtraChargeTypeManagement.ConfirmationMessage.MarkAsDeleted" (Are you sure you want to mark extra charge type "{0}" as deleted?)
    */
    public get extraChargeTypeManagementConfirmationMessageMarkAsDeleted() : string {
        return this.get(this.extraChargeTypeManagementConfirmationMessageMarkAsDeletedLanguageItemName);
    }

    /**
    /* "ExtraChargeTypeManagement.FlyoutMessage.PermanentlyDeleted" ("{0}" was permanently deleted.)
    */
    public get extraChargeTypeManagementFlyoutMessagePermanentlyDeleted() : string {
        return this.get(this.extraChargeTypeManagementFlyoutMessagePermanentlyDeletedLanguageItemName);
    }

    /**
    /* "ExtraChargeTypeManagement.FlyoutMessage.MarkedAsDeleted" ("{0}" was marked as deleted.)
    */
    public get extraChargeTypeManagementFlyoutMessageMarkedAsDeleted() : string {
        return this.get(this.extraChargeTypeManagementFlyoutMessageMarkedAsDeletedLanguageItemName);
    }

    /**
    /* "Generic.Group.MarkedAsDeleted" (Marked as deleted)
    */
    public get genericGroupMarkedAsDeleted() : string {
        return this.get(this.genericGroupMarkedAsDeletedLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.NonConsecutiveGroups" (Items of the same group must be in consecutive order)
    */
    public get formDefinitionPageNonConsecutiveGroups() : string {
        return this.get(this.formDefinitionPageNonConsecutiveGroupsLanguageItemName);
    }

    /**
    /* "AttachmentsFiltersModal.Type" (Attachment type)
    */
    public get attachmentsFiltersModalType() : string {
        return this.get(this.attachmentsFiltersModalTypeLanguageItemName);
    }

    /**
    /* "WorkOrders.Actions.Delete" (Delete work order)
    */
    public get workOrdersActionsDelete() : string {
        return this.get(this.workOrdersActionsDeleteLanguageItemName);
    }

    /**
    /* "WorkOrders.Actions.RemoveActivationDate" (Remove activation date)
    */
    public get workOrdersActionsRemoveActivationDate() : string {
        return this.get(this.workOrdersActionsRemoveActivationDateLanguageItemName);
    }

    /**
    /* "TasksPanel.DeleteAttachment" (Delete attachment)
    */
    public get tasksPanelDeleteAttachment() : string {
        return this.get(this.tasksPanelDeleteAttachmentLanguageItemName);
    }

    /**
    /* "TasksPanel.DeleteDistance" (Delete mileage / distance)
    */
    public get tasksPanelDeleteDistance() : string {
        return this.get(this.tasksPanelDeleteDistanceLanguageItemName);
    }

    /**
    /* "TasksPanel.DeleteEquipment" (Delete products)
    */
    public get tasksPanelDeleteEquipment() : string {
        return this.get(this.tasksPanelDeleteEquipmentLanguageItemName);
    }

    /**
    /* "TasksPanel.DeleteExtraCharge" (Delete extra charge)
    */
    public get tasksPanelDeleteExtraCharge() : string {
        return this.get(this.tasksPanelDeleteExtraChargeLanguageItemName);
    }

    /**
    /* "Form.EmailInput.Receiver" (Receiver (Renta Task users only))
    */
    public get formEmailInputReceiver() : string {
        return this.get(this.formEmailInputReceiverLanguageItemName);
    }

    /**
    /* "FormDefinitionsPage.Icon.Tooltip.CopyFormDefinition" (Copy form definition template)
    */
    public get formDefinitionsPageIconTooltipCopyFormDefinition() : string {
        return this.get(this.formDefinitionsPageIconTooltipCopyFormDefinitionLanguageItemName);
    }

    /**
    /* "ConstructionSites.ToolBar.SearchTermFilterWithProjectNumber" (Site / Customer / Project number / Address)
    */
    public get constructionSitesToolBarSearchTermFilterWithProjectNumber() : string {
        return this.get(this.constructionSitesToolBarSearchTermFilterWithProjectNumberLanguageItemName);
    }

    /**
    /* "Generic.ProjectNumber" (Project number)
    */
    public get genericProjectNumber() : string {
        return this.get(this.genericProjectNumberLanguageItemName);
    }

    /**
    /* "FormsList.Completed.ColumnHeader.Preview" (Preview)
    */
    public get formsListCompletedColumnHeaderPreview() : string {
        return this.get(this.formsListCompletedColumnHeaderPreviewLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.PreviewDetails.FailedAlert" (Failed to open details page. If this happens again, contact support.)
    */
    public get rentaTasksWorkOrderPreviewDetailsFailedAlert() : string {
        return this.get(this.rentaTasksWorkOrderPreviewDetailsFailedAlertLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.Button.Label.ShowDetails" (Show details)
    */
    public get rentaTasksWorkOrderButtonLabelShowDetails() : string {
        return this.get(this.rentaTasksWorkOrderButtonLabelShowDetailsLanguageItemName);
    }

    /**
    /* "RentaTasks.PreviewDetails.GetManual" (On this page you can check different work order details: note for customer, assigned mounters, equipments, extra charges (if enabled), distances.)
    */
    public get rentaTasksPreviewDetailsGetManual() : string {
        return this.get(this.rentaTasksPreviewDetailsGetManualLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.ContactInfo" (Contact info)
    */
    public get rentaTasksWorkOrderDetailsContactInfo() : string {
        return this.get(this.rentaTasksWorkOrderDetailsContactInfoLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.AssignedMounters" (Assigned mounters)
    */
    public get rentaTasksWorkOrderDetailsAssignedMounters() : string {
        return this.get(this.rentaTasksWorkOrderDetailsAssignedMountersLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.NoAssignedMounters" (No assigned mounters)
    */
    public get rentaTasksWorkOrderDetailsNoAssignedMounters() : string {
        return this.get(this.rentaTasksWorkOrderDetailsNoAssignedMountersLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.NoEquipments" (No equipments have been added yet)
    */
    public get rentaTasksWorkOrderDetailsNoEquipments() : string {
        return this.get(this.rentaTasksWorkOrderDetailsNoEquipmentsLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.Equipments" (Equipments)
    */
    public get rentaTasksWorkOrderDetailsEquipments() : string {
        return this.get(this.rentaTasksWorkOrderDetailsEquipmentsLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.NoSalaryHours" (No salary hours have been added yet)
    */
    public get rentaTasksWorkOrderDetailsNoSalaryHours() : string {
        return this.get(this.rentaTasksWorkOrderDetailsNoSalaryHoursLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.ExtraCharges" (Extra charges)
    */
    public get rentaTasksWorkOrderDetailsExtraCharges() : string {
        return this.get(this.rentaTasksWorkOrderDetailsExtraChargesLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.NoExtraCharges" (No extra charges have been added yet)
    */
    public get rentaTasksWorkOrderDetailsNoExtraCharges() : string {
        return this.get(this.rentaTasksWorkOrderDetailsNoExtraChargesLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.Distances" (Mileages)
    */
    public get rentaTasksWorkOrderDetailsDistances() : string {
        return this.get(this.rentaTasksWorkOrderDetailsDistancesLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.NoDistances" (No distances have been added yet)
    */
    public get rentaTasksWorkOrderDetailsNoDistances() : string {
        return this.get(this.rentaTasksWorkOrderDetailsNoDistancesLanguageItemName);
    }

    /**
    /* "Generic.Amount" (Amount)
    */
    public get genericAmount() : string {
        return this.get(this.genericAmountLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.SalaryHoursTable.NormalHours" (Normal hours)
    */
    public get rentaTasksWorkOrderDetailsSalaryHoursTableNormalHours() : string {
        return this.get(this.rentaTasksWorkOrderDetailsSalaryHoursTableNormalHoursLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.SalaryHoursTable.Overtime100" (Overtime 100%)
    */
    public get rentaTasksWorkOrderDetailsSalaryHoursTableOvertime100() : string {
        return this.get(this.rentaTasksWorkOrderDetailsSalaryHoursTableOvertime100LanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.SalaryHoursTable.Overtime50" (Overtime 50%)
    */
    public get rentaTasksWorkOrderDetailsSalaryHoursTableOvertime50() : string {
        return this.get(this.rentaTasksWorkOrderDetailsSalaryHoursTableOvertime50LanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.MileagesTable.VehiclesAmount" (Vehicles)
    */
    public get rentaTasksWorkOrderDetailsMileagesTableVehiclesAmount() : string {
        return this.get(this.rentaTasksWorkOrderDetailsMileagesTableVehiclesAmountLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.MileagesTable.TotalMileages" (Total distance, km)
    */
    public get rentaTasksWorkOrderDetailsMileagesTableTotalMileages() : string {
        return this.get(this.rentaTasksWorkOrderDetailsMileagesTableTotalMileagesLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrderDetails.JobSummary" (Note for customer)
    */
    public get rentaTasksWorkOrderDetailsJobSummary() : string {
        return this.get(this.rentaTasksWorkOrderDetailsJobSummaryLanguageItemName);
    }

    /**
    /* "Generic.FullName" (Full name)
    */
    public get genericFullName() : string {
        return this.get(this.genericFullNameLanguageItemName);
    }

    /**
    /* "RentaTasks.Controller.Steps.Title.DetailsPreview" (Details)
    */
    public get rentaTasksControllerStepsTitleDetailsPreview() : string {
        return this.get(this.rentaTasksControllerStepsTitleDetailsPreviewLanguageItemName);
    }

    /**
    /* "Generic.CustomerName" (Customer name)
    */
    public get genericCustomerName() : string {
        return this.get(this.genericCustomerNameLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.MountersSignaturesRequired" (Mounter signatures required (mapping))
    */
    public get formDefinitionPageMountersSignaturesRequired() : string {
        return this.get(this.formDefinitionPageMountersSignaturesRequiredLanguageItemName);
    }

    /**
    /* "MountersSignatures.InstructionMessage" (Please select mounters from dropdown to add a signature. Unselecting mounter will remove created signature.)
    */
    public get mountersSignaturesInstructionMessage() : string {
        return this.get(this.mountersSignaturesInstructionMessageLanguageItemName);
    }

    /**
    /* "MountersSignatures.ValidationMessage" (Please make sure all selected mounters have added signature and Signee name)
    */
    public get mountersSignaturesValidationMessage() : string {
        return this.get(this.mountersSignaturesValidationMessageLanguageItemName);
    }

    /**
    /* "MountersSignatures.SubmitSignatures" (Submit signatures)
    */
    public get mountersSignaturesSubmitSignatures() : string {
        return this.get(this.mountersSignaturesSubmitSignaturesLanguageItemName);
    }

    /**
    /* "Signature.SigneeName" (Signer's name)
    */
    public get signatureSigneeName() : string {
        return this.get(this.signatureSigneeNameLanguageItemName);
    }

    /**
    /* "Signature.SignatureFor" (Signature for)
    */
    public get signatureSignatureFor() : string {
        return this.get(this.signatureSignatureForLanguageItemName);
    }

    /**
    /* "FormSummaryTable.MountersSignatures" (Mounters signatures)
    */
    public get formSummaryTableMountersSignatures() : string {
        return this.get(this.formSummaryTableMountersSignaturesLanguageItemName);
    }

    /**
    /* "MountersSignatures.SummaryError" (Mounters signatures are required for the form, but none is added.)
    */
    public get mountersSignaturesSummaryError() : string {
        return this.get(this.mountersSignaturesSummaryErrorLanguageItemName);
    }

    /**
    /* "Generic.Active" (Active)
    */
    public get genericActive() : string {
        return this.get(this.genericActiveLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.Attachments.AttachmentType" (Attachment type)
    */
    public get workOrderDetailsPanelGridAttachmentsAttachmentType() : string {
        return this.get(this.workOrderDetailsPanelGridAttachmentsAttachmentTypeLanguageItemName);
    }

    /**
    /* "ConstructionSiteManagement.Tabs.ProjectAttachments" (Project attachments)
    */
    public get constructionSiteManagementTabsProjectAttachments() : string {
        return this.get(this.constructionSiteManagementTabsProjectAttachmentsLanguageItemName);
    }

    /**
    /* "AddConstructionSiteAttachmentModal.PublicCheckbox" (Public)
    */
    public get addConstructionSiteAttachmentModalPublicCheckbox() : string {
        return this.get(this.addConstructionSiteAttachmentModalPublicCheckboxLanguageItemName);
    }

    /**
    /* "AddConstructionSiteAttachmentModal.Title" (Add construction site attachment)
    */
    public get addConstructionSiteAttachmentModalTitle() : string {
        return this.get(this.addConstructionSiteAttachmentModalTitleLanguageItemName);
    }

    /**
    /* "ConstructionSiteAttachmentsPanel.Toolbar.PublicCheckbox" (Public)
    */
    public get constructionSiteAttachmentsPanelToolbarPublicCheckbox() : string {
        return this.get(this.constructionSiteAttachmentsPanelToolbarPublicCheckboxLanguageItemName);
    }

    /**
    /* "ConstructionSiteAttachmentsPanel.Toolbar.AddAttachmentsButton" (Add attachments)
    */
    public get constructionSiteAttachmentsPanelToolbarAddAttachmentsButton() : string {
        return this.get(this.constructionSiteAttachmentsPanelToolbarAddAttachmentsButtonLanguageItemName);
    }

    /**
    /* "ConstructionSiteAttachmentsGrid.NoDataText" (No attachments)
    */
    public get constructionSiteAttachmentsGridNoDataText() : string {
        return this.get(this.constructionSiteAttachmentsGridNoDataTextLanguageItemName);
    }

    /**
    /* "Enum.AttachmentType.ConstructionSiteAttachment" (Construction site attachment)
    */
    public get enumAttachmentTypeConstructionSiteAttachment() : string {
        return this.get(this.enumAttachmentTypeConstructionSiteAttachmentLanguageItemName);
    }

    /**
    /* "ConstructionSiteAttachmentsGrid.FileName" (File name)
    */
    public get constructionSiteAttachmentsGridFileName() : string {
        return this.get(this.constructionSiteAttachmentsGridFileNameLanguageItemName);
    }

    /**
    /* "ConstructionSiteAttachmentsGrid.FileType" (File type)
    */
    public get constructionSiteAttachmentsGridFileType() : string {
        return this.get(this.constructionSiteAttachmentsGridFileTypeLanguageItemName);
    }

    /**
    /* "ConstructionSiteAttachmentsGrid.Public" (Public)
    */
    public get constructionSiteAttachmentsGridPublic() : string {
        return this.get(this.constructionSiteAttachmentsGridPublicLanguageItemName);
    }

    /**
    /* "ConstructionSiteAttachmentsGrid.DeleteAttachment" (Delete attachment)
    */
    public get constructionSiteAttachmentsGridDeleteAttachment() : string {
        return this.get(this.constructionSiteAttachmentsGridDeleteAttachmentLanguageItemName);
    }

    /**
    /* "ConstructionSiteAttachmentsGrid.ConfirmDelete" (Are you sure you want to delete {0} attachment?)
    */
    public get constructionSiteAttachmentsGridConfirmDelete() : string {
        return this.get(this.constructionSiteAttachmentsGridConfirmDeleteLanguageItemName);
    }

    /**
    /* "ConstructionSiteAttachmentsGrid.DownloadAttachment" (Download attachment)
    */
    public get constructionSiteAttachmentsGridDownloadAttachment() : string {
        return this.get(this.constructionSiteAttachmentsGridDownloadAttachmentLanguageItemName);
    }

    /**
    /* "Generic.WorkingHours" (Working hours)
    */
    public get genericWorkingHours() : string {
        return this.get(this.genericWorkingHoursLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Step" (Step)
    */
    public get formDefinitionPageStep() : string {
        return this.get(this.formDefinitionPageStepLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.ValueStepIncorrect" (step value must be greater than 0)
    */
    public get formDefinitionPageValueStepIncorrect() : string {
        return this.get(this.formDefinitionPageValueStepIncorrectLanguageItemName);
    }

    /**
    /* "Generic.DefaultAlarmJobPrice" (Default alarm job price)
    */
    public get genericDefaultAlarmJobPrice() : string {
        return this.get(this.genericDefaultAlarmJobPriceLanguageItemName);
    }

    /**
    /* "MyAccountPage.NotificationTab.Title" (Notification settings)
    */
    public get myAccountPageNotificationTabTitle() : string {
        return this.get(this.myAccountPageNotificationTabTitleLanguageItemName);
    }

    /**
    /* "GlobalNotificationSettingsPage.Title" (Global notification settings)
    */
    public get globalNotificationSettingsPageTitle() : string {
        return this.get(this.globalNotificationSettingsPageTitleLanguageItemName);
    }

    /**
    /* "NotificationSettings.FlyoutMessage.GlobalSettingSaved" (Global notification setting saved successfully.)
    */
    public get notificationSettingsFlyoutMessageGlobalSettingSaved() : string {
        return this.get(this.notificationSettingsFlyoutMessageGlobalSettingSavedLanguageItemName);
    }

    /**
    /* "NotificationSettings.FlyoutMessage.UserSettingSaved" (User notification setting saved successfully.)
    */
    public get notificationSettingsFlyoutMessageUserSettingSaved() : string {
        return this.get(this.notificationSettingsFlyoutMessageUserSettingSavedLanguageItemName);
    }

    /**
    /* "NotificationSettings.AlertMessage.GlobalSettingsDisabled" (Notifications type of "{0}" are globally disabled.)
    */
    public get notificationSettingsAlertMessageGlobalSettingsDisabled() : string {
        return this.get(this.notificationSettingsAlertMessageGlobalSettingsDisabledLanguageItemName);
    }

    /**
    /* "NotificationSettings.Dropdown.Type" (Notification type:)
    */
    public get notificationSettingsDropdownType() : string {
        return this.get(this.notificationSettingsDropdownTypeLanguageItemName);
    }

    /**
    /* "NotificationSettings.Switch.Enable" (Notifications on/off:)
    */
    public get notificationSettingsSwitchEnable() : string {
        return this.get(this.notificationSettingsSwitchEnableLanguageItemName);
    }

    /**
    /* "NotificationSettings.Dropdown.MediaType" (Media type:)
    */
    public get notificationSettingsDropdownMediaType() : string {
        return this.get(this.notificationSettingsDropdownMediaTypeLanguageItemName);
    }

    /**
    /* "NotificationSettings.Dropdown.Interval" (Interval:)
    */
    public get notificationSettingsDropdownInterval() : string {
        return this.get(this.notificationSettingsDropdownIntervalLanguageItemName);
    }

    /**
    /* "NotificationSettings.DateInput.SendTime" (Notifications occurrence time:)
    */
    public get notificationSettingsDateInputSendTime() : string {
        return this.get(this.notificationSettingsDateInputSendTimeLanguageItemName);
    }

    /**
    /* "NotificationSettings.Dropdown.WeeklySendOccurrence" (Week day(s) occurrence:)
    */
    public get notificationSettingsDropdownWeeklySendOccurrence() : string {
        return this.get(this.notificationSettingsDropdownWeeklySendOccurrenceLanguageItemName);
    }

    /**
    /* "NotificationSettings.DateInput.PausedFrom" (Notifications paused from:)
    */
    public get notificationSettingsDateInputPausedFrom() : string {
        return this.get(this.notificationSettingsDateInputPausedFromLanguageItemName);
    }

    /**
    /* "NotificationSettings.DateInput.PausedTo" (Notifications paused until:)
    */
    public get notificationSettingsDateInputPausedTo() : string {
        return this.get(this.notificationSettingsDateInputPausedToLanguageItemName);
    }

    /**
    /* "Enum.NotificationInterval.Daily" (Daily)
    */
    public get enumNotificationIntervalDaily() : string {
        return this.get(this.enumNotificationIntervalDailyLanguageItemName);
    }

    /**
    /* "Enum.NotificationInterval.OnDemand" (On-demand)
    */
    public get enumNotificationIntervalOnDemand() : string {
        return this.get(this.enumNotificationIntervalOnDemandLanguageItemName);
    }

    /**
    /* "Enum.NotificationInterval.Weekly" (Weekly)
    */
    public get enumNotificationIntervalWeekly() : string {
        return this.get(this.enumNotificationIntervalWeeklyLanguageItemName);
    }

    /**
    /* "Enum.NotificationMediaType.Email" (Email)
    */
    public get enumNotificationMediaTypeEmail() : string {
        return this.get(this.enumNotificationMediaTypeEmailLanguageItemName);
    }

    /**
    /* "Enum.NotificationMediaType.EmailAndSms" (Email and SMS)
    */
    public get enumNotificationMediaTypeEmailAndSms() : string {
        return this.get(this.enumNotificationMediaTypeEmailAndSmsLanguageItemName);
    }

    /**
    /* "Enum.NotificationMediaType.Sms" (SMS)
    */
    public get enumNotificationMediaTypeSms() : string {
        return this.get(this.enumNotificationMediaTypeSmsLanguageItemName);
    }

    /**
    /* "Enum.DayOfWeek.Monday" (Monday)
    */
    public get enumDayOfWeekMonday() : string {
        return this.get(this.enumDayOfWeekMondayLanguageItemName);
    }

    /**
    /* "Enum.DayOfWeek.Tuesday" (Tuesday)
    */
    public get enumDayOfWeekTuesday() : string {
        return this.get(this.enumDayOfWeekTuesdayLanguageItemName);
    }

    /**
    /* "Enum.DayOfWeek.Wednesday" (Wednesday)
    */
    public get enumDayOfWeekWednesday() : string {
        return this.get(this.enumDayOfWeekWednesdayLanguageItemName);
    }

    /**
    /* "Enum.DayOfWeek.Thursday" (Thursday)
    */
    public get enumDayOfWeekThursday() : string {
        return this.get(this.enumDayOfWeekThursdayLanguageItemName);
    }

    /**
    /* "Enum.DayOfWeek.Friday" (Friday)
    */
    public get enumDayOfWeekFriday() : string {
        return this.get(this.enumDayOfWeekFridayLanguageItemName);
    }

    /**
    /* "Enum.DayOfWeek.Saturday" (Saturday)
    */
    public get enumDayOfWeekSaturday() : string {
        return this.get(this.enumDayOfWeekSaturdayLanguageItemName);
    }

    /**
    /* "Enum.DayOfWeek.Sunday" (Sunday)
    */
    public get enumDayOfWeekSunday() : string {
        return this.get(this.enumDayOfWeekSundayLanguageItemName);
    }

    /**
    /* "Enum.NotificationType.WorkOrdersProcessedApproval" (Work orders processed approval)
    */
    public get enumNotificationTypeWorkOrdersProcessedApproval() : string {
        return this.get(this.enumNotificationTypeWorkOrdersProcessedApprovalLanguageItemName);
    }

    /**
    /* "Enum.NotificationType.WorkOrdersPendingApproval" (Work orders pending approval)
    */
    public get enumNotificationTypeWorkOrdersPendingApproval() : string {
        return this.get(this.enumNotificationTypeWorkOrdersPendingApprovalLanguageItemName);
    }

    /**
    /* "Enum.NotificationType.WorkOrderReactivation" (Work order reactivation)
    */
    public get enumNotificationTypeWorkOrderReactivation() : string {
        return this.get(this.enumNotificationTypeWorkOrderReactivationLanguageItemName);
    }

    /**
    /* "NotificationSettings.NumberInput.PendingDays" (Pending days)
    */
    public get notificationSettingsNumberInputPendingDays() : string {
        return this.get(this.notificationSettingsNumberInputPendingDaysLanguageItemName);
    }

    /**
    /* "NotificationSettings.Text.Description" (Notification setting type description:)
    */
    public get notificationSettingsTextDescription() : string {
        return this.get(this.notificationSettingsTextDescriptionLanguageItemName);
    }

    /**
    /* "NotificationSettings.NotificationType.WorkOrdersPendingApproval.Description" (Notification for the managers of work orders which are pending approval by the customer.)
    */
    public get notificationSettingsNotificationTypeWorkOrdersPendingApprovalDescription() : string {
        return this.get(this.notificationSettingsNotificationTypeWorkOrdersPendingApprovalDescriptionLanguageItemName);
    }

    /**
    /* "NotificationSettings.NotificationType.WorkOrderReactivation.Description" (Notification for the mounters when the work order gets reactivated by the manager.)
    */
    public get notificationSettingsNotificationTypeWorkOrderReactivationDescription() : string {
        return this.get(this.notificationSettingsNotificationTypeWorkOrderReactivationDescriptionLanguageItemName);
    }

    /**
    /* "NotificationSettings.NotificationType.WorkOrdersProcessedApproval.Description" (Notification for the managers when work orders get approved/declined by the customer.)
    */
    public get notificationSettingsNotificationTypeWorkOrdersProcessedApprovalDescription() : string {
        return this.get(this.notificationSettingsNotificationTypeWorkOrdersProcessedApprovalDescriptionLanguageItemName);
    }

    /**
    /* "FormSummaryTable.SelectedReceiversHeader" (Will be sent to:)
    */
    public get formSummaryTableSelectedReceiversHeader() : string {
        return this.get(this.formSummaryTableSelectedReceiversHeaderLanguageItemName);
    }

    /**
    /* "Notification.Title" (Notification ({0}))
    */
    public get notificationTitle() : string {
        return this.get(this.notificationTitleLanguageItemName);
    }

    /**
    /* "Notification.Title.Loading" (Notification loading...)
    */
    public get notificationTitleLoading() : string {
        return this.get(this.notificationTitleLoadingLanguageItemName);
    }

    /**
    /* "WorkOrder.CurrentStatus" (Current status)
    */
    public get workOrderCurrentStatus() : string {
        return this.get(this.workOrderCurrentStatusLanguageItemName);
    }

    /**
    /* "Generic.SentAt" (Sent at)
    */
    public get genericSentAt() : string {
        return this.get(this.genericSentAtLanguageItemName);
    }

    /**
    /* "Generic.SentBy" (Sent by)
    */
    public get genericSentBy() : string {
        return this.get(this.genericSentByLanguageItemName);
    }

    /**
    /* "Generic.ApprovedAt" (Approved at)
    */
    public get genericApprovedAt() : string {
        return this.get(this.genericApprovedAtLanguageItemName);
    }

    /**
    /* "Generic.ApprovedBy" (Approved by)
    */
    public get genericApprovedBy() : string {
        return this.get(this.genericApprovedByLanguageItemName);
    }

    /**
    /* "WorkOrderChangeStatusModal.Title.Reactivate" (Send notification to mounter(s))
    */
    public get workOrderChangeStatusModalTitleReactivate() : string {
        return this.get(this.workOrderChangeStatusModalTitleReactivateLanguageItemName);
    }

    /**
    /* "WorkOrderChangeStatusModal.Title.Decline" (Send notification to manager(s))
    */
    public get workOrderChangeStatusModalTitleDecline() : string {
        return this.get(this.workOrderChangeStatusModalTitleDeclineLanguageItemName);
    }

    /**
    /* "Generic.ApprovedOrDeclinedAt" (Approved/Declined At)
    */
    public get genericApprovedOrDeclinedAt() : string {
        return this.get(this.genericApprovedOrDeclinedAtLanguageItemName);
    }

    /**
    /* "Generic.ApprovedOrDeclinedBy" (Approved/Declined By)
    */
    public get genericApprovedOrDeclinedBy() : string {
        return this.get(this.genericApprovedOrDeclinedByLanguageItemName);
    }

    /**
    /* "Generic.From" (From)
    */
    public get genericFrom() : string {
        return this.get(this.genericFromLanguageItemName);
    }

    /**
    /* "Generic.To" (To)
    */
    public get genericTo() : string {
        return this.get(this.genericToLanguageItemName);
    }

    /**
    /* "Notification.WorkOrdersPendingApproval.Subtitle" (Work order(s) that are waiting for customer approval)
    */
    public get notificationWorkOrdersPendingApprovalSubtitle() : string {
        return this.get(this.notificationWorkOrdersPendingApprovalSubtitleLanguageItemName);
    }

    /**
    /* "WorkOrderChangeStatusModal.Placeholder.CommentReason" (Please, comment a reason)
    */
    public get workOrderChangeStatusModalPlaceholderCommentReason() : string {
        return this.get(this.workOrderChangeStatusModalPlaceholderCommentReasonLanguageItemName);
    }

    /**
    /* "StatusMessageModal.Title.WorkOrderReactivated" (Work order has been reactivated.)
    */
    public get statusMessageModalTitleWorkOrderReactivated() : string {
        return this.get(this.statusMessageModalTitleWorkOrderReactivatedLanguageItemName);
    }

    /**
    /* "StatusMessageModal.Title.WorkReportDeclined" (The work report has been declined.)
    */
    public get statusMessageModalTitleWorkReportDeclined() : string {
        return this.get(this.statusMessageModalTitleWorkReportDeclinedLanguageItemName);
    }

    /**
    /* "StatusMessageModal.CommentedReason" (Commented reason: {0})
    */
    public get statusMessageModalCommentedReason() : string {
        return this.get(this.statusMessageModalCommentedReasonLanguageItemName);
    }

    /**
    /* "Generic.Ok" (Ok)
    */
    public get genericOk() : string {
        return this.get(this.genericOkLanguageItemName);
    }

    /**
    /* "ApproveFormPage.AlertError.SignatureIsRequired" (Signature is required to complete form.”)
    */
    public get approveFormPageAlertErrorSignatureIsRequired() : string {
        return this.get(this.approveFormPageAlertErrorSignatureIsRequiredLanguageItemName);
    }

    /**
    /* "RentalEquipment.AddRentalEquipment" (Add individual rental equipment)
    */
    public get rentalEquipmentAddRentalEquipment() : string {
        return this.get(this.rentalEquipmentAddRentalEquipmentLanguageItemName);
    }

    /**
    /* "RentalEquipment.RentalEquipment" (Rental equipment)
    */
    public get rentalEquipmentRentalEquipment() : string {
        return this.get(this.rentalEquipmentRentalEquipmentLanguageItemName);
    }

    /**
    /* "RentalEquipment.AddRentalEquipmentToWorkOrder" (Add individual rental equipment to work order)
    */
    public get rentalEquipmentAddRentalEquipmentToWorkOrder() : string {
        return this.get(this.rentalEquipmentAddRentalEquipmentToWorkOrderLanguageItemName);
    }

    /**
    /* "RentalEquipment.ActionType" (Action type)
    */
    public get rentalEquipmentActionType() : string {
        return this.get(this.rentalEquipmentActionTypeLanguageItemName);
    }

    /**
    /* "Enum.RentalItemActionType.Leave" (Leave)
    */
    public get enumRentalItemActionTypeLeave() : string {
        return this.get(this.enumRentalItemActionTypeLeaveLanguageItemName);
    }

    /**
    /* "Enum.RentalItemActionType.Return" (Return)
    */
    public get enumRentalItemActionTypeReturn() : string {
        return this.get(this.enumRentalItemActionTypeReturnLanguageItemName);
    }

    /**
    /* "Enum.NotificationType.WorkOrderAssignment" (Work order assignment)
    */
    public get enumNotificationTypeWorkOrderAssignment() : string {
        return this.get(this.enumNotificationTypeWorkOrderAssignmentLanguageItemName);
    }

    /**
    /* "NotificationSettings.NotificationType.WorkOrderAssignment.Description" (Notification for the mounter when they have been assigned to a work order.)
    */
    public get notificationSettingsNotificationTypeWorkOrderAssignmentDescription() : string {
        return this.get(this.notificationSettingsNotificationTypeWorkOrderAssignmentDescriptionLanguageItemName);
    }

    /**
    /* "RentaTasks.WorkOrder.SignIn.AlreadySignedInAlert" (Cannot sign-in. You are already signed-in to another work order.)
    */
    public get rentaTasksWorkOrderSignInAlreadySignedInAlert() : string {
        return this.get(this.rentaTasksWorkOrderSignInAlreadySignedInAlertLanguageItemName);
    }

    /**
    /* "AuditQuestionInput.PictureRequired" (Picture is required)
    */
    public get auditQuestionInputPictureRequired() : string {
        return this.get(this.auditQuestionInputPictureRequiredLanguageItemName);
    }

    /**
    /* "AuditQuestionInput.PictureOptional" (Add picture if needed)
    */
    public get auditQuestionInputPictureOptional() : string {
        return this.get(this.auditQuestionInputPictureOptionalLanguageItemName);
    }

    /**
    /* "Generic.AlarmJob" (Alarm job)
    */
    public get genericAlarmJob() : string {
        return this.get(this.genericAlarmJobLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsHoursGrid.Add" (Add)
    */
    public get workOrderDetailsHoursGridAdd() : string {
        return this.get(this.workOrderDetailsHoursGridAddLanguageItemName);
    }

    /**
    /* "DailyHoursModal.Labels.IncludeAlarmJob" (Include alarm job)
    */
    public get dailyHoursModalLabelsIncludeAlarmJob() : string {
        return this.get(this.dailyHoursModalLabelsIncludeAlarmJobLanguageItemName);
    }

    /**
    /* "WorkOrder.Actions.ConfirmApproveSent" (Work order has been sent to the customer for approval. Are you sure you want to mark it as approved by the customer?)
    */
    public get workOrderActionsConfirmApproveSent() : string {
        return this.get(this.workOrderActionsConfirmApproveSentLanguageItemName);
    }

    /**
    /* "WorkOrderTypeManagement.TypeExists.Alert" (Work order type {0} already exists)
    */
    public get workOrderTypeManagementTypeExistsAlert() : string {
        return this.get(this.workOrderTypeManagementTypeExistsAlertLanguageItemName);
    }

    /**
    /* "UserManagement.Dropdown.Subcontractor" (Subcontractor)
    */
    public get userManagementDropdownSubcontractor() : string {
        return this.get(this.userManagementDropdownSubcontractorLanguageItemName);
    }

    /**
    /* "UserManagement.MounterPermissions.CanCreateWorkOrder" (Can create work orders)
    */
    public get userManagementMounterPermissionsCanCreateWorkOrder() : string {
        return this.get(this.userManagementMounterPermissionsCanCreateWorkOrderLanguageItemName);
    }

    /**
    /* "UserManagement.MounterPermissions.CanCompleteWorkOrder" (Can complete work orders)
    */
    public get userManagementMounterPermissionsCanCompleteWorkOrder() : string {
        return this.get(this.userManagementMounterPermissionsCanCompleteWorkOrderLanguageItemName);
    }

    /**
    /* "UserManagement.MounterPermissions.CanProcessForm" (Can process forms)
    */
    public get userManagementMounterPermissionsCanProcessForm() : string {
        return this.get(this.userManagementMounterPermissionsCanProcessFormLanguageItemName);
    }

    /**
    /* "AddSubcontractorModal.ValidationError.SubcontractorAlreadyExists" (Subcontractor already exists)
    */
    public get addSubcontractorModalValidationErrorSubcontractorAlreadyExists() : string {
        return this.get(this.addSubcontractorModalValidationErrorSubcontractorAlreadyExistsLanguageItemName);
    }

    /**
    /* "SubcontractorsPanel.Confirmation.DeleteSubcontractor" (Are you sure, you want to delete the subcontractor '{0}'?)
    */
    public get subcontractorsPanelConfirmationDeleteSubcontractor() : string {
        return this.get(this.subcontractorsPanelConfirmationDeleteSubcontractorLanguageItemName);
    }

    /**
    /* "Generic.DeletedAt" (Deleted at)
    */
    public get genericDeletedAt() : string {
        return this.get(this.genericDeletedAtLanguageItemName);
    }

    /**
    /* "Generic.DeletedBy" (Deleted by)
    */
    public get genericDeletedBy() : string {
        return this.get(this.genericDeletedByLanguageItemName);
    }

    /**
    /* "MobileForm.SaveAndCloseLabel" (Save and close)
    */
    public get mobileFormSaveAndCloseLabel() : string {
        return this.get(this.mobileFormSaveAndCloseLabelLanguageItemName);
    }

    /**
    /* "MobileForm.SaveAndCloseDescription" (Save and close and return)
    */
    public get mobileFormSaveAndCloseDescription() : string {
        return this.get(this.mobileFormSaveAndCloseDescriptionLanguageItemName);
    }

    /**
    /* "Generic.CreatedBy" (Created by)
    */
    public get genericCreatedBy() : string {
        return this.get(this.genericCreatedByLanguageItemName);
    }

    /**
    /* "Generic.CreatedAt" (Created at)
    */
    public get genericCreatedAt() : string {
        return this.get(this.genericCreatedAtLanguageItemName);
    }

    /**
    /* "Generic.System" (System)
    */
    public get genericSystem() : string {
        return this.get(this.genericSystemLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Tab.History" (History)
    */
    public get workOrderDetailsPanelTabHistory() : string {
        return this.get(this.workOrderDetailsPanelTabHistoryLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.WorkOrderStatuses.ChangedAt" (Changed at)
    */
    public get workOrderDetailsPanelWorkOrderStatusesChangedAt() : string {
        return this.get(this.workOrderDetailsPanelWorkOrderStatusesChangedAtLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.WorkOrderStatuses.ChangedBy" (Changed by)
    */
    public get workOrderDetailsPanelWorkOrderStatusesChangedBy() : string {
        return this.get(this.workOrderDetailsPanelWorkOrderStatusesChangedByLanguageItemName);
    }

    /**
    /* "Generic.Schedule" (Schedule)
    */
    public get genericSchedule() : string {
        return this.get(this.genericScheduleLanguageItemName);
    }

    /**
    /* "RentalEquipment.ProductWithIdNotAvailableForRent" (Product with id "{0}" is not available for rent)
    */
    public get rentalEquipmentProductWithIdNotAvailableForRent() : string {
        return this.get(this.rentalEquipmentProductWithIdNotAvailableForRentLanguageItemName);
    }

    /**
    /* "RentalEquipment.ProductInfoRetrievedSuccessfully" (Product info retrieved successfully)
    */
    public get rentalEquipmentProductInfoRetrievedSuccessfully() : string {
        return this.get(this.rentalEquipmentProductInfoRetrievedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.ProductWithSameIdHasAlreadyBeenAdded" (Product with same id has already been added)
    */
    public get genericProductWithSameIdHasAlreadyBeenAdded() : string {
        return this.get(this.genericProductWithSameIdHasAlreadyBeenAddedLanguageItemName);
    }

    /**
    /* "Form.Input.ExternalId" (External id)
    */
    public get formInputExternalId() : string {
        return this.get(this.formInputExternalIdLanguageItemName);
    }

    /**
    /* "WorkOrder.ContractType.DropdownLabel" (Contract type)
    */
    public get workOrderContractTypeDropdownLabel() : string {
        return this.get(this.workOrderContractTypeDropdownLabelLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderContractType.FixedPrice" (Fixed price)
    */
    public get enumWorkOrderContractTypeFixedPrice() : string {
        return this.get(this.enumWorkOrderContractTypeFixedPriceLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderContractType.Normal" (Hourly work)
    */
    public get enumWorkOrderContractTypeNormal() : string {
        return this.get(this.enumWorkOrderContractTypeNormalLanguageItemName);
    }

    /**
    /* "Enum.WorkOrderContractType.Warranty" (Warranty)
    */
    public get enumWorkOrderContractTypeWarranty() : string {
        return this.get(this.enumWorkOrderContractTypeWarrantyLanguageItemName);
    }

    /**
    /* "WorkOrder.FixedCostLabel" (Fixed cost)
    */
    public get workOrderFixedCostLabel() : string {
        return this.get(this.workOrderFixedCostLabelLanguageItemName);
    }

    /**
    /* "WorkOrder.FixedHoursCostLabel" (Hours cost)
    */
    public get workOrderFixedHoursCostLabel() : string {
        return this.get(this.workOrderFixedHoursCostLabelLanguageItemName);
    }

    /**
    /* "WorkOrder.FixedTransportationCostLabel" (Transportation cost)
    */
    public get workOrderFixedTransportationCostLabel() : string {
        return this.get(this.workOrderFixedTransportationCostLabelLanguageItemName);
    }

    /**
    /* "WorkOrder.FixedProductCostLabel" (Product cost)
    */
    public get workOrderFixedProductCostLabel() : string {
        return this.get(this.workOrderFixedProductCostLabelLanguageItemName);
    }

    /**
    /* "WorkOrder.FixedPriceHeader" (Contract prices)
    */
    public get workOrderFixedPriceHeader() : string {
        return this.get(this.workOrderFixedPriceHeaderLanguageItemName);
    }

    /**
    /* "WorkOrder.HourlyPriceHeader" (Hourly work prices)
    */
    public get workOrderHourlyPriceHeader() : string {
        return this.get(this.workOrderHourlyPriceHeaderLanguageItemName);
    }

    /**
    /* "WorkOrder.PauseStart.Label" (Start task pause)
    */
    public get workOrderPauseStartLabel() : string {
        return this.get(this.workOrderPauseStartLabelLanguageItemName);
    }

    /**
    /* "WorkOrder.PauseEnd.Label" (End task pause)
    */
    public get workOrderPauseEndLabel() : string {
        return this.get(this.workOrderPauseEndLabelLanguageItemName);
    }

    /**
    /* "Generic.Action.PauseTask" ( Pause task)
    */
    public get genericActionPauseTask() : string {
        return this.get(this.genericActionPauseTaskLanguageItemName);
    }

    /**
    /* "CalendarPage.CalendarData.PauseOverlay.Text" (Paused from {0} to {1})
    */
    public get calendarPageCalendarDataPauseOverlayText() : string {
        return this.get(this.calendarPageCalendarDataPauseOverlayTextLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.PausedSuccessfully" (Work order paused successfully)
    */
    public get genericWorkOrderPausedSuccessfully() : string {
        return this.get(this.genericWorkOrderPausedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.PauseFailed" (Failed to pause work order)
    */
    public get genericWorkOrderPauseFailed() : string {
        return this.get(this.genericWorkOrderPauseFailedLanguageItemName);
    }

    /**
    /* "FormSummaryTable.ApproverSignature" (Approver's signature)
    */
    public get formSummaryTableApproverSignature() : string {
        return this.get(this.formSummaryTableApproverSignatureLanguageItemName);
    }

    /**
    /* "NewVersionAvailable.Title" (A new version of the application is available)
    */
    public get newVersionAvailableTitle() : string {
        return this.get(this.newVersionAvailableTitleLanguageItemName);
    }

    /**
    /* "NewVersionAvailable.Description" (The browser window must be refreshed for all changes to take effect)
    */
    public get newVersionAvailableDescription() : string {
        return this.get(this.newVersionAvailableDescriptionLanguageItemName);
    }

    /**
    /* "NewVersionAvailable.RefreshButton" (Update)
    */
    public get newVersionAvailableRefreshButton() : string {
        return this.get(this.newVersionAvailableRefreshButtonLanguageItemName);
    }

    /**
    /* "CatalogManagement.RentalMassProductsPageTitle" (Rental items catalog)
    */
    public get catalogManagementRentalMassProductsPageTitle() : string {
        return this.get(this.catalogManagementRentalMassProductsPageTitleLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProducts.AddRentalMassEquipment" (Add mass rental items)
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsAddRentalMassEquipment() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsAddRentalMassEquipmentLanguageItemName);
    }

    /**
    /* "SubcontractorAssignmentModal.Warning" (The selected mounter belongs to a subcontractor company that is not yet assigned to the contract. If you want to assign the work order to the mounter, a subcontractor company will be assigned to the contract as well. )
    */
    public get subcontractorAssignmentModalWarning() : string {
        return this.get(this.subcontractorAssignmentModalWarningLanguageItemName);
    }

    /**
    /* "Generic.Unassign" (Unassign)
    */
    public get genericUnassign() : string {
        return this.get(this.genericUnassignLanguageItemName);
    }

    /**
    /* "Generic.Assign" (Assign)
    */
    public get genericAssign() : string {
        return this.get(this.genericAssignLanguageItemName);
    }

    /**
    /* "AssignedMountersWarningModal.MountersAreAssigned" (A subcontractor can’t be removed until all the work orders that have been assigned to the subcontractor mounters are unassigned.)
    */
    public get assignedMountersWarningModalMountersAreAssigned() : string {
        return this.get(this.assignedMountersWarningModalMountersAreAssignedLanguageItemName);
    }

    /**
    /* "AssignedMountersWarningModal.AssignedMounters" (Assigned mounters)
    */
    public get assignedMountersWarningModalAssignedMounters() : string {
        return this.get(this.assignedMountersWarningModalAssignedMountersLanguageItemName);
    }

    /**
    /* "SubcontractorAssignmentModal.Title" (Add Subcontractor)
    */
    public get subcontractorAssignmentModalTitle() : string {
        return this.get(this.subcontractorAssignmentModalTitleLanguageItemName);
    }

    /**
    /* "Generic.Clear" (Clear)
    */
    public get genericClear() : string {
        return this.get(this.genericClearLanguageItemName);
    }

    /**
    /* "Generic.Action.UnpauseTask" (End the work order pause)
    */
    public get genericActionUnpauseTask() : string {
        return this.get(this.genericActionUnpauseTaskLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.UnpausedSuccessfully" (Ending the work order pause was successful)
    */
    public get genericWorkOrderUnpausedSuccessfully() : string {
        return this.get(this.genericWorkOrderUnpausedSuccessfullyLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.UnpauseFailed" (Ending the work order pause was unsuccessful)
    */
    public get genericWorkOrderUnpauseFailed() : string {
        return this.get(this.genericWorkOrderUnpauseFailedLanguageItemName);
    }

    /**
    /* "Generic.Time" (Time)
    */
    public get genericTime() : string {
        return this.get(this.genericTimeLanguageItemName);
    }

    /**
    /* "Catalog.Modal.AddRentalEquipmentInstead" (Add rental equipment instead)
    */
    public get catalogModalAddRentalEquipmentInstead() : string {
        return this.get(this.catalogModalAddRentalEquipmentInsteadLanguageItemName);
    }

    /**
    /* "RentaTasks.AddEquipment.CategoriesOrProductsModal.Title.RentalMassEquipment" (Mass rental items)
    */
    public get rentaTasksAddEquipmentCategoriesOrProductsModalTitleRentalMassEquipment() : string {
        return this.get(this.rentaTasksAddEquipmentCategoriesOrProductsModalTitleRentalMassEquipmentLanguageItemName);
    }

    /**
    /* "RentalEquipment.AddRentalMassEquipment" (Add mass rental items)
    */
    public get rentalEquipmentAddRentalMassEquipment() : string {
        return this.get(this.rentalEquipmentAddRentalMassEquipmentLanguageItemName);
    }

    /**
    /* "CalendarPage.SubContractorMounterSuffix" (SUB)
    */
    public get calendarPageSubContractorMounterSuffix() : string {
        return this.get(this.calendarPageSubContractorMounterSuffixLanguageItemName);
    }

    /**
    /* "Enum.NotificationType.WorkOrderDeclined" (Rejection of the WO from the customer)
    */
    public get enumNotificationTypeWorkOrderDeclined() : string {
        return this.get(this.enumNotificationTypeWorkOrderDeclinedLanguageItemName);
    }

    /**
    /* "NotificationSettings.NotificationType.WorkOrderDeclined.Description" (Notification to the manager when the customer rejects the work order.)
    */
    public get notificationSettingsNotificationTypeWorkOrderDeclinedDescription() : string {
        return this.get(this.notificationSettingsNotificationTypeWorkOrderDeclinedDescriptionLanguageItemName);
    }

    /**
    /* "RegionManagement.PageTitle" (Region management)
    */
    public get regionManagementPageTitle() : string {
        return this.get(this.regionManagementPageTitleLanguageItemName);
    }

    /**
    /* "Generic.Region" (Region)
    */
    public get genericRegion() : string {
        return this.get(this.genericRegionLanguageItemName);
    }

    /**
    /* "Generic.RegionWorkNumbers" (Region work numbers)
    */
    public get genericRegionWorkNumbers() : string {
        return this.get(this.genericRegionWorkNumbersLanguageItemName);
    }

    /**
    /* "Enum.WorkType.AlertJobHours" (Alert job hours)
    */
    public get enumWorkTypeAlertJobHours() : string {
        return this.get(this.enumWorkTypeAlertJobHoursLanguageItemName);
    }

    /**
    /* "Enum.WorkType.FixedCost" (Fixed cost)
    */
    public get enumWorkTypeFixedCost() : string {
        return this.get(this.enumWorkTypeFixedCostLanguageItemName);
    }

    /**
    /* "Enum.WorkType.FixedHoursCost" (Fixed cost)
    */
    public get enumWorkTypeFixedHoursCost() : string {
        return this.get(this.enumWorkTypeFixedHoursCostLanguageItemName);
    }

    /**
    /* "Enum.WorkType.FixedProductCost" (Fixed product cost)
    */
    public get enumWorkTypeFixedProductCost() : string {
        return this.get(this.enumWorkTypeFixedProductCostLanguageItemName);
    }

    /**
    /* "Enum.WorkType.FixedTransportationCost" (Fixed transportation cost)
    */
    public get enumWorkTypeFixedTransportationCost() : string {
        return this.get(this.enumWorkTypeFixedTransportationCostLanguageItemName);
    }

    /**
    /* "Enum.WorkType.Mileages" (Mileages)
    */
    public get enumWorkTypeMileages() : string {
        return this.get(this.enumWorkTypeMileagesLanguageItemName);
    }

    /**
    /* "Enum.WorkType.NormalHours" (Hours)
    */
    public get enumWorkTypeNormalHours() : string {
        return this.get(this.enumWorkTypeNormalHoursLanguageItemName);
    }

    /**
    /* "Enum.WorkType.Overtime100" (Overtime 100%)
    */
    public get enumWorkTypeOvertime100() : string {
        return this.get(this.enumWorkTypeOvertime100LanguageItemName);
    }

    /**
    /* "Enum.WorkType.Overtime50" (Overtime 50%)
    */
    public get enumWorkTypeOvertime50() : string {
        return this.get(this.enumWorkTypeOvertime50LanguageItemName);
    }

    /**
    /* "FormDefinitionPage.Options" (Options)
    */
    public get formDefinitionPageOptions() : string {
        return this.get(this.formDefinitionPageOptionsLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Tab.ExternalNotifications" (External notifications)
    */
    public get workOrderDetailsPanelTabExternalNotifications() : string {
        return this.get(this.workOrderDetailsPanelTabExternalNotificationsLanguageItemName);
    }

    /**
    /* "WorkOrderDetailsPanel.Grid.ExternalNotifications.Sender" (Sender)
    */
    public get workOrderDetailsPanelGridExternalNotificationsSender() : string {
        return this.get(this.workOrderDetailsPanelGridExternalNotificationsSenderLanguageItemName);
    }

    /**
    /* "ExternalNotificationModal.PreviewTitle" (Notification preview)
    */
    public get externalNotificationModalPreviewTitle() : string {
        return this.get(this.externalNotificationModalPreviewTitleLanguageItemName);
    }

    /**
    /* "Enum.AttachmentType.ExternalNotificationAttachment" (External notification attachment)
    */
    public get enumAttachmentTypeExternalNotificationAttachment() : string {
        return this.get(this.enumAttachmentTypeExternalNotificationAttachmentLanguageItemName);
    }

    /**
    /* "ExternalNotificationModal.Title" (Send notification)
    */
    public get externalNotificationModalTitle() : string {
        return this.get(this.externalNotificationModalTitleLanguageItemName);
    }

    /**
    /* "ExternalNotificationModal.Subtitle" (Notification contains the work order report as an attachment)
    */
    public get externalNotificationModalSubtitle() : string {
        return this.get(this.externalNotificationModalSubtitleLanguageItemName);
    }

    /**
    /* "ExternalNotificationModal.RecipientEmail" (Recipient's email)
    */
    public get externalNotificationModalRecipientEmail() : string {
        return this.get(this.externalNotificationModalRecipientEmailLanguageItemName);
    }

    /**
    /* "ExternalNotificationModal.RequestDate" (Request date)
    */
    public get externalNotificationModalRequestDate() : string {
        return this.get(this.externalNotificationModalRequestDateLanguageItemName);
    }

    /**
    /* "ExternalNotificationModal.SendersEmail" (Sender's email)
    */
    public get externalNotificationModalSendersEmail() : string {
        return this.get(this.externalNotificationModalSendersEmailLanguageItemName);
    }

    /**
    /* "ExternalNotificationModal.SendersFirstName" (Sender's first name)
    */
    public get externalNotificationModalSendersFirstName() : string {
        return this.get(this.externalNotificationModalSendersFirstNameLanguageItemName);
    }

    /**
    /* "ExternalNotificationModal.SendersLastName" (Sender's last name)
    */
    public get externalNotificationModalSendersLastName() : string {
        return this.get(this.externalNotificationModalSendersLastNameLanguageItemName);
    }

    /**
    /* "ExternalNotificationModal.SendersPhone" (Sender's phone number)
    */
    public get externalNotificationModalSendersPhone() : string {
        return this.get(this.externalNotificationModalSendersPhoneLanguageItemName);
    }

    /**
    /* "WorkOrders.Actions.Notification" (Send external notification)
    */
    public get workOrdersActionsNotification() : string {
        return this.get(this.workOrdersActionsNotificationLanguageItemName);
    }

    /**
    /* "Generic.WorkOrder.RequiredCostPool" (Cost pool is required to proceed)
    */
    public get genericWorkOrderRequiredCostPool() : string {
        return this.get(this.genericWorkOrderRequiredCostPoolLanguageItemName);
    }

    /**
    /* "WorkOrder.ContractNo" (Contract No)
    */
    public get workOrderContractNo() : string {
        return this.get(this.workOrderContractNoLanguageItemName);
    }

    /**
    /* "UserManagement.UseConstructionSiteCommunicationLanguage" (Use construction site language in emails)
    */
    public get userManagementUseConstructionSiteCommunicationLanguage() : string {
        return this.get(this.userManagementUseConstructionSiteCommunicationLanguageLanguageItemName);
    }

    /**
    /* "Enum.CommunicationLanguage.English" (English)
    */
    public get enumCommunicationLanguageEnglish() : string {
        return this.get(this.enumCommunicationLanguageEnglishLanguageItemName);
    }

    /**
    /* "Enum.CommunicationLanguage.Finnish" (Finnish)
    */
    public get enumCommunicationLanguageFinnish() : string {
        return this.get(this.enumCommunicationLanguageFinnishLanguageItemName);
    }

    /**
    /* "Enum.CommunicationLanguage.Swedish" (Swedish)
    */
    public get enumCommunicationLanguageSwedish() : string {
        return this.get(this.enumCommunicationLanguageSwedishLanguageItemName);
    }

    /**
    /* "FileType.Image" (Image)
    */
    public get fileTypeImage() : string {
        return this.get(this.fileTypeImageLanguageItemName);
    }

    /**
    /* "FileType.Pdf" (PDF)
    */
    public get fileTypePdf() : string {
        return this.get(this.fileTypePdfLanguageItemName);
    }

    /**
    /* "FileType.Word" (Word)
    */
    public get fileTypeWord() : string {
        return this.get(this.fileTypeWordLanguageItemName);
    }

    /**
    /* "FileType.Excel" (Excel)
    */
    public get fileTypeExcel() : string {
        return this.get(this.fileTypeExcelLanguageItemName);
    }

    /**
    /* "FileType.PowerPoint" (PowerPoint)
    */
    public get fileTypePowerPoint() : string {
        return this.get(this.fileTypePowerPointLanguageItemName);
    }

    /**
    /* "FileType.OpenOfficeText" (OpenOffice text)
    */
    public get fileTypeOpenOfficeText() : string {
        return this.get(this.fileTypeOpenOfficeTextLanguageItemName);
    }

    /**
    /* "FileType.OpenOfficeSpreadsheet" (OpenOffice spreadsheet)
    */
    public get fileTypeOpenOfficeSpreadsheet() : string {
        return this.get(this.fileTypeOpenOfficeSpreadsheetLanguageItemName);
    }

    /**
    /* "FileType.OpenOfficePresentation" (OpenOffice presentation)
    */
    public get fileTypeOpenOfficePresentation() : string {
        return this.get(this.fileTypeOpenOfficePresentationLanguageItemName);
    }

    /**
    /* "Enum.CalendarUnitTime.Day" (Day)
    */
    public get enumCalendarUnitTimeDay() : string {
        return this.get(this.enumCalendarUnitTimeDayLanguageItemName);
    }

    /**
    /* "UserManagement.UserSsoInfoLabel" (User has activated O365 login)
    */
    public get userManagementUserSsoInfoLabel() : string {
        return this.get(this.userManagementUserSsoInfoLabelLanguageItemName);
    }

    /**
    /* "NewsEditor.AddNew" (Add new)
    */
    public get newsEditorAddNew() : string {
        return this.get(this.newsEditorAddNewLanguageItemName);
    }

    /**
    /* "NewsEditor.Delete.Confirm" (Are you sure you want to remove this news?)
    */
    public get newsEditorDeleteConfirm() : string {
        return this.get(this.newsEditorDeleteConfirmLanguageItemName);
    }

    /**
    /* "NewsEditor.Help.Header" (Here is a short cheat sheet for the markdown syntax used in the news editor. Code on the left is interpreted and rendered on the right.)
    */
    public get newsEditorHelpHeader() : string {
        return this.get(this.newsEditorHelpHeaderLanguageItemName);
    }

    /**
    /* "NewsEditor.Input.Description" (Description)
    */
    public get newsEditorInputDescription() : string {
        return this.get(this.newsEditorInputDescriptionLanguageItemName);
    }

    /**
    /* "NewsEditor.Input.Enabled" (Enabled)
    */
    public get newsEditorInputEnabled() : string {
        return this.get(this.newsEditorInputEnabledLanguageItemName);
    }

    /**
    /* "NewsEditor.Input.Image" (Image)
    */
    public get newsEditorInputImage() : string {
        return this.get(this.newsEditorInputImageLanguageItemName);
    }

    /**
    /* "NewsEditor.Input.Title" (Title)
    */
    public get newsEditorInputTitle() : string {
        return this.get(this.newsEditorInputTitleLanguageItemName);
    }

    /**
    /* "NewsEditor.PageTitle" (News editor)
    */
    public get newsEditorPageTitle() : string {
        return this.get(this.newsEditorPageTitleLanguageItemName);
    }

    /**
    /* "NewsEditor.Save.Success" (Save success)
    */
    public get newsEditorSaveSuccess() : string {
        return this.get(this.newsEditorSaveSuccessLanguageItemName);
    }

    /**
    /* "Enum.WorkType.CustomProducts" (Custom product)
    */
    public get enumWorkTypeCustomProducts() : string {
        return this.get(this.enumWorkTypeCustomProductsLanguageItemName);
    }

    /**
    /* "WorkReportWithComments.ActionLabel" (Work order report with comments)
    */
    public get workReportWithCommentsActionLabel() : string {
        return this.get(this.workReportWithCommentsActionLabelLanguageItemName);
    }

    /**
    /* "WorkOrderDetails.HoursGrid.SubContractorErrorMessage" (Please add a mounter to this work order first.)
    */
    public get workOrderDetailsHoursGridSubContractorErrorMessage() : string {
        return this.get(this.workOrderDetailsHoursGridSubContractorErrorMessageLanguageItemName);
    }

    /**
    /* "WorkReportWithComments.Confirmation" (The report is too large to download directly, but we can send it to your email. Would you like us to send the report to your email?)
    */
    public get workReportWithCommentsConfirmation() : string {
        return this.get(this.workReportWithCommentsConfirmationLanguageItemName);
    }

    /**
    /* "WorkOrder.InvoiceWithoutCreatingOrder" (Mark as invoiced)
    */
    public get workOrderInvoiceWithoutCreatingOrder() : string {
        return this.get(this.workOrderInvoiceWithoutCreatingOrderLanguageItemName);
    }

    /**
    /* "Finland.WorkOrder.InvoiceAction" (Invoice (TK))
    */
    public get finlandWorkOrderInvoiceAction() : string {
        return this.get(this.finlandWorkOrderInvoiceActionLanguageItemName);
    }

    /**
    /* "Finland.WorkOrder.MarkAsInvoicedAction" (Mark as invoiced)
    */
    public get finlandWorkOrderMarkAsInvoicedAction() : string {
        return this.get(this.finlandWorkOrderMarkAsInvoicedActionLanguageItemName);
    }

    /**
    /* "FormDefinitionPage.ItemExportSize" (Item print size)
    */
    public get formDefinitionPageItemExportSize() : string {
        return this.get(this.formDefinitionPageItemExportSizeLanguageItemName);
    }

    /**
    /* "ConstructionSitePanel.ERPConstructionSiteId" (ERP Construction Site ID)
    */
    public get constructionSitePanelERPConstructionSiteId() : string {
        return this.get(this.constructionSitePanelERPConstructionSiteIdLanguageItemName);
    }

    /**
    /* "WorkReportWithComments.AdditionalReceiverConfirmation" (You are sending the report with comments to an additional receiver. Are you sure?)
    */
    public get workReportWithCommentsAdditionalReceiverConfirmation() : string {
        return this.get(this.workReportWithCommentsAdditionalReceiverConfirmationLanguageItemName);
    }

    /**
    /* "Generic.EmailPlaceholder" (receiver@email.com)
    */
    public get genericEmailPlaceholder() : string {
        return this.get(this.genericEmailPlaceholderLanguageItemName);
    }

    /**
    /* "TasksPage.CommentReportReceiverLabel" (Comment report receiver)
    */
    public get tasksPageCommentReportReceiverLabel() : string {
        return this.get(this.tasksPageCommentReportReceiverLabelLanguageItemName);
    }

    /**
    /* "Enum.UserRoleGroup.SalesPersons" (Sales Persons)
    */
    public get enumUserRoleGroupSalesPersons() : string {
        return this.get(this.enumUserRoleGroupSalesPersonsLanguageItemName);
    }

    /**
    /* "RoleName.SalesPerson" (Sales person)
    */
    public get roleNameSalesPerson() : string {
        return this.get(this.roleNameSalesPersonLanguageItemName);
    }

    /**
    /* "FeatureFlagManagement.FeatureEnabledHeader" (Enabled)
    */
    public get featureFlagManagementFeatureEnabledHeader() : string {
        return this.get(this.featureFlagManagementFeatureEnabledHeaderLanguageItemName);
    }

    /**
    /* "FeatureFlagManagement.Title" (Feature Flag)
    */
    public get featureFlagManagementTitle() : string {
        return this.get(this.featureFlagManagementTitleLanguageItemName);
    }

    /**
    /* "FeatureFlags.INFO_BAR" (Information bar)
    */
    public get featureFlagsINFOBAR() : string {
        return this.get(this.featureFlagsINFOBARLanguageItemName);
    }

    /**
    /* "FeatureFlags.APPLICATION_UPDATED" (Show application updated text)
    */
    public get featureFlagsAPPLICATIONUPDATED() : string {
        return this.get(this.featureFlagsAPPLICATIONUPDATEDLanguageItemName);
    }

    /**
    /* "KnownSettings.ApplicationUpdatedText" (Application updated text)
    */
    public get knownSettingsApplicationUpdatedText() : string {
        return this.get(this.knownSettingsApplicationUpdatedTextLanguageItemName);
    }

    /**
    /* "KnownSettings.InfoBarText" (Information bar text)
    */
    public get knownSettingsInfoBarText() : string {
        return this.get(this.knownSettingsInfoBarTextLanguageItemName);
    }

    /**
    /* "KnownSettings.AlarmJobPrice" (Alarm job price)
    */
    public get knownSettingsAlarmJobPrice() : string {
        return this.get(this.knownSettingsAlarmJobPriceLanguageItemName);
    }

    /**
    /* "ErrorPage.UserName" (Username )
    */
    public get errorPageUserName() : string {
        return this.get(this.errorPageUserNameLanguageItemName);
    }

    /**
    /* "ErrorPage.RequestId" (Identifier )
    */
    public get errorPageRequestId() : string {
        return this.get(this.errorPageRequestIdLanguageItemName);
    }

    /**
    /* "ErrorPage.DateAndTime" (Date and time )
    */
    public get errorPageDateAndTime() : string {
        return this.get(this.errorPageDateAndTimeLanguageItemName);
    }

    /**
    /* "OfflinePage.Body" (It looks like you don't have a working internet connection at the moment.)
    */
    public get offlinePageBody() : string {
        return this.get(this.offlinePageBodyLanguageItemName);
    }

    /**
    /* "OfflinePage.Title" (No internet connection)
    */
    public get offlinePageTitle() : string {
        return this.get(this.offlinePageTitleLanguageItemName);
    }

    /**
    /* "CopyWorkOrder.Confirmation" (Create a copy of the work order?)
    */
    public get copyWorkOrderConfirmation() : string {
        return this.get(this.copyWorkOrderConfirmationLanguageItemName);
    }

    /**
    /* "CatalogManagement.ErrorMessage.Restore.CategoryNotExists" (Category cannot be restored. Category with id '{0}' does not exist.)
    */
    public get catalogManagementErrorMessageRestoreCategoryNotExists() : string {
        return this.get(this.catalogManagementErrorMessageRestoreCategoryNotExistsLanguageItemName);
    }

    /**
    /* "Catalog.FlyoutMessage.CategoryMarkedAsDeleted" (Category '{0}' marked as deleted.)
    */
    public get catalogFlyoutMessageCategoryMarkedAsDeleted() : string {
        return this.get(this.catalogFlyoutMessageCategoryMarkedAsDeletedLanguageItemName);
    }

    /**
    /* "Catalog.FlyoutMessage.CategoryRestored" (Category '{0}' successfully restored.)
    */
    public get catalogFlyoutMessageCategoryRestored() : string {
        return this.get(this.catalogFlyoutMessageCategoryRestoredLanguageItemName);
    }

    /**
    /* "WorkOrders.Button.MyWorkOrders" (My Work Orders)
    */
    public get workOrdersButtonMyWorkOrders() : string {
        return this.get(this.workOrdersButtonMyWorkOrdersLanguageItemName);
    }

    /**
    /* "RentaTasks.Dashboard.RouteWidget.CurrentTask" (Current task)
    */
    public get rentaTasksDashboardRouteWidgetCurrentTask() : string {
        return this.get(this.rentaTasksDashboardRouteWidgetCurrentTaskLanguageItemName);
    }

    /**
    /* "DailyHoursModal.Mounters.Assigned" (Assigned mounters)
    */
    public get dailyHoursModalMountersAssigned() : string {
        return this.get(this.dailyHoursModalMountersAssignedLanguageItemName);
    }

    /**
    /* "ConstructionSites.Agreements.BrokenAgreements" (The following attachments could not be uploaded)
    */
    public get constructionSitesAgreementsBrokenAgreements() : string {
        return this.get(this.constructionSitesAgreementsBrokenAgreementsLanguageItemName);
    }

    /**
    /* "TopNav.WorkOrderCreationRequests" (Work order requests)
    */
    public get topNavWorkOrderCreationRequests() : string {
        return this.get(this.topNavWorkOrderCreationRequestsLanguageItemName);
    }

    /**
    /* "Enum.CalendarUnitTime.TwoWeeks" (2 weeks)
    */
    public get enumCalendarUnitTimeTwoWeeks() : string {
        return this.get(this.enumCalendarUnitTimeTwoWeeksLanguageItemName);
    }

    /**
    /* "ProductItem.Product.DefaultExternalId" (Default External Id)
    */
    public get productItemProductDefaultExternalId() : string {
        return this.get(this.productItemProductDefaultExternalIdLanguageItemName);
    }
}

//Singleton
export default new Localizer();